/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 35130:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(19601);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
module.exports = desvg;

/**
 * @name desvg
 * @summary Generate component using passed svg-loader output.
 *
 * @description
 * Generate component using passed svg-loader output.
 *
 * @param {Function} h
 * The helper function (e.g. `React.createElement` or Preact's `h`).
 *
 * @param {Object} svg
 * The svg-loader output.
 *
 * @returns {Object}
 * The generated component.
 *
 * @example
 * import { createElement } from 'react'
 * import svgContent from './icon.svg'
 * import desvg from 'desvg'
 *
 * // Basic usage
 * const Icon = desvg(createElement, svgContent)
 * <Icon fill='currentColor' />
 * //=> <svg fill='currentColor' ...>...</svg>
 */
function desvg(h, svg) {
  var content = svg.content;
  var attributes = svg.attributes;
  return /*#__PURE__*/function () {
    function _class() {
      _classCallCheck(this, _class);
    }
    _createClass(_class, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate() {
        return false;
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props;
        return h('svg', Object.assign({
          dangerouslySetInnerHTML: {
            __html: content
          }
        }, attributes, props), props && props.children);
      }
    }]);
    return _class;
  }();
}

/***/ }),

/***/ 5813:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var desvg = __webpack_require__(35130);
var h = __webpack_require__(79758).h;
module.exports = desvg.bind(null, h);

/***/ }),

/***/ 49096:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* unused harmony export default */
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30489);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12419);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(79758);
/* harmony import */ var _theme_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(49190);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }










function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var PopupDialog = /*#__PURE__*/function (_Component) {
  _inherits(PopupDialog, _Component);
  var _super = _createSuper(PopupDialog);
  function PopupDialog() {
    var _this;
    _classCallCheck(this, PopupDialog);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onRef", function (node) {
      _this.node = node;
    });
    _defineProperty(_assertThisInitialized(_this), "onClose", function (event) {
      event.preventDefault();
      _this.props.wantsToClose();
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (event) {
      if (event.target === _this.node || event.target.closest('.popup-dialog-control')) {
        // запрещаем дефолтное действие при нажатии на диалог и его контролы, предотвращает выделение всего окна
        // при нажатии на него в ФФ на маке
        event.preventDefault();
      }
    });
    _this.node = null;
    return _this;
  }
  _createClass(PopupDialog, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        addClassName = _this$props.addClassName,
        noCloseButton = _this$props.noCloseButton;
      var closeButton = '';
      if (!noCloseButton) {
        closeButton = (0,preact__WEBPACK_IMPORTED_MODULE_10__.h)("span", {
          className: "close-popup popup-dialog-control",
          onClick: this.onClose
        }, (0,preact__WEBPACK_IMPORTED_MODULE_10__.h)(_theme_icons__WEBPACK_IMPORTED_MODULE_11__/* .IconClose */ .bMz, null));
      }
      return (0,preact__WEBPACK_IMPORTED_MODULE_10__.h)("div", {
        ref: this.onRef,
        onMouseDown: this.onMouseDown,
        className: 'popup-dialog ' + (addClassName ? addClassName : '')
      }, closeButton, this.props.children);
    }
  }]);
  return PopupDialog;
}(preact__WEBPACK_IMPORTED_MODULE_10__/* .Component */ .wA);


/***/ }),

/***/ 19617:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* unused harmony export default */
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79758);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PopupDialogBody = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function PopupDialogBody() {
    _classCallCheck(this, PopupDialogBody);
  }
  _createClass(PopupDialogBody, [{
    key: "render",
    value: function render() {
      var addClassName = this.props.addClassName;
      var props = Object.assign({}, this.props);
      delete props.addClassName;
      return h("div", _extends({}, props, {
        className: 'popup-dialog-body ' + (addClassName ? addClassName : '')
      }), this.props.children);
    }
  }]);
  return PopupDialogBody;
}()));


/***/ }),

/***/ 25251:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* unused harmony export default */
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79758);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PopupDialogButtons = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function PopupDialogButtons() {
    _classCallCheck(this, PopupDialogButtons);
    _defineProperty(this, "onMouseDown", function (event) {
      event.preventDefault();
      event.stopPropagation();
    });
  }
  _createClass(PopupDialogButtons, [{
    key: "onButtonClick",
    value: function onButtonClick(key, button, event) {
      var wantsToClose = this.props.wantsToClose;
      if (button.onClick) {
        button.onClick(event);
      }
      if (key == 'cancel') {
        wantsToClose && wantsToClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        addClassName = _this$props.addClassName,
        buttons = _this$props.buttons,
        editor = _this$props.editor,
        _this$props$revertBut = _this$props.revertButtons,
        revertButtons = _this$props$revertBut === void 0 ? false : _this$props$revertBut;
      var i18n = editor.plugins.i18n;
      var buttonSet = (revertButtons ? Object.keys(buttons).reverse() : Object.keys(buttons)).map(function (key) {
        var button = buttons[key];
        var text = button.text ? button.text : '';
        if (!text) {
          text = i18n.get("dialog_common.button.".concat(key)) || key;
        }
        return h("span", {
          className: 'dialog-button ' + (button.style ? 'dialog-button-' + button.style : ''),
          onClick: _this.onButtonClick.bind(_this, key, button),
          onMouseDown: _this.onMouseDown
        }, text);
      });
      return h("div", {
        className: 'popup-dialog-buttons ' + (addClassName ? addClassName : '')
      }, buttonSet);
    }
  }]);
  return PopupDialogButtons;
}()));


/***/ }),

/***/ 83483:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* unused harmony export default */
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PopupDialogTitle = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function PopupDialogTitle() {
    _classCallCheck(this, PopupDialogTitle);
  }
  _createClass(PopupDialogTitle, [{
    key: "render",
    value: function render() {
      var addClassName = this.props.addClassName;
      return h("div", {
        className: 'popup-dialog-title popup-dialog-control ' + (addClassName ? addClassName : '')
      }, this.props.children);
    }
  }]);
  return PopupDialogTitle;
}()));


/***/ }),

/***/ 10856:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ PopupMenu)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79758);
/* harmony import */ var _theme_scss_popup_menu_vars_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81578);
/* harmony import */ var _theme_scss_popup_menu_vars_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_theme_scss_popup_menu_vars_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _util_popup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92143);
/* harmony import */ var _util_popupMenuItemsNav__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28480);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21791);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var is_hotkey__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28199);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var menuItemHeight = parseInt(_theme_scss_popup_menu_vars_scss__WEBPACK_IMPORTED_MODULE_2__.menuItemHeight);
var menuPadding = parseInt(_theme_scss_popup_menu_vars_scss__WEBPACK_IMPORTED_MODULE_2__.menuPadding);
var isEnterKey = (0,is_hotkey__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)('enter');
var isEscKey = (0,is_hotkey__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)('esc');
var PopupMenu = /*#__PURE__*/function () {
  function PopupMenu(props) {
    var _this = this;
    _classCallCheck(this, PopupMenu);
    _defineProperty(this, "onRef", function (node) {
      _this.domNode = node;
      _this.props.domRef && _this.props.domRef(node);
      _this.popper = null;
    });
    _defineProperty(this, "disableRecycling", function () {
      _this.nextBase = null;
    });
    _defineProperty(this, "onResize", function () {
      _this.popper.destroy();
      _this.createPopper();
    });
    _defineProperty(this, "onResizeDebounce", lodash_debounce__WEBPACK_IMPORTED_MODULE_5___default()(this.onResize, 200, {
      trailing: true
    }));
    _defineProperty(this, "onBodyMouseDown", function (event) {
      var target = event.target;
      if (target === _this.domNode || _this.domNode.contains(target)) {
        return;
      }
      _this.props.wantsToClose(event);
    });
    _defineProperty(this, "onBodyKeyDown", function (event) {
      var _this$props = _this.props,
        closeOnEsc = _this$props.closeOnEsc,
        onEnterAction = _this$props.onEnterAction,
        wantsToClose = _this$props.wantsToClose;
      if (isEscKey(event) && closeOnEsc && wantsToClose) {
        event.stopPropagation();
        var menues = _this.domNode && _this.domNode.getElementsByClassName('popup-menu');
        if (menues && menues.length === 0) {
          wantsToClose(event);
        }
      } else if (isEnterKey(event) && onEnterAction) {
        event.stopPropagation();
        var args = [event];
        if (_this.keyNavigator) {
          var item = _this.keyNavigator.getSelected();
          args.push(item);
        }
        onEnterAction.apply(void 0, args);
        wantsToClose && wantsToClose();
      } else if (_this.keyNavigator) {
        _this.keyNavigator.handleEvent(event);
      }
    });
    var keyNavigation = props.keyNavigation,
      _props$keyNavigationP = props.keyNavigationParams,
      keyNavigationParams = _props$keyNavigationP === void 0 ? {} : _props$keyNavigationP;
    var navParams = Object.assign({}, {
      popup: this,
      selector: '.menu-item',
      selectedClass: 'menu-item-selected'
    }, keyNavigationParams);
    this.keyNavigator = keyNavigation ? new _util_popupMenuItemsNav__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z(navParams) : false;
    this.resizeObserver = null;
  }
  _createClass(PopupMenu, [{
    key: "createPopper",
    value: function createPopper() {
      var _this$props2 = this.props,
        anchorNode = _this$props2.anchorNode,
        anchorOptions = _this$props2.anchorOptions,
        removeOnPopperDestroy = _this$props2.removeOnPopperDestroy;
      this.popper = (0,_util_popup__WEBPACK_IMPORTED_MODULE_3__/* .createPopper */ .f)(anchorNode, this.domNode, Object.assign({}, {
        removeOnDestroy: removeOnPopperDestroy || false
      }, anchorOptions));
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      // если установлено свойство freeze, то компонент не будет менятся, это удобно использовать в транзициях скрытия, когда
      // состояние среды поменялось, но оно не должно быть отражено на меню, т.е. меню должно закрытся таким каким было
      // при начале скрытия
      if (this.props.freeze || nextProps.freeze) {
        return false;
      }
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var anchorNode = this.props.anchorNode;
      if (anchorNode && prevProps.anchorNode !== anchorNode) {
        this.popper.destroy();
        this.createPopper();
      } else {
        this.popper && this.popper.update && this.popper.update();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props3 = this.props,
        wantsToClose = _this$props3.wantsToClose,
        anchorNode = _this$props3.anchorNode;
      if (wantsToClose) {
        // используем таймаут чтобы подождать пока обработается event, который привел к открытию меню
        this.dispatchEventTimeout = setTimeout(function () {
          // отлавливаем нажатие мыши на теле документа и просим родительский компонент закрыть меню если нужно
          document.body.addEventListener('mousedown', _this2.onBodyMouseDown);
        }, 0);
      }
      document.body.addEventListener('keydown', this.onBodyKeyDown);
      if (anchorNode) {
        this.createPopper();
      }
      if (this.props.listenSizeChange) {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.domNode);
        window.addEventListener('resize', this.onResizeDebounce);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.dispatchEventTimeout) {
        clearTimeout(this.dispatchEventTimeout);
      }
      document.body.removeEventListener('mousedown', this.onBodyMouseDown);
      document.body.removeEventListener('keydown', this.onBodyKeyDown);
      if (this.popper) {
        this.popper.destroy();
      }
      if (this.props.listenSizeChange) {
        this.resizeObserver.disconnect();
        window.removeEventListener('resize', this.onResizeDebounce);
      }
      setTimeout(this.disableRecycling);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        maxHeight = _this$props4.maxHeight,
        addClassName = _this$props4.addClassName,
        customStyles = _this$props4.customStyles;
      var style = Object.assign({}, customStyles && customStyles || {});
      if (maxHeight) {
        // подготовливаем размер меню так, чтобы показывались пункты меню целиком при первом рендере
        // в рамках максимальной высоты
        var maxHeightStyle = Math.floor((maxHeight - menuPadding) / menuItemHeight) * menuItemHeight;
        style.maxHeight = maxHeightStyle + menuPadding + (style.overflowY === 'visible' ? menuPadding : 0) + 'px';
      }
      return (0,preact__WEBPACK_IMPORTED_MODULE_1__.h)("div", {
        style: style,
        className: 'popup-menu ' + (addClassName || ''),
        ref: this.onRef,
        onMouseDown: this.props.onMouseDown,
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave
      }, this.props.children);
    }
  }]);
  return PopupMenu;
}();


/***/ }),

/***/ 28411:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ PopupMenuItem)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69600);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30489);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12419);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(79758);
/* harmony import */ var _theme_scss_vars_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(20199);
/* harmony import */ var _theme_scss_vars_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_theme_scss_vars_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _theme_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(49190);
/* harmony import */ var preact_transition_group__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(49839);
/* harmony import */ var is_hotkey__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(28199);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }











function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var isEscKey = (0,is_hotkey__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)('esc');
var PopupMenuItem = /*#__PURE__*/function (_Component) {
  _inherits(PopupMenuItem, _Component);
  var _super = _createSuper(PopupMenuItem);
  function PopupMenuItem(props) {
    var _this;
    _classCallCheck(this, PopupMenuItem);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "disableRecycling", function () {
      _this.nextBase = null;
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (event) {
      if (_this.props.submenu) {
        _this.setState(function () {
          return {
            submenuVisible: true
          };
        });
      }
      if (_this.props.onMenuItemEnter) {
        _this.props.onMenuItemEnter(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      if (_this.props.submenu) {
        _this.setState(function () {
          return {
            submenuVisible: false
          };
        });
      }
      if (_this.props.onMenuItemLeave) {
        _this.props.onMenuItemLeave();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseMove", function (event) {
      if (_this.props.onMenuItemMouseMove) {
        _this.props.onMenuItemMouseMove(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onRef", function (node) {
      _this.domNode = node;
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (event) {
      // чтобы не происходила смена range отменяем действие браузера по умолчанию
      event.preventDefault();
      event.stopPropagation();
      _this.props.onMouseDown && _this.props.onMouseDown();
    });
    _defineProperty(_assertThisInitialized(_this), "onContextMenu", function (event) {
      event.preventDefault();
    });
    _defineProperty(_assertThisInitialized(_this), "onBodyKeyDown", function (event) {
      if (isEscKey(event) && _this.props.submenu) {
        event.stopPropagation();
        _this.setState(function (prevState) {
          var submenuVisible = prevState.submenuVisible;
          if (submenuVisible) {
            var node = _this.props.submenu && _this.props.submenu.props && _this.props.submenu.props.anchorNode;
            if (node) {
              var currentSubmenu = node.lastChild && node.lastChild.firstChild && node.lastChild.firstChild.className;
              var menues = node.getElementsByClassName('popup-menu');
              if (menues.length === 1 || menues.length > 1 && currentSubmenu === 'popup-menu') {
                return {
                  submenuVisible: false
                };
              }
            }
          }
          return null;
        });
      }
    });
    _this.state = {
      submenuVisible: false
    };
    _this.domNode = null;
    return _this;
  }
  _createClass(PopupMenuItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.props.submenu) {
        this.dispatchEventTimeout = setTimeout(function () {
          document.body.addEventListener('keydown', _this2.onBodyKeyDown);
        }, 0);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.dispatchEventTimeout) {
        clearTimeout(this.dispatchEventTimeout);
      }
      if (this.props.submenu) {
        document.body.removeEventListener('keydown', this.onBodyKeyDown);
      }
      setTimeout(this.disableRecycling);
    }
  }, {
    key: "render",
    value: function render() {
      var submenuVisible = this.state.submenuVisible;
      var _this$props = this.props,
        id = _this$props.id,
        idAttr = _this$props.idAttr,
        menuStyle = _this$props.menuStyle,
        disabled = _this$props.disabled,
        submenu = _this$props.submenu,
        text = _this$props.text,
        className = _this$props.className,
        isNew = _this$props.isNew;
      var hint = this.props.hint;
      var Icon = this.props.icon;
      var attrs = {};
      if (idAttr) {
        attrs[idAttr] = id;
      }
      var classNames = ['menu-item'];
      if (className) {
        classNames.push(className);
      }

      // Стили можно задавать массивом
      if (menuStyle) {
        if (menuStyle === 'link') {
          classNames.shift();
          classNames.push('link-menu-item');
        } else {
          var menuStyleArr = menuStyle;
          if (typeof menuStyleArr == "string") menuStyleArr = [menuStyleArr];
          for (var i in menuStyleArr) {
            classNames.push('menu-item-' + menuStyleArr[i]);
          }
        }
      }
      if (disabled) {
        classNames.push('disabled');
      }
      if (submenu && !hint) {
        hint = (0,preact__WEBPACK_IMPORTED_MODULE_11__.h)(_theme_icons__WEBPACK_IMPORTED_MODULE_13__/* .IconArrowRight */ .Ec8, null);
      }
      var submenuContainer = null;
      if (submenu) {
        submenu.props.anchorNode = this.domNode;
        var submenuIfVisible = submenuVisible ? submenu : null;
        submenuContainer = (0,preact__WEBPACK_IMPORTED_MODULE_11__.h)(preact_transition_group__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
          transitionName: "popup-menu",
          transitionEnterTimeout: _theme_scss_vars_scss__WEBPACK_IMPORTED_MODULE_12__.popupAppearDuration,
          transitionLeaveTimeout: _theme_scss_vars_scss__WEBPACK_IMPORTED_MODULE_12__.popupAppearDuration
        }, submenuIfVisible);
      }
      var isNewLabel = null;
      if (isNew) {
        isNewLabel = (0,preact__WEBPACK_IMPORTED_MODULE_11__.h)("span", {
          className: "is-new"
        }, "New");
      }
      return (0,preact__WEBPACK_IMPORTED_MODULE_11__.h)("div", _extends({}, attrs, {
        ref: this.onRef,
        "data-menu-id": id,
        onClick: this.props.onClick,
        onMouseDown: this.onMouseDown,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onMouseMove: this.onMouseMove,
        onContextMenu: this.onContextMenu,
        className: classNames.join(' ')
      }), Icon ? (0,preact__WEBPACK_IMPORTED_MODULE_11__.h)("div", {
        className: "icon"
      }, (0,preact__WEBPACK_IMPORTED_MODULE_11__.h)(Icon, null)) : null, (0,preact__WEBPACK_IMPORTED_MODULE_11__.h)("div", {
        className: "text"
      }, text, isNewLabel), hint ? (0,preact__WEBPACK_IMPORTED_MODULE_11__.h)("div", {
        className: "hint"
      }, hint) : null, submenuContainer);
    }
  }]);
  return PopupMenuItem;
}(preact__WEBPACK_IMPORTED_MODULE_11__/* .Component */ .wA);


/***/ }),

/***/ 81900:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Pj": () => (/* binding */ IntlProvider),
  "xv": () => (/* reexport */ preact_i18n_esm_Text)
});

// UNUSED EXPORTS: Localizer, default, withText

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(30489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(12419);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/preact/dist/preact.module.js
var preact_module = __webpack_require__(79758);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__(23123);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(69600);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__(73210);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(4723);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(15306);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__(40561);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
// EXTERNAL MODULE: ./node_modules/preact/hooks/dist/hooks.module.js
var hooks_module = __webpack_require__(8065);
// EXTERNAL MODULE: ./node_modules/dlv/dist/dlv.umd.js
var dlv_umd = __webpack_require__(50172);
var dlv_umd_default = /*#__PURE__*/__webpack_require__.n(dlv_umd);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
;// CONCATENATED MODULE: ./node_modules/preact-markup/dist/preact-markup.module.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

















var e,
  o = {};
function n(r, t, e) {
  if (3 === r.nodeType) {
    var o = "textContent" in r ? r.textContent : r.nodeValue || "";
    if (!1 !== n.options.trim) {
      var a = 0 === t || t === e.length - 1;
      if ((!(o = o.match(/^[\s\n]+$/g) && "all" !== n.options.trim ? " " : o.replace(/(^[\s\n]+|[\s\n]+$)/g, "all" === n.options.trim || a ? "" : " ")) || " " === o) && e.length > 1 && a) return null;
    }
    return o;
  }
  if (1 !== r.nodeType) return null;
  var p = String(r.nodeName).toLowerCase();
  if ("script" === p && !n.options.allowScripts) return null;
  var l,
    s,
    u = n.h(p, function (r) {
      var t = r && r.length;
      if (!t) return null;
      for (var e = {}, o = 0; o < t; o++) {
        var a = r[o],
          i = a.name,
          p = a.value;
        "on" === i.substring(0, 2) && n.options.allowEvents && (p = new Function(p)), e[i] = p;
      }
      return e;
    }(r.attributes), (s = (l = r.childNodes) && Array.prototype.map.call(l, n).filter(i)) && s.length ? s : null);
  return n.visitor && n.visitor(u), u;
}
var a,
  i = function i(r) {
    return r;
  },
  p = {};
function l(r) {
  var t = (r.type || "").toLowerCase(),
    e = l.map;
  e && e.hasOwnProperty(t) ? (r.type = e[t], r.props = Object.keys(r.props || {}).reduce(function (t, e) {
    var o;
    return t[(o = e, o.replace(/-(.)/g, function (r, t) {
      return t.toUpperCase();
    }))] = r.props[e], t;
  }, {})) : r.type = t.replace(/[^a-z0-9-]/i, "");
}
/* harmony default export */ const preact_markup_module = ((function (t) {
  function i() {
    t.apply(this, arguments);
  }
  return t && (i.__proto__ = t), (i.prototype = Object.create(t && t.prototype)).constructor = i, i.setReviver = function (r) {
    a = r;
  }, i.prototype.shouldComponentUpdate = function (r) {
    var t = this.props;
    return r.wrap !== t.wrap || r.type !== t.type || r.markup !== t.markup;
  }, i.prototype.setComponents = function (r) {
    if (this.map = {}, r) for (var t in r) {
      if (r.hasOwnProperty(t)) {
        var e = t.replace(/([A-Z]+)([A-Z][a-z0-9])|([a-z0-9]+)([A-Z])/g, "$1$3-$2$4").toLowerCase();
        this.map[e] = r[t];
      }
    }
  }, i.prototype.render = function (t) {
    var i = t.wrap;
    void 0 === i && (i = !0);
    var s,
      u = t.type,
      c = t.markup,
      m = t.components,
      v = t.reviver,
      f = t.onError,
      d = t["allow-scripts"],
      h = t["allow-events"],
      y = t.trim,
      w = function (r, t) {
        var e = {};
        for (var o in r) {
          Object.prototype.hasOwnProperty.call(r, o) && -1 === t.indexOf(o) && (e[o] = r[o]);
        }
        return e;
      }(t, ["wrap", "type", "markup", "components", "reviver", "onError", "allow-scripts", "allow-events", "trim"]),
      C = v || this.reviver || this.constructor.prototype.reviver || a || preact_module.h;
    this.setComponents(m);
    var g = {
      allowScripts: d,
      allowEvents: h,
      trim: y
    };
    try {
      s = function (r, t, a, i, s) {
        var u = function (r, t) {
          var o,
            n,
            a,
            i,
            p = "html" === t ? "text/html" : "application/xml";
          "html" === t ? (i = "body", a = "<!DOCTYPE html>\n<html><body>" + r + "</body></html>") : (i = "xml", a = '<?xml version="1.0" encoding="UTF-8"?>\n<xml>' + r + "</xml>");
          try {
            o = new DOMParser().parseFromString(a, p);
          } catch (r) {
            n = r;
          }
          if (o || "html" !== t || ((o = e || (e = function () {
            if (document.implementation && document.implementation.createHTMLDocument) return document.implementation.createHTMLDocument("");
            var r = document.createElement("iframe");
            return r.style.cssText = "position:absolute; left:0; top:-999em; width:1px; height:1px; overflow:hidden;", r.setAttribute("sandbox", "allow-forms"), document.body.appendChild(r), r.contentWindow.document;
          }())).open(), o.write(a), o.close()), o) {
            var l = o.getElementsByTagName(i)[0],
              s = l.firstChild;
            return r && !s && (l.error = "Document parse failed."), s && "parsererror" === String(s.nodeName).toLowerCase() && (s.removeChild(s.firstChild), s.removeChild(s.lastChild), l.error = s.textContent || s.nodeValue || n || "Unknown error", l.removeChild(s)), l;
          }
        }(r, t);
        if (u && u.error) throw new Error(u.error);
        var c = u && u.body || u;
        l.map = i || p;
        var m = c && function (r, t, e, a) {
          return n.visitor = t, n.h = e, n.options = a || o, n(r);
        }(c, l, a, s);
        return l.map = null, m && m.props && m.props.children || null;
      }(c, u, C, this.map, g);
    } catch (r) {
      f ? f({
        error: r
      }) : "undefined" != typeof console && console.error && console.error("preact-markup: " + r);
    }
    if (!1 === i) return s || null;
    var x = w.hasOwnProperty("className") ? "className" : "class",
      b = w[x];
    return b ? b.splice ? b.splice(0, 0, "markup") : "string" == typeof b ? w[x] += " markup" : "object" == _typeof(b) && (b.markup = !0) : w[x] = "markup", C("div", w, s || null);
  }, i;
})(preact_module/* Component */.wA));
;// CONCATENATED MODULE: ./node_modules/preact-i18n/dist/preact-i18n.esm.js
















function preact_i18n_esm_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { preact_i18n_esm_typeof = function _typeof(obj) { return typeof obj; }; } else { preact_i18n_esm_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return preact_i18n_esm_typeof(obj); }




var preact_i18n_esm_IntlContext = (0,preact_module/* createContext */.kr)({
  intl: {}
});

/** Check if an object is not null or undefined
 *	@private
 */
function preact_i18n_esm_defined(obj) {
  return obj !== null && obj !== undefined;
}

/** A simpler Object.assign
 *  @private
 */
function preact_i18n_esm_assign(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }
  return obj;
}

/** Recursively copy keys from `source` to `target`, skipping truthy values already in `target`.
 *	@private
 */
function deepAssign(target, source) {
  var out = preact_i18n_esm_assign({}, target);
  for (var i in source) {
    if (source.hasOwnProperty(i)) {
      if (target[i] && source[i] && preact_i18n_esm_typeof(target[i]) === 'object' && preact_i18n_esm_typeof(source[i]) === 'object') {
        out[i] = deepAssign(target[i], source[i]);
      } else {
        out[i] = target[i] || source[i];
      }
    }
  }
  return out;
}

/** select('foo,bar') creates a mapping: `{ foo, bar }`
 *	@private
 */
function preact_i18n_esm_select(properties) {
  properties = properties || {};
  if (typeof properties === 'string') {
    properties = properties.split(',');
  }
  if ('join' in properties) {
    var selected = {};
    for (var i = 0; i < properties.length; i++) {
      var val = properties[i].trim();
      if (val) {
        selected[val.split('.').pop()] = val;
      }
    }
    return selected;
  }
  return properties;
}
function objectWithoutProperties(obj, exclude) {
  var target = {};
  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }
  return target;
}
var URL_FLAG = /[?&#]intl=show/;

/** `<IntlProvider>` is a nestable internationalization definition provider.
 *	It exposes an Intl scope & definition into the tree,
 *	making them available to descendant components.
 *
 *	> **Note:** When nested, gives precedence to keys higher up the tree!
 *	> This means lower-level components can set their defaults by wrapping themselves
 *	> in an `<IntlProvider>`, but still remain localizable by their parent components.
 *
 *	@name IntlProvider
 *	@param props
 *	@param {String} [props.scope]			Nest `definition` under a root key, and set the active scope for the tree (essentially prefixing all `<Text />` keys).
 *	@param {Boolean} [props.mark=false]		If `true`, all `<Text>` elements will be shown with a red/green background indicating whether they have valid Intl keys.
 *	@param {Object} [props.definition={}]	Merge the given definition into the current intl definition, giving the *current* definition precedence (i.e., only adding keys, acting as defaults)
 *
 *	@example
 *	// generally imported from a JSON file:
 *	let definition = {
 *		foo: 'Le Feux'
 *	};
 *
 *	<IntlProvider scope="weather" definition={definition}>
 *		<Text key="foo">The Foo</Text>
 *	</IntlProvider>
 *
 *	// This will render the text:
 *	"Le Feux"
 */

function preact_i18n_esm_IntlProvider(ref) {
  var scope = ref.scope;
  var mark = ref.mark;
  var definition = ref.definition;
  var rest = objectWithoutProperties(ref, ["scope", "mark", "definition"]);
  var props = rest;
  var ref$1 = (0,hooks_module/* useContext */.qp)(preact_i18n_esm_IntlContext);
  var parentIntl = ref$1.intl;
  var intl = preact_i18n_esm_assign({}, parentIntl || {});

  // set active scope for the tree if given
  if (scope) {
    intl.scope = scope;
  }

  // merge definition into current with lower precedence
  if (definition) {
    intl.dictionary = deepAssign(intl.dictionary || {}, definition);
  }
  if (mark || typeof location !== 'undefined' && String(location).match(URL_FLAG)) {
    intl.mark = true;
  }
  return (0,preact_module.h)(preact_i18n_esm_IntlContext.Provider, {
    value: {
      intl: intl
    }
  }, props.children);
}

/**
 * Higher-order function that creates an `<IntlProvider />` wrapper component for the given component.  It
 * takes two forms depending on how many arguments it's given:
 * It can take a functional form like:
 * intl(ComponentToWrap, options)
 *
 * or it can take an annotation form like:
 * @intl(options)
 * class ComponentToWrap extends Component {}
 *
 *	@param {Component or Object} args[0] If there are two arguments, the first argument is the Component to wrap in `<IntlProvider/>`. If there is just one argument, this is the options object to pass as `props` to `<IntlProvider/>`. See the definition of the options param below for details.
 *	@param {Object} options If there are two arguments, the second argument is Passed as `props` to `<IntlProvider />`
 *	@param [options.scope]			Nest `definition` under a root key, and set the active scope for the tree (essentially prefixing all `<Text />` keys).
 *	@param [options.definition={}]	Merge the given definition into the current intl definition, giving the *current* definition precedence (i.e., only adding keys, acting as defaults)
 */
function intl(Child, options) {
  if (arguments.length < 2) {
    options = Child;
    return function (Child) {
      return intl(Child, options);
    };
  }
  function IntlProviderWrapper(props) {
    return (0,preact_module.h)(preact_i18n_esm_IntlProvider, options || {}, (0,preact_module.h)(Child, props));
  }
  IntlProviderWrapper.getWrappedComponent = Child && Child.getWrappedComponent || function () {
    return Child;
  };
  return IntlProviderWrapper;
}
var EMPTY = {};

/** Populate {{template.fields}} within a given string.
 *
 *	@private
 *	@param {String} template	The string containing fields to be resolved
 *	@param {Object} [fields={}]	Optionally nested object of fields, referencable from `template`.
 *	@example
 *		template('foo{{bar}}', { bar:'baz' }) === 'foobaz'
 */
function preact_i18n_esm_template(template, fields, scope, dictionary) {
  return template && template.replace(/\{\{([\w.-]+)\}\}/g, replacer.bind(null, fields || EMPTY, scope, dictionary));
}

/** Replacement callback for injecting fields into a String
 *	@private
 */
function replacer(currentFields, scope, dictionary, s, field) {
  var parts = field.split('.'),
    v = currentFields;
  for (var i = 0; i < parts.length; i++) {
    v = v[parts[i]];
    if (v == null) {
      return '';
    } // eslint-disable-line eqeqeq

    //allow field values to be <Text /> nodes
    if (v && v.type === preact_i18n_esm_Text) {
      return preact_i18n_esm_translate(v.props.id, scope, dictionary, v.props.fields, v.props.plural, v.props.fallback);
    }
  }
  // allow for recursive {{config.xx}} references:
  if (typeof v === 'string' && v.match(/\{\{/)) {
    v = preact_i18n_esm_template(v, currentFields);
  }
  return v;
}

/** Attempts to look up a translated value from a given dictionary.
 *  Also supports json templating using the format: {{variable}}
 *  Falls back to default text.
 *
 *  @param {String} id  			Intl field name/id (subject to scope)
 *  @param {String} [scope='']		Scope, which prefixes `id` with `${scope}.`
 *  @param {Object} dictionary		A nested object containing translations
 *  @param {Object} [fields={}]		Template fields for use by translated strings
 *  @param {Number} [plural]		Indicates a quantity, used to trigger pluralization
 *  @param {String|Array} [fallback]	Text to return if no translation is found
 *  @returns {String} translated
 */
function preact_i18n_esm_translate(id, scope, dictionary, fields, plural, fallback) {
  if (scope) {
    id = scope + '.' + id;
  }
  var value = dictionary && dlv_umd_default()(dictionary, id);

  // plural forms:
  // key: ['plural', 'singular']
  // key: { none, one, many }
  // key: { zero, one, other }
  // key: { singular, plural }
  if ((plural || plural === 0) && value && preact_i18n_esm_typeof(value) === 'object') {
    if (value.splice) {
      value = value[plural] || value[0];
    } else if (plural === 0 && preact_i18n_esm_defined(value.none || value.zero)) {
      value = value.none || value.zero;
    } else if (plural === 1 && preact_i18n_esm_defined(value.one || value.singular)) {
      value = value.one || value.singular;
    } else {
      value = value.some || value.many || value.plural || value.other || value;
    }
  }
  return value && preact_i18n_esm_template(value, fields, scope, dictionary) || fallback || null;
}

/** Highlight/colorize the i18n'd node if `mark` is set on `intl` in context.  If not, just returns `value`
 *
 *	@private
 *	@param {String|VNode} value	The l10n'd text/vnode to highlight or pass through
 *	@param {string} id	The key used to lookup the value in the intl dictionary
 */
function preact_i18n_esm_HighlightI18N(ref) {
  var value = ref.value;
  var id = ref.id;
  var ref$1 = (0,hooks_module/* useContext */.qp)(preact_i18n_esm_IntlContext);
  var intl = ref$1.intl;
  if (intl && intl.mark) {
    var dictionaryKey = "dictionary" + (intl && intl.scope ? "." + intl.scope : '') + "." + id;
    return (0,preact_module.h)('mark', {
      style: {
        background: value ? dlv_umd_default()(intl, dictionaryKey) ? 'rgba(119,231,117,.5)' : 'rgba(229,226,41,.5)' : 'rgba(228,147,51,.5)'
      },
      title: id
    }, value);
  }
  return value;
}

/** `<Text>` renders internationalized text.
 *	It attempts to look up translated values from a dictionary in context.
 *
 *	Template strings can contain `{{field}}` placeholders,
 *	which injects values from the `fields` prop.
 *
 *	When string lookup fails, renders its children as fallback text.
 *
 *	@param {Object}       props               props
 *	@param {String}       props.id            Key to look up in intl dictionary, within any parent scopes (`$scope1.$scope2.$id`)
 *	@param {ReactElement} [props.children]    Fallback text if no definition is found
 *	@param {Object}       [props.fields={}]   Values to inject into template `{{fields}}`. Values in the `fields` object will be coerced to strings, with the exception of `<Text/>` nodes which will be resolved to their translated value
 *	@param {Number}       [props.plural]      Integer "count", used to select plural forms
 *
 *	@example
 *	// If there is no dictionary in context..
 *	<Text id="foo">The Foo</Text>
 *	// ..produces the text:
 *	"The Foo"
 *
 *	@example
 *	// Given a dictionary and some fields..
 *	<IntlProvider definition={{ foo:'Le Feux {{bar}}' }}>
 *		<Text id="foo" fields={{ bar: 'BEAR' }}>The Foo</Text>
 *	</IntlProvider>
 *	// ..produces the text:
 *	"Le Feux BEAR"
 *
 *	@example
 *	// Within a scope, both `id` and the definition are namespaced..
 *	<IntlProvider scope="weather" definition={{ foo:'Le Feux' }}>
 *		<Text id="foo">The Foo</Text>
 *	</IntlProvider>
 *	// ..produces the text:
 *	"Le Feux"
 */
function preact_i18n_esm_Text(ref) {
  var id = ref.id;
  var fallback = ref.children;
  var plural = ref.plural;
  var fields = ref.fields;
  var ref$1 = (0,hooks_module/* useContext */.qp)(preact_i18n_esm_IntlContext);
  var intl = ref$1.intl;
  var value = preact_i18n_esm_translate(id, intl && intl.scope, intl && intl.dictionary, fields, plural, fallback);
  return (0,preact_module.h)(preact_i18n_esm_HighlightI18N, {
    id: id,
    value: value
  });
}

/** Translates the property values in an Object, returning a copy.
 *	**Note:** By default, `String` keys will be treated as Intl ID's.
 *	Pass `true` to return an Object containing *only* translated
 *	values where the prop is a <Text /> node.
 *
 *	@private
 *	@param {Object} props	An object with values to translate
 *	@param {Object} intl	An intl context object (eg: `context.intl`)
 *	@param {Boolean} [onlyTextNodes=false]	Only process `<Text />` values
 *	@returns {Object} translatedProps
 */
function translateMapping(props, intl, onlyTextNodes) {
  var out = {};
  intl = intl || {};
  props = preact_i18n_esm_select(props);
  for (var name in props) {
    if (props.hasOwnProperty(name) && props[name]) {
      var def = props[name];

      // if onlyTextNodes=true, skip any props that aren't <Text /> vnodes
      if (!onlyTextNodes && typeof def === 'string') {
        out[name] = preact_i18n_esm_translate(def, intl.scope, intl.dictionary);
      } else if (def.type === preact_i18n_esm_Text) {
        // it's a <Text />, just grab its props:
        def = preact_i18n_esm_assign({
          // use children as fallback content
          fallback: def.props.children
        }, def.props);
        out[name] = preact_i18n_esm_translate(def.id, intl.scope, intl.dictionary, def.fields, def.plural, def.fallback);
      }
    }
  }
  return out;
}

/** `<Localizer />` is a Compositional Component.
 *	It "renders" out any `<Text />` values in its child's props.
 *
 *	@name Localizer
 *	@param {Object} props
 *	@param {Object} props.children	Child components with props to localize.
 *	@param {Object} context
 *	@param {Object} context.intl		[internal] dictionary and scope info
 *	@example
 *	<Localizer>
 *		<input placeholder={<Text id="username.placeholder" />} />
 *	</Localizer>
 *	// produces:
 *	<input placeholder="foo" />
 *
 *	@example
 *	<Localizer>
 *		<abbr title={<Text id="oss-title">Open Source Software</Text>}>
 *			<Text id="oss">OSS</Text>
 *		</abbr>
 *	</Localizer>
 *	// produces:
 *	<abbr title="Open Source Software">OSS</abbr>
 */
function Localizer(ref) {
  var children = ref.children;
  var ref$1 = (0,hooks_module/* useContext */.qp)(preact_i18n_esm_IntlContext);
  var intl = ref$1.intl;
  return children && children.length ? children.map(function (child) {
    return (0,preact_module/* cloneElement */.Tm)(child, translateMapping(child.props, intl, true));
  }) : children && (0,preact_module/* cloneElement */.Tm)(children, translateMapping(children.props, intl, true));
}
function objectWithoutProperties$1(obj, exclude) {
  var target = {};
  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }
  return target;
}

/* eslint-disable react/no-danger */

/** `<MarkupText>` is just like {@link Text} but it can also contain html markup in rendered strings.  It wraps its contents in a `<span>` tag.
 *
 *	@param {Object} props				props
 *	@param {String} props.id			Key to look up in intl dictionary, within any parent scopes (`$scope1.$scope2.$id`)
 *	@param {Object} [props.fields={}]	Values to inject into template `{{fields}}`.  Values in the `fields` object will be coerced to strings, with the exception of `<Text/>` nodes which will be resolved to their translated value
 *	@param {Number} [props.plural]		Integer "count", used to select plural forms
 *
 *	@example
 *	// If there is no dictionary in context..
 *	<MarkupText id="foo"><b>The Foo</b></MarkupText>
 *	// ..produces the vnode:
 *	<span><b>The Foo</b></span>
 *
 *	@example
 *	// Given a dictionary and some fields..
 *	<IntlProvider definition={{ foo:'Le Feux <b>{{bar}}</b>' }}>
 *		<MarkupText id="foo" fields={{ bar: 'BEAR' }}>The Foo</MarkupText>
 *	</IntlProvider>
 *	// ..produces the vnode:
 *	<span>Le Feux <b>BEAR</b></span>
 *
 *	@example
 *	// Within a scope, both `id` and the definition are namespaced..
 *	<IntlProvider scope="weather" definition={{ foo:'Le <a href="http://foo.com">Feux</a>' }}>
 *		<MarkupText id="foo">The Foo</MarkupText>
 *	</IntlProvider>
 *	// ..produces the vnode:
 *	<span>Le <a href="http://foo.com">Feux</a></span>
 *
 *	@example
 *	// renders nothing if there is no key match and no fallback
 *	<div><MarkupText /></div>
 *	// ..produces the vnode:
 *	<div/>
 */
function MarkupText(ref) {
  var id = ref.id;
  var fields = ref.fields;
  var plural = ref.plural;
  var children = ref.children;
  var rest = objectWithoutProperties$1(ref, ["id", "fields", "plural", "children"]);
  var props = rest;
  return (0,preact_module.h)(Localizer, null, (0,preact_module.h)(Html, Object.assign({}, {
    html: (0,preact_module.h)(preact_i18n_esm_Text, {
      id: id,
      fields: fields,
      plural: plural,
      children: children
    }),
    id: id
  }, props)));
}
function Html(ref) {
  var html = ref.html;
  var id = ref.id;
  var rest = objectWithoutProperties$1(ref, ["html", "id"]);
  var props = rest;
  return (0,preact_module.h)(preact_i18n_esm_HighlightI18N, {
    id: id,
    value: !html ? html : typeof html === 'string' ? (0,preact_module.h)(preact_markup_module, Object.assign({}, {
      type: "html",
      trim: false
    }, props, {
      markup: html
    })) : (0,preact_module.h)('span', null, html)
  });
}

/** `@withText()` is a Higher Order Component, often used as a decorator.
 *
 *	It wraps a child component and passes it translations
 *	based on a mapping to the dictionary & scope in context.
 *
 *	@param {Object|Function|String} mapping		Maps prop names to intl keys (or `<Text>` nodes).
 *
 *	@example @withText({
 *		placeholder: 'user.placeholder'
 *	})
 *	class Foo {
 *		// now the `placeholder` prop is our localized String:
 *		render({ placeholder }) {
 *			return <input placeholder={placeholder} />
 *		}
 *	}
 *
 *	@example @withText({
 *		placeholder: <Text id="user.placeholder">fallback text</Text>
 *	})
 *	class Foo {
 *		render({ placeholder }) {
 *			return <input placeholder={placeholder} />
 *		}
 *	}
 *
 *	@example @withText('user.placeholder')
 *	class Foo {
 *		// for Strings/Arrays, the last path segment becomes the prop name:
 *		render({ placeholder }) {
 *			return <input placeholder={placeholder} />
 *		}
 *	}
 *
 *	@example <caption>Works with functional components, too</caption>
 *	const Foo = withText('user.placeholder')( props =>
 *		<input placeholder={props.placeholder} />
 *	)
 *
 * 	@example <caption>getWrappedComponent() returns wrapped child Component</caption>
 *	const Foo = () => <div/>;
 *	const WrappedFoo = withText('user.placeholer')(Foo);
 *	WrappedFoo.getWrappedComponent() === Foo; // true
 */
function withText(mapping) {
  return function withTextWrapper(Child) {
    function WithTextWrapper(props, context) {
      var ref = (0,hooks_module/* useContext */.qp)(preact_i18n_esm_IntlContext);
      var intl = ref.intl;
      var map = typeof mapping === 'function' ? mapping(props, {
        intl: intl
      }) : mapping;
      var translations = translateMapping(map, intl);
      return (0,preact_module.h)(Child, preact_i18n_esm_assign(preact_i18n_esm_assign({}, props), translations));
    }
    WithTextWrapper.getWrappedComponent = Child && Child.getWrappedComponent || function () {
      return Child;
    };
    return WithTextWrapper;
  };
}

/** `useText` is the hook version of {@link withText}
 *
 *	@param {Object|Function|String} mapping		Maps prop names to intl keys (or `<Text>` nodes).
 *
 *	@example function MyComponent() {
 *		const { placeholder } = useText({
 *			placeholder: 'user.placeholder'
 *		});
 *		return <input placeholder={placeholder} />
 *	}
 *
 *	@example function MyComponent() {
 *		const { placeholder } = useText({
 *			placeholder: <Text id="user.placeholder">fallback text</Text>
 *		});
 *		return <input placeholder={placeholder} />
 *	}
 *
 *	@example function MyComponent() {
 *		// for Strings/Arrays, the last path segment becomes the prop name:
 *		const { placeholder } = useText('user.placeholder');
 *
 *		return <input placeholder={placeholder} />
 *	}
 */
function useText(mapping) {
  var ref = (0,hooks_module/* useContext */.qp)(preact_i18n_esm_IntlContext);
  var intl = ref.intl;
  return translateMapping(typeof mapping === 'function' ? mapping({
    intl: intl
  }) : mapping, intl);
}
intl.intl = intl;
intl.IntlContext = preact_i18n_esm_IntlContext;
intl.IntlProvider = preact_i18n_esm_IntlProvider;
intl.Text = preact_i18n_esm_Text;
intl.MarkupText = MarkupText;
intl.Localizer = Localizer;
intl.withText = withText;
intl.useText = useText;
intl.translate = preact_i18n_esm_translate;
/* harmony default export */ const preact_i18n_esm = ((/* unused pure expression or super */ null && (intl)));

;// CONCATENATED MODULE: ./node_modules/preact-i18n/src/lib/util.js











function util_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { util_typeof = function _typeof(obj) { return typeof obj; }; } else { util_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return util_typeof(obj); }
/** Check if an object is not null or undefined
 *	@private
 */
function util_defined(obj) {
  return obj !== null && obj !== undefined;
}

/** A simpler Object.assign
 *  @private
 */
function util_assign(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }
  return obj;
}

/** Recursively copy keys from `source` to `target`, skipping truthy values already in `target`.
 *	@private
 */
function util_deepAssign(target, source) {
  var out = util_assign({}, target);
  for (var i in source) {
    if (source.hasOwnProperty(i)) {
      if (target[i] && source[i] && util_typeof(target[i]) === 'object' && util_typeof(source[i]) === 'object') {
        out[i] = util_deepAssign(target[i], source[i]);
      } else {
        out[i] = target[i] || source[i];
      }
    }
  }
  return out;
}

/** select('foo,bar') creates a mapping: `{ foo, bar }`
 *	@private
 */
function util_select(properties) {
  properties = properties || {};
  if (typeof properties === 'string') {
    properties = properties.split(',');
  }
  if ('join' in properties) {
    var selected = {};
    for (var i = 0; i < properties.length; i++) {
      var val = properties[i].trim();
      if (val) selected[val.split('.').pop()] = val;
    }
    return selected;
  }
  return properties;
}
;// CONCATENATED MODULE: ./node_modules/preact-i18n/src/contexts/intl-context.js

var intl_context_IntlContext = (0,preact_module/* createContext */.kr)({
  intl: {}
});
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
;// CONCATENATED MODULE: ./node_modules/preact-i18n/src/components/highlight-i18n.js






/** Highlight/colorize the i18n'd node if `mark` is set on `intl` in context.  If not, just returns `value`
 *
 *	@private
 *	@param {String|VNode} value	The l10n'd text/vnode to highlight or pass through
 *	@param {string} id	The key used to lookup the value in the intl dictionary
 */
function highlight_i18n_HighlightI18N(_ref) {
  var value = _ref.value,
    id = _ref.id;
  var _useContext = useContext(IntlContext),
    intl = _useContext.intl;
  if (intl && intl.mark) {
    var dictionaryKey = "dictionary".concat(intl && intl.scope ? ".".concat(intl.scope) : '', ".").concat(id);
    return h("mark", {
      style: {
        background: value ? delve(intl, dictionaryKey) ? 'rgba(119,231,117,.5)' : 'rgba(229,226,41,.5)' : 'rgba(228,147,51,.5)'
      },
      title: id
    }, value);
  }
  return value;
}
;// CONCATENATED MODULE: ./node_modules/preact-i18n/src/components/text.js






/** `<Text>` renders internationalized text.
 *	It attempts to look up translated values from a dictionary in context.
 *
 *	Template strings can contain `{{field}}` placeholders,
 *	which injects values from the `fields` prop.
 *
 *	When string lookup fails, renders its children as fallback text.
 *
 *	@param {Object}       props               props
 *	@param {String}       props.id            Key to look up in intl dictionary, within any parent scopes (`$scope1.$scope2.$id`)
 *	@param {ReactElement} [props.children]    Fallback text if no definition is found
 *	@param {Object}       [props.fields={}]   Values to inject into template `{{fields}}`. Values in the `fields` object will be coerced to strings, with the exception of `<Text/>` nodes which will be resolved to their translated value
 *	@param {Number}       [props.plural]      Integer "count", used to select plural forms
 *
 *	@example
 *	// If there is no dictionary in context..
 *	<Text id="foo">The Foo</Text>
 *	// ..produces the text:
 *	"The Foo"
 *
 *	@example
 *	// Given a dictionary and some fields..
 *	<IntlProvider definition={{ foo:'Le Feux {{bar}}' }}>
 *		<Text id="foo" fields={{ bar: 'BEAR' }}>The Foo</Text>
 *	</IntlProvider>
 *	// ..produces the text:
 *	"Le Feux BEAR"
 *
 *	@example
 *	// Within a scope, both `id` and the definition are namespaced..
 *	<IntlProvider scope="weather" definition={{ foo:'Le Feux' }}>
 *		<Text id="foo">The Foo</Text>
 *	</IntlProvider>
 *	// ..produces the text:
 *	"Le Feux"
 */
function text_Text(_ref) {
  var id = _ref.id,
    fallback = _ref.children,
    plural = _ref.plural,
    fields = _ref.fields;
  var _useContext = useContext(IntlContext),
    intl = _useContext.intl;
  var value = translate(id, intl && intl.scope, intl && intl.dictionary, fields, plural, fallback);
  return h(HighlightI18N, {
    id: id,
    value: value
  });
}
;// CONCATENATED MODULE: ./node_modules/preact-i18n/src/lib/template.js






var template_EMPTY = {};

/** Populate {{template.fields}} within a given string.
 *
 *	@private
 *	@param {String} template	The string containing fields to be resolved
 *	@param {Object} [fields={}]	Optionally nested object of fields, referencable from `template`.
 *	@example
 *		template('foo{{bar}}', { bar:'baz' }) === 'foobaz'
 */
function template_template(template, fields, scope, dictionary) {
  return template && template.replace(/\{\{([\w.-]+)\}\}/g, template_replacer.bind(null, fields || template_EMPTY, scope, dictionary));
}

/** Replacement callback for injecting fields into a String
 *	@private
 */
function template_replacer(currentFields, scope, dictionary, s, field) {
  var parts = field.split('.'),
    v = currentFields;
  for (var i = 0; i < parts.length; i++) {
    v = v[parts[i]];
    if (v == null) return ''; // eslint-disable-line eqeqeq

    //allow field values to be <Text /> nodes
    if (v && v.type === Text) {
      return translate(v.props.id, scope, dictionary, v.props.fields, v.props.plural, v.props.fallback);
    }
  }
  // allow for recursive {{config.xx}} references:
  if (typeof v === 'string' && v.match(/\{\{/)) {
    v = template_template(v, currentFields);
  }
  return v;
}
;// CONCATENATED MODULE: ./node_modules/preact-i18n/src/lib/translate.js








function translate_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { translate_typeof = function _typeof(obj) { return typeof obj; }; } else { translate_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return translate_typeof(obj); }




/** Attempts to look up a translated value from a given dictionary.
 *  Also supports json templating using the format: {{variable}}
 *  Falls back to default text.
 *
 *  @param {String} id  			Intl field name/id (subject to scope)
 *  @param {String} [scope='']		Scope, which prefixes `id` with `${scope}.`
 *  @param {Object} dictionary		A nested object containing translations
 *  @param {Object} [fields={}]		Template fields for use by translated strings
 *  @param {Number} [plural]		Indicates a quantity, used to trigger pluralization
 *  @param {String|Array} [fallback]	Text to return if no translation is found
 *  @returns {String} translated
 */
function translate_translate(id, scope, dictionary, fields, plural, fallback) {
  if (scope) id = scope + '.' + id;
  var value = dictionary && delve(dictionary, id);

  // plural forms:
  // key: ['plural', 'singular']
  // key: { none, one, many }
  // key: { zero, one, other }
  // key: { singular, plural }
  if ((plural || plural === 0) && value && translate_typeof(value) === 'object') {
    if (value.splice) {
      value = value[plural] || value[0];
    } else if (plural === 0 && defined(value.none || value.zero)) {
      value = value.none || value.zero;
    } else if (plural === 1 && defined(value.one || value.singular)) {
      value = value.one || value.singular;
    } else {
      value = value.some || value.many || value.plural || value.other || value;
    }
  }
  return value && template(value, fields, scope, dictionary) || fallback || null;
}
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/i18n/messages/en.json
const en_namespaceObject = JSON.parse('{"table":{"common":{"column":"Column"},"move_column_cant_split_merged_cells":{"title":"Unable to move column","text":"Cannot move a column into a merged cell. Unmerge then try again."},"move_column_cant_move_part_of_merged_cells":{"title":"Unable to move column","text":"The column you\'re trying to move contains part of a merged cell. If you want to move the column, unmerge the cells first."},"move_column_failed":{"title":"Unable to move column","text":"An unexpected error has occured while moving a column, plese try again."},"move_row_cant_split_merged_cells":{"title":"Unable to move row","text":"Cannot move a row into a merged cell. Unmerge then try again."},"move_row_cant_move_part_of_merged_cells":{"title":"Unable to move row","text":"The row you\'re trying to move contains part of a merged cell. If you want to move the row, unmerge the cells first."},"move_row_cant_move_in_sortable_table":{"title":"Unable to move row","text":"Cannot move a row in a sortable table. Cancel sorting then try again."},"move_row_cant_move_in_filtered_table":{"title":"Unable to move row","text":"Cannot move a row in a filtered table. Cancel filter then try again."},"move_row_failed":{"title":"Unable to move row","text":"An unexpected error has occured while moving a row, plese try again."},"first_move_column_or_row_message":"You can select multiple rows or columns by holding down the CTRL button and clicking on the desired rows or columns.","menu":{"delete":"Delete","help":"Help","delete_column":{"one":"Delete column","many":"Delete {{count}} columns"},"delete_row":{"one":"Delete row","many":"Delete {{count}} rows"},"add":"Add","add_row_before":{"one":"Row above","many":"{{count}} rows above"},"add_row_after":{"one":"Row below","many":"{{count}} rows below"},"add_col_before":{"one":"Column left","many":"{{count}} columns left"},"add_col_after":{"one":"Column right","many":"{{count}} columns right"},"copy_cell":{"one":"Copy cell","many":"Copy cells"},"copy_table":"Copy table","table_layout":{"name":"Table layout","column_headings":"Column headings","row_headings":"Row headings"},"import_csv":"Import from CSV","merge_cells":"Merge cells","insert_checkbox":"Insert checkbox","background_color":"Background color","formatting":"Formatting","clear":"Clear","reset":"Reset","divide_cells":"Unmerge cells","type":{"name_cell":"Cell type","name_cells":"Cells type","name_column":"Column type","name_columns":"Columns type","type_cell":{"one":"Cell type","many":"Cells type"},"type_col":{"one":"Column type","many":"Columns type"},"same_as_column":"Same as column","reset_cells":"Reset cells to default","none":"Multi type","text":"Text","textline":"Text","number":"Number","attachment":"Files","checkbox":"Checkbox","multiselect":"Multiple select","singleselect":"Single select","collaborator":"Collaborator","currency":"Currency","date":"Date","link":"Link","rating":"Rating","progress":"Progress","mention":"Mention"},"number_format":{"name":"Number format","number":"Number","commas":"Number with commas","percent":"Percent"},"currency_format":{"name":"Currency type","dollar":"Dollar","euro":"Euro","yen":"Yen","yuan":"Yuan","rouble":"Rouble","pound":"Pound","rupee":"Rupee","hryvnia":"Hryvnia","won":"Won","frank":"Frank","real":"Real","other":"Other","stick":"Show symbol","before":"Before","after":"After"},"decimal_format":{"name":"Decimal separator","comma":"Comma","point":"Point","hint":"The separator is used for decimal places. Comma decimal separators will look like 1.000,99, and point separators look like 1,000.99"},"progress_format":{"name":"Progress options","simple":"Simple","colored":"Colored","start_from":"Start from (0-100)","default_amount":"Default amount (0-100)"},"rating_format":{"name":"Rating options","star":"Star","flag":"Flag","heart":"Heart","amount":"Amount (1-10)"},"date_format":{"name":"Date/Time format"},"mention_panel":{"open":"Open","edit":"Edit","clear":"Clear"},"color_numbers":{"name":"Color numbers","enable":"Enable color numbers"},"filter":"Filter","comment":"Comment"},"formatting_menu":{"align_left":"Left","align_center":"Center","align_right":"Right","valign_top":"Top","valign_center":"Middle","valign_bottom":"Bottom","text":"Text","text_align":"Text align","text_color":"Text color","bold":"Bold","italic":"Italic","strikethrough":"Strikethrough","underline":"Underline"},"col_menu":{"add_column_after":{"one":"Add column right","many":"Add {{count}} columns right"},"add_column_before":{"one":"Add column left","many":"Add {{count}} columns left"},"duplicate_column":{"one":"Duplicate column","many":"Duplicate columns"},"rename":"Rename"},"row_menu":{"add_row_after":{"one":"Add row below","many":"Add {{count}} rows below"},"add_row_before":{"one":"Add row above","many":"Add {{count}} rows above"}},"warning":{"merge_different":"Can\'t merge different types of objects","convert_merged":"Can\'t convert merged cells"},"select":{"create_list":"Type to create a list","create_item":"Type to create an item","create_option":"Type to create option","create_label":"Type to create label","create":"Create","delete":"Delete"},"attachment":{"upload_more":"Upload file(s)","downloading":"Downloading"},"collaborator":{"placeholder":"Type to add people","no_result":"No results","loading":"Loading...","unknown":"Unknown Person"},"checkbox":{"checked":"Yes","not_checked":"No"},"sorting":{"name":"Sorting","sort":"Sort","disable":"Remove sort","change":"Click for change","asc":{"common":"Ascending","text":"Sort A-Z","number":"Sort 1-9","checkbox":"Unselected first"},"desc":{"common":"Descending","text":"Sort Z-A","number":"Sort 9-1","checkbox":"Selected first"},"warning":{"column_merged":{"title":"Unable to sort column","text":"Can\'t sort column with merged cells"},"table_rowspan":{"title":"Unable to sort column","text":"Can\'t sort table with merged rows"},"merge":{"title":"Cells cannot be merged","text":"Cells cannot be merged while column sorting is active. Disable sorting and try again."},"different_currencies":{"title":"Sort warning","text":"You\'re using different currencies in one column. Sorting may be incorrect."}},"exit_dialog":{"title":"Remove sort","toggle":"Keep sorted","text_keep":"Keep sorted","text_no_keep":"Column order will be restored to its initial order before sorting was applied","apply":"Apply"}},"filter":{"by_field":"Filter by this field","empty_table":"All records are filtered","popup_title":"In this table, show records","empty_filters":"No conditions are applied to this database","where":"Where","or":"Or","and":"And","add_condition":"Add condition","clear_all":"Clear all","contains":"contains","is":"is","is_not":"is not","contains_not":"contains not","has_any_of":"has any of","has_none_of":"has none of","empty":"empty","not_empty":"not empty","filetype":"filetype","select_users_placeholder":"Select users","type_text_placeholder":"Type text","type_text_or_select_placeholder":"Type text or select","type_number_placeholder":"Type number","select_type_placeholder":"Select type","select_date_placeholder":"Select date","date":{"today":"Today","yesterday":"Yesterday","tomorrow":"Tomorrow","custom":"Custom"},"filetypes":{"images":"Images","documents":"Documents","media":"Media","other":"Other"},"warning":{"cells_merged":{"title":"Unable to filter table","text":"Can\'t filter column with merged cells"},"merge":{"title":"Cells cannot be merged","text":"Cells cannot be merged while table filter is active. Disable filter and try again."},"column_multitype":{"title":"Unable to filter table","text":"There is no such possibility to filter columns with Multi type. Please, try to convert to another type and try again."},"table_not_have_typed_columns":{"title":"Unable to filter table","text":"No columns available for filtering."}},"enable_filter":"Enable filter","disable_filter":"Disable filter"},"wrap_cells":{"layout_menu":"Wrap cells","warnings":{"merge":{"title":"Unable to merge cells","text":"Unable to merge cells in nowrap mode"},"toggle":{"title":"Unable to switch option","text":"The table contains merged cells"}}},"duplicate_column":{"title":"Duplicate column","text_1":"Duplicate column content","text_2":"You can duplicate the whole column containing data or leave duplicated column empty","accept":"Duplicate","copy":"copy"},"convert_column":{"title":"Change column type","text_before":"This column contains values. Changing the column type will erase some of the values. Use","text_cmd":"undo","text_after":"command to reverse changes if needed.","accept":"Change type"},"merge_cells_with_comments":{"title":"Merging cells","text":"The cells will be merged from left to right and the new cell will show a comment from the left cell.","accept":"Merge"},"summary":{"layout_menu":"Show calculation bar","name":{"none":"None","all":"All","empty":"Empty","fill":"Filled","unique":"Unique","empty_percent":"Percent empty","fill_percent":"Percent filled","unique_percent":"Percent unique","sum":"Sum","average":"Average","min":"Min","max":"Max","median":"Median","min_date":"Earliest date","max_date":"Latest date","range_days":"Date range (days)","range_month":"Date range (month)","checked":"Checked","unchecked":"Unchecked","checked_percent":"Percent checked","unchecked_percent":"Percent unchecked","filter_rating":"With rating:","filter_progress":"With progress:","filesize_min":"Min size","filesize_max":"Max size"},"item":{"none":"Calculate","min_date":"Earliest","max_date":"Latest","range_days":"Range (days)","range_month":"Range (month)","checked_percent":"Checked","unchecked_percent":"Unchecked","filter_rating":"With rating","filter_progress":"With progress"}},"comments":{"tooltip":{"one":"Comment","more":"Comments"}}},"file":{"image_viewer":{"could_not_load_image":"Couldn\'t load the image"},"download_file":"Download {{name}}","listen_file":"Play {{name}}","stop_file":"Stop {{name}}","uploading":"Uploading","wrtc":{"how_to_fix":"How to fix it?","how_to_url":"https://nimbusweb.me/s/share/5441210/4qccr41slk6wsw61h5fb","how_to_url2":"https://nimbusweb.me/s/share/5607239/l55bgak2ivs9bfptruka#b1995924032_670","rec_err_au":"Recording error. No microphone access.","rec_err_vi":"Recording error. No access to microphone/webcam. ","allow_micro":"Allow Access to microphone","allow_media":"Select the window you want to record","select_opt":"What will be recorded","screenonly":"Screen only","camonly":"Cam only","screencam":"Screen + Cam","enable_micro":"Enable microphone","startRecording":"Start recording","stopRecording":"Stop recording","pauseRecording":"Pause recording","resumeRecording":"Resume recording","cancelRecording":"Сancel recording","confirmCancel":"Are you sure you want to cancel the video recording?","cancel":"Сancel","prepareUpload":"Please wait, preparing to upload record","hasTmpRecord":"The recording was interrupted but not lost","restore":"Restore","delete":"Delete","recordOnAnotherDevice":"Recording is in progress on another device ..."},"menu":{"enabled":"Enabled","disabled":"Disabled","open_in_new_tab":"Open in new tab","copy_link":"Copy link to file","expand_in_full_window":"Expand in Full Window","autoplay":"Autoplay","sound_default":"Sound by default","sound_loop":"Loop","sound_hideControls":"Hide controls","sound_showPanel":"Show top panel","shadow_video":"Shadow for video","video_params":"Video settings","disallow_download":"Downloading","for_note":"For workspaces users","for_share":"Public page","motion_video":"Motion video","preview_video":"Change preview","preview_video_btn":"Preview","print":"Print","convert_to_image":"Convert to image","convert_to_file":"Convert to file","style":"Style","shadow_image":"Shadow for image","rename":"Rename","replace":"Replace","delete":"Delete","download":"Download","get_text_from_image":"Get text from image","view_as":"View as","single_page":"Single page","all_pages":"All pages","cta_motion_video_message":"CTA is enabled for videos. You cannot use CTA and Motion video at the same time. Disable CTA and try enabling Motion video again.","cta_loop_message":"CTA is enabled for videos. You cannot use CTA and Loop at the same time. Disable CTA and try enabling Loop again.","grid":"Grid","cta_drop_in_grid":"CTA is enabled for videos. We recommend checking the correctness of the CTA display after transferring the video into a grid column.","cta_exists_in_grid":"The grid column has a video with an active CTA. Please check if it is correct after the transfer."},"downloading":"Downloading","attachment_not_found_error":"Error while uploading","pdf_viewer":{"initializing_full_window_view":"Initializing Full Window view","preparing_document_for_printing":"Preparing document for printing...","printing_initialization":"Printing initialization...","abort":"abort","set_page_as_default":"Set page as default","unset_page_as_default":"Default page. Click to make the page normal."},"video_just_uploaded_codec_error":"You are trying to upload a video that has been encoded with the {codec} codec. We do not guarantee the correct playback of this video on all browsers. We recommend converting the video to another format and uploading it again.","video_codec_error":"This video is encoded with {codec} codec, which is not supported in your browser.","safari_webm_not_support":"Currently, Safari browsers do not support WEBM format. Try to open the page in another browser, such as Google Chrome or Mozilla Firefox.","video_transcribe":"Transcribe","video_summary":"Summary","video_meeting_notes":"Meeting Notes","video_ask_ai":"Ask AI"},"image":{"text_from_image_popup":{"title":"Text from image","no_text":"There is no text","copy":"Copy all text"},"unknown_error":"The link is wrong","add_image":"Paste link or ","add_image_or":"or","add_image_small":"Paste or ","browse":"browse","browse_image":"Browse image","too_large_error":"The image size is too large","image_info_dialog":{"title":"Image info","type":"Type","size":"Size","location":"Location","copy_link":"Copy link"},"rotate_wait":{"full":"Please wait","medium":"Wait"},"attachment_not_found_error":"An unexpected error has occured with the image","readonly_placeholder":"Empty image","unsplash":{"name":"Unsplash","header":"Search image","placeholder":"Search for an image","search":"Search","description":"Search to find more results.","no_result":"No images found.","caption_preffix":"Photo by"},"comments":"Comments"},"attachment":{"unknown_error":"Something went wrong, try choosing another file","attachment_is_being_uploaded":"A file is being uploaded on another device...","attachment_will_be_downloaded_online":"The file will be downloaded when you are online.","attachment_preview_is_not_available":"Preview is not available.","choose_a_file":"Choose files","wait_resolving_without_info":"Please wait..."},"video":{"player":{"play":"Play","pause":"Pause","volume":"Volume","fullscreen_on":"Fullscreen","fullscreen_off":"Exit Fullscreen","watch_again":"Watch again"}},"step_outliner":{"about_steps":"About steps","total_steps":"Total steps"},"search":{"placeholder":"Find in page","matches":"Matches:"},"copy":{"copied":"Copied!","copy_to_clipboard":"Copy to clipboard"},"apply":"Apply","done":"Done","block_menu":{"align":{"left":"Left align","center":"Center align","right":"Right align","justify":"Justify"},"indent":{"indent":"Increase indent","outdent":"Decrease indent"},"tooltip":"Drag to move\\n<span>Click to open menu</span>","copy_tooltip":"Copy link","color":{"background_color":"Background color","color":"Color","line_color":"Line color","line_type":"Line type","player_color":"Player\'s color"},"line_type":{"default":"Standart line","dotted":"Dots"},"add":{"name":"Add block","above":"Above","below":"Below","left":"Left","right":"Right","above_column":"Above column","below_column":"Under column"},"convert_to":{"name":"Convert to","to_do_list":"Checklist","number_list":"Number List","bullet_list":"Bullet List","paragraph":"Paragraph","large_heading":"Large Heading","medium_heading":"Medium Heading","small_heading":"Small Heading","large_heading_toggle":"Collapsible Large Heading","medium_heading_toggle":"Collapsible Medium Heading","small_heading_toggle":"Collapsible Small Heading","code":"Code","quote":"Quote","hint":"Hint","image":"Image","file":"File","remote_frame":"Embed","link":"Link","bookmark":"Bookmark","button":"Button","toggle":"Toggle Block","step":"Steps"},"comment_block":"Comment","edit":"Edit","duplicate":"Duplicate","copy_block":"Copy block","copy_blocks":"Copy blocks","copy_link":"Copy Link","delete":"Delete","replace":"Replace","blot_lock":"Lock block","blot_unlock":"Unlock block","set_as_preview":"Set as preview","get_text_from_image":"Get text from image","edit_image":"Edit image","download":"Download","view_full_size":"View full size","open_in_new_tab":"Open in new tab","image_info":"Image info","rotate_image":"Rotate","add_sub_task":"Add subtask","add_sub_text":"Add subtext","layout":"Layout","embed_align":{"left":"Left align","center":"Center align","right":"Right align","default":"Default size","full_width":"Full width"},"expand_all":"Expand all","collapse_all":"Collapse all","add_caption":"Add caption","blot_locked_admin":"Editing of the block is denied. Click to unlock it.","blot_locked_admins":"Editing of the blocks is denied. Click to unlock it.","blot_locked_user":"You don’t have permission to edit this bock. Contact your organization admin.","show_header":"Show top bar","show_borders":"Show borders","rename":"Rename"},"convert_menu_groups":{"suggestions":"Suggestions","basic":"Basic","advanced":"Advanced","media":"Media","embed":"Integrations","views":"Views","templates":"Templates","helpful_links":"Helpful links"},"embedded_menu":{"start_typing":"Type \\"/\\" or add","start_typing_full":"Start writing or type \\"/\\", \\"@\\"","more_items":"More items...","rate_editor":"Rate the Page Editor","add_an_element":"Add an element","paragraph":"Paragraph","todo":"Checkbox list","numbered_list":"Numbered list","bullet_list":"Bullet list","table":"Table","image":"Image","file":"File","audioRec":"Audio Record","videoRec":"Video Record","recordExist":"You cannot start a new recording until the previous one is completed. End or delete the previous record to start a new one.","large_heading":"Heading 1","medium_heading":"Heading 2","small_heading":"Heading 3","large_heading_toggle":"Collapsible Large Heading","medium_heading_toggle":"Collapsible Medium Heading","small_heading_toggle":"Collapsible Small Heading","section_break":"Line","link":"Link","code":"Code","quote":"Quote","hint":"Hint","hint_placeholder":"Type something","mention":"Mention member","outline":"Outline","remote_frame":"Embed: Link, iFrame, JS Code","integrations":"Integrations","google_drive":"Google Drive","google_sheets":"Google sheets","html":"HTML","toggle":"Toggle block","tasks_list":"Task list","lock_blot":"Lock block","link_page":"Link page / Create","date":"Date","more_integrations":"more integrations","two_columns":"2 columns","meeting_notes":"Marketing Strategy","marketing_brief":"Marketing Quarterly Planning ","content_plan":"Content plan","more_templates":"more templates","get_feedback":"Get a feedback","contact_support":"Contact support","learn_nimbus":"Learn Nimbus","footer_top":"Did you know? You can start typing to search the list","footer_bottom":"Can’t find smth you want?","footer_link":"Tell us","add_note":"New page","database_with_options":"Database","board":"Kanban / Task Board","progress":"Progress","dropdown_list":"Dropdown list","uploader":"File uploader","use_ai":"Use Fusebase AI","helper":"AI Helper","summarize":"Summarize","explain":"Explain","improve":"Improve","spelling":"Fix spelling and grammar","cta":"Call to actions","shorter":"Make shorter","longer":"Make longer","step":"Steps","step_outliner":"Step outliner"},"button":{"title":"Title","id_info_tooltip":"This ID can be used in the future when editing the CSS file.","address":"URL or Email","open_in_new_tab":"Open in new tab","shape":"Button shape","background":"Background","size":"Button size","small":"Small","medium":"Medium","big":"Big","cancel":"Cancel","done":"Done","length_error":"The text is too large for the button. Try selecting less text (no more than 50 characters).","type":"Button type","default":"Default","withShadow":"Button with shadow","3d":"3d button","convert":{"popup_title":"Convert to button"}},"link":{"open":"Open","send":"Send","copy":"Copy","edit":"Edit","remove":"Remove","text_label":"Text","url_label":"Link","email_label":"Address","copied":"Link copied to clipboard","cancel":"Cancel","done":"Done"},"syntax":{"menu":{"language":"Language","theme":"Theme","wrap":"Enable wrap","unwrap":"Disable wrap","lineNumbersOn":"Show line numbers","lineNumbersOff":"Hide line numbers"},"convert":{"popup_title":"Convert to code","blots_have_comments":"There are comments in the text that will be deleted during conversion.","text_has_inline_comments":"There are comments inside the text that will be deleted during conversion.","confirm":"Convert"}},"list":{"list_style":"List style","type_default":"Default","type_rectangle":"Rectangle","type_star":"Star","type_dart":"Dart","type_rounded":"Rounded","type_arrow":"Arrow","type_diamond":"Diamond"},"caption":{"placeholder":"Add caption"},"mention":{"show_all":"Show all","show_all_users":"Show all","placeholder":"Showing recent or type to search","user":"People","workspace":"Workspaces","folder":"Folders","note":"Pages","no_results":"No results","offline_message":"Mention only works with active connection. Turn on the Internet and try again.","info":{"note":{"one":"page","some":"pages","many":"pages"},"subfolder":{"one":"subfolder","some":"subfolders","many":"subfolders"},"member":{"one":"member","some":"members","many":"members"},"owner":"owner","loading":"Loading preview...","loading_failed":"Loading failed","not_loaded":"Page has not been loaded yet"},"back_button":"Back","create_note_for":"Create Page:","create_folder_for":"Create Folder:"},"calendar":{"ui":{"date":"Date","am":"AM","pm":"PM","date_format":"Date format","show_time":"Show time","time_format":"Time format","time_12":"12H","time_24":"24H","first_week_day":"First day of the week","time_zone":"Time zone","use_gmt":"Use GMT for all members","use_gmt_hint":"Use the same time zone (GMT) for all collaborators","table":{"clear":"Clear"},"inline":{"clear":"Delete"},"reminder":{"name":"Alert","panel_name":"Alert","push_name":"Reminder of the event","remove_confirm_message":"You have set reminders that are tied to the time. Do you want to delete these reminders?","remove_confirm_text":"Delete","remove_cancel_text":"Do not delete","before_period":"","after_period":"before","period":{"m":{"one":"minute","many":"minutes"},"h":{"one":"hour","many":"hours"},"d":{"one":"day","many":"days"},"w":{"one":"week","many":"weeks"}},"value":{"none":"None","0m":"On start","1m":"1 minute before","5m":"5 min before","10m":"10 minutes before","15m":"15 minutes before","30m":"30 minutes before","1h":"Hour before","2h":"2 hours before","1d":"Day before","2d":"2 days before","7d":"Week before","10d":"10 days before","14d":"2 weeks before","custom":"Custom"},"until":{"in":"In","d":"d","h":"h","m":"min","already_been":"Already been","less_minute":"Less than a minute","now":"Now"}},"postfix":{"day":"d","month":"m"}},"insert":{"category_name":"Date","custom":"Custom","now":"Now","today":"Today","tomorrow":"Tomorrow"},"date_format":{"ddmmyyyy":"dd/mm/yyyy","mmddyyyy":"mm/dd/yyyy","yyyyddmm":"yyyy/mm/dd","monthddyyyy":"Month dd, yyyy","default":"Match browser format"},"months":{"0":"January","1":"February","2":"March","3":"April","4":"May","5":"June","6":"July","7":"August","8":"September","9":"October","10":"November","11":"December"},"days":{"short":{"0":"Su","1":"Mo","2":"Tu","3":"We","4":"Th","5":"Fr","6":"Sa"},"full":{"0":"Sunday","1":"Monday","2":"Tuesday","3":"Wednesday","4":"Thursday","5":"Friday","6":"Saturday"}}},"content_not_supported":"This page is not supported on your version of the FuseBase app. Try updating it or use another client with the latest version.","profession_ask":{"title":"Save time by using templates to create new pages","text":"Type in your occupation and our team will create templates for you. It’s free, with no hidden charges","i_am_a":"I am a","placeholder":"e.g. designer, teacher, sales agent, etc.","request_template":"Request template","sucess_message":"Thank you! Your occupation will be added into our queue."},"bookmark":{"name":"Bookmark","edit":"Edit bookmark","title":"Title","address":"Address","description":"Description","placeholder":"Paste or write link with https://...","placeholder_mobile":"Paste or write link","loading_preview":"Loading preview…","block_menu":{"change_mode":{"menu_name":"View as","mode_tile":"Tile","mode_card":"Card","mode_cover":"Cover"},"change_preview":"Change preview","delete_preview":"Delete preview","reset_preview":"Reset preview","change_preview_background":"Preview background","options":{"menu_name":"Options","open_in_same_tab":"Open in same tab"}},"error":{"unknown_error":"Something went wrong, try enter another URL","preview_notfound":"Previews not found"},"upload":{"new_preview":"Upload New","quota_error":"The file is larger than the 3MB allowed. Try another file.","unknown_error":"Unknown error. Try another file."}},"businessCard":{"PERSON":"Name","ORGANIZATION":"Company","TITLE":"Title","ADDRESS":"Position","URL":"Site","PHONE":"Phone","EMAIL":"Email","SKYPE":"Skype","TWITTER":"Twitter","INSTAGRAM":"Instagram","FACEBOOK":"Facebook","LINKEDIN":"LinkedIn","VK":"Vk"},"dialog_common":{"button":{"ok":"Ok","cancel":"Cancel"}},"outline":{"default_name":"Outline","menu":{"expand":"Expand","collapse":"Collapse","rename":"Rename"},"context_menu":{"convert_to":{"text":"Text"},"style":{"name":"Outline style","list_only":"List only","numbered_list":"Numbered list","bordered":"Show border","border_color":"Border color"}},"empty":"Add Headlines to your page and they will appear as links here"},"floating_toolbar":{"use_ai":"Use AI","bold":"Bold","italic":"Italic","underline":"Underline","strikethrough":"Strikethrough","clear":"Clear Formatting","code":"Code","button":"Button","link":"Link","highlight":"Highlight","extraHighlight":"Text labels","color":"Color and highlight","text":"Text","clear_all":"Clear all","placeholder":"Placeholder","adapts":{"dark":"Adapts to a dark theme","light":"Adapts to a light theme"},"create_note":"Create page","add_comment":"Add comment"},"remote_frame":{"placeholder_small":"Embed URL","placeholder_full":"Embed any URL, like YouTube, Github, Maps, Twitter, etc.","loading":"Loading...","context_menu":{"change_link":"Change link","full_size":"Full screen","reset_size":"Reset size","open_origin":"Open original","layout":"Layout","show_toolbar":"Show editing toolbar","copy_original":"Copy link to original"},"error":{"is_not_link":"Link or code is incorrect","content_error":"This URL is not supported or invalid. <a href=\\"https://nimbusweb.me/contact-us.php\\" target=\\"_blank\\">Contact us</a> if you think that this URL can be embedded.","unknown_error":"Something went wrong, try enter another URL","wrong_signature":"This content is corrupted and cannot be displayed","google_docs_auth_error":"Most likely you can\'t embed Google Docs/Sheets/Slide file because you don\'t have access to it. <a href=\\"http://nimb.ws/EkX87M\\" target=\\"_blank\\">Please read our guide.</a>","internal_link_error":"{{serviceName}} has forbidden following internal links. Click on Back to return to the previous page."},"convert_bookmark":"Convert to bookmark","convert_link":"Convert to link","back_button":"Back"},"google_drive":{"block_name":"Google Drive","loading":"Loading...","menu":{"expand":"Expand","collapse":"Collapse","open_origin":"Open in Google Drive","download":"Download","change_account":"Change account","choose_another_file":"Choose another file"},"last_modified":"Last modified by {{userName}} {{time}} ago","browse":"Browse file","login":"Sign in with Google","login_text":"Browse files and add from Google Drive"},"html":{"default_name":"HTML","loading":"Loading...","menu":{"open_source":"Open source link","export_blot":"Save HTML"},"unknown_error":"Unknown error","device_cant_display_content":"Your device can\'t display this content","wrong_signature":"This content is corrupted and cannot be displayed"},"relative_time":{"seconds":{"one":"{{count}} second","some":"{{count}} seconds","many":"{{count}} seconds"},"minutes":{"one":"{{count}} minute","some":"{{count}} minutes","many":"{{count}} minutes"},"hours":{"one":"{{count}} hour","some":"{{count}} hours","many":"{{count}} hours"},"days":{"one":"{{count}} day","some":"{{count}} days","many":"{{count}} days"},"months":{"one":"{{count}} month","some":"{{count}} months","many":"{{count}} months"},"years":{"one":"{{count}} year","some":"{{count}} years","many":"{{count}} years"}},"collapsible_content":{"menu":{"expand":"Expand","collapse":"Collapse","rename":"Rename"}},"convert_link":{"url":"URL","title":"Title","embed":"Embed","bookmark":"Bookmark","button":"Button","link_to_note":"Link to page","link_to_folder":"Link to folder","link_to_workspace":"Link to workspace","convert_error":"Error occurred while converting the URL"},"fullwidth":{"menu_item":"Full width"},"resizeable":{"point_tooltip":{"default":"Resize","bottom-right":"Resize\\n(press and hold the {{altKey}} button for free resize)"}},"toggle":{"placeholder":"Click here to create or move a block","expand":"Expand toggle","collapse":"Collapse toggle","expand_heading":"Expand heading","collapse_heading":"Collapse heading","expand_step":"Expand step","collapse_step":"Collapse step"},"step":{"content_placeholder":"Click here to create description to the step","title_placeholder":"Enter a short title to describe this step","aggregator_placeholder":"Enter a short descriptive title","menu":{"step_layout":{"name":"Layout","show_number":"Show number","show_arrow":"Show arrow","show_border":"Show border"}},"add_step":"Add step"},"tasks_list":{"not_supported":"Currently, we cannot display the task list as it is not supported in this type of pages.","menu":{"show_title":"Show task list name","view":"Default view","task_list_view":"Task list","calendar_view":"Calendar","kanban_view":"Kanban"}},"board":{"not_supported":"Currently, we cannot display the task board as it is not supported in this type of pages.","menu":{"add_new_column":"New column","board_layout":{"name":"Layout","show_add_new_column":"Show Add column"}}},"empty_features":{"use_template":"Use a template","import":"Import","add_database":"Add database","add_database_with_options":"Add database with options","add_board":"Kanban / Task Board","use_ai":"Use Fusebase AI","use_ai_agents":"Use AI Agents"},"ai_manager":{"generate_error":"Unfortunately, there are no results for your request. Please try another request.","unload_message":"Fusebase AI content is being generated. Are you sure you want to exit?","unknown_error":"Unknown error. Try again later or contact support.","dialog":{"title":"Discard draft","body":"Do you want to discard draft?","accept":"Yes, discard"},"ask_ai_to_edit":"Ask Fusebase AI to edit or generate...","ask_ai_to_edit_with_context":"Ask Fusebase AI to edit or generate with page context...","tell_ai_what_to_do":"Tell Fusebase AI what to do next...","ai_is_writing":"AI is writing...","try_again":"Try again","stop":"Stop","responses_can_be_inaccurate":"AI responses can be inaccurate or misleading","learn_more":"Learn more","have_an_idea":"Have an idea?","use_page_context":"Use page context","draft_with_fusebase_ai":"Draft with Fusebase AI","tone_of_voice":"Tone of voice","suggested_tones":"Witty, serious, etc.","output_length":"Output length","drafts":{"sales_email":"Sales email","sales_email_preffix":"Write sales email about","proposal":"Proposal","proposal_preffix":"Write proposal about","newsletter":"Newsletter","newsletter_preffix":"Write newsletter about","blog_post":"Blog post","blog_post_preffix":"Create a Blog post about","brainstorm_ideas":"Brainstorm ideas","brainstorm_ideas_preffix":"Write brainstorm ideas about","social_media_post":"Social media post","social_media_post_preffix":"Create a social media post about","content_calendar":"Content Calendar","content_calendar_preffix":"Generate a content calendar about","step_by_step_guide":"Step by Step Guide","step_by_step_guide_preffix":"Write a step by step guide to instruct how to","follow_up_email":"Follow up email","follow_up_email_preffix":"Create a follow up about"},"manage":{"replace":"Replace","insert_above":"Insert above","insert_below":"Insert below","done":"Done","continue":"Continue writing","shorter":"Make shorter","longer":"Make longer","insert_as_text":"Insert as text","insert_as_task_list":"Insert as task list","insert_as_checkbox_list":"Insert as checkbox text","copy":"Copy","try_again":"Try again","discard":"Discard"},"actions":{"custom":"AI Helper","summarize":"Summarize","explain":"Explain","improve":"Improve","spelling":"Fix spelling and grammar","cta":"Call to actions","shorter":"Make shorter","longer":"Make longer"}},"uploader":{"header":"Upload files","description":"Here, you can add some helpful information about file uploading","dropzone_full":"Drag file(s) here or","browse":"click to upload","dropzone_compact":"Add more files","uploading_progress":"Uploading {{progress}}%","uploading_files":"Uploading files","counter":"{{current}} of {{total}}","timer":"less than 1 minute remaining","header_placeholder":"Write a title, max {{maxChars}} characters","description_placeholder":"Write a description, max {{maxChars}} characters","errors":{"network":"Failed uploading file","too_big":"File is too big"},"menu":{"disallow_download":"Downloading","for_note":"For workspaces users","for_share":"Public page","convert_to_files":"Convert to files","allow_upload":"Uploading","enable_in_public_page":"Enable in public page"}},"convert_menu_tooltips":{"labels":{"management":"Great for knowledge management","collaboration":"Great for collaboration"},"paragraph":{"title":"Best for main content","description":"This is the main block for writing page content."},"todo":{"title":"A List For Small Tasks? Check!","description":"Write down small errands and routine tasks that need to be done."},"numberedlist":{"title":"Let\'s Line Up: One, Two, Three!","description":"Make your content easy-to-read and display it in a series."},"bulletlist":{"title":"Points Make Everything Clearer","description":"You can create a list that will stand out from other content."},"table":{"title":"Rejoice the Formatting","description":"Organize your information in a table to get a holistic view on your work."},"image":{"title":"We Need To See It — Add An Image","description":"Make your pages more attractive by adding pictures of any file type, moving them and resizing."},"file":{"title":"Files Here, Files There, Files Everywhere!","description":"Create a database for your project by adding files with different types of extensions to your page."},"largeheading":{"title":"Best for Primary Sections of Page","description":"This is the biggest heading you can add. Attract attention to the most vital part of your page and ease up your navigation."},"mediumheading":{"title":"Best for Secondary Section of Page","description":"This is a middle-size heading you can add. Divide your page into sections with it and easily find what you need."},"smallheading":{"title":"Best For Great Ideas In Subsections","description":"This is a small-size heading you can add, but still it stands out. Use it to divide your page into subsections."},"tasks-list":{"title":"Organize Your Work With Nimbus Tasks","description":"Here you can group your tasks in task lists. Assign tasks to your team members, set deadlines and add statuses for easy tracking."},"hline":{"title":"Let\'s Make A Break","description":"Separate different parts of a project or divide your examples and ideas for it."},"link":{"title":"Pave A Path with Links","description":"Whenever you\'ve got an idea for your project, add a link to it and name it."},"syntax":{"title":"Don\'t Forget About Code","description":"You can add code right on your page, switching between themes, languages and more!"},"link-page":{"title":"Your Next Stop Is Another Page","description":"Link another page connected to this project and easily access it right away."},"date":{"title":"Just Say When","description":"Set a deadline for your project or mark the precise time when you started to work on a page."},"mention":{"title":"Get Your Team Involved","description":"Your team members will get email notifications to open a particular page and collaborate there."},"blockquote":{"title":"And I Quote","description":"You can highlight important words from your clients or single out a motivational phrase."},"hint":{"title":"Let\'s Drop A Hint","description":"Choose an emoji and background color to highlight warnings, disclaimers or notifications on your page."},"toggle":{"title":"Hide & Seek Expand Text Block","description":"Sort and hide additional information on your pages for easier navigation and access."},"outline":{"title":"See What Awaits You On The Page","description":"Create a table of contents for easy navigation on long pages or wikis."},"lock-blot":{"title":"No One Can Edit It","description":"You can leave a particular information block on your page untouched and read-only."},"embed":{"title":"Add More Than Just A Link","description":"You can integrate other tools on your page to keep them all in one place and automatically updated."},"figma":{"title":"Keep Your Visuals Even Closer","description":"Add Figma to see how project visuals are designed in real time."},"miro":{"title":"Your Miro Board Is In A Safe Space","description":"Check a layout strategy or a road map for your project and work further on your page."},"columns":{"title":"Two columns are better than one","description":"Divide your page in two columns to add more content there and make your page look neater."},"meeting-notes":{"title":"Set Goals And Move Forward","description":"Use this template to build a marketing strategy and keep all details in one place."},"marketing-brief":{"title":"Dream Big, Plan Quarter By Quarter","description":"Use this template to build a marketing plan by quarters."},"content-plan":{"title":"Control And Lead Your Work","description":"Use this template to take everything inside your head to a table where you can visualize all parts and manage tasks."},"integrations":{"title":"Add More Than Just A Link","description":"You can integrate other tools on your page to keep them all in one place and automatically updated."},"google-drive":{"title":"Drive Your Files From Google Drive","description":"You can connect your Google Drive account and insert links to your drive files for quick access."},"google-sheets":{"title":"Minus Google Sheet Tab","description":"Keep your data in one place with other project details to draw conclusions more easily."},"bookmark":{"title":"Mark Your Link With A New Look","description":"Use a bookmark to show the title of your link, a small description and a preview picture of the website."},"audioRec":{"title":"Say It, Don\'t Write it","description":"Add a human touch to your collaboration, recording voice feedback to the content on your page."},"videoRec":{"title":"Show it, Don\'t Write It","description":"Record a visual explanation of what should be done or give explicit feedback with a video example."},"button":{"title":"Came, Saw, Clicked","description":"Add a CTA element that will drag attention to important links on your pages."},"largeheading-toggle":{"title":"Hide More In A Large-Sized Collapsible Heading","description":"Define the most vital part of your page and hide information there for easy access."},"mediumheading-toggle":{"title":"Make Your Sections Shorter","description":"Create sections with a middle-sized collapsible heading and hide part of your content there."},"smallheading-toggle":{"title":"Make Your Subsections Shorter","description":"Create subsections with a small-sized collapsible heading on your pages and hide additional information there."},"database-with-options":{"title":"Oh How The Tables Have Turned","description":"Create a database for your project and customize it by selecting different types of columns and rows, changing background color and more."},"board":{"title":"Welcome Your Tasks On a Board","description":"Display tasks as cards on a Kanban board to get a bird’s eye view."},"progress":{"title":"See How Far You\'ve Come!","description":"Choose your value and estimate it. Rate and comment on your added content, tasks or other activities."},"uploader":{"title":"Say Goodbye to the File Mess!","description":"Clarify what files your clients and/or team need to send. With the file uploader, you can get what you want and keep it all in one place."},"dropdown-list":{"title":"Drop Your Options","description":"Place answer options anywhere in the text & let others give instant feedback."},"use-ai":{"title":"Work Smart, Not Hard","description":"Use AI to create and improve your content, get new ideas, and make personalized recommendations. Work with an AI assistant in your workspace."}},"feature_availability":{"plus":{"not-available":"Available for Plus & Team & Business plans","trial":"This is open as a trial Plus feature for you"},"team":{"not-available":"Available for Team & Business plans","trial":"This is open as a trial Team feature for you"},"business2023":{"not-available":"Available for Business plan","trial":"This is open as a trial Business feature for you"}}}');
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/i18n/messages/ru.json
const ru_namespaceObject = JSON.parse('{"table":{"common":{"column":"Колонка"},"move_column_cant_split_merged_cells":{"title":"Невозможно перенести колонку","text":"Невозможно перенести колонку в ячейки, которые были объединены. Сначала, уберите объединение."},"move_column_cant_move_part_of_merged_cells":{"title":"Невозможно перенести колонку","text":"В колонке, которую вы хотите перенести есть объедененные ячейки. Сначала, вам нужно убрать объеденение."},"move_column_failed":{"title":"Невозможно перенести колонку","text":"Ошибка при переносе колонки. Попробуйте снова."},"move_row_cant_split_merged_cells":{"title":"Невозможно перенести строку","text":"Невозможно перенести строку в ячейки, которые были объединены. Сначала, уберите объединение."},"move_row_cant_move_part_of_merged_cells":{"title":"Невозможно перенести строку","text":"В строке, которую вы хотите перенести есть объедененные ячейки. Сначала, вам нужно убрать объеденение."},"move_row_cant_move_in_sortable_table":{"title":"Невозможно перенести строку","text":"Невозможно перенести строку, если есть активная сортировка. Отключите сортировку и попробуйте снова."},"move_row_cant_move_in_filtered_table":{"title":"Невозможно перенести строку","text":"Невозможно перенести строку, если есть активные фильтры. Отключите фильтры и попробуйте снова."},"move_row_failed":{"title":"Невозможно перенести строку","text":"Ошибка при переносе строки. Попробуйте снова"},"first_move_column_or_row_message":"Вы можете выделить несколько строк или колонок, если зажмёте CTRL и будете кликать на нужные строки или колонки.","menu":{"delete":"Удалить","help":"Инструкция","delete_column":{"one":"Удалить колонку","many":"Удалить {{count}} колонки"},"delete_row":{"one":"Удалить строку","many":"Удалить {{count}} строки"},"add":"Добавить","add_row_before":{"one":"Добавить строку выше","many":"Добавить {{count}} строки выше"},"add_row_after":{"one":"Добавить строку ниже","many":"Добавить {{count}} строки ниже"},"add_col_before":{"one":"Добавить колонку слева","many":"Добавить {{count}} колонки слева"},"add_col_after":{"one":"Добавить колонку справа","many":"Добавить {{count}} колонки справа"},"copy_cell":{"one":"Копировать ячейку","many":"Копировать ячейки"},"copy_table":"Копировать таблицу","table_layout":{"name":"Стиль таблицы","column_headings":"Показывать колонтитул колонки","row_headings":"Показывать колонтитул строки"},"import_csv":"Импорт из CSV","merge_cells":"Объединить ячейки","insert_checkbox":"Вставить чекбокс","background_color":"Цвет фона","formatting":"Форматирование","clear":"Очистить","reset":"Сбросить значения","divide_cells":"Разъединить ячейки","type":{"name_cell":"Тип ячейки","name_cells":"Тип ячеек","name_column":"Тип колонки","name_columns":"Тип колонок","type_cell":{"one":"Тип ячейки","many":"Тип ячеек"},"type_col":{"one":"Тип колонки","many":"Тип колонок"},"same_as_column":"Как колонка","reset_cells":"Сбросить формат ячеек","none":"Общий тип","text":"Текст","textline":"Текст","number":"Числа","attachment":"Файлы","checkbox":"Чекбоксы","multiselect":"Много опций","singleselect":"Одна опция","collaborator":"Участники","currency":"Валюта","date":"Дата","link":"Ссылки","rating":"Рейтинг","progress":"Прогресс","mention":"Упоминание"},"number_format":{"name":"Формат числа","number":"Число","commas":"С разделителями","percent":"Проценты"},"currency_format":{"name":"Валюта","dollar":"Доллар","euro":"Евро","yen":"Иена","yuan":"Юань","rouble":"Рубль","pound":"Фунт","rupee":"Рупия","hryvnia":"Гривна","won":"Вона","frank":"Франк","real":"Риал","other":"Другая","stick":"Символ валюты","before":"До","after":"После"},"decimal_format":{"name":"Десятичный разделитель","comma":"Запятая","point":"Точка","hint":"Разделитель используется для десятичных разрядов. Например, если запятая, то будет такой вид: 1.000,99, а если точка, то: 1,000.99"},"progress_format":{"name":"Настройки прогресса","simple":"Простой","colored":"Цветной","start_from":"Начать с (0-100)","default_amount":"По умолчанию (0-100)"},"rating_format":{"name":"Настройки рейтинга","star":"Звезда","flag":"Флаг","heart":"Сердце","amount":"Число (1-10)"},"date_format":{"name":"Настройки даты и времени"},"mention_panel":{"open":"Открыть","edit":"Изменить","clear":"Удалить"},"color_numbers":{"name":"Цветные цифры","enable":"Включить цветные цифры"},"filter":"Фильтрация","comment":"Комментарий"},"formatting_menu":{"align_left":"Лево","align_center":"Центр","align_right":"Право","valign_top":"Верх","valign_center":"Середина","valign_bottom":"Низ","text":"Текст","text_align":"Выравнивание текста","text_color":"Цвет текста","bold":"Жирный","italic":"Наклонный","strikethrough":"Перечеркнутый","underline":"Подчеркнутый"},"col_menu":{"add_column_after":{"one":"Добавить колонку справа","many":"Добавить {{count}} колонки справа"},"add_column_before":{"one":"Добавить колонку слева","many":"Добавить {{count}} колонки слева"},"duplicate_column":{"one":"Дублировать колонку","many":"Дублировать колонки"},"rename":"Переименовать"},"row_menu":{"add_row_after":{"one":"Добавить строку снизу","many":"Добавить {{count}} строки снизу"},"add_row_before":{"one":"Добавить строку сверху","many":"Добавить {{count}} строки сверху"}},"warning":{"merge_different":"Невозможно объединить разные типы объектов","convert_merged":"Невозможно конвертировать объединенные ячейки"},"select":{"create_list":"Напишите, чтобы создать список","create_item":"Напишите, чтобы создать опцию","create_option":"Напишите, чтобы создать опцию","create_label":"Напишите лейбл","create":"Создать","delete":"Удалить"},"attachment":{"upload_more":"Загрузить файлы","downloading":"Загрузка"},"collaborator":{"placeholder":"Введите имя","no_result":"Не найдено","loading":"Загрузка...","unknown":"Неизвестный"},"checkbox":{"checked":"Да","not_checked":"Нет"},"sorting":{"name":"Сортировка","sort":"Сортировка","disable":"Отключить сортировку","change":"Клик, чтобы поменять","asc":{"common":"По возрастанию","text":"От А до Я","number":"От 1 до 9","checkbox":"Сначала неотмеченные"},"desc":{"common":"По убыванию","text":"От Я до А","number":"От 9 до 1","checkbox":"Сначала отмеченные"},"warning":{"column_merged":{"title":"Не удалось отсортировать колонку","text":"Невозможно отсортировать колонку с объединенными ячейками"},"table_rowspan":{"title":"Не удалось отсортировать колонку","text":"Невозможно отсортировать таблицу с объединенными строками"},"merge":{"title":"Нельзя объединять ячейки","text":"Нельзя объединять ячейки при активной сортировке колонки. Отключите сортировку и попробуйте снова."},"different_currencies":{"title":"Предупреждение","text":"Вы используете разные валюты в ячейках, в связи с этим данные сортировки могут быть некорректными."}},"exit_dialog":{"title":"Отключение сортировки","toggle":"Сохранить текущий порядок строк","text_keep":"Будет сохранен порядок строк, который получился при сортировке.","text_no_keep":"Будет возвращен порядок строк, который был ДО включения сортировки.","apply":"Готово"}},"filter":{"by_field":"Фильтрация по колонке","empty_table":"Все записи отфильтрованы","popup_title":"Показать строки","empty_filters":"Нет применённых фильтров для базы данных","where":"Где","or":"Или","and":"И","add_condition":"Добавить условие","clear_all":"Очистить всё","contains":"содержит","is":"совпадает","is_not":"не совпадает","contains_not":"не содержит","has_any_of":"один из","has_none_of":"не содержит ни одного из","empty":"пустая","not_empty":"не пустая","filetype":"тип файлов","select_users_placeholder":"Выберите пользователей","type_text_placeholder":"Введите текст","type_text_or_select_placeholder":"Введите текст или выберите","type_number_placeholder":"Введите число","select_type_placeholder":"Выберите тип","select_date_placeholder":"Выберите дату","date":{"today":"Сегодня","yesterday":"Вчера","tomorrow":"Завтра","custom":"Другая"},"filetypes":{"images":"Изображения","documents":"Документы","media":"Медиа","other":"Другие"},"warning":{"cells_merged":{"title":"Не удалось применить фильтры","text":"Невозможно отфильтровать таблицу с объединенными ячейками"},"merge":{"title":"Нельзя объединять ячейки","text":"Нельзя объединять ячейки при активном фильтре колонки. Отключите фильтры и попробуйте снова."},"column_multitype":{"title":"Не удалось применить фильтры","text":"Нельзя фильтровать колонки с типом Общий тип. Сконвертируйте в другой тип и попробуйте снова."},"table_not_have_typed_columns":{"title":"Не удалось применить фильтры","text":"Нет доступных колонок для фильтрации."}},"enable_filter":"Включить фильтр","disable_filter":"Выключить фильтр"},"wrap_cells":{"layout_menu":"Разбиение ячеек","warnings":{"merge":{"title":"Объединение невозможно","text":"Невозможно объединить ячейки в режиме \'без разбиения\'"},"toggle":{"title":"Невозможно использовать опцию","text":"Таблица содержит объединенные ячейки"}}},"duplicate_column":{"title":"Дублировать колонку","text_1":"Дублировать содержимое ячеек","text_2":"В ячейке колонки есть данные. Вы можете их дублировать тоже или дублировать пустую колонку.","accept":"Дублировать","copy":"копия"},"convert_column":{"title":"Смена типа колонки","text_before":"Колонка содержит данные. При смене типа колонки данные будут удалены. Используйте клавиши","text_cmd":"ctrl+z","text_after":"чтобы отменить изменения.","accept":"Изменить тип"},"merge_cells_with_comments":{"title":"Объединение ячеек","text":"Ячейки будут объединены слева направо и к новой ячейке будет показан комментарий от левой ячейки.","accept":"Объединить"},"summary":{"layout_menu":"Показать панель подсчёта","name":{"none":"Без подсчёта","all":"Всего","empty":"Пустые ячейки","fill":"Заполненные ячейки","unique":"Уникальные ячейки","empty_percent":"Пустые в процентах","fill_percent":"Заполненные в процентах","unique_percent":"Уникальные в процентах","sum":"Сумма","average":"Среднее","min":"Минимальное","max":"Максимальное","median":"Медиана","min_date":"Самая ранняя","max_date":"Самая поздняя","range_days":"Промежуток в днях","range_month":"Промежуток в месяцах","checked":"Отмеченные","unchecked":"Неотмеченные","checked_percent":"Отмеченные в процентах","unchecked_percent":"Неотмеченные в процентах","filter_rating":"С рейтингом:","filter_progress":"С прогрессом:","filesize_min":"Минимальный размер","filesize_max":"Максимальный размер"},"item":{"none":"Подсчёт","empty":"Пустые","fill":"Заполненные","unique":"Уникальные","empty_percent":"Пустые","fill_percent":"Заполненные","unique_percent":"Уникальные","min_date":"Ранняя","max_date":"Поздняя","range_days":"Промежуток","range_month":"Промежуток","checked_percent":"Отмеченные","unchecked_percent":"Неотмеченные","filter_rating":"С рейтингом","filter_progress":"С прогрессом","filesize_min":"Мин. размер","filesize_max":"Макс. размер","min":"Мин","max":"Макс"}},"comments":{"tooltip":{"one":"Комментарий","more":"Комментарии"}}},"file":{"image_viewer":{"could_not_load_image":"Не получилось загрузить картинку"},"download_file":"Скачать {{name}}","listen_file":"Прослушать {{name}}","stop_file":"Остановить {{name}}","uploading":"Загружаем","wrtc":{"how_to_fix":"Как это исправить?","how_to_url":"https://nimbusweb.me/s/share/5441213/cwwryo2477pssn2sgkww","how_to_url2":"https://nimbusweb.me/s/share/5607239/l55bgak2ivs9bfptruka#b1995924032_670","rec_err_au":"Ошибка записи. Нет доступа к микрофону","rec_err_vi":"Ошибка записи. Нет доступа к микрофону/вебкамере ","allow_micro":"Разрешите доступ к микрофону","allow_media":"Выберите окно, которое надо записать","select_opt":"Что будем записывать","screenonly":"Только экран","camonly":"Только камера","screencam":"Экран + Камера","enable_micro":"Запись с микрофона","startRecording":"Начать запись","stopRecording":"Остановить запись","pauseRecording":"Приостановить запись","resumeRecording":"Возобновить запись","cancelRecording":"Отменить запись","confirmCancel":"Вы действительно хотите отменить запись видео?","cancel":"Отмена","prepareUpload":"Подождите, идет подготовка к загрузке записи","hasTmpRecord":"Запись была прервана, но не потеряна","restore":"Восстановить","delete":"Удалить","recordOnAnotherDevice":"Идет запись на другом устройстве..."},"menu":{"enabled":"Включено","disabled":"Выключено","open_in_new_tab":"Открыть в новой вкладке","copy_link":"Копировать ссылку на файл","expand_in_full_window":"Просмотр на весь экран","autoplay":"Автопроигрывание","sound_default":"Звук по умолчанию","sound_loop":"Зацикливание","sound_hideControls":"Скрыть управление","sound_showPanel":"Показывать верхнюю панель","shadow_video":"Тень для видео","video_params":"Настройки видео","disallow_download":"Скачивание","for_note":"Участники проекта","for_share":"Публичная страница","motion_video":"Motion видео","preview_video":"Сменить превью","preview_video_btn":"Превью","print":"Печать","convert_to_image":"Конвертировать в изображение","convert_to_file":"Конвертировать в файл","style":"Стиль","shadow_image":"Тень для картинки","rename":"Переименовать","replace":"Заменить","delete":"Удалить","download":"Скачать","get_text_from_image":"Получить текст изображения","view_as":"Отображать как","single_page":"Одна страница","all_pages":"Все страницы","cta_motion_video_message":"Для видео включен CTA. Невозможно одновременно использовать CTA и Motion видео. Отключите CTA и попробуйте снова включить Motion видео.","cta_loop_message":"Для видео включен CTA. Невозможно одновременно использовать CTA и Зацикливание. Отключите CTA и попробуйте снова включить Зацикливание.","grid":"Колонка","cta_drop_in_grid":"В видео включен CTA. Мы рекомендуем проверить правильность отображения CTA после переноса в колонку.","cta_exists_in_grid":"В колонке есть видео с активным CTA. Проверьте его правильность после переноса."},"downloading":"Скачивание...","attachment_not_found_error":"Ошибка загрузки файла","pdf_viewer":{"initializing_full_window_view":"Инициализация полного окна","preparing_document_for_printing":"Подготовка документа для печати...","printing_initialization":"Инициализация печати...","abort":"отменить","set_page_as_default":"Показывать страницу по умолчанию","unset_page_as_default":"Страница по умолчанию. Кликните, чтобы сделать страницу обычной."},"video_just_uploaded_codec_error":"Вы пытаетесь загрузить видео, которое было закодировано кодеком {codec} Мы не гарантируем корректное воспроизведение данного видео на всех браузерах. Рекомендуем конвертировать видео в другой формат и загрузить снова.","video_codec_error":"Данное видео закодировано кодеком {codec}, который не поддерживается в вашем браузере.","safari_webm_not_support":"На данный момент, браузер Safari не поддерживает формат WEBM. Попробуйте открыть страницу в другом браузере, например Google Chrome или Mozilla Firefox.","video_transcribe":"Транскрипт","video_summary":"Сводка","video_meeting_notes":"Заметки с встречи","video_ask_ai":"Спросить AI"},"image":{"text_from_image_popup":{"title":"Получить текст с картинки","no_text":"Не удалось получить текст","copy":"Копировать текст"},"unknown_error":"Не верная ссылка","add_image":"Вставьте ссылку или выберите ","add_image_or":"или","add_image_small":"Вставьте или выберите ","browse":"с диска","browse_image":"Выбрать изображение","too_large_error":"Изображение слишком большое","image_info_dialog":{"title":"Информация об изображении","type":"Тип","size":"Размер","location":"Адрес","copy_link":"Копировать"},"rotate_wait":{"full":"Немного терпения","medium":"Подождите"},"attachment_not_found_error":"Произошла ошибка при загрузке изображения","readonly_placeholder":"Пустое изображение","unsplash":{"name":"Unsplash","header":"Выберите картинку","placeholder":"Поиск изображения","search":"Поиск","description":"Выполните поиск, чтобы найти больше результатов.","no_result":"Изображения не найдены.","caption_preffix":"Автор"},"comments":"Комментарии"},"attachment":{"unknown_error":"Что-то пошло не так, попробуйте выбрать другой файл","attachment_is_being_uploaded":"Идет загрузка на другом устройстве...","attachment_will_be_downloaded_online":"Файл будет загружен когда вы будете онлайн.","attachment_preview_is_not_available":"Предпросмотр недоступен.","choose_a_file":"Выберите файлы","wait_resolving_without_info":"Немного терпения..."},"video":{"player":{"play":"Играть видео","pause":"Пауза","volume":"Громкость","fullscreen_on":"Во весь экран","fullscreen_off":"Выйти из режима Весь экран","watch_again":"Воспроизвести повторно"}},"search":{"placeholder":"Поиск на странице","matches":"Совпадений:"},"copy":{"copied":"Скопировано!","copy_to_clipboard":"Копировать в буфер обмена"},"apply":"Готово","done":"Готово","block_menu":{"align":{"left":"Выровнять по левому краю","center":"Выровнять по центру","right":"Выровнять по правому краю","justify":"Выровнять по ширине"},"indent":{"indent":"Увеличить отступ","outdent":"Уменьшить отступ"},"tooltip":"Потяните для перемещения\\n<span>Кликните для открытия меню</span>","copy_tooltip":"Скопировать ссылку","color":{"background_color":"Цвет фона","color":"Цвет","line_color":"Цвет линии","line_type":"Тип линии","player_color":"Цвет плеера"},"line_type":{"default":"Обычная линия","dotted":"Точки"},"add":{"name":"Добавить блок","above":"Сверху","below":"Снизу","left":"Слева","right":"Справа","above_column":"Над колонкой","below_column":"Под колонкой"},"convert_to":{"name":"Конвертировать в","to_do_list":"Чеклист","number_list":"Нумерованный список","bullet_list":"Маркированный список","paragraph":"Параграф","large_heading":"Большой заголовок","medium_heading":"Средний заголовок","small_heading":"Малый заголовок","large_heading_toggle":"Сворачиваемый заголовок 1","medium_heading_toggle":"Сворачиваемый заголовок 2","small_heading_toggle":"Сворачиваемый заголовок 3","code":"Код","quote":"Цитата","hint":"Примечание","image":"Изображение","file":"Файл","remote_frame":"Объект/Embed","link":"Ссылка","bookmark":"Закладка","button":"Кнопка","toggle":"Сворачиваемый блок","step":"Steps"},"comment_block":"Комментарий","edit":"Редактировать","duplicate":"Дублировать","copy_block":"Копировать содержимое блока","copy_blocks":"Копировать содержимое блоков","copy_link":"Копировать ссылку","delete":"Удалить","replace":"Заменить","blot_lock":"Запретить редактирование","blot_unlock":"Разрешить редактирование","set_as_preview":"Установить как превью","get_text_from_image":"Получить текст изображения","edit_image":"Редактировать изображение","download":"Скачать","view_full_size":"Открыть в полный размер","open_in_new_tab":"Открыть в новой вкладке","image_info":"Информация об изображении","rotate_image":"Повернуть","add_sub_task":"Добавить подзадачу","add_sub_text":"Добавить подтекст","layout":"Стиль","embed_align":{"left":"Выравнивание слева","center":"Выравнивание по центру","right":"Выравнивание справа","default":"Исходный размер","full_width":"На всю ширину"},"expand_all":"Развернуть все","collapse_all":"Свернуть все","add_caption":"Добавить подпись","blot_locked_admin":"Блок запрещён для редактирования. Кликните, чтобы разблокировать.","blot_locked_admins":"Блоки запрещены для редактирования. Кликните, чтобы разблокировать.","blot_locked_user":"У Вас нет прав на редактирование данного блока. Обратитесь к вашему администратору.","show_header":"Показывать верхнюю панель","show_borders":"Показывать рамки","rename":"Переименовать"},"convert_menu_groups":{"suggestions":"Рекомендуем","basic":"Базовые","advanced":"Продвинутые","media":"Медиа","embed":"Embed","views":"Сложные объекты","templates":"Шаблоны","helpful_links":"Полезные ссылки"},"embedded_menu":{"start_typing":"Напишите \\"/\\" или добавьте","start_typing_full":"Напишите \\"/\\", \\"@\\" или добавьте","more_items":"Больше элементов...","add_an_element":"Добавить элемент","paragraph":"Параграф","todo":"Чеклист","numbered_list":"Нумерованный список","bullet_list":"Маркированный список","table":"Таблица","image":"Изображение","file":"Файл","audioRec":"Аудиозапись","videoRec":"Видеозапись","recordExist":"Вы не можете начать новую запись пока не завершена предыдущая. Завершите или удалите предыдущую запись, чтобы начать новую.","large_heading":"Заголовок 1","medium_heading":"Заголовок 2","small_heading":"Заголовок 3","large_heading_toggle":"Сворачиваемый заголовок H1","medium_heading_toggle":"Сворачиваемый заголовок H2","small_heading_toggle":"Сворачиваемый заголовок H3","section_break":"Линия","link":"Ссылка","code":"Код","quote":"Цитата","hint":"Примечание","hint_placeholder":"Напишите желаемый текст","mention":"Упоминание","outline":"Содержание","remote_frame":"Объект/Embed","integrations":"Интеграции","google_drive":"Google Drive","google_sheets":"Google sheets","html":"HTML","toggle":"Сворачиваемый блок","tasks_list":"Список задач","lock_blot":"Запретить редактирование","link_page":"Ссылка на страницу","date":"Дата","more_integrations":"другие интеграции","two_columns":"2 колонки","meeting_notes":"Meeting notes","marketing_brief":"Marketing Brief","content_plan":"Content plan","more_templates":"другие шаблоны","get_feedback":"Обратная связь","contact_support":"Служба поддержки","learn_nimbus":"Инструкция","footer_top":"Введите текст, чтобы искать объекты.","footer_bottom":"Есть вопросы? Мы с удовольствием на них","footer_link":"ответим!","add_note":"Новая страница","database_with_options":"База данных","board":"Канбан / Доска задач","progress":"Прогресс","dropdown_list":"Выпадающий список","uploader":"Загрузчик файлов","use_ai":"Использовать Fusebase AI","helper":"AI помощник","summarize":"Резюмировать","explain":"Объяснить","improve":"Улучшить","spelling":"Исправить орфографию и грамматику","cta":"Призывы к действию","shorter":"Сделать короче","longer":"Сделать длиннее","step":"Steps"},"button":{"title":"Заголовок","id_info_tooltip":"Данный ID в будущем можно будет использовать при редактировании CSS файла.","address":"Адрес или Email","open_in_new_tab":"Открывать в новой вкладке","shape":"Форма кнопки","background":"Задний фон","size":"Размер","small":"Малый","medium":"Средний","big":"Большой","cancel":"Отмена","done":"Готово","length_error":"Слишком большой текст для кнопки. Попробуйте выделить меньшее количество текста (до 50 символов).","type":"Тип кнопки","default":"Обычная","withShadow":"Кнопка с тенью","3d":"3D кнопка","convert":{"popup_title":"Конвертировать в кнопку"}},"link":{"open":"Открыть","send":"Отправить","copy":"Копировать","edit":"Изменить","remove":"Удалить","text_label":"Текст","url_label":"Ссылка","email_label":"Адрес","copied":"Ссылка скопирована в буфер обмена","cancel":"Отмена","done":"Готово"},"syntax":{"menu":{"language":"Язык","theme":"Тема","wrap":"Включить перенос строк","unwrap":"Выключить перенос строк","lineNumbersOn":"Показать нумерацию строк","lineNumbersOff":"Скрыть нумерацию строк"},"convert":{"popup_title":"Ковертировать в код","blots_have_comments":"В тексте есть комментарии, которые будут удалены при конвертации.","text_has_inline_comments":"Внутри текста есть комментарии, которые будут удалены при конвертации.","confirm":"Конвертировать"}},"list":{"list_style":"Стиль списка","type_default":"По умолчанию","type_rectangle":"Квадрат","type_star":"Звезда","type_dart":"Дротик","type_rounded":"Круг","type_arrow":"Стрела","type_diamond":"Ромб"},"caption":{"placeholder":"Добавить описание"},"mention":{"show_all":"Показать все","show_all_users":"Показать всех","placeholder":"Напишите или выберите из списка","user":"Участники","workspace":"Проекты","folder":"Папки","note":"Страницы","no_results":"Нет результатов","offline_message":"Упоминания работают только при активном соединении. Включите Интернет и попробуйте снова.","info":{"note":{"one":"страница","some":"страницы","many":"страниц"},"subfolder":{"one":"подпапка","some":"подпапки","many":"подпапок"},"member":{"one":"участник","some":"участника","many":"участников"},"owner":"владелец","loading":"Загрузка превью...","loading_failed":"Ошибка загрузки","not_loaded":"Страница ещё не загрузилась"},"back_button":"Назад","create_note_for":"Создать страницу:","create_folder_for":"Создать папку:"},"calendar":{"ui":{"date":"Дата","am":"AM","pm":"PM","date_format":"Формат даты","show_time":"Показывать время","time_format":"Формат времени","time_12":"12ч","time_24":"24ч","first_week_day":"Первый день недели","time_zone":"Часовой пояс","use_gmt":"Время по Гринвичу","use_gmt_hint":"Один часовой пояс для всех участников","table":{"clear":"Очистить"},"inline":{"clear":"Удалить"},"reminder":{"name":"Напоминание","panel_name":"Напоминание","push_name":"Напоминание о событии","remove_confirm_message":"У вас установлены алерты, которые привязаны ко времени. Вы хотите удалить эти напоминания?","remove_confirm_text":"Удалить","remove_cancel_text":"Не удалять напоминания","before_period":"за","after_period":"","period":{"m":{"one":"минуту","many":"минуты"},"h":{"one":"час","many":"часа"},"d":{"one":"день","many":"дня"},"w":{"one":"неделю","many":"недели"}},"value":{"none":"Нет","0m":"При наступлении","1m":"за 1 минуту","5m":"за 5 минут","10m":"за 10 минут","15m":"за 15 минут","30m":"за 30 минут","1h":"за 1 час","2h":"за 2 часа","1d":"за 1 день","2d":"за 2 дня","7d":"за 7 дней","10d":"за 10 дней","14d":"за 14 дней","custom":"Другое"},"until":{"in":"Через","d":"д.","h":"ч.","m":"мин.","already_been":"Уже было","less_minute":"Меньше минуты","now":"Сейчас"}},"postfix":{"day":"д","month":"мес"}},"insert":{"category_name":"Дата","custom":"Другая","now":"Сейчас","today":"Сегодня","tomorrow":"Завтра"},"date_format":{"ddmmyyyy":"дд/мм/гггг","mmddyyyy":"мм/дд/гггг","yyyyddmm":"гггг/мм/дд","monthddyyyy":"Месяц дд, гггг","default":"Формат браузера"},"months":{"0":"Январь","1":"Февраль","2":"Март","3":"Апрель","4":"Май","5":"Июнь","6":"Июль","7":"Август","8":"Сентябрь","9":"Октябрь","10":"Ноябрь","11":"Декабрь"},"days":{"short":{"0":"Вс","1":"Пн","2":"Вт","3":"Ср","4":"Чт","5":"Пт","6":"Сб"},"full":{"0":"Воскресенье","1":"Понедельник","2":"Вторник","3":"Среда","4":"Четверг","5":"Пятница","6":"Суббота"}}},"content_not_supported":"На странице есть контент, который не поддерживается версией редактора на вашем клиенте. Обновите клиент для полноценной работы.","profession_ask":{"title":"Сохраните время, используя шаблоны при создании новых страниц","text":"Введите вашу должность и наша комманда создаст шаблон для вас. Это бесплатно, никаких скрытых платежей.","i_am_a":"Моя должность - ","placeholder":"например дизайнер, учитель, агент, и т.д.","request_template":"Запросить шаблон","sucess_message":"Спасибо! Ваша должность добавлена в обработку."},"bookmark":{"name":"Закладка","edit":"Редактировать закладку","title":"Заголовок","address":"Ссылка","description":"Описание","placeholder":"Вставьте, или напишите ссылку с https://...","placeholder_mobile":"Вставьте, или напишите ссылку","loading_preview":"Загрузка превью…","block_menu":{"change_mode":{"menu_name":"Отобразить как","mode_tile":"Плитка","mode_card":"Карточка","mode_cover":"Обложка"},"change_preview":"Изменить превью","delete_preview":"Удалить превью","reset_preview":"Сбросить превью","change_preview_background":"Фон превью","options":{"menu_name":"Параметры","open_in_same_tab":"Открывать в текущей вкладке"}},"error":{"unknown_error":"Что-то пошло не так, попробуйте ввести другой URL","preview_notfound":"Превью не найдены"},"upload":{"new_preview":"Загрузить картинку","quota_error":"Размер файла превышает допустимый размер в 3MB. Попробуйте другой файл.","unknown_error":"Неизвестная ошибка. Попробуйте другой файл."}},"businessCard":{"PERSON":"Имя","ORGANIZATION":"Организация","TITLE":"Описание","ADDRESS":"Адрес","URL":"Сайт","PHONE":"Телефон","EMAIL":"Электронная почта","SKYPE":"Скайп","TWITTER":"Твиттер","INSTAGRAM":"Инстаграм","FACEBOOK":"Фейсбук","LINKEDIN":"LinkedIn","VK":"ВКонтакте"},"dialog_common":{"button":{"ok":"Да","cancel":"Отмена"}},"outline":{"default_name":"Содержание","menu":{"expand":"Развернуть","collapse":"Свернуть","rename":"Переименовать"},"context_menu":{"convert_to":{"text":"Текст"},"style":{"name":"Стиль содержания","list_only":"Список","numbered_list":"Нумерованный список","bordered":"Показать рамку","border_color":"Цвет рамки"}},"empty":"Добавьте Заголовки к своей странице, и они будут отображаться здесь как ссылки"},"floating_toolbar":{"bold":"Жирный","italic":"Курсив","underline":"Подчеркнутый","strikethrough":"Перечеркнутый","clear":"Очистить форматирование","code":"Код","button":"Кнопка","link":"Ссылка","highlight":"Маркер","extraHighlight":"Маркеры с рамкой","color":"Цвет и выделение текста","text":"Текст","clear_all":"Очистить всё","placeholder":"Заполнитель","adapts":{"dark":"Адаптировать к темной теме","light":"Адаптировать к светлой теме"},"create_note":"Создать страницу","add_comment":"Добавить комментарий"},"remote_frame":{"placeholder_small":"Вставьте URL","placeholder_full":"Вставьте ссылку с YouTube, Github, Maps, Twitter и т.д.","loading":"Загрузка...","context_menu":{"change_link":"Сменить ссылку","full_size":"На весь экран","reset_size":"Сбросить размер","open_origin":"Перейти к источнику","layout":"Стиль","show_toolbar":"Показать тулбар","copy_original":"Копировать ссылку на оригинал"},"error":{"is_not_link":"Ссылка или код неверные","content_error":"Данная ссылка не поддерживается или является некорректной. Напишите в <a href=\\"https://nimbusweb.me/contact-us.php\\" target=\\"_blank\\">нашу службу поддержки</a>, если вы считаете, что произошла ошибка.","unknown_error":"Что-то пошло не так, попробуйте ввести другой URL","wrong_signature":"Неверная ссылка или контент эмбеда повреждён","google_docs_auth_error":"Скорее всего нет прав доступа к этому документу. У нас есть небольшая <a href=\\"https://nimbusweb.me/s/share/4246032/x9umr2emrgvf4xxa45vy\\" target=\\"_blank\\">инструкция</a>, которая подскажет, как поменять права на документ.","internal_link_error":"{{serviceName}} запретил переход по внутренним ссылкам. Нажмите на Назад, чтобы вернуться на предыдущую страницу."},"convert_bookmark":"Конвертировать в закладку","convert_link":"Конвертировать в ссылку","back_button":"Назад"},"google_drive":{"block_name":"Google Drive","loading":"Загрузка...","menu":{"expand":"Развернуть","collapse":"Свернуть","open_origin":"Открыть в Google Drive","download":"Скачать","change_account":"Сменить аккаунт","choose_another_file":"Выбрать другой файл"},"last_modified":"Последнее изменение {{userName}} {{time}} назад","browse":"Выбрать файл","login":"Sign in with Google","login_text":"Выберите и добавьте файл из Google Drive"},"html":{"default_name":"HTML","loading":"Загрузка...","menu":{"open_source":"Открыть оригинал","export_blot":"Сохранить HTML"},"unknown_error":"Неизвестная ошибка","device_cant_display_content":"Данное содержимое не может быть отображено на вашем устройстве","wrong_signature":"Данное содержимое повреждено и не может быть показано"},"relative_time":{"seconds":{"one":"{{count}} секунду","some":"{{count}} секунды","many":"{{count}} секунд"},"minutes":{"one":"{{count}} минуту","some":"{{count}} минуты","many":"{{count}} минут"},"hours":{"one":"{{count}} час","some":"{{count}} часа","many":"{{count}} часов"},"days":{"one":"{{count}} день","some":"{{count}} дня","many":"{{count}} дней"},"months":{"one":"{{count}} месяц","some":"{{count}} месяца","many":"{{count}} месяцев"},"years":{"one":"{{count}} год","some":"{{count}} года","many":"{{count}} лет"}},"collapsible_content":{"menu":{"expand":"Развернуть","collapse":"Свернуть","rename":"Переименовать"}},"convert_link":{"url":"URL","title":"Ссылка+Имя","embed":"Объект/Embed","bookmark":"Закладка","button":"Кнопка","link_to_note":"Ссылка на страницу","link_to_folder":"Ссылка на папку","link_to_workspace":"Ссылка на проект","convert_error":"Возникла ошибка конвертации URL"},"fullwidth":{"menu_item":"На всю ширину"},"resizeable":{"point_tooltip":{"default":"Изменить размер","bottom-right":"Изменить размер\\n(зажмите {{altKey}} для свободного изменения)"}},"toggle":{"placeholder":"Кликните сюда или перенесите блок","expand":"Развернуть блок","collapse":"Свернуть блок","expand_heading":"Развернуть заголовок","collapse_heading":"Свернуть заголовок","expand_step":"Expand step","collapse_step":"Collapse step"},"step":{"content_placeholder":"Click here to create description to the step","title_placeholder":"Enter a short title to describe this step","aggregator_placeholder":"Enter a short descriptive title","menu":{"step_layout":{"name":"Layout","show_number":"Show number","show_arrow":"Show arrow","show_border":"Show border"}}},"tasks_list":{"not_supported":"Мы не можем в данный момент отобразить список задач, так как он не поддерживается в данном типе страниц.","menu":{"show_title":"Show task list name","view":"Default view","task_list_view":"Task list","calendar_view":"Calendar","kanban_view":"Kanban"}},"board":{"not_supported":"Мы не можем в данный момент отобразить канбан, так как он не поддерживается в данном типе страниц.","menu":{"add_new_column":"Новая колонка","board_layout":{"name":"Стиль","show_add_new_column":"Показывать Новая колонка"}}},"empty_features":{"use_template":"Использовать шаблон","import":"Импорт","add_database":"База данных","add_database_with_options":"База данных","add_board":"Канбан / Доска задач","use_ai":"Использовать Fusebase AI","use_ai_agents":"Использовать ИИ-агентов"},"ai_manager":{"generate_error":"К сожалению, нет результата по вашему запросу. Попробуйте другой запрос.","unload_message":"Идет генерация контента Fusebase AI, вы действительно хотите выйти?","unknown_error":"Неизвестная ошибка. Попробуйте позже или обратитесь в службу поддержки.","dialog":{"title":"Удалить черновик","body":"Вы действительно хотите удалить черновик?","accept":"Да, удалить"},"manage":{"insert_as_text":"Вставить как текст","insert_as_task_list":"Вставить как список задач","insert_as_checkbox_list":"Вставить как чеклист","try_again":"Попробовать еще раз","discard":"Удалить черновик","done":"Вставить","insert_above":"Вставить выше","insert_below":"Вставить ниже","continue":"Продолжить","shorter":"Короче","longer":"Длиннее","translate":"Перевести","replace":"Заменить","copy":"Копировать"}},"uploader":{"header":"Загрузка файлов","description":"Здесь вы можете добавить полезную информацию о загрузке файлов","dropzone_full":"Перетащите файл(ы) сюда или","browse":"нажмите для загрузки","dropzone_compact":"Добавить файлы","uploading":"Загрузка {{progress}}%","uploading_files":"Загрузка файлов","counter":"{{current}} из {{total}}","timer":"осталось менее 1 минуты","header_placeholder":"Введите заголовок не более {{maxChars}} символов","description_placeholder":"Введите описание не более {{maxChars}} символов","errors":{"network":"Не удалось загрузить файл","too_big":"Файл слишком большой"},"menu":{"disallow_download":"Скачивание","for_note":"Участники проекта","for_share":"Публичная страница","convert_to_files":"Конвертировать в файлы","allow_upload":"Загрузка","enable_in_public_page":"Разрешить в публичной странице"}},"convert_menu_tooltips":{"labels":{"management":"Подходит для базы знаний","collaboration":"Групповая работа"},"paragraph":{"title":"Идеально для основного контента","description":"Это основной блок для наполнения страницы контентом."},"todo":{"title":"Идеально для простых задач","description":"Создается пустой пункт чеклиста, который можно заполнить, а потом закрыть."},"numberedlist":{"title":"Раз, два, три!","description":"Cписок, в котором каждый пункт стоит по порядковым номерам."},"bulletlist":{"title":"Маркеры, которые помогают","description":"Список, в котором каждый пункт отмечен специальным маркером (вид маркера можно менять)."},"table":{"title":"Расширьте возможности страницы","description":"Структурируйте и организуйте вашу информацию через таблицу."},"image":{"title":"Разбавим серые будни!","description":"Добавьте на страницу картинки, чтобы добавить больше контекста. Картинкам можно менять размер, можно их комментировать и т.д."},"file":{"title":"Файлы здесь, файлы там, файлы везде!","description":"Загружайте с компьютера файлы разных типов: документы, медиа, архивы и т.д."},"largeheading":{"title":"Идеально для больших разделов","description":"На странице есть несколько больших секций? Выделите их с помощью больших заголовков!"},"mediumheading":{"title":"Для второстепенных разделов","description":"Добавьте саб-секции на страницу с помощью средних заголовков."},"smallheading":{"title":"Идеально для небольших разделов","description":"Привлеките внимание к нужному блоку страницы с помощью маленьких заголовков!"},"tasks-list":{"title":"Задачи, с которыми удобно работать","description":"Создавайте задачи, назначайте ответственных и устанавливайте дедлайны, чтобы отслеживать прогресс."},"hline":{"title":"Давайте, поставим... линию!","description":"Горизонтальная линия, разделяющая части страницы."},"link":{"title":"Ссылки... просто ссылки","description":"Добавьте ссылку на внешний сайт или внутреннюю страницу."},"syntax":{"title":"Кода много не бывает ;)","description":"Добавьте на страницу сниппет с кодом. Мы распознаём большинство популярных языков программирования."},"link-page":{"title":"Создайте свою структуру","description":"Добавьте ссылку на любую страницу или папку в текущем проекте."},"date":{"title":"Просто укажите дату и время","description":"Добавьте дату и время прямо в текст страницы. При желании, можно добавить напоминание к выбранной дате."},"mention":{"title":"Вам важно об этом знать!","description":"Упомяните нужного участника или участницу проекта, чтобы привлечь их внимание к странице."},"blockquote":{"title":"Слова, которые важны","description":"Подчеркните важность ваших слов с помощью оформленной цитаты."},"hint":{"title":"Обратите внимание!","description":"Выделите важный для вас текст в специальном блоке с иконкой, которую вы можете выбрать сами."},"toggle":{"title":"Скройте лишнее!","description":"Сворачивает и разворачивает выбранное содержимое страницы (текст, картинки и т.д)."},"outline":{"title":"Достаточно одного взгляда!","description":"На странице много секций с заголовками? Оглавление позволит лучше ориентироваться в таком разнообразии!"},"lock-blot":{"title":"Здесь правила устанавливаю Я!","description":"Запретите редактировать и никто не сможет изменить содержимое блока!"},"embed":{"title":"Больше, чем просто ссылка","description":"Отобразит содержимое с других сервисов. Поддерживаем тысячи сервисов!"},"figma":{"title":"Держите дизайн рядом!","description":"Обсуждайте макеты и дизайнерские решения из Figma прямо на странице Nimbus Note."},"miro":{"title":"Новая вершина командной работы!","description":"Делаете проект? Создайте его прототип в Miro и обсуждайте прямо на странице Nimbus Note!"},"columns":{"title":"Одна хорошо, но две лучше ;)","description":"Разделите вашу страницу или блок на странице на колонки в один клик!"},"meeting-notes":{"title":"Зафиксируйте цели и двигайтесь дальше!","description":"Обсудили с командой важные моменты? Зафиксируйте результаты в нашем шаблоне."},"marketing-brief":{"title":"Воплощайте фантазии в жизнь","description":"Используйте данный шаблон для быстрого создания дизайнерского брифа."},"content-plan":{"title":"Создайте план и контролируйте его","description":"Мы подготовили для вас прототип контент плана. Вам осталось только его заполнить ;)"},"integrations":{"title":"Больше, чем просто ссылка","description":"Отобразит содержимое с других сервисов. Поддерживаем тысячи сервисов!"},"google-drive":{"title":"Далеко ходить не надо","description":"Подключите свой аккаунт Google Drive и добавьте с него файлы прямо на вашу страницу Nimbus Note."},"google-sheets":{"title":"Минус одна вкладка в браузере","description":"Отобразите содержимое ваших Google таблиц прямо на странице Nimbus Note!"},"bookmark":{"title":"Прочь, скучные ссылки!","description":"Вставьте ссылку и мы её покажем в красивом блоке с названием страницы, её описанием и логотипом."},"audioRec":{"title":"Вам нужно это услышать!","description":"Запишите аудио сообщение прямо со страницы."},"videoRec":{"title":"Вам нужно это увидеть!","description":"Запишите видео с вебкамеры или запишите происходящее на странице не выходя с Nimbus Note."},"button":{"title":"Пришли, увидели и нажали :)","description":"Не подходят обычные ссылки? Добавьте кнопку, которая украсит вашу страницу и позволит открывать нужные ссылки."},"largeheading-toggle":{"title":"Идеально для больших разделов","description":"Спрячьте лишнее и упростите внешний вид вашей страницы с помощью больших сворачиваемых заголовков."},"mediumheading-toggle":{"title":"Упростите внешний вид страницы","description":"Добавьте саб-секции на страницу и спрячьте в них содержимое с помощью средних сворачиваемых заголовков."},"smallheading-toggle":{"title":"Идеально для второстепенных разделов","description":"Скрывайте контент страницы с помощью маленьких сворачиваемых заголовков."},"database-with-options":{"title":"Таблица превращается... в базу данных","description":"Оцените всю мощь наших таблиц в специально подготовленном для Вас шаблоне базы данных!"},"board":{"title":"Наглядное управление вашими задачами!","description":"Создавайте и редактируйте карточки задач на доске Канбан."},"progress":{"title":"Оцените ваш прогресс!","description":"Выберите цель и двигайтесь к ней! Используйте прогресс бар для оценки выполненных задач и других активностей."},"uploader":{"title":"Скажите \\"НЕТ\\" файловому беспорядку!","description":"Собирайте файлы с клиентов и агрегируйте их по одной теме, чтобы ничего не упустить!"},"dropdown-list":{"title":"Выберите нужную опцию","description":"Составьте список и позвольте участникам команды выбрать нужную опцию."},"use-ai":{"title":"Добавьте волшебства!","description":"Наш AI помощник напишет вам текст любой сложности и по любой теме, проанализует содержимое страницы и на ее основе создаст саммари или список задач и даже укажет грамматические ошибки (если они конечно есть 😉)."}},"feature_availability":{"plus":{"not-available":"Доступно для Plus, Team и Business плана","trial":"Премиум функционал доступный на время триала"},"team":{"not-available":"Доступно для Team и Business плана","trial":"Бизнес функционал доступный на время триала"},"business2023":{"not-available":"Доступно для Business плана","trial":"Бизнес функционал доступный на время триала"}}}');
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/i18n/messages/de.json
const de_namespaceObject = JSON.parse('{"table":{"common":{"column":"Spalte"},"move_column_cant_split_merged_cells":{"title":"Spalte kann nicht verschoben werden","text":"Eine Spalte kann nicht in eine verbundene Zelle verschoben werden. Bitte Verbindung aufheben und dann erneut versuchen."},"move_column_cant_move_part_of_merged_cells":{"title":"Spalte kann nicht verschoben werden","text":"Die Spalte, die verschoben werden soll, enthält einen Teil einer verbundenen Zelle. Wenn die Spalte verschoben werden soll, bitte zuerst die Zellen voneinander trennen."},"move_column_failed":{"title":"Spalte kann nicht verschoben werden","text":"Beim Verschieben einer Spalte ist ein unerwarteter Fehler aufgetreten, bitte erneut versuchen."},"move_row_cant_split_merged_cells":{"title":"Zeile kann nicht verschoben werden","text":"Eine Zeile kann nicht in eine verbundene Zelle verschoben werden. Bitte Verbindung aufheben und dann erneut versuchen."},"move_row_cant_move_part_of_merged_cells":{"title":"Zeile kann nicht verschoben werden","text":"Die Zeile, die verschoben werden soll, enthält einen Teil einer verbundenen Zelle. Wenn die Spalte verschoben werden soll, bitte zuerst die Zellen voneinander trennen."},"move_row_cant_move_in_sortable_table":{"title":"Zeile kann nicht verschoben werden","text":"Eine Zeile kann nicht in einer sortierbaren Tabelle verschoben werden. Bitte Sortierung aufheben und erneut versuchen."},"move_row_cant_move_in_filtered_table":{"title":"Unable to move row","text":"Cannot move a row in a filtered table. Cancel filter then try again."},"move_row_failed":{"title":"Zeile kann nicht verschoben werden","text":"Beim Verschieben einer Zeile ist ein unerwarteter Fehler aufgetreten, bitte erneut versuchen."},"first_move_column_or_row_message":"You can select multiple rows or columns by holding down the CTRL button and clicking on the desired rows or columns.","menu":{"delete":"Löschen","help":"Hilfe","delete_column":{"one":"Spalte löschen","many":"{{count}} Spalten löschen"},"delete_row":{"one":"Zeile löschen","many":"Delete {{count}} Zeilen löschen"},"add":"Hinzufügen","add_row_before":{"one":"Zeile nach oben","many":"{{count}} Zeilen nach oben"},"add_row_after":{"one":"Zeile nach unten","many":"{{count}} Zeilen nach unten"},"add_col_before":{"one":"Spalte nach links","many":"{{count}} Spalten nach links"},"add_col_after":{"one":"Spalte nach rechts","many":"{{count}} Spalten nach rechts"},"copy_cell":{"one":"Zelle kopieren","many":"Zellen kopieren"},"copy_table":"Tabelle kopieren","table_layout":{"name":"Tabellen Layout","column_headings":"Spaltenüberschriften","row_headings":"Zeilenüberschriften"},"import_csv":"Import from CSV","merge_cells":"Zellen verbinden","insert_checkbox":"Markierungsfeld einfügen","background_color":"Hintergrundfarbe","formatting":"Formatierung","clear":"Entfernen","reset":"Zurücksetzen","divide_cells":"Zellenverbindung entfernen","type":{"name_cell":"Zellentyp","name_cells":"Zellentyp","name_column":"Spaltentyp","name_columns":"Spaltentyp","type_cell":{"one":"Zellentyp","many":"Zellentyp"},"type_col":{"one":"Spaltentyp","many":"Spaltentyp"},"same_as_column":"Gleich wie Spalte","reset_cells":"Zellen auf Standard zurücksetzen","none":"Mehrfachtyp","text":"Text","textline":"Text","number":"Zahl","attachment":"Anhang","checkbox":"Markierungsfeld","multiselect":"Mehrfachauswahl","singleselect":"Einzelauswahl","collaborator":"Mitarbeiter","currency":"Währung","date":"Datum","link":"Link","rating":"Bewertung","progress":"Fortschritt","mention":"Erwähnung"},"number_format":{"name":"Zahlenformat","number":"Zahl","commas":"Zahl mit Kommas","percent":"Prozent"},"currency_format":{"name":"Währungstyp","dollar":"Dollar","euro":"Euro","yen":"Yen","yuan":"Yuan","rouble":"Rubel","pound":"Pfund","rupee":"Rupie","hryvnia":"Hryvnia","won":"Won","frank":"Franken","real":"Real","other":"Sonstiges","stick":"Symbol anzeigen","before":"Vorher","after":"Nachher"},"decimal_format":{"name":"Dezimaltrennzeichen","comma":"Komma","point":"Punkt","hint":"Das Trennzeichen wird für Dezimalstellen verwendet. Dezimaltrennzeichen mit Komma sehen aus wie 1.000,99, und Trennzeichen mit Punkt sehen aus wie 1,000.99."},"progress_format":{"name":"Fortschrittsoptionen","simple":"Einfach","colored":"Farbig","start_from":"Beginnt von (0-100)","default_amount":"Standardbetrag  (0-100)"},"rating_format":{"name":"Bewertungsoptionen","star":"Stern","flag":"Fahne","heart":"HERZ","amount":"Betrag (1-10)"},"date_format":{"name":"Datum Uhrzeit Format"},"mention_panel":{"open":"Öffnen","edit":"Bearbeiten","clear":"Entfernen"},"color_numbers":{"name":"Farbige Zahlen","enable":"Farbige Zahlen aktivieren"},"filter":"Filter","comment":"Kommentar"},"formatting_menu":{"align_left":"Links","align_center":"Zentriert","align_right":"Rechts","valign_top":"Oben","valign_center":"Mitte","valign_bottom":"Unten","text":"Text","text_align":"Text ausrichten","text_color":"Textfarbe","bold":"Fett","italic":"Kursiv","strikethrough":"Durchgestrichen","underline":"Untergestrichen"},"col_menu":{"add_column_after":{"one":"Spalte rechts hinzufügen","many":"{{count}} Spalten rechts hinzufügen"},"add_column_before":{"one":"Spalte links hinzufügen","many":"Add {{count}} Spalten links hinzufügen"},"duplicate_column":{"one":"Spalte duplizieren","many":"Spalten duplizieren"},"rename":"Umbenennen"},"row_menu":{"add_row_after":{"one":"Zeile unten hinzufügen","many":"{{count}} Zeilen unten hinzufügen"},"add_row_before":{"one":"Zeile oben hinzufügen","many":"{{count}} Zeilen oben hinzufügen"}},"warning":{"merge_different":"Unterschiedliche Objekttypen können nicht verbunden werden","convert_merged":"Verbundene Zellen können nicht konvertiert werden"},"select":{"create_list":"Tippe zum Erstellen einer Liste","create_item":"Tippe zum Erstellen eines Eintrags","create_option":"Tippe zum Erstellen einer Option","create_label":"Tippe zum Erstellen einer Beschriftung","create":"Erstellen","delete":"Löschen"},"attachment":{"upload_more":"Datei(en) hochladen","downloading":"Herunterladen"},"collaborator":{"placeholder":"Typ zum Hinzufügen von Personen","no_result":"Keine Ergebnisse","loading":"Wird geladen...","unknown":"Unbekannte Person"},"checkbox":{"checked":"Ja","not_checked":"Nein"},"sorting":{"name":"Sortierung","sort":"Sortieren","disable":"Sortierung entfernen","change":"Zum Ändern anklicken","asc":{"common":"Aufsteigend","text":"Sortieren nach A-Z","number":"Sortieren nach 1-9","checkbox":"Nicht ausgewählte zuerst"},"desc":{"common":"Absteigend","text":"Sortieren nach Z-A","number":"Sortieren nach 9-1","checkbox":"Ausgewählte zuerst"},"warning":{"column_merged":{"title":"Spalte kann nicht sortiert werden","text":"Spalte mit verbundenen Zellen kann nicht sortiert werden"},"table_rowspan":{"title":"Spalte konnte nicht sortiert werden","text":"Tabelle mit verbundenen Zeilen kann nicht sortiert werden"},"merge":{"title":"Cells cannot be merged","text":"Cells cannot be merged while column sorting is active. Disable sorting and try again."},"different_currencies":{"title":"Sortierwarnung","text":"Es gibt verschiedene Währungen in einer Spalte. Die Sortierung ist möglicherweise falsch."}},"exit_dialog":{"title":"Sortierung entfernen","toggle":"Sortierung beibehalten","text_keep":"Sortierung beibehalten","text_no_keep":"Spaltenreihenfolge wird in der ursprünglichen Reihenfolge wiederhergestellt, in der sie vor Anwendung der Sortierung bestand","apply":"Anwenden"}},"filter":{"by_field":"Nach diesem Feld filtern","empty_table":"Alle Einträge sind gefiltert","popup_title":"In dieser Tabelle Einträge anzeigen","empty_filters":"Keine Bedingungen sind auf diese Datenbank angewendet","where":"Wo","or":"Oder","and":"Und","add_condition":"Bedingung hinzufügen","clear_all":"Alle löschen","contains":"enthält","is":"ist","is_not":"ist nicht","contains_not":"enthält nicht","has_any_of":"hat eines von","has_none_of":"hat keines von","empty":"leer","not_empty":"nicht leer","filetype":"Dateityp","select_users_placeholder":"Benutzer auswählen","type_text_placeholder":"Text eingeben","type_text_or_select_placeholder":"Text eingeben oder auswählen","type_number_placeholder":"Nummer eingeben","select_type_placeholder":"Typ auswählen","select_date_placeholder":"Datum auswählen","date":{"today":"Heute","yesterday":"Gestern","tomorrow":"Morgen","custom":"Benutzerdefiniert"},"filetypes":{"images":"Bilder","documents":"Dokumente","media":"Medien","other":"Andere"},"warning":{"cells_merged":{"title":"Tabelle kann nicht gefiltert werden","text":"Die Spalte mit zusammengeführten Zellen kann nicht gefiltert werden."},"merge":{"title":"Zellen können nicht zusammengeführt werden","text":"Zellen können nicht zusammengeführt werden, während der Tabellenfilter aktiv ist. Filter deaktivieren und erneut versuchen."},"column_multitype":{"title":"Tabelle kann nicht gefiltert werden","text":"Es ist nicht möglich, Spalten mit Multi-Typ zu filtern. Bitte in einen anderen Typ konvertieren und erneut versuchen."},"table_not_have_typed_columns":{"title":"Tabelle kann nicht gefiltert werden","text":"Keine Spalten zum Filtern verfügbar."}},"enable_filter":"Filter aktivieren","disable_filter":"Filter deaktivieren"},"wrap_cells":{"layout_menu":"Zeilenumbruch","warnings":{"merge":{"title":"Zellen können nicht verbunden werden","text":"Zellen können nur im Zeilenumbruch Modus zusammengeführt werden"},"toggle":{"title":"Option kann nicht geändert werden","text":"Tabelle enthält verbundene Zellen"}}},"duplicate_column":{"title":"Spalte duplizieren","text_1":"Spalteninhalt duplizieren","text_2":"Sie können die gesamte Spalte inklusive Daten duplizieren oder die duplizerte Spalte leer lassen","accept":"Duplizieren","copy":"Kopieren"},"convert_column":{"title":"Spaltentyp ändern","text_before":"Diese Spalte enthält Werte. Wenn der Spaltentyp geändert wird, werden einige der Werte gelöscht. Anwenden","text_cmd":"Rückgängig machen","text_after":"Befehl, um Änderungen bei Bedarf rückgängig zu machen.","accept":"Typ ändern"},"merge_cells_with_comments":{"title":"Merging cells","text":"The cells will be merged from left to right and the new cell will show a comment from the left cell.","accept":"Merge"},"summary":{"layout_menu":"Berechnungsleiste anzeigen","name":{"none":"Keine","all":"Alle","empty":"Leer","fill":"Nicht leer","unique":"Einmalig","empty_percent":"Prozent leer","fill_percent":"Prozent nicht leer","unique_percent":"Prozent einmalig","sum":"Summe","average":"Durchschnitt","min":"Min","max":"Max","median":"Mittelwert","min_date":"Frühestes Datum","max_date":"Spätestes Datum","range_days":"Datumsbereich (Tage)","range_month":"Datumsbereich (Monat)","checked":"Geprüft","unchecked":"Nicht geprüft","checked_percent":"Prozent geprüft","unchecked_percent":"Prozent nicht geprüft","filter_rating":"Mit Bewertung:","filter_progress":"Mit Fortschritt:","filesize_min":"Minimale Größe","filesize_max":"Maximale Größe"},"item":{"none":"Berechnen","min_date":"Frühestens","max_date":"Spätestens","range_days":"Bereich (Tage)","range_month":"Bereich (Monat)","checked_percent":"Geprüft","unchecked_percent":"Nicht geprüft","filter_rating":"Mit Bewertung","filter_progress":"Mit Fortschritt"}},"comments":{"tooltip":{"one":"Kommentar","more":"Kommentare"}}},"file":{"image_viewer":{"could_not_load_image":"Bild konnte nicht geladen werden"},"download_file":"{{name}} herunterladen","listen_file":"{{name}} abspielen","stop_file":"{{name}} aufhören","uploading":"Hochladen","wrtc":{"how_to_fix":"Wie lässt sich das beheben?","how_to_url":"https://nimbusweb.me/s/share/5441210/4qccr41slk6wsw61h5fb","how_to_url2":"https://nimbusweb.me/s/share/5607239/l55bgak2ivs9bfptruka#b1995924032_670","rec_err_au":"Fehler bei der Aufnahme. Kein Zugriff auf das Mikrofon.","rec_err_vi":"Fehler bei der Aufnahme. Kein Zugriff auf Mikrofon/Webcam.","allow_micro":"Zugriff auf das Mikrofon erlauben","allow_media":"Wählen Sie das Fenster aus, das Sie aufnehmen möchten","select_opt":"Was wird aufgenommen","screenonly":"Nur Bildschirm","camonly":"Nur Kamera","screencam":"Bildschirm + Kamera","enable_micro":"Mikrofon einschalten","startRecording":"Aufnahme starten","stopRecording":"Aufnahme beenden","pauseRecording":"Aufnahme anhalten","resumeRecording":"Aufnahme fortsetzen","cancelRecording":"Aufnahme abbrechen","confirmCancel":"Sind Sie sicher, dass Sie die Videoaufzeichnung abbrechen möchten?","cancel":"Abbrechen","prepareUpload":"Bitte warten, das Hochladen der Aufnahme wird vorbereitet","hasTmpRecord":"Die Aufnahme wurde unterbrochen, ging aber nicht verloren","restore":"Wiederherstellen","delete":"Löschen","recordOnAnotherDevice":"Die Aufnahme läuft auf einem anderen Gerät ..."},"menu":{"enabled":"Aktiviert","disabled":"Deaktiviert","open_in_new_tab":"In neuem Tab öffnen","copy_link":"Link in Datei kopieren","expand_in_full_window":"Vollfenster anzeigen","autoplay":"Autoplay","sound_default":"Sound standardmäßig","sound_loop":"Schleifen","sound_hideControls":"Steuerelemente ausblenden","sound_showPanel":"Oberes Panel anzeigen","shadow_video":"Schatten für Video","video_params":"Video-Parameter","disallow_download":"Herunterladen deaktiviert für","for_note":"Arbeitsbereich-Benutzer","for_share":"Öffentliche Seiten","motion_video":"Bewegungsvideo","preview_video":"Vorschau ändern","preview_video_btn":"Vorschau","print":"Drucken","convert_to_image":"In Bild umwandeln","convert_to_file":"In Datei umwandeln","style":"Stil","shadow_image":"Schatten für Bild","rename":"Umbenennen","replace":"Ersetzen","delete":"Löschen","download":"Herunterladen","get_text_from_image":"Text aus Bild extrahieren","view_as":"Ansicht als","single_page":"Einzelseite","all_pages":"Alle Seiten","cta_motion_video_message":"CTA ist für Videos aktiviert. Sie können CTA und Bewegungsvideo nicht gleichzeitig verwenden. Deaktivieren Sie CTA und versuchen Sie, das Bewegungsvideo erneut zu aktivieren.","cta_loop_message":"CTA ist für Videos aktiviert. Sie können CTA und Schleife nicht gleichzeitig verwenden. Deaktivieren Sie CTA und versuchen Sie, die Schleife erneut zu aktivieren.","grid":"Raster","cta_drop_in_grid":"CTA ist für Videos aktiviert. Wir empfehlen, die Korrektheit der CTA-Anzeige nach dem Übertragen des Videos in eine Rasterspalte zu überprüfen.","cta_exists_in_grid":"Die Rasterspalte enthält ein Video mit aktivem CTA. Bitte prüfen Sie die Korrektheit nach dem Übertragen."},"downloading":"Herunterladen","attachment_not_found_error":"Fehler beim Hochladen","pdf_viewer":{"initializing_full_window_view":"Vollfensteransicht einstellen","preparing_document_for_printing":"Dokument für den Druck vorbereiten...","printing_initialization":"Druckeinstellung...","abort":"Abbrechen","set_page_as_default":"Seite als Standard festlegen","unset_page_as_default":"Standardseite. Klicken Sie, um die Seite zu normalisieren."},"video_just_uploaded_codec_error":"Sie versuchen, ein Video hochzuladen, das mit dem Codec {codec} kodiert wurde. Wir können nicht garantieren, dass dieses Video auf allen Browsern korrekt wiedergegeben wird. Wir empfehlen, das Video in ein anderes Format zu konvertieren und es erneut hochzuladen.","video_codec_error":"Dieses Video ist mit dem Codec {codec} kodiert, der in Ihrem Browser nicht unterstützt wird.","safari_webm_not_support":"Zurzeit unterstützt der Safari-Browser das WEBM-Format nicht. Versuchen Sie, die Notiz in einem anderen Browser zu öffnen, z. B. in Google Chrome oder Mozilla Firefox.","video_transcribe":"Transkribieren","video_summary":"Zusammenfassung","video_meeting_notes":"Besprechungsnotizen","video_ask_ai":"KI fragen"},"image":{"text_from_image_popup":{"title":"Text aus Bild","no_text":"Es gibt keinen Text","copy":"Gesamten Text kopieren"},"unknown_error":"Der Link ist falsch","add_image":"Bildlink einfügen oder ","add_image_or":"oder","add_image_small":"Einfügen oder ","browse":"durchblättern","browse_image":"Bild durchsuchen","too_large_error":"Bildgröße ist zu groß","image_info_dialog":{"title":"Bildinfo","type":"Typ","size":"Größe","location":"Standort","copy_link":"Link kopieren"},"rotate_wait":{"full":"Bitte warten","medium":"Warten"},"attachment_not_found_error":"Ein unerwarteter Fehler ist beim Bild aufgetreten","readonly_placeholder":"Leeres Bild","unsplash":{"name":"Unsplash","header":"Bild suchen","placeholder":"Nach einem Bild suchen","search":"Suchen","description":"Suchen, um weitere Ergebnisse zu finden.","no_result":"Keine Bilder gefunden.","caption_preffix":"Foto von"},"comments":"Kommentare"},"attachment":{"unknown_error":"Etwas ist schief gelaufen, bitte versuchen, eine andere Datei auszuwählen","attachment_is_being_uploaded":"Datei wird hochgeladen...","attachment_will_be_downloaded_online":"Datei wird heruntergeladen, sobald Sie online sind.","attachment_preview_is_not_available":"Vorschau ist nicht verfügbar.","choose_a_file":"Dateien auswählen","wait_resolving_without_info":"Bitte warten..."},"video":{"player":{"play":"Abspielen","pause":"Pause","volume":"Lautstärke","fullscreen_on":"Vollbild","fullscreen_off":"Vollbild beenden","watch_again":"Nochmals ansehen."}},"step_outliner":{"about_steps":"Über Schritte","total_steps":"Gesamtschritte"},"search":{"placeholder":"In der Notiz finden","matches":"Treffer:"},"copy":{"copied":"Kopiert!","copy_to_clipboard":"In die Zwischenablage kopieren"},"apply":"Anwenden","done":"Erledigt","block_menu":{"align":{"left":"Links ausrichten","center":"Mittig ausrichten","right":"Rechts ausrichten","justify":"Blocksatz"},"indent":{"indent":"Einzug vergrößern","outdent":"Einzug verkleinern"},"tooltip":"Ziehen um zu Verschieben\\n<span>Zum Öffnen des Menüs klicken</span>","copy_tooltip":"Link kopieren","color":{"background_color":"Hintergrundfarbe","color":"Farbe","line_color":"Linienfarbe","line_type":"Zeilentyp","player_color":"Farbe des Players"},"line_type":{"default":"Standardlinie","dotted":"Punkte"},"add":{"name":"Block hinzufügen","above":"Oben","below":"Unten","left":"Links","right":"Rechts","above_column":"Above column","below_column":"Under column"},"convert_to":{"name":"Konvertieren zu","to_do_list":"Checklist","number_list":"Nummerierte Liste","bullet_list":"Aufzählungsliste","paragraph":"Absatz","large_heading":"Große Überschrift","medium_heading":"Mittlere Überschrift","small_heading":"Kleine Überschrift","large_heading_toggle":"Einklappbare große Überschrift","medium_heading_toggle":"Einklappbare mittlere Überschrift","small_heading_toggle":"Einklappbare kleine Überschrift","code":"Code","quote":"Zitat","hint":"Hinweis","image":"Bild","file":"Datei","remote_frame":"Einbetten","link":"Link","bookmark":"Lesezeichen","button":"Schaltfläche","toggle":"Umschaltblock","step":"Schritte"},"comment_block":"Kommentar","edit":"Bearbeiten","duplicate":"Duplizieren","copy_block":"Block kopieren","copy_blocks":"Blöcke kopieren","copy_link":"Link kopieren","delete":"Löschen","replace":"Ersetzen","blot_lock":"Block sperren","blot_unlock":"Block entsperren","set_as_preview":"Als Vorschau festlegen","get_text_from_image":"Text vom Bild holen","edit_image":"Edit image","download":"Herunterladen","view_full_size":"Ansicht in voller Größe","open_in_new_tab":"In neuem Tab öffnen","image_info":"Bildinfo","rotate_image":"Drehen","add_sub_task":"Unteraufgabe hinzufügen","add_sub_text":"Untertext hinzufügen","layout":"Layout","embed_align":{"left":"Links ausrichten","center":"Mittig ausrichten","right":"Rechts ausrichten","default":"Standardgröße","full_width":"Volle Breite"},"expand_all":"Alle ausklappen","collapse_all":"Alle einklappen","add_caption":"Titelzeile hinzufügen","blot_locked_admin":"Die Bearbeitung des Blocks ist gesperrt. Klicken Sie, um die Sperre aufzuheben.","blot_locked_admins":"Die Bearbeitung der Blöcke ist gesperrt. Klicken Sie, um die Sperre aufzuheben.","blot_locked_user":"Sie haben keine Berechtigung, diesen Bock zu bearbeiten. Wenden Sie sich an den Administrator Ihrer Organisation.","show_header":"Obere Leiste anzeigen","show_borders":"Rahmen anzeigen","rename":"Umbenennen"},"convert_menu_groups":{"suggestions":"Vorgeschlagen","basic":"Grundlegendes","advanced":"Erweitert","media":"Medien","embed":"Integrationen","views":"Ansichten","templates":"Vorlagen","helpful_links":"Hilfreiche Links"},"embedded_menu":{"start_typing":"Geben Sie \\"/\\" ein oder hinzufügen","start_typing_full":"Beginnen Sie zu schreiben oder geben Sie \\"/\\", \\"@\\" ein","more_items":"Mehr Einträge...","rate_editor":"Bewerten Sie den Seiteneditor","add_an_element":"Element hinzufügen","paragraph":"Absatz","todo":"Checkbox-Liste","numbered_list":"Nummerierte Liste","bullet_list":"Aufzählungsliste","table":"Tabelle","image":"Bild","file":"Datei","audioRec":"Audio Aufnahme","videoRec":"Video Aufnahme","recordExist":"Sie können eine neue Aufnahme erst beginnen, wenn die vorherige abgeschlossen ist. Beenden oder löschen Sie die vorherige Aufnahme, um eine neue zu beginnen.","large_heading":"Überschrift 1","medium_heading":"Überschrift 2","small_heading":"Überschrift 3","large_heading_toggle":"Einklappbare Überschrift 1","medium_heading_toggle":"Einklappbare Überschrift 2","small_heading_toggle":"Einklappbare Überschrift 3","section_break":"Abschnittsumbruch","link":"Link","code":"Code","quote":"Zitat","hint":"Hinweis","hint_placeholder":"Schreibe etwas","mention":"Mitglieder erwähnen","outline":"Inhaltsübersicht","remote_frame":"Einbetten: Link, iFrame, JS Code","integrations":"Integrationen","google_drive":"Google Drive","google_sheets":"Google-Tabellen","html":"HTML","toggle":"Umschalter","tasks_list":"Aufgabenliste","lock_blot":"Block sperren","link_page":"Seiten-Link","date":"Datum","more_integrations":"weitere Integrationen","two_columns":"Zwei Spalten","meeting_notes":"Marketing-Strategie","marketing_brief":"Marketing-Quartalsplanung","content_plan":"Inhaltliche Planung","more_templates":"weitere Vorlagen","get_feedback":"Feedback einholen","contact_support":"Kontakt zum Support","learn_nimbus":"Nimbus kennenlernen","footer_top":"Wussten Sie schon? Sie können mit der Eingabe beginnen, um die Liste zu durchsuchen","footer_bottom":"Können Sie etwas nicht finden?","footer_link":"Teilen Sie es uns mit","add_note":"Neue Seite","database_with_options":"Datenbank","board":"Aufgabentafel","progress":"Fortschritt","dropdown_list":"Dropdown-Liste","uploader":"Datei-Uploader","use_ai":"Fusebase-KI verwenden","helper":"KI-Helfer","summarize":"Zusammenfassen","explain":"Erklären","improve":"Verbessern","spelling":"Rechtschreibung und Grammatik korrigieren","cta":"Handlungsaufforderungen","shorter":"Kürzer machen","longer":"Länger machen","step":"Schritte","step_outliner":"Schritt-Umriss"},"button":{"title":"Titel","id_info_tooltip":"Diese ID kann in Zukunft bei der Bearbeitung der CSS-Datei verwendet werden.","address":"URL oder E-Mail","open_in_new_tab":"In neuem Tab öffnen","shape":"Form des Buttons","background":"Hintergrund","size":"Größe des Buttons","small":"Klein","medium":"Mittel","big":"Groß","cancel":"Abbrechen","done":"Fertig","length_error":"Der Text ist zu groß für den Button. Versuchen Sie, weniger Text auszuwählen (nicht mehr als 50 Zeichen).","type":"Button-Typ","default":"Standard","withShadow":"Button mit Schatten","3d":"3d Button","convert":{"popup_title":"In Button umwandeln"}},"link":{"open":"Öffnen","send":"Senden","copy":"Kopieren","edit":"Bearbeiten","remove":"Entfernen","text_label":"Text","url_label":"Link-Adresse","email_label":"E-Mail-Adresse","copied":"Link in die Zwischenablage kopiert","cancel":"Abbrechen","done":"Fertig"},"syntax":{"menu":{"language":"Sprache","theme":"Theme","wrap":"Zeilenumbruch aktivieren","unwrap":"Zeilenumbruch deaktivieren","lineNumbersOn":"Zeilennummern anzeigen","lineNumbersOff":"Zeilennummern verbergen"},"convert":{"popup_title":"In Code umwandeln","blots_have_comments":"Es gibt Kommentare im Text, die während der Umwandlung gelöscht werden.","text_has_inline_comments":"Es gibt Kommentare im Text, die während der Umwandlung gelöscht werden.","confirm":"Umwandeln"}},"list":{"list_style":"Listenstil","type_default":"Voreinstellung","type_rectangle":"Rechteck","type_star":"Stern","type_dart":"Dart","type_rounded":"Abgerundet","type_arrow":"Pfeil","type_diamond":"Diamant"},"caption":{"placeholder":"Titelzeile hinzufügen"},"mention":{"show_all":"Alle anzeigen","show_all_users":"Alle anzeigen","placeholder":"Letzten anzeigen oder Typ zu suchen","user":"Personen","workspace":"Arbeitsbereiche","folder":"Ordner","note":"Notizen","no_results":"Keine Ergebnisse","offline_message":"Erwähnung funktioniert nur bei aktiver Verbindung. Bitte Internet einschalten und erneut versuchen.","info":{"note":{"one":"Notiz","some":"Notizen","many":"Notizen"},"subfolder":{"one":"Unterordner","some":"Unterordner","many":"Unterordner"},"member":{"one":"Mitglied","some":"Mitglieder","many":"Mitglieder"},"owner":"Besitzer","loading":"Vorschau wird geladen...","loading_failed":"Laden fehlgeschlagen","not_loaded":"Notiz wurde noch nicht geladen"},"back_button":"Zurück","create_note_for":"Notiz erstellen","create_folder_for":"Ordner erstellen"},"calendar":{"ui":{"date":"Datum","am":"AM","pm":"PM","date_format":"Datumsformat","show_time":"Uhrzeit anzeigen","time_format":"Zeitformat","time_12":"12H","time_24":"24H","first_week_day":"Erster Tag der Woche","time_zone":"Zeitzone","use_gmt":"GMT für alle Mitglieder verwenden","use_gmt_hint":"Dieselbe Zeitzone (GMT) für alle Mitarbeiter verwenden","table":{"clear":"Entfernen"},"inline":{"clear":"Löschen"},"reminder":{"name":"Warnung","panel_name":"Warnung","push_name":"Event Erinnerung","remove_confirm_message":"You have alerts that are time-bound. Do you want to delete these reminders?","remove_confirm_text":"Delete","remove_cancel_text":"Don\'t delete reminders","before_period":"","after_period":"vorher","period":{"m":{"one":"Minute","many":"Minuten"},"h":{"one":"Stunde","many":"Stunden"},"d":{"one":"Tag","many":"Tage"},"w":{"one":"Woche","many":"Wochen"}},"value":{"none":"Keine","0m":"Beim Start","1m":"1 Minute vorher","5m":"5 Minuten vorher","10m":"10 Minuten vorher","15m":"15 Minuten vorher","30m":"30 Minuten vorher","1h":"1 Stunde vorher","2h":"2 Stunden vorher","1d":"1 Tag vorher","2d":"2 Tage vorher","7d":"7 Tage vorher","10d":"10 Tage vorher","14d":"14 Tage vorher","custom":"Benutzerdefiniert"},"until":{"in":"In","d":"T","h":"S","m":"Min","already_been":"Schon gewesen","less_minute":"Weniger als eine Minute","now":"Jetzt"}},"postfix":{"day":"T","month":"M"}},"insert":{"category_name":"Datum","custom":"Benutzerdefiniert","now":"Jetzt","today":"Heute","tomorrow":"Morgen"},"date_format":{"ddmmyyyy":"dd/mm/yyyy","mmddyyyy":"mm/dd/yyyy","yyyyddmm":"yyyy/mm/dd","monthddyyyy":"Monat dd, yyyy","default":"Browser Format anpassen"},"months":{"0":"Januar","1":"Februar","2":"März","3":"April","4":"Mai","5":"Juni","6":"Juli","7":"August","8":"September","9":"Oktober","10":"November","11":"Dezember"},"days":{"short":{"0":"So","1":"Mo","2":"Di","3":"Mi","4":"Do","5":"Fr","6":"Sa"},"full":{"0":"Sonntag","1":"Montag","2":"Dienstag","3":"Mittwoch","4":"Donnerstag","5":"Freitag","6":"Samstag"}}},"content_not_supported":"Diese Notiz wird von Ihrer Version der FuseBase App nicht unterstützt. Versuchen Sie, sie zu aktualisieren oder verwenden Sie einen anderen Client in der neuesten Version.","profession_ask":{"title":"Zeit sparen durch die Verwendung von Vorlagen zur Erstellung neuer Notizen","text":"Geben Sie Ihren Beruf ein, und unser Team erstellt Vorlagen für Sie. Es ist kostenlos, ohne versteckte Kosten","i_am_a":"Ich bin","placeholder":"e.g. Designer, Lehrer, Verkäufer, usw.","request_template":"Template anfordern","sucess_message":"Vielen Dank! Dieser Beruf wird in unsere Warteliste aufgenommen."},"bookmark":{"name":"Lesezeichen","edit":"Lesezeichen bearbeiten","title":"Titel","address":"Adresse","description":"Beschreibung","placeholder":"Link mit https:// einfügen oder schreiben...","placeholder_mobile":"Paste or write link","loading_preview":"Vorschau wird geladen...","block_menu":{"change_mode":{"menu_name":"Ansicht als","mode_tile":"Kachel","mode_card":"Karte","mode_cover":"Einband"},"change_preview":"Vorschau ändern","delete_preview":"Vorschau löschen","reset_preview":"Vorschau zurücksetzen","change_preview_background":"Preview background","options":{"menu_name":"Optionen","open_in_same_tab":"Im gleichen Tab öffnen"}},"error":{"unknown_error":"Etwas ist schief gelaufen, bitte eine andere URL einzugeben","preview_notfound":"Vorschau nicht gefunden"},"upload":{"new_preview":"Neue Datei hochladen","quota_error":"Die Datei ist größer als die erlaubten 3 MB. Versuchen Sie eine andere Datei.","unknown_error":"Unbekannter Fehler. Versuchen Sie eine andere Datei."}},"businessCard":{"PERSON":"Name","ORGANIZATION":"Unternehmen","TITLE":"Titel","ADDRESS":"Standort","URL":"Webseite","PHONE":"Telefon","EMAIL":"E-Mail","SKYPE":"Skype","TWITTER":"Twitter","INSTAGRAM":"Instagram","FACEBOOK":"Facebook","LINKEDIN":"LinkedIn","VK":"Vk"},"dialog_common":{"button":{"ok":"Ok","cancel":"Abbrechen"}},"outline":{"default_name":"Inhaltsübersicht","menu":{"expand":"Ausklappen","collapse":"Einklappen","rename":"Umbenennen"},"context_menu":{"convert_to":{"text":"Text"},"style":{"name":"Stil der Inhaltsübersicht","list_only":"Einfache Liste","numbered_list":"Nummerierte Liste","bordered":"Rahmen anzeigen","border_color":"Randfarbe"}},"empty":"Fügen Sie Ihrer Notiz Überschriften hinzu, dann erscheinen diese hier als Links"},"floating_toolbar":{"use_ai":"KI verwenden","bold":"Fett","italic":"Kursiv","underline":"Unterstrichen","strikethrough":"Durchgestrichen","clear":"Formatierung entfernen","code":"Code","button":"Button","link":"Link","highlight":"Hervorhebung","extraHighlight":"Kontrastreiche Hervorhebung","color":"Farbe für Text und Hervorhebung","text":"Textfarbe","clear_all":"Alle zurücksetzen","placeholder":"Platzhalter","adapts":{"dark":"Passt sich einem dunklen Thema an","light":"Passt sich einem hellen Thema an"},"create_note":"Notiz erstellen","add_comment":"Kommentar hinzufügen"},"remote_frame":{"placeholder_small":"URL einbinden","placeholder_full":"Jede URL einbinden, wie YouTube, Github, Maps, Twitter usw.","loading":"Wird geladen...","context_menu":{"change_link":"Link ändern","full_size":"Vollbild","reset_size":"Größe zurücksetzen","open_origin":"Original öffnen","layout":"Layout","show_toolbar":"Bearbeitungsleiste anzeigen","copy_original":"Link zum Original kopieren"},"error":{"is_not_link":"Link ist nicht korrekt","content_error":"Die folgende Domain wird nicht unterstützt oder die URL ist falsch. Bitte <a href=\\"https://nimbusweb.me/contact-us.php\\" target=\\"_blank\\">unseren Support kontaktieren</a> und wir werden den Link bearbeiten.","unknown_error":"Etwas ist schief gelaufen, bitte eine andere URL eingeben","wrong_signature":"Dieser Inhalt ist fehlerhaft und kann nicht angezeigt werde","google_docs_auth_error":"Höchstwahrscheinlich kann die Google Dokumenten/Tabellen/Präsentations Datei nicht eingebettet werden, weil kein Zugriff darauf möglich ist.  <a href=\\"http://nimb.ws/EkX87M\\" target=\\"_blank\\">Bitte unsere Anleitung lesen.</a>","internal_link_error":"{{serviceName}} has forbidden following internal links. Click on Back to return to the previous page."},"convert_bookmark":"In Lesezeichen umwandeln","convert_link":"In Link umwandeln","back_button":"Zurück"},"google_drive":{"block_name":"Google Drive","loading":"Wird geladen...","menu":{"expand":"Ausklappen","collapse":"Einklappen","open_origin":"In Google Drive öffnen","download":"Herunterladen","change_account":"Konto ändern","choose_another_file":"Andere Datei auswählen"},"last_modified":"Zuletzt geändert von {{userName}} vor {{time}}","browse":"Datei durchsuchen","login":"Bei Google anmelden","login_text":"Dateien durchsuchen und von Google Drive hinzufügen"},"html":{"default_name":"HTML","loading":"Wird geladen...","menu":{"open_source":"Quell-Link öffnen","export_blot":"HTML speichern"},"unknown_error":"Unbekannter Fehler","device_cant_display_content":"Gerät kann diesen Inhalt nicht anzeigen","wrong_signature":"Dieser Inhalt ist fehlerhaft und kann nicht angezeigt werden"},"relative_time":{"seconds":{"one":"{{count}} Sekunde","some":"{{count}} Sekunden","many":"{{count}} Sekunden"},"minutes":{"one":"{{count}} Minute","some":"{{count}} Minuten","many":"{{count}} Minuten"},"hours":{"one":"{{count}} Stunde","some":"{{count}} Stunden","many":"{{count}} Stunden"},"days":{"one":"{{count}} Tag","some":"{{count}} Tage","many":"{{count}} Tage"},"months":{"one":"{{count}} Monat","some":"{{count}} Monate","many":"{{count}} Monate"},"years":{"one":"{{count}} Jahr","some":"{{count}} Jahre","many":"{{count}} Jahre"}},"collapsible_content":{"menu":{"expand":"Aufklappen","collapse":"Einklappen","rename":"Umbenennen"}},"convert_link":{"url":"URL","title":"Titel","embed":"Einbinden","bookmark":"Lesezeichen","button":"Button","link_to_note":"Link zur Notiz","link_to_folder":"Link zum Ordner","link_to_workspace":"Link to workspace","convert_error":"Bei der Konvertierung der URL ist ein Fehler aufgetreten"},"fullwidth":{"menu_item":"Volle Breite"},"resizeable":{"point_tooltip":{"default":"Größe ändern","bottom-right":"Größe ändern\\n(halten Sie die Taste {{altKey}} gedrückt, um die Größe frei zu ändern)"}},"toggle":{"placeholder":"Klicken Sie hier, um einen Block zu erstellen oder zu verschieben","expand":"Umschalter erweitern","collapse":"Umschalter reduzieren","expand_heading":"Überschrift erweitern","collapse_heading":"Überschrift reduzieren","expand_step":"Schritt erweitern","collapse_step":"Schritt reduzieren"},"step":{"content_placeholder":"Klicken Sie hier, um eine Beschreibung für den Schritt zu erstellen","title_placeholder":"Geben Sie einen kurzen Titel ein, um diesen Schritt zu beschreiben","aggregator_placeholder":"Geben Sie einen kurzen beschreibenden Titel ein","menu":{"step_layout":{"name":"Layout","show_number":"Nummer anzeigen","show_arrow":"Pfeil anzeigen","show_border":"Rahmen anzeigen"}},"add_step":"Schritt hinzufügen"},"tasks_list":{"not_supported":"Derzeit können wir die Aufgabenliste nicht anzeigen, da sie in diesem Seitentyp nicht unterstützt wird.","menu":{"show_title":"Aufgabenlisten-Namen anzeigen","view":"Standardansicht","task_list_view":"Aufgabenliste","calendar_view":"Kalender","kanban_view":"Kanban"}},"board":{"not_supported":"Derzeit können wir die Aufgaben-Tafel nicht anzeigen, da sie in diesem Seitentyp nicht unterstützt wird.","menu":{"add_new_column":"Neue Spalte","board_layout":{"name":"Layout","show_add_new_column":"Schaltfläche „Spalte hinzufügen“ anzeigen"}}},"empty_features":{"use_template":"Vorlage verwenden","import":"Importieren","add_database":"Datenbank hinzufügen","add_database_with_options":"Datenbank mit Optionen hinzufügen","add_board":"Aufgabentafel hinzufügen","use_ai":"Fusebase KI verwenden","use_ai_agents":"KI-Agenten verwenden"},"ai_manager":{"generate_error":"Leider gibt es keine Ergebnisse für Ihre Anfrage. Bitte versuchen Sie es mit einer anderen Anfrage.","unload_message":"Inhalte der Fusebase KI werden generiert. Möchten Sie wirklich beenden?","unknown_error":"Unbekannter Fehler. Versuchen Sie es später erneut oder wenden Sie sich an den Support.","dialog":{"title":"Entwurf verwerfen","body":"Möchten Sie den Entwurf verwerfen?","accept":"Ja, verwerfen"},"ask_ai_to_edit":"Fragen Sie Fusebase AI, um zu bearbeiten oder zu generieren...","ask_ai_to_edit_with_context":"Fragen Sie Fusebase AI, um mit Seitenkontext zu bearbeiten oder zu generieren...","tell_ai_what_to_do":"Sagen Sie Fusebase AI, was als Nächstes zu tun ist...","ai_is_writing":"KI schreibt...","try_again":"Erneut versuchen","stop":"Stopp","responses_can_be_inaccurate":"KI-Antworten können ungenau oder irreführend sein","learn_more":"Mehr erfahren","have_an_idea":"Haben Sie eine Idee?","use_page_context":"Seitenkontext verwenden","draft_with_fusebase_ai":"Mit Fusebase AI entwerfen","tone_of_voice":"Tonfall","suggested_tones":"Witzig, ernsthaft, etc.","output_length":"Ausgabelänge","drafts":{"sales_email":"Verkaufs-E-Mail","sales_email_preffix":"Schreiben Sie eine Verkaufs-E-Mail über","proposal":"Vorschlag","proposal_preffix":"Schreiben Sie einen Vorschlag über","newsletter":"Newsletter","newsletter_preffix":"Schreiben Sie einen Newsletter über","blog_post":"Blogbeitrag","blog_post_preffix":"Erstellen Sie einen Blogbeitrag über","brainstorm_ideas":"Ideen brainstormen","brainstorm_ideas_preffix":"Schreiben Sie Ideen zum Brainstorming über","social_media_post":"Social-Media-Beitrag","social_media_post_preffix":"Erstellen Sie einen Social-Media-Beitrag über","content_calendar":"Inhaltskalender","content_calendar_preffix":"Erstellen Sie einen Inhaltskalender über","step_by_step_guide":"Schritt-für-Schritt-Anleitung","step_by_step_guide_preffix":"Schreiben Sie eine Schritt-für-Schritt-Anleitung, um zu zeigen, wie man","follow_up_email":"Follow-up-E-Mail","follow_up_email_preffix":"Erstellen Sie ein Follow-up über"},"manage":{"replace":"Ersetzen","insert_above":"Oberhalb einfügen","insert_below":"Unterhalb einfügen","done":"Fertig","continue":"Weiter schreiben","shorter":"Kürzer machen","longer":"Länger machen","insert_as_text":"Als Text einfügen","insert_as_task_list":"Als Aufgabenliste einfügen","insert_as_checkbox_list":"Als Checkbox-Liste einfügen","copy":"Kopieren","try_again":"Erneut versuchen","discard":"Verwerfen"},"actions":{"custom":"KI-Helfer","summarize":"Zusammenfassen","explain":"Erklären","improve":"Verbessern","spelling":"Rechtschreibung & Grammatik","cta":"Handlungsaufforderungen","shorter":"Kürzer machen","longer":"Länger machen"}},"uploader":{"header":"Dateien hochladen","description":"Hier können Sie hilfreiche Informationen zum Hochladen von Dateien hinzufügen","dropzone_full":"Dateien hierher ziehen oder","browse":"klicken, um hochzuladen","dropzone_compact":"Weitere Dateien hinzufügen","uploading_progress":"Hochladen {{progress}}%","uploading_files":"Dateien werden hochgeladen","counter":"{{current}} von {{total}}","timer":"weniger als 1 Minute verbleibend","header_placeholder":"Titel schreiben, max. {{maxChars}} Zeichen","description_placeholder":"Beschreibung schreiben, max. {{maxChars}} Zeichen","errors":{"network":"Datei-Upload fehlgeschlagen","too_big":"Datei ist zu groß"},"menu":{"disallow_download":"Herunterladen","for_note":"Für Arbeitsbereichs-Benutzer","for_share":"Öffentliche Seite","convert_to_files":"In Dateien umwandeln","allow_upload":"Hochladen","enable_in_public_page":"Auf öffentlicher Seite aktivieren"}},"convert_menu_tooltips":{"labels":{"management":"Gut geeignet für Wissensmanagement","collaboration":"Perfekt für die Zusammenarbeit"},"paragraph":{"title":"Am besten für den Hauptinhalt","description":"Dies ist der Hauptblock zum Schreiben von Seiteninhalten."},"todo":{"title":"Eine Liste für kleine Aufgaben? Einfach abhaken!","description":"Schreib kleine Besorgungen und Routineaufgaben auf, die zu erledigen sind."},"numberedlist":{"title":"In einer Reihe aufstellen: Eins, zwei, drei!","description":"Erhöhe die Lesbarkeit Deiner Inhalte und zeige sie in einer Reihefolge an."},"bulletlist":{"title":"Aufzählungspunkte machen alles klarer","description":"Du kannst eine Liste erstellen, die sich von anderen Inhalten abhebt."},"table":{"title":"Erfreue Dich an der Strukturierung","description":"Organisiere Deine Informationen in einer Tabelle, um einen ganzheitlichen Blick auf Deine Arbeit zu erhalten."},"image":{"title":"Wir müssen es sehen - füge ein Bild hinzu","description":"Gestalte Deine Seiten attraktiver, indem Du Bilder eines beliebigen Dateityps hinzufügst, verschiebst oder in der Größe veränderst."},"file":{"title":"Dateien hier, Dateien dort, Dateien überall!","description":"Erstelle eine Datenbank für Dein Projekt, indem Du Dateien mit verschiedenen Erweiterungen zu Deiner Seite hinzufügst."},"largeheading":{"title":"Am besten geeignet für die Hauptabschnitte der Seite","description":"Dies ist die größte Überschrift, die Du hinzufügen kannst. Du lenkst damit die Aufmerksamkeit auf den wichtigsten Teil Deiner Seite und erleichterst die Navigation."},"mediumheading":{"title":"Am besten geeignet für die sekundären Abschnitte der Seite","description":"Dies ist eine mittelgroße Überschrift, die Du hinzufügen kannst. Unterteile damit Deine Seite in Abschnitte um alles, was Du brauchst, leicht zu finden."},"smallheading":{"title":"Am besten geeignet für starke Ideen in Unterabschnitten","description":"Dies ist eine kleine Überschrift, die Du hinzufügen kannst, die aber dennoch hervorsticht. Verwende sie, um Deine Seite in Unterabschnitte zu unterteilen."},"tasks-list":{"title":"Organisiere Deine Arbeit mit Nimbus Tasks","description":"Hier kannst Du Deine Aufgaben in Aufgabenlisten gruppieren. Weise Deinen Teammitgliedern Aufgaben zu, setze Fristen und füge den Status für eine einfache Verfolgung hinzu."},"hline":{"title":"Lass uns die Inhalte trennen","description":"Trenne verschiedene Teile eines Projekts oder unterteile Deine Beispiele und Ideen für das Projekt."},"link":{"title":"Pflastere den Weg mit Links","description":"Wann immer Du eine Idee für Dein Projekt hast, füge einen Link hinzu und benenne ihn."},"syntax":{"title":"Vergiss den Code nicht","description":"Du kannst Code direkt auf Deiner Seite hinzufügen und dabei zwischen Themen, Sprachen und mehr wechseln!"},"link-page":{"title":"Dein nächster Halt ist eine andere Seite","description":"Verlinke eine andere Seite, die mit diesem Projekt verbunden ist, um sofort darauf zuzugreifen."},"date":{"title":"Sag einfach, wann","description":"Lege eine Frist für Dein Projekt fest oder markiere den genauen Zeitpunkt, an dem Du mit der Arbeit an einer Seite begonnen hast."},"mention":{"title":"Beziehe Dein Team mit ein","description":"Deine Teammitglieder erhalten E-Mail-Benachrichtigungen, um eine bestimmte Seite zu öffnen und dort mitzuarbeiten."},"blockquote":{"title":"Und ich zitiere","description":"Du kannst wichtige Worte Deiner Kunden hervorheben oder eine motivierende Phrase herausstellen."},"hint":{"title":"Lass uns einen Hinweis geben","description":"Wähle ein Emoji und eine Hintergrundfarbe, um Warnungen, Haftungsausschlüsse oder Benachrichtigungen auf Deiner Seite hervorzuheben."},"toggle":{"title":"Textblöcke zusammenklappen und ausklappen","description":"Sortiere und verberge zusätzliche Informationen auf Deinen Seiten, um die Navigation und den Zugriff zu erleichtern."},"outline":{"title":"Sehen, was Dich auf der Seite erwartet","description":"Erstelle ein Inhaltsverzeichnis für eine einfache Navigation auf langen Seiten oder Wikis."},"lock-blot":{"title":"Keiner kann ihn bearbeiten","description":"Du kannst einen bestimmten Informationsblock auf Deiner Seite unangetastet und schreibgeschützt lassen."},"embed":{"title":"Weniger Tabs mit Google-Tabellen","description":"Halte Deine Daten mit anderen Projektdetails an einem Ort, um leichter Ergebnisse erzielen zu können."},"figma":{"title":"Bleibe an Deinem Bildmaterial noch näher dran","description":"Füge Figma hinzu, um die Entwicklung von Projektvisualisierungen in Echtzeit zu verfolgen."},"miro":{"title":"Dein Miro-Board befindet sich an einem sicheren Ort","description":"Entwickle eine Layout-Strategie oder einen Fahrplan für Dein Projekt und setze dann die Arbeit an Deiner Seite fort."},"columns":{"title":"Zwei Spalten sind besser als eine","description":"Unterteile Deine Seite in zwei Spalten, um dort mehr Inhalt hinzuzufügen und Deine Seite übersichtlicher zu gestalten."},"meeting-notes":{"title":"Ziele setzen und vorankommen","description":"Verwende diese Vorlage, um eine Marketingstrategie zu erstellen und alle Details an einem Ort zu speichern."},"marketing-brief":{"title":"Groß träumen, vierteljährlich planen","description":"Verwende diese Vorlage, um einen Marketingplan nach Quartalen zu erstellen."},"content-plan":{"title":"Kontrolliere und führe Deine Arbeit","description":"Verwende diese Vorlage, um alles, was Dir durch den Kopf geht, auf einen Tisch zu legen, wo Du alle Teile visualisieren und Aufgaben verwalten kannst."},"integrations":{"title":"Weniger Tabs mit Google-Tabellen","description":"Halte Deine Daten mit anderen Projektdetails an einem Ort, um leichter Ergebnisse erzielen zu können."},"google-drive":{"title":"Lade Deine Dateien von Google Drive","description":"Du kannst Dein Google Drive-Konto einbinden und Links zu Deinen Drive-Dateien für einen schnellen Zugriff einfügen."},"google-sheets":{"title":"Google Sheet Registerkarte","description":"Halte Deine Daten zusammen mit anderen Projektdetails an einem Ort, um leichter Schlüsse ziehen zu können."},"bookmark":{"title":"Kennzeichne Deinen Link durch einen neuen Look","description":"Verwende Lesezeichen, um den Titel Deines Links, eine kleine Beschreibung und ein Vorschaubild der Website anzuzeigen."},"audioRec":{"title":"Sprechen statt schreiben","description":"Verleihe der Zusammenarbeit eine menschliche Note, indem Du Sprachfeedback zu den Inhalten auf Deiner Seite aufnimmst."},"videoRec":{"title":"Zeigen statt schreiben","description":"Nimm eine visuelle Erklärung auf, was zu tun ist, oder gib explizites Feedback anhand eines Videobeispiels."},"button":{"title":"Gekommen, gesehen, geklickt","description":"Füge ein CTA-Element hinzu, das die Aufmerksamkeit auf wichtige Links auf Deinen Seiten lenkt."},"largeheading-toggle":{"title":"Verstecke zusätzlichen Inhalt in einer großformatigen einklappbaren Überschrift","description":"Definiere den wichtigsten Teil Deiner Seite und verbirg dort Informationen, um einfach darauf zuzugreifen."},"mediumheading-toggle":{"title":"Verkürze Deine Abschnitte","description":"Erstelle Abschnitte mit einer mittelgroßen einklappbaren Überschrift und verstecke dort einen Teil Deines Inhalts."},"smallheading-toggle":{"title":"Verkürze Deine Unterabschnitte","description":"Erstelle auf Deinen Seiten Unterabschnitte mit einer kleinen einklappbaren Überschrift, um dort zusätzliche Informationen zu verbergen."},"database-with-options":{"title":"Von der Tabelle zur Datenbank","description":"Erstelle eine Datenbank für Dein Projekt und passe sie an, indem Du verschiedene Arten von Spalten und Zeilen auswählst, die Hintergrundfarbe änderst und vieles mehr."},"board":{"title":"Sag Hallo zu Deinen Aufgaben auf einer Tafel","description":"Zeige Deine Aufgaben als Karten auf einem Kanban-Board an. Damit hast Du immer einen Gesamtüberblick."},"progress":{"title":"Sieh, wie weit Du gekommen bist!","description":"Wähle Deinen Wert und schätze ihn. Bewerte und kommentiere Deine hinzugefügten Inhalte, Aufgaben oder anderen Aktivitäten."},"uploader":{"title":"Sage Auf Wiedersehen zum Dateichaos!","description":"Kläre, welche Dateien deine Kunden und/oder dein Team senden müssen. Mit dem Datei-Uploader kannst du genau das bekommen, was du benötigst und alles an einem Ort aufbewahren."},"dropdown-list":{"title":"Gib uns Optionen","description":"Platziere Antwortoptionen an beliebiger Stelle im Text und lass andere sofort Feedback geben."},"use-ai":{"title":"Arbeite intelligent, nicht hart","description":"Nutze KI, um deine Inhalte zu erstellen und zu verbessern, neue Ideen zu bekommen und personalisierte Empfehlungen zu erhalten. Arbeite mit einem KI-Assistenten in deinem Arbeitsbereich."}},"feature_availability":{"plus":{"not-available":"Verfügbar für Plus-, Team- und Business-Tarife","trial":"Dies ist als Testversion einer Plus-Funktion für Sie geöffnet"},"team":{"not-available":"Verfügbar für Team- und Business-Tarife","trial":"Dies ist als Testversion einer Team-Funktion für Sie geöffnet"},"business2023":{"not-available":"Verfügbar für den Business-Tarif","trial":"Dies ist als Testversion einer Business-Funktion für Sie geöffnet"}}}');
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/i18n/messages/it.json
const it_namespaceObject = JSON.parse('{"table":{"common":{"column":"Colonna"},"move_column_cant_split_merged_cells":{"title":"Impossibile spostare la colonna","text":"Impossibile spostare una colonna in una cella unita. Separale e riprova."},"move_column_cant_move_part_of_merged_cells":{"title":"Impossibile spostare la colonna","text":"La colonna che stai tentando di spostare contiene parte di una cella unita. Se vuoi spostare la colonna, separa prima le celle."},"move_column_failed":{"title":"Impossibile spostare la colonna","text":"Si è verificato un errore imprevisto durante lo spostamento di una colonna, riprova."},"move_row_cant_split_merged_cells":{"title":"Impossibile spostare la riga","text":"Impossibile spostare una riga in una cella unita. Separale e riprova."},"move_row_cant_move_part_of_merged_cells":{"title":"Impossibile spostare la riga","text":"La riga che stai tentando di spostare contiene parte di una cella unita. Se desideri spostare la riga, separa prima le celle."},"move_row_cant_move_in_sortable_table":{"title":"Impossibile spostare la riga","text":"Impossibile spostare una riga in una tabella ordinabile. Annulla l\'ordinamento e riprova."},"move_row_cant_move_in_filtered_table":{"title":"Unable to move row","text":"Cannot move a row in a filtered table. Cancel filter then try again."},"move_row_failed":{"title":"Impossibile spostare la riga","text":"Si è verificato un errore imprevisto durante lo spostamento di una riga, riprova."},"first_move_column_or_row_message":"You can select multiple rows or columns by holding down the CTRL button and clicking on the desired rows or columns.","menu":{"delete":"Elimina","help":"Aiuto","delete_column":{"one":"Elimina colonna","many":"Elimina {{count}} colonne"},"delete_row":{"one":"Elimina riga","many":"Elimina {{count}} righe"},"add":"Inserisci","add_row_before":{"one":"Riga sopra","many":"{{count}} righe sopra"},"add_row_after":{"one":"Riga sotto","many":"{{count}} righe sotto"},"add_col_before":{"one":"Colonna a sinistra","many":"{{count}} colonne a sinistra"},"add_col_after":{"one":"Colonna a destra","many":"{{count}} colonne a destra"},"copy_cell":{"one":"Copia cella","many":"Copia celle"},"copy_table":"Copia tabella","table_layout":{"name":"Layout della tabella","column_headings":"Intestazioni di colonna","row_headings":"Intestazioni di riga"},"import_csv":"Import from CSV","merge_cells":"Unisci celle","insert_checkbox":"Inserisci casella di controllo","background_color":"Colore di sfondo","formatting":"Formattazione","clear":"Cancella","reset":"Ripristina","divide_cells":"Dividi le celle","type":{"name_cell":"Tipo di cella","name_cells":"Tipo di celle","name_column":"Tipo di colonna","name_columns":"Tipo di colonne","type_cell":{"one":"Tipo di cella","many":"Tipo di celle"},"type_col":{"one":"Tipo di colonna","many":"Tipo di colonne"},"same_as_column":"Uguale alla colonna","reset_cells":"Ripristina le celle ai valori predefiniti","none":"Multi tipo","text":"Testo","textline":"Testo","number":"Numero","attachment":"Allegato","checkbox":"Casella di controllo","multiselect":"Selezione multipla","singleselect":"Selezione singola","collaborator":"Collaboratore","currency":"Valuta","date":"Data","link":"Link","rating":"Valutazione","progress":"Progresso","mention":"Citazione"},"number_format":{"name":"Formato numero","number":"Numero","commas":"Numero con virgole","percent":"Percentuale"},"currency_format":{"name":"Tipo di valuta","dollar":"Dollaro","euro":"Euro","yen":"Yen","yuan":"Yuan","rouble":"Rublo","pound":"Sterlina","rupee":"Rupia","hryvnia":"Grivnia","won":"Won","frank":"Franco","real":"Real","other":"Altro","stick":"Mostra il simbolo","before":"Prima","after":"Dopo"},"decimal_format":{"name":"Decimal separator","comma":"Comma","point":"Point","hint":"The separator is used for decimal places. Comma decimal separators will look like 1.000,99, and point separators look like 1,000.99"},"progress_format":{"name":"Opzioni di avanzamento","simple":"Semplice","colored":"Colorato","start_from":"Inizia da (0-100)","default_amount":"Quantità predefinita (0-100)"},"rating_format":{"name":"Opzioni di valutazione","star":"Stella","flag":"Bandiera","heart":"Cuore","amount":"Quantità (1-10)"},"date_format":{"name":"Formato Data/Ora"},"mention_panel":{"open":"Apri","edit":"Modifica","clear":"Cancella"},"color_numbers":{"name":"Color numbers","enable":"Enable color numbers"},"filter":"Filter","comment":"Comment"},"formatting_menu":{"align_left":"Sinistra","align_center":"Centro","align_right":"Destra","valign_top":"Superiore","valign_center":"Medio","valign_bottom":"Inferiore","text":"Testo","text_align":"Allineamento del testo","text_color":"Colore del testo","bold":"Grassetto","italic":"Corsivo","strikethrough":"Barrato","underline":"Sottolineato"},"col_menu":{"add_column_after":{"one":"Aggiungi colonna a destra","many":"Aggiungi {{count}} colonne a destra"},"add_column_before":{"one":"Aggiungi colonna a sinistra","many":"Aggiungi {{count}} colonne a sinistra"},"duplicate_column":{"one":"Duplica colonna","many":"Duplica colonne"},"rename":"Rinomina"},"row_menu":{"add_row_after":{"one":"Aggiungi riga sotto","many":"Aggiungi {{count}} righe sotto"},"add_row_before":{"one":"Aggiungi riga sopra","many":"Aggiungi {{count}} righe sopra"}},"warning":{"merge_different":"Non è possibile unire diversi tipi di oggetti","convert_merged":"Non è possibile convertire celle unite"},"select":{"create_list":"Digita per creare un elenco","create_item":"Digita per creare un elemento","create_option":"Digita per creare un\'opzione","create_label":"Digita per creare un\'etichetta","create":"Crea","delete":"Elimina"},"attachment":{"upload_more":"Carica file","downloading":"Download in corso"},"collaborator":{"placeholder":"Digita per aggiungere persone","no_result":"Nessun risultato","loading":"Caricamento in corso...","unknown":"Persona sconosciuta"},"checkbox":{"checked":"Sì","not_checked":"No"},"sorting":{"name":"Ordinamento","sort":"Ordina","disable":"Rimuovi ordinamento","change":"Fai clic per modificare","asc":{"common":"Ascendente","text":"Ordina A-Z","number":"Ordina 1-9","checkbox":"Prima non selezionato"},"desc":{"common":"Discendente","text":"Ordina Z-A","number":"Ordina 9-1","checkbox":"Prima selezionato"},"warning":{"column_merged":{"title":"Impossibile ordinare la colonna","text":"Impossibile ordinare la colonna con celle unite"},"table_rowspan":{"title":"Impossibile ordinare la colonna","text":"Impossibile ordinare la tabella con righe unite"},"merge":{"title":"Cells cannot be merged","text":"Cells cannot be merged while column sorting is active. Disable sorting and try again."},"different_currencies":{"title":"Avviso di ordinamento","text":"Stai utilizzando diverse valute in una colonna. L\'ordinamento potrebbe non essere corretto."}},"exit_dialog":{"title":"Rimuovi ordinamento","toggle":"Mantieni ordinato","text_keep":"Mantieni ordinato","text_no_keep":"L\'ordine delle colonne verrà ripristinato al suo ordine iniziale prima dell\'applicazione dell\'ordinamento","apply":"Applica"}},"filter":{"by_field":"Filter by this field","empty_table":"All records are filtered","popup_title":"In this table, show records","empty_filters":"No conditions are applied to this database","where":"Where","or":"Or","and":"And","add_condition":"Add condition","clear_all":"Clear all","contains":"contains","is":"is","is_not":"is not","contains_not":"contains not","has_any_of":"has any of","has_none_of":"has none of","empty":"empty","not_empty":"not empty","filetype":"filetype","select_users_placeholder":"Select users","type_text_placeholder":"Type text","type_text_or_select_placeholder":"Type text or select","type_number_placeholder":"Type number","select_type_placeholder":"Select type","select_date_placeholder":"Select date","date":{"today":"Today","yesterday":"Yesterday","tomorrow":"Tomorrow","custom":"Custom"},"filetypes":{"images":"Images","documents":"Documents","media":"Media","other":"Other"},"warning":{"cells_merged":{"title":"Unable to filter table","text":"Can\'t filter column with merged cells"},"merge":{"title":"Cells cannot be merged","text":"Cells cannot be merged while table filter is active. Disable filter and try again."},"column_multitype":{"title":"Unable to filter table","text":"There is no such possibility to filter columns with Multi type. Please, try to convert to another type and try again."},"table_not_have_typed_columns":{"title":"Unable to filter table","text":"No columns available for filtering."}},"enable_filter":"Enable filter","disable_filter":"Disable filter"},"wrap_cells":{"layout_menu":"A capo automatico","warnings":{"merge":{"title":"Impossibile unire le celle","text":"Impossibile unire le celle in modalità non a capo"},"toggle":{"title":"Impossibile cambiare opzione","text":"La tabella contiene celle unite"}}},"duplicate_column":{"title":"Duplica colonna","text_1":"Duplica il contenuto della colonna","text_2":"Puoi duplicare l\'intera colonna contenente i dati o lasciare vuota la colonna duplicata","accept":"Duplica","copy":"copia"},"convert_column":{"title":"Cambia il tipo di colonna","text_before":"Questa colonna contiene valori. Cambiare il tipo di colonna cancellerà alcuni valori. Usa il comando","text_cmd":"annulla","text_after":"per annullare le modifiche se necessario.","accept":"Cambia tipo"},"merge_cells_with_comments":{"title":"Merging cells","text":"The cells will be merged from left to right and the new cell will show a comment from the left cell.","accept":"Merge"},"summary":{"layout_menu":"Mostra la barra di calcolo","name":{"none":"Nessuna","all":"Tutte","empty":"Vuote","fill":"Riempite","unique":"Uniche","empty_percent":"Percentuale vuote","fill_percent":"Percentuale riempite","unique_percent":"Percentuale uniche","sum":"Somma","average":"Media","min":"Min","max":"Max","median":"Mediana","min_date":"Prima data","max_date":"Ultima data","range_days":"Intervallo di date (giorni)","range_month":"Intervallo di date (mese)","checked":"Selezionate","unchecked":"Deselezionate","checked_percent":"Percentuale selezionate","unchecked_percent":"Percentuale deselezionate","filter_rating":"Con valutazione:","filter_progress":"Con progresso:","filesize_min":"Dimensione minima","filesize_max":"Dimensione massima"},"item":{"none":"Calcola","min_date":"Prima","max_date":"Ultima","range_days":"Intervallo (giorni)","range_month":"Intervallo (mese)","checked_percent":"Selezionate","unchecked_percent":"Deselezionate","filter_rating":"Con valutazione","filter_progress":"Con progresso"}},"comments":{"tooltip":{"one":"Comment","more":"Comments"}}},"file":{"image_viewer":{"could_not_load_image":"Impossibile caricare l\'immagine"},"download_file":"Scarica {{name}}","listen_file":"Play {{name}}","stop_file":"Stop {{name}}","uploading":"Caricamento in corso","wrtc":{"how_to_fix":"How to fix it?","how_to_url":"https://nimbusweb.me/s/share/5441210/4qccr41slk6wsw61h5fb","how_to_url2":"https://nimbusweb.me/s/share/5607239/l55bgak2ivs9bfptruka#b1995924032_670","rec_err_au":"Recording error. No microphone access.","rec_err_vi":"Recording error. No access to microphone/webcam. ","allow_micro":"Allow Access to microphone","allow_media":"Select the window you want to record","select_opt":"What will be recorded","screenonly":"Screen only","camonly":"Cam only","screencam":"Screen + Cam","enable_micro":"Enable microphone","startRecording":"Start recording","stopRecording":"Stop recording","pauseRecording":"Pause recording","resumeRecording":"Resume recording","cancelRecording":"Сancel recording","confirmCancel":"Are you sure you want to cancel the video recording?","cancel":"Сancel","prepareUpload":"Please wait, preparing to upload record","hasTmpRecord":"The recording was interrupted but not lost","restore":"Restore","delete":"Delete","recordOnAnotherDevice":"Recording is in progress on another device ..."},"menu":{"enabled":"Abilitato","disabled":"Disabilitato","open_in_new_tab":"Apri in una nuova scheda","copy_link":"Copia il collegamento al file","expand_in_full_window":"Espandi a finestra intera","autoplay":"Riproduzione automatica","sound_default":"Suono per impostazione predefinita","sound_loop":"Ciclo","sound_hideControls":"Nascondi controlli","sound_showPanel":"Show top panel","shadow_video":"Ombra per il video","video_params":"Parametri video","disallow_download":"Download in corso","for_note":"For workspaces users","for_share":"Public page","motion_video":"Motion video","preview_video":"Change preview","preview_video_btn":"Preview","print":"Stampa","convert_to_image":"Converti in immagine","convert_to_file":"Convert to file","style":"Stile","shadow_image":"Ombra per l\'immagine","rename":"Rinomina","replace":"Sostituisci","delete":"Elimina","download":"Scarica","get_text_from_image":"Ottieni testo dall\'immagine","view_as":"View as","single_page":"Single page","all_pages":"All pages","cta_motion_video_message":"CTA is enabled for videos. You cannot use CTA and Motion video at the same time. Disable CTA and try enabling Motion video again.","cta_loop_message":"CTA is enabled for videos. You cannot use CTA and Loop at the same time. Disable CTA and try enabling Loop again.","grid":"Grid","cta_drop_in_grid":"CTA is enabled for videos. We recommend checking the correctness of the CTA display after transferring the video into a grid column.","cta_exists_in_grid":"The grid column has a video with an active CTA. Please check if it is correct after the transfer."},"downloading":"Download in corso","attachment_not_found_error":"Errore durante il caricamento","pdf_viewer":{"initializing_full_window_view":"Inizializzazione della visualizzazione a finestra intera","preparing_document_for_printing":"Preparazione del documento per la stampa ...","printing_initialization":"Inizializzazione della stampa ...","abort":"abortire","set_page_as_default":"Set page as default","unset_page_as_default":"Default page. Click to make the page normal."},"video_just_uploaded_codec_error":"You are trying to upload a video that has been encoded with the {codec} codec. We do not guarantee the correct playback of this video on all browsers. We recommend converting the video to another format and uploading it again.","video_codec_error":"This video is encoded with {codec} codec, which is not supported in your browser.","safari_webm_not_support":"Currently, Safari browsers do not support WEBM format. Try to open the note in another browser, such as Google Chrome or Mozilla Firefox.","video_transcribe":"Transcribe","video_summary":"Summary","video_meeting_notes":"Meeting Notes","video_ask_ai":"Ask AI"},"image":{"text_from_image_popup":{"title":"Testo da immagine","no_text":"Non c\'è testo","copy":"Copia tutto il testo"},"unknown_error":"Il collegamento è errato","add_image":"Incolla il link dell\'immagine o ","add_image_or":"o","add_image_small":"Incolla o ","browse":"sfoglia","browse_image":"Sfoglia immagine","too_large_error":"La dimensione dell\'immagine è troppo grande","image_info_dialog":{"title":"Informazioni sull\'immagine","type":"Tipo","size":"Dimensione","location":"Posizione","copy_link":"Copia link"},"rotate_wait":{"full":"Attendere prego","medium":"Aspetta"},"attachment_not_found_error":"Si è verificato un errore imprevisto con l\'immagine","readonly_placeholder":"Immagine vuota","unsplash":{"name":"Unsplash","header":"Search image","placeholder":"Search for an image","search":"Search","description":"Search to find more results.","no_result":"No images found.","caption_preffix":"Photo by"},"comments":"Comments"},"attachment":{"unknown_error":"Qualcosa è andato storto, prova a scegliere un altro file","attachment_is_being_uploaded":"A file is being uploaded on another device...","attachment_will_be_downloaded_online":"Il file verrà scaricato quando sarai online.","attachment_preview_is_not_available":"L\'anteprima non è disponibile.","choose_a_file":"Scegliere i file","wait_resolving_without_info":"Please wait..."},"video":{"player":{"play":"Riproduci","pause":"Pausa","volume":"Volume","fullscreen_on":"A schermo intero","fullscreen_off":"Esci dalla modalità schermo intero","watch_again":"Watch again"}},"search":{"placeholder":"Trova nella nota","matches":"Risultati:"},"copy":{"copied":"Copiato!","copy_to_clipboard":"Copia negli appunti"},"apply":"Applica","done":"Fatto","block_menu":{"align":{"left":"Allinea a sinistra","center":"Allinea al centro","right":"Allinea a destra","justify":"Giustifica"},"indent":{"indent":"Aumenta il rientro","outdent":"Riduci il rientro"},"tooltip":"Trascina per spostare\\n<span>Fai clic per aprire il menu</span>","copy_tooltip":"Copy link","color":{"background_color":"Colore di sfondo","color":"Colore","line_color":"Colore della linea","line_type":"Tipo di linea","player_color":"Player\'s color"},"line_type":{"default":"Linea standard","dotted":"Punti"},"add":{"name":"Aggiungi blocco","above":"Sopra","below":"Sotto","left":"Sinistra","right":"Destra","above_column":"Above column","below_column":"Under column"},"convert_to":{"name":"Convertire in","to_do_list":"Checklist","number_list":"Elenco numerato","bullet_list":"Elenco puntato","paragraph":"Paragrafo","large_heading":"Intestazione grande","medium_heading":"Intestazione media","small_heading":"Intestazione piccola","large_heading_toggle":"Collapsible Large Heading","medium_heading_toggle":"Collapsible Medium Heading","small_heading_toggle":"Collapsible Small Heading","code":"Codice","quote":"Citazione","hint":"Hint","image":"Immagine","file":"File","remote_frame":"Incorporamento","link":"Link","bookmark":"Segnalibro","button":"Button","toggle":"Toggle Block","step":"Steps"},"comment_block":"Comment","edit":"Modifica","duplicate":"Duplica","copy_block":"Copy block","copy_blocks":"Copy blocks","copy_link":"Copia link","delete":"Elimina","replace":"Sostituisci","blot_lock":"Lock block","blot_unlock":"Unlock block","set_as_preview":"Imposta come anteprima","get_text_from_image":"Ottieni testo dall\'immagine","edit_image":"Edit image","download":"Scarica","view_full_size":"Visualizza a grandezza naturale","open_in_new_tab":"Apri in una nuova scheda","image_info":"Informazioni sull\'immagine","rotate_image":"Ruota","add_sub_task":"Aggiungi attività secondaria","add_sub_text":"Aggiungi sottotesto","layout":"Disposizione","embed_align":{"left":"Left align","center":"Center align","right":"Right align","default":"Default size","full_width":"Full width"},"expand_all":"Expand all","collapse_all":"Collapse all","add_caption":"Aggiungi didascalia","blot_locked_admin":"Editing of the block is denied. Click to unlock it.","blot_locked_admins":"Editing of the blocks is denied. Click to unlock it.","blot_locked_user":"You don’t have permission to edit this bock. Contact your organization admin.","show_header":"Show top bar","show_borders":"Show borders","rename":"Rinomina"},"convert_menu_groups":{"suggestions":"Suggestions","basic":"Basic","advanced":"Advanced","media":"Media","embed":"Embed","views":"Views","templates":"Templates","helpful_links":"Helpful links"},"embedded_menu":{"start_typing":"Type \\"/\\" or add","start_typing_full":"Start writing or type \\"/\\", \\"@\\"","more_items":"Altri elementi ...","add_an_element":"Aggiungi un elemento","paragraph":"Paragraph","todo":"Checklist","numbered_list":"Elenco numerato","bullet_list":"Elenco puntato","table":"Tabella","image":"Immagine","file":"File","audioRec":"Audio Record","videoRec":"Video Record","recordExist":"You cannot start a new recording until the previous one is completed. End or delete the previous record to start a new one.","large_heading":"Intestazione 1","medium_heading":"Intestazione 2","small_heading":"Intestazione 3","large_heading_toggle":"Collapsible Large Heading","medium_heading_toggle":"Collapsible Medium Heading","small_heading_toggle":"Collapsible Small Heading","section_break":"Interruzione di sezione","link":"Link","code":"Codice","quote":"Citazione","hint":"Hint","hint_placeholder":"Type something","mention":"Mention member","outline":"Scaletta","remote_frame":"Incorporamento","integrations":"Integrations","google_drive":"Google Drive","google_sheets":"Google sheets","html":"HTML","toggle":"Toggle block","tasks_list":"Task list","lock_blot":"Lock block","link_page":"Link page / Create","date":"Date","more_integrations":"more integrations","two_columns":"2 columns","meeting_notes":"Meeting notes","marketing_brief":"Marketing Brief","content_plan":"Content plan","more_templates":"more templates","get_feedback":"Get a feedback","contact_support":"Contact support","learn_nimbus":"Learn Nimbus","footer_top":"Did you know? You can start typing to search the list","footer_bottom":"Can’t find smth you want?","footer_link":"Tell us","add_note":"New page","database_with_options":"Database","board":"Kanban / Task Board","progress":"Progress","dropdown_list":"Dropdown list","uploader":"File uploader","use_ai":"Use Fusebase AI","helper":"AI helper","summarize":"Summarize","explain":"Explain","improve":"Improve","spelling":"Fix spelling and grammar","cta":"Call to actions","shorter":"Make shorter","longer":"Make longer","step":"Steps"},"button":{"title":"Title","id_info_tooltip":"This ID can be used in the future when editing the CSS file.","address":"URL or Email","open_in_new_tab":"Open in new tab","shape":"Button shape","background":"Background","size":"Button size","small":"Small","medium":"Medium","big":"Big","cancel":"Cancel","done":"Done","length_error":"The text is too large for the button. Try selecting less text (no more than 50 characters).","type":"Button type","default":"Default","withShadow":"Button with shadow","3d":"3d button","convert":{"popup_title":"Convert to button"}},"link":{"open":"Apri","send":"Invia","copy":"Copia","edit":"Modifica","remove":"Rimuovi","text_label":"Testo","url_label":"Link","email_label":"Indirizzo","copied":"Link copiato negli appunti","cancel":"Cancel","done":"Done"},"syntax":{"menu":{"language":"Lingua","theme":"Theme","wrap":"Abilita a capo","unwrap":"Disabilita a capo","lineNumbersOn":"Show line numbers","lineNumbersOff":"Hide line numbers"},"convert":{"popup_title":"Convert to code","blots_have_comments":"There are comments in the text that will be deleted during conversion.","text_has_inline_comments":"There are comments inside the text that will be deleted during conversion.","confirm":"Convert"}},"list":{"list_style":"Stile elenco","type_default":"Predefinito","type_rectangle":"Rettangolo","type_star":"Stella","type_dart":"Dardo","type_rounded":"Arrotondato","type_arrow":"Freccia","type_diamond":"Losanga"},"caption":{"placeholder":"Aggiungi didascalia"},"mention":{"show_all":"Mostra tutto","show_all_users":"Mostra tutti","placeholder":"Mostra recenti o digita per cercare","user":"Persone","workspace":"Spazi di lavoro","folder":"Cartelle","note":"Appunti","no_results":"Nessun risultato","offline_message":"La menzione funziona solo con connessione attiva. Accendi Internet e riprova.","info":{"note":{"one":"nota","some":"note","many":"note"},"subfolder":{"one":"sottocartella","some":"sottocartelle","many":"sottocartelle"},"member":{"one":"membro","some":"membri","many":"membri"},"owner":"proprietario","loading":"Caricamento anteprima ...","loading_failed":"Caricamento fallito","not_loaded":"Note has not been loaded yet"},"back_button":"Indietro","create_note_for":"Create Note","create_folder_for":"Create Folder"},"calendar":{"ui":{"date":"Data","am":"AM","pm":"PM","date_format":"Formato data","show_time":"Mostra orario","time_format":"Formato orario","time_12":"12 ore","time_24":"24 ore","first_week_day":"Primo giorno della settimana","time_zone":"Fuso orario","use_gmt":"Usa GMT per tutti i membri","use_gmt_hint":"Utilizza lo stesso fuso orario (GMT) per tutti i collaboratori","table":{"clear":"Cancella"},"inline":{"clear":"Elimina"},"reminder":{"name":"Avviso","panel_name":"Avviso","push_name":"Promemoria dell\'evento","remove_confirm_message":"You have alerts that are time-bound. Do you want to delete these reminders?","remove_confirm_text":"Delete","remove_cancel_text":"Don\'t delete reminders","before_period":"","after_period":"prima","period":{"m":{"one":"minuto","many":"minuti"},"h":{"one":"ora","many":"ore"},"d":{"one":"giorno","many":"giorni"},"w":{"one":"settimana","many":"settimane"}},"value":{"none":"Nessuno","0m":"All\'inizio","1m":"1 minuto prima","5m":"5 minuti prima","10m":"10 minuti prima","15m":"15 minuti prima","30m":"30 minuti prima","1h":"1 ora prima","2h":"2 ore prima","1d":"1 giorno prima","2d":"2 giorni prima","7d":"7 giorni prima","10d":"10 giorni prima","14d":"14 giorni prima","custom":"Personalizzato"},"until":{"in":"Tra","d":"g","h":"o","m":"min","already_been":"Già stato","less_minute":"Meno di un minuto","now":"Adesso"}},"postfix":{"day":"g","month":"m"}},"insert":{"category_name":"Data","custom":"Personalizzato","now":"Now","today":"Oggi","tomorrow":"Domani"},"date_format":{"ddmmyyyy":"gg/mm/aaaa","mmddyyyy":"mm/gg/aaaa","yyyyddmm":"aaaa/mm/gg","monthddyyyy":"Mese gg, aaaa","default":"Adatta al formato del browser"},"months":{"0":"Gennaio","1":"Febbraio","2":"Marzo","3":"Aprile","4":"Maggio","5":"Giugno","6":"Luglio","7":"Agosto","8":"Settembre","9":"Ottobre","10":"Novembre","11":"Dicembre"},"days":{"short":{"0":"Do","1":"Lu","2":"Ma","3":"Me","4":"Gi","5":"Ve","6":"Sa"},"full":{"0":"Domenica","1":"Lunedì","2":"Martedì","3":"Mercoledì","4":"Giovedì","5":"Venerdì","6":"Sabato"}}},"content_not_supported":"Questa nota non è supportata sulla tua versione dell\'app FuseBase. Prova ad aggiornarla o utilizza un altro client con l\'ultima versione.","profession_ask":{"title":"Risparmia tempo utilizzando i modelli per creare nuove note","text":"Inserisci la tua occupazione e il nostro team creerà dei modelli per te. È gratuito, senza costi nascosti","i_am_a":"Sono un","placeholder":"per esempio. designer, insegnante, agente di vendita, ecc.","request_template":"Richiedi modello","sucess_message":"Grazie! La tua occupazione verrà aggiunta alla nostra coda di attesa."},"bookmark":{"name":"Segnalibro","edit":"Modifica segnalibro","title":"Titolo","address":"Indirizzo","description":"Descrizione","placeholder":"Incolla o scrivi il link con https://...","placeholder_mobile":"Paste or write link","loading_preview":"Caricamento anteprima ...","block_menu":{"change_mode":{"menu_name":"Visualizza come","mode_tile":"Tessera","mode_card":"Cartolina","mode_cover":"Cover"},"change_preview":"Cambia anteprima","delete_preview":"Elimina anteprima","reset_preview":"Reimposta anteprima","change_preview_background":"Preview background","options":{"menu_name":"Options","open_in_same_tab":"Open in same tab"}},"error":{"unknown_error":"Qualcosa è andato storto, prova a inserire un altro URL","preview_notfound":"Anteprime non trovate"},"upload":{"new_preview":"Upload New","quota_error":"The file is larger than the 3MB allowed. Try another file.","unknown_error":"Unknown error. Try another file."}},"businessCard":{"PERSON":"Nome","ORGANIZATION":"Azienda","TITLE":"Titolo","ADDRESS":"Posizione","URL":"Sito","PHONE":"Telefono","EMAIL":"E-mail","SKYPE":"Skype","TWITTER":"Twitter","INSTAGRAM":"Instagram","FACEBOOK":"Facebook","LINKEDIN":"LinkedIn","VK":"Vk"},"dialog_common":{"button":{"ok":"Ok","cancel":"Annulla"}},"outline":{"default_name":"Scaletta","menu":{"expand":"Espandi","collapse":"Collassa","rename":"Rinomina"},"context_menu":{"convert_to":{"text":"Testo"},"style":{"name":"Stile scaletta","list_only":"Solo elenco","numbered_list":"Elenco numerato","bordered":"Mostra bordo","border_color":"Border color"}},"empty":"Aggiungi Intestazioni alla tua nota e appariranno come link qui"},"floating_toolbar":{"bold":"Grassetto","italic":"Corsivo","underline":"Sottolineato","strikethrough":"Barrato","clear":"Cancella Formattazione","code":"Codice","button":"Button","link":"Link","highlight":"Evidenzia","extraHighlight":"High contrast highlights","color":"Colore","text":"Testo","clear_all":"Clear all","placeholder":"Segnaposto","adapts":{"dark":"Adatta a un tema scuro","light":"Adatta a un tema chiaro"},"create_note":"Create note","add_comment":"Add comment"},"remote_frame":{"placeholder_small":"Incorpora URL","placeholder_full":"Incorpora qualsiasi URL, come YouTube, Github, Maps, Twitter, ecc.","loading":"Caricamento in corso...","context_menu":{"change_link":"Cambia link","full_size":"Dimensione originale","reset_size":"Reset size","open_origin":"Apri originale","layout":"Disposizione","show_toolbar":"Mostra barra di modifica","copy_original":"Copy link to original"},"error":{"is_not_link":"Il collegamento non è corretto","content_error":"Il seguente dominio non è supportato o l\'URL non è corretto. Contatta il <a href=\\"https://nimbusweb.me/contact-us.php\\" target=\\"_blank\\">nostro supporto</a> ed elaboreremo il tuo collegamento.","unknown_error":"Qualcosa è andato storto, prova a inserire un altro URL","wrong_signature":"Questo contenuto è danneggiato e non può essere visualizzato","google_docs_auth_error":"Molto probabilmente non puoi incorporare il Documento/Foglio/Presentazione Google perché non hai accesso ad esso.<a href=\\"http://nimb.ws/EkX87M\\" target=\\"_blank\\">Leggi la nostra guida.</a>","internal_link_error":"{{serviceName}} has forbidden following internal links. Click on Back to return to the previous page."},"convert_bookmark":"Converti in segnalibro","convert_link":"Converti in link","back_button":"Back"},"google_drive":{"block_name":"Google Drive","loading":"Caricamento in corso...","menu":{"expand":"Espandi","collapse":"Collassa","open_origin":"Apri in Google Drive","download":"Scarica","change_account":"Cambia account","choose_another_file":"Scegli un altro file"},"last_modified":"Ultima modifica di {{userName}} {{time}} fa","browse":"Sfoglia file","login":"Accedi con Google","login_text":"Sfoglia i file e aggiungi da Google Drive"},"html":{"default_name":"HTML","loading":"Caricamento in corso...","menu":{"open_source":"Collegamento open source","export_blot":"Save HTML"},"unknown_error":"Errore sconosciuto","device_cant_display_content":"Il tuo dispositivo non può visualizzare questo contenuto","wrong_signature":"Questo contenuto è danneggiato e non può essere visualizzato"},"relative_time":{"seconds":{"one":"{{count}} secondo","some":"{{count}} secondi","many":"{{count}} secondi"},"minutes":{"one":"{{count}} minuto","some":"{{count}} minuti","many":"{{count}} minuti"},"hours":{"one":"{{count}} ora","some":"{{count}} ore","many":"{{count}} ore"},"days":{"one":"{{count}} giorno","some":"{{count}} giorni","many":"{{count}} giorni"},"months":{"one":"{{count}} mese","some":"{{count}} mesi","many":"{{count}} mesi"},"years":{"one":"{{count}} anno","some":"{{count}} anni","many":"{{count}} anni"}},"collapsible_content":{"menu":{"expand":"Espandi","collapse":"Collassa","rename":"Rinomina"}},"convert_link":{"url":"URL","title":"Titolo","embed":"Incorpora","bookmark":"Segnalibro","button":"Button","link_to_note":"Link alla nota","link_to_folder":"Collegamento alla cartella","link_to_workspace":"Link to workspace","convert_error":"Si è verificato un errore durante la conversione dell\'URL"},"fullwidth":{"menu_item":"Larghezza intera"},"resizeable":{"point_tooltip":{"default":"Resize","bottom-right":"Resize\\n(press and hold the {{altKey}} button for free resize)"}},"toggle":{"placeholder":"Click here to create or move a block","expand":"Expand toggle","collapse":"Collapse toggle","expand_heading":"Expand heading","collapse_heading":"Collapse heading","expand_step":"Expand step","collapse_step":"Collapse step"},"step":{"content_placeholder":"Click here to create description to the step","title_placeholder":"Enter a short title to describe this step","aggregator_placeholder":"Enter a short descriptive title","menu":{"step_layout":{"name":"Layout","show_number":"Show number","show_arrow":"Show arrow","show_border":"Show border"}}},"tasks_list":{"not_supported":"Currently, we cannot display the task list as it is not supported in this type of pages.","menu":{"show_title":"Show task list name","view":"Default view","task_list_view":"Task list","calendar_view":"Calendar","kanban_view":"Kanban"}},"board":{"not_supported":"Currently, we cannot display the task board as it is not supported in this type of pages.","menu":{"add_new_column":"New column","board_layout":{"name":"Layout","show_add_new_column":"Show Add column"}}},"empty_features":{"use_template":"Use a template","import":"Import","add_database":"Add database","add_database_with_options":"Add database with options","add_board":"Kanban / Task Board","use_ai":"Use Fusebase AI","use_ai_agents":"Use AI Agents"},"ai_manager":{"generate_error":"Unfortunately, there are no results for your request. Please try another request.","unload_message":"Fusebase AI content is being generated. Are you sure you want to exit?","unknown_error":"Unknown error. Try again later or contact support.","dialog":{"title":"Discard draft","body":"Do you want to discard draft?","accept":"Yes, discard"}},"uploader":{"header":"Upload files","description":"Here, you can add some helpful information about file uploading","dropzone_full":"Drag file(s) here or","browse":"click to upload","dropzone_compact":"Add more files","uploading_progress":"Uploading {{progress}}%","uploading_files":"Uploading files","counter":"{{current}} of {{total}}","timer":"less than 1 minute remaining","header_placeholder":"Write a title, max {{maxChars}} characters","description_placeholder":"Write a description, max {{maxChars}} characters","errors":{"network":"Failed uploading file","too_big":"File is too big"},"menu":{"disallow_download":"Downloading","for_note":"For workspaces users","for_share":"Public page","convert_to_files":"Convert to files","allow_upload":"Uploading","enable_in_public_page":"Enable in public page"}},"convert_menu_tooltips":{"labels":{"management":"Great for knowledge management","collaboration":"Great for collaboration"},"paragraph":{"title":"Best for main content","description":"This is the main block for writing page content."},"todo":{"title":"A List For Small Tasks? Check!","description":"Write down small errands and routine tasks that need to be done."},"numberedlist":{"title":"Let\'s Line Up: One, Two, Three!","description":"Make your content easy-to-read and display it in a series."},"bulletlist":{"title":"Points Make Everything Clearer","description":"You can create a list that will stand out from other content."},"table":{"title":"Rejoice the Formatting","description":"Organize your information in a table to get a holistic view on your work."},"image":{"title":"We Need To See It — Add An Image","description":"Make your pages more attractive by adding pictures of any file type, moving them and resizing."},"file":{"title":"Files Here, Files There, Files Everywhere!","description":"Create a database for your project by adding files with different types of extensions to your page."},"largeheading":{"title":"Best for Primary Sections of Page","description":"This is the biggest heading you can add. Attract attention to the most vital part of your page and ease up your navigation."},"mediumheading":{"title":"Best for Secondary Section of Page","description":"This is a middle-size heading you can add. Divide your page into sections with it and easily find what you need."},"smallheading":{"title":"Best For Great Ideas In Subsections","description":"This is a small-size heading you can add, but still it stands out. Use it to divide your page into subsections."},"tasks-list":{"title":"Organize Your Work With Nimbus Tasks","description":"Here you can group your tasks in task lists. Assign tasks to your team members, set deadlines and add statuses for easy tracking."},"hline":{"title":"Let\'s Make A Break","description":"Separate different parts of a project or divide your examples and ideas for it."},"link":{"title":"Pave A Path with Links","description":"Whenever you\'ve got an idea for your project, add a link to it and name it."},"syntax":{"title":"Don\'t Forget About Code","description":"You can add code right on your page, switching between themes, languages and more!"},"link-page":{"title":"Your Next Stop Is Another Page","description":"Link another page connected to this project and easily access it right away."},"date":{"title":"Just Say When","description":"Set a deadline for your project or mark the precise time when you started to work on a page."},"mention":{"title":"Get Your Team Involved","description":"Your team members will get email notifications to open a particular page and collaborate there."},"blockquote":{"title":"And I Quote","description":"You can highlight important words from your clients or single out a motivational phrase."},"hint":{"title":"Let\'s Drop A Hint","description":"Choose an emoji and background color to highlight warnings, disclaimers or notifications on your page."},"toggle":{"title":"Hide & Seek Expand Text Block","description":"Sort and hide additional information on your pages for easier navigation and access."},"outline":{"title":"See What Awaits You On The Page","description":"Create a table of contents for easy navigation on long pages or wikis."},"lock-blot":{"title":"No One Can Edit It","description":"You can leave a particular information block on your page untouched and read-only."},"embed":{"title":"Add More Than Just A Link","description":"You can integrate other tools on your page to keep them all in one place and automatically updated."},"figma":{"title":"Keep Your Visuals Even Closer","description":"Add Figma to see how project visuals are designed in real time."},"miro":{"title":"Your Miro Board Is In A Safe Space","description":"Check a layout strategy or a road map for your project and work further on your page."},"columns":{"title":"Two columns are better than one","description":"Divide your page in two columns to add more content there and make your page look neater."},"meeting-notes":{"title":"Set Goals And Move Forward","description":"Use this template to build a marketing strategy and keep all details in one place."},"marketing-brief":{"title":"Dream Big, Plan Quarter By Quarter","description":"Use this template to build a marketing plan by quarters."},"content-plan":{"title":"Control And Lead Your Work","description":"Use this template to take everything inside your head to a table where you can visualize all parts and manage tasks."},"integrations":{"title":"Add More Than Just A Link","description":"You can integrate other tools on your page to keep them all in one place and automatically updated."},"google-drive":{"title":"Drive Your Files From Google Drive","description":"You can connect your Google Drive account and insert links to your drive files for quick access."},"google-sheets":{"title":"Minus Google Sheet Tab","description":"Keep your data in one place with other project details to draw conclusions more easily."},"bookmark":{"title":"Mark Your Link With A New Look","description":"Use a bookmark to show the title of your link, a small description and a preview picture of the website."},"audioRec":{"title":"Say It, Don\'t Write it","description":"Add a human touch to your collaboration, recording voice feedback to the content on your page."},"videoRec":{"title":"Show it, Don\'t Write It","description":"Record a visual explanation of what should be done or give explicit feedback with a video example."},"button":{"title":"Came, Saw, Clicked","description":"Add a CTA element that will drag attention to important links on your pages."},"largeheading-toggle":{"title":"Hide More In A Large-Sized Collapsible Heading","description":"Define the most vital part of your page and hide information there for easy access."},"mediumheading-toggle":{"title":"Make Your Sections Shorter","description":"Create sections with a middle-sized collapsible heading and hide part of your content there."},"smallheading-toggle":{"title":"Make Your Subsections Shorter","description":"Create subsections with a small-sized collapsible heading on your pages and hide additional information there."},"database-with-options":{"title":"Oh How The Tables Have Turned","description":"Create a database for your project and customize it by selecting different types of columns and rows, changing background color and more."},"board":{"title":"Welcome Your Tasks On a Board","description":"Display tasks as cards on a Kanban board to get a bird’s eye view."},"progress":{"title":"See How Far You\'ve Come!","description":"Choose your value and estimate it. Rate and comment on your added content, tasks or other activities."},"uploader":{"title":"Say Goodbye to the File Mess!","description":"Clarify what files your clients and/or team need to send. With the file uploader, you can get what you want and keep it all in one place."},"dropdown-list":{"title":"Drop Your Options","description":"Place answer options anywhere in the text & let others give instant feedback."},"use-ai":{"title":"Work Smart, Not Hard","description":"Use AI to create and improve your content, get new ideas, and make personalized recommendations. Work with an AI assistant in your workspace."}},"feature_availability":{"plus":{"not-available":"Available for Plus & Team & Business plans","trial":"This is open as a trial Plus feature for you"},"team":{"not-available":"Available for Team & Business plans","trial":"This is open as a trial Team feature for you"},"business2023":{"not-available":"Available for Business plan","trial":"This is open as a trial Business feature for you"}}}');
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/i18n/messages/es.json
const es_namespaceObject = JSON.parse('{"table":{"common":{"column":"Columna"},"move_column_cant_split_merged_cells":{"title":"No se puede mover la columna","text":"No se puede mover la columna a una celda combinada. Primero divídela e inténtalo de nuevo."},"move_column_cant_move_part_of_merged_cells":{"title":"No se puede mover la columna","text":"La columna que estás intentando mover contiene parte de una celda combinada. Si quieres mover la columna, divide las celdas primero."},"move_column_failed":{"title":"No se puede mover la columna","text":"Ha ocurrido un error inesperado al mover una columna. Por favor, inténtalo de nuevo."},"move_row_cant_split_merged_cells":{"title":"No se puede mover la fila","text":"No se puede mover la fila a una celda combinada. Primero divídela e inténtalo de nuevo."},"move_row_cant_move_part_of_merged_cells":{"title":"No se puede mover la fila","text":"TLa fila que estás intentado mover contiene parte de una celda combinada. Si quieres mover la fila, divide las celdas primero."},"move_row_cant_move_in_sortable_table":{"title":"No se puede mover la fila","text":"No se pueden mover fila en una tabla ordenada. Borra los ajustes de ordenación primero e inténtalo de nuevo."},"move_row_cant_move_in_filtered_table":{"title":"Unable to move row","text":"Cannot move a row in a filtered table. Cancel filter then try again."},"move_row_failed":{"title":"No se puede mover la fila","text":"Ha ocurrido un error inesperado al mover una fila. Por favor, inténtalo de nuevo."},"first_move_column_or_row_message":"You can select multiple rows or columns by holding down the CTRL button and clicking on the desired rows or columns.","menu":{"delete":"Eliminar","help":"Ayuda","delete_column":{"one":"Eliminar columna","many":"Eliminar {{count}} columnas"},"delete_row":{"one":"Eliminar fila","many":"Eliminar {{count}} filas"},"add":"Añadir","add_row_before":{"one":"Fila arriba","many":"{{count}} filas arriba"},"add_row_after":{"one":"Fila debajo","many":"{{count}} Filas debajo"},"add_col_before":{"one":"Columna a la izquierda","many":"{{count}} columnas a la izquierda"},"add_col_after":{"one":"Columna a la derecha","many":"{{count}} columnas a la derecha"},"copy_cell":{"one":"Copiar celda","many":"Copiar celdas"},"copy_table":"Copiar tabla","table_layout":{"name":"Diseño de tablat","column_headings":"Encabezados de columnas","row_headings":"Encabezados de filas"},"import_csv":"Import from CSV","merge_cells":"Combinar celdas","insert_checkbox":"Insertar casilla de verificación","background_color":"Color de fondo","formatting":"Formato","clear":"Borrar","reset":"Restaurar","divide_cells":"Dividir celdas","type":{"name_cell":"Tipo de celda","name_cells":"Tipo de celdas","name_column":"Tipo de columna","name_columns":"Tipo de columnas","type_cell":{"one":"Tipo de celda","many":"Tipo de celdas"},"type_col":{"one":"Tipo de columna","many":"Tipo de columnas"},"same_as_column":"Igual que la columna","reset_cells":"Restaurar celdas a los ajustes por defecto","none":"Mútiple","text":"Texto","textline":"Texto","number":"Número","attachment":"Adjunto","checkbox":"Casilla de verificación","multiselect":"Selección múltiple","singleselect":"Selección única","collaborator":"Persona","currency":"Moneda","date":"Fecha","link":"Enlace","rating":"Valoración","progress":"Progreso","mention":"Mención"},"number_format":{"name":"Formato de número","number":"Número","commas":"Número con comas","percent":"Porcentaje"},"currency_format":{"name":"Tipo de moneda","dollar":"Dólar","euro":"Euro","yen":"Yen","yuan":"Yuan","rouble":"Rublo","pound":"Libra","rupee":"Rupia","hryvnia":"Grivna","won":"Won","frank":"Franco","real":"Real","other":"Otra","stick":"Mostrar símbolo","before":"Antes","after":"Después"},"decimal_format":{"name":"Decimal separator","comma":"Comma","point":"Point","hint":"The separator is used for decimal places. Comma decimal separators will look like 1.000,99, and point separators look like 1,000.99"},"progress_format":{"name":"Opciones de progreso","simple":"Simple","colored":"A color","start_from":"Empezar desde (0-100)","default_amount":"Cantidad por defecto (0-100)"},"rating_format":{"name":"Opciones de valoración","star":"Estrellas","flag":"Banderas","heart":"Corazones","amount":"Cantidad (1-10)"},"date_format":{"name":"Formato de fecha y hora"},"mention_panel":{"open":"Abrir","edit":"Editar","clear":"Borrar"},"color_numbers":{"name":"Color numbers","enable":"Enable color numbers"},"filter":"Filter","comment":"Comment"},"formatting_menu":{"align_left":"Izquierda","align_center":"Centrar","align_right":"Derecha","valign_top":"Arriba","valign_center":"Centro","valign_bottom":"Abajo","text":"Texto","text_align":"Alineación del texto","text_color":"Color del texto","bold":"Negrita","italic":"Cursiva","strikethrough":"Tachado","underline":"Subrayado"},"col_menu":{"add_column_after":{"one":"Añadir columna a la derecha","many":"Añadir {{count}} columnas a la derecha"},"add_column_before":{"one":"Añadir columna a la izquierda","many":"Añadir {{count}} columnas a la izquierda"},"duplicate_column":{"one":"Duplicar columna","many":"Duplicar columnas"},"rename":"Renombrar"},"row_menu":{"add_row_after":{"one":"Añadir fila debajo","many":"Añadir {{count}} filas debajo"},"add_row_before":{"one":"Añadir fila arriba","many":"Añadir {{count}} filas arriba"}},"warning":{"merge_different":"No se pueden combinar diferentes tipos de objetos","convert_merged":"No se pueden convertir las celdas combinadas"},"select":{"create_list":"Escribe para crear una lista","create_item":"Escribe para crear un elemento","create_option":"Escribe para crear una opción","create_label":"Escribe para crear una etiqueta","create":"Crear","delete":"Eliminar"},"attachment":{"upload_more":"Subir archivo(s)","downloading":"Descargando"},"collaborator":{"placeholder":"Escribe para añadir personas","no_result":"Sin resultados","loading":"Cargando...","unknown":"Persona desconocida"},"checkbox":{"checked":"Sí","not_checked":"No"},"sorting":{"name":"Ordenar","sort":"Ordenar","disable":"Eliminar orden","change":"Haz click para cambiar","asc":{"common":"Ascendente","text":"Ordenar de la A-Z","number":"Ordenar del 1-9","checkbox":"No seleccionados primero"},"desc":{"common":"Descendente","text":"Ordenar de la Z-A","number":"Ordenar del 9-1","checkbox":"Seleccionados primero"},"warning":{"column_merged":{"title":"No se pueden ordenar la columna","text":"No se puede ordenar columnas con celdas combinadas"},"table_rowspan":{"title":"No se puede ordenar la columna","text":"No se puede ordenar columnas con filas combinadas"},"merge":{"title":"Cells cannot be merged","text":"Cells cannot be merged while column sorting is active. Disable sorting and try again."},"different_currencies":{"title":"Advertencia de ordenación","text":"Estás utilizando diferentes monedas en una misma columna. El orden puede no aplicarse correctamente."}},"exit_dialog":{"title":"Eliminar orden","toggle":"Mantener ordenado","text_keep":"Mantener ordenado","text_no_keep":"El orden de la columna se restaurará a sus ajustes por defecto","apply":"Aplicar"}},"filter":{"by_field":"Filter by this field","empty_table":"All records are filtered","popup_title":"In this table, show records","empty_filters":"No conditions are applied to this database","where":"Where","or":"Or","and":"And","add_condition":"Add condition","clear_all":"Clear all","contains":"contains","is":"is","is_not":"is not","contains_not":"contains not","has_any_of":"has any of","has_none_of":"has none of","empty":"empty","not_empty":"not empty","filetype":"filetype","select_users_placeholder":"Select users","type_text_placeholder":"Type text","type_text_or_select_placeholder":"Type text or select","type_number_placeholder":"Type number","select_type_placeholder":"Select type","select_date_placeholder":"Select date","date":{"today":"Today","yesterday":"Yesterday","tomorrow":"Tomorrow","custom":"Custom"},"filetypes":{"images":"Images","documents":"Documents","media":"Media","other":"Other"},"warning":{"cells_merged":{"title":"Unable to filter table","text":"Can\'t filter column with merged cells"},"merge":{"title":"Cells cannot be merged","text":"Cells cannot be merged while table filter is active. Disable filter and try again."},"column_multitype":{"title":"Unable to filter table","text":"There is no such possibility to filter columns with Multi type. Please, try to convert to another type and try again."},"table_not_have_typed_columns":{"title":"Unable to filter table","text":"No columns available for filtering."}},"enable_filter":"Enable filter","disable_filter":"Disable filter"},"wrap_cells":{"layout_menu":"Ajustar celdas","warnings":{"merge":{"title":"No se pueden combinar las celdas","text":"No se puede combinar celdas que estén en el modo \\"no ajustar\\""},"toggle":{"title":"No se puede cambiar el ajuste","text":"La tabla contiene celdas combinadas"}}},"duplicate_column":{"title":"Duplicar columna","text_1":"Duplicar el contenido de la columna","text_2":"Puedes duplicar la columna al completo, incluyendo su contenido o duplicar la columna sin contenido","accept":"Duplicar","copy":"copiar"},"convert_column":{"title":"Cambiar el tipo de columna","text_before":"Esta columna contiene valores. Cambiar el tipo de columna eliminará alguno de esos valores. Usa","text_cmd":"deshacer","text_after":"para revertir los cambios si fuese necesario.","accept":"Cambiar tipo"},"merge_cells_with_comments":{"title":"Merging cells","text":"The cells will be merged from left to right and the new cell will show a comment from the left cell.","accept":"Merge"},"summary":{"layout_menu":"Mostrar barra de cálculos","name":{"none":"Nada","all":"Todo","empty":"Las vacías","fill":"Las que tienen datos","unique":"Las que son diferentes","empty_percent":"Sin porcentaje","fill_percent":"Con porcentaje","unique_percent":"Con porcentajes diferentes","sum":"Suma","average":"Media","min":"Mín.","max":"Máx.","median":"Mediana","min_date":"La fecha más antigua","max_date":"La fecha más reciente","range_days":"Rango de fechas (días)","range_month":"Rango de fechas (mes)","checked":"Marcadas","unchecked":"Sin marcar","checked_percent":"Porcentaje completado","unchecked_percent":"Porcentaje sin completar","filter_rating":"Con valoración:","filter_progress":"Con progreso:","filesize_min":"Tamaño mín.","filesize_max":"Tamaño máx."},"item":{"none":"Calcular","min_date":"La más antigua","max_date":"La más reciente","range_days":"Rango (días)","range_month":"Rango (mes)","checked_percent":"Marcadas","unchecked_percent":"Sin marcar","filter_rating":"Con valoración","filter_progress":"Con progreso"}},"comments":{"tooltip":{"one":"Comment","more":"Comments"}}},"file":{"image_viewer":{"could_not_load_image":"No se pudo cargar la imagen"},"download_file":"Descargar {{name}}","listen_file":"Play {{name}}","stop_file":"Stop {{name}}","uploading":"Subiendo","wrtc":{"how_to_fix":"How to fix it?","how_to_url":"https://nimbusweb.me/s/share/5441210/4qccr41slk6wsw61h5fb","how_to_url2":"https://nimbusweb.me/s/share/5607239/l55bgak2ivs9bfptruka#b1995924032_670","rec_err_au":"Recording error. No microphone access.","rec_err_vi":"Recording error. No access to microphone/webcam. ","allow_micro":"Allow Access to microphone","allow_media":"Select the window you want to record","select_opt":"What will be recorded","screenonly":"Screen only","camonly":"Cam only","screencam":"Screen + Cam","enable_micro":"Enable microphone","startRecording":"Start recording","stopRecording":"Stop recording","pauseRecording":"Pause recording","resumeRecording":"Resume recording","cancelRecording":"Сancel recording","confirmCancel":"Are you sure you want to cancel the video recording?","cancel":"Сancel","prepareUpload":"Please wait, preparing to upload record","hasTmpRecord":"The recording was interrupted but not lost","restore":"Restore","delete":"Delete","recordOnAnotherDevice":"Recording is in progress on another device ..."},"menu":{"enabled":"Enabled","disabled":"Disabled","open_in_new_tab":"Abrir en una pestaña nueva","copy_link":"Copiar enlace al archivo","expand_in_full_window":"Abrir en pantalla completa","autoplay":"Autoplay","sound_default":"Sound by default","sound_loop":"Loop","sound_hideControls":"Hide controls","sound_showPanel":"Show top panel","shadow_video":"Shadow for video","video_params":"Video settings","disallow_download":"Downloading","for_note":"For workspaces users","for_share":"Public page","motion_video":"Motion video","preview_video":"Change preview","preview_video_btn":"Preview","print":"Imprimir","convert_to_image":"Convertir en imagen","convert_to_file":"Convert to file","style":"Style","shadow_image":"Shadow for image","rename":"Renombrar","replace":"Reemplazar","delete":"Eliminar","download":"Descargar","get_text_from_image":"Extraer texto de imagen","view_as":"View as","single_page":"Single page","all_pages":"All pages","cta_motion_video_message":"CTA is enabled for videos. You cannot use CTA and Motion video at the same time. Disable CTA and try enabling Motion video again.","cta_loop_message":"CTA is enabled for videos. You cannot use CTA and Loop at the same time. Disable CTA and try enabling Loop again.","grid":"Grid","cta_drop_in_grid":"CTA is enabled for videos. We recommend checking the correctness of the CTA display after transferring the video into a grid column.","cta_exists_in_grid":"The grid column has a video with an active CTA. Please check if it is correct after the transfer."},"downloading":"Descargando","attachment_not_found_error":"Error al subir","pdf_viewer":{"initializing_full_window_view":"Iniciando la vista a pantalla completa","preparing_document_for_printing":"Preparando el documento para la impresión...","printing_initialization":"Iniciando la impresión...","abort":"abortar","set_page_as_default":"Set page as default","unset_page_as_default":"Default page. Click to make the page normal."},"video_just_uploaded_codec_error":"You are trying to upload a video that has been encoded with the {codec} codec. We do not guarantee the correct playback of this video on all browsers. We recommend converting the video to another format and uploading it again.","video_codec_error":"This video is encoded with {codec} codec, which is not supported in your browser.","safari_webm_not_support":"Currently, Safari browsers do not support WEBM format. Try to open the note in another browser, such as Google Chrome or Mozilla Firefox.","video_transcribe":"Transcribe","video_summary":"Summary","video_meeting_notes":"Meeting Notes","video_ask_ai":"Ask AI"},"image":{"text_from_image_popup":{"title":"Texto de imagen","no_text":"No hay texto","copy":"Copiar todo el texto"},"unknown_error":"El enlace no es correcto","add_image":"Pegar el enlace de la imagen o ","add_image_or":"o","add_image_small":"Pegar o ","browse":"explorar","browse_image":"Explorar imagen","too_large_error":"El tamaño de la imagen es demasiado grande","image_info_dialog":{"title":"Información de la imagen","type":"Tipo","size":"Tamaño","location":"Ubicación","copy_link":"Copiar enlace"},"rotate_wait":{"full":"Por favor, espera","medium":"Espera"},"attachment_not_found_error":"Ha ocurrido un error inesperado con la imagen","readonly_placeholder":"Imagen vacía","unsplash":{"name":"Unsplash","header":"Search image","placeholder":"Search for an image","search":"Search","description":"Search to find more results.","no_result":"No images found.","caption_preffix":"Photo by"},"comments":"Comments"},"attachment":{"unknown_error":"Algo ha ido mal. Prueba eligiendo otro archivo","attachment_is_being_uploaded":"A file is being uploaded on another device...","attachment_will_be_downloaded_online":"El archivo se descargará cuando estés conectado.","attachment_preview_is_not_available":"La vista previa no está disponible.","choose_a_file":"Elegir archivos","wait_resolving_without_info":"Please wait..."},"video":{"player":{"play":"Reproducir","pause":"Pausar","volume":"Volumen","fullscreen_on":"Pantalla completa","fullscreen_off":"Salir de pantalla completa","watch_again":"Watch again"}},"search":{"placeholder":"Buscar en la nota","matches":"Coincidencias:"},"copy":{"copied":"¡Copiado!","copy_to_clipboard":"Copiar al portapapeles"},"apply":"Aplicar","done":"Hecho","block_menu":{"align":{"left":"Alinear a la izquierda","center":"Centrar","right":"Alinear a la derecha","justify":"Justificar"},"indent":{"indent":"Aumentar sangría","outdent":"Reducir sangría"},"tooltip":"Arrastra para mover\\n<span>Haz click para abrir el menú</span>","copy_tooltip":"Copy link","color":{"background_color":"Color de fondo","color":"Color","line_color":"Color de la línea","line_type":"Tipo de línea","player_color":"Player\'s color"},"line_type":{"default":"Línea estándar","dotted":"Puntos"},"add":{"name":"Añadir bloque","above":"Arriba","below":"Abajo","left":"A la izquierda","right":"A la derecha","above_column":"Above column","below_column":"Under column"},"convert_to":{"name":"Convertir en","to_do_list":"Checklist","number_list":"Lista numerada","bullet_list":"Lista con viñetas","paragraph":"Párrafo","large_heading":"Título grande","medium_heading":"Título mediano","small_heading":"Título pequeño","large_heading_toggle":"Collapsible Large Heading","medium_heading_toggle":"Collapsible Medium Heading","small_heading_toggle":"Collapsible Small Heading","code":"Código","quote":"Cita","hint":"Hint","image":"Imagen","file":"Archivo","remote_frame":"Insertar","link":"Enlace","bookmark":"Marcador","button":"Button","toggle":"Toggle Block","step":"Steps"},"comment_block":"Comment","edit":"Editar","duplicate":"Duplicar","copy_block":"Copy block","copy_blocks":"Copy blocks","copy_link":"Copiar enlace","delete":"Eliminar","replace":"Reemplazar","blot_lock":"Lock block","blot_unlock":"Unlock block","set_as_preview":"Establecer como miniatura","get_text_from_image":"Extraer texto de imagen","edit_image":"Edit image","download":"Descargar","view_full_size":"Ver a tamaño completo","open_in_new_tab":"Abrir en una pestaña nueva","image_info":"Información de la imagen","rotate_image":"Rotar","add_sub_task":"Añadir subtarea","add_sub_text":"Añadir subtexto","layout":"Layout","embed_align":{"left":"Left align","center":"Center align","right":"Right align","default":"Default size","full_width":"Full width"},"expand_all":"Expand all","collapse_all":"Collapse all","add_caption":"Añadir pie","blot_locked_admin":"Editing of the block is denied. Click to unlock it.","blot_locked_admins":"Editing of the blocks is denied. Click to unlock it.","blot_locked_user":"You don’t have permission to edit this bock. Contact your organization admin.","show_header":"Show top bar","show_borders":"Show borders","rename":"Renombrar"},"convert_menu_groups":{"suggestions":"Suggestions","basic":"Basic","advanced":"Advanced","media":"Media","embed":"Embed","views":"Views","templates":"Templates","helpful_links":"Helpful links"},"embedded_menu":{"start_typing":"Type \\"/\\" or add","start_typing_full":"Start writing or type \\"/\\", \\"@\\"","more_items":"Más elementos...","add_an_element":"Añadir un elemento","paragraph":"Paragraph","todo":"Checklist","numbered_list":"Lista numerada","bullet_list":"Lista con viñetas","table":"Tabla","image":"Imagen","file":"Archivo","audioRec":"Audio Record","videoRec":"Video Record","recordExist":"You cannot start a new recording until the previous one is completed. End or delete the previous record to start a new one.","large_heading":"Título 1","medium_heading":"Título 2","small_heading":"Título 3","large_heading_toggle":"Collapsible Large Heading","medium_heading_toggle":"Collapsible Medium Heading","small_heading_toggle":"Collapsible Small Heading","section_break":"Separador","link":"Enlace","code":"Código","quote":"Cita","hint":"Hint","hint_placeholder":"Type something","mention":"Mention member","outline":"Tabla de contenido","remote_frame":"Insertar","integrations":"Integrations","google_drive":"Google Drive","google_sheets":"Google sheets","html":"HTML","toggle":"Toggle block","tasks_list":"Task list","lock_blot":"Lock block","link_page":"Link page / Create","date":"Date","more_integrations":"more integrations","two_columns":"2 columns","meeting_notes":"Meeting notes","marketing_brief":"Marketing Brief","content_plan":"Content plan","more_templates":"more templates","get_feedback":"Get a feedback","contact_support":"Contact support","learn_nimbus":"Learn Nimbus","footer_top":"Did you know? You can start typing to search the list","footer_bottom":"Can’t find smth you want?","footer_link":"Tell us","add_note":"New page","database_with_options":"Database","board":"Kanban / Task Board","progress":"Progress","dropdown_list":"Dropdown list","uploader":"File uploader","use_ai":"Use Fusebase AI","helper":"AI helper","summarize":"Summarize","explain":"Explain","improve":"Improve","spelling":"Fix spelling and grammar","cta":"Call to actions","shorter":"Make shorter","longer":"Make longer","step":"Steps"},"button":{"title":"Title","id_info_tooltip":"This ID can be used in the future when editing the CSS file.","address":"URL or Email","open_in_new_tab":"Open in new tab","shape":"Button shape","background":"Background","size":"Button size","small":"Small","medium":"Medium","big":"Big","cancel":"Cancel","done":"Done","length_error":"The text is too large for the button. Try selecting less text (no more than 50 characters).","type":"Button type","default":"Default","withShadow":"Button with shadow","3d":"3d button","convert":{"popup_title":"Convert to button"}},"link":{"open":"Abrir","send":"Enviar","copy":"Copiar","edit":"Editar","remove":"Eliminar","text_label":"Texto","url_label":"Enlace","email_label":"Correo electrónico","copied":"Enlace copiado al portapapeles","cancel":"Cancel","done":"Done"},"syntax":{"menu":{"language":"Idioma","theme":"Theme","wrap":"Activar ajustar","unwrap":"Desactivar ajustar","lineNumbersOn":"Show line numbers","lineNumbersOff":"Hide line numbers"},"convert":{"popup_title":"Convert to code","blots_have_comments":"There are comments in the text that will be deleted during conversion.","text_has_inline_comments":"There are comments inside the text that will be deleted during conversion.","confirm":"Convert"}},"list":{"list_style":"Estilo de lista","type_default":"Por defecto","type_rectangle":"Rectángulos","type_star":"Estrellas","type_dart":"Dardos","type_rounded":"Círculos","type_arrow":"Flechas","type_diamond":"Diamantes"},"caption":{"placeholder":"Añadir pie"},"mention":{"show_all":"Mostrar todo","show_all_users":"Mostrar todo","placeholder":"Mostrando los recientes o escribe para buscar","user":"Personas","workspace":"Espacios de trabajo","folder":"Carpetas","note":"Notas","no_results":"Sin resultados","offline_message":"Las menciones solo funcionan con una conexión a internet activa. Conéctate a internet e inténtalo de nuevo.","info":{"note":{"one":"nota","some":"notas","many":"notas"},"subfolder":{"one":"subcarpeta","some":"subcarpetas","many":"subcarpetas"},"member":{"one":"miembro","some":"miembros","many":"miembros"},"owner":"propietario","loading":"Cargando previsualización...","loading_failed":"La carga ha fallado","not_loaded":"Note has not been loaded yet"},"back_button":"Volver","create_note_for":"Create Note","create_folder_for":"Create Folder"},"calendar":{"ui":{"date":"Fecha","am":"AM","pm":"PM","date_format":"Formato de fecha","show_time":"Mostrar hora","time_format":"Formato de hora","time_12":"12H","time_24":"24H","first_week_day":"Primer día de la semana","time_zone":"Zona horaria","use_gmt":"Usar GMT para todos los miembros","use_gmt_hint":"Usa la misma zona horaria (GMT) para todos los colaboradores","table":{"clear":"Borrar"},"inline":{"clear":"Eliminar"},"reminder":{"name":"Alerta","panel_name":"Alerta","push_name":"Recordatorio del evento","remove_confirm_message":"You have alerts that are time-bound. Do you want to delete these reminders?","remove_confirm_text":"Delete","remove_cancel_text":"Don\'t delete reminders","before_period":"","after_period":"antes","period":{"m":{"one":"minuto","many":"minutos"},"h":{"one":"hora","many":"horas"},"d":{"one":"día","many":"días"},"w":{"one":"semana","many":"semanas"}},"value":{"none":"Ninguno","0m":"A la hora de inicio","1m":"1 minuto antes","5m":"5 minutos antes","10m":"10 minutos antes","15m":"15 minutos antes","30m":"30 minutos antes","1h":"1 hora antes","2h":"2 horas antes","1d":"1 día antes","2d":"2 días antes","7d":"7 días antes","10d":"10 días antes","14d":"14 días antes","custom":"Personalizado"},"until":{"in":"En","d":"d","h":"h","m":"min","already_been":"Ya ha sido","less_minute":"Menos de un minuto","now":"Ahora"}},"postfix":{"day":"d","month":"m"}},"insert":{"category_name":"Fecha","custom":"Personalizado","now":"Now","today":"Hoy","tomorrow":"Mañana"},"date_format":{"ddmmyyyy":"dd/mm/aaaa","mmddyyyy":"mm/dd/aaaa","yyyyddmm":"aaaa/mm/dd","monthddyyyy":"Mes dd, aaaa","default":"Coincidir con el formato del navegador"},"months":{"0":"Enero","1":"Febrero","2":"Marzo","3":"Abril","4":"Mayo","5":"Junio","6":"Julio","7":"Agosto","8":"Septiembre","9":"Octubre","10":"Noviembre","11":"Diciembre"},"days":{"short":{"0":"Do","1":"Lu","2":"Ma","3":"Mi","4":"Ju","5":"Vi","6":"Sá"},"full":{"0":"Domingo","1":"Lunes","2":"Martes","3":"Miércoles","4":"Jueves","5":"Viernes","6":"Sábado"}}},"content_not_supported":"Esta nota no es compatible con la versión de tu aplicación FuseBase. Prueba actualizándola o usa otro cliente con la última versión.","profession_ask":{"title":"Ahorra tiempo usando plantillas para crear notas nuevas","text":"Escribe tu ocupación y nuestro equipo creará plantillas para ti. Es totalmente gratis, sin ningún tipo de coste","i_am_a":"Soy","placeholder":"por ejemplo, diseñador, profesores, agente de ventas, etc.","request_template":"Solicitar plantilla","sucess_message":"¡Gracias! Tu solicitud se añadirá a la cola."},"bookmark":{"name":"Marcador","edit":"Editar marcador","title":"Título","address":"Dirección","description":"Descripción","placeholder":"Pega o escribe el enlace con https://...","placeholder_mobile":"Paste or write link","loading_preview":"Cargando previsualización…","block_menu":{"change_mode":{"menu_name":"Ver como","mode_tile":"Mosaico","mode_card":"Tarjeta","mode_cover":"Cover"},"change_preview":"Cambiar miniatura","delete_preview":"Eliminar miniatura","reset_preview":"Restaurar miniatura","change_preview_background":"Preview background","options":{"menu_name":"Options","open_in_same_tab":"Open in same tab"}},"error":{"unknown_error":"Algo ha ido mal. Prueba introduciendo otra URL","preview_notfound":"No se han encontrado miniaturas"},"upload":{"new_preview":"Upload New","quota_error":"The file is larger than the 3MB allowed. Try another file.","unknown_error":"Unknown error. Try another file."}},"businessCard":{"PERSON":"Nombre","ORGANIZATION":"Empresa","TITLE":"Título","ADDRESS":"Posición","URL":"Sitio web","PHONE":"Teléfono","EMAIL":"Correo electrónico","SKYPE":"Skype","TWITTER":"Twitter","INSTAGRAM":"Instagram","FACEBOOK":"Facebook","LINKEDIN":"LinkedIn","VK":"Vk"},"dialog_common":{"button":{"ok":"Aceptar","cancel":"Cancelar"}},"outline":{"default_name":"Tabla de contenido","menu":{"expand":"Expandir","collapse":"Contraer","rename":"Renombrar"},"context_menu":{"convert_to":{"text":"Texto"},"style":{"name":"Estilo de la tabla de contenido","list_only":"Solo lista","numbered_list":"Lista numerada","bordered":"Mostrar borde","border_color":"Border color"}},"empty":"Añade títulos a tu nota y aparecerán aquí automáticamente como enlaces"},"floating_toolbar":{"bold":"Negrita","italic":"Cursiva","underline":"Subrayado","strikethrough":"Tachado","clear":"Limpiar formato","code":"Código","button":"Button","link":"Enlace","highlight":"Resaltar","extraHighlight":"High contrast highlights","color":"Color","text":"Texto","clear_all":"Clear all","placeholder":"Marcador","adapts":{"dark":"Se adapta al modo oscuro","light":"Se adapta al modo claro"},"create_note":"Create note","add_comment":"Add comment"},"remote_frame":{"placeholder_small":"Insertar URL","placeholder_full":"Inserta cualquier URL como YouTube, Github, Maps, Twitter, etc.","loading":"Cargando...","context_menu":{"change_link":"Cambiar enlace","full_size":"Tamaño completo","reset_size":"Reset size","open_origin":"Abrir original","layout":"Diseño","show_toolbar":"Mostrar barra de edición","copy_original":"Copy link to original"},"error":{"is_not_link":"El enlace no es correcto","content_error":"El dominio no se soporta o la URL no es correcta. Por favor, escribe a nuestro <a href=\\"https://nimbusweb.me/contact-us.php\\" target=\\"_blank\\">equipo de soporte</a> y nosotros procesaremos tu enlace.","unknown_error":"Algo ha ido mal. Intenta insertar otra URL","wrong_signature":"Este contenido está corrupto o no se puede mostrar","google_docs_auth_error":"Probablemente no puedas insertar documentos, presentaciones u hojas de cálculo de Google porque no tienes acceso a ellos. <a href=\\"http://nimb.ws/EkX87M\\" target=\\"_blank\\">Por favor, lee nuestra guía.</a>","internal_link_error":"{{serviceName}} has forbidden following internal links. Click on Back to return to the previous page."},"convert_bookmark":"Convertir en marcador","convert_link":"Convertir en enlace","back_button":"Back"},"google_drive":{"block_name":"Google Drive","loading":"Cargando...","menu":{"expand":"Expandir","collapse":"Contraer","open_origin":"Abrir en Google Drive","download":"Descargar","change_account":"Cambiar cuenta","choose_another_file":"Elegir otro archivo"},"last_modified":"Modificado por última vez por {{userName}}, hace {{time}}","browse":"Seleccionar archivo","login":"Iniciar sesión con Google","login_text":"Selecciona archivos y añádelos desde Google Drive"},"html":{"default_name":"HTML","loading":"Cargando...","menu":{"open_source":"Abrir origen del enlace","export_blot":"Save HTML"},"unknown_error":"Error desconocido","device_cant_display_content":"Tu dispositivo no puede mostrar este contenido","wrong_signature":"Este contenido está corrupto y no puede mostrarse"},"relative_time":{"seconds":{"one":"{{count}} segundo","some":"{{count}} segundos","many":"{{count}} segundos"},"minutes":{"one":"{{count}} minuto","some":"{{count}} minutos","many":"{{count}} minutos"},"hours":{"one":"{{count}} hora","some":"{{count}} horas","many":"{{count}} horas"},"days":{"one":"{{count}} día","some":"{{count}} días","many":"{{count}} días"},"months":{"one":"{{count}} mes","some":"{{count}} meses","many":"{{count}} meses"},"years":{"one":"{{count}} año","some":"{{count}} años","many":"{{count}} años"}},"collapsible_content":{"menu":{"expand":"Expandir","collapse":"Contraer","rename":"Renombrar"}},"convert_link":{"url":"URL","title":"Título","embed":"Insertar","bookmark":"Marcador","button":"Button","link_to_note":"Enlace a nota","link_to_folder":"Enlace a carpeta","link_to_workspace":"Link to workspace","convert_error":"Ha ocurrido un error al convertir la URL"},"fullwidth":{"menu_item":"Ancho completo"},"resizeable":{"point_tooltip":{"default":"Resize","bottom-right":"Resize\\n(press and hold the {{altKey}} button for free resize)"}},"toggle":{"placeholder":"Click here to create or move a block","expand":"Expand toggle","collapse":"Collapse toggle","expand_heading":"Expand heading","collapse_heading":"Collapse heading","expand_step":"Expand step","collapse_step":"Collapse step"},"step":{"content_placeholder":"Click here to create description to the step","title_placeholder":"Enter a short title to describe this step","aggregator_placeholder":"Enter a short descriptive title","menu":{"step_layout":{"name":"Layout","show_number":"Show number","show_arrow":"Show arrow","show_border":"Show border"}}},"tasks_list":{"not_supported":"Currently, we cannot display the task list as it is not supported in this type of pages.","menu":{"show_title":"Show task list name","view":"Default view","task_list_view":"Task list","calendar_view":"Calendar","kanban_view":"Kanban"}},"board":{"not_supported":"Currently, we cannot display the task board as it is not supported in this type of pages.","menu":{"add_new_column":"New column","board_layout":{"name":"Layout","show_add_new_column":"Show Add column"}}},"empty_features":{"use_template":"Use a template","import":"Import","add_database":"Add database","add_database_with_options":"Add database with options","add_board":"Kanban / Task Board","use_ai":"Use Fusebase AI","use_ai_agents":"Use AI Agents"},"ai_manager":{"generate_error":"Unfortunately, there are no results for your request. Please try another request.","unload_message":"Fusebase AI content is being generated. Are you sure you want to exit?","unknown_error":"Unknown error. Try again later or contact support.","dialog":{"title":"Discard draft","body":"Do you want to discard draft?","accept":"Yes, discard"}},"uploader":{"header":"Upload files","description":"Here, you can add some helpful information about file uploading","dropzone_full":"Drag file(s) here or","browse":"click to upload","dropzone_compact":"Add more files","uploading_progress":"Uploading {{progress}}%","uploading_files":"Uploading files","counter":"{{current}} of {{total}}","timer":"less than 1 minute remaining","header_placeholder":"Write a title, max {{maxChars}} characters","description_placeholder":"Write a description, max {{maxChars}} characters","errors":{"network":"Failed uploading file","too_big":"File is too big"},"menu":{"disallow_download":"Downloading","for_note":"For workspaces users","for_share":"Public page","convert_to_files":"Convert to files","allow_upload":"Uploading","enable_in_public_page":"Enable in public page"}},"convert_menu_tooltips":{"labels":{"management":"Great for knowledge management","collaboration":"Great for collaboration"},"paragraph":{"title":"Best for main content","description":"This is the main block for writing page content."},"todo":{"title":"A List For Small Tasks? Check!","description":"Write down small errands and routine tasks that need to be done."},"numberedlist":{"title":"Let\'s Line Up: One, Two, Three!","description":"Make your content easy-to-read and display it in a series."},"bulletlist":{"title":"Points Make Everything Clearer","description":"You can create a list that will stand out from other content."},"table":{"title":"Rejoice the Formatting","description":"Organize your information in a table to get a holistic view on your work."},"image":{"title":"We Need To See It — Add An Image","description":"Make your pages more attractive by adding pictures of any file type, moving them and resizing."},"file":{"title":"Files Here, Files There, Files Everywhere!","description":"Create a database for your project by adding files with different types of extensions to your page."},"largeheading":{"title":"Best for Primary Sections of Page","description":"This is the biggest heading you can add. Attract attention to the most vital part of your page and ease up your navigation."},"mediumheading":{"title":"Best for Secondary Section of Page","description":"This is a middle-size heading you can add. Divide your page into sections with it and easily find what you need."},"smallheading":{"title":"Best For Great Ideas In Subsections","description":"This is a small-size heading you can add, but still it stands out. Use it to divide your page into subsections."},"tasks-list":{"title":"Organize Your Work With Nimbus Tasks","description":"Here you can group your tasks in task lists. Assign tasks to your team members, set deadlines and add statuses for easy tracking."},"hline":{"title":"Let\'s Make A Break","description":"Separate different parts of a project or divide your examples and ideas for it."},"link":{"title":"Pave A Path with Links","description":"Whenever you\'ve got an idea for your project, add a link to it and name it."},"syntax":{"title":"Don\'t Forget About Code","description":"You can add code right on your page, switching between themes, languages and more!"},"link-page":{"title":"Your Next Stop Is Another Page","description":"Link another page connected to this project and easily access it right away."},"date":{"title":"Just Say When","description":"Set a deadline for your project or mark the precise time when you started to work on a page."},"mention":{"title":"Get Your Team Involved","description":"Your team members will get email notifications to open a particular page and collaborate there."},"blockquote":{"title":"And I Quote","description":"You can highlight important words from your clients or single out a motivational phrase."},"hint":{"title":"Let\'s Drop A Hint","description":"Choose an emoji and background color to highlight warnings, disclaimers or notifications on your page."},"toggle":{"title":"Hide & Seek Expand Text Block","description":"Sort and hide additional information on your pages for easier navigation and access."},"outline":{"title":"See What Awaits You On The Page","description":"Create a table of contents for easy navigation on long pages or wikis."},"lock-blot":{"title":"No One Can Edit It","description":"You can leave a particular information block on your page untouched and read-only."},"embed":{"title":"Add More Than Just A Link","description":"You can integrate other tools on your page to keep them all in one place and automatically updated."},"figma":{"title":"Keep Your Visuals Even Closer","description":"Add Figma to see how project visuals are designed in real time."},"miro":{"title":"Your Miro Board Is In A Safe Space","description":"Check a layout strategy or a road map for your project and work further on your page."},"columns":{"title":"Two columns are better than one","description":"Divide your page in two columns to add more content there and make your page look neater."},"meeting-notes":{"title":"Set Goals And Move Forward","description":"Use this template to build a marketing strategy and keep all details in one place."},"marketing-brief":{"title":"Dream Big, Plan Quarter By Quarter","description":"Use this template to build a marketing plan by quarters."},"content-plan":{"title":"Control And Lead Your Work","description":"Use this template to take everything inside your head to a table where you can visualize all parts and manage tasks."},"integrations":{"title":"Add More Than Just A Link","description":"You can integrate other tools on your page to keep them all in one place and automatically updated."},"google-drive":{"title":"Drive Your Files From Google Drive","description":"You can connect your Google Drive account and insert links to your drive files for quick access."},"google-sheets":{"title":"Minus Google Sheet Tab","description":"Keep your data in one place with other project details to draw conclusions more easily."},"bookmark":{"title":"Mark Your Link With A New Look","description":"Use a bookmark to show the title of your link, a small description and a preview picture of the website."},"audioRec":{"title":"Say It, Don\'t Write it","description":"Add a human touch to your collaboration, recording voice feedback to the content on your page."},"videoRec":{"title":"Show it, Don\'t Write It","description":"Record a visual explanation of what should be done or give explicit feedback with a video example."},"button":{"title":"Came, Saw, Clicked","description":"Add a CTA element that will drag attention to important links on your pages."},"largeheading-toggle":{"title":"Hide More In A Large-Sized Collapsible Heading","description":"Define the most vital part of your page and hide information there for easy access."},"mediumheading-toggle":{"title":"Make Your Sections Shorter","description":"Create sections with a middle-sized collapsible heading and hide part of your content there."},"smallheading-toggle":{"title":"Make Your Subsections Shorter","description":"Create subsections with a small-sized collapsible heading on your pages and hide additional information there."},"database-with-options":{"title":"Oh How The Tables Have Turned","description":"Create a database for your project and customize it by selecting different types of columns and rows, changing background color and more."},"board":{"title":"Welcome Your Tasks On a Board","description":"Display tasks as cards on a Kanban board to get a bird’s eye view."},"progress":{"title":"See How Far You\'ve Come!","description":"Choose your value and estimate it. Rate and comment on your added content, tasks or other activities."},"uploader":{"title":"Say Goodbye to the File Mess!","description":"Clarify what files your clients and/or team need to send. With the file uploader, you can get what you want and keep it all in one place."},"dropdown-list":{"title":"Drop Your Options","description":"Place answer options anywhere in the text & let others give instant feedback."},"use-ai":{"title":"Work Smart, Not Hard","description":"Use AI to create and improve your content, get new ideas, and make personalized recommendations. Work with an AI assistant in your workspace."}},"feature_availability":{"plus":{"not-available":"Available for Plus & Team & Business plans","trial":"This is open as a trial Plus feature for you"},"team":{"not-available":"Available for Team & Business plans","trial":"This is open as a trial Team feature for you"},"business2023":{"not-available":"Available for Business plan","trial":"This is open as a trial Business feature for you"}}}');
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/i18n/messages/tr.json
const tr_namespaceObject = JSON.parse('{"table":{"common":{"column":"Sütun"},"move_column_cant_split_merged_cells":{"title":"Sütun taşınamıyor.","text":"Sütunlar Birleştirilmiş bir hücre içine taşınamaz. Birleştirmeyi iptal edip tekrar deneyiniz."},"move_column_cant_move_part_of_merged_cells":{"title":"Sütun taşınamıyor.","text":"Sütun birleştirilmiş bir hücrenin parçasını içermekte. Sütun\'u taşımak için hücreden ayırın."},"move_column_failed":{"title":"Sütun taşınamıyor.","text":"Sütun taşınırken beklenmeyen bir hata oluştu. Lütfen tekrar deneyiniz."},"move_row_cant_split_merged_cells":{"title":"Satır Taşınamıyor!","text":"Satırlar Birleştirilmiş bir hücre içine taşınamaz. Birleştirmeyi iptal edip tekrar deneyiniz."},"move_row_cant_move_part_of_merged_cells":{"title":"Satır Taşınamıyor!","text":"Satırlar birleştirilmiş bir hücrenin parçasını içermekte. Satırı taşımak için hücreden ayırın."},"move_row_cant_move_in_sortable_table":{"title":"Satır Taşınamıyor!","text":"Sıralanabilir bir tablodaki satır taşınamaz. Sıralamayı İptal Edip Tekrar Deneyiniz"},"move_row_cant_move_in_filtered_table":{"title":"Unable to move row","text":"Cannot move a row in a filtered table. Cancel filter then try again."},"move_row_failed":{"title":"Satır Taşınamıyor!","text":"Satır taşınırken beklenmeyen bir hata oluştu. Lütfen tekrar deneyiniz."},"first_move_column_or_row_message":"You can select multiple rows or columns by holding down the CTRL button and clicking on the desired rows or columns.","menu":{"delete":"Sil","help":"Yardım","delete_column":{"one":"Sütunu Sil","many":"{{count}} Sütunu Sil"},"delete_row":{"one":"Satırı Sil","many":"{{count}} Satırı Sil"},"add":"Ekle","add_row_before":{"one":"Yukarı Satır","many":"{{count}} Yukarı Satır"},"add_row_after":{"one":"Aşağı Satır","many":"{{count}} Aşağı Satır"},"add_col_before":{"one":"Sol Sutun","many":"{{count}} Sol Sütun"},"add_col_after":{"one":"Sağ Sütun","many":"{{count}} Sağ Sütun"},"copy_cell":{"one":"Hücreyi Kopyala","many":"Hücreleri Kopyala"},"copy_table":"Tabloyu Kopyala","table_layout":{"name":"Tablo Düzeni","column_headings":"Sütun Başlıkları","row_headings":"Satır Başlıkları"},"import_csv":"Import from CSV","merge_cells":"Hücreleri Birleştir","insert_checkbox":"Onay Kutusu Ekle","background_color":"Arkaplan Rengi","formatting":"Biçimlendir","clear":"Açık","reset":"Sıfırla","divide_cells":"Birleştirilmiş Hücreleri Ayır","type":{"name_cell":"Hücre Tipi","name_cells":"Hücrelerin Tipi","name_column":"Sütun Tipi","name_columns":"Sütunların Tipi","type_cell":{"one":"Hücre Tipi","many":"Hücrelerin Tipi"},"type_col":{"one":"Sutun Tipi","many":"Sutunların Tipi"},"same_as_column":"Sütunlar Aynı","reset_cells":"Hücreleri Varsayılana Döndür","none":"Çoklu Tip","text":"Metin","textline":"Metin","number":"Numara","attachment":"Ek Dosya","checkbox":"Onay Kutusu","multiselect":"Çoklu Seçim","singleselect":"Tek Seçim","collaborator":"Ortak Alan","currency":"Para Birimi","date":"Tarih","link":"Link","rating":"Değerlendirme","progress":"İlerleme","mention":"Bahsetme"},"number_format":{"name":"Sayı Formatları","number":"Sayılar","commas":"Virgül İçeren Sayılar","percent":"Yüzde"},"currency_format":{"name":"Para Tipleri","dollar":"Dollar","euro":"Euro","yen":"Yen","yuan":"Yuan","rouble":"Rouble","pound":"Pound","rupee":"Rupee","hryvnia":"Hryvnia","won":"Won","frank":"Frank","real":"Gerçek","other":"Diğer","stick":"Sembol göster","before":"Önce","after":"Sonra"},"decimal_format":{"name":"Decimal separator","comma":"Comma","point":"Point","hint":"The separator is used for decimal places. Comma decimal separators will look like 1.000,99, and point separators look like 1,000.99"},"progress_format":{"name":"İlerleme Seçenekleri","simple":"Basit","colored":"Renk","start_from":"Şuradan Başla(0-100)","default_amount":"Varsayılan Miktar (0-100)"},"rating_format":{"name":"Değerlendirme Seçenekleri","star":"Yıldız","flag":"Bayrak","heart":"Kalp","amount":"Tutar (1-10)"},"date_format":{"name":"Tarih / Saat Biçimi"},"mention_panel":{"open":"Aç","edit":"Düzenle","clear":"Temizle"},"color_numbers":{"name":"Color numbers","enable":"Enable color numbers"},"filter":"Filter","comment":"Yorum"},"formatting_menu":{"align_left":"Sol","align_center":"Orta","align_right":"Alt","valign_top":"Üst","valign_center":"Orta","valign_bottom":"Alt","text":"Metin","text_align":"Metni Hizala","text_color":"Metin Rengi","bold":"Kalın","italic":"İtalik","strikethrough":"Üstü Çizili","underline":"Altı Çizili"},"col_menu":{"add_column_after":{"one":"Sağa sütun ekle","many":"Sağa {{count}} Sütun Ekle"},"add_column_before":{"one":"Sola sütun ekle","many":"Sola {{count}} Sütun Ekle"},"duplicate_column":{"one":"Sutunu Kopyala","many":"Sutunları Kopyala"},"rename":"Adını Değiştir"},"row_menu":{"add_row_after":{"one":"Aşağı satır ekle","many":"Aşağıya {{count}} satır ekle"},"add_row_before":{"one":"Yukarıya satır ekle","many":"Yukarıya {{count}} satır ekle"}},"warning":{"merge_different":"Farklı nesne türleri birleştirilemez","convert_merged":"Birleştirilmiş hücreler dönüştürülemiyor"},"select":{"create_list":"Liste oluşturmak için tıkla","create_item":"Bir öğe oluştur","create_option":"Bir seçenek oluştur","create_label":"Etiket oluşturmak için yazın","create":"Oluştur","delete":"Sil"},"attachment":{"upload_more":"Dosya(lar) yükleniyor","downloading":"Yükleniyor"},"collaborator":{"placeholder":"kişi eklemek için tıkla","no_result":"Sonuç yok","loading":"Yükleniyor...","unknown":"bilinmeyen kişi"},"checkbox":{"checked":"Evet","not_checked":"Hayır"},"sorting":{"name":"Sıralama","sort":"Sırala","disable":"Sıralamayı sil","change":"Değiştirmek için tıkla","asc":{"common":"Artan","text":"Sırala A-Z","number":"Sırala 1-9","checkbox":"Önce seçilmemiş"},"desc":{"common":"Azalan","text":"Sırala Z-A","number":"Sırala 9-1","checkbox":"Önce seçilmiş"},"warning":{"column_merged":{"title":"Sütunu sıralayamıyor","text":"Birleştirilmiş satırlara sahip tablo sıralanamıyor"},"table_rowspan":{"title":"Sütunu sıralayamıyor","text":"Birleştirilmiş satırlara sahip tablo sıralanamıyor"},"merge":{"title":"Cells cannot be merged","text":"Cells cannot be merged while column sorting is active. Disable sorting and try again."},"different_currencies":{"title":"Sıralama uyarısı","text":"Bir sütunda farklı para birimleri kullanıyorsunuz. Sıralama yanlış olabilir."}},"exit_dialog":{"title":"Sıralamayı kaldır","toggle":"Sıralamayı bırak","text_keep":"Sıralama kalsın","text_no_keep":"Sütun sırası, sıralama uygulanmadan önce baştaki sırasına geri yüklenecektir","apply":"Uygula"}},"filter":{"by_field":"Filter by this field","empty_table":"All records are filtered","popup_title":"In this table, show records","empty_filters":"No conditions are applied to this database","where":"Where","or":"Or","and":"And","add_condition":"Add condition","clear_all":"Clear all","contains":"contains","is":"is","is_not":"is not","contains_not":"contains not","has_any_of":"has any of","has_none_of":"has none of","empty":"empty","not_empty":"not empty","filetype":"filetype","select_users_placeholder":"Select users","type_text_placeholder":"Type text","type_text_or_select_placeholder":"Type text or select","type_number_placeholder":"Type number","select_type_placeholder":"Select type","select_date_placeholder":"Select date","date":{"today":"Today","yesterday":"Yesterday","tomorrow":"Tomorrow","custom":"Custom"},"filetypes":{"images":"Images","documents":"Documents","media":"Media","other":"Other"},"warning":{"cells_merged":{"title":"Unable to filter table","text":"Can\'t filter column with merged cells"},"merge":{"title":"Cells cannot be merged","text":"Cells cannot be merged while table filter is active. Disable filter and try again."},"column_multitype":{"title":"Unable to filter table","text":"There is no such possibility to filter columns with Multi type. Please, try to convert to another type and try again."},"table_not_have_typed_columns":{"title":"Unable to filter table","text":"No columns available for filtering."}},"enable_filter":"Enable filter","disable_filter":"Disable filter"},"wrap_cells":{"layout_menu":"Hücreleri birleştir","warnings":{"merge":{"title":"Satırları birleştiremiyor","text":"Nowrap modunda hücreler birleştirilemiyor"},"toggle":{"title":"Seçenek değiştirilemiyor","text":"Tablo birleştirilmiş hücreler içeriyor"}}},"duplicate_column":{"title":"Sütunu çoğalt","text_1":"Sütunun içeriğini çoğalt","text_2":"Veri içeren sütunun tamamını çoğaltabilir veya çoğaltılan sütunu boş bırakabilirsiniz","accept":"Çoğalt","copy":"Kopyala"},"convert_column":{"title":"Sütün türünü diğiştir","text_before":"Bu sütun değerler içerir. Sütun türünü değiştirmek bazı değerleri silecektir","text_cmd":"Geri al","text_after":"Gerekirse değişiklikleri geri alma emrini verebilirsiniz","accept":"Türü değiştir"},"merge_cells_with_comments":{"title":"Merging cells","text":"The cells will be merged from left to right and the new cell will show a comment from the left cell.","accept":"Merge"},"summary":{"layout_menu":"Hesaplama çubuğunu göster","name":{"none":"Hiçbiri","all":"Tümü","empty":"Boşalt","fill":"Dolu","unique":"Benzersiz","empty_percent":"Boş yüzde","fill_percent":"Yüzde doldur","unique_percent":"Benzersiz yüzde","sum":"Toplam","average":"Ortalama","min":"Minimum","max":"Maksimum","median":"Orta değer","min_date":"En erken tarih","max_date":"En geç tarih","range_days":"Tarih Aralığı (gün)","range_month":"Tarih aralıgı (ay)","checked":"Kontrol edilmiş","unchecked":"Kontrol edilmemiş","checked_percent":"İşaretlenmiş yüzde","unchecked_percent":"İşaretlenmemiş yüzde","filter_rating":"Derecelendirme ile:","filter_progress":"İlerleme ile:","filesize_min":"Minimum hacim","filesize_max":"Maksimum hacim"},"item":{"none":"Hesapla","min_date":"En erken","max_date":"En geç","range_days":"Aralık (gün)","range_month":"Mesafe (ay)","checked_percent":"Kontrol edildi","unchecked_percent":"Kontrol edilmedi","filter_rating":"Aralıkta","filter_progress":"Gelişmekte"}},"comments":{"tooltip":{"one":"Comment","more":"Comments"}}},"file":{"image_viewer":{"could_not_load_image":"Fotoğraf yüklenemiyor"},"download_file":"Yükle {{isim}}","listen_file":"Oynat {{name}}","stop_file":"Durdur {{name}}","uploading":"Yükleniyor","wrtc":{"how_to_fix":"Nasıl düzeltilir?","how_to_url":"https://nimbusweb.me/s/share/5441210/4qccr41slk6wsw61h5fb","how_to_url2":"https://nimbusweb.me/s/share/5607239/l55bgak2ivs9bfptruka#b1995924032_670","rec_err_au":"Kayıt hatası. Mikrofon erişimi yok.","rec_err_vi":"Kayıt hatası. Mikrofona/web kamerasına erişim yok. ","allow_micro":"Mikrofona Erişim İzni Ver","allow_media":"Kaydetmek istediğiniz pencereyi seçin","select_opt":"Ne kaydedilecek","screenonly":"Yalnızca ekran","camonly":"Yalnızca kamera","screencam":"Ekran + Kamera","enable_micro":"Mikrofonu etkinleştir","startRecording":"Kaydı başlat","stopRecording":"Kaydı durdur","pauseRecording":"Kaydı duraklat","resumeRecording":"Kaydı devam ettir","cancelRecording":"Kaydı iptal et","confirmCancel":"Video kaydını iptal etmek istediğinizden emin misiniz?","cancel":"İptal","prepareUpload":"Lütfen bekleyin, kayıt yüklemeye hazırlanıyor","hasTmpRecord":"Kayıt kesintiye uğradı ancak kaybolmadı","restore":"Geri yükle","delete":"Sil","recordOnAnotherDevice":"Başka bir cihazda kayıt yapılıyor ..."},"menu":{"enabled":"Etkin","disabled":"Devre dışı","open_in_new_tab":"Yeni sekmede aç","copy_link":"Linki dosyaya kopyala","expand_in_full_window":"Tüm ekrenda göster","autoplay":"Otomatik oynat","sound_default":"Varsayılan olarak ses","sound_loop":"Döngü","sound_hideControls":"Kontrolleri gizle","sound_showPanel":"Show top panel","shadow_video":"Video için gölge","video_params":"Video ayarları","disallow_download":"İndiriliyor","for_note":"Çalışma alanları kullanıcıları için","for_share":"Herkese açık sayfa","motion_video":"Hareketli video","preview_video":"Change preview","preview_video_btn":"Preview","print":"Yazdır","convert_to_image":"Fotoğrafa dönüştür","convert_to_file":"Convert to file","style":"Stil","shadow_image":"Resim için gölge","rename":"Yeniden adlandır","replace":"Yerine koy","delete":"Sil","download":"Yükle","get_text_from_image":"Fotoğraftan yazı çıkar","view_as":"Farklı görüntüle","single_page":"Tek sayfa","all_pages":"Tüm sayfalar","cta_motion_video_message":"CTA is enabled for videos. You cannot use CTA and Motion video at the same time. Disable CTA and try enabling Motion video again.","cta_loop_message":"CTA is enabled for videos. You cannot use CTA and Loop at the same time. Disable CTA and try enabling Loop again.","grid":"Grid","cta_drop_in_grid":"CTA is enabled for videos. We recommend checking the correctness of the CTA display after transferring the video into a grid column.","cta_exists_in_grid":"The grid column has a video with an active CTA. Please check if it is correct after the transfer."},"downloading":"yükleniyor","attachment_not_found_error":"Yüklenirken bir hata oluştu","pdf_viewer":{"initializing_full_window_view":"Tam Pencere görünümünü başlatma","preparing_document_for_printing":"Dosya yazdırılımak için hazırlanıyor...","printing_initialization":"Baskı başlatma...","abort":"iptal et","set_page_as_default":"Sayfayı varsayılan olarak ayarla","unset_page_as_default":"Varsayılan sayfa. Sayfayı normal yapmak için tıklayın."},"video_just_uploaded_codec_error":"{codec} codec bileşeniyle kodlanmış bir video yüklemeye çalışıyorsunuz. Bu videonun tüm tarayıcılarda doğru oynatılacağını garanti etmiyoruz. Videoyu başka bir biçime dönüştürmenizi ve yeniden yüklemenizi öneririz.","video_codec_error":"Bu video, tarayıcınızda desteklenmeyen {codec} codec bileşeniyle kodlanmıştır.","safari_webm_not_support":"Şu anda Safari tarayıcıları WEBM biçimini desteklememektedir. Notu Google Chrome veya Mozilla Firefox gibi başka bir tarayıcıda açmayı deneyin.","video_transcribe":"Transcribe","video_summary":"Summary","video_meeting_notes":"Meeting Notes","video_ask_ai":"Ask AI"},"image":{"text_from_image_popup":{"title":"Fotoğraftan yazı","no_text":"Yazı yok","copy":"Tüm metni kopyala"},"unknown_error":"Hatalı link","add_image":"Fotoğraf linkini yapıştır ya da ","add_image_or":"ya da","add_image_small":"Yapıştır ya da ","browse":"Göz at","browse_image":"Resme göz atın","too_large_error":"Görüntü boyutu çok büyük","image_info_dialog":{"title":"Resim bilgisi","type":"Tür","size":"Hacim","location":"Konum","copy_link":"Link kopyala"},"rotate_wait":{"full":"Lütfen bekleyin","medium":"Bekleyin"},"attachment_not_found_error":"Görüntüde beklenmeyen bir hata oluştu","readonly_placeholder":"Boş fotoğraf","unsplash":{"name":"Unsplash","header":"Search image","placeholder":"Search for an image","search":"Search","description":"Search to find more results.","no_result":"No images found.","caption_preffix":"Photo by"},"comments":"Comments"},"attachment":{"unknown_error":"Yanlış giden bir şey var, başka dosya seçmeyi dene","attachment_is_being_uploaded":"dosya yüleniyor...","attachment_will_be_downloaded_online":"Çeivirimiçi olduğunda bu dosya yüklenecek.","attachment_preview_is_not_available":"Önizleme mevcut değil.","choose_a_file":"Dosyaları seç","wait_resolving_without_info":"Please wait..."},"video":{"player":{"play":"Oynat","pause":"Durdur","volume":"Ses","fullscreen_on":"Tam ekren","fullscreen_off":"Tam ekrenden çık","watch_again":"Tekrar izle"}},"search":{"placeholder":"Notta bul","matches":"Eşleşmeler:"},"copy":{"copied":"Kopyalandı!","copy_to_clipboard":"Panoya kopyala"},"apply":"Uygula","done":"Tamam","block_menu":{"align":{"left":"Sola hizala","center":"Ortaya hizala","right":"Sağa hizala","justify":"Doğrula"},"indent":{"indent":"Girintiyi artır","outdent":"Girintiyi azalt"},"tooltip":"Taşımak için sürükleyin\\n<span>Menude açmak için tıkla</span>","copy_tooltip":"Linki kopyala","color":{"background_color":"Arkaplan rengi","color":"Renk","line_color":"Satır rengi","line_type":"Satır türü","player_color":"Oyuncunun rengi"},"line_type":{"default":"Standart Satır","dotted":"Nokta"},"add":{"name":"Engel ekle","above":"Üst","below":"Alt","left":"Sol","right":"Sağ","above_column":"Above column","below_column":"Under column"},"convert_to":{"name":"\'ya dönüştür","to_do_list":"Checklist","number_list":"Numara listesi","bullet_list":"Bullet List","paragraph":"Paragraf","large_heading":"Büyük Başlık","medium_heading":"Orta Başlık","small_heading":"Küçük başlık","large_heading_toggle":"Collapsible Large Heading","medium_heading_toggle":"Collapsible Medium Heading","small_heading_toggle":"Collapsible Small Heading","code":"Kod","quote":"Alıntı","hint":"İpucu","image":"Fotoğraf","file":"Dosya","remote_frame":"Yerleştir","link":"Link","bookmark":"Yer imi","button":"Buton","toggle":"Geçiş Bloğu","step":"Steps"},"comment_block":"Yorum","edit":"Düzenle","duplicate":"Çiftle","copy_block":"Bloğu kopyala","copy_blocks":"Blokları kopyala","copy_link":"Linki kopyala","delete":"Sil","replace":"Yerine yerleştir","blot_lock":"Bloğu kilitle","blot_unlock":"Blok kilidini aç","set_as_preview":"Önizleme olarak ayarla","get_text_from_image":"Fotoğraftan yazıyı çıkar","edit_image":"Fotoğrafı düzenle","download":"İndir","view_full_size":"Tam boyutu gör","open_in_new_tab":"Yeni sekmede aç","image_info":"Fotoğraf bilgileri","rotate_image":"Dönüştür","add_sub_task":"Alt görev ekle","add_sub_text":"Alt metin ekle","layout":"Düzen","embed_align":{"left":"Sola hizala","center":"Ortaya hizala","right":"Sağa hizala","default":"Varsayılan boyut","full_width":"Tam genişlik"},"expand_all":"Tümünü genişlet","collapse_all":"Tümünü daralt","add_caption":"Alt yazı ekle","blot_locked_admin":"Bloğun düzenlenmesi reddedildi. Kilidi açmak için tıklayın.","blot_locked_admins":"Blokların düzenlenmesi reddedildi. Kilidi açmak için tıklayın.","blot_locked_user":"Bu bloğu düzenleme izniniz yok. Kuruluş yöneticinizle iletişime geçin.","show_header":"Üst çubuğu göster","show_borders":"Kenarlıkları göster","rename":"Yeniden adlandır"},"convert_menu_groups":{"suggestions":"Suggestions","basic":"Basic","advanced":"Advanced","media":"Media","embed":"Embed","views":"Views","templates":"Templates","helpful_links":"Helpful links"},"embedded_menu":{"start_typing":"\\"/\\" yaz yada ekle","start_typing_full":"Start writing or type \\"/\\", \\"@\\"","more_items":"Daha fazla öğe...","add_an_element":"Öğe ekle","paragraph":"Paragraf","todo":"Checklist","numbered_list":"Numara listesi","bullet_list":"Madde listesi","table":"Ta,ü","image":"fotoğraf","file":"Dosya","audioRec":"Ses Kaydı","videoRec":"Video Kaydı","recordExist":"Bir önceki kayıt tamamlanana kadar yeni bir kayıt başlatamazsınız. Yeni bir kayıt başlatmak için önceki kaydı sonlandırın veya silin.","large_heading":"Büyük Başlık","medium_heading":"Orta Başlık","small_heading":"Küçük başlık","large_heading_toggle":"Collapsible Large Heading","medium_heading_toggle":"Collapsible Medium Heading","small_heading_toggle":"Collapsible Small Heading","section_break":"Bölüm ayırıcı","link":"Link","code":"Kod","quote":"Alıntı","hint":"İpucu","hint_placeholder":"Birşeyler yaz","mention":"Mention member","outline":"Anahat","remote_frame":"Yerleştir","integrations":"Integrations","google_drive":"Google Drive","google_sheets":"Google sheets","html":"HTML","toggle":"Aç/Kapat Bloğu","tasks_list":"Task list","lock_blot":"Lock block","link_page":"Link page / Create","date":"Date","more_integrations":"more integrations","two_columns":"2 columns","meeting_notes":"Meeting notes","marketing_brief":"Marketing Brief","content_plan":"Content plan","more_templates":"more templates","get_feedback":"Get a feedback","contact_support":"Contact support","learn_nimbus":"Learn Nimbus","footer_top":"Did you know? You can start typing to search the list","footer_bottom":"Can’t find smth you want?","footer_link":"Tell us","add_note":"New page","database_with_options":"Database","board":"Kanban / Task Board","progress":"Progress","dropdown_list":"Dropdown list","uploader":"File uploader","use_ai":"Use Fusebase AI","helper":"AI helper","summarize":"Summarize","explain":"Explain","improve":"Improve","spelling":"Fix spelling and grammar","cta":"Call to actions","shorter":"Make shorter","longer":"Make longer","step":"Steps"},"button":{"title":"Başlık","id_info_tooltip":"Bu kimlik gelecekte CSS dosyasını düzenlerken kullanılabilir.","address":"URL yada E-posta","open_in_new_tab":"Yeni sekmede aç","shape":"Buton şekli","background":"Arkaplan","size":"Buton boyutu","small":"Küçük","medium":"Orta","big":"Büyük","cancel":"İptal et","done":"Tamamlandı","length_error":"Metin, düğme için çok büyük. Daha az metin seçmeyi deneyin (en fazla 50 karakter).","type":"Buton tipi","default":"Varsayılan","withShadow":"Gölgeli Buton","3d":"3d buton","convert":{"popup_title":"Butona dönüştür"}},"link":{"open":"Aç","send":"Gönder","copy":"Kopyala","edit":"Değiştir","remove":"Kaldır","text_label":"Metin","url_label":"Link","email_label":"Adres","copied":"Link panoya kopyalandı","cancel":"İptal et","done":"Tamamlandı"},"syntax":{"menu":{"language":"Dil","theme":"Theme","wrap":"Sarmayı etkinleştir","unwrap":"Sarmayı iptal et","lineNumbersOn":"Satır numaralarını göster","lineNumbersOff":"Satır numaralarını gizle"},"convert":{"popup_title":"Koda Dönüştür","blots_have_comments":"Metin içerisinde dönüştürme sırasında silinecek yorumlar var.","text_has_inline_comments":"Metnin içerisinde dönüştürme sırasında silinecek yorumlar var.","confirm":"Dönüştür"}},"list":{"list_style":"Liste stili","type_default":"Varsayılan","type_rectangle":"Dikdörtgen","type_star":"Başlat","type_dart":"Dart","type_rounded":"Yuvarlak","type_arrow":"Ok","type_diamond":"Elmas"},"caption":{"placeholder":"Altyazı ekle"},"mention":{"show_all":"Tümünü göster","show_all_users":"Tümünü göster","placeholder":"En son oluşturulanlar gösteriliyor yada aramak için birşeyler yazın","user":"Kişiler","workspace":"Çalışma alanı","folder":"Klasörler","note":"Nolar","no_results":"Sonuç yok","offline_message":"Bahsetme yalnızca aktif bağlantı ile çalışır. İnterneti açın ve tekrar deneyin.","info":{"note":{"one":"not","some":"not","many":"not"},"subfolder":{"one":"Alt dosya","some":"Alt dosya","many":"Alt dosya"},"member":{"one":"Üye","some":"Üye","many":"Üye"},"owner":"sahip","loading":"Önizleme yükleniyor...","loading_failed":"Yükleme başarısız oldu","not_loaded":"Not henüz yüklenmedi"},"back_button":"Geri dön","create_note_for":"Not Oluştur:","create_folder_for":"Klasör oluştur:"},"calendar":{"ui":{"date":"Tarih","am":"sabah","pm":"öğleden sonra","date_format":"Tarih formatı","show_time":"Zamanı göster","time_format":"Zaman formatı","time_12":"12S","time_24":"24S","first_week_day":"Haftanın ilk günü","time_zone":"Saat dilimi","use_gmt":"Bütün üyeler için GMT kullan","use_gmt_hint":"Tüm ortak çalışanlar için aynı saat dilimini (GMT) kullanın","table":{"clear":"Temizle"},"inline":{"clear":"Temizle"},"reminder":{"name":"Uyarı","panel_name":"Uyarı","push_name":"Olay için hatırlatıcı","remove_confirm_message":"Zamana bağlı uyarılarınız var. Bu hatırlatıcıları silmek istiyor musunuz?","remove_confirm_text":"Sil","remove_cancel_text":"Hatırlatıcıları silme","before_period":"","after_period":"Önce","period":{"m":{"one":"dakika","many":"dakika"},"h":{"one":"saat","many":"saat"},"d":{"one":"gün","many":"gün"},"w":{"one":"hafta","many":"hafta"}},"value":{"none":"Hiçbiri","0m":"Başlangıçta","1m":"1 dakika önce","5m":"5 dakika önce","10m":"10 dakika önce","15m":"15 dakika önce","30m":"30 dakika önc","1h":"1 saat öcce","2h":"2 saat öcce","1d":"1 gün önce","2d":"2 gün önce","7d":"7 gün önce","10d":"10 gün önce","14d":"14 gün önce","custom":"Özel"},"until":{"in":"--","d":"g","h":"s","m":"dk","already_been":"oldu","less_minute":"Bir dakikadan az","now":"Şimdi"}},"postfix":{"day":"g","month":"a"}},"insert":{"category_name":"Tarih","custom":"Özel","now":"Şimdi","today":"Bugün","tomorrow":"Yarın"},"date_format":{"ddmmyyyy":"gg/aa/yyyy","mmddyyyy":"aa/gg/yyyy","yyyyddmm":"yyyy/aa/gg","monthddyyyy":"Ay gg, yyyy","default":"Tarayıcı formatını eşleştir"},"months":{"0":"Ocak","1":"Şubat","2":"Mart","3":"Nisan","4":"Mayıs","5":"Haziran","6":"Temmuz","7":"Ağustos","8":"Eylül","9":"Ekim","10":"Kasım","11":"Aralık"},"days":{"short":{"0":"Pa","1":"Pt","2":"Sa","3":"Ça","4":"Pe","5":"Cu","6":"Ct"},"full":{"0":"Pazar","1":"Pazartesi","2":"Salı","3":"Çarşamba","4":"Perşembe","5":"Cuma","6":"Cumartesi"}}},"content_not_supported":"FuseBase uygulaması sürümünüzde desteklenmiyor. Güncellemeyi deneyin veya en son sürüme sahip başka bir istemci kullanın.","profession_ask":{"title":"Yeni notlar oluşturmak için şablonları kullanarak zaman kazanın","text":"Mesleğinizi yazın, ekibimiz sizin için şablonlar oluştursun. Ücretsizdir ve hiçbir gizli ücreti yoktur","i_am_a":"Ben bir:","placeholder":"Ör. tasarımcı, öğretmen, satış temsilcisi vb.","request_template":"Şablon iste","sucess_message":"Teşekkürler! Mesleğiniz kuyruğumuza eklenecek."},"bookmark":{"name":"Yer imi","edit":"Yer imini düzenle","title":"Başlık","address":"Adres","description":"Açıklama","placeholder":" https://... ile bir link yaz veya yapıştır","placeholder_mobile":"Bağlantıyı yapıştırın veya yazın","loading_preview":"Önizleme yükleniyor…","block_menu":{"change_mode":{"menu_name":"Görüntüle","mode_tile":"Tuğla","mode_card":"Kart","mode_cover":"Kapak"},"change_preview":"Önizlemeyi değiştir","delete_preview":"Önizlemeyi sil","reset_preview":"Önizlemeyi sıfırla","change_preview_background":"Önizleme için arka planı değiştir","options":{"menu_name":"Seçenekler","open_in_same_tab":"Aynı sekmede aç"}},"error":{"unknown_error":"Bir hata oluştu, lütfen başka bir URL girmeyi deneyin","preview_notfound":"Önizlemeler bulunamadı"},"upload":{"new_preview":"Yeni Yükle","quota_error":"Dosya izin verilen 3MB\'den daha büyük. Başka bir dosya deneyin.","unknown_error":"Bilinmeyen hata. Başka bir dosya deneyin."}},"businessCard":{"PERSON":"İsim","ORGANIZATION":"Şirket","TITLE":"Başlık","ADDRESS":"Adres","URL":"Site","PHONE":"Telefon","EMAIL":"Email","SKYPE":"Skype","TWITTER":"Twitter","INSTAGRAM":"Instagram","FACEBOOK":"Facebook","LINKEDIN":"LinkedIn","VK":"VK"},"dialog_common":{"button":{"ok":"Tamam","cancel":"İptal et"}},"outline":{"default_name":"Anahat","menu":{"expand":"Genişlet","collapse":"Daralt","rename":"Yeniden adlandır"},"context_menu":{"convert_to":{"text":"Yazı"},"style":{"name":"Anahat türü","list_only":"Sadece liste","numbered_list":"Numaralanmış liste","bordered":"Kenarlığı göster","border_color":"Kenar rengi"}},"empty":"Notunuza Başlıklar ekleyin, burada bağlantılar olarak görünecektir"},"floating_toolbar":{"bold":"Kalın","italic":"İtalik","underline":"Altı çizgili","strikethrough":"Üstü çizili","clear":"Formatı temizle","code":"Kod","button":"Buton","link":"Link","highlight":"Vurgulama","extraHighlight":"Metin etiketleri","color":"Renk","text":"Yazı","clear_all":"Hepsini temizle","placeholder":"Yer tutucu","adapts":{"dark":"Karanlık temaya uyumla","light":"Aydınlık temaya uyumla"},"create_note":"Not oluştur","add_comment":"Yorum ekle"},"remote_frame":{"placeholder_small":"URL yerleştir","placeholder_full":"YouTube, Github, Haritalar, Twitter vb. Gibi herhangi bir URL\'yi yerleştirin.","loading":"Yükleniyor...","context_menu":{"change_link":"Linki değiştir","full_size":"Tam hacim","reset_size":"Boyutu sıfırla","open_origin":"Orjinali aç","layout":"Düzen","show_toolbar":"Düzenleme araç çubuğunu göster","copy_original":"Copy link to original"},"error":{"is_not_link":"Yanlış link","content_error":"Aşağıdaki alan desteklenmiyor veya URL yanlış. Lütfen <a href=\\"https://nimbusweb.me/contact-us.php\\" target=\\"_blank\\">destek ekibimiz ile</a> iletişime geçin.","unknown_error":"Yanlışlık var, Başka URL gir","wrong_signature":"Bu içerik bozuk ve gosterilemez","google_docs_auth_error":"Erişiminiz olmadığı için büyük olasılıkla Google Dokümanlar / E-Tablolar / Slayt dosyasını yerleştiremezsiniz. <a href=\\"http://nimb.ws/EkX87M\\" target=\\"_blank\\">Lütfen kılavuzumuzu okuyun.</a>","internal_link_error":"{{serviceName}} has forbidden following internal links. Click on Back to return to the previous page."},"convert_bookmark":"Yer imine dönüştür","convert_link":"Linke dönüştür","back_button":"Geri dön"},"google_drive":{"block_name":"Google Drive","loading":"Yükleniyor...","menu":{"expand":"Genişlet","collapse":"Daralt","open_origin":"Google Drive\'da aç","download":"Yükle","change_account":"Hesabı değiştir","choose_another_file":"Başka dosya seç"},"last_modified":"En son {{userName}} tarafından {{time}} önce değiştirildi","browse":"Dosyada ara","login":"Google ile giriş yap","login_text":"Dosyalara göz atın ve Google Drive\'dan ekleyin"},"html":{"default_name":"HTML","loading":"Yükleniyor...","menu":{"open_source":"Ana linki aç","export_blot":"HTML\'i kaydet"},"unknown_error":"Bilinmeyen hata","device_cant_display_content":"Cihazınız bu içeriği gösteremiyor","wrong_signature":"Bu içerik bozuk ve gösterilemez"},"relative_time":{"seconds":{"one":"{{count}} saniye","some":"{{count}} saniye","many":"{{count}} saniye"},"minutes":{"one":"{{count}} Dakika","some":"{{count}} Dakika","many":"{{count}} Dakika"},"hours":{"one":"{{count}} Saat","some":"{{count}} Saat","many":"{{count}} Saat"},"days":{"one":"{{count}} Gün","some":"{{count}} Gün","many":"{{count}} Gün"},"months":{"one":"{{count}} Ay","some":"{{count}} Ay","many":"{{count}} Ay"},"years":{"one":"{{count}} Yıl","some":"{{count}} Yıl","many":"{{count}} Yıl"}},"collapsible_content":{"menu":{"expand":"Genişlet","collapse":"Daralt","rename":"Yeniden adlandır"}},"convert_link":{"url":"URL","title":"Başlık","embed":"Yerleştir","bookmark":"Yer imi","button":"Button","link_to_note":"Nota bağla","link_to_folder":"Dosyaya bağla","link_to_workspace":"Çalışma alanına bağla","convert_error":"URL dönüştürürken bir yanlışlık oldu"},"fullwidth":{"menu_item":"Tam genişlik"},"resizeable":{"point_tooltip":{"default":"Yeniden boyutlandır","bottom-right":"Yeniden boyutlandır\\n(ücretsiz yeniden boyutlandırma için {{altKey}} düğmesini basılı tutun)"}},"toggle":{"placeholder":"Bir blok oluşturmak veya taşımak için buraya tıklayın","expand":"Geçişi genişlet","collapse":"Geçişi daralt","expand_heading":"Expand heading","collapse_heading":"Collapse heading","expand_step":"Expand step","collapse_step":"Collapse step"},"step":{"content_placeholder":"Click here to create description to the step","title_placeholder":"Enter a short title to describe this step","aggregator_placeholder":"Enter a short descriptive title","menu":{"step_layout":{"name":"Layout","show_number":"Show number","show_arrow":"Show arrow","show_border":"Show border"}}},"tasks_list":{"not_supported":"Currently, we cannot display the task list as it is not supported in this type of pages.","menu":{"show_title":"Show task list name","view":"Default view","task_list_view":"Task list","calendar_view":"Calendar","kanban_view":"Kanban"}},"board":{"not_supported":"Currently, we cannot display the task board as it is not supported in this type of pages.","menu":{"add_new_column":"New column","board_layout":{"name":"Layout","show_add_new_column":"Show Add column"}}},"empty_features":{"use_template":"Use a template","import":"Import","add_database":"Add database","add_database_with_options":"Add database with options","add_board":"Kanban / Task Board","use_ai":"Use Fusebase AI","use_ai_agents":"Use AI Agents"},"ai_manager":{"generate_error":"Unfortunately, there are no results for your request. Please try another request.","unload_message":"Fusebase AI content is being generated. Are you sure you want to exit?","unknown_error":"Unknown error. Try again later or contact support.","dialog":{"title":"Discard draft","body":"Do you want to discard draft?","accept":"Yes, discard"}},"uploader":{"header":"Upload files","description":"Here, you can add some helpful information about file uploading","dropzone_full":"Drag file(s) here or","browse":"click to upload","dropzone_compact":"Add more files","uploading_progress":"Uploading {{progress}}%","uploading_files":"Uploading files","counter":"{{current}} of {{total}}","timer":"less than 1 minute remaining","header_placeholder":"Write a title, max {{maxChars}} characters","description_placeholder":"Write a description, max {{maxChars}} characters","errors":{"network":"Failed uploading file","too_big":"File is too big"},"menu":{"disallow_download":"Downloading","for_note":"For workspaces users","for_share":"Public page","convert_to_files":"Convert to files","allow_upload":"Uploading","enable_in_public_page":"Enable in public page"}},"convert_menu_tooltips":{"labels":{"management":"Great for knowledge management","collaboration":"Great for collaboration"},"paragraph":{"title":"Best for main content","description":"This is the main block for writing page content."},"todo":{"title":"A List For Small Tasks? Check!","description":"Write down small errands and routine tasks that need to be done."},"numberedlist":{"title":"Let\'s Line Up: One, Two, Three!","description":"Make your content easy-to-read and display it in a series."},"bulletlist":{"title":"Points Make Everything Clearer","description":"You can create a list that will stand out from other content."},"table":{"title":"Rejoice the Formatting","description":"Organize your information in a table to get a holistic view on your work."},"image":{"title":"We Need To See It — Add An Image","description":"Make your pages more attractive by adding pictures of any file type, moving them and resizing."},"file":{"title":"Files Here, Files There, Files Everywhere!","description":"Create a database for your project by adding files with different types of extensions to your page."},"largeheading":{"title":"Best for Primary Sections of Page","description":"This is the biggest heading you can add. Attract attention to the most vital part of your page and ease up your navigation."},"mediumheading":{"title":"Best for Secondary Section of Page","description":"This is a middle-size heading you can add. Divide your page into sections with it and easily find what you need."},"smallheading":{"title":"Best For Great Ideas In Subsections","description":"This is a small-size heading you can add, but still it stands out. Use it to divide your page into subsections."},"tasks-list":{"title":"Organize Your Work With Nimbus Tasks","description":"Here you can group your tasks in task lists. Assign tasks to your team members, set deadlines and add statuses for easy tracking."},"hline":{"title":"Let\'s Make A Break","description":"Separate different parts of a project or divide your examples and ideas for it."},"link":{"title":"Pave A Path with Links","description":"Whenever you\'ve got an idea for your project, add a link to it and name it."},"syntax":{"title":"Don\'t Forget About Code","description":"You can add code right on your page, switching between themes, languages and more!"},"link-page":{"title":"Your Next Stop Is Another Page","description":"Link another page connected to this project and easily access it right away."},"date":{"title":"Just Say When","description":"Set a deadline for your project or mark the precise time when you started to work on a page."},"mention":{"title":"Get Your Team Involved","description":"Your team members will get email notifications to open a particular page and collaborate there."},"blockquote":{"title":"And I Quote","description":"You can highlight important words from your clients or single out a motivational phrase."},"hint":{"title":"Let\'s Drop A Hint","description":"Choose an emoji and background color to highlight warnings, disclaimers or notifications on your page."},"toggle":{"title":"Hide & Seek Expand Text Block","description":"Sort and hide additional information on your pages for easier navigation and access."},"outline":{"title":"See What Awaits You On The Page","description":"Create a table of contents for easy navigation on long pages or wikis."},"lock-blot":{"title":"No One Can Edit It","description":"You can leave a particular information block on your page untouched and read-only."},"embed":{"title":"Add More Than Just A Link","description":"You can integrate other tools on your page to keep them all in one place and automatically updated."},"figma":{"title":"Keep Your Visuals Even Closer","description":"Add Figma to see how project visuals are designed in real time."},"miro":{"title":"Your Miro Board Is In A Safe Space","description":"Check a layout strategy or a road map for your project and work further on your page."},"columns":{"title":"Two columns are better than one","description":"Divide your page in two columns to add more content there and make your page look neater."},"meeting-notes":{"title":"Set Goals And Move Forward","description":"Use this template to build a marketing strategy and keep all details in one place."},"marketing-brief":{"title":"Dream Big, Plan Quarter By Quarter","description":"Use this template to build a marketing plan by quarters."},"content-plan":{"title":"Control And Lead Your Work","description":"Use this template to take everything inside your head to a table where you can visualize all parts and manage tasks."},"integrations":{"title":"Add More Than Just A Link","description":"You can integrate other tools on your page to keep them all in one place and automatically updated."},"google-drive":{"title":"Drive Your Files From Google Drive","description":"You can connect your Google Drive account and insert links to your drive files for quick access."},"google-sheets":{"title":"Minus Google Sheet Tab","description":"Keep your data in one place with other project details to draw conclusions more easily."},"bookmark":{"title":"Mark Your Link With A New Look","description":"Use a bookmark to show the title of your link, a small description and a preview picture of the website."},"audioRec":{"title":"Say It, Don\'t Write it","description":"Add a human touch to your collaboration, recording voice feedback to the content on your page."},"videoRec":{"title":"Show it, Don\'t Write It","description":"Record a visual explanation of what should be done or give explicit feedback with a video example."},"button":{"title":"Came, Saw, Clicked","description":"Add a CTA element that will drag attention to important links on your pages."},"largeheading-toggle":{"title":"Hide More In A Large-Sized Collapsible Heading","description":"Define the most vital part of your page and hide information there for easy access."},"mediumheading-toggle":{"title":"Make Your Sections Shorter","description":"Create sections with a middle-sized collapsible heading and hide part of your content there."},"smallheading-toggle":{"title":"Make Your Subsections Shorter","description":"Create subsections with a small-sized collapsible heading on your pages and hide additional information there."},"database-with-options":{"title":"Oh How The Tables Have Turned","description":"Create a database for your project and customize it by selecting different types of columns and rows, changing background color and more."},"board":{"title":"Welcome Your Tasks On a Board","description":"Display tasks as cards on a Kanban board to get a bird’s eye view."},"progress":{"title":"See How Far You\'ve Come!","description":"Choose your value and estimate it. Rate and comment on your added content, tasks or other activities."},"uploader":{"title":"Say Goodbye to the File Mess!","description":"Clarify what files your clients and/or team need to send. With the file uploader, you can get what you want and keep it all in one place."},"dropdown-list":{"title":"Drop Your Options","description":"Place answer options anywhere in the text & let others give instant feedback."},"use-ai":{"title":"Work Smart, Not Hard","description":"Use AI to create and improve your content, get new ideas, and make personalized recommendations. Work with an AI assistant in your workspace."}},"feature_availability":{"plus":{"not-available":"Available for Plus & Team & Business plans","trial":"This is open as a trial Plus feature for you"},"team":{"not-available":"Available for Team & Business plans","trial":"This is open as a trial Team feature for you"},"business2023":{"not-available":"Available for Business plan","trial":"This is open as a trial Business feature for you"}}}');
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/i18n/messages/ua.json
const ua_namespaceObject = JSON.parse('{"table":{"common":{"column":"Колонка"},"move_column_cant_split_merged_cells":{"title":"Неможливо перемістити колонку","text":"Не вдається перемістити колонку в об\'єднану клітинку. Від\'єднайте і спробуйте ще раз."},"move_column_cant_move_part_of_merged_cells":{"title":"Неможливо перемістити колонку","text":"Колонка, яку ви намагаєтеся перемістити, містить частину об\'єднаної клітинки. Якщо ви хочете перемістити колонку, спочатку роз\'єднайте клітинки."},"move_column_failed":{"title":"Неможливо перемістити колонку","text":"Виникла несподівана помилка під час переміщення колонки, будь ласка, спробуйте ще раз."},"move_row_cant_split_merged_cells":{"title":"Неможливо перемістити рядок","text":"Не вдається перемістити рядок в об\'єднану клітинку. Від\'єднайте і спробуйте ще раз."},"move_row_cant_move_part_of_merged_cells":{"title":"Неможливо перемістити рядок","text":"Рядок, який ви намагаєтеся перемістити, містить частину об\'єднаної клітинки. Якщо ви хочете перемістити рядок, спочатку роз\'єднайте клітинки."},"move_row_cant_move_in_sortable_table":{"title":"Неможливо перемістити рядок","text":"Не вдається перемістити рядок у відсортованій таблиці. Скасуйте сортування і повторіть спробу."},"move_row_cant_move_in_filtered_table":{"title":"Неможливо перемістити рядок","text":"Неможливо перемістити рядок у відфільтрованій таблиці. Скасуйте фільтр і повторіть спробу."},"move_row_failed":{"title":"Неможливо перемістити рядок","text":"Під час переміщення рядка сталася несподівана помилка, будь ласка, спробуйте ще раз."},"first_move_column_or_row_message":"Ви можете вибрати кілька рядків або колонок, утримуючи кнопку CTRL і клікаючи на потрібні рядки або колонки","menu":{"delete":"Видалити","help":"Допомогти","delete_column":{"one":"Видалити колонку","many":"Видалити {{count}} колонки"},"delete_row":{"one":"Видалити рядок","many":"Видалити {{count}} рядки"},"add":"Додати","add_row_before":{"one":"Рядок вище","many":"{{count}} Рядки вище"},"add_row_after":{"one":"Рядок нижче","many":"{{count}} рядки нижче"},"add_col_before":{"one":"Колонка зліва","many":"{{count}} колонки зліва"},"add_col_after":{"one":"Колонка справа","many":"{{count}} колонки справа"},"copy_cell":{"one":"Скопіювати клітинку","many":"Скопіювати клітинки"},"copy_table":"Скопіювати таблицю","table_layout":{"name":"Розмітка таблиці","column_headings":"Заголовки колонки","row_headings":"Заголовки рядків"},"import_csv":"Імпорт із CSV","merge_cells":"Об\'єднати клітинки","insert_checkbox":"Вставити вибіркове поле","background_color":"Фоновий колір","formatting":"Форматування","clear":"Очистити","reset":"Скинути","divide_cells":"Роз\'єднати клітинки","type":{"name_cell":"Тип клітинки","name_cells":"Тип клітинок","name_column":"Тип колонки","name_columns":"Тип колонок","type_cell":{"one":"Тип клітинки","many":"Тип клітинок"},"type_col":{"one":"Тип колонки","many":"Тип колонок"},"same_as_column":"Те саме, що колонка","reset_cells":"Скинути клітинки до значень за замовчуванням","none":"Багатофункціональний тип","text":"Текст","textline":"Текст","number":"Число","attachment":"Файли","checkbox":"Вибіркове поле","multiselect":"Кілька варіантів вибору","singleselect":"Один вибір","collaborator":"Відповідальний","currency":"Валюта","date":"Дата","link":"Посилання","rating":"Оцінка","progress":"Прогрес","mention":"Згадка"},"number_format":{"name":"Формат числа","number":"Число","commas":"Число з комами","percent":"Відсоток"},"currency_format":{"name":"Тип валюти","dollar":"Долар","euro":"Євро","yen":"Єна","yuan":"Юань","rouble":"Рубль","pound":"Фунт","rupee":"Рупія","hryvnia":"Гривня","won":"Вон","frank":"Франк","real":"Реал","other":"Інша","stick":"Показати символ","before":"До","after":"Після"},"decimal_format":{"name":"Роздільник десяткової частини","comma":"Кома","point":"Крапка","hint":"Роздільник використовується для десяткових знаків. Роздільники десяткових частин з комою виглядатимуть ось так 1000,99, а крапкові роздільники так 1000.99"},"progress_format":{"name":"Варіанти прогресу","simple":"Простий","colored":"Кольоровий","start_from":"Почати із(0-100)","default_amount":"Кількість за замовчуванням(0-100)"},"rating_format":{"name":"Варіанти оцінки","star":"Зірка","flag":"Прапорець","heart":"Сердечко","amount":"Кількість(1-10)"},"date_format":{"name":"Формат Дата/Час"},"mention_panel":{"open":"Відкрити","edit":"Редагувати","clear":"Очистити"},"color_numbers":{"name":"Кольорові номери","enable":"Увімкнути кольорові номери"},"filter":"Фільтр","comment":"Коментар"},"formatting_menu":{"align_left":"Зліва","align_center":"По центру","align_right":"Справа","valign_top":"Зверху","valign_center":"Посередині","valign_bottom":"Внизу","text":"Текст","text_align":"Вирівнювання тексту","text_color":"Колір тексту","bold":"Жирний","italic":"Курсив","strikethrough":"Закреслити","underline":"Підкреслити"},"col_menu":{"add_column_after":{"one":"Додати колонку справа","many":"Додати{{count}} колонок справа"},"add_column_before":{"one":"Додати колонку зліва","many":"Додати {{count}} колонок зліва"},"duplicate_column":{"one":"Дублювати колонку","many":"Дублювати колонки"},"rename":"Перейменувати"},"row_menu":{"add_row_after":{"one":"Додати рядок знизу","many":"Додати{{count}} рядки знизу"},"add_row_before":{"one":"Додати рядок зверху","many":"Додати {{count}} рядки зверху"}},"warning":{"merge_different":"Неможливо об\'єднати різні типи об\'єктів","convert_merged":"Не вдається перетворити об\'єднані клітинки"},"select":{"create_list":"Введіть текст, щоб створити список","create_item":"Введіть текст, щоб створити об\'єкт","create_option":"Введіть текст, щоб створити варіант","create_label":"Введіть текст","create":"Створити","delete":"Видалити"},"attachment":{"upload_more":"Завантажити файл(и)","downloading":"Скачати"},"collaborator":{"placeholder":"Введіть текст, щоб додати людей","no_result":"Немає результатів","loading":"Завантаження...","unknown":"Невідома особа"},"checkbox":{"checked":"Так","not_checked":"Ні"},"sorting":{"name":"Сортування","sort":"Сортувати","disable":"Прибрати сортування","change":"Клікніть, щоб змінити","asc":{"common":"За зростанням","text":"Сортувати від А до Я","number":"Сортувати від 1 до 9","checkbox":"Невибране спершу"},"desc":{"common":"За спаданням","text":"Сортувати від Я до А","number":"Сортувати від 9 до 1","checkbox":"Вибране спершу"},"warning":{"column_merged":{"title":"Неможливо відсортувати колонку","text":"Неможливо відсортувати колонку з об\'єднаними клітинками"},"table_rowspan":{"title":"Неможливо відсортувати колонку","text":"Не вдається відсортувати таблицю з об\'єднаними рядками"},"merge":{"title":"Клітинки не можна об\'єднати","text":"Неможливо об\'єднати клітинки, коли активне сортування у колонках. Вимкніть сортування і спробуйте ще раз."},"different_currencies":{"title":"Важливо!","text":"Ви використовуєте різні валюти в одній колонці. Сортування може бути некоректним."}},"exit_dialog":{"title":"Прибрати сортування","toggle":"Залишити сортування","text_keep":"Залишити сортування","text_no_keep":"Перед сортуванням порядок колонок буде відновлено до початкового","apply":"Застосувати"}},"filter":{"by_field":"Фільтрувати за цим полем","empty_table":"Всі записи відфільтровано","popup_title":"У цій таблиці показувати записи","empty_filters":"До цієї бази даних не застосовуються жодні умови","where":"Де","or":"Або","and":"І","add_condition":"Додати умову","clear_all":"Очистити все","contains":"містить","is":"є","is_not":"не є","contains_not":"містить не","has_any_of":"має деякі","has_none_of":"немає жодних","empty":"пустий","not_empty":"не пустий","filetype":"тип файлу","select_users_placeholder":"Вибрати користувачів","type_text_placeholder":"Ввести текст","type_text_or_select_placeholder":"Ввести текст або вибрати","type_number_placeholder":"Тип цифри","select_type_placeholder":"Вибрати тип","select_date_placeholder":"Вибрати дату","date":{"today":"Сьогодні","yesterday":"Вчора","tomorrow":"Завтра","custom":"Індивідуальний"},"filetypes":{"images":"Зображення","documents":"Документи","media":"Медіа","other":"Інше"},"warning":{"cells_merged":{"title":"Неможливо відфільтрувати таблицю","text":"Неможливо відфільтрувати колонку з об\'єднаними клітинками"},"merge":{"title":"Клітинки не можна об\'єднати","text":"Клітинки не можна об\'єднати, поки активний фільтр таблиці. Вимкніть фільтр і спробуйте ще раз."},"column_multitype":{"title":"Неможливо відфільтрувати таблицю","text":"Немає можливості фільтрувати стовпці з багатофункціональним типом. Будь ласка, спробуйте перетворити в інший тип і спробуйте ще раз."},"table_not_have_typed_columns":{"title":"Неможливо відфільтрувати таблицю","text":"Немає колонок для фільтрації."}},"enable_filter":"Увімкнути фільтр","disable_filter":"Вимкнути фільтр"},"wrap_cells":{"layout_menu":"Згорнути клітинки","warnings":{"merge":{"title":"Неможливо об\'єднати клітинки","text":"Неможливо об\'єднати клітинки в режимі незгортання"},"toggle":{"title":"Не вдається переключити опцію","text":"Таблиця містить об\'єднані клітинки"}}},"duplicate_column":{"title":"Дублювати колонку","text_1":"Дублювати вміст колонки","text_2":"Ви можете продублювати всю колонку з даними або залишити дублікат пустим","accept":"Дублювати","copy":"копіювати"},"convert_column":{"title":"Змінити тип колонки","text_before":"Ця колонка містить значення. Зміна типу колонки призведе до видалення деяких значень. Застосувати","text_cmd":"Скасувати","text_after":"команда для відміни змін, якщо потрібно.","accept":"Змінити тип"},"merge_cells_with_comments":{"title":"Merging cells","text":"The cells will be merged from left to right and the new cell will show a comment from the left cell.","accept":"Merge"},"summary":{"layout_menu":"Показати панель розрахунків","name":{"none":"Жодної","all":"Всі","empty":"Пусті","fill":"Заповнені","unique":"Унікальні","empty_percent":"Відсоток пустих","fill_percent":"Відсоток заповнених","unique_percent":"Відсоток унікальних","sum":"Сума","average":"Середнє","min":"Мін","max":"Макс","median":"Медіанне значення","min_date":"Найдавніша дата","max_date":"Найновіша дата","range_days":"Діапазон дат (дні)","range_month":"Діапазон дат (місяці)","checked":"Відмічено","unchecked":"Невідмічено","checked_percent":"Відсоток відмічених","unchecked_percent":"Відсоток невідмічених","filter_rating":"Із оцінкою:","filter_progress":"Із прогресом:","filesize_min":"Мін розмір","filesize_max":"Макс розмір"},"item":{"none":"Порахувати","min_date":"Найдавніша","max_date":"Найновіша","range_days":"Діапазон(день)","range_month":"Діапазон (місяць)","checked_percent":"Відмічено","unchecked_percent":"Невідмічено","filter_rating":"Із оцінкою","filter_progress":"Із прогресом"}},"comments":{"tooltip":{"one":"Comment","more":"Comments"}}},"file":{"image_viewer":{"could_not_load_image":"Неможливо завантажити зображення"},"download_file":"Скачати {{name}}","listen_file":"Грати {{name}}","stop_file":"Зупинити {{name}}","uploading":"Завантажити","wrtc":{"how_to_fix":"Як це виправити?","how_to_url":"https://nimbusweb.me/s/share/5441210/4qccr41slk6wsw61h5fb","how_to_url2":"https://nimbusweb.me/s/share/5607239/l55bgak2ivs9bfptruka#b1995924032_670","rec_err_au":"Помилка запису. Немає доступу до мікрофона.","rec_err_vi":"Помилка запису. Немає доступу до мікрофона/вебкамери. ","allow_micro":"Дозволити доступ до мікрофона","allow_media":"Виберіть вікно, яке хочете записати","select_opt":"Що буде записано","screenonly":"Тільки екран","camonly":"Тільки камера","screencam":"Екран + Камера","enable_micro":"Увімкнути мікрофон","startRecording":"Почати запис","stopRecording":"Зупинити запис","pauseRecording":"Призупинити запис","resumeRecording":"Продовжити запис","cancelRecording":"Скасувати запис","confirmCancel":"Ви впевнені, що хочете скасувати відеозапис?","cancel":"Скасувати","prepareUpload":"Будь ласка, зачекайте, запис готується до завантаження","hasTmpRecord":"Запис було перервано, але не втрачено","restore":"Відновити","delete":"Видалити","recordOnAnotherDevice":"Йде запис на іншому пристрої ..."},"menu":{"enabled":"Увімкнути","disabled":"Вимкнути","open_in_new_tab":"Відкрити у новій вкладці","copy_link":"Скопіювати посилання до файлу","expand_in_full_window":"Розгорнути у повному вікні","autoplay":"Автовідтворення","sound_default":"Звук за замовчуванням","sound_loop":"Цикл","sound_hideControls":"Сховати елементи керування","sound_showPanel":"Показати верхню панель","shadow_video":"Тінь для відео","video_params":"Налаштування відео","disallow_download":"Скачування","for_note":"Для користувачів просторів","for_share":"Зовнішня сторінка","motion_video":"Моушн відео","preview_video":"Змінити попередній перегляд","preview_video_btn":"Попередній перегляд","print":"Роздрукувати","convert_to_image":"Перетворити на зображення","convert_to_file":"Перетворити на файл","style":"Стиль","shadow_image":"Тінь для зображення","rename":"Перейменувати","replace":"Замінити","delete":"Видалити","download":"Скачати","get_text_from_image":"Отримати текст із зображення","view_as":"Переглянути як","single_page":"Одна сторінка","all_pages":"Всі сторінки","cta_motion_video_message":"Заклик до дії ввімкнено для відео. Ви не можете використовувати заклик до дії та моушн відео одночасно. Вимкніть заклик до дії і спробуйте ввімкнути моушн відео знову.","cta_loop_message":"Заклик до дії ввімкнено для відео. Ви не можете використовувати заклик до дії та цикл одночасно. Вимкніть заклик до дії і спробуйте ввімкнути цикл знову.","grid":"Сітка","cta_drop_in_grid":"Заклик до дії ввімкнено для відео. Рекомендуємо перевірити коректність відображення заклика до дії після перенесення відео в колонку сітки.","cta_exists_in_grid":"У колонці сітки є відео з активним закликом до дії. Будь ласка, перевірте його коректність після переходу."},"downloading":"Скачування","attachment_not_found_error":"Помилка під час завантаження","pdf_viewer":{"initializing_full_window_view":"Ініціалізація повноекранного перегляду","preparing_document_for_printing":"Підготовка документа до друку...","printing_initialization":"Ініціалізація друку...","abort":"перервати","set_page_as_default":"Установити сторінку за замовчуванням","unset_page_as_default":"Сторінка за замовчуванням. Натисніть, щоб зробити сторінку звичайною."},"video_just_uploaded_codec_error":"Ви намагаєтеся завантажити відео, яке було закодовано кодеком {codec}. Ми не гарантуємо коректне відтворення цього відео у всіх браузерах. Ми рекомендуємо конвертувати відео в інший формат і завантажити його знову.","video_codec_error":"Це відео закодовано кодеком {codec}, який не підтримується вашим браузером.","safari_webm_not_support":"Наразі браузери Safari не підтримують формат WEBM. Спробуйте відкрити сторінку в іншому браузері, наприклад, Google Chrome або Mozilla Firefox.","video_transcribe":"Транскрипт","video_summary":"Сводка","video_meeting_notes":"Заметки с встречи","video_ask_ai":"Спросить AI"},"image":{"text_from_image_popup":{"title":"Текст із зображення","no_text":"Немає тексту","copy":"Скопіювати ввесь текст"},"unknown_error":"Посилання неправильне","add_image":"Вставте посилання на зображення або ","add_image_or":"або","add_image_small":"Вставте або ","browse":"шукати","browse_image":"Шукати зображення","too_large_error":"Завеликий розмір зображення","image_info_dialog":{"title":"Інформація про зображення","type":"Тип","size":"Розмір","location":"Розташування","copy_link":"Скопіювати посилання"},"rotate_wait":{"full":"Будь ласка, зачекайте","medium":"Зачекайте"},"attachment_not_found_error":"Виникла несподівана помилка із зображенням","readonly_placeholder":"Пусте зображення","unsplash":{"name":"Unsplash","header":"Виберіть картинку","placeholder":"Пошук зображення","search":"Пошук","description":"Виконайте пошук, щоб знайти більше результатів.","no_result":"Зображення не знайдено.","caption_preffix":"Автор"},"comments":"Comments"},"attachment":{"unknown_error":"Щось пішло не так, спробуйте вибрати інший файл","attachment_is_being_uploaded":"Файл завантажується на інший пристрій...","attachment_will_be_downloaded_online":"Файл завантажиться, коли ви будете онлайн.","attachment_preview_is_not_available":"Попередній перегляд недоступний.","choose_a_file":"Вибрати файли","wait_resolving_without_info":"Будь ласка, зачекайте..."},"video":{"player":{"play":"Відтворити","pause":"Зупинити","volume":"Звук","fullscreen_on":"На увесь екран","fullscreen_off":"Вийти із повноекранного режиму","watch_again":"Переглянути знову"}},"search":{"placeholder":"Знайти у сторінці","matches":"Відповідає:"},"copy":{"copied":"Скопійовано!","copy_to_clipboard":"Скопіювати в буфер обміну"},"apply":"Застосувати","done":"Готово","block_menu":{"align":{"left":"Вирівняти по лівому краю","center":"Вирівняти по центру","right":"Вирівняти по правому краю","justify":"Виправдати"},"indent":{"indent":"Збільшити відступ","outdent":"Зменшити відступ"},"tooltip":"Перетягніть, щоб перемістити\\n<span>Клікніть, щоб відкрити меню</span>","copy_tooltip":"Скопіювати посилання","color":{"background_color":"Фоновий колір","color":"Колір","line_color":"Колір лінії","line_type":"Тип лінії","player_color":"Колір програвача"},"line_type":{"default":"Звичайна лінія","dotted":"Пунктирна"},"add":{"name":"Додати блок","above":"Зверху","below":"Знизу","left":"Зліва","right":"Справа","above_column":"Вище колонки","below_column":"Нижче колонки"},"convert_to":{"name":"Конвертувати до","to_do_list":"Чек-лист","number_list":"Пронумерований список","bullet_list":"Маркований список","paragraph":"Абзац","large_heading":"Заголовок H1","medium_heading":"Заголовок H2","small_heading":"Заголовок H3","large_heading_toggle":"Заголовок, що згортається H1","medium_heading_toggle":"Заголовок, що згортається H2","small_heading_toggle":"Заголовок, що згортається H3","code":"Код","quote":"Цитата","hint":"Підказка","image":"Зображення","file":"Файл","remote_frame":"Вставка","link":"Посилання","bookmark":"Закладка","button":"Кнопка","toggle":"Блок, що згортається","step":"Steps"},"comment_block":"Коментар","edit":"Редагувати","duplicate":"Дублювати","copy_block":"Копіювати блок","copy_blocks":"Копіювати блоки","copy_link":"Копіювати посилання","delete":"Видалити","replace":"Замінити","blot_lock":"Замкнути блок","blot_unlock":"Відкрити блок","set_as_preview":"Встановити для попереднього перегляду","get_text_from_image":"Отримати текст із зображення","edit_image":"Редагувати зображення","download":"Скачати","view_full_size":"Переглянути в повному розмірі","open_in_new_tab":"Відкрити в новій вкладці","image_info":"Інформацію про зображення","rotate_image":"Покрутити","add_sub_task":"Додати підзадачу","add_sub_text":"Додати підтекст","layout":"Розмітка","embed_align":{"left":"Вирівняти по лівому краю","center":"Вирівняти по центру","right":"Вирівняти по правому краю","default":"Розмір за замовчуванням","full_width":"На всю ширину"},"expand_all":"Розгорнути повністю","collapse_all":"Згорнути повністю","add_caption":"Додати підпис","blot_locked_admin":"Редагування блоку заборонено. Натисніть, щоб дозволити.","blot_locked_admins":"Редагування блоків заборонено. Натисніть, щоб дозволити.","blot_locked_user":"Ви не маєте права редагувати цей блок. Зверніться до адміністратора вашої організації.","show_header":"Показати верхню панель","show_borders":"Показати межі","rename":"Перейменувати"},"convert_menu_groups":{"suggestions":"Рекомендації","basic":"Основні","advanced":"Просунуті","media":"Медіа","embed":"Інтерграції","views":"Види","templates":"Шаблони","helpful_links":"Корисні посилання"},"embedded_menu":{"start_typing":"Введіть \\"/\\" або додайте","start_typing_full":"Почніть писати або введіть \\"/\\", \\"@\\"","more_items":"Більше позицій...","add_an_element":"Додати елемент","paragraph":"Абзац","todo":"Список чек-лист","numbered_list":" Нумерований список","bullet_list":"Маркований список","table":"Таблиця","image":"Зображення","file":"Файл","audioRec":"Запис аудіо","videoRec":"Запис відео","recordExist":" Ви не можете почати новий запис, поки не завершиться попередній. Завершіть або видаліть попередній запис, щоб почати новий.","large_heading":"Заголовок H1","medium_heading":"Заголовок H2","small_heading":"Заголовок H3","large_heading_toggle":"Заголовок, що згортається H1","medium_heading_toggle":"Заголовок, що згортається H2","small_heading_toggle":"Заголовок, що згортається H3","section_break":"Лінія","link":"Посилання","code":"Код","quote":"Цитата","hint":"Підказка","hint_placeholder":"Напишіть щось","mention":"Згадати учасника","outline":"Зміст","remote_frame":"Вставка: Посилання, iFrame, JS-код","integrations":"Інтеграції","google_drive":"Google Drive","google_sheets":"Google sheets","html":"HTML","toggle":"Блок, що згортається","tasks_list":"Список задач","lock_blot":"Замкнути блок","link_page":"Перелінкувати сторінки / Створити","date":"Дата","more_integrations":"більше інтеграцій","two_columns":"2 колонки","meeting_notes":"Marketing Strategy","marketing_brief":"Marketing Quarterly PlanningВ ","content_plan":"Content plan","more_templates":"більше шаблонів","get_feedback":"Отримати відгук","contact_support":"Зв’язатися із підтримкою","learn_nimbus":"Дізнатися про Nimbus","footer_top":" А ви знали, що можете почати вводити текст, щоб здійснити пошук у списку","footer_bottom":"Не можете знайти що шукаєте?","footer_link":"Поділіться з нами","add_note":"Нова сторінка","database_with_options":"База даних","board":"Kanban / Дошка задач","progress":"Прогрес","dropdown_list":"Список, що випадає","uploader":"File uploader","use_ai":"Use Fusebase AI","helper":"AI помічник","summarize":"Підсумувати","explain":"Пояснити","improve":"Поліпшити","spelling":"Виправити правопис і граматику","cta":"Заклик до дії","shorter":"Зробити коротше","longer":"Зробити довше","step":"Steps"},"button":{"title":"Назва","id_info_tooltip":" Цей ідентифікатор можна використовувати в майбутньому при редагуванні CSS-файлу.","address":"URL-адреса або електронна пошта","open_in_new_tab":"Відкрити у новій вкладці","shape":" Форма кнопки","background":"Фон","size":"Розмір кнопки","small":"Малий","medium":"Середній","big":"Великий","cancel":"Скасувати","done":"Готово","length_error":" Текст завеликий для кнопки. Спробуйте вибрати менший (не більше 50 символів).","type":"Вид кнопки","default":"За завмовчуванням","withShadow":"Кнопка з тінню","3d":"3D кнопка","convert":{"popup_title":"Перетворити у кнопку"}},"link":{"open":"Відкрити","send":"Надіслати","copy":"Скопіювати","edit":"Редагувати","remove":"Прибрати","text_label":"Текст","url_label":"Посилання","email_label":"Адреса електронної пошти","copied":" Посилання скопійовано в буфер обміну","cancel":"Скасувати","done":"Готово"},"syntax":{"menu":{"language":"Мова","theme":"Тема","wrap":"Увімкнути згортання","unwrap":"Вимкнути згортання","lineNumbersOn":" Показати номери рядків","lineNumbersOff":" Сховати номери рядків"},"convert":{"popup_title":"Перетворити у код","blots_have_comments":"У тексті є коментарі, які будуть видалені під час конвертації.","text_has_inline_comments":"Всередині тексту є коментарі, які будуть видалені під час конвертації.","confirm":"Конвертувати"}},"list":{"list_style":"Стиль списку","type_default":"За завмовчуванням","type_rectangle":"Прямокутник","type_star":"Зірка","type_dart":"Дротик","type_rounded":"Заокруглення","type_arrow":"Стрілка","type_diamond":"Діамант"},"caption":{"placeholder":"Додати підпис"},"mention":{"show_all":"Показати все","show_all_users":"Показати все","placeholder":" Показати нещодавні або ввести для пошуку","user":"Люди","workspace":"Простори","folder":"Папки","note":"Сторінки","no_results":"Немає результатів","offline_message":" Згадка працює лише при активному з\'єднанні. Увімкніть Інтернет і спробуйте ще раз.","info":{"note":{"one":"сторінка","some":"сторінок","many":"сторінок"},"subfolder":{"one":"підпапка","some":"підпапок","many":"підпапок"},"member":{"one":"учасник","some":"учасників","many":"учасників"},"owner":"власник","loading":"Завантаження попереднього перегляду...","loading_failed":"Не вдалося завантажити","not_loaded":"Сторінка ще не завантажилася"},"back_button":"Назад","create_note_for":"Створити сторінку:","create_folder_for":"Створити папку:"},"calendar":{"ui":{"date":"Дата","am":"AM","pm":"PM","date_format":"Формат дати","show_time":"Показати час","time_format":"Формат часу","time_12":"12год","time_24":"24год","first_week_day":"Перший день тижня","time_zone":"Часовий пояс","use_gmt":"Застосувати GMT для всіх учасників","use_gmt_hint":"Застосувати однаковий часовий пояс (GMT) для всіх учасників","table":{"clear":"Очистити"},"inline":{"clear":"Видалити"},"reminder":{"name":"Нагадування","panel_name":" Нагадування","push_name":" Нагадування про подію","remove_confirm_message":" У вас є нагадування з прив\'язкою до часу. Ви хочете видалити ці нагадування?","remove_confirm_text":"Видалити","remove_cancel_text":"Не видаляти нагадування","before_period":"До","after_period":"Після","period":{"m":{"one":"хвилина","many":"хвилин"},"h":{"one":"година","many":"годин"},"d":{"one":"день","many":"днів"},"w":{"one":"тиждень","many":"тижнів"}},"value":{"none":"Жодного","0m":"На початку","1m":"За 1 хвилину до","5m":"За 5 хвилин до","10m":"За 10 хвилин до","15m":"За 15 хвилин до","30m":"За 30 хвилин до","1h":"За 1 годину до","2h":"За 2 години до","1d":"За 1 день до","2d":"За 2 дні до","7d":"За 7 днів до","10d":"За 10 днів до","14d":"За 14 днів до","custom":"Індивідуально"},"until":{"in":"в","d":"д","h":"г","m":"хв","already_been":"Вже було","less_minute":"Менш ніж за хвилину","now":"Зараз"}},"postfix":{"day":"д","month":"м"}},"insert":{"category_name":"Дата","custom":"Інша","now":"Зараз","today":"Сьогодні","tomorrow":"Завтра"},"date_format":{"ddmmyyyy":"дд/мм/рік","mmddyyyy":"мм/дд/рік","yyyyddmm":"рік/мм/дд","monthddyyyy":"Місяць дд, рік","default":"Згідно з форматом браузера"},"months":{"0":"Січень","1":"Лютий","2":"Березень","3":"Квітень","4":"Травень","5":"Червень","6":"Липень","7":"Серпень","8":"Вересень","9":"Жовтень","10":"Листопад","11":"Грудень"},"days":{"short":{"0":"Нд","1":"Пн","2":"Вт","3":"Ср","4":"Чт","5":"Пт","6":"Сб"},"full":{"0":"неділя","1":"понеділок","2":"вівторок","3":"середа","4":"четвер","5":"п’ятниця","6":"субота"}}},"content_not_supported":" Ця сторінка не підтримується у вашій версії програми FuseBase. Спробуйте оновити її або використайте інший клієнт з останньою версією.","profession_ask":{"title":" Збережіть час, використовуйте шаблони для створення нових сторінок ","text":"Введіть свою професію, і наша команда створить для вас шаблони. Це безкоштовно, без жодних прихованих платежів","i_am_a":"Я","placeholder":" наприклад, дизайнер, вчитель, торговий агент тощо","request_template":"Створити запит на шаблон","sucess_message":" Дякую! Ваш запит буде додано до черги."},"bookmark":{"name":"Закладка","edit":"Редагувати закладку","title":"Назва","address":"Адреса","description":"Опис","placeholder":"Вставте або напишіть посилання з https://...","placeholder_mobile":" Вставте або напишіть посилання","loading_preview":"Завантаження попереднього перегляду¦","block_menu":{"change_mode":{"menu_name":"Переглянути як","mode_tile":"Назва","mode_card":"Картка","mode_cover":"Обкладинка"},"change_preview":"Змінити попередній перегляд","delete_preview":"Видалити попередній перегляд","reset_preview":"Перевстановити попередній перегляд","change_preview_background":"Попереднього переглянути фон","options":{"menu_name":"Варіанти","open_in_same_tab":" Відкрити в тій самій вкладці"}},"error":{"unknown_error":" Щось пішло не так, спробуйте ввести іншу URL-адресу","preview_notfound":" Попередній перегляд не знайдено"},"upload":{"new_preview":"Завантажити нове","quota_error":"Розмір файлу перевищує дозволені 3 МБ. Спробуйте інший файл.","unknown_error":"Невідома помилка. Спробуйте інший файл."}},"businessCard":{"PERSON":"Ім’я","ORGANIZATION":"Компанія","TITLE":"Назва","ADDRESS":"Посада","URL":"Вебсайт","PHONE":"Номер телефону","EMAIL":"Електронна адреса","SKYPE":"Skype","TWITTER":"Twitter","INSTAGRAM":"Instagram","FACEBOOK":"Facebook","LINKEDIN":"LinkedIn","VK":"Vk"},"dialog_common":{"button":{"ok":"Ok","cancel":"Відмінити"}},"outline":{"default_name":"Зміст","menu":{"expand":"Розгорнути","collapse":"Згорнути","rename":"Перейменувати"},"context_menu":{"convert_to":{"text":"Текст"},"style":{"name":"Стиль змісту","list_only":"Тільки список","numbered_list":"Нумерований список","bordered":"Показати межу","border_color":"Колір межі"}},"empty":"Додайте заголовки на свою сторінку, і вони з\'являться тут у вигляді посилань"},"floating_toolbar":{"bold":"Жирний","italic":"Курсив","underline":"Підкреслити","strikethrough":"Закреслити","clear":"Прибрати форматування","code":"Код","button":"Кнопка","link":"Посилання","highlight":"Виділити","extraHighlight":"Мітки для текстів","color":"Розфарбувати та виділити","text":"Текст","clear_all":"Очистити все","placeholder":"Заповнювач","adapts":{"dark":" Адаптується до темної теми","light":" Адаптується до світлої теми"},"create_note":"Створити сторінку","add_comment":"Додати коментар"},"remote_frame":{"placeholder_small":"Вкласти URL-адресу","placeholder_full":"Вставте будь-яку URL-адресу, наприклад, YouTube, Github, Maps, Twitter, тощо","loading":"Завантаження...","context_menu":{"change_link":"Змінити посилання","full_size":" На весь екран","reset_size":"Скинути розмір","open_origin":"Відкрити оригінал","layout":"Розмітка","show_toolbar":"Показати панель інструментів редагування","copy_original":"Copy link to original"},"error":{"is_not_link":"Посилання або код неправильні","content_error":" Ця URL-адреса не підтримується або недійсна. <a href=\\"https://nimbusweb.me/contact-us.php\\" target=\\"_blank\\">Зв’яжіться з нами </a> якщо ви вважаєте, що цю URL-адресу можна вкласти.","unknown_error":" Щось пішло не так, спробуйте ввести іншу URL-адресу","wrong_signature":" Цей вміст пошкоджений і не може бути відображений","google_docs_auth_error":" Швидше за все, ви не можете вставити файл Google Docs/Sheets/Slides, тому що у вас немає до нього доступу. <a href=\\"http://nimb.ws/EkX87M\\" target=\\"_blank\\"> Будь ласка, прочитайте наш гайд.</a>","internal_link_error":"{{serviceName}} заборонив переходити за внутрішніми посиланнями. Натисніть на кнопку Назад, щоб повернутися на попередню сторінку."},"convert_bookmark":"Перетворити у закладку","convert_link":"Перетворити у посилання","back_button":"Назад"},"google_drive":{"block_name":"Google Drive","loading":"Завантаження...","menu":{"expand":"Розгорнути","collapse":"Згорнути","open_origin":"Відкрити в Google Drive","download":"Скачати","change_account":"Змінити обліковий запис","choose_another_file":"Вибрати інший файл"},"last_modified":"Востаннє змінено {{userName}} {{time}} тому","browse":"Шукати файл","login":"Увійдіть за допомогою Google","login_text":"Переглядайте та додавайте файли з Google Диску"},"html":{"default_name":"HTML","loading":"Завантаження...","menu":{"open_source":"Відкрити посилання на джерело","export_blot":"Зберегти HTML"},"unknown_error":"Невідома помилка","device_cant_display_content":"Ваш пристрій не може відобразити цей вміст","wrong_signature":"Цей вміст пошкоджений і не відображається"},"relative_time":{"seconds":{"one":"{{count}} секунда","some":"{{count}} секунд","many":"{{count}} секунд"},"minutes":{"one":"{{count}} хвилина","some":"{{count}} хвилин","many":"{{count}} хвилин"},"hours":{"one":"{{count}} година","some":"{{count}} годин","many":"{{count}} годин"},"days":{"one":"{{count}} день","some":"{{count}} днів","many":"{{count}} днів"},"months":{"one":"{{count}} місяць","some":"{{count}} місяців","many":"{{count}} місяців"},"years":{"one":"{{count}} рік","some":"{{count}} років","many":"{{count}} років"}},"collapsible_content":{"menu":{"expand":"Розгорнути","collapse":"Згорнути","rename":"Перейменувати"}},"convert_link":{"url":"URL-адреса","title":"Назва","embed":"Вкладка","bookmark":"Закладка","button":"Кнопка","link_to_note":"Посилання на сторінку","link_to_folder":"Посилання на папку","link_to_workspace":"Посилання на простір","convert_error":"Виникла помилка при перетворенні URL-адреси"},"fullwidth":{"menu_item":"На всю ширину"},"resizeable":{"point_tooltip":{"default":"Змінити розмір","bottom-right":" Змінити розмір\\n(натисніть і утримуйте клавішу {{altKey}} для зміни розміру)"}},"toggle":{"placeholder":"Натисніть тут, щоб створити або перемістити блок","expand":"Розгорнути блок","collapse":"Згорнути блок","expand_heading":"Розгорнути заголовок","collapse_heading":"Згорнути заголовок","expand_step":"Expand step","collapse_step":"Collapse step"},"step":{"content_placeholder":"Click here to create description to the step","title_placeholder":"Enter a short title to describe this step","aggregator_placeholder":"Enter a short descriptive title","menu":{"step_layout":{"name":"Layout","show_number":"Show number","show_arrow":"Show arrow","show_border":"Show border"}}},"tasks_list":{"not_supported":"Наразі ми не можемо відобразити список задач, оскільки він не підтримується в цьому типі сторінок.","menu":{"show_title":"Show task list name","view":"Default view","task_list_view":"Task list","calendar_view":"Calendar","kanban_view":"Kanban"}},"board":{"not_supported":"Наразі ми не можемо відобразити дошку задач, оскільки вона не підтримується в цьому типі сторінок.","menu":{"add_new_column":"Нова колонка","board_layout":{"name":"Розмітка","show_add_new_column":"Показати Додати колонку"}}},"empty_features":{"use_template":"Використати шаблон","import":"Імпортувати","add_database":"Додати базу даних","add_database_with_options":"Додати базу даних із опціями","add_board":"Kanban / Дошка задач","use_ai":"Use Fusebase AI","use_ai_agents":"Use AI Agents"},"ai_manager":{"generate_error":"Unfortunately, there are no results for your request. Please try another request.","unload_message":"Fusebase AI content is being generated. Are you sure you want to exit?","unknown_error":"Unknown error. Try again later or contact support.","dialog":{"title":"Discard draft","body":"Do you want to discard draft?","accept":"Yes, discard"}},"uploader":{"header":"Upload files","description":"Here, you can add some helpful information about file uploading","dropzone_full":"Drag file(s) here or","browse":"click to upload","dropzone_compact":"Add more files","uploading_progress":"Uploading {{progress}}%","uploading_files":"Uploading files","counter":"{{current}} of {{total}}","timer":"less than 1 minute remaining","header_placeholder":"Write a title, max {{maxChars}} characters","description_placeholder":"Write a description, max {{maxChars}} characters","errors":{"network":"Failed uploading file","too_big":"File is too big"},"menu":{"disallow_download":"Downloading","for_note":"For workspaces users","for_share":"Public page","convert_to_files":"Convert to files","allow_upload":"Uploading","enable_in_public_page":"Enable in public page"}},"convert_menu_tooltips":{"labels":{"management":" Підходить для управління знаннями","collaboration":"Підходить для взаємодії"},"paragraph":{"title":"Найкраще для найважливішого","description":" Це основний блок для написання контенту сторінки."},"todo":{"title":"Список для дрібних задач? Сюди!","description":"Записуйте невеликі доручення та рутинні завдання, які потрібно виконати."},"numberedlist":{"title":" Шикуймося: раз, два, три!","description":" Зробіть свій контент зручним для читання та показуйте його у вигляді списку."},"bulletlist":{"title":"Зробіть все зрозумілішим","description":"Ви можете створити список, який буде виділятися серед іншого контенту."},"table":{"title":"Форматуйте з радістю","description":" Організуйте інформацію в таблицю, щоб отримати цілісне уявлення про роботу."},"image":{"title":"Нам потрібно це побачити!Додайте зображення","description":" Зробіть свої сторінки привабливішими. Додавайте зображення будь-якого типу, переміщуйте їх і змінюйте розмір."},"file":{"title":" Файли тут, файли там, файли всюди!","description":" Створіть базу даних для вашого проєкту. Додайте на сторінку файли з різними типами розширень."},"largeheading":{"title":"Найкраще для основних розділів сторінки","description":" Це найбільший заголовок, який ви можете додати. Приверніть увагу до найважливої частини вашої сторінки та полегшіть навігацію."},"mediumheading":{"title":"Найкраще для другорядної інформації","description":"Це заголовок середнього розміру, який ви можете додати. За допомогою нього ви можете розділити сторінку на розділи і легко знайти те, що вам потрібно."},"smallheading":{"title":" Найкраще для чудових ідей у підсекціях","description":" Це найменший за розміром заголовок, який ви можете додати, але він все одно виділяється. Використовуйте його, щоб розділити сторінку на підсекції."},"tasks-list":{"title":"Організуйте свою роботу із задачами","description":"Тут ви можете групувати задачі в списки задач. Призначайте задачі учасникам, встановлюйте дедлайни та додавайте статуси для легкого відстеження."},"hline":{"title":"Проведімо лінію","description":"Відокремлюйте різні частини проєкту або розмежовуйте приклади та ідеї для нього."},"link":{"title":"Залиште посилання","description":"Щоразу, коли у вас з\'являється ідея для проєкту, додайте посилання на неї і дайте їй назву."},"syntax":{"title":"Не забувайте про код","description":"Ви можете додавати код прямо на своїй сторінці, перемикатися між темами, мовами тощо!"},"link-page":{"title":"Наступна зупинка - інша сторінка","description":"Посилайтесь на іншу сторінку, пов\'язану з проєктом, і легко переходьте на неї."},"date":{"title":"Просто скажіть коли","description":"Встановіть дедлайн для проєкту або позначте точний час, коли ви почали працювати над сторінкою."},"mention":{"title":"Залучайте свою команду","description":"Учасники вашої команди отримуватимуть сповіщення на електронну пошту, щоб відкрити певну сторінку та працювати на ній."},"blockquote":{"title":"І я цитую","description":"Ви можете виділити важливі слова ваших клієнтів або позначити мотиваційну фразу."},"hint":{"title":"Дайте підказку","description":"Виберіть емодзі та колір фону, щоб виділити попередження, застереження або сповіщення на сторінці."},"toggle":{"title":"Заховайте ваші блоки","description":"Сортуйте та приховуйте додаткову інформацію на сторінках для легшої навігації та доступу."},"outline":{"title":"Перегляньте, що чекає на вас","description":"Створіть зміст для зручної навігації на довгих сторінках або вікі."},"lock-blot":{"title":"Не для редагування","description":"Ви можете залишити певні інформаційні блоки на своїй сторінці лише для читання."},"embed":{"title":"Більше, ніж просто посилання","description":"Ви можете інтегрувати різні інструменти на сторінку. Зберігайте все в одному місці з автоматичним оновленням."},"figma":{"title":"Ваші дизайни на одній сторінці","description":"Додайте Figma на сторінку. Дивіться як створюються дизайни для проєкту в реальному часі."},"miro":{"title":"Ваша Miro Board у безпечному місці","description":"Ознайомтеся із довгостроковою стратегією вашого проєкту і враховуйте її у створенні сторінки."},"columns":{"title":"Одна колонка – добре, дві – краще!","description":"Розділіть сторінку на дві колонки, щоб додати туди більше контенту і зробити сторінку охайнішою."},"meeting-notes":{"title":"Ставте цілі та рухайтеся вперед","description":"Використовуйте цей шаблон, щоб побудувати маркетингову стратегію і тримати всі деталі в одному місці."},"marketing-brief":{"title":" Мрійте про велике, плануйте квартал за кварталом","description":"Використовуйте цей шаблон для побудови маркетингового плану по кварталах."},"content-plan":{"title":"Контролюйте та керуйте своєю роботою","description":"Використовуйте цей шаблон, щоб відтворити свої плани у таблиці. Візуалізуйте процес і керуйте задачами."},"integrations":{"title":"Більше, ніж просто посилання","description":"Ви можете інтегрувати різні інструменти на сторінку. Зберігайте все в одному місці з автоматичним оновленням."},"google-drive":{"title":"Зберіть всі файли з Google Drive","description":"Ви можете підключити свій обліковий запис Google Drive і вставити посилання на файли на диску для швидкого доступу до них."},"google-sheets":{"title":"Мінус одна вкладка з Google Sheet","description":"Зберігайте дані в одному місці з іншими деталями проекту, щоб легше проводити аналіз."},"bookmark":{"title":"Новий вид посилання тут","description":"Використовуйте закладку, щоб показати назву вашого посилання, невеликий опис і зображення сайту із попереднім переглядом."},"audioRec":{"title":"Не пишіть, краще скажіть","description":"Персоналізуйте вашу роботу. Запишіть голосовий відгук до матеріалів на сторінці."},"videoRec":{"title":"Не пишіть, краще покажіть","description":" Запишіть відео пояснення того, що потрібно зробити, або надайте чіткий зворотній зв\'язок."},"button":{"title":"Прийшов, побачив, клікнув","description":"Додайте елемент заклику до дії, який привертатиме увагу до важливих посилань на ваших сторінках."},"largeheading-toggle":{"title":"Заховайте більше у заголовку, що згортається H1","description":"Визначте найбільш важливу частину вашої сторінки та сховайте там інформацію для легкого доступу."},"mediumheading-toggle":{"title":"Зробіть ваші розділи ще коротшими","description":"Створюйте розділи із заголовком, що згортається H2 і ховайте в них частину контенту."},"smallheading-toggle":{"title":"Зробіть ваші підрозділи ще коротшими","description":"Створюйте розділи із заголовком, що згортається H3 і ховайте в них додаткову інформацію."},"database-with-options":{"title":"Оце так таблиці!","description":" Створіть базу даних для проєкту та налаштуйте її. Вибирайте різні типи колонок і рядків, змінюйте колір фону, тощо."},"board":{"title":"До дошки!","description":"Відображайте задачі у вигляді карток на дошці Kanban, щоб мати цілісне уявлення."},"progress":{"title":"Оцініть ваш прогрес!","description":"Виберіть мету і рухайтеся до неї! Використовуйте прогрес бар для оцінки виконаних завдань та інших активностей."},"uploader":{"title":"Say Goodbye to the File Mess!","description":"Clarify what files your clients and/or team need to send. With the file uploader, you can get what you want and keep it all in one place."},"dropdown-list":{"title":"Drop Your Options","description":"Place answer options anywhere in the text & let others give instant feedback."},"use-ai":{"title":"Work Smart, Not Hard","description":"Use AI to create and improve your content, get new ideas, and make personalized recommendations. Work with an AI assistant in your workspace."}},"feature_availability":{"plus":{"not-available":"Доступно для Plus, Team та Business планів","trial":"Вам доступний функціонал на час пробного періоду"},"team":{"not-available":"Доступно для Team та Business планів","trial":"Вам доступний функціонал на час пробного періоду плану Team"},"business2023":{"not-available":"Доступно для Business плану","trial":"Вам доступний функціонал на час пробного періоду плану Business"}}}');
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/i18n/messages/fr.json
const fr_namespaceObject = JSON.parse('{"table":{"common":{"column":"Colonne"},"move_column_cant_split_merged_cells":{"title":"Impossible de déplacer la colonne","text":"Impossible de déplacer une colonne dans une cellule fusionnée. Défusionnez-la, puis réessayez."},"move_column_cant_move_part_of_merged_cells":{"title":"Impossible de déplacer la colonne","text":"La colonne que vous essayez de déplacer contient une partie d\'une cellule fusionnée. Si vous souhaitez déplacer la colonne, défusionnez d\'abord les cellules."},"move_column_failed":{"title":"Impossible de déplacer la colonne","text":"Une erreur inattendue s\'est produite lors du déplacement de la colonne, veuillez réessayer."},"move_row_cant_split_merged_cells":{"title":"Impossible de déplacer la ligne","text":"Impossible de déplacer une ligne dans une cellule fusionnée. Défusionnez-la, puis réessayez."},"move_row_cant_move_part_of_merged_cells":{"title":"Impossible de déplacer la ligne","text":"La ligne que vous essayez de déplacer contient une partie d\'une cellule fusionnée. Si vous souhaitez déplacer la ligne, défusionnez d\'abord les cellules."},"move_row_cant_move_in_sortable_table":{"title":"Impossible de déplacer la ligne","text":"Impossible de déplacer une ligne dans un tableau triable. Annulez le tri, puis réessayez."},"move_row_cant_move_in_filtered_table":{"title":"Impossible de déplacer la ligne","text":"Impossible de déplacer une ligne dans un tableau filtré. Annulez le filtre, puis réessayez."},"move_row_failed":{"title":"Impossible de déplacer la ligne","text":"Une erreur inattendue s\'est produite lors du déplacement de la ligne, veuillez réessayer."},"first_move_column_or_row_message":"Vous pouvez sélectionner plusieurs lignes ou colonnes en maintenant la touche CTRL enfoncée et en cliquant sur les lignes ou colonnes souhaitées.","menu":{"delete":"Supprimer","help":"Aide","delete_column":{"one":"Supprimer la colonne","many":"Supprimer {{count}} colonnes"},"delete_row":{"one":"Supprimer la ligne","many":"Supprimer {{count}} lignes"},"add":"Ajouter","add_row_before":{"one":"Ligne au-dessus","many":"{{count}} lignes au-dessus"},"add_row_after":{"one":"Ligne en dessous","many":"{{count}} lignes en dessous"},"add_col_before":{"one":"Colonne à gauche","many":"{{count}} colonnes à gauche"},"add_col_after":{"one":"Colonne à droite","many":"{{count}} colonnes à droite"},"copy_cell":{"one":"Copier la cellule","many":"Copier les cellules"},"copy_table":"Copier le tableau","table_layout":{"name":"Disposition du tableau","column_headings":"En-têtes de colonnes","row_headings":"En-têtes de lignes"},"import_csv":"Importer depuis un fichier CSV","merge_cells":"Fusionner les cellules","insert_checkbox":"Insérer une case à cocher","background_color":"Couleur d\'arrière-plan","formatting":"Mise en forme","clear":"Effacer","reset":"Réinitialiser","divide_cells":"Défusionner les cellules","type":{"name_cell":"Type de cellule","name_cells":"Type des cellules","name_column":"Type de colonne","name_columns":"Type des colonnes","type_cell":{"one":"Type de cellule","many":"Type des cellules"},"type_col":{"one":"Type de colonne","many":"Type des colonnes"},"same_as_column":"Identique à la colonne","reset_cells":"Réinitialiser les cellules par défaut","none":"Type multiple","text":"Texte","textline":"Texte","number":"Nombre","attachment":"Fichiers","checkbox":"Case à cocher","multiselect":"Sélection multiple","singleselect":"Sélection unique","collaborator":"Collaborateur","currency":"Devise","date":"Date","link":"Lien","rating":"Évaluation","progress":"Progression","mention":"Mention"},"number_format":{"name":"Format de nombre","number":"Nombre","commas":"Nombre avec des virgules","percent":"Pourcentage"},"currency_format":{"name":"Type de devise","dollar":"Dollar","euro":"Euro","yen":"Yen","yuan":"Yuan","rouble":"Rouble","pound":"Livre","rupee":"Roupie","hryvnia":"Hryvnia","won":"Won","frank":"Franc","real":"Réel","other":"Autre","stick":"Afficher le symbole","before":"Avant","after":"Après"},"decimal_format":{"name":"Séparateur décimal","comma":"Virgule","point":"Point","hint":"Le séparateur est utilisé pour les décimales. Les séparateurs décimaux avec des virgules s\'affichent comme 1.000,99, et ceux avec des points s\'affichent comme 1,000.99"},"progress_format":{"name":"Options de progression","simple":"Simple","colored":"Coloré","start_from":"Commencer à partir de (0-100)","default_amount":"Montant par défaut (0-100)"},"rating_format":{"name":"Options d\'évaluation","star":"Étoile","flag":"Drapeau","heart":"Cœur","amount":"Montant (1-10)"},"date_format":{"name":"Format date/heure"},"mention_panel":{"open":"Ouvrir","edit":"Modifier","clear":"Effacer"},"color_numbers":{"name":"Numéros colorés","enable":"Activer les numéros colorés"},"filter":"Filtre","comment":"Commentaire"},"formatting_menu":{"align_left":"Gauche","align_center":"Centre","align_right":"Droite","valign_top":"Haut","valign_center":"Milieu","valign_bottom":"Bas","text":"Texte","text_align":"Alignement du texte","text_color":"Couleur du texte","bold":"Gras","italic":"Italique","strikethrough":"Barré","underline":"Souligné"},"col_menu":{"add_column_after":{"one":"Ajouter une colonne à droite","many":"Ajouter {{count}} colonnes à droite"},"add_column_before":{"one":"Ajouter une colonne à gauche","many":"Ajouter {{count}} colonnes à gauche"},"duplicate_column":{"one":"Dupliquer la colonne","many":"Dupliquer les colonnes"},"rename":"Renommer"},"row_menu":{"add_row_after":{"one":"Ajouter une ligne en dessous","many":"Ajouter {{count}} lignes en dessous"},"add_row_before":{"one":"Ajouter une ligne au-dessus","many":"Ajouter {{count}} lignes au-dessus"}},"warning":{"merge_different":"Impossible de fusionner des types d\'objets différents","convert_merged":"Impossible de convertir des cellules fusionnées"},"select":{"create_list":"Tapez pour créer une liste","create_item":"Tapez pour créer un élément","create_option":"Tapez pour créer une option","create_label":"Tapez pour créer une étiquette","create":"Créer","delete":"Supprimer"},"attachment":{"upload_more":"Télécharger des fichiers","downloading":"Téléchargement"},"collaborator":{"placeholder":"Tapez pour ajouter des personnes","no_result":"Aucun résultat","loading":"Chargement...","unknown":"Personne inconnue"},"checkbox":{"checked":"Oui","not_checked":"Non"},"sorting":{"name":"Tri","sort":"Trier","disable":"Supprimer le tri","change":"Cliquez pour changer","asc":{"common":"Croissant","text":"Trier A-Z","number":"Trier 1-9","checkbox":"Non sélectionné en premier"},"desc":{"common":"Décroissant","text":"Trier Z-A","number":"Trier 9-1","checkbox":"Sélectionné en premier"},"warning":{"column_merged":{"title":"Impossible de trier la colonne","text":"Impossible de trier une colonne contenant des cellules fusionnées"},"table_rowspan":{"title":"Impossible de trier la colonne","text":"Impossible de trier un tableau avec des lignes fusionnées"},"merge":{"title":"Les cellules ne peuvent pas être fusionnées","text":"Les cellules ne peuvent pas être fusionnées lorsque le tri des colonnes est actif. Désactivez le tri et réessayez."},"different_currencies":{"title":"Avertissement de tri","text":"Vous utilisez différentes devises dans une colonne. Le tri peut être incorrect."}},"exit_dialog":{"title":"Supprimer le tri","toggle":"Garder trié","text_keep":"Garder trié","text_no_keep":"L\'ordre des colonnes sera restauré à son ordre initial avant l\'application du tri","apply":"Appliquer"}},"filter":{"by_field":"Filtrer par ce champ","empty_table":"Tous les enregistrements sont filtrés","popup_title":"Dans ce tableau, afficher les enregistrements","empty_filters":"Aucune condition n\'est appliquée à cette base de données","where":"Où","or":"Ou","and":"Et","add_condition":"Ajouter une condition","clear_all":"Tout effacer","contains":"contient","is":"est","is_not":"n\'est pas","contains_not":"ne contient pas","has_any_of":"contient un des","has_none_of":"ne contient aucun des","empty":"vide","not_empty":"non vide","filetype":"type de fichier","select_users_placeholder":"Sélectionner des utilisateurs","type_text_placeholder":"Saisir du texte","type_text_or_select_placeholder":"Saisir du texte ou sélectionner","type_number_placeholder":"Saisir un nombre","select_type_placeholder":"Sélectionner un type","select_date_placeholder":"Sélectionner une date","date":{"today":"Aujourd\'hui","yesterday":"Hier","tomorrow":"Demain","custom":"Personnalisé"},"filetypes":{"images":"Images","documents":"Documents","media":"Médias","other":"Autre"},"warning":{"cells_merged":{"title":"Impossible de filtrer le tableau","text":"Impossible de filtrer une colonne contenant des cellules fusionnées"},"merge":{"title":"Les cellules ne peuvent pas être fusionnées","text":"Les cellules ne peuvent pas être fusionnées lorsque le filtre du tableau est actif. Désactivez le filtre et réessayez."},"column_multitype":{"title":"Impossible de filtrer le tableau","text":"Il n\'est pas possible de filtrer les colonnes de type multiple. Veuillez essayer de convertir en un autre type et réessayer."},"table_not_have_typed_columns":{"title":"Impossible de filtrer le tableau","text":"Aucune colonne disponible pour le filtrage."}},"enable_filter":"Activer le filtre","disable_filter":"Désactiver le filtre"},"wrap_cells":{"layout_menu":"Renvoyer les cellules à la ligne","warnings":{"merge":{"title":"Impossible de fusionner les cellules","text":"Impossible de fusionner les cellules en mode sans renvoi à la ligne"},"toggle":{"title":"Impossible de changer l\'option","text":"Le tableau contient des cellules fusionnées"}}},"duplicate_column":{"title":"Dupliquer la colonne","text_1":"Dupliquer le contenu de la colonne","text_2":"Vous pouvez dupliquer l\'ensemble de la colonne contenant des données ou laisser la colonne dupliquée vide","accept":"Dupliquer","copy":"copier"},"convert_column":{"title":"Changer le type de colonne","text_before":"Cette colonne contient des valeurs. Changer le type de colonne effacera certaines des valeurs. Utilisez la commande","text_cmd":"annuler","text_after":"pour revenir en arrière si nécessaire.","accept":"Changer de type"},"merge_cells_with_comments":{"title":"Fusionner les cellules","text":"Les cellules seront fusionnées de gauche à droite et la nouvelle cellule affichera un commentaire de la cellule de gauche.","accept":"Fusionner"},"summary":{"layout_menu":"Afficher la barre de calcul","name":{"none":"Aucun","all":"Tous","empty":"Vide","fill":"Rempli","unique":"Unique","empty_percent":"Pourcentage vide","fill_percent":"Pourcentage rempli","unique_percent":"Pourcentage unique","sum":"Somme","average":"Moyenne","min":"Min","max":"Max","median":"Médiane","min_date":"Date la plus ancienne","max_date":"Date la plus récente","range_days":"Intervalle de dates (jours)","range_month":"Intervalle de dates (mois)","checked":"Coché","unchecked":"Non coché","checked_percent":"Pourcentage coché","unchecked_percent":"Pourcentage non coché","filter_rating":"Avec note :","filter_progress":"Avec progression :","filesize_min":"Taille minimale","filesize_max":"Taille maximale"},"item":{"none":"Calculer","min_date":"La plus ancienne","max_date":"La plus récente","range_days":"Intervalle (jours)","range_month":"Intervalle (mois)","checked_percent":"Coché","unchecked_percent":"Non coché","filter_rating":"Avec note","filter_progress":"Avec progression"}},"comments":{"tooltip":{"one":"Commentaire","more":"Commentaires"}}},"file":{"image_viewer":{"could_not_load_image":"Impossible de charger l\'image"},"download_file":"Télécharger {{name}}","listen_file":"Lire {{name}}","stop_file":"Arrêter {{name}}","uploading":"Téléchargement en cours","wrtc":{"how_to_fix":"Comment le corriger ?","how_to_url":"https://nimbusweb.me/s/share/5441210/4qccr41slk6wsw61h5fb","how_to_url2":"https://nimbusweb.me/s/share/5607239/l55bgak2ivs9bfptruka#b1995924032_670","rec_err_au":"Erreur d\'enregistrement. Pas d\'accès au microphone.","rec_err_vi":"Erreur d\'enregistrement. Pas d\'accès au microphone/webcam.","allow_micro":"Autoriser l\'accès au microphone","allow_media":"Sélectionnez la fenêtre à enregistrer","select_opt":"Ce qui sera enregistré","screenonly":"Écran","camonly":"Caméra","screencam":"Écran + Caméra","enable_micro":"Activer le microphone","startRecording":"Enregistrer","stopRecording":"Arrêter l\'enregistrement","pauseRecording":"Mettre l\'enregistrement en pause","resumeRecording":"Reprendre l\'enregistrement","cancelRecording":"Annuler l\'enregistrement","confirmCancel":"Êtes-vous sûr de vouloir annuler l\'enregistrement vidéo ?","cancel":"Annuler","prepareUpload":"Veuillez patienter, préparation du téléversement de l\'enregistrement","hasTmpRecord":"L\'enregistrement a été interrompu mais n\'est pas perdu","restore":"Restaurer","delete":"Supprimer","recordOnAnotherDevice":"L\'enregistrement est en cours sur un autre appareil..."},"menu":{"enabled":"Activé","disabled":"Désactivé","open_in_new_tab":"Ouvrir dans un nouvel onglet","copy_link":"Copier le lien du fichier","expand_in_full_window":"Agrandir en plein écran","autoplay":"Lecture automatique","sound_default":"Son par défaut","sound_loop":"Boucle","sound_hideControls":"Masquer les contrôles","sound_showPanel":"Afficher le panneau supérieur","shadow_video":"Ombre pour la vidéo","video_params":"Paramètres de la vidéo","disallow_download":"Téléchargement","for_note":"Pour les utilisateurs d\'espaces de travail","for_share":"Page publique","motion_video":"Vidéo animée","preview_video":"Modifier l\'aperçu","preview_video_btn":"Aperçu","print":"Imprimer","convert_to_image":"Convertir en image","convert_to_file":"Convertir en fichier","style":"Style","shadow_image":"Ombre pour l\'image","rename":"Renommer","replace":"Remplacer","delete":"Supprimer","download":"Télécharger","get_text_from_image":"Extraire le texte de l\'image","view_as":"Afficher comme","single_page":"Page unique","all_pages":"Toutes les pages","cta_motion_video_message":"La fonction CTA est activée pour les vidéos. Vous ne pouvez pas utiliser CTA et Vidéo animée en même temps. Désactivez CTA et essayez d\'activer Vidéo animée à nouveau.","cta_loop_message":"La fonction CTA est activée pour les vidéos. Vous ne pouvez pas utiliser CTA et Boucle en même temps. Désactivez CTA et essayez d\'activer Boucle à nouveau.","grid":"Grille","cta_drop_in_grid":"La fonction CTA est activée pour les vidéos. Nous vous recommandons de vérifier l\'affichage correct du CTA après avoir déplacé la vidéo dans une colonne de la grille.","cta_exists_in_grid":"La colonne de la grille contient une vidéo avec un CTA actif. Veuillez vérifier si elle est correcte après le transfert."},"downloading":"Téléchargement","attachment_not_found_error":"Erreur lors de l\'importation","pdf_viewer":{"initializing_full_window_view":"Initialisation de l\'affichage en plein écran","preparing_document_for_printing":"Préparation du document pour l\'impression...","printing_initialization":"Initialisation de l\'impression...","abort":"annuler","set_page_as_default":"Définir la page par défaut","unset_page_as_default":"Page par défaut. Cliquez pour rendre la page normale."},"video_just_uploaded_codec_error":"Vous essayez de téléverser une vidéo encodée avec le codec {codec}. Nous ne garantissons pas la lecture correcte de cette vidéo sur tous les navigateurs. Nous vous recommandons de convertir la vidéo dans un autre format et de la téléverser à nouveau.","video_codec_error":"Cette vidéo est encodée avec le codec {codec}, qui n\'est pas pris en charge par votre navigateur.","safari_webm_not_support":"Actuellement, les navigateurs Safari ne prennent pas en charge le format WEBM. Essayez d\'ouvrir la page dans un autre navigateur, comme Google Chrome ou Mozilla Firefox.","video_transcribe":"Transcrire","video_summary":"Résumé","video_meeting_notes":"Notes de réunion","video_ask_ai":"Demander à l\'IA"},"image":{"text_from_image_popup":{"title":"Texte de l\'image","no_text":"Il n\'y a pas de texte","copy":"Copier tout le texte"},"unknown_error":"Le lien est incorrect","add_image":"Coller le lien ou ","add_image_or":"ou","add_image_small":"Coller ou ","browse":"parcourir","browse_image":"Parcourir l\'image","too_large_error":"La taille de l\'image est trop grande","image_info_dialog":{"title":"Infos sur l\'image","type":"Type","size":"Taille","location":"Emplacement","copy_link":"Copier le lien"},"rotate_wait":{"full":"Veuillez patienter","medium":"Attendez"},"attachment_not_found_error":"Une erreur inattendue s\'est produite avec l\'image","readonly_placeholder":"Image vide","unsplash":{"name":"Unsplash","header":"Rechercher une image","placeholder":"Rechercher une image","search":"Rechercher","description":"Recherchez pour trouver plus de résultats.","no_result":"Aucune image trouvée.","caption_preffix":"Photo de"},"comments":"Commentaires"},"attachment":{"unknown_error":"Un problème est survenu, essayez de choisir un autre fichier","attachment_is_being_uploaded":"Un fichier est en cours de téléversement sur un autre appareil...","attachment_will_be_downloaded_online":"Le fichier sera téléchargé lorsque vous serez en ligne.","attachment_preview_is_not_available":"Aperçu non disponible.","choose_a_file":"Choisir des fichiers","wait_resolving_without_info":"Veuillez patienter..."},"video":{"player":{"play":"Lire","pause":"Pause","volume":"Volume","fullscreen_on":"Plein écran","fullscreen_off":"Quitter le plein écran","watch_again":"Regarder à nouveau"}},"step_outliner":{"about_steps":"À propos des étapes","total_steps":"Nombre total d\'étapes"},"search":{"placeholder":"Rechercher dans la page","matches":"Correspondances :"},"copy":{"copied":"Copié !","copy_to_clipboard":"Copier dans le presse-papiers"},"apply":"Appliquer","done":"Terminé","block_menu":{"align":{"left":"Aligner à gauche","center":"Aligner au centre","right":"Aligner à droite","justify":"Justifier"},"indent":{"indent":"Augmenter le retrait","outdent":"Diminuer le retrait"},"tooltip":"Glissez pour déplacer\\n<span>Cliquez pour ouvrir le menu</span>","copy_tooltip":"Copier le lien","color":{"background_color":"Couleur de fond","color":"Couleur","line_color":"Couleur de la ligne","line_type":"Type de ligne","player_color":"Couleur du joueur"},"line_type":{"default":"Ligne standard","dotted":"Points"},"add":{"name":"Ajouter un bloc","above":"Au-dessus","below":"En dessous","left":"Gauche","right":"Droite","above_column":"Au-dessus de la colonne","below_column":"Sous la colonne"},"convert_to":{"name":"Convertir en","to_do_list":"Liste de tâches","number_list":"Liste numérotée","bullet_list":"Liste à puces","paragraph":"Paragraphe","large_heading":"Titre principal","medium_heading":"Titre moyen","small_heading":"Petit titre","large_heading_toggle":"Titre principal réductible","medium_heading_toggle":"Titre moyen réductible","small_heading_toggle":"Petit titre réductible","code":"Code","quote":"Citation","hint":"Astuce","image":"Image","file":"Fichier","remote_frame":"Intégrer","link":"Lien","bookmark":"Marque-page","button":"Bouton","toggle":"Bloc bascule","step":"Étapes"},"comment_block":"Commentaire","edit":"Modifier","duplicate":"Dupliquer","copy_block":"Copier le bloc","copy_blocks":"Copier les blocs","copy_link":"Copier le lien","delete":"Supprimer","replace":"Remplacer","blot_lock":"Verrouiller le bloc","blot_unlock":"Déverrouiller le bloc","set_as_preview":"Définir comme aperçu","get_text_from_image":"Obtenir le texte de l\'image","edit_image":"Modifier l\'image","download":"Télécharger","view_full_size":"Voir en taille réelle","open_in_new_tab":"Ouvrir dans un nouvel onglet","image_info":"Informations sur l\'image","rotate_image":"Faire pivoter","add_sub_task":"Ajouter une sous-tâche","add_sub_text":"Ajouter un sous-texte","layout":"Disposition","embed_align":{"left":"Aligner à gauche","center":"Aligner au centre","right":"Aligner à droite","default":"Taille par défaut","full_width":"Pleine largeur"},"expand_all":"Tout déplier","collapse_all":"Tout replier","add_caption":"Ajouter une légende","blot_locked_admin":"Modification du bloc refusée. Cliquez pour le déverrouiller.","blot_locked_admins":"Modification des blocs refusée. Cliquez pour les déverrouiller.","blot_locked_user":"Vous n\'avez pas la permission de modifier ce bloc. Contactez l\'administrateur de votre organisation.","show_header":"Afficher la barre supérieure","show_borders":"Afficher les bordures","rename":"Renommer"},"convert_menu_groups":{"suggestions":"Suggestions","basic":"Basique","advanced":"Avancé","media":"Médias","embed":"Intégrations","views":"Vues","templates":"Modèles","helpful_links":"Liens utiles"},"embedded_menu":{"start_typing":"Tapez \\"/\\" ou ajoutez","start_typing_full":"Commencez à écrire ou tapez \\"/\\", \\"@\\"","more_items":"Plus d\'éléments...","rate_editor":"Noter l\'éditeur de page","add_an_element":"Ajouter un élément","paragraph":"Paragraphe","todo":"Liste de cases à cocher","numbered_list":"Liste numérotée","bullet_list":"Liste à puces","table":"Tableau","image":"Image","file":"Fichier","audioRec":"Enregistrement audio","videoRec":"Enregistrement vidéo","recordExist":"Vous ne pouvez pas démarrer un nouvel enregistrement tant que le précédent n\'est pas terminé. Terminez ou supprimez l\'enregistrement précédent pour en commencer un nouveau.","large_heading":"Titre 1","medium_heading":"Titre 2","small_heading":"Titre 3","large_heading_toggle":"Grand titre pliable","medium_heading_toggle":"Titre moyen pliable","small_heading_toggle":"Petit titre pliable","section_break":"Ligne","link":"Lien","code":"Code","quote":"Citation","hint":"Indice","hint_placeholder":"Tapez quelque chose","mention":"Mentionner un membre","outline":"Plan","remote_frame":"Intégrer : Lien, iFrame, Code JS","integrations":"Intégrations","google_drive":"Google Drive","google_sheets":"Google Sheets","html":"HTML","toggle":"Bloc bascule","tasks_list":"Liste des tâches","lock_blot":"Verrouiller le bloc","link_page":"Lier une page / Créer","date":"Date","more_integrations":"plus d\'intégrations","two_columns":"2 colonnes","meeting_notes":"Stratégie marketing","marketing_brief":"Planification trimestrielle marketing","content_plan":"Plan de contenu","more_templates":"plus de modèles","get_feedback":"Obtenir un retour","contact_support":"Contacter le support","learn_nimbus":"Apprendre Nimbus","footer_top":"Saviez-vous ? Vous pouvez commencer à taper pour rechercher dans la liste","footer_bottom":"Vous ne trouvez pas ce que vous cherchez ?","footer_link":"Dites-le-nous","add_note":"Nouvelle page","database_with_options":"Base de données","board":"Kanban / Tableau des tâches","progress":"Progression","dropdown_list":"Liste déroulante","uploader":"Téléverseur de fichiers","use_ai":"Utiliser Fusebase IA","helper":"Assistant IA","summarize":"Résumer","explain":"Expliquer","improve":"Améliorer","spelling":"Corriger l\'orthographe et la grammaire","cta":"Appels à l\'action","shorter":"Raccourcir","longer":"Allonger","step":"Étapes","step_outliner":"Plan des étapes"},"button":{"title":"Titre","id_info_tooltip":"Cet ID peut être utilisé ultérieurement lors de l\'édition du fichier CSS.","address":"URL ou Email","open_in_new_tab":"Ouvrir dans un nouvel onglet","shape":"Forme du bouton","background":"Arrière-plan","size":"Taille du bouton","small":"Petit","medium":"Moyen","big":"Grand","cancel":"Annuler","done":"Terminé","length_error":"Le texte est trop long pour le bouton. Essayez de sélectionner moins de texte (pas plus de 50 caractères).","type":"Type de bouton","default":"Par défaut","withShadow":"Bouton avec ombre","3d":"Bouton 3D","convert":{"popup_title":"Convertir en bouton"}},"link":{"open":"Ouvrir","send":"Envoyer","copy":"Copier","edit":"Modifier","remove":"Supprimer","text_label":"Texte","url_label":"Lien","email_label":"Adresse","copied":"Lien copié dans le presse-papiers","cancel":"Annuler","done":"Terminé"},"syntax":{"menu":{"language":"Langue","theme":"Thème","wrap":"Activer le retour à la ligne","unwrap":"Désactiver le retour à la ligne","lineNumbersOn":"Afficher les numéros de ligne","lineNumbersOff":"Masquer les numéros de ligne"},"convert":{"popup_title":"Convertir en code","blots_have_comments":"Il y a des commentaires dans le texte qui seront supprimés lors de la conversion.","text_has_inline_comments":"Il y a des commentaires dans le texte qui seront supprimés lors de la conversion.","confirm":"Convertir"}},"list":{"list_style":"Style de liste","type_default":"Par défaut","type_rectangle":"Rectangle","type_star":"Étoile","type_dart":"Flèche","type_rounded":"Arrondi","type_arrow":"Flèche","type_diamond":"Diamant"},"caption":{"placeholder":"Ajouter une légende"},"mention":{"show_all":"Tout afficher","show_all_users":"Tout afficher","placeholder":"Affichage récent ou tapez pour rechercher","user":"Personnes","workspace":"Espaces de travail","folder":"Dossiers","note":"Pages","no_results":"Aucun résultat","offline_message":"La mention ne fonctionne qu\'avec une connexion active. Activez Internet et réessayez.","info":{"note":{"one":"page","some":"pages","many":"pages"},"subfolder":{"one":"sous-dossier","some":"sous-dossiers","many":"sous-dossiers"},"member":{"one":"membre","some":"membres","many":"membres"},"owner":"propriétaire","loading":"Chargement de l\'aperçu...","loading_failed":"Échec du chargement","not_loaded":"La page n\'a pas encore été chargée"},"back_button":"Retour","create_note_for":"Créer une page :","create_folder_for":"Créer un dossier :"},"calendar":{"ui":{"date":"Date","am":"AM","pm":"PM","date_format":"Format de date","show_time":"Afficher l\'heure","time_format":"Format de l\'heure","time_12":"12H","time_24":"24H","first_week_day":"Premier jour de la semaine","time_zone":"Fuseau horaire","use_gmt":"Utiliser GMT pour tous les membres","use_gmt_hint":"Utiliser le même fuseau horaire (GMT) pour tous les collaborateurs","table":{"clear":"Effacer"},"inline":{"clear":"Supprimer"},"reminder":{"name":"Alerte","panel_name":"Alerte","push_name":"Rappel de l\'événement","remove_confirm_message":"Vous avez défini des rappels liés à l\'heure. Voulez-vous supprimer ces rappels ?","remove_confirm_text":"Supprimer","remove_cancel_text":"Ne pas supprimer","before_period":"","after_period":"avant","period":{"m":{"one":"minute","many":"minutes"},"h":{"one":"heure","many":"heures"},"d":{"one":"jour","many":"jours"},"w":{"one":"semaine","many":"semaines"}},"value":{"none":"Aucun","0m":"Au début","1m":"1 minute avant","5m":"5 minutes avant","10m":"10 minutes avant","15m":"15 minutes avant","30m":"30 minutes avant","1h":"1 heure avant","2h":"2 heures avant","1d":"1 jour avant","2d":"2 jours avant","7d":"1 semaine avant","10d":"10 jours avant","14d":"2 semaines avant","custom":"Personnalisé"},"until":{"in":"Dans","d":"j","h":"h","m":"min","already_been":"Déjà passé","less_minute":"Moins d\'une minute","now":"Maintenant"}},"postfix":{"day":"j","month":"m"}},"insert":{"category_name":"Date","custom":"Personnalisé","now":"Maintenant","today":"Aujourd\'hui","tomorrow":"Demain"},"date_format":{"ddmmyyyy":"jj/mm/aaaa","mmddyyyy":"mm/jj/aaaa","yyyyddmm":"aaaa/jj/mm","monthddyyyy":"Mois jj, aaaa","default":"Correspond au format du navigateur"},"months":{"0":"Janvier","1":"Février","2":"Mars","3":"Avril","4":"Mai","5":"Juin","6":"Juillet","7":"Août","8":"Septembre","9":"Octobre","10":"Novembre","11":"Décembre"},"days":{"short":{"0":"Di","1":"Lu","2":"Ma","3":"Me","4":"Je","5":"Ve","6":"Sa"},"full":{"0":"Dimanche","1":"Lundi","2":"Mardi","3":"Mercredi","4":"Jeudi","5":"Vendredi","6":"Samedi"}}},"content_not_supported":"Cette page n\'est pas prise en charge dans votre version de l\'application FuseBase. Essayez de la mettre à jour ou utilisez un autre client avec la dernière version.","profession_ask":{"title":"Gagnez du temps en utilisant des modèles pour créer de nouvelles pages","text":"Indiquez votre profession et notre équipe créera des modèles pour vous. C\'est gratuit, sans frais cachés.","i_am_a":"Je suis","placeholder":"par exemple : designer, enseignant, agent commercial, etc.","request_template":"Demander un modèle","sucess_message":"Merci ! Votre profession sera ajoutée à notre file d\'attente."},"bookmark":{"name":"Marque-page","edit":"Modifier le marque-page","title":"Titre","address":"Adresse","description":"Description","placeholder":"Collez ou écrivez un lien avec https://...","placeholder_mobile":"Collez ou écrivez un lien","loading_preview":"Chargement de l\'aperçu…","block_menu":{"change_mode":{"menu_name":"Voir comme","mode_tile":"Tuile","mode_card":"Carte","mode_cover":"Couverture"},"change_preview":"Changer l\'aperçu","delete_preview":"Supprimer l\'aperçu","reset_preview":"Réinitialiser l\'aperçu","change_preview_background":"Arrière-plan de l\'aperçu","options":{"menu_name":"Options","open_in_same_tab":"Ouvrir dans le même onglet"}},"error":{"unknown_error":"Un problème est survenu, essayez une autre URL.","preview_notfound":"Aucun aperçu trouvé."},"upload":{"new_preview":"Téléverser un nouveau","quota_error":"Le fichier dépasse la limite autorisée de 3 Mo. Essayez un autre fichier.","unknown_error":"Erreur inconnue. Essayez un autre fichier."}},"businessCard":{"PERSON":"Nom","ORGANIZATION":"Entreprise","TITLE":"Titre","ADDRESS":"Poste","URL":"Site","PHONE":"Téléphone","EMAIL":"Email","SKYPE":"Skype","TWITTER":"Twitter","INSTAGRAM":"Instagram","FACEBOOK":"Facebook","LINKEDIN":"LinkedIn","VK":"Vk"},"dialog_common":{"button":{"ok":"Ok","cancel":"Annuler"}},"outline":{"default_name":"Plan","menu":{"expand":"Développer","collapse":"Réduire","rename":"Renommer"},"context_menu":{"convert_to":{"text":"Texte"},"style":{"name":"Style de plan","list_only":"Liste uniquement","numbered_list":"Liste numérotée","bordered":"Afficher la bordure","border_color":"Couleur de la bordure"}},"empty":"Ajoutez des titres à votre page et ils apparaîtront ici comme des liens"},"floating_toolbar":{"use_ai":"Utiliser l\'IA","bold":"Gras","italic":"Italique","underline":"Souligné","strikethrough":"Barré","clear":"Effacer la mise en forme","code":"Code","button":"Bouton","link":"Lien","highlight":"Surligner","extraHighlight":"Étiquettes de texte","color":"Couleur et surlignage","text":"Texte","clear_all":"Tout effacer","placeholder":"Espace réservé","adapts":{"dark":"S\'adapte au thème sombre","light":"S\'adapte au thème clair"},"create_note":"Créer une page","add_comment":"Ajouter un commentaire"},"remote_frame":{"placeholder_small":"Intégrer une URL","placeholder_full":"Intégrez n\'importe quelle URL, comme YouTube, Github, Maps, Twitter, etc.","loading":"Chargement...","context_menu":{"change_link":"Changer le lien","full_size":"Plein écran","reset_size":"Réinitialiser la taille","open_origin":"Ouvrir l\'original","layout":"Disposition","show_toolbar":"Afficher la barre d\'outils d\'édition","copy_original":"Copier le lien de l\'original"},"error":{"is_not_link":"Le lien ou le code est incorrect","content_error":"Cette URL n\'est pas prise en charge ou est invalide. <a href=\\"https://nimbusweb.me/contact-us.php\\" target=\\"_blank\\">Contactez-nous</a> si vous pensez que cette URL peut être intégrée.","unknown_error":"Un problème est survenu, essayez une autre URL.","wrong_signature":"Ce contenu est corrompu et ne peut pas être affiché.","google_docs_auth_error":"Vous ne pouvez probablement pas intégrer le fichier Google Docs/Sheets/Slide car vous n\'y avez pas accès. <a href=\\"http://nimb.ws/EkX87M\\" target=\\"_blank\\">Veuillez lire notre guide.</a>","internal_link_error":"{{serviceName}} a interdit le suivi des liens internes. Cliquez sur Retour pour revenir à la page précédente."},"convert_bookmark":"Convertir en marque-page","convert_link":"Convertir en lien","back_button":"Retour"},"google_drive":{"block_name":"Google Drive","loading":"Chargement...","menu":{"expand":"Développer","collapse":"Réduire","open_origin":"Ouvrir dans Google Drive","download":"Télécharger","change_account":"Changer de compte","choose_another_file":"Choisir un autre fichier"},"last_modified":"Dernière modification par {{userName}} il y a {{time}}","browse":"Parcourir le fichier","login":"Se connecter avec Google","login_text":"Parcourir les fichiers et ajouter depuis Google Drive"},"html":{"default_name":"HTML","loading":"Chargement...","menu":{"open_source":"Ouvrir le lien source","export_blot":"Enregistrer en HTML"},"unknown_error":"Erreur inconnue","device_cant_display_content":"Votre appareil ne peut pas afficher ce contenu","wrong_signature":"Ce contenu est corrompu et ne peut pas être affiché"},"relative_time":{"seconds":{"one":"{{count}} seconde","some":"{{count}} secondes","many":"{{count}} secondes"},"minutes":{"one":"{{count}} minute","some":"{{count}} minutes","many":"{{count}} minutes"},"hours":{"one":"{{count}} heure","some":"{{count}} heures","many":"{{count}} heures"},"days":{"one":"{{count}} jour","some":"{{count}} jours","many":"{{count}} jours"},"months":{"one":"{{count}} mois","some":"{{count}} mois","many":"{{count}} mois"},"years":{"one":"{{count}} an","some":"{{count}} ans","many":"{{count}} ans"}},"collapsible_content":{"menu":{"expand":"Développer","collapse":"Réduire","rename":"Renommer"}},"convert_link":{"url":"URL","title":"Titre","embed":"Intégrer","bookmark":"Marque-page","button":"Bouton","link_to_note":"Lien vers une page","link_to_folder":"Lien vers un dossier","link_to_workspace":"Lien vers un espace de travail","convert_error":"Une erreur est survenue lors de la conversion de l\'URL"},"fullwidth":{"menu_item":"Pleine largeur"},"resizeable":{"point_tooltip":{"default":"Redimensionner","bottom-right":"Redimensionner\\n(maintenez la touche {{altKey}} enfoncée pour un redimensionnement libre)"}},"toggle":{"placeholder":"Cliquez ici pour créer ou déplacer un bloc","expand":"Développer le bascule","collapse":"Réduire le bascule","expand_heading":"Développer le titre","collapse_heading":"Réduire le titre","expand_step":"Développer l\'étape","collapse_step":"Réduire l\'étape"},"step":{"content_placeholder":"Cliquez ici pour créer une description de l\'étape","title_placeholder":"Saisissez un titre court pour décrire cette étape","aggregator_placeholder":"Saisissez un titre descriptif court","menu":{"step_layout":{"name":"Disposition","show_number":"Afficher le numéro","show_arrow":"Afficher la flèche","show_border":"Afficher la bordure"}},"add_step":"Ajouter étape"},"tasks_list":{"not_supported":"Actuellement, nous ne pouvons pas afficher la liste des tâches, car elle n\'est pas prise en charge dans ce type de page.","menu":{"show_title":"Afficher le nom de la liste des tâches","view":"Vue par défaut","task_list_view":"Liste des tâches","calendar_view":"Calendrier","kanban_view":"Kanban"}},"board":{"not_supported":"Actuellement, nous ne pouvons pas afficher le tableau des tâches, car il n\'est pas pris en charge dans ce type de page.","menu":{"add_new_column":"Nouvelle colonne","board_layout":{"name":"Disposition","show_add_new_column":"Afficher Ajouter une colonne"}}},"empty_features":{"use_template":"Utiliser un modèle","import":"Importer","add_database":"Ajouter une base de données","add_database_with_options":"Ajouter une base de données avec options","add_board":"Kanban / Tableau de tâches","use_ai":"Utiliser Fusebase AI","use_ai_agents":"Utiliser des agents d’IA"},"ai_manager":{"generate_error":"Malheureusement, aucune réponse n\'est disponible pour votre demande. Veuillez essayer une autre demande.","unload_message":"Le contenu de Fusebase AI est en cours de génération. Êtes-vous sûr de vouloir quitter ?","unknown_error":"Erreur inconnue. Réessayez plus tard ou contactez le support.","dialog":{"title":"Supprimer le brouillon","body":"Voulez-vous supprimer le brouillon ?","accept":"Oui, supprimer"},"ask_ai_to_edit":"Demander à Fusebase AI d\'éditer ou de générer...","ask_ai_to_edit_with_context":"Demander à Fusebase AI d\'éditer ou de générer avec le contexte de la page...","tell_ai_what_to_do":"Indiquez à Fusebase AI quoi faire ensuite...","ai_is_writing":"L\'IA est en train d\'écrire...","try_again":"Réessayer","stop":"Arrêter","responses_can_be_inaccurate":"Les réponses de l\'IA peuvent être inexactes ou trompeuses","learn_more":"En savoir plus","have_an_idea":"Avez-vous une idée ?","use_page_context":"Utiliser le contexte de la page","draft_with_fusebase_ai":"Rédiger avec Fusebase AI","tone_of_voice":"Ton de voix","suggested_tones":"Humoristique, sérieux, etc.","output_length":"Longueur de sortie","drafts":{"sales_email":"Email de vente","sales_email_preffix":"Rédigez un email de vente sur","proposal":"Proposition","proposal_preffix":"Rédigez une proposition sur","newsletter":"Newsletter","newsletter_preffix":"Rédigez une newsletter sur","blog_post":"Article de blog","blog_post_preffix":"Créez un article de blog sur","brainstorm_ideas":"Idées de brainstorming","brainstorm_ideas_preffix":"Rédigez des idées de brainstorming sur","social_media_post":"Publication sur les réseaux sociaux","social_media_post_preffix":"Créez une publication sur les réseaux sociaux sur","content_calendar":"Calendrier de contenu","content_calendar_preffix":"Générez un calendrier de contenu sur","step_by_step_guide":"Guide étape par étape","step_by_step_guide_preffix":"Rédigez un guide étape par étape pour expliquer comment","follow_up_email":"Email de relance","follow_up_email_preffix":"Créez un email de relance sur"},"manage":{"replace":"Remplacer","insert_above":"Insérer au-dessus","insert_below":"Insérer en dessous","done":"Terminé","continue":"Continuer à écrire","shorter":"Rendre plus court","longer":"Rendre plus long","insert_as_text":"Insérer en tant que texte","insert_as_task_list":"Insérer en tant que liste de tâches","insert_as_checkbox_list":"Insérer en tant que liste à cases à cocher","copy":"Copier","try_again":"Réessayer","discard":"Supprimer"},"actions":{"custom":"Assistant IA","summarize":"Résumer","explain":"Expliquer","improve":"Améliorer","spelling":"Corriger orthographe/grammaire","cta":"Appels à l\'action","shorter":"Raccourcir","longer":"Allonger"}},"uploader":{"header":"Télécharger des fichiers","description":"Ici, vous pouvez ajouter des informations utiles sur le téléchargement de fichiers","dropzone_full":"Glissez le(s) fichier(s) ici ou","browse":"cliquez pour télécharger","dropzone_compact":"Ajouter plus de fichiers","uploading_progress":"Téléchargement {{progress}}%","uploading_files":"Téléchargement des fichiers","counter":"{{current}} sur {{total}}","timer":"moins d\'une minute restante","header_placeholder":"Écrivez un titre, max {{maxChars}} caractères","description_placeholder":"Écrivez une description, max {{maxChars}} caractères","errors":{"network":"Échec du téléchargement du fichier","too_big":"Le fichier est trop volumineux"},"menu":{"disallow_download":"Téléchargement","for_note":"Pour les utilisateurs des espaces de travail","for_share":"Page publique","convert_to_files":"Convertir en fichiers","allow_upload":"Téléversement","enable_in_public_page":"Activer dans la page publique"}},"convert_menu_tooltips":{"labels":{"management":"Idéal pour la gestion des connaissances","collaboration":"Idéal pour la collaboration"},"paragraph":{"title":"Parfait pour le contenu principal","description":"Ceci est le bloc principal pour écrire le contenu de la page."},"todo":{"title":"Une liste pour les petites tâches ? Cochez !","description":"Notez les petites courses et tâches de routine à accomplir."},"numberedlist":{"title":"Mettez en ligne : Un, Deux, Trois !","description":"Rendez votre contenu facile à lire et affichez-le sous forme de série."},"bulletlist":{"title":"Les points rendent tout plus clair","description":"Vous pouvez créer une liste qui se démarquera du reste du contenu."},"table":{"title":"Réjouissez-vous du formatage","description":"Organisez vos informations dans un tableau pour avoir une vue d\'ensemble de votre travail."},"image":{"title":"Il faut le voir — Ajoutez une image","description":"Rendez vos pages plus attrayantes en ajoutant des images de tout type, en les déplaçant et en les redimensionnant."},"file":{"title":"Des fichiers ici, des fichiers là, des fichiers partout !","description":"Créez une base de données pour votre projet en ajoutant des fichiers de différents types d\'extensions à votre page."},"largeheading":{"title":"Parfait pour les sections principales de la page","description":"C\'est le plus grand titre que vous pouvez ajouter. Attirez l\'attention sur la partie la plus importante de votre page et facilitez votre navigation."},"mediumheading":{"title":"Parfait pour les sections secondaires de la page","description":"C\'est un titre de taille moyenne que vous pouvez ajouter. Divisez votre page en sections et trouvez facilement ce dont vous avez besoin."},"smallheading":{"title":"Parfait pour les grandes idées dans les sous-sections","description":"C\'est un petit titre que vous pouvez ajouter, mais il reste distinctif. Utilisez-le pour diviser votre page en sous-sections."},"tasks-list":{"title":"Organisez votre travail avec Nimbus Tasks","description":"Ici, vous pouvez regrouper vos tâches dans des listes de tâches. Attribuez des tâches à vos coéquipiers, définissez des échéances et ajoutez des statuts pour un suivi facile."},"hline":{"title":"Faisons une pause","description":"Séparez différentes parties d\'un projet ou divisez vos exemples et idées."},"link":{"title":"Tracez un chemin avec des liens","description":"Ajoutez un lien à votre projet et nommez-le chaque fois que vous avez une idée."},"syntax":{"title":"N\'oubliez pas le code","description":"Ajoutez du code directement sur votre page en changeant les thèmes, les langues et plus encore !"},"link-page":{"title":"Votre prochain arrêt est une autre page","description":"Liez une autre page connectée à ce projet et accédez-y facilement."},"date":{"title":"Dites simplement quand","description":"Fixez une échéance pour votre projet ou marquez l\'heure exacte du début de votre travail."},"mention":{"title":"Faites participer votre équipe","description":"Vos coéquipiers recevront des notifications par email pour ouvrir une page spécifique et y collaborer."},"blockquote":{"title":"Et je cite","description":"Mettez en avant des mots importants de vos clients ou une phrase motivante."},"hint":{"title":"Ajoutons un indice","description":"Choisissez un emoji et une couleur de fond pour mettre en évidence des avertissements, des avertissements ou des notifications."},"toggle":{"title":"Masquer et afficher le bloc de texte","description":"Triez et masquez des informations supplémentaires pour une navigation et un accès plus faciles."},"outline":{"title":"Voyez ce qui vous attend sur la page","description":"Créez une table des matières pour une navigation facile sur des pages longues ou des wikis."},"lock-blot":{"title":"Personne ne peut le modifier","description":"Rendez un bloc d\'information spécifique de votre page non modifiable et en lecture seule."},"embed":{"title":"Ajoutez plus qu\'un simple lien","description":"Intégrez d\'autres outils à votre page pour tout garder en un seul endroit, automatiquement mis à jour."},"figma":{"title":"Gardez vos visuels encore plus près","description":"Ajoutez Figma pour voir la conception des visuels de projet en temps réel."},"miro":{"title":"Votre tableau Miro est en lieu sûr","description":"Consultez une stratégie de mise en page ou une feuille de route pour votre projet et continuez à travailler sur votre page."},"columns":{"title":"Deux colonnes valent mieux qu\'une","description":"Divisez votre page en deux colonnes pour ajouter plus de contenu et la rendre plus nette."},"meeting-notes":{"title":"Fixez des objectifs et progressez","description":"Utilisez ce modèle pour créer une stratégie marketing et garder tous les détails en un seul endroit."},"marketing-brief":{"title":"Rêvez en grand, planifiez trimestre par trimestre","description":"Utilisez ce modèle pour établir un plan marketing par trimestres."},"content-plan":{"title":"Contrôlez et dirigez votre travail","description":"Utilisez ce modèle pour visualiser toutes les parties de votre projet et gérer les tâches."},"integrations":{"title":"Ajoutez plus qu\'un simple lien","description":"Intégrez d\'autres outils à votre page pour tout garder en un seul endroit et automatiquement mis à jour."},"google-drive":{"title":"Gérez vos fichiers depuis Google Drive","description":"Connectez votre compte Google Drive et insérez des liens vers vos fichiers pour un accès rapide."},"google-sheets":{"title":"Moins d\'onglets, plus d\'efficacité","description":"Gardez vos données au même endroit que les détails du projet pour tirer des conclusions plus facilement."},"bookmark":{"title":"Marquez votre lien avec un nouveau look","description":"Utilisez un marque-page pour afficher le titre de votre lien, une brève description et une image d\'aperçu du site."},"audioRec":{"title":"Dites-le, ne l\'écrivez pas","description":"Ajoutez une touche humaine à votre collaboration en enregistrant des retours vocaux pour le contenu de votre page."},"videoRec":{"title":"Montrez-le, ne l\'écrivez pas","description":"Enregistrez une explication visuelle de ce qui doit être fait ou donnez un retour explicite avec un exemple vidéo."},"button":{"title":"Venu, vu, cliqué","description":"Ajoutez un élément d\'appel à l\'action (CTA) pour attirer l\'attention sur des liens importants de vos pages."},"largeheading-toggle":{"title":"Cachez plus dans un titre dépliable de grande taille","description":"Définissez la partie la plus importante de votre page et cachez-y des informations pour un accès facile."},"mediumheading-toggle":{"title":"Rendez vos sections plus courtes","description":"Créez des sections avec un titre dépliable de taille moyenne et cachez-y une partie de votre contenu."},"smallheading-toggle":{"title":"Rendez vos sous-sections plus courtes","description":"Créez des sous-sections avec un petit titre dépliable sur vos pages et cachez-y des informations supplémentaires."},"database-with-options":{"title":"Oh, comme les tables ont changé","description":"Créez une base de données pour votre projet et personnalisez-la avec différents types de colonnes, des couleurs de fond et plus encore."},"board":{"title":"Accueillez vos tâches sur un tableau","description":"Affichez les tâches sous forme de cartes sur un tableau Kanban pour avoir une vue d\'ensemble."},"progress":{"title":"Voyez jusqu\'où vous êtes allé !","description":"Choisissez votre valeur et estimez-la. Évaluez et commentez vos contenus, tâches ou autres activités ajoutées."},"uploader":{"title":"Dites adieu au désordre des fichiers !","description":"Précisez les fichiers que vos clients ou votre équipe doivent envoyer. Avec le téléchargeur de fichiers, gardez tout au même endroit."},"dropdown-list":{"title":"Déroulez vos options","description":"Placez des options de réponse dans le texte et laissez les autres donner leur avis instantanément."},"use-ai":{"title":"Travaillez intelligemment, pas durement","description":"Utilisez l\'IA pour créer et améliorer votre contenu, obtenir de nouvelles idées et faire des recommandations personnalisées. Travaillez avec un assistant IA dans votre espace de travail."}},"feature_availability":{"plus":{"not-available":"Disponible pour les abonnements Plus, Team et Business","trial":"Ceci est ouvert en tant que fonctionnalité d\'essai Plus pour vous"},"team":{"not-available":"Disponible pour les abonnements Team et Business","trial":"Ceci est ouvert en tant que fonctionnalité d\'essai Team pour vous"},"business2023":{"not-available":"Disponible pour l\'abonnement Business","trial":"Ceci est ouvert en tant que fonctionnalité d\'essai Business pour vous"}}}');
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/plugins/i18n/index.js
function i18n_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { i18n_typeof = function _typeof(obj) { return typeof obj; }; } else { i18n_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return i18n_typeof(obj); }









function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (i18n_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }











var messages = {
  ru: ru_namespaceObject,
  en: en_namespaceObject,
  de: de_namespaceObject,
  it: it_namespaceObject,
  es: es_namespaceObject,
  tr: tr_namespaceObject,
  ua: ua_namespaceObject,
  fr: fr_namespaceObject
};
var i18nPluginInstance;
var IntlProvider = /*#__PURE__*/function (_Component) {
  _inherits(IntlProvider, _Component);
  var _super = _createSuper(IntlProvider);
  function IntlProvider() {
    _classCallCheck(this, IntlProvider);
    return _super.apply(this, arguments);
  }
  _createClass(IntlProvider, [{
    key: "render",
    value: function render() {
      if (!i18nPluginInstance) {
        throw new Error('i18n plugin must be initialized prior to any usage of IntlProvider');
      }
      return (0,preact_module.h)(preact_i18n_esm_IntlProvider, {
        definition: i18nPluginInstance.getCurrentDefinition()
      }, this.props.children);
    }
  }]);
  return IntlProvider;
}(preact_module/* Component */.wA);

var I18n = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function I18n(_ref) {
    var editor = _ref.editor,
      scroll = _ref.scroll,
      options = _ref.options;
    _classCallCheck(this, I18n);
    this.options = options || {};
    this.language = 'en';
    if (this.options.language && messages.hasOwnProperty(this.options.language)) {
      this.language = this.options.language;
    }
    // сохраняем глобально, для использования в провайдере
    i18nPluginInstance = this;
  }
  _createClass(I18n, [{
    key: "getCurrentDefinition",
    value: function getCurrentDefinition() {
      return messages[this.language];
    }
  }, {
    key: "get",
    value: function get(id, fields, plural, fallback) {
      return translate(id, '', this.getCurrentDefinition(), fields, plural, fallback);
    }
  }]);
  return I18n;
}()));


/***/ }),

/***/ 23497:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);
/* harmony import */ var _components_popupMenu__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10856);
/* harmony import */ var _components_popupDialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49096);
/* harmony import */ var _components_popupDialogTitle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83483);
/* harmony import */ var _components_popupDialogBody__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19617);
/* harmony import */ var _components_popupDialogButtons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25251);






var ConfirmPopup = function ConfirmPopup(props) {
  var onCancel = props.onCancel,
    onConfirm = props.onConfirm,
    title = props.title,
    message = props.message,
    confirmText = props.confirmText,
    cancelText = props.cancelText,
    editor = props.editor,
    _props$maxWidth = props.maxWidth,
    maxWidth = _props$maxWidth === void 0 ? 520 : _props$maxWidth,
    _props$revertButtons = props.revertButtons,
    revertButtons = _props$revertButtons === void 0 ? false : _props$revertButtons,
    _props$addClassName = props.addClassName,
    addClassName = _props$addClassName === void 0 ? 'column-convert-popup' : _props$addClassName;
  var buttons = {};
  if (cancelText) {
    buttons.cancel = {
      text: cancelText
    };
  }
  if (confirmText) {
    buttons.accept = {
      text: confirmText,
      style: 'active',
      onClick: onConfirm
    };
  }
  return h(PopupMenu, {
    wantsToClose: onCancel,
    addClassName: addClassName,
    closeOnEsc: true
  }, h(PopupDialog, {
    wantsToClose: onCancel,
    addClassName: 'reduced-padding',
    noCloseButton: true
  }, h(PopupDialogTitle, null, title), h(PopupDialogBody, {
    style: {
      'max-width': maxWidth + 'px'
    }
  }, h("p", null, h("span", null, message))), h(PopupDialogButtons, {
    editor: editor,
    wantsToClose: onCancel,
    buttons: buttons,
    revertButtons: revertButtons
  })));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ConfirmPopup)));

/***/ }),

/***/ 95174:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qZ": () => (/* binding */ TOOLTIP_ATTR),
/* harmony export */   "cD": () => (/* binding */ TOOLTIP_ADD_OPTIONS)
/* harmony export */ });
/* unused harmony exports TOOLTIP_ATTR_ALLOW_UNSAFE_HTML, TOOLTIP_SMALL_ATTR, TOOLTIP_TIMEOUT_ATTR, TOOLTIP_ADD_CLASS, default */
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _theme_scss_tooltip_vars_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29650);
/* harmony import */ var _theme_scss_tooltip_vars_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_theme_scss_tooltip_vars_scss__WEBPACK_IMPORTED_MODULE_1__);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var TOOLTIP_ATTR = 'data-editor-toolip';
var TOOLTIP_ATTR_ALLOW_UNSAFE_HTML = 'data-editor-tooltip-html';
var TOOLTIP_SMALL_ATTR = 'data-editor-toolip-small';
var TOOLTIP_TIMEOUT_ATTR = 'data-editor-tooltip-delay';
var TOOLTIP_ADD_CLASS = 'data-editor-tooltip-class';
var TOOLTIP_ADD_OPTIONS = 'data-editor-tooltip-options';


var TOOLTIP_NODE_CLASS = 'editor-tooltip';
var TOOLTIP_ARROW_CLASS = 'editor-tooltip-arrow';
var DEFAULT_TOOLTIP_SHOW_TIMEOUT = 200;
var transitionDuration = parseInt(_theme_scss_tooltip_vars_scss__WEBPACK_IMPORTED_MODULE_1__.transitionDuration);
var Tooltip = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function Tooltip(node, opts) {
    var _this = this;
    _classCallCheck(this, Tooltip);
    _defineProperty(this, "onMouseOver", function (event) {
      if (event.target === _this.node || _this.node.contains(event.target)) {
        return;
      }
      clearTimeout(_this.timer);
      if (!_this.isShown) {
        _this.removeMouseOverListener();
      } else {
        _this.destroy();
      }
    });
    _defineProperty(this, "removeMouseOverListener", function () {
      document.body.removeEventListener('mouseover', _this.onMouseOver, false);
    });
    _defineProperty(this, "onBodyMouseDown", function (event) {
      _this.destroy();
    });
    this.opts = opts;
    this.node = node;
    this.tooltipNode = null;
    this.container = opts.container || document.body;
    this.popper = null;
    this.isShown = false;
    this.destroyed = false;
    document.body.addEventListener('mouseover', this.onMouseOver, false);
    this.timer = setTimeout(function () {
      _this.show();
    }, this.opts.timeout);
  }
  _createClass(Tooltip, [{
    key: "runTransition",
    value: function runTransition(node, duration, type) {
      node.classList.add(TOOLTIP_NODE_CLASS + '-' + type);
      setTimeout(function () {
        node.classList.add(TOOLTIP_NODE_CLASS + '-' + type + '-active');
      }, 100);
      setTimeout(function () {
        node.classList.remove(TOOLTIP_NODE_CLASS + '-' + type);
      }, duration);
    }
  }, {
    key: "show",
    value: function show() {
      var _this2 = this;
      this.isShown = true;
      var node = document.createElement('div');
      node.classList.add(TOOLTIP_NODE_CLASS);
      this.tooltipNode = node;
      if (this.opts.addClass) {
        this.tooltipNode.classList.add(this.opts.addClass);
      }
      var textNode = document.createElement('span');
      var textAttr = this.opts.html ? 'innerHTML' : 'textContent';
      textNode[textAttr] = this.opts.text;
      var smallTextNode = null;
      if (this.opts.textSmall) {
        smallTextNode = document.createElement('small');
        smallTextNode[textAttr] = this.opts.textSmall;
      }
      var arrow = document.createElement('div');
      arrow.classList.add(TOOLTIP_ARROW_CLASS);
      node.appendChild(textNode);
      if (smallTextNode) {
        node.appendChild(smallTextNode);
      }
      node.appendChild(arrow);
      var popperOptions = Object.assign({}, {
        placement: 'top',
        positionFixed: true,
        modifiers: {
          offset: {
            offset: '0,10'
          },
          arrow: {
            element: arrow
          },
          preventOverflow: {
            boundariesElement: this.opts.scrollingContainer
          },
          flip: {
            boundariesElement: this.opts.scrollingContainer
          }
        }
      }, this.opts.options ? JSON.parse(this.opts.options) : {});
      popperOptions.onCreate = function () {
        _this2.runTransition(node, transitionDuration, 'enter');
      };
      this.container.appendChild(node);
      this.popper = new Popper(this.node, this.tooltipNode, popperOptions);
      document.addEventListener('mousedown', this.onBodyMouseDown);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.destroyed) {
        return;
      }
      // для случая если тултип еще не успел показатся очищаем таймер
      clearTimeout(this.timer);
      document.removeEventListener('mousedown', this.onBodyMouseDown);
      this.destroyed = true;
      if (this.popper) {
        // поппер может быть еще не создан из-за таймаута показа
        this.popper.destroy();
      }
      if (this.tooltipNode) {
        // tooltipNode может быть еще не создана из-за таймаута показа
        this.tooltipNode.parentNode.removeChild(this.tooltipNode);
      }
      this.removeMouseOverListener();
    }
  }]);
  return Tooltip;
}()));
var TooltipManager = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function TooltipManager(_ref) {
    var _this3 = this;
    var scroll = _ref.scroll,
      editor = _ref.editor,
      options = _ref.options;
    _classCallCheck(this, TooltipManager);
    _defineProperty(this, "onMouseOver", function (event) {
      // пока отключил показ тултипов для редактора, если к нему применен css scale,
      // так как тултипы показываются совсем не там где нужно, скейл ломает позиционирование поппера
      if (_this3.editor.options.scale !== undefined && _this3.editor.options.scale !== 0) {
        return;
      }
      if (!event.target.closest) {
        return;
      }
      var tooltipNode = event.target.closest('[' + TOOLTIP_ATTR + ']');
      if (!tooltipNode) {
        return;
      }
      if (_this3.tooltip) {
        _this3.tooltip.destroy();
      }
      var tooltip = new Tooltip(tooltipNode, {
        text: tooltipNode.getAttribute(TOOLTIP_ATTR),
        textSmall: tooltipNode.getAttribute(TOOLTIP_SMALL_ATTR),
        container: _this3.editor.getScrollingContainer(),
        timeout: tooltipNode.getAttribute(TOOLTIP_TIMEOUT_ATTR) || DEFAULT_TOOLTIP_SHOW_TIMEOUT,
        addClass: tooltipNode.getAttribute(TOOLTIP_ADD_CLASS),
        options: tooltipNode.getAttribute(TOOLTIP_ADD_OPTIONS),
        html: tooltipNode.getAttribute(TOOLTIP_ATTR_ALLOW_UNSAFE_HTML) === '1',
        scrollingContainer: _this3.editor.getScrollingContainer()
      });
      _this3.tooltip = tooltip;
    });
    options = Object.assign({
      enabled: true
    }, options);
    this.editor = editor;
    this.scroll = scroll;
    this.tooltip = null;
    this.enabled = options.enabled;
    this.init();
  }
  _createClass(TooltipManager, [{
    key: "init",
    value: function init() {
      if (!this.enabled) {
        return;
      }
      this.editor.getScrollingContainer().addEventListener('mouseover', this.onMouseOver, false);
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.tooltip) {
        this.tooltip.destroy();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.editor.getScrollingContainer().removeEventListener('mouseover', this.onMouseOver, false);
    }
  }]);
  return TooltipManager;
}()));


/***/ }),

/***/ 49190:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SC9": () => (/* reexport default from dynamic */ _images_icons_plus_svg__WEBPACK_IMPORTED_MODULE_15___default.a),
/* harmony export */   "UrD": () => (/* reexport default from dynamic */ _images_icons_minus_svg__WEBPACK_IMPORTED_MODULE_16___default.a),
/* harmony export */   "Ec8": () => (/* reexport default from dynamic */ _images_icons_arrow_right_svg__WEBPACK_IMPORTED_MODULE_25___default.a),
/* harmony export */   "bMz": () => (/* reexport default from dynamic */ _images_icons_icon_close_svg__WEBPACK_IMPORTED_MODULE_55___default.a),
/* harmony export */   "ed9": () => (/* reexport default from dynamic */ _images_icons_chevron_left_svg__WEBPACK_IMPORTED_MODULE_64___default.a),
/* harmony export */   "EZi": () => (/* reexport default from dynamic */ _images_icons_done_color_svg__WEBPACK_IMPORTED_MODULE_78___default.a),
/* harmony export */   "DgX": () => (/* reexport default from dynamic */ _images_icons_pin_button_svg__WEBPACK_IMPORTED_MODULE_164___default.a),
/* harmony export */   "uII": () => (/* reexport default from dynamic */ _images_icons_unpin_button_svg__WEBPACK_IMPORTED_MODULE_165___default.a)
/* harmony export */ });
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);
/* harmony import */ var _images_icons_checkbox_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98892);
/* harmony import */ var _images_icons_checkbox_svg__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_images_icons_checkbox_svg__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _images_icons_list_number_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47238);
/* harmony import */ var _images_icons_list_number_svg__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_number_svg__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _images_icons_list_bullet_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95161);
/* harmony import */ var _images_icons_list_bullet_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_bullet_svg__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _images_icons_table_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20913);
/* harmony import */ var _images_icons_table_svg__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_images_icons_table_svg__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _images_icons_smile_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37620);
/* harmony import */ var _images_icons_smile_svg__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_images_icons_smile_svg__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _images_icons_image_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50375);
/* harmony import */ var _images_icons_image_svg__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_images_icons_image_svg__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _images_icons_empty_image_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80648);
/* harmony import */ var _images_icons_empty_image_svg__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_images_icons_empty_image_svg__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _images_icons_file_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7086);
/* harmony import */ var _images_icons_file_svg__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_images_icons_file_svg__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _images_icons_pin_btn_svg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4421);
/* harmony import */ var _images_icons_pin_btn_svg__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_images_icons_pin_btn_svg__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _images_icons_header_small_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70191);
/* harmony import */ var _images_icons_header_small_svg__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_images_icons_header_small_svg__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _images_icons_header_medium_svg__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41701);
/* harmony import */ var _images_icons_header_medium_svg__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_images_icons_header_medium_svg__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _images_icons_header_large_svg__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1305);
/* harmony import */ var _images_icons_header_large_svg__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_images_icons_header_large_svg__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _images_icons_hline_svg__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(28444);
/* harmony import */ var _images_icons_hline_svg__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_images_icons_hline_svg__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _images_icons_link_svg__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(60623);
/* harmony import */ var _images_icons_link_svg__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_images_icons_link_svg__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _images_icons_plus_svg__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(36520);
/* harmony import */ var _images_icons_plus_svg__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_images_icons_plus_svg__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _images_icons_minus_svg__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(31958);
/* harmony import */ var _images_icons_minus_svg__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_images_icons_minus_svg__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _images_icons_bold_svg__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69425);
/* harmony import */ var _images_icons_bold_svg__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_images_icons_bold_svg__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _images_icons_italic_svg__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(34061);
/* harmony import */ var _images_icons_italic_svg__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_images_icons_italic_svg__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _images_icons_underline_svg__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(78555);
/* harmony import */ var _images_icons_underline_svg__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_images_icons_underline_svg__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _images_icons_strikethrough_svg__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(27501);
/* harmony import */ var _images_icons_strikethrough_svg__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_images_icons_strikethrough_svg__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _images_icons_highlight_svg__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(81740);
/* harmony import */ var _images_icons_highlight_svg__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_images_icons_highlight_svg__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _images_icons_trash_svg__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(77242);
/* harmony import */ var _images_icons_trash_svg__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_images_icons_trash_svg__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _images_icons_edit_svg__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(13783);
/* harmony import */ var _images_icons_edit_svg__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_images_icons_edit_svg__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _images_icons_arrow_left_svg__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(61177);
/* harmony import */ var _images_icons_arrow_left_svg__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_images_icons_arrow_left_svg__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _images_icons_arrow_right_svg__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(83675);
/* harmony import */ var _images_icons_arrow_right_svg__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_images_icons_arrow_right_svg__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _images_icons_arrow_down_svg__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(19379);
/* harmony import */ var _images_icons_arrow_down_svg__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_images_icons_arrow_down_svg__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _images_icons_paragraph_svg__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(36419);
/* harmony import */ var _images_icons_paragraph_svg__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_images_icons_paragraph_svg__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _images_icons_no_color_svg__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(42477);
/* harmony import */ var _images_icons_no_color_svg__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_images_icons_no_color_svg__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _images_icons_no_color_light_svg__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(99562);
/* harmony import */ var _images_icons_no_color_light_svg__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_images_icons_no_color_light_svg__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _images_icons_no_color_dark_svg__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(36771);
/* harmony import */ var _images_icons_no_color_dark_svg__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_images_icons_no_color_dark_svg__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _images_icons_align_left_svg__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(35596);
/* harmony import */ var _images_icons_align_left_svg__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_images_icons_align_left_svg__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _images_icons_align_center_svg__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(87163);
/* harmony import */ var _images_icons_align_center_svg__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_images_icons_align_center_svg__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _images_icons_align_right_svg__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(4802);
/* harmony import */ var _images_icons_align_right_svg__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_images_icons_align_right_svg__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _images_icons_align_justify_svg__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(36842);
/* harmony import */ var _images_icons_align_justify_svg__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_images_icons_align_justify_svg__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _images_icons_valign_top_svg__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(10226);
/* harmony import */ var _images_icons_valign_top_svg__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_images_icons_valign_top_svg__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _images_icons_valign_center_svg__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(52725);
/* harmony import */ var _images_icons_valign_center_svg__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(_images_icons_valign_center_svg__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _images_icons_valign_bottom_svg__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(59146);
/* harmony import */ var _images_icons_valign_bottom_svg__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(_images_icons_valign_bottom_svg__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var _images_icons_indent_svg__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(11894);
/* harmony import */ var _images_icons_indent_svg__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(_images_icons_indent_svg__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _images_icons_outdent_svg__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(7306);
/* harmony import */ var _images_icons_outdent_svg__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(_images_icons_outdent_svg__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _images_icons_clear_formatting_svg__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(57872);
/* harmony import */ var _images_icons_clear_formatting_svg__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(_images_icons_clear_formatting_svg__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var _images_icons_list_circle_svg__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(30350);
/* harmony import */ var _images_icons_list_circle_svg__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_circle_svg__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var _images_icons_list_rectangle_svg__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(56987);
/* harmony import */ var _images_icons_list_rectangle_svg__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_rectangle_svg__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var _images_icons_list_star_svg__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(60965);
/* harmony import */ var _images_icons_list_star_svg__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_star_svg__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var _images_icons_list_dart_svg__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(35235);
/* harmony import */ var _images_icons_list_dart_svg__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_dart_svg__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var _images_icons_list_rounded_svg__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(74107);
/* harmony import */ var _images_icons_list_rounded_svg__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_rounded_svg__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var _images_icons_list_arrow_svg__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(12479);
/* harmony import */ var _images_icons_list_arrow_svg__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_arrow_svg__WEBPACK_IMPORTED_MODULE_46__);
/* harmony import */ var _images_icons_list_diamond_svg__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(59481);
/* harmony import */ var _images_icons_list_diamond_svg__WEBPACK_IMPORTED_MODULE_47___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_diamond_svg__WEBPACK_IMPORTED_MODULE_47__);
/* harmony import */ var _images_icons_embed_align_left_svg__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(54970);
/* harmony import */ var _images_icons_embed_align_left_svg__WEBPACK_IMPORTED_MODULE_48___default = /*#__PURE__*/__webpack_require__.n(_images_icons_embed_align_left_svg__WEBPACK_IMPORTED_MODULE_48__);
/* harmony import */ var _images_icons_embed_align_center_svg__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(55782);
/* harmony import */ var _images_icons_embed_align_center_svg__WEBPACK_IMPORTED_MODULE_49___default = /*#__PURE__*/__webpack_require__.n(_images_icons_embed_align_center_svg__WEBPACK_IMPORTED_MODULE_49__);
/* harmony import */ var _images_icons_embed_align_right_svg__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(51093);
/* harmony import */ var _images_icons_embed_align_right_svg__WEBPACK_IMPORTED_MODULE_50___default = /*#__PURE__*/__webpack_require__.n(_images_icons_embed_align_right_svg__WEBPACK_IMPORTED_MODULE_50__);
/* harmony import */ var _images_icons_embed_align_fullwidth_svg__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(47529);
/* harmony import */ var _images_icons_embed_align_fullwidth_svg__WEBPACK_IMPORTED_MODULE_51___default = /*#__PURE__*/__webpack_require__.n(_images_icons_embed_align_fullwidth_svg__WEBPACK_IMPORTED_MODULE_51__);
/* harmony import */ var _images_icons_add_row_svg__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(30245);
/* harmony import */ var _images_icons_add_row_svg__WEBPACK_IMPORTED_MODULE_52___default = /*#__PURE__*/__webpack_require__.n(_images_icons_add_row_svg__WEBPACK_IMPORTED_MODULE_52__);
/* harmony import */ var _images_icons_add_column_svg__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(22032);
/* harmony import */ var _images_icons_add_column_svg__WEBPACK_IMPORTED_MODULE_53___default = /*#__PURE__*/__webpack_require__.n(_images_icons_add_column_svg__WEBPACK_IMPORTED_MODULE_53__);
/* harmony import */ var _images_icons_resize_svg__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(91323);
/* harmony import */ var _images_icons_resize_svg__WEBPACK_IMPORTED_MODULE_54___default = /*#__PURE__*/__webpack_require__.n(_images_icons_resize_svg__WEBPACK_IMPORTED_MODULE_54__);
/* harmony import */ var _images_icons_icon_close_svg__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(66995);
/* harmony import */ var _images_icons_icon_close_svg__WEBPACK_IMPORTED_MODULE_55___default = /*#__PURE__*/__webpack_require__.n(_images_icons_icon_close_svg__WEBPACK_IMPORTED_MODULE_55__);
/* harmony import */ var _images_icons_quote_svg__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(67308);
/* harmony import */ var _images_icons_quote_svg__WEBPACK_IMPORTED_MODULE_56___default = /*#__PURE__*/__webpack_require__.n(_images_icons_quote_svg__WEBPACK_IMPORTED_MODULE_56__);
/* harmony import */ var _images_icons_audio_svg__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(4817);
/* harmony import */ var _images_icons_audio_svg__WEBPACK_IMPORTED_MODULE_57___default = /*#__PURE__*/__webpack_require__.n(_images_icons_audio_svg__WEBPACK_IMPORTED_MODULE_57__);
/* harmony import */ var _images_icons_document_svg__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(41286);
/* harmony import */ var _images_icons_document_svg__WEBPACK_IMPORTED_MODULE_58___default = /*#__PURE__*/__webpack_require__.n(_images_icons_document_svg__WEBPACK_IMPORTED_MODULE_58__);
/* harmony import */ var _images_icons_image2_svg__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(93034);
/* harmony import */ var _images_icons_image2_svg__WEBPACK_IMPORTED_MODULE_59___default = /*#__PURE__*/__webpack_require__.n(_images_icons_image2_svg__WEBPACK_IMPORTED_MODULE_59__);
/* harmony import */ var _images_icons_video_svg__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(22220);
/* harmony import */ var _images_icons_video_svg__WEBPACK_IMPORTED_MODULE_60___default = /*#__PURE__*/__webpack_require__.n(_images_icons_video_svg__WEBPACK_IMPORTED_MODULE_60__);
/* harmony import */ var _images_icons_more_vertical_svg__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(46605);
/* harmony import */ var _images_icons_more_vertical_svg__WEBPACK_IMPORTED_MODULE_61___default = /*#__PURE__*/__webpack_require__.n(_images_icons_more_vertical_svg__WEBPACK_IMPORTED_MODULE_61__);
/* harmony import */ var _images_icons_file_other_svg__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(51392);
/* harmony import */ var _images_icons_file_other_svg__WEBPACK_IMPORTED_MODULE_62___default = /*#__PURE__*/__webpack_require__.n(_images_icons_file_other_svg__WEBPACK_IMPORTED_MODULE_62__);
/* harmony import */ var _images_icons_code_format_svg__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(47778);
/* harmony import */ var _images_icons_code_format_svg__WEBPACK_IMPORTED_MODULE_63___default = /*#__PURE__*/__webpack_require__.n(_images_icons_code_format_svg__WEBPACK_IMPORTED_MODULE_63__);
/* harmony import */ var _images_icons_chevron_left_svg__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(47904);
/* harmony import */ var _images_icons_chevron_left_svg__WEBPACK_IMPORTED_MODULE_64___default = /*#__PURE__*/__webpack_require__.n(_images_icons_chevron_left_svg__WEBPACK_IMPORTED_MODULE_64__);
/* harmony import */ var _images_icons_chevron_right_svg__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(16186);
/* harmony import */ var _images_icons_chevron_right_svg__WEBPACK_IMPORTED_MODULE_65___default = /*#__PURE__*/__webpack_require__.n(_images_icons_chevron_right_svg__WEBPACK_IMPORTED_MODULE_65__);
/* harmony import */ var _images_icons_search2_svg__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(26350);
/* harmony import */ var _images_icons_search2_svg__WEBPACK_IMPORTED_MODULE_66___default = /*#__PURE__*/__webpack_require__.n(_images_icons_search2_svg__WEBPACK_IMPORTED_MODULE_66__);
/* harmony import */ var _images_icons_maximize_svg__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(29828);
/* harmony import */ var _images_icons_maximize_svg__WEBPACK_IMPORTED_MODULE_67___default = /*#__PURE__*/__webpack_require__.n(_images_icons_maximize_svg__WEBPACK_IMPORTED_MODULE_67__);
/* harmony import */ var _images_icons_minimize_svg__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(63821);
/* harmony import */ var _images_icons_minimize_svg__WEBPACK_IMPORTED_MODULE_68___default = /*#__PURE__*/__webpack_require__.n(_images_icons_minimize_svg__WEBPACK_IMPORTED_MODULE_68__);
/* harmony import */ var _images_icons_pause_svg__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(26143);
/* harmony import */ var _images_icons_pause_svg__WEBPACK_IMPORTED_MODULE_69___default = /*#__PURE__*/__webpack_require__.n(_images_icons_pause_svg__WEBPACK_IMPORTED_MODULE_69__);
/* harmony import */ var _images_icons_play_svg__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(1250);
/* harmony import */ var _images_icons_play_svg__WEBPACK_IMPORTED_MODULE_70___default = /*#__PURE__*/__webpack_require__.n(_images_icons_play_svg__WEBPACK_IMPORTED_MODULE_70__);
/* harmony import */ var _images_icons_audioRec_svg__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(69710);
/* harmony import */ var _images_icons_audioRec_svg__WEBPACK_IMPORTED_MODULE_71___default = /*#__PURE__*/__webpack_require__.n(_images_icons_audioRec_svg__WEBPACK_IMPORTED_MODULE_71__);
/* harmony import */ var _images_icons_videoRec_svg__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(27237);
/* harmony import */ var _images_icons_videoRec_svg__WEBPACK_IMPORTED_MODULE_72___default = /*#__PURE__*/__webpack_require__.n(_images_icons_videoRec_svg__WEBPACK_IMPORTED_MODULE_72__);
/* harmony import */ var _images_icons_pause_big_svg__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(46015);
/* harmony import */ var _images_icons_pause_big_svg__WEBPACK_IMPORTED_MODULE_73___default = /*#__PURE__*/__webpack_require__.n(_images_icons_pause_big_svg__WEBPACK_IMPORTED_MODULE_73__);
/* harmony import */ var _images_icons_play_big_svg__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(69499);
/* harmony import */ var _images_icons_play_big_svg__WEBPACK_IMPORTED_MODULE_74___default = /*#__PURE__*/__webpack_require__.n(_images_icons_play_big_svg__WEBPACK_IMPORTED_MODULE_74__);
/* harmony import */ var _images_icons_volume_1_svg__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(4311);
/* harmony import */ var _images_icons_volume_1_svg__WEBPACK_IMPORTED_MODULE_75___default = /*#__PURE__*/__webpack_require__.n(_images_icons_volume_1_svg__WEBPACK_IMPORTED_MODULE_75__);
/* harmony import */ var _images_icons_volume_2_svg__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(84005);
/* harmony import */ var _images_icons_volume_2_svg__WEBPACK_IMPORTED_MODULE_76___default = /*#__PURE__*/__webpack_require__.n(_images_icons_volume_2_svg__WEBPACK_IMPORTED_MODULE_76__);
/* harmony import */ var _images_icons_volume_x_svg__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(80347);
/* harmony import */ var _images_icons_volume_x_svg__WEBPACK_IMPORTED_MODULE_77___default = /*#__PURE__*/__webpack_require__.n(_images_icons_volume_x_svg__WEBPACK_IMPORTED_MODULE_77__);
/* harmony import */ var _images_icons_done_color_svg__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(91177);
/* harmony import */ var _images_icons_done_color_svg__WEBPACK_IMPORTED_MODULE_78___default = /*#__PURE__*/__webpack_require__.n(_images_icons_done_color_svg__WEBPACK_IMPORTED_MODULE_78__);
/* harmony import */ var _images_icons_type_checkbox_svg__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(64631);
/* harmony import */ var _images_icons_type_checkbox_svg__WEBPACK_IMPORTED_MODULE_79___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_checkbox_svg__WEBPACK_IMPORTED_MODULE_79__);
/* harmony import */ var _images_icons_type_currency_svg__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(325);
/* harmony import */ var _images_icons_type_currency_svg__WEBPACK_IMPORTED_MODULE_80___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_currency_svg__WEBPACK_IMPORTED_MODULE_80__);
/* harmony import */ var _images_icons_type_multiselect_svg__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(12154);
/* harmony import */ var _images_icons_type_multiselect_svg__WEBPACK_IMPORTED_MODULE_81___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_multiselect_svg__WEBPACK_IMPORTED_MODULE_81__);
/* harmony import */ var _images_icons_type_number_svg__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(39046);
/* harmony import */ var _images_icons_type_number_svg__WEBPACK_IMPORTED_MODULE_82___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_number_svg__WEBPACK_IMPORTED_MODULE_82__);
/* harmony import */ var _images_icons_type_progress_svg__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(92702);
/* harmony import */ var _images_icons_type_progress_svg__WEBPACK_IMPORTED_MODULE_83___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_progress_svg__WEBPACK_IMPORTED_MODULE_83__);
/* harmony import */ var _images_icons_type_singleselect_svg__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(56486);
/* harmony import */ var _images_icons_type_singleselect_svg__WEBPACK_IMPORTED_MODULE_84___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_singleselect_svg__WEBPACK_IMPORTED_MODULE_84__);
/* harmony import */ var _images_icons_type_text_svg__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(85265);
/* harmony import */ var _images_icons_type_text_svg__WEBPACK_IMPORTED_MODULE_85___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_text_svg__WEBPACK_IMPORTED_MODULE_85__);
/* harmony import */ var _images_icons_type_mention_svg__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(66339);
/* harmony import */ var _images_icons_type_mention_svg__WEBPACK_IMPORTED_MODULE_86___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_mention_svg__WEBPACK_IMPORTED_MODULE_86__);
/* harmony import */ var _images_icons_type_collaborator_svg__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(33753);
/* harmony import */ var _images_icons_type_collaborator_svg__WEBPACK_IMPORTED_MODULE_87___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_collaborator_svg__WEBPACK_IMPORTED_MODULE_87__);
/* harmony import */ var _images_icons_type_date_svg__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(24655);
/* harmony import */ var _images_icons_type_date_svg__WEBPACK_IMPORTED_MODULE_88___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_date_svg__WEBPACK_IMPORTED_MODULE_88__);
/* harmony import */ var _images_icons_type_attachment_svg__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(93858);
/* harmony import */ var _images_icons_type_attachment_svg__WEBPACK_IMPORTED_MODULE_89___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_attachment_svg__WEBPACK_IMPORTED_MODULE_89__);
/* harmony import */ var _images_icons_type_link_svg__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(52124);
/* harmony import */ var _images_icons_type_link_svg__WEBPACK_IMPORTED_MODULE_90___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_link_svg__WEBPACK_IMPORTED_MODULE_90__);
/* harmony import */ var _images_icons_type_rating_svg__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(21685);
/* harmony import */ var _images_icons_type_rating_svg__WEBPACK_IMPORTED_MODULE_91___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_rating_svg__WEBPACK_IMPORTED_MODULE_91__);
/* harmony import */ var _images_icons_progress_simple_svg__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(49962);
/* harmony import */ var _images_icons_progress_simple_svg__WEBPACK_IMPORTED_MODULE_92___default = /*#__PURE__*/__webpack_require__.n(_images_icons_progress_simple_svg__WEBPACK_IMPORTED_MODULE_92__);
/* harmony import */ var _images_icons_progress_colored_svg__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(14211);
/* harmony import */ var _images_icons_progress_colored_svg__WEBPACK_IMPORTED_MODULE_93___default = /*#__PURE__*/__webpack_require__.n(_images_icons_progress_colored_svg__WEBPACK_IMPORTED_MODULE_93__);
/* harmony import */ var _images_icons_rating_star_light_svg__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(4735);
/* harmony import */ var _images_icons_rating_star_light_svg__WEBPACK_IMPORTED_MODULE_94___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_star_light_svg__WEBPACK_IMPORTED_MODULE_94__);
/* harmony import */ var _images_icons_rating_star_gray_svg__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(75851);
/* harmony import */ var _images_icons_rating_star_gray_svg__WEBPACK_IMPORTED_MODULE_95___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_star_gray_svg__WEBPACK_IMPORTED_MODULE_95__);
/* harmony import */ var _images_icons_rating_star_red_svg__WEBPACK_IMPORTED_MODULE_96__ = __webpack_require__(76936);
/* harmony import */ var _images_icons_rating_star_red_svg__WEBPACK_IMPORTED_MODULE_96___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_star_red_svg__WEBPACK_IMPORTED_MODULE_96__);
/* harmony import */ var _images_icons_rating_star_blue_svg__WEBPACK_IMPORTED_MODULE_97__ = __webpack_require__(37322);
/* harmony import */ var _images_icons_rating_star_blue_svg__WEBPACK_IMPORTED_MODULE_97___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_star_blue_svg__WEBPACK_IMPORTED_MODULE_97__);
/* harmony import */ var _images_icons_rating_flag_light_svg__WEBPACK_IMPORTED_MODULE_98__ = __webpack_require__(98763);
/* harmony import */ var _images_icons_rating_flag_light_svg__WEBPACK_IMPORTED_MODULE_98___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_flag_light_svg__WEBPACK_IMPORTED_MODULE_98__);
/* harmony import */ var _images_icons_rating_flag_gray_svg__WEBPACK_IMPORTED_MODULE_99__ = __webpack_require__(80764);
/* harmony import */ var _images_icons_rating_flag_gray_svg__WEBPACK_IMPORTED_MODULE_99___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_flag_gray_svg__WEBPACK_IMPORTED_MODULE_99__);
/* harmony import */ var _images_icons_rating_flag_red_svg__WEBPACK_IMPORTED_MODULE_100__ = __webpack_require__(55009);
/* harmony import */ var _images_icons_rating_flag_red_svg__WEBPACK_IMPORTED_MODULE_100___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_flag_red_svg__WEBPACK_IMPORTED_MODULE_100__);
/* harmony import */ var _images_icons_rating_flag_blue_svg__WEBPACK_IMPORTED_MODULE_101__ = __webpack_require__(8507);
/* harmony import */ var _images_icons_rating_flag_blue_svg__WEBPACK_IMPORTED_MODULE_101___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_flag_blue_svg__WEBPACK_IMPORTED_MODULE_101__);
/* harmony import */ var _images_icons_rating_heart_light_svg__WEBPACK_IMPORTED_MODULE_102__ = __webpack_require__(16030);
/* harmony import */ var _images_icons_rating_heart_light_svg__WEBPACK_IMPORTED_MODULE_102___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_heart_light_svg__WEBPACK_IMPORTED_MODULE_102__);
/* harmony import */ var _images_icons_rating_heart_gray_svg__WEBPACK_IMPORTED_MODULE_103__ = __webpack_require__(85625);
/* harmony import */ var _images_icons_rating_heart_gray_svg__WEBPACK_IMPORTED_MODULE_103___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_heart_gray_svg__WEBPACK_IMPORTED_MODULE_103__);
/* harmony import */ var _images_icons_rating_heart_red_svg__WEBPACK_IMPORTED_MODULE_104__ = __webpack_require__(61335);
/* harmony import */ var _images_icons_rating_heart_red_svg__WEBPACK_IMPORTED_MODULE_104___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_heart_red_svg__WEBPACK_IMPORTED_MODULE_104__);
/* harmony import */ var _images_icons_rating_heart_blue_svg__WEBPACK_IMPORTED_MODULE_105__ = __webpack_require__(71138);
/* harmony import */ var _images_icons_rating_heart_blue_svg__WEBPACK_IMPORTED_MODULE_105___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_heart_blue_svg__WEBPACK_IMPORTED_MODULE_105__);
/* harmony import */ var _images_icons_cross_svg__WEBPACK_IMPORTED_MODULE_106__ = __webpack_require__(33597);
/* harmony import */ var _images_icons_cross_svg__WEBPACK_IMPORTED_MODULE_106___default = /*#__PURE__*/__webpack_require__.n(_images_icons_cross_svg__WEBPACK_IMPORTED_MODULE_106__);
/* harmony import */ var _images_icons_alert_svg__WEBPACK_IMPORTED_MODULE_107__ = __webpack_require__(32577);
/* harmony import */ var _images_icons_alert_svg__WEBPACK_IMPORTED_MODULE_107___default = /*#__PURE__*/__webpack_require__.n(_images_icons_alert_svg__WEBPACK_IMPORTED_MODULE_107__);
/* harmony import */ var _images_icons_download2_svg__WEBPACK_IMPORTED_MODULE_108__ = __webpack_require__(27317);
/* harmony import */ var _images_icons_download2_svg__WEBPACK_IMPORTED_MODULE_108___default = /*#__PURE__*/__webpack_require__.n(_images_icons_download2_svg__WEBPACK_IMPORTED_MODULE_108__);
/* harmony import */ var _images_icons_note_svg__WEBPACK_IMPORTED_MODULE_109__ = __webpack_require__(8386);
/* harmony import */ var _images_icons_note_svg__WEBPACK_IMPORTED_MODULE_109___default = /*#__PURE__*/__webpack_require__.n(_images_icons_note_svg__WEBPACK_IMPORTED_MODULE_109__);
/* harmony import */ var _images_icons_folder_svg__WEBPACK_IMPORTED_MODULE_110__ = __webpack_require__(32472);
/* harmony import */ var _images_icons_folder_svg__WEBPACK_IMPORTED_MODULE_110___default = /*#__PURE__*/__webpack_require__.n(_images_icons_folder_svg__WEBPACK_IMPORTED_MODULE_110__);
/* harmony import */ var _images_icons_workspace_svg__WEBPACK_IMPORTED_MODULE_111__ = __webpack_require__(7294);
/* harmony import */ var _images_icons_workspace_svg__WEBPACK_IMPORTED_MODULE_111___default = /*#__PURE__*/__webpack_require__.n(_images_icons_workspace_svg__WEBPACK_IMPORTED_MODULE_111__);
/* harmony import */ var _images_icons_shared_svg__WEBPACK_IMPORTED_MODULE_112__ = __webpack_require__(31665);
/* harmony import */ var _images_icons_shared_svg__WEBPACK_IMPORTED_MODULE_112___default = /*#__PURE__*/__webpack_require__.n(_images_icons_shared_svg__WEBPACK_IMPORTED_MODULE_112__);
/* harmony import */ var _images_icons_favorites_svg__WEBPACK_IMPORTED_MODULE_113__ = __webpack_require__(84581);
/* harmony import */ var _images_icons_favorites_svg__WEBPACK_IMPORTED_MODULE_113___default = /*#__PURE__*/__webpack_require__.n(_images_icons_favorites_svg__WEBPACK_IMPORTED_MODULE_113__);
/* harmony import */ var _images_icons_todo_svg__WEBPACK_IMPORTED_MODULE_114__ = __webpack_require__(88536);
/* harmony import */ var _images_icons_todo_svg__WEBPACK_IMPORTED_MODULE_114___default = /*#__PURE__*/__webpack_require__.n(_images_icons_todo_svg__WEBPACK_IMPORTED_MODULE_114__);
/* harmony import */ var _images_icons_syntax_svg__WEBPACK_IMPORTED_MODULE_115__ = __webpack_require__(18294);
/* harmony import */ var _images_icons_syntax_svg__WEBPACK_IMPORTED_MODULE_115___default = /*#__PURE__*/__webpack_require__.n(_images_icons_syntax_svg__WEBPACK_IMPORTED_MODULE_115__);
/* harmony import */ var _images_icons_templates_svg__WEBPACK_IMPORTED_MODULE_116__ = __webpack_require__(62171);
/* harmony import */ var _images_icons_templates_svg__WEBPACK_IMPORTED_MODULE_116___default = /*#__PURE__*/__webpack_require__.n(_images_icons_templates_svg__WEBPACK_IMPORTED_MODULE_116__);
/* harmony import */ var _images_icons_question_svg__WEBPACK_IMPORTED_MODULE_117__ = __webpack_require__(40286);
/* harmony import */ var _images_icons_question_svg__WEBPACK_IMPORTED_MODULE_117___default = /*#__PURE__*/__webpack_require__.n(_images_icons_question_svg__WEBPACK_IMPORTED_MODULE_117__);
/* harmony import */ var _images_icons_sort_ascending_svg__WEBPACK_IMPORTED_MODULE_118__ = __webpack_require__(17884);
/* harmony import */ var _images_icons_sort_ascending_svg__WEBPACK_IMPORTED_MODULE_118___default = /*#__PURE__*/__webpack_require__.n(_images_icons_sort_ascending_svg__WEBPACK_IMPORTED_MODULE_118__);
/* harmony import */ var _images_icons_sort_descending_svg__WEBPACK_IMPORTED_MODULE_119__ = __webpack_require__(59681);
/* harmony import */ var _images_icons_sort_descending_svg__WEBPACK_IMPORTED_MODULE_119___default = /*#__PURE__*/__webpack_require__.n(_images_icons_sort_descending_svg__WEBPACK_IMPORTED_MODULE_119__);
/* harmony import */ var _images_icons_mention_svg__WEBPACK_IMPORTED_MODULE_120__ = __webpack_require__(94384);
/* harmony import */ var _images_icons_mention_svg__WEBPACK_IMPORTED_MODULE_120___default = /*#__PURE__*/__webpack_require__.n(_images_icons_mention_svg__WEBPACK_IMPORTED_MODULE_120__);
/* harmony import */ var _images_icons_tasks_svg__WEBPACK_IMPORTED_MODULE_121__ = __webpack_require__(12216);
/* harmony import */ var _images_icons_tasks_svg__WEBPACK_IMPORTED_MODULE_121___default = /*#__PURE__*/__webpack_require__.n(_images_icons_tasks_svg__WEBPACK_IMPORTED_MODULE_121__);
/* harmony import */ var _images_icons_outline_svg__WEBPACK_IMPORTED_MODULE_122__ = __webpack_require__(68234);
/* harmony import */ var _images_icons_outline_svg__WEBPACK_IMPORTED_MODULE_122___default = /*#__PURE__*/__webpack_require__.n(_images_icons_outline_svg__WEBPACK_IMPORTED_MODULE_122__);
/* harmony import */ var _images_icons_check_svg__WEBPACK_IMPORTED_MODULE_123__ = __webpack_require__(21855);
/* harmony import */ var _images_icons_check_svg__WEBPACK_IMPORTED_MODULE_123___default = /*#__PURE__*/__webpack_require__.n(_images_icons_check_svg__WEBPACK_IMPORTED_MODULE_123__);
/* harmony import */ var _images_icons_arrow_right_rounded_svg__WEBPACK_IMPORTED_MODULE_124__ = __webpack_require__(61093);
/* harmony import */ var _images_icons_arrow_right_rounded_svg__WEBPACK_IMPORTED_MODULE_124___default = /*#__PURE__*/__webpack_require__.n(_images_icons_arrow_right_rounded_svg__WEBPACK_IMPORTED_MODULE_124__);
/* harmony import */ var _images_icons_bell_svg__WEBPACK_IMPORTED_MODULE_125__ = __webpack_require__(11803);
/* harmony import */ var _images_icons_bell_svg__WEBPACK_IMPORTED_MODULE_125___default = /*#__PURE__*/__webpack_require__.n(_images_icons_bell_svg__WEBPACK_IMPORTED_MODULE_125__);
/* harmony import */ var _images_icons_calendar_svg__WEBPACK_IMPORTED_MODULE_126__ = __webpack_require__(74985);
/* harmony import */ var _images_icons_calendar_svg__WEBPACK_IMPORTED_MODULE_126___default = /*#__PURE__*/__webpack_require__.n(_images_icons_calendar_svg__WEBPACK_IMPORTED_MODULE_126__);
/* harmony import */ var _images_icons_cloud_error_svg__WEBPACK_IMPORTED_MODULE_127__ = __webpack_require__(71185);
/* harmony import */ var _images_icons_cloud_error_svg__WEBPACK_IMPORTED_MODULE_127___default = /*#__PURE__*/__webpack_require__.n(_images_icons_cloud_error_svg__WEBPACK_IMPORTED_MODULE_127__);
/* harmony import */ var _images_icons_embed_svg__WEBPACK_IMPORTED_MODULE_128__ = __webpack_require__(26258);
/* harmony import */ var _images_icons_embed_svg__WEBPACK_IMPORTED_MODULE_128___default = /*#__PURE__*/__webpack_require__.n(_images_icons_embed_svg__WEBPACK_IMPORTED_MODULE_128__);
/* harmony import */ var _images_icons_google_drive_svg__WEBPACK_IMPORTED_MODULE_129__ = __webpack_require__(55551);
/* harmony import */ var _images_icons_google_drive_svg__WEBPACK_IMPORTED_MODULE_129___default = /*#__PURE__*/__webpack_require__.n(_images_icons_google_drive_svg__WEBPACK_IMPORTED_MODULE_129__);
/* harmony import */ var _images_icons_people_svg__WEBPACK_IMPORTED_MODULE_130__ = __webpack_require__(53686);
/* harmony import */ var _images_icons_people_svg__WEBPACK_IMPORTED_MODULE_130___default = /*#__PURE__*/__webpack_require__.n(_images_icons_people_svg__WEBPACK_IMPORTED_MODULE_130__);
/* harmony import */ var _images_icons_back_button_svg__WEBPACK_IMPORTED_MODULE_131__ = __webpack_require__(86306);
/* harmony import */ var _images_icons_back_button_svg__WEBPACK_IMPORTED_MODULE_131___default = /*#__PURE__*/__webpack_require__.n(_images_icons_back_button_svg__WEBPACK_IMPORTED_MODULE_131__);
/* harmony import */ var _images_icons_menu_more_down_svg__WEBPACK_IMPORTED_MODULE_132__ = __webpack_require__(16357);
/* harmony import */ var _images_icons_menu_more_down_svg__WEBPACK_IMPORTED_MODULE_132___default = /*#__PURE__*/__webpack_require__.n(_images_icons_menu_more_down_svg__WEBPACK_IMPORTED_MODULE_132__);
/* harmony import */ var _images_icons_list_collapse_svg__WEBPACK_IMPORTED_MODULE_133__ = __webpack_require__(98854);
/* harmony import */ var _images_icons_list_collapse_svg__WEBPACK_IMPORTED_MODULE_133___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_collapse_svg__WEBPACK_IMPORTED_MODULE_133__);
/* harmony import */ var _images_icons_placeholder_icon_svg__WEBPACK_IMPORTED_MODULE_134__ = __webpack_require__(7393);
/* harmony import */ var _images_icons_placeholder_icon_svg__WEBPACK_IMPORTED_MODULE_134___default = /*#__PURE__*/__webpack_require__.n(_images_icons_placeholder_icon_svg__WEBPACK_IMPORTED_MODULE_134__);
/* harmony import */ var _images_icons_bookmark_svg__WEBPACK_IMPORTED_MODULE_135__ = __webpack_require__(22793);
/* harmony import */ var _images_icons_bookmark_svg__WEBPACK_IMPORTED_MODULE_135___default = /*#__PURE__*/__webpack_require__.n(_images_icons_bookmark_svg__WEBPACK_IMPORTED_MODULE_135__);
/* harmony import */ var _images_icons_url_svg__WEBPACK_IMPORTED_MODULE_136__ = __webpack_require__(29672);
/* harmony import */ var _images_icons_url_svg__WEBPACK_IMPORTED_MODULE_136___default = /*#__PURE__*/__webpack_require__.n(_images_icons_url_svg__WEBPACK_IMPORTED_MODULE_136__);
/* harmony import */ var _images_icons_title_svg__WEBPACK_IMPORTED_MODULE_137__ = __webpack_require__(76094);
/* harmony import */ var _images_icons_title_svg__WEBPACK_IMPORTED_MODULE_137___default = /*#__PURE__*/__webpack_require__.n(_images_icons_title_svg__WEBPACK_IMPORTED_MODULE_137__);
/* harmony import */ var _images_icons_embed_b_svg__WEBPACK_IMPORTED_MODULE_138__ = __webpack_require__(99474);
/* harmony import */ var _images_icons_embed_b_svg__WEBPACK_IMPORTED_MODULE_138___default = /*#__PURE__*/__webpack_require__.n(_images_icons_embed_b_svg__WEBPACK_IMPORTED_MODULE_138__);
/* harmony import */ var _images_icons_youtube_svg__WEBPACK_IMPORTED_MODULE_139__ = __webpack_require__(46921);
/* harmony import */ var _images_icons_youtube_svg__WEBPACK_IMPORTED_MODULE_139___default = /*#__PURE__*/__webpack_require__.n(_images_icons_youtube_svg__WEBPACK_IMPORTED_MODULE_139__);
/* harmony import */ var _images_icons_google_maps_svg__WEBPACK_IMPORTED_MODULE_140__ = __webpack_require__(517);
/* harmony import */ var _images_icons_google_maps_svg__WEBPACK_IMPORTED_MODULE_140___default = /*#__PURE__*/__webpack_require__.n(_images_icons_google_maps_svg__WEBPACK_IMPORTED_MODULE_140__);
/* harmony import */ var _images_icons_airtable_svg__WEBPACK_IMPORTED_MODULE_141__ = __webpack_require__(88098);
/* harmony import */ var _images_icons_airtable_svg__WEBPACK_IMPORTED_MODULE_141___default = /*#__PURE__*/__webpack_require__.n(_images_icons_airtable_svg__WEBPACK_IMPORTED_MODULE_141__);
/* harmony import */ var _images_icons_invision_svg__WEBPACK_IMPORTED_MODULE_142__ = __webpack_require__(13669);
/* harmony import */ var _images_icons_invision_svg__WEBPACK_IMPORTED_MODULE_142___default = /*#__PURE__*/__webpack_require__.n(_images_icons_invision_svg__WEBPACK_IMPORTED_MODULE_142__);
/* harmony import */ var _images_icons_figma_svg__WEBPACK_IMPORTED_MODULE_143__ = __webpack_require__(83763);
/* harmony import */ var _images_icons_figma_svg__WEBPACK_IMPORTED_MODULE_143___default = /*#__PURE__*/__webpack_require__.n(_images_icons_figma_svg__WEBPACK_IMPORTED_MODULE_143__);
/* harmony import */ var _images_icons_github_gist_svg__WEBPACK_IMPORTED_MODULE_144__ = __webpack_require__(71492);
/* harmony import */ var _images_icons_github_gist_svg__WEBPACK_IMPORTED_MODULE_144___default = /*#__PURE__*/__webpack_require__.n(_images_icons_github_gist_svg__WEBPACK_IMPORTED_MODULE_144__);
/* harmony import */ var _images_icons_twitter_svg__WEBPACK_IMPORTED_MODULE_145__ = __webpack_require__(35783);
/* harmony import */ var _images_icons_twitter_svg__WEBPACK_IMPORTED_MODULE_145___default = /*#__PURE__*/__webpack_require__.n(_images_icons_twitter_svg__WEBPACK_IMPORTED_MODULE_145__);
/* harmony import */ var _images_icons_typeform_svg__WEBPACK_IMPORTED_MODULE_146__ = __webpack_require__(61615);
/* harmony import */ var _images_icons_typeform_svg__WEBPACK_IMPORTED_MODULE_146___default = /*#__PURE__*/__webpack_require__.n(_images_icons_typeform_svg__WEBPACK_IMPORTED_MODULE_146__);
/* harmony import */ var _images_icons_vimeo_svg__WEBPACK_IMPORTED_MODULE_147__ = __webpack_require__(89713);
/* harmony import */ var _images_icons_vimeo_svg__WEBPACK_IMPORTED_MODULE_147___default = /*#__PURE__*/__webpack_require__.n(_images_icons_vimeo_svg__WEBPACK_IMPORTED_MODULE_147__);
/* harmony import */ var _images_icons_nimbus_svg__WEBPACK_IMPORTED_MODULE_148__ = __webpack_require__(92688);
/* harmony import */ var _images_icons_nimbus_svg__WEBPACK_IMPORTED_MODULE_148___default = /*#__PURE__*/__webpack_require__.n(_images_icons_nimbus_svg__WEBPACK_IMPORTED_MODULE_148__);
/* harmony import */ var _images_icons_upload_svg__WEBPACK_IMPORTED_MODULE_149__ = __webpack_require__(26798);
/* harmony import */ var _images_icons_upload_svg__WEBPACK_IMPORTED_MODULE_149___default = /*#__PURE__*/__webpack_require__.n(_images_icons_upload_svg__WEBPACK_IMPORTED_MODULE_149__);
/* harmony import */ var _images_icons_play_icon_svg__WEBPACK_IMPORTED_MODULE_150__ = __webpack_require__(51195);
/* harmony import */ var _images_icons_play_icon_svg__WEBPACK_IMPORTED_MODULE_150___default = /*#__PURE__*/__webpack_require__.n(_images_icons_play_icon_svg__WEBPACK_IMPORTED_MODULE_150__);
/* harmony import */ var _images_icons_pause_icon_svg__WEBPACK_IMPORTED_MODULE_151__ = __webpack_require__(10231);
/* harmony import */ var _images_icons_pause_icon_svg__WEBPACK_IMPORTED_MODULE_151___default = /*#__PURE__*/__webpack_require__.n(_images_icons_pause_icon_svg__WEBPACK_IMPORTED_MODULE_151__);
/* harmony import */ var _images_icons_record_icon_svg__WEBPACK_IMPORTED_MODULE_152__ = __webpack_require__(14698);
/* harmony import */ var _images_icons_record_icon_svg__WEBPACK_IMPORTED_MODULE_152___default = /*#__PURE__*/__webpack_require__.n(_images_icons_record_icon_svg__WEBPACK_IMPORTED_MODULE_152__);
/* harmony import */ var _images_icons_remove_record_svg__WEBPACK_IMPORTED_MODULE_153__ = __webpack_require__(88170);
/* harmony import */ var _images_icons_remove_record_svg__WEBPACK_IMPORTED_MODULE_153___default = /*#__PURE__*/__webpack_require__.n(_images_icons_remove_record_svg__WEBPACK_IMPORTED_MODULE_153__);
/* harmony import */ var _images_icons_stop_icon_svg__WEBPACK_IMPORTED_MODULE_154__ = __webpack_require__(14345);
/* harmony import */ var _images_icons_stop_icon_svg__WEBPACK_IMPORTED_MODULE_154___default = /*#__PURE__*/__webpack_require__.n(_images_icons_stop_icon_svg__WEBPACK_IMPORTED_MODULE_154__);
/* harmony import */ var _images_icons_screen_only_svg__WEBPACK_IMPORTED_MODULE_155__ = __webpack_require__(30315);
/* harmony import */ var _images_icons_screen_only_svg__WEBPACK_IMPORTED_MODULE_155___default = /*#__PURE__*/__webpack_require__.n(_images_icons_screen_only_svg__WEBPACK_IMPORTED_MODULE_155__);
/* harmony import */ var _images_icons_cam_only_svg__WEBPACK_IMPORTED_MODULE_156__ = __webpack_require__(21088);
/* harmony import */ var _images_icons_cam_only_svg__WEBPACK_IMPORTED_MODULE_156___default = /*#__PURE__*/__webpack_require__.n(_images_icons_cam_only_svg__WEBPACK_IMPORTED_MODULE_156__);
/* harmony import */ var _images_icons_screen_cam_svg__WEBPACK_IMPORTED_MODULE_157__ = __webpack_require__(80562);
/* harmony import */ var _images_icons_screen_cam_svg__WEBPACK_IMPORTED_MODULE_157___default = /*#__PURE__*/__webpack_require__.n(_images_icons_screen_cam_svg__WEBPACK_IMPORTED_MODULE_157__);
/* harmony import */ var _images_icons_screen_only_active_svg__WEBPACK_IMPORTED_MODULE_158__ = __webpack_require__(77142);
/* harmony import */ var _images_icons_screen_only_active_svg__WEBPACK_IMPORTED_MODULE_158___default = /*#__PURE__*/__webpack_require__.n(_images_icons_screen_only_active_svg__WEBPACK_IMPORTED_MODULE_158__);
/* harmony import */ var _images_icons_cam_only_active_svg__WEBPACK_IMPORTED_MODULE_159__ = __webpack_require__(31887);
/* harmony import */ var _images_icons_cam_only_active_svg__WEBPACK_IMPORTED_MODULE_159___default = /*#__PURE__*/__webpack_require__.n(_images_icons_cam_only_active_svg__WEBPACK_IMPORTED_MODULE_159__);
/* harmony import */ var _images_icons_screen_cam_active_svg__WEBPACK_IMPORTED_MODULE_160__ = __webpack_require__(61762);
/* harmony import */ var _images_icons_screen_cam_active_svg__WEBPACK_IMPORTED_MODULE_160___default = /*#__PURE__*/__webpack_require__.n(_images_icons_screen_cam_active_svg__WEBPACK_IMPORTED_MODULE_160__);
/* harmony import */ var _images_icons_soundOn_svg__WEBPACK_IMPORTED_MODULE_161__ = __webpack_require__(10653);
/* harmony import */ var _images_icons_soundOn_svg__WEBPACK_IMPORTED_MODULE_161___default = /*#__PURE__*/__webpack_require__.n(_images_icons_soundOn_svg__WEBPACK_IMPORTED_MODULE_161__);
/* harmony import */ var _images_icons_soundOff_svg__WEBPACK_IMPORTED_MODULE_162__ = __webpack_require__(24570);
/* harmony import */ var _images_icons_soundOff_svg__WEBPACK_IMPORTED_MODULE_162___default = /*#__PURE__*/__webpack_require__.n(_images_icons_soundOff_svg__WEBPACK_IMPORTED_MODULE_162__);
/* harmony import */ var _images_icons_full_width_mode_svg__WEBPACK_IMPORTED_MODULE_163__ = __webpack_require__(89129);
/* harmony import */ var _images_icons_full_width_mode_svg__WEBPACK_IMPORTED_MODULE_163___default = /*#__PURE__*/__webpack_require__.n(_images_icons_full_width_mode_svg__WEBPACK_IMPORTED_MODULE_163__);
/* harmony import */ var _images_icons_pin_button_svg__WEBPACK_IMPORTED_MODULE_164__ = __webpack_require__(88398);
/* harmony import */ var _images_icons_pin_button_svg__WEBPACK_IMPORTED_MODULE_164___default = /*#__PURE__*/__webpack_require__.n(_images_icons_pin_button_svg__WEBPACK_IMPORTED_MODULE_164__);
/* harmony import */ var _images_icons_unpin_button_svg__WEBPACK_IMPORTED_MODULE_165__ = __webpack_require__(29300);
/* harmony import */ var _images_icons_unpin_button_svg__WEBPACK_IMPORTED_MODULE_165___default = /*#__PURE__*/__webpack_require__.n(_images_icons_unpin_button_svg__WEBPACK_IMPORTED_MODULE_165__);
/* harmony import */ var _images_icons_lock_svg__WEBPACK_IMPORTED_MODULE_166__ = __webpack_require__(72102);
/* harmony import */ var _images_icons_lock_svg__WEBPACK_IMPORTED_MODULE_166___default = /*#__PURE__*/__webpack_require__.n(_images_icons_lock_svg__WEBPACK_IMPORTED_MODULE_166__);
/* harmony import */ var _images_icons_lock_hover_svg__WEBPACK_IMPORTED_MODULE_167__ = __webpack_require__(8941);
/* harmony import */ var _images_icons_lock_hover_svg__WEBPACK_IMPORTED_MODULE_167___default = /*#__PURE__*/__webpack_require__.n(_images_icons_lock_hover_svg__WEBPACK_IMPORTED_MODULE_167__);
/* harmony import */ var _images_icons_create_note_svg__WEBPACK_IMPORTED_MODULE_168__ = __webpack_require__(44744);
/* harmony import */ var _images_icons_create_note_svg__WEBPACK_IMPORTED_MODULE_168___default = /*#__PURE__*/__webpack_require__.n(_images_icons_create_note_svg__WEBPACK_IMPORTED_MODULE_168__);
/* harmony import */ var _images_icons_create_folder_svg__WEBPACK_IMPORTED_MODULE_169__ = __webpack_require__(13532);
/* harmony import */ var _images_icons_create_folder_svg__WEBPACK_IMPORTED_MODULE_169___default = /*#__PURE__*/__webpack_require__.n(_images_icons_create_folder_svg__WEBPACK_IMPORTED_MODULE_169__);
/* harmony import */ var _images_icons_comment_svg__WEBPACK_IMPORTED_MODULE_170__ = __webpack_require__(3641);
/* harmony import */ var _images_icons_comment_svg__WEBPACK_IMPORTED_MODULE_170___default = /*#__PURE__*/__webpack_require__.n(_images_icons_comment_svg__WEBPACK_IMPORTED_MODULE_170__);
/* harmony import */ var _images_icons_hint_svg__WEBPACK_IMPORTED_MODULE_171__ = __webpack_require__(82052);
/* harmony import */ var _images_icons_hint_svg__WEBPACK_IMPORTED_MODULE_171___default = /*#__PURE__*/__webpack_require__.n(_images_icons_hint_svg__WEBPACK_IMPORTED_MODULE_171__);
/* harmony import */ var _images_icons_comment_mobile_svg__WEBPACK_IMPORTED_MODULE_172__ = __webpack_require__(58191);
/* harmony import */ var _images_icons_comment_mobile_svg__WEBPACK_IMPORTED_MODULE_172___default = /*#__PURE__*/__webpack_require__.n(_images_icons_comment_mobile_svg__WEBPACK_IMPORTED_MODULE_172__);
/* harmony import */ var _images_icons_button_svg__WEBPACK_IMPORTED_MODULE_173__ = __webpack_require__(60681);
/* harmony import */ var _images_icons_button_svg__WEBPACK_IMPORTED_MODULE_173___default = /*#__PURE__*/__webpack_require__.n(_images_icons_button_svg__WEBPACK_IMPORTED_MODULE_173__);
/* harmony import */ var _images_icons_empty_svg__WEBPACK_IMPORTED_MODULE_174__ = __webpack_require__(91027);
/* harmony import */ var _images_icons_empty_svg__WEBPACK_IMPORTED_MODULE_174___default = /*#__PURE__*/__webpack_require__.n(_images_icons_empty_svg__WEBPACK_IMPORTED_MODULE_174__);
/* harmony import */ var _images_icons_edit_video_svg__WEBPACK_IMPORTED_MODULE_175__ = __webpack_require__(97393);
/* harmony import */ var _images_icons_edit_video_svg__WEBPACK_IMPORTED_MODULE_175___default = /*#__PURE__*/__webpack_require__.n(_images_icons_edit_video_svg__WEBPACK_IMPORTED_MODULE_175__);
/* harmony import */ var _images_icons_paragraph_2_svg__WEBPACK_IMPORTED_MODULE_176__ = __webpack_require__(69435);
/* harmony import */ var _images_icons_paragraph_2_svg__WEBPACK_IMPORTED_MODULE_176___default = /*#__PURE__*/__webpack_require__.n(_images_icons_paragraph_2_svg__WEBPACK_IMPORTED_MODULE_176__);
/* harmony import */ var _images_icons_add_comment_svg__WEBPACK_IMPORTED_MODULE_177__ = __webpack_require__(44859);
/* harmony import */ var _images_icons_add_comment_svg__WEBPACK_IMPORTED_MODULE_177___default = /*#__PURE__*/__webpack_require__.n(_images_icons_add_comment_svg__WEBPACK_IMPORTED_MODULE_177__);
/* harmony import */ var _images_icons_watch_again_svg__WEBPACK_IMPORTED_MODULE_178__ = __webpack_require__(77445);
/* harmony import */ var _images_icons_watch_again_svg__WEBPACK_IMPORTED_MODULE_178___default = /*#__PURE__*/__webpack_require__.n(_images_icons_watch_again_svg__WEBPACK_IMPORTED_MODULE_178__);
/* harmony import */ var _images_icons_toggle_svg__WEBPACK_IMPORTED_MODULE_179__ = __webpack_require__(33277);
/* harmony import */ var _images_icons_toggle_svg__WEBPACK_IMPORTED_MODULE_179___default = /*#__PURE__*/__webpack_require__.n(_images_icons_toggle_svg__WEBPACK_IMPORTED_MODULE_179__);
/* harmony import */ var _images_icons_checklist_svg__WEBPACK_IMPORTED_MODULE_180__ = __webpack_require__(36598);
/* harmony import */ var _images_icons_checklist_svg__WEBPACK_IMPORTED_MODULE_180___default = /*#__PURE__*/__webpack_require__.n(_images_icons_checklist_svg__WEBPACK_IMPORTED_MODULE_180__);
/* harmony import */ var _images_icons_player_download_svg__WEBPACK_IMPORTED_MODULE_181__ = __webpack_require__(25637);
/* harmony import */ var _images_icons_player_download_svg__WEBPACK_IMPORTED_MODULE_181___default = /*#__PURE__*/__webpack_require__.n(_images_icons_player_download_svg__WEBPACK_IMPORTED_MODULE_181__);
/* harmony import */ var _images_icons_large_header_toggle_svg__WEBPACK_IMPORTED_MODULE_182__ = __webpack_require__(78018);
/* harmony import */ var _images_icons_large_header_toggle_svg__WEBPACK_IMPORTED_MODULE_182___default = /*#__PURE__*/__webpack_require__.n(_images_icons_large_header_toggle_svg__WEBPACK_IMPORTED_MODULE_182__);
/* harmony import */ var _images_icons_medium_header_toggle_svg__WEBPACK_IMPORTED_MODULE_183__ = __webpack_require__(37871);
/* harmony import */ var _images_icons_medium_header_toggle_svg__WEBPACK_IMPORTED_MODULE_183___default = /*#__PURE__*/__webpack_require__.n(_images_icons_medium_header_toggle_svg__WEBPACK_IMPORTED_MODULE_183__);
/* harmony import */ var _images_icons_small_header_toggle_svg__WEBPACK_IMPORTED_MODULE_184__ = __webpack_require__(71571);
/* harmony import */ var _images_icons_small_header_toggle_svg__WEBPACK_IMPORTED_MODULE_184___default = /*#__PURE__*/__webpack_require__.n(_images_icons_small_header_toggle_svg__WEBPACK_IMPORTED_MODULE_184__);
/* harmony import */ var _images_icons_custom_link_svg__WEBPACK_IMPORTED_MODULE_185__ = __webpack_require__(89883);
/* harmony import */ var _images_icons_custom_link_svg__WEBPACK_IMPORTED_MODULE_185___default = /*#__PURE__*/__webpack_require__.n(_images_icons_custom_link_svg__WEBPACK_IMPORTED_MODULE_185__);
/* harmony import */ var _images_icons_columns_svg__WEBPACK_IMPORTED_MODULE_186__ = __webpack_require__(97368);
/* harmony import */ var _images_icons_columns_svg__WEBPACK_IMPORTED_MODULE_186___default = /*#__PURE__*/__webpack_require__.n(_images_icons_columns_svg__WEBPACK_IMPORTED_MODULE_186__);
/* harmony import */ var _images_icons_default_color_icon_svg__WEBPACK_IMPORTED_MODULE_187__ = __webpack_require__(28824);
/* harmony import */ var _images_icons_default_color_icon_svg__WEBPACK_IMPORTED_MODULE_187___default = /*#__PURE__*/__webpack_require__.n(_images_icons_default_color_icon_svg__WEBPACK_IMPORTED_MODULE_187__);
/* harmony import */ var _images_icons_template_icon_svg__WEBPACK_IMPORTED_MODULE_188__ = __webpack_require__(64268);
/* harmony import */ var _images_icons_template_icon_svg__WEBPACK_IMPORTED_MODULE_188___default = /*#__PURE__*/__webpack_require__.n(_images_icons_template_icon_svg__WEBPACK_IMPORTED_MODULE_188__);
/* harmony import */ var _images_icons_invite_svg__WEBPACK_IMPORTED_MODULE_189__ = __webpack_require__(44819);
/* harmony import */ var _images_icons_invite_svg__WEBPACK_IMPORTED_MODULE_189___default = /*#__PURE__*/__webpack_require__.n(_images_icons_invite_svg__WEBPACK_IMPORTED_MODULE_189__);
/* harmony import */ var _images_icons_file_icon_svg__WEBPACK_IMPORTED_MODULE_190__ = __webpack_require__(62012);
/* harmony import */ var _images_icons_file_icon_svg__WEBPACK_IMPORTED_MODULE_190___default = /*#__PURE__*/__webpack_require__.n(_images_icons_file_icon_svg__WEBPACK_IMPORTED_MODULE_190__);
/* harmony import */ var _images_icons_link_diag_svg__WEBPACK_IMPORTED_MODULE_191__ = __webpack_require__(4718);
/* harmony import */ var _images_icons_link_diag_svg__WEBPACK_IMPORTED_MODULE_191___default = /*#__PURE__*/__webpack_require__.n(_images_icons_link_diag_svg__WEBPACK_IMPORTED_MODULE_191__);
/* harmony import */ var _images_icons_feedback_svg__WEBPACK_IMPORTED_MODULE_192__ = __webpack_require__(23953);
/* harmony import */ var _images_icons_feedback_svg__WEBPACK_IMPORTED_MODULE_192___default = /*#__PURE__*/__webpack_require__.n(_images_icons_feedback_svg__WEBPACK_IMPORTED_MODULE_192__);
/* harmony import */ var _images_icons_support_svg__WEBPACK_IMPORTED_MODULE_193__ = __webpack_require__(62428);
/* harmony import */ var _images_icons_support_svg__WEBPACK_IMPORTED_MODULE_193___default = /*#__PURE__*/__webpack_require__.n(_images_icons_support_svg__WEBPACK_IMPORTED_MODULE_193__);
/* harmony import */ var _images_icons_learn_svg__WEBPACK_IMPORTED_MODULE_194__ = __webpack_require__(76767);
/* harmony import */ var _images_icons_learn_svg__WEBPACK_IMPORTED_MODULE_194___default = /*#__PURE__*/__webpack_require__.n(_images_icons_learn_svg__WEBPACK_IMPORTED_MODULE_194__);
/* harmony import */ var _images_icons_miro_svg__WEBPACK_IMPORTED_MODULE_195__ = __webpack_require__(26934);
/* harmony import */ var _images_icons_miro_svg__WEBPACK_IMPORTED_MODULE_195___default = /*#__PURE__*/__webpack_require__.n(_images_icons_miro_svg__WEBPACK_IMPORTED_MODULE_195__);
/* harmony import */ var _images_icons_database_svg__WEBPACK_IMPORTED_MODULE_196__ = __webpack_require__(23996);
/* harmony import */ var _images_icons_database_svg__WEBPACK_IMPORTED_MODULE_196___default = /*#__PURE__*/__webpack_require__.n(_images_icons_database_svg__WEBPACK_IMPORTED_MODULE_196__);
/* harmony import */ var _images_icons_filter_svg__WEBPACK_IMPORTED_MODULE_197__ = __webpack_require__(80124);
/* harmony import */ var _images_icons_filter_svg__WEBPACK_IMPORTED_MODULE_197___default = /*#__PURE__*/__webpack_require__.n(_images_icons_filter_svg__WEBPACK_IMPORTED_MODULE_197__);
/* harmony import */ var _images_icons_board_svg__WEBPACK_IMPORTED_MODULE_198__ = __webpack_require__(38096);
/* harmony import */ var _images_icons_board_svg__WEBPACK_IMPORTED_MODULE_198___default = /*#__PURE__*/__webpack_require__.n(_images_icons_board_svg__WEBPACK_IMPORTED_MODULE_198__);
/* harmony import */ var _images_icons_progress_svg__WEBPACK_IMPORTED_MODULE_199__ = __webpack_require__(54958);
/* harmony import */ var _images_icons_progress_svg__WEBPACK_IMPORTED_MODULE_199___default = /*#__PURE__*/__webpack_require__.n(_images_icons_progress_svg__WEBPACK_IMPORTED_MODULE_199__);
/* harmony import */ var _images_icons_comment_new_svg__WEBPACK_IMPORTED_MODULE_200__ = __webpack_require__(7688);
/* harmony import */ var _images_icons_comment_new_svg__WEBPACK_IMPORTED_MODULE_200___default = /*#__PURE__*/__webpack_require__.n(_images_icons_comment_new_svg__WEBPACK_IMPORTED_MODULE_200__);
/* harmony import */ var _images_icons_promt_icon_svg__WEBPACK_IMPORTED_MODULE_201__ = __webpack_require__(38312);
/* harmony import */ var _images_icons_promt_icon_svg__WEBPACK_IMPORTED_MODULE_201___default = /*#__PURE__*/__webpack_require__.n(_images_icons_promt_icon_svg__WEBPACK_IMPORTED_MODULE_201__);
/* harmony import */ var _images_icons_agent_robot_face_svg__WEBPACK_IMPORTED_MODULE_202__ = __webpack_require__(28852);
/* harmony import */ var _images_icons_agent_robot_face_svg__WEBPACK_IMPORTED_MODULE_202___default = /*#__PURE__*/__webpack_require__.n(_images_icons_agent_robot_face_svg__WEBPACK_IMPORTED_MODULE_202__);
/* harmony import */ var _images_icons_sync_svg__WEBPACK_IMPORTED_MODULE_203__ = __webpack_require__(82481);
/* harmony import */ var _images_icons_sync_svg__WEBPACK_IMPORTED_MODULE_203___default = /*#__PURE__*/__webpack_require__.n(_images_icons_sync_svg__WEBPACK_IMPORTED_MODULE_203__);
/* harmony import */ var _images_icons_done_svg__WEBPACK_IMPORTED_MODULE_204__ = __webpack_require__(99635);
/* harmony import */ var _images_icons_done_svg__WEBPACK_IMPORTED_MODULE_204___default = /*#__PURE__*/__webpack_require__.n(_images_icons_done_svg__WEBPACK_IMPORTED_MODULE_204__);
/* harmony import */ var _images_icons_ai_help_svg__WEBPACK_IMPORTED_MODULE_205__ = __webpack_require__(60251);
/* harmony import */ var _images_icons_ai_help_svg__WEBPACK_IMPORTED_MODULE_205___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_help_svg__WEBPACK_IMPORTED_MODULE_205__);
/* harmony import */ var _images_icons_ai_cta_svg__WEBPACK_IMPORTED_MODULE_206__ = __webpack_require__(86766);
/* harmony import */ var _images_icons_ai_cta_svg__WEBPACK_IMPORTED_MODULE_206___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_cta_svg__WEBPACK_IMPORTED_MODULE_206__);
/* harmony import */ var _images_icons_ai_explain_svg__WEBPACK_IMPORTED_MODULE_207__ = __webpack_require__(44461);
/* harmony import */ var _images_icons_ai_explain_svg__WEBPACK_IMPORTED_MODULE_207___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_explain_svg__WEBPACK_IMPORTED_MODULE_207__);
/* harmony import */ var _images_icons_ai_improve_svg__WEBPACK_IMPORTED_MODULE_208__ = __webpack_require__(79058);
/* harmony import */ var _images_icons_ai_improve_svg__WEBPACK_IMPORTED_MODULE_208___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_improve_svg__WEBPACK_IMPORTED_MODULE_208__);
/* harmony import */ var _images_icons_ai_longer_svg__WEBPACK_IMPORTED_MODULE_209__ = __webpack_require__(10812);
/* harmony import */ var _images_icons_ai_longer_svg__WEBPACK_IMPORTED_MODULE_209___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_longer_svg__WEBPACK_IMPORTED_MODULE_209__);
/* harmony import */ var _images_icons_ai_shorter_svg__WEBPACK_IMPORTED_MODULE_210__ = __webpack_require__(67906);
/* harmony import */ var _images_icons_ai_shorter_svg__WEBPACK_IMPORTED_MODULE_210___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_shorter_svg__WEBPACK_IMPORTED_MODULE_210__);
/* harmony import */ var _images_icons_ai_spelling_svg__WEBPACK_IMPORTED_MODULE_211__ = __webpack_require__(89959);
/* harmony import */ var _images_icons_ai_spelling_svg__WEBPACK_IMPORTED_MODULE_211___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_spelling_svg__WEBPACK_IMPORTED_MODULE_211__);
/* harmony import */ var _images_icons_ai_summarize_svg__WEBPACK_IMPORTED_MODULE_212__ = __webpack_require__(65216);
/* harmony import */ var _images_icons_ai_summarize_svg__WEBPACK_IMPORTED_MODULE_212___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_summarize_svg__WEBPACK_IMPORTED_MODULE_212__);
/* harmony import */ var _images_icons_replace_svg__WEBPACK_IMPORTED_MODULE_213__ = __webpack_require__(36039);
/* harmony import */ var _images_icons_replace_svg__WEBPACK_IMPORTED_MODULE_213___default = /*#__PURE__*/__webpack_require__.n(_images_icons_replace_svg__WEBPACK_IMPORTED_MODULE_213__);
/* harmony import */ var _images_icons_icon_arrow_up_svg__WEBPACK_IMPORTED_MODULE_214__ = __webpack_require__(79611);
/* harmony import */ var _images_icons_icon_arrow_up_svg__WEBPACK_IMPORTED_MODULE_214___default = /*#__PURE__*/__webpack_require__.n(_images_icons_icon_arrow_up_svg__WEBPACK_IMPORTED_MODULE_214__);
/* harmony import */ var _images_icons_icon_arrow_down_svg__WEBPACK_IMPORTED_MODULE_215__ = __webpack_require__(91527);
/* harmony import */ var _images_icons_icon_arrow_down_svg__WEBPACK_IMPORTED_MODULE_215___default = /*#__PURE__*/__webpack_require__.n(_images_icons_icon_arrow_down_svg__WEBPACK_IMPORTED_MODULE_215__);
/* harmony import */ var _images_icons_translate_svg__WEBPACK_IMPORTED_MODULE_216__ = __webpack_require__(60302);
/* harmony import */ var _images_icons_translate_svg__WEBPACK_IMPORTED_MODULE_216___default = /*#__PURE__*/__webpack_require__.n(_images_icons_translate_svg__WEBPACK_IMPORTED_MODULE_216__);
/* harmony import */ var _images_icons_copy_svg__WEBPACK_IMPORTED_MODULE_217__ = __webpack_require__(67012);
/* harmony import */ var _images_icons_copy_svg__WEBPACK_IMPORTED_MODULE_217___default = /*#__PURE__*/__webpack_require__.n(_images_icons_copy_svg__WEBPACK_IMPORTED_MODULE_217__);
/* harmony import */ var _images_icons_icon_cog_svg__WEBPACK_IMPORTED_MODULE_218__ = __webpack_require__(5952);
/* harmony import */ var _images_icons_icon_cog_svg__WEBPACK_IMPORTED_MODULE_218___default = /*#__PURE__*/__webpack_require__.n(_images_icons_icon_cog_svg__WEBPACK_IMPORTED_MODULE_218__);
/* harmony import */ var _images_icons_step_svg__WEBPACK_IMPORTED_MODULE_219__ = __webpack_require__(57551);
/* harmony import */ var _images_icons_step_svg__WEBPACK_IMPORTED_MODULE_219___default = /*#__PURE__*/__webpack_require__.n(_images_icons_step_svg__WEBPACK_IMPORTED_MODULE_219__);
/* harmony import */ var _images_icons_player_transcript_svg__WEBPACK_IMPORTED_MODULE_220__ = __webpack_require__(47137);
/* harmony import */ var _images_icons_player_transcript_svg__WEBPACK_IMPORTED_MODULE_220___default = /*#__PURE__*/__webpack_require__.n(_images_icons_player_transcript_svg__WEBPACK_IMPORTED_MODULE_220__);
/* harmony import */ var _images_icons_file_check_alt_svg__WEBPACK_IMPORTED_MODULE_221__ = __webpack_require__(42020);
/* harmony import */ var _images_icons_file_check_alt_svg__WEBPACK_IMPORTED_MODULE_221___default = /*#__PURE__*/__webpack_require__.n(_images_icons_file_check_alt_svg__WEBPACK_IMPORTED_MODULE_221__);
/* harmony import */ var _images_icons_user_pen_alt_svg__WEBPACK_IMPORTED_MODULE_222__ = __webpack_require__(77586);
/* harmony import */ var _images_icons_user_pen_alt_svg__WEBPACK_IMPORTED_MODULE_222___default = /*#__PURE__*/__webpack_require__.n(_images_icons_user_pen_alt_svg__WEBPACK_IMPORTED_MODULE_222__);
/* harmony import */ var _images_icons_star_svg__WEBPACK_IMPORTED_MODULE_223__ = __webpack_require__(42941);
/* harmony import */ var _images_icons_star_svg__WEBPACK_IMPORTED_MODULE_223___default = /*#__PURE__*/__webpack_require__.n(_images_icons_star_svg__WEBPACK_IMPORTED_MODULE_223__);
/* harmony import */ var _images_icons_undo_svg__WEBPACK_IMPORTED_MODULE_224__ = __webpack_require__(69206);
/* harmony import */ var _images_icons_undo_svg__WEBPACK_IMPORTED_MODULE_224___default = /*#__PURE__*/__webpack_require__.n(_images_icons_undo_svg__WEBPACK_IMPORTED_MODULE_224__);
/* harmony import */ var _images_icons_redo_svg__WEBPACK_IMPORTED_MODULE_225__ = __webpack_require__(20065);
/* harmony import */ var _images_icons_redo_svg__WEBPACK_IMPORTED_MODULE_225___default = /*#__PURE__*/__webpack_require__.n(_images_icons_redo_svg__WEBPACK_IMPORTED_MODULE_225__);
/* harmony import */ var _images_icons_pencil_svg__WEBPACK_IMPORTED_MODULE_226__ = __webpack_require__(68278);
/* harmony import */ var _images_icons_pencil_svg__WEBPACK_IMPORTED_MODULE_226___default = /*#__PURE__*/__webpack_require__.n(_images_icons_pencil_svg__WEBPACK_IMPORTED_MODULE_226__);
/* harmony import */ var _images_icons_eye_open_svg__WEBPACK_IMPORTED_MODULE_227__ = __webpack_require__(75259);
/* harmony import */ var _images_icons_eye_open_svg__WEBPACK_IMPORTED_MODULE_227___default = /*#__PURE__*/__webpack_require__.n(_images_icons_eye_open_svg__WEBPACK_IMPORTED_MODULE_227__);
/* harmony import */ var _images_icons_eye_closed_svg__WEBPACK_IMPORTED_MODULE_228__ = __webpack_require__(47346);
/* harmony import */ var _images_icons_eye_closed_svg__WEBPACK_IMPORTED_MODULE_228___default = /*#__PURE__*/__webpack_require__.n(_images_icons_eye_closed_svg__WEBPACK_IMPORTED_MODULE_228__);
/* harmony import */ var _images_icons_user_plus_svg__WEBPACK_IMPORTED_MODULE_229__ = __webpack_require__(24327);
/* harmony import */ var _images_icons_user_plus_svg__WEBPACK_IMPORTED_MODULE_229___default = /*#__PURE__*/__webpack_require__.n(_images_icons_user_plus_svg__WEBPACK_IMPORTED_MODULE_229__);
/* harmony import */ var _images_icons_checkbox_checked_svg__WEBPACK_IMPORTED_MODULE_230__ = __webpack_require__(41614);
/* harmony import */ var _images_icons_checkbox_checked_svg__WEBPACK_IMPORTED_MODULE_230___default = /*#__PURE__*/__webpack_require__.n(_images_icons_checkbox_checked_svg__WEBPACK_IMPORTED_MODULE_230__);









































































































































































































































/***/ }),

/***/ 33103:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dc": () => (/* binding */ wait)
/* harmony export */ });
/* unused harmony exports SELF_CONTROLLED_CONTENT_CLASS, isNodeSelfControlled, getID, waitFor, isRendered, getDeletedYMapAttr, objDiff, copyHtmlToClipboard, getParsed, mergeDeep, isObject, isEqual, objUniques, getSelectedText, getAllPrototypes, processConvertBlotWithComments, filterProps, arrayTrimEnd, getWindow */
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87751);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_names_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36210);
/* harmony import */ var core_js_modules_es_object_get_own_property_names_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_names_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70189);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69600);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(30489);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26699);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(32023);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(40561);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(91038);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(79758);
/* harmony import */ var _util_dom__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(67546);
/* harmony import */ var _plugins_popupManager_confirmPopup__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(23497);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }































// надо найти лучшее место для этой константы
var SELF_CONTROLLED_CONTENT_CLASS = 'self-controlled-content';
function isNodeSelfControlled(node) {
  node = getElementNode(node);
  if (!node) {
    return false;
  }
  return Boolean(node.closest('.' + SELF_CONTROLLED_CONTENT_CLASS));
}
function getID(typeInst) {
  if (typeof typeInst.get === 'function' && typeInst.get('id')) {
    return typeInst.get('id');
  }
  return typeInst._id.user + '_' + typeInst._id.clock;
}

/**
 * waiting for YMap element to have status=true
 * once status is true cb is called
 * @param {YMap} el
 * @param {Function} cb
 */
function waitFor(el, cb) {
  if (el.get('status') === true) {
    return process.nextTick(cb);
  }
  el.observe(function observer() {
    if (el.get('status') !== true) {
      return;
    }
    el.unobserve(observer);
    cb();
  });
}
function wait(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}

/**
 * checks if a node that uses yMap is renderered
 * @param {Boolean}
 */
function isRendered(yMap) {
  var id = getID(yMap);
  return Boolean(document.getElementById(id));
}
function getDeletedYMapAttr(yMap, key) {
  var v = yMap._map.get(key);
  if (v === undefined) {
    return undefined;
  }
  if (!v || !v._content) {
    return v;
  } else {
    return v._content[v._content.length - 1];
  }
}

// obj1 - obj2
function objDiff(obj1, obj2) {
  var diff = {};
  for (var k in obj2) {
    if (obj1[k] !== obj2[k]) {
      diff[k] = obj2[k];
    }
  }
  return diff;
}
function copyHtmlToClipboard(html) {
  if (_typeof(html) == "object") {
    html = html.outerHTML;
  }
  var container = document.createElement('div');
  container.innerHTML = html;
  container.style.position = 'fixed';
  container.style.pointerEvents = 'none';
  container.style.opacity = 0;
  var activeSheets = Array.prototype.slice.call(document.styleSheets).filter(function (sheet) {
    return !sheet.disabled;
  });
  document.body.appendChild(container);
  window.getSelection().removeAllRanges();
  var range = document.createRange();
  range.selectNode(container);
  window.getSelection().addRange(range);
  document.execCommand('copy');
  document.body.removeChild(container);
  return true;
}
if (typeof window !== 'undefined') {
  window.EPRFL = {
    _times: {},
    _starts: {},
    _callTimes: {},
    start: function start(name) {
      this._starts[name] = new Date().getTime();
    },
    end: function end(name) {
      if (!this._times[name]) {
        this._times[name] = 0;
        this._callTimes[name] = 0;
      }
      this._times[name] += new Date().getTime() - this._starts[name];
      this._callTimes[name]++;
    },
    show: function show() {
      for (var k in this._times) {
        console.info(k, this._times[k] / 1000, ', called', this._callTimes[k], 'times');
      }
    }
  };
}
function getParsed(value) {
  var str = String(value);
  var float = parseFloat(str.replace(',', '.'));
  if (!isNaN(float) && float.toString() === str) {
    return float;
  } else {
    return value;
  }
}
function mergeDeep(target) {
  if (!target) {
    target = {};
  }
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }
  if (!sources.length) {
    return target;
  }
  var source = sources.shift();
  if (isObject(target) && isObject(source)) {
    for (var key in source) {
      if (isObject(source[key])) {
        if (!target[key]) {
          Object.assign(target, _defineProperty({}, key, {}));
        }
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, _defineProperty({}, key, source[key]));
      }
    }
  }
  return mergeDeep.apply(void 0, [target].concat(sources));
}
function isObject(item) {
  return item && _typeof(item) === 'object' && !Array.isArray(item);
}
function isEqual(a, b) {
  if (_typeof(a) !== 'object' || _typeof(b) !== 'object') {
    return a === b;
  }
  if (a === null || b === null || typeof a === 'undefined' || typeof b === 'undefined') {
    return a === b;
  }
  var aProps = Object.getOwnPropertyNames(a);
  var bProps = Object.getOwnPropertyNames(b);
  if (aProps.length !== bProps.length) {
    return false;
  }
  var _iterator = _createForOfIteratorHelper(aProps),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var prop = _step.value;
      if (!isEqual(a[prop], b[prop])) {
        return false;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return true;
}
function objUniques(main, second) {
  var diff = {};
  var props = [].concat(Object.getOwnPropertyNames(main)).concat(Object.getOwnPropertyNames(second));
  var propsSet = new Set(props);
  propsSet.forEach(function (prop) {
    if (second.hasOwnProperty(prop)) {
      if (_typeof(main[prop]) === 'object' && _typeof(second[prop]) === 'object') {
        var propDiff = objUniques(main[prop], second[prop]);
        if (Object.keys(propDiff).length !== 0) {
          diff[prop] = propDiff;
        }
      } else if (main[prop] !== second[prop]) {
        diff[prop] = second[prop];
      }
    }
  });
  return diff;
}

/**
 * Функция возвращает выделенный текст и дельту
 * @param editor
 * @returns {{delta: [{}], text: string}}
 */
function getSelectedText(editor) {
  var blots = editor.scroll.getSelectedBlocks().reduce(function (blots, blot) {
    if (blot.hasTextLine) {
      return [].concat(_toConsumableArray(blots), _toConsumableArray(blot.getChildrenForAction()));
    } else {
      return [].concat(_toConsumableArray(blots), [blot]);
    }
  }, []);
  var texts = [];
  var deltas = [{
    ops: []
  }];
  blots.forEach(function (blot) {
    var _editor$scroll$select = editor.scroll.selection.getRange({
        offsetBlot: blot
      }),
      _editor$scroll$select2 = _slicedToArray(_editor$scroll$select, 1),
      blotRange = _editor$scroll$select2[0];
    var text = '';
    var delta = {
      ops: []
    };
    if (blotRange && blot && blot.getText && blot.getContents) {
      text = blot.getText(blotRange.index, blotRange.length);
      delta = blot.getContents(blotRange.index, blotRange.length);
      texts.push(text);
      deltas.push(delta);
    }
  });
  return {
    text: texts.join("\n"),
    delta: deltas
  };
}

/**
 * Функция возвращает массив всех прототипов сущьности
 * @param {any} entity
 * @returns {array}
 */
function getAllPrototypes(entity) {
  var prototypes = [];
  var prototype = Object.getPrototypeOf(entity);
  while (prototype !== null) {
    if (prototype) {
      prototypes.push(prototype);
    }
    prototype = Object.getPrototypeOf(prototype);
  }
  return prototypes;
}

/**
 * Показывает диалог для подтвержения конвертации если в параграфах есть более одного блота с комментариями
 * @param editor
 * @param wantsToClose
 * @param type
 * @returns {Promise<boolean>}
 */
function processConvertBlotWithComments(_x, _x2, _x3) {
  return _processConvertBlotWithComments.apply(this, arguments);
}

/*
 * Фильтрует объект по допустимому списку ключей
 * @param { objec t} props: объект
 * @param { array } filter: допустимые ключи
 * @param { array } types: типы значений
 * @returns {object} отфильтрованный объект
 */
function _processConvertBlotWithComments() {
  _processConvertBlotWithComments = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(editor, wantsToClose, type) {
    var selected, withBlotComments, withInlineComments, _editor$plugins, popupManager, commentManager, i18n, isSyntax, isButton, title, message, cancel;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            selected = [];
            withBlotComments = [];
            withInlineComments = [];
            _editor$plugins = editor.plugins, popupManager = _editor$plugins.popupManager, commentManager = _editor$plugins.commentManager, i18n = _editor$plugins.i18n;
            editor.scroll.getSelectedBlocks().forEach(function (blot) {
              // сохраняем болоты с комментариями
              if (blot.map.has('commentThreads')) {
                withBlotComments.push(blot);
              }
              if (commentManager.getBlotInlineComments(blot).length) {
                withInlineComments.push(blot);
              }
              // сохраняем выделенные блоты
              selected.push(blot);
            });
            isSyntax = (withBlotComments.length > 1 || withInlineComments.length) && type === 'syntax';
            isButton = withInlineComments.length && type === 'button-single';
            if (!(isSyntax || isButton)) {
              _context.next = 19;
              break;
            }
            title = i18n.get('syntax.convert.popup_title');
            message = withInlineComments.length ? i18n.get('syntax.convert.text_has_inline_comments') : i18n.get('syntax.convert.blots_have_comments');
            if (isButton) {
              title = i18n.get('button.convert.popup_title');
            }

            // закрываем меню
            wantsToClose && wantsToClose();
            // ожидаем когда пользователь нажмент на подтврерждение или отмену
            _context.next = 14;
            return new Promise(function (resolve) {
              var confirm;
              var onCancel = function onCancel() {
                resolve(true);
              };
              var onConfirm = function onConfirm() {
                // так как при клике на кнопку пропадает фокус с блотов то переустанавливаем выделение
                editor.scroll.setSelectedBlots(selected);
                resolve(false);
              };
              confirm = h(ConfirmPopup, {
                onCancel: onCancel,
                onConfirm: onConfirm,
                title: title,
                message: message,
                confirmText: i18n.get('syntax.convert.confirm'),
                editor: editor
              });
              popupManager.dialog(confirm);
            });
          case 14:
            cancel = _context.sent;
            // закрываем диалог
            confirm = null;
            popupManager.dialog(null);
            if (!cancel) {
              _context.next = 19;
              break;
            }
            return _context.abrupt("return", true);
          case 19:
            return _context.abrupt("return", false);
          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _processConvertBlotWithComments.apply(this, arguments);
}
function filterProps(props, filter) {
  var types = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var result = {};
  var _iterator2 = _createForOfIteratorHelper(filter),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var key = _step2.value;
      if (props.hasOwnProperty(key)) {
        if (types[key] === 'number') {
          result[key] = parseInt(props[key]);
        } else if (types[key] === 'boolean' || props[key] === 'true' || props[key] === 'false') {
          if (props[key] === 'false') {
            result[key] = false;
          } else {
            result[key] = props[key] ? true : false;
          }
        } else {
          result[key] = props[key];
        }
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return result;
}

/**
 * Удаляет элементы с конца массива
 * По умолчанию: false, undefined
 * @param {array} arr: массив
 * @param {array} clear: удаляемые значения, напр: false
 * @returns {array} очищенный массив
 */
function arrayTrimEnd() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var clear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [false, 'undefined'];
  for (var i = arr.length - 1; i >= 0; i--) {
    var type = _typeof(arr[i]);
    if (clear.includes(type) || clear.includes(arr[i])) {
      arr.splice(i, 1);
    } else {
      break;
    }
  }
  return arr;
}

/**
 * Возвращает заглушку на глобальный объект window если он не найден
 * @return {{removeEventListener: removeEventListener, addEventListener: addEventListener}|Window}
 */
var getWindow = function getWindow() {
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object') {
    return window;
  }
  console.log('window was not found');
  return {
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {}
  };
};

/***/ }),

/***/ 67546:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gx": () => (/* binding */ isNodeInViewport)
/* harmony export */ });
/* unused harmony exports getFixedBoundingClientRect, getElementPosition, getComputedStyle, getComputedStyles, searchUp, isNodeConnected, isNodeEqualOrContain, getRelRect, getElementNode, searchByCoordinates, getScrollbarWidth, isNodeHasScrollbar, querySelectorAllDirectChildren, nodeIsWebComponent, PseudoDomNode, PseudoMutationObserver, scrollToNode, getTextNodesIn, unwrapNode, wrapNode, getNextSibling, getAttributesString, contenteditableCursorToEnd */
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26699);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32023);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69600);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91038);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var lodash_escape__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(66213);
/* harmony import */ var lodash_escape__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(lodash_escape__WEBPACK_IMPORTED_MODULE_17__);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



















// отличается от node.getBoundingClientRect() тем, что для элементов BODY и HTML возвращает фиксированный rect,
// начинающийся в начале viewport и заканчивающийся в его конце
function getFixedBoundingClientRect(node) {
  var rect;
  if (node.tagName === 'BODY' || node.tagName === 'HTML') {
    // просто возвращаем размеры вьюпорта
    var width = window.innerWidth;
    var height = window.innerHeight;
    rect = {
      left: 0,
      right: width,
      top: 0,
      bottom: height,
      x: 0,
      y: 0,
      width: width,
      height: height
    };
  } else {
    rect = node.getBoundingClientRect();
  }
  return rect;
}

/**
 * Получить положение и размеры элемента
 * @param {HTMLElement} node
 * @param {HTMLElement} parent если не null положение будет расчитано относительно этого элемента
 * @returns {{top: *, left: *, width: number, height: number}}
 */
function getElementPosition(node) {
  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var rect = node.getBoundingClientRect();
  var item = node;
  var top = rect.top + window.scrollY;
  var left = rect.left + window.scrollX;
  if (parent) {
    top = 0;
    left = 0;
    do {
      top += item.offsetTop || 0;
      left += item.offsetLeft || 0;
      item = item.offsetParent;
      if (item === parent) {
        item = null;
      }
    } while (item);
  }
  return {
    left: left,
    top: top,
    width: rect.width,
    height: rect.height
  };
}
function getComputedStyle(node, style) {
  var postfix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var val = window.getComputedStyle(node)[style];
  if (typeof val === 'string' && postfix) {
    val = parseFloat(val.replace(postfix, ''));
  }
  return val;
}
function getComputedStyles(node, styles) {
  var postfix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var computedStyles = window.getComputedStyle(node);
  var res = {};
  var _iterator = _createForOfIteratorHelper(styles),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var style = _step.value;
      var val = computedStyles[style];
      if (typeof val === 'string' && postfix) {
        val = parseFloat(val.replace(postfix, ''));
      }
      res[style] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return res;
}
function searchUp(node, max, fn) {
  if (typeof max === 'function') {
    fn = max;
    max = Number.POSITIVE_INFINITY;
  }
  var iter = 0;
  while (node) {
    if (fn(node)) {
      return node;
    }
    node = node.parentNode;
    iter++;
    if (iter > max) {
      return null;
    }
  }
  return null;
}
function isNodeInViewport(node) {
  var rect = node.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}
function isNodeConnected(node) {
  if (typeof node.isConnected !== 'undefined') {
    return node.isConnected;
  }
  return document.body.contains(node);
}
function isNodeEqualOrContain(node, target) {
  if (node === target) {
    return true;
  }
  if (!node) {
    return false;
  }
  if (!node.contains) {
    return false;
  }
  return node.contains(target);
}
function getRelRect(node, relNode) {
  var rect = node.getBoundingClientRect();
  var relRect = relNode.getBoundingClientRect();
  var result = {
    left: rect.left - relRect.left,
    top: rect.top + relNode.scrollTop - relRect.top,
    width: rect.width,
    height: rect.height
  };
  result.right = result.left + result.width;
  result.bottom = result.top + result.height;
  return result;
}
function getElementNode(node) {
  if (node.nodeType === Node.TEXT_NODE) {
    return node.parentNode;
  }
  return node;
}
function searchByCoordinates(start, dir, increment, end, fn) {
  var point = Object.assign({}, start);
  var checkEnd = function checkEnd() {
    if (increment > 0) {
      return point[dir] < end;
    } else {
      return point[dir] > end;
    }
  };
  for (; checkEnd(); point[dir] += increment) {
    var node = document.elementFromPoint(point.x, point.y);
    if (fn(node)) {
      return node;
    }
  }
  return null;
}
function getScrollbarWidth() {
  var outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.width = "100px";
  outer.style.msOverflowStyle = "scrollbar";
  document.body.appendChild(outer);
  var widthNoScroll = outer.offsetWidth;
  outer.style.overflow = "scroll";
  var inner = document.createElement("div");
  inner.style.width = "100%";
  outer.appendChild(inner);
  var widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  return widthNoScroll - widthWithScroll;
}
function isNodeHasScrollbar(node) {
  if (node.clientHeight < node.scrollHeight) {
    return true;
  }
  return false;
}
function querySelectorAllDirectChildren(node, selector) {
  var res = [];
  var _iterator2 = _createForOfIteratorHelper(node.childNodes),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var child = _step2.value;
      if (child.matches && child.matches(selector)) {
        res.push(child);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return res;
}
function nodeIsWebComponent(node) {
  return node.tagName && node.tagName.includes("-");
}
var PseudoDomNode = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function PseudoDomNode() {
    _classCallCheck(this, PseudoDomNode);
    this.childNodes = [];
  }
  _createClass(PseudoDomNode, [{
    key: "appendChild",
    value: function appendChild() {}
  }, {
    key: "insertBefore",
    value: function insertBefore() {}
  }, {
    key: "setAttribute",
    value: function setAttribute() {}
  }, {
    key: "getAttribute",
    value: function getAttribute() {}
  }]);
  return PseudoDomNode;
}()));
var PseudoMutationObserver = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function PseudoMutationObserver() {
    _classCallCheck(this, PseudoMutationObserver);
  }
  _createClass(PseudoMutationObserver, [{
    key: "observe",
    value: function observe() {}
  }]);
  return PseudoMutationObserver;
}()));
/**
 * Скроллит container до node, добавляет node класс highlighedClass
 *
 * @param {Node} container Контейнер, который нужно проскроллить
 * @param {Node} node Элемент до которого нужно проскроллить
 * @param {Object=} highlight Параметры подсветки ноды, можно передать null|false тогда блок не будет подсвечен
 * @param {Node=} highlight.node Нода, которой нужно присвоить класс подсветки
 * @param {String=} highlight.highlightClass Класс, который нужно добавить подсвечиваемой ноде
 * @param {Number=} highlight.timeout Таймаут подсветки ноды
 * @param {Boolean} smooth Плавная прокрутка
 */
function scrollToNode(container, node) {
  var highlight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    node: node,
    highlightClass: 'highlighted-block',
    timeout: 3000
  };
  var smooth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var initialSmooth = window.getComputedStyle(container).scrollBehavior;
  var highlightTimeout = null;
  //тут пришлось скопировать функцию из util/blot, при ее импорте ломается редактор
  var getContainerOffset = function getContainerOffset(node, container) {
    var x = 0;
    var y = 0;
    var el = node;
    while (el !== container && el !== null) {
      x += el.offsetLeft - el.scrollLeft;
      y += el.offsetTop - el.scrollTop;
      el = el.offsetParent;
    }
    return {
      x: x,
      y: y
    };
  };
  var onHighlightedNodeDocumentClick = function onHighlightedNodeDocumentClick(event) {
    if (highlightTimeout) {
      clearTimeout(highlightTimeout);
      highlightTimeout = null;
      highlight.node.classList.remove(highlight.highlightClass);
    }
    document.removeEventListener('click', onHighlightedNodeDocumentClick, false);
  };
  var nodeOffset = getContainerOffset(node, container);
  if (!smooth) {
    container.style.scrollBehavior = 'auto';
  }
  container.scrollTop = nodeOffset.y - 10 - offset;
  container.style.scrollBehavior = initialSmooth;
  if (highlight) {
    if (highlightTimeout) {
      try {
        clearTimeout(highlightTimeout);
      } catch (err) {}
    }
    highlight.node.classList.add(highlight.highlightClass);
    highlightTimeout = setTimeout(function () {
      highlight.node.classList.remove(highlight.highlightClass);
      document.removeEventListener('click', onHighlightedNodeDocumentClick, false);
    }, highlight.timeout);
    setTimeout(function () {
      document.addEventListener('click', onHighlightedNodeDocumentClick, false);
    }, 0);
  }
}

/**
 * Gets an array of the matching text nodes contained by the specified element.
 * @param  {!Element} elem
 *     The DOM element which will be traversed.
 * @param  {function(!Node,!Element):boolean} opt_fnFilter
 *     Optional function that if a true-ish value is returned will cause the
 *     text node in question to be added to the array to be returned from
 *     getTextNodesIn().  The first argument passed will be the text node in
 *     question while the second will be the parent of the text node.
 * @return {!Array.<!Node>}
 *     Array of the matching text nodes contained by the specified element.
 */
function getTextNodesIn(elem, opt_fnFilter) {
  var textNodes = [];
  if (elem) {
    for (var nodes = elem.childNodes, i = nodes.length; i--;) {
      var node = nodes[i],
        nodeType = node.nodeType;
      if (nodeType == 3) {
        if (!opt_fnFilter || opt_fnFilter(node, elem)) {
          textNodes.push(node);
        }
      } else if (nodeType == 1 || nodeType == 9 || nodeType == 11) {
        textNodes.push.apply(textNodes, _toConsumableArray(getTextNodesIn(node, opt_fnFilter)));
      }
    }
  }
  return textNodes;
}

/**
 * копирует дочерние элементы из node в родителя на место node и удаляет сам node
 * @param  {Node} node
 */
function unwrapNode(node) {
  var parent = node.parentNode;
  while (node.firstChild) {
    parent.insertBefore(node.firstChild, node);
  }
  parent.removeChild(node);
}

/**
 * оборачивает node во wrapper
 * @param  {Node} node
 * @param  {Node} wrapper
 */
function wrapNode(node, wrapper) {
  node.parentNode.insertBefore(wrapper, node);
  wrapper.appendChild(node);
}
function getNextSibling(node, fn) {
  if (!fn) {
    return node.nextSibling;
  }
  var sibling = node.nextSibling;
  while (sibling) {
    if (fn(sibling)) {
      break;
    }
    sibling = sibling.nextSibling;
  }
  return sibling;
}
function getAttributesString(node) {
  var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var attributes = [];
  var _iterator3 = _createForOfIteratorHelper(node.getAttributeNames()),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var attribute = _step3.value;
      if (skip.indexOf(attribute) >= 0) {
        continue;
      }
      attributes.push(attribute + '="' + _escape(node.getAttribute(attribute)) + '"');
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return attributes.join(' ');
}

/**
 * Устанавливает курсор в конец contenteditable элемента
 * @param {Node} domNode
 */
function contenteditableCursorToEnd(domNode) {
  if (domNode) {
    domNode.focus();
    var selection = window.getSelection();
    var range = new Range();
    range.selectNodeContents(domNode);
    range.collapse();
    selection.removeAllRanges();
    selection.addRange(range);
  }
}

/***/ }),

/***/ 92143:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": () => (/* binding */ createPopper)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var popper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12212);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








function createPopper(anchor, popup) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var allowFlip = true;
  var storeState = {};
  options = Object.assign({
    placement: 'right-start',
    preservePosition: true,
    removeOnDestroy: true,
    behavior: 'flip',
    priority: ['bottom', 'top'],
    offset: '-11px, 0',
    boundariesElement: 'viewport'
  }, options);
  var fn = null;
  if (options.preservePosition) {
    fn = function fn(data, options) {
      if (!allowFlip) {
        return Object.assign(data, storeState);
      }
      data = popper_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Defaults.modifiers.flip.fn */ .Z.Defaults.modifiers.flip.fn(data, options);
      storeState = {
        flipped: data.flipped,
        placement: data.placement,
        offsets: data.offsets
      };
      return data;
    };
  }
  return new popper_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z(anchor, popup, {
    positionFixed: options.positionFixed,
    placement: options.placement,
    removeOnDestroy: options.removeOnDestroy,
    onCreate: function onCreate() {
      // позволяем перевернутся меню только при начальном рендере
      allowFlip = false;
    },
    modifiers: _objectSpread({
      flip: {
        behavior: options.behavior,
        fn: fn,
        boundariesElement: options.boundariesElement
      },
      offset: {
        offset: options.offset
      },
      preventOverflow: _objectSpread({
        priority: options.priority
      }, options.overflowBoundariesElement ? {
        boundariesElement: options.overflowBoundariesElement
      } : {})
    }, options.arrow ? options.arrow : {})
  });
}

/***/ }),

/***/ 28480:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ PopupMenuItemsNav)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91038);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var is_hotkey__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(28199);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }











function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var isArrowDownKey = (0,is_hotkey__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)('down');
var isArrowUpKey = (0,is_hotkey__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)('up');
var isCtrlDownKey = (0,is_hotkey__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)('mod+down');
var isCtrlUpKey = (0,is_hotkey__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)('mod+up');
var PopupMenuItemsNav = /*#__PURE__*/function () {
  function PopupMenuItemsNav(props) {
    _classCallCheck(this, PopupMenuItemsNav);
    this.props = props;
    this.popup = props.popup;
    this.selector = props.selector;
    this.selectedClass = props.selectedClass;
    this.allowMultipleSelect = props.hasOwnProperty('allowMultipleSelect') ? props.allowMultipleSelect : false;
  }
  _createClass(PopupMenuItemsNav, [{
    key: "items",
    get: function get() {
      if (!this.popup.domNode) return [];
      return Array.from(this.popup.domNode.querySelectorAll(this.selector)).filter(function (node) {
        return !node.classList.contains('hidden');
      });
    }
  }, {
    key: "getSelected",
    value: function getSelected() {
      var _this = this;
      var item = null;
      var selectedItems = this.items.filter(function (i) {
        return i.classList.contains(_this.selectedClass);
      });
      if (this.allowMultipleSelect) {
        return selectedItems;
      }
      if (selectedItems.length === 1) {
        item = selectedItems[0];
      }
      return item;
    }
  }, {
    key: "selectNext",
    value: function selectNext() {
      var selected = this.getSelected();
      if (selected) {
        var isMultiple = Array.isArray(selected);
        var current = isMultiple ? selected[selected.length - 1] : selected;
        var currentIndex = this.items.indexOf(current);
        var toSelect = currentIndex === this.items.length - 1 ? this.items[0] : this.items[currentIndex + 1];
        toSelect.classList.add(this.selectedClass);
        this.scrollIntoView(toSelect);
        current.classList.remove(this.selectedClass);
      } else {
        this.items[0].classList.add(this.selectedClass);
      }
    }
  }, {
    key: "selectPrev",
    value: function selectPrev() {
      var selected = this.getSelected();
      if (selected) {
        var isMultiple = Array.isArray(selected);
        var current = isMultiple ? selected[0] : selected;
        var currentIndex = this.items.indexOf(current);
        var toSelect = currentIndex === 0 ? this.items[this.items.length - 1] : this.items[currentIndex - 1];
        toSelect.classList.add(this.selectedClass);
        this.scrollIntoView(toSelect);
        current.classList.remove(this.selectedClass);
      } else {
        this.items[this.items.length - 1].classList.add(this.selectedClass);
      }
    }
  }, {
    key: "selectFirst",
    value: function selectFirst() {
      var selected = this.getSelected();
      if (selected) {
        var isMultiple = Array.isArray(selected);
        var current = isMultiple ? selected[0] : selected;
        if (this.items.indexOf(current) === 0) return;
        var toSelect = this.items[0];
        toSelect.classList.add(this.selectedClass);
        this.scrollIntoView(toSelect);
        current.classList.remove(this.selectedClass);
      } else {
        this.items[0].classList.add(this.selectedClass);
      }
    }
  }, {
    key: "selectLast",
    value: function selectLast() {
      var selected = this.getSelected();
      if (selected) {
        var isMultiple = Array.isArray(selected);
        var current = isMultiple ? selected[0] : selected;
        if (this.items.indexOf(current) === this.items.length - 1) return;
        var toSelect = this.items[this.items.length - 1];
        toSelect.classList.add(this.selectedClass);
        this.scrollIntoView(toSelect);
        current.classList.remove(this.selectedClass);
      } else {
        this.items[this.items.length - 1].classList.add(this.selectedClass);
      }
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView(node) {
      var container = this.popup.domNode;
      if (!container) return;
      var _node$getBoundingClie = node.getBoundingClientRect(),
        itemHeight = _node$getBoundingClie.height;
      var _container$getBoundin = container.getBoundingClientRect(),
        containerHeight = _container$getBoundin.height;
      var scrollTop = null;
      if (node.offsetTop + itemHeight > containerHeight + container.scrollTop) {
        scrollTop = node.offsetTop + itemHeight - containerHeight;
      } else if (node.offsetTop < container.scrollTop) {
        scrollTop = node.offsetTop;
      }
      if (this.props.stickyHeader && this.props.headerHeight) {
        if (scrollTop !== null) {
          if (node.offsetTop - scrollTop < this.props.headerHeight) {
            scrollTop = node.offsetTop - scrollTop;
          }
        } else {
          if (node.offsetTop - container.scrollTop < this.props.headerHeight) {
            scrollTop = container.scrollTop - this.props.headerHeight;
          }
        }
      }
      if (scrollTop !== null) {
        container.scrollTop = scrollTop;
      }
    }
  }, {
    key: "selectItems",
    value: function selectItems() {
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var selected = this.getSelected();
      var isMultiple = Array.isArray(selected);
      if (isMultiple) {
        var _iterator = _createForOfIteratorHelper(selected),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            item.classList.remove(this.selectedClass);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        selected.classList.remove(this.selectedClass);
      }
      if (items) {
        if (Array.isArray(items) && items.length) {
          if (items.length === 1) {
            items[0].classList.add(this.selectedClass);
          } else if (this.allowMultipleSelect) {
            var _iterator2 = _createForOfIteratorHelper(items),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _item = _step2.value;
                _item.classList.add(this.selectedClass);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          } else {
            console.error('Multiple select items is not allowed');
          }
        } else if (items.classList) {
          items.classList.add(this.selectedClass);
        }
      }
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(event) {
      var processed = false;
      if (isArrowDownKey(event)) {
        processed = true;
        this.selectNext();
      } else if (isArrowUpKey(event)) {
        processed = true;
        this.selectPrev();
      } else if (isCtrlDownKey(event)) {
        processed = true;
        this.selectLast();
      } else if (isCtrlUpKey(event)) {
        processed = true;
        this.selectFirst();
      }
      if (processed) {
        event.preventDefault();
        event.stopPropagation();
      }
      return processed;
    }
  }]);
  return PopupMenuItemsNav;
}();


/***/ }),

/***/ 50172:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
!function (t, n) {
  "object" == ( false ? 0 : _typeof(exports)) && "undefined" != "object" ? module.exports = function (t, n, e, i, o) {
    for (n = n.split ? n.split(".") : n, i = 0; i < n.length; i++) {
      t = t ? t[n[i]] : o;
    }
    return t === o ? e : t;
  } :  true ? !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    return function (t, n, e, i, o) {
      for (n = n.split ? n.split(".") : n, i = 0; i < n.length; i++) {
        t = t ? t[n[i]] : o;
      }
      return t === o ? e : t;
    };
  }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : 0;
}(this);

/***/ }),

/***/ 27266:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(82472);
__webpack_require__(92990);
__webpack_require__(18927);
__webpack_require__(33105);
__webpack_require__(35035);
__webpack_require__(74345);
__webpack_require__(7174);
__webpack_require__(32846);
__webpack_require__(44731);
__webpack_require__(77209);
__webpack_require__(96319);
__webpack_require__(58867);
__webpack_require__(37789);
__webpack_require__(33739);
__webpack_require__(29368);
__webpack_require__(14483);
__webpack_require__(12056);
__webpack_require__(3462);
__webpack_require__(30678);
__webpack_require__(27462);
__webpack_require__(33824);
__webpack_require__(55021);
__webpack_require__(12974);
__webpack_require__(15016);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(60285);
__webpack_require__(41637);
__webpack_require__(15306);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download

(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(this, function () {
  return function download(data, strFileName, strMimeType) {
    var self = window,
      // this script is only for browsers anyway...
      defaultMime = "application/octet-stream",
      // this default mime also triggers iframe downloads
      mimeType = strMimeType || defaultMime,
      payload = data,
      url = !strFileName && !strMimeType && payload,
      anchor = document.createElement("a"),
      toString = function toString(a) {
        return String(a);
      },
      myBlob = self.Blob || self.MozBlob || self.WebKitBlob || toString,
      fileName = strFileName || "download",
      blob,
      reader;
    myBlob = myBlob.call ? myBlob.bind(self) : Blob;
    if (String(this) === "true") {
      //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
      payload = [payload, mimeType];
      mimeType = payload[0];
      payload = payload[1];
    }
    if (url && url.length < 2048) {
      // if no filename and no mime, assume a url was passed as the only argument
      fileName = url.split("/").pop().split("?")[0];
      anchor.href = url; // assign href prop to temp anchor
      if (anchor.href.indexOf(url) !== -1) {
        // if the browser determines that it's a potentially valid url path:
        var ajax = new XMLHttpRequest();
        ajax.open("GET", url, true);
        ajax.responseType = 'blob';
        ajax.onload = function (e) {
          download(e.target.response, fileName, defaultMime);
        };
        setTimeout(function () {
          ajax.send();
        }, 0); // allows setting custom ajax headers using the return:
        return ajax;
      } // end if valid url?
    } // end if url?

    //go ahead and download dataURLs right away
    if (/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)) {
      if (payload.length > 1024 * 1024 * 1.999 && myBlob !== toString) {
        payload = dataUrlToBlob(payload);
        mimeType = payload.type || defaultMime;
      } else {
        return navigator.msSaveBlob ?
        // IE10 can't do a[download], only Blobs:
        navigator.msSaveBlob(dataUrlToBlob(payload), fileName) : saver(payload); // everyone else can save dataURLs un-processed
      }
    } else {
      //not data url, is it a string with special needs?
      if (/([\x80-\xff])/.test(payload)) {
        var i = 0,
          tempUiArr = new Uint8Array(payload.length),
          mx = tempUiArr.length;
        for (i; i < mx; ++i) {
          tempUiArr[i] = payload.charCodeAt(i);
        }
        payload = new myBlob([tempUiArr], {
          type: mimeType
        });
      }
    }
    blob = payload instanceof myBlob ? payload : new myBlob([payload], {
      type: mimeType
    });
    function dataUrlToBlob(strUrl) {
      var parts = strUrl.split(/[:;,]/),
        type = parts[1],
        decoder = parts[2] == "base64" ? atob : decodeURIComponent,
        binData = decoder(parts.pop()),
        mx = binData.length,
        i = 0,
        uiArr = new Uint8Array(mx);
      for (i; i < mx; ++i) {
        uiArr[i] = binData.charCodeAt(i);
      }
      return new myBlob([uiArr], {
        type: type
      });
    }
    function saver(url, winMode) {
      if ('download' in anchor) {
        //html5 A[download]
        anchor.href = url;
        anchor.setAttribute("download", fileName);
        anchor.className = "download-js-link";
        anchor.innerHTML = "downloading...";
        anchor.style.display = "none";
        document.body.appendChild(anchor);
        setTimeout(function () {
          anchor.click();
          document.body.removeChild(anchor);
          if (winMode === true) {
            setTimeout(function () {
              self.URL.revokeObjectURL(anchor.href);
            }, 250);
          }
        }, 66);
        return true;
      }

      // handle non-a[download] safari as best we can:
      if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
        if (/^data:/.test(url)) url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
        if (!window.open(url)) {
          // popup blocked, offer direct download:
          if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) {
            location.href = url;
          }
        }
        return true;
      }

      //do iframe dataURL download (old ch+FF):
      var f = document.createElement("iframe");
      document.body.appendChild(f);
      if (!winMode && /^data:/.test(url)) {
        // force a mime that will download:
        url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
      }
      f.src = url;
      setTimeout(function () {
        document.body.removeChild(f);
      }, 333);
    } //end saver

    if (navigator.msSaveBlob) {
      // IE10+ : (has Blob, but not a[download] or URL)
      return navigator.msSaveBlob(blob, fileName);
    }
    if (self.URL) {
      // simple fast and modern way using Blob and URL:
      saver(self.URL.createObjectURL(blob), true);
    } else {
      // handle non-Blob()+non-URL browsers:
      if (typeof blob === "string" || blob.constructor === toString) {
        try {
          return saver("data:" + mimeType + ";base64," + self.btoa(blob));
        } catch (y) {
          return saver("data:" + mimeType + "," + encodeURIComponent(blob));
        }
      }

      // Blob but not URL support:
      reader = new FileReader();
      reader.onload = function (e) {
        saver(this.result);
      };
      reader.readAsDataURL(blob);
    }
    return true;
  }; /* end download() */
});

/***/ }),

/***/ 94092:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



__webpack_require__(36535);
__webpack_require__(67556);
__webpack_require__(82526);
__webpack_require__(92222);
__webpack_require__(36210);
__webpack_require__(44048);
__webpack_require__(9653);
__webpack_require__(30489);
__webpack_require__(68309);
__webpack_require__(47941);
__webpack_require__(41539);
__webpack_require__(47042);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
var R = (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === 'object' ? Reflect : null;
var ReflectApply = R && typeof R.apply === 'function' ? R.apply : function ReflectApply(target, receiver, args) {
  return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys;
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}
function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
};
function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;
function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + _typeof(listener));
  }
}
Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function get() {
    return defaultMaxListeners;
  },
  set: function set(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});
EventEmitter.init = function () {
  if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }
  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};
function _getMaxListeners(that) {
  if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) {
    args.push(arguments[i]);
  }
  var doError = type === 'error';
  var events = this._events;
  if (events !== undefined) doError = doError && events.error === undefined;else if (!doError) return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0) er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];
  if (handler === undefined) return false;
  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i) {
      ReflectApply(listeners[i], this, args);
    }
  }
  return true;
};
function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;
  checkListener(listener);
  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type, listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }
  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] = prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }
  return target;
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
  return _addListener(this, type, listener, true);
};
function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0) return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}
function _onceWrap(target, type, listener) {
  var state = {
    fired: false,
    wrapFn: undefined,
    target: target,
    type: type,
    listener: listener
  };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}
EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
  checkListener(listener);
  this.prependListener(type, _onceWrap(this, type, listener));
  return this;
};

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
  var list, events, position, i, originalListener;
  checkListener(listener);
  events = this._events;
  if (events === undefined) return this;
  list = events[type];
  if (list === undefined) return this;
  if (list === listener || list.listener === listener) {
    if (--this._eventsCount === 0) this._events = Object.create(null);else {
      delete events[type];
      if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
    }
  } else if (typeof list !== 'function') {
    position = -1;
    for (i = list.length - 1; i >= 0; i--) {
      if (list[i] === listener || list[i].listener === listener) {
        originalListener = list[i].listener;
        position = i;
        break;
      }
    }
    if (position < 0) return this;
    if (position === 0) list.shift();else {
      spliceOne(list, position);
    }
    if (list.length === 1) events[type] = list[0];
    if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
  }
  return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
  var listeners, events, i;
  events = this._events;
  if (events === undefined) return this;

  // not listening for removeListener, no need to emit
  if (events.removeListener === undefined) {
    if (arguments.length === 0) {
      this._events = Object.create(null);
      this._eventsCount = 0;
    } else if (events[type] !== undefined) {
      if (--this._eventsCount === 0) this._events = Object.create(null);else delete events[type];
    }
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    var keys = Object.keys(events);
    var key;
    for (i = 0; i < keys.length; ++i) {
      key = keys[i];
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = Object.create(null);
    this._eventsCount = 0;
    return this;
  }
  listeners = events[type];
  if (typeof listeners === 'function') {
    this.removeListener(type, listeners);
  } else if (listeners !== undefined) {
    // LIFO order
    for (i = listeners.length - 1; i >= 0; i--) {
      this.removeListener(type, listeners[i]);
    }
  }
  return this;
};
function _listeners(target, type, unwrap) {
  var events = target._events;
  if (events === undefined) return [];
  var evlistener = events[type];
  if (evlistener === undefined) return [];
  if (typeof evlistener === 'function') return unwrap ? [evlistener.listener || evlistener] : [evlistener];
  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};
EventEmitter.listenerCount = function (emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;
  if (events !== undefined) {
    var evlistener = events[type];
    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }
  return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i) {
    copy[i] = arr[i];
  }
  return copy;
}
function spliceOne(list, index) {
  for (; index + 1 < list.length; index++) {
    list[index] = list[index + 1];
  }
  list.pop();
}
function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}
function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }
    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    }
    ;
    eventTargetAgnosticAddListener(emitter, name, resolver, {
      once: true
    });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, {
        once: true
      });
    }
  });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}
function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + _typeof(emitter));
  }
}

/***/ }),

/***/ 28199:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_require__(21249);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(23123);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(27852);
__webpack_require__(47042);
__webpack_unused_export__ = ({
  value: true
});

/**
 * Constants.
 */

var IS_MAC = typeof window != 'undefined' && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
var MODIFIERS = {
  alt: 'altKey',
  control: 'ctrlKey',
  meta: 'metaKey',
  shift: 'shiftKey'
};
var ALIASES = {
  add: '+',
  break: 'pause',
  cmd: 'meta',
  command: 'meta',
  ctl: 'control',
  ctrl: 'control',
  del: 'delete',
  down: 'arrowdown',
  esc: 'escape',
  ins: 'insert',
  left: 'arrowleft',
  mod: IS_MAC ? 'meta' : 'control',
  opt: 'alt',
  option: 'alt',
  return: 'enter',
  right: 'arrowright',
  space: ' ',
  spacebar: ' ',
  up: 'arrowup',
  win: 'meta',
  windows: 'meta'
};
var CODES = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  escape: 27,
  ' ': 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  arrowleft: 37,
  arrowup: 38,
  arrowright: 39,
  arrowdown: 40,
  insert: 45,
  delete: 46,
  meta: 91,
  numlock: 144,
  scrolllock: 145,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  '\'': 222
};
for (var f = 1; f < 20; f++) {
  CODES['f' + f] = 111 + f;
}

/**
 * Is hotkey?
 */

function isHotkey(hotkey, options, event) {
  if (options && !('byKey' in options)) {
    event = options;
    options = null;
  }
  if (!Array.isArray(hotkey)) {
    hotkey = [hotkey];
  }
  var array = hotkey.map(function (string) {
    return parseHotkey(string, options);
  });
  var check = function check(e) {
    return array.some(function (object) {
      return compareHotkey(object, e);
    });
  };
  var ret = event == null ? check : check(event);
  return ret;
}
function isCodeHotkey(hotkey, event) {
  return isHotkey(hotkey, event);
}
function isKeyHotkey(hotkey, event) {
  return isHotkey(hotkey, {
    byKey: true
  }, event);
}

/**
 * Parse.
 */

function parseHotkey(hotkey, options) {
  var byKey = options && options.byKey;
  var ret = {};

  // Special case to handle the `+` key since we use it as a separator.
  hotkey = hotkey.replace('++', '+add');
  var values = hotkey.split('+');
  var length = values.length;

  // Ensure that all the modifiers are set to false unless the hotkey has them.

  for (var k in MODIFIERS) {
    ret[MODIFIERS[k]] = false;
  }
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;
  try {
    for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var value = _step.value;
      var optional = value.endsWith('?') && value.length > 1;
      if (optional) {
        value = value.slice(0, -1);
      }
      var name = toKeyName(value);
      var modifier = MODIFIERS[name];
      if (length === 1 || !modifier) {
        if (byKey) {
          ret.key = name;
        } else {
          ret.which = toKeyCode(value);
        }
      }
      if (modifier) {
        ret[modifier] = optional ? null : true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return ret;
}

/**
 * Compare.
 */

function compareHotkey(object, event) {
  for (var key in object) {
    var expected = object[key];
    var actual = void 0;
    if (expected == null) {
      continue;
    }
    if (key === 'key' && event.key != null) {
      actual = event.key.toLowerCase();
    } else if (key === 'which') {
      actual = expected === 91 && event.which === 93 ? 91 : event.which;
    } else {
      actual = event[key];
    }
    if (actual == null && expected === false) {
      continue;
    }
    if (actual !== expected) {
      return false;
    }
  }
  return true;
}

/**
 * Utils.
 */

function toKeyCode(name) {
  name = toKeyName(name);
  var code = CODES[name] || name.toUpperCase().charCodeAt(0);
  return code;
}
function toKeyName(name) {
  name = name.toLowerCase();
  name = ALIASES[name] || name;
  return name;
}

/**
 * Export.
 */

exports.ZP = isHotkey;
__webpack_unused_export__ = isHotkey;
__webpack_unused_export__ = isCodeHotkey;
__webpack_unused_export__ = isKeyHotkey;
__webpack_unused_export__ = parseHotkey;
__webpack_unused_export__ = compareHotkey;
__webpack_unused_export__ = toKeyCode;
__webpack_unused_export__ = toKeyName;

/***/ }),

/***/ 60764:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(47042);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
  MAX_SAFE_INTEGER = 9007199254740991,
  MAX_INTEGER = 1.7976931348623157e+308,
  NAN = 0 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
  genTag = '[object GeneratorFunction]',
  symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
  nativeMax = Math.max;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
    length = array.length;
  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = _typeof(index);
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if (guard ? isIterateeCall(array, size, guard) : size === undefined) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array ? array.length : 0;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
    resIndex = 0,
    result = Array(nativeCeil(length / size));
  while (index < length) {
    result[resIndex++] = baseSlice(array, index, index += size);
  }
  return result;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = _typeof(value);
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && _typeof(value) == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return _typeof(value) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
    remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = chunk;

/***/ }),

/***/ 21791:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(47042);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof __webpack_require__.g === "undefined" ? "undefined" : _typeof(__webpack_require__.g)) == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
  nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function now() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
    lastThis,
    maxWait,
    result,
    timerId,
    lastCallTime,
    lastInvokeTime = 0,
    leading = false,
    maxing = false,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs,
      thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime,
      result = wait - timeSinceLastCall;
    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }
  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }
  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }
  function debounced() {
    var time = now(),
      isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = _typeof(value);
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && _typeof(value) == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return _typeof(value) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = debounce;

/***/ }),

/***/ 66213:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(24603);
__webpack_require__(74916);
__webpack_require__(39714);
__webpack_require__(41539);
__webpack_require__(15306);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"'`]/g,
  reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof __webpack_require__.g === "undefined" ? "undefined" : _typeof(__webpack_require__.g)) == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function (key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var _Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
  symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && _typeof(value) == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return _typeof(value) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
 * their corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * Backticks are escaped because in IE < 9, they can break out of
 * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
 * [#133](https://html5sec.org/#133) of the
 * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape(string) {
  string = toString(string);
  return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
}
module.exports = escape;

/***/ }),

/***/ 47983:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(47042);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof __webpack_require__.g === "undefined" ? "undefined" : _typeof(__webpack_require__.g)) == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
  nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function now() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
    lastThis,
    maxWait,
    result,
    timerId,
    lastCallTime,
    lastInvokeTime = 0,
    leading = false,
    maxing = false,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs,
      thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime,
      result = wait - timeSinceLastCall;
    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }
  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }
  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }
  function debounced() {
    var time = now(),
      isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = _typeof(value);
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && _typeof(value) == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return _typeof(value) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = throttle;

/***/ }),

/***/ 12212:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2707);
/* harmony import */ var core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23123);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69826);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34553);
/* harmony import */ var core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(4723);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(73210);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(64765);
/* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_17__);


















/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();
function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}
function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}
var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }
  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
    overflow = _getStyleComputedProp.overflow,
    overflowX = _getStyleComputedProp.overflowX,
    overflowY = _getStyleComputedProp.overflowY;
  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }
  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }
  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }
  var nodeName = offsetParent && offsetParent.nodeName;
  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }
  return offsetParent;
}
function isOffsetContainer(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }
  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }
    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }
  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}
function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);
  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}
var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
};
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}
  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;
  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');
    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }
  return getClientRect(result);
}
function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);
  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);
    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }
  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }
  return offsets;
}
function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);
  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };
  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = {
    top: 0,
    left: 0
  };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }
    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
        height = _getWindowSizes.height,
        width = _getWindowSizes.width;
      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
  return boundaries;
}
function getArea(_ref) {
  var width = _ref.width,
    height = _ref.height;
  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  if (placement.indexOf('auto') === -1) {
    return placement;
  }
  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };
  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });
  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
      height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });
  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
  var variation = placement.split('-')[1];
  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
  };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }
  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);
      data = fn(data, modifier);
    }
  });
  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }
  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;
  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
      enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }
  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}
function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, {
    passive: true
  });
  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, {
    passive: true
  });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;
  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }
  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, {
    position: options.positionFixed ? 'fixed' : 'absolute'
  });
  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
    popper = _data$offsets.popper,
    reference = _data$offsets.reference;
  var round = Math.round,
    floor = Math.floor;
  var noRound = function noRound(v) {
    return v;
  };
  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);
  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;
  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}
var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
    y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };
  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
    top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });
  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });
  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }
  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }
  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
    popper = _data$offsets.popper,
    reference = _data$offsets.reference;
  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}
var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }
  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }
  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';
  var flipOrder = [];
  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }
  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }
    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);
    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;
      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }
      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }
      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
    popper = _data$offsets.popper,
    reference = _data$offsets.reference;
  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';
  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }
  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }
  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }
    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));
  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
    _data$offsets = data.offsets,
    popper = _data$offsets.popper,
    reference = _data$offsets.reference;
  var basePlacement = placement.split('-')[0];
  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }
  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }
  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
    left = popperStyles.left,
    transform = popperStyles[transformProp];
  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';
  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;
  options.boundaries = boundaries;
  var order = options.priority;
  var popper = data.offsets.popper;
  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };
  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });
  data.offsets.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
      reference = _data$offsets.reference,
      popper = _data$offsets.popper;
    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };
    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }
  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;
  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }
    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }
    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
    popper = _data$offsets.popper,
    reference = _data$offsets.reference;
  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);
  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },
  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },
  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },
  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },
  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },
  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },
  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },
  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },
  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },
  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',
  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,
  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,
  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,
  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},
  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},
  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);
    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();
    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }
    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs

  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */

    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */
  }]);

  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */

Popper.Utils = (typeof window !== 'undefined' ? window : __webpack_require__.g).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Popper);

/***/ }),

/***/ 79758:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sY": () => (/* binding */ S),
/* harmony export */   "h": () => (/* binding */ v),
/* harmony export */   "wA": () => (/* binding */ _),
/* harmony export */   "Tm": () => (/* binding */ B),
/* harmony export */   "kr": () => (/* binding */ D),
/* harmony export */   "bR": () => (/* binding */ A),
/* harmony export */   "YM": () => (/* binding */ l)
/* harmony export */ });
/* unused harmony exports hydrate, createElement, Fragment, createRef, isValidElement */
/* harmony import */ var core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2707);
/* harmony import */ var core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_sub_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60086);
/* harmony import */ var core_js_modules_es_string_sub_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_sub_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40561);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__);









var n,
  l,
  u,
  i,
  t,
  o,
  r,
  f,
  e = {},
  c = [],
  s = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function a(n, l) {
  for (var u in l) {
    n[u] = l[u];
  }
  return n;
}
function h(n) {
  var l = n.parentNode;
  l && l.removeChild(n);
}
function v(l, u, i) {
  var t,
    o,
    r,
    f = {};
  for (r in u) {
    "key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
  }
  if (arguments.length > 2 && (f.children = arguments.length > 3 ? n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for (r in l.defaultProps) {
    void 0 === f[r] && (f[r] = l.defaultProps[r]);
  }
  return y(l, f, t, o, null);
}
function y(n, i, t, o, r) {
  var f = {
    type: n,
    props: i,
    key: t,
    ref: o,
    __k: null,
    __: null,
    __b: 0,
    __e: null,
    __d: void 0,
    __c: null,
    __h: null,
    constructor: void 0,
    __v: null == r ? ++u : r
  };
  return null != l.vnode && l.vnode(f), f;
}
function p() {
  return {
    current: null
  };
}
function d(n) {
  return n.children;
}
function _(n, l) {
  this.props = n, this.context = l;
}
function k(n, l) {
  if (null == l) return n.__ ? k(n.__, n.__.__k.indexOf(n) + 1) : null;
  for (var u; l < n.__k.length; l++) {
    if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
  }
  return "function" == typeof n.type ? k(n) : null;
}
function b(n) {
  var l, u;
  if (null != (n = n.__) && null != n.__c) {
    for (n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++) {
      if (null != (u = n.__k[l]) && null != u.__e) {
        n.__e = n.__c.base = u.__e;
        break;
      }
    }
    return b(n);
  }
}
function m(n) {
  (!n.__d && (n.__d = !0) && t.push(n) && !g.__r++ || r !== l.debounceRendering) && ((r = l.debounceRendering) || o)(g);
}
function g() {
  for (var n; g.__r = t.length;) {
    n = t.sort(function (n, l) {
      return n.__v.__b - l.__v.__b;
    }), t = [], n.some(function (n) {
      var l, u, i, t, o, r;
      n.__d && (o = (t = (l = n).__v).__e, (r = l.__P) && (u = [], (i = a({}, t)).__v = t.__v + 1, j(r, t, i, l.__n, void 0 !== r.ownerSVGElement, null != t.__h ? [o] : null, u, null == o ? k(t) : o, t.__h), z(u, t), t.__e != o && b(t)));
    });
  }
}
function w(n, l, u, i, t, o, r, f, s, a) {
  var h,
    v,
    p,
    _,
    b,
    m,
    g,
    w = i && i.__k || c,
    A = w.length;
  for (u.__k = [], h = 0; h < l.length; h++) {
    if (null != (_ = u.__k[h] = null == (_ = l[h]) || "boolean" == typeof _ ? null : "string" == typeof _ || "number" == typeof _ || "bigint" == typeof _ ? y(null, _, null, null, _) : Array.isArray(_) ? y(d, {
      children: _
    }, null, null, null) : _.__b > 0 ? y(_.type, _.props, _.key, null, _.__v) : _)) {
      if (_.__ = u, _.__b = u.__b + 1, null === (p = w[h]) || p && _.key == p.key && _.type === p.type) w[h] = void 0;else for (v = 0; v < A; v++) {
        if ((p = w[v]) && _.key == p.key && _.type === p.type) {
          w[v] = void 0;
          break;
        }
        p = null;
      }
      j(n, _, p = p || e, t, o, r, f, s, a), b = _.__e, (v = _.ref) && p.ref != v && (g || (g = []), p.ref && g.push(p.ref, null, _), g.push(v, _.__c || b, _)), null != b ? (null == m && (m = b), "function" == typeof _.type && null != _.__k && _.__k === p.__k ? _.__d = s = x(_, s, n) : s = P(n, _, p, w, b, s), a || "option" !== u.type ? "function" == typeof u.type && (u.__d = s) : n.value = "") : s && p.__e == s && s.parentNode != n && (s = k(p));
    }
  }
  for (u.__e = m, h = A; h--;) {
    null != w[h] && ("function" == typeof u.type && null != w[h].__e && w[h].__e == u.__d && (u.__d = k(i, h + 1)), N(w[h], w[h]));
  }
  if (g) for (h = 0; h < g.length; h++) {
    M(g[h], g[++h], g[++h]);
  }
}
function x(n, l, u) {
  var i, t;
  for (i = 0; i < n.__k.length; i++) {
    (t = n.__k[i]) && (t.__ = n, l = "function" == typeof t.type ? x(t, l, u) : P(u, t, t, n.__k, t.__e, l));
  }
  return l;
}
function A(n, l) {
  return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function (n) {
    A(n, l);
  }) : l.push(n)), l;
}
function P(n, l, u, i, t, o) {
  var r, f, e;
  if (void 0 !== l.__d) r = l.__d, l.__d = void 0;else if (null == u || t != o || null == t.parentNode) n: if (null == o || o.parentNode !== n) n.appendChild(t), r = null;else {
    for (f = o, e = 0; (f = f.nextSibling) && e < i.length; e += 2) {
      if (f == t) break n;
    }
    n.insertBefore(t, o), r = o;
  }
  return void 0 !== r ? r : t.nextSibling;
}
function C(n, l, u, i, t) {
  var o;
  for (o in u) {
    "children" === o || "key" === o || o in l || H(n, o, null, u[o], i);
  }
  for (o in l) {
    t && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || H(n, o, l[o], u[o], i);
  }
}
function $(n, l, u) {
  "-" === l[0] ? n.setProperty(l, u) : n[l] = null == u ? "" : "number" != typeof u || s.test(l) ? u : u + "px";
}
function H(n, l, u, i, t) {
  var o;
  n: if ("style" === l) {
    if ("string" == typeof u) n.style.cssText = u;else {
      if ("string" == typeof i && (n.style.cssText = i = ""), i) for (l in i) {
        u && l in u || $(n.style, l, "");
      }
      if (u) for (l in u) {
        i && u[l] === i[l] || $(n.style, l, u[l]);
      }
    }
  } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? i || n.addEventListener(l, o ? T : I, o) : n.removeEventListener(l, o ? T : I, o);else if ("dangerouslySetInnerHTML" !== l) {
    if (t) l = l.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");else if ("href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
      n[l] = null == u ? "" : u;
      break n;
    } catch (n) {}
    "function" == typeof u || (null != u && (!1 !== u || "a" === l[0] && "r" === l[1]) ? n.setAttribute(l, u) : n.removeAttribute(l));
  }
}
function I(n) {
  this.l[n.type + !1](l.event ? l.event(n) : n);
}
function T(n) {
  this.l[n.type + !0](l.event ? l.event(n) : n);
}
function j(n, u, i, t, o, r, f, e, c) {
  var s,
    h,
    v,
    y,
    p,
    k,
    b,
    m,
    g,
    x,
    A,
    P = u.type;
  if (void 0 !== u.constructor) return null;
  null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, r = [e]), (s = l.__b) && s(u);
  try {
    n: if ("function" == typeof P) {
      if (m = u.props, g = (s = P.contextType) && t[s.__c], x = s ? g ? g.props.value : s.__ : t, i.__c ? b = (h = u.__c = i.__c).__ = h.__E : ("prototype" in P && P.prototype.render ? u.__c = h = new P(m, x) : (u.__c = h = new _(m, x), h.constructor = P, h.render = O), g && g.sub(h), h.props = m, h.state || (h.state = {}), h.context = x, h.__n = t, v = h.__d = !0, h.__h = []), null == h.__s && (h.__s = h.state), null != P.getDerivedStateFromProps && (h.__s == h.state && (h.__s = a({}, h.__s)), a(h.__s, P.getDerivedStateFromProps(m, h.__s))), y = h.props, p = h.state, v) null == P.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), null != h.componentDidMount && h.__h.push(h.componentDidMount);else {
        if (null == P.getDerivedStateFromProps && m !== y && null != h.componentWillReceiveProps && h.componentWillReceiveProps(m, x), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(m, h.__s, x) || u.__v === i.__v) {
          h.props = m, h.state = h.__s, u.__v !== i.__v && (h.__d = !1), h.__v = u, u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function (n) {
            n && (n.__ = u);
          }), h.__h.length && f.push(h);
          break n;
        }
        null != h.componentWillUpdate && h.componentWillUpdate(m, h.__s, x), null != h.componentDidUpdate && h.__h.push(function () {
          h.componentDidUpdate(y, p, k);
        });
      }
      h.context = x, h.props = m, h.state = h.__s, (s = l.__r) && s(u), h.__d = !1, h.__v = u, h.__P = n, s = h.render(h.props, h.state, h.context), h.state = h.__s, null != h.getChildContext && (t = a(a({}, t), h.getChildContext())), v || null == h.getSnapshotBeforeUpdate || (k = h.getSnapshotBeforeUpdate(y, p)), A = null != s && s.type === d && null == s.key ? s.props.children : s, w(n, Array.isArray(A) ? A : [A], u, i, t, o, r, f, e, c), h.base = u.__e, u.__h = null, h.__h.length && f.push(h), b && (h.__E = h.__ = null), h.__e = !1;
    } else null == r && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = L(i.__e, u, i, t, o, r, f, c);
    (s = l.diffed) && s(u);
  } catch (n) {
    u.__v = null, (c || null != r) && (u.__e = e, u.__h = !!c, r[r.indexOf(e)] = null), l.__e(n, u, i);
  }
}
function z(n, u) {
  l.__c && l.__c(u, n), n.some(function (u) {
    try {
      n = u.__h, u.__h = [], n.some(function (n) {
        n.call(u);
      });
    } catch (n) {
      l.__e(n, u.__v);
    }
  });
}
function L(l, u, i, t, o, r, f, c) {
  var s,
    a,
    v,
    y = i.props,
    p = u.props,
    d = u.type,
    _ = 0;
  if ("svg" === d && (o = !0), null != r) for (; _ < r.length; _++) {
    if ((s = r[_]) && (s === l || (d ? s.localName == d : 3 == s.nodeType))) {
      l = s, r[_] = null;
      break;
    }
  }
  if (null == l) {
    if (null === d) return document.createTextNode(p);
    l = o ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), r = null, c = !1;
  }
  if (null === d) y === p || c && l.data === p || (l.data = p);else {
    if (r = r && n.call(l.childNodes), a = (y = i.props || e).dangerouslySetInnerHTML, v = p.dangerouslySetInnerHTML, !c) {
      if (null != r) for (y = {}, _ = 0; _ < l.attributes.length; _++) {
        y[l.attributes[_].name] = l.attributes[_].value;
      }
      (v || a) && (v && (a && v.__html == a.__html || v.__html === l.innerHTML) || (l.innerHTML = v && v.__html || ""));
    }
    if (C(l, p, y, o, c), v) u.__k = [];else if (_ = u.props.children, w(l, Array.isArray(_) ? _ : [_], u, i, t, o && "foreignObject" !== d, r, f, r ? r[0] : i.__k && k(i, 0), c), null != r) for (_ = r.length; _--;) {
      null != r[_] && h(r[_]);
    }
    c || ("value" in p && void 0 !== (_ = p.value) && (_ !== l.value || "progress" === d && !_) && H(l, "value", _, y.value, !1), "checked" in p && void 0 !== (_ = p.checked) && _ !== l.checked && H(l, "checked", _, y.checked, !1));
  }
  return l;
}
function M(n, u, i) {
  try {
    "function" == typeof n ? n(u) : n.current = u;
  } catch (n) {
    l.__e(n, i);
  }
}
function N(n, u, i) {
  var t, o;
  if (l.unmount && l.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || M(t, null, u)), null != (t = n.__c)) {
    if (t.componentWillUnmount) try {
      t.componentWillUnmount();
    } catch (n) {
      l.__e(n, u);
    }
    t.base = t.__P = null;
  }
  if (t = n.__k) for (o = 0; o < t.length; o++) {
    t[o] && N(t[o], u, "function" != typeof n.type);
  }
  i || null == n.__e || h(n.__e), n.__e = n.__d = void 0;
}
function O(n, l, u) {
  return this.constructor(n, u);
}
function S(u, i, t) {
  var o, r, f;
  l.__ && l.__(u, i), r = (o = "function" == typeof t) ? null : t && t.__k || i.__k, f = [], j(i, u = (!o && t || i).__k = v(d, null, [u]), r || e, e, void 0 !== i.ownerSVGElement, !o && t ? [t] : r ? null : i.firstChild ? n.call(i.childNodes) : null, f, !o && t ? t : r ? r.__e : i.firstChild, o), z(f, u);
}
function q(n, l) {
  S(n, l, q);
}
function B(l, u, i) {
  var t,
    o,
    r,
    f = a({}, l.props);
  for (r in u) {
    "key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
  }
  return arguments.length > 2 && (f.children = arguments.length > 3 ? n.call(arguments, 2) : i), y(l.type, f, t || l.key, o || l.ref, null);
}
function D(n, l) {
  var u = {
    __c: l = "__cC" + f++,
    __: n,
    Consumer: function Consumer(n, l) {
      return n.children(l);
    },
    Provider: function Provider(n) {
      var u, i;
      return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function () {
        return i;
      }, this.shouldComponentUpdate = function (n) {
        this.props.value !== n.value && u.some(m);
      }, this.sub = function (n) {
        u.push(n);
        var l = n.componentWillUnmount;
        n.componentWillUnmount = function () {
          u.splice(u.indexOf(n), 1), l && l.call(n);
        };
      }), n.children;
    }
  };
  return u.Provider.__ = u.Consumer.contextType = u;
}
n = c.slice, l = {
  __e: function __e(n, l) {
    for (var u, i, t; l = l.__;) {
      if ((u = l.__c) && !u.__) try {
        if ((i = u.constructor) && null != i.getDerivedStateFromError && (u.setState(i.getDerivedStateFromError(n)), t = u.__d), null != u.componentDidCatch && (u.componentDidCatch(n), t = u.__d), t) return u.__E = u;
      } catch (l) {
        n = l;
      }
    }
    throw n;
  }
}, u = 0, i = function i(n) {
  return null != n && void 0 === n.constructor;
}, _.prototype.setState = function (n, l) {
  var u;
  u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = a({}, this.state), "function" == typeof n && (n = n(a({}, u), this.props)), n && a(u, n), null != n && this.__v && (l && this.__h.push(l), m(this));
}, _.prototype.forceUpdate = function (n) {
  this.__v && (this.__e = !0, n && this.__h.push(n), m(this));
}, _.prototype.render = d, t = [], o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, g.__r = 0, f = 0;


/***/ }),

/***/ 8065:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qp": () => (/* binding */ F)
/* harmony export */ });
/* unused harmony exports useState, useReducer, useEffect, useLayoutEffect, useRef, useImperativeHandle, useMemo, useCallback, useDebugValue, useErrorBoundary */
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_sub_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60086);
/* harmony import */ var core_js_modules_es_string_sub_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_sub_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79758);





var t,
  u,
  r,
  o = 0,
  i = [],
  c = preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__b */ .YM.__b,
  f = preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__r */ .YM.__r,
  e = preact__WEBPACK_IMPORTED_MODULE_4__/* .options.diffed */ .YM.diffed,
  a = preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__c */ .YM.__c,
  v = preact__WEBPACK_IMPORTED_MODULE_4__/* .options.unmount */ .YM.unmount;
function m(t, r) {
  preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__h */ .YM.__h && preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__h */ .YM.__h(u, t, o || r), o = 0;
  var i = u.__H || (u.__H = {
    __: [],
    __h: []
  });
  return t >= i.__.length && i.__.push({}), i.__[t];
}
function l(n) {
  return o = 1, p(w, n);
}
function p(n, r, o) {
  var i = m(t++, 2);
  return i.t = n, i.__c || (i.__ = [o ? o(r) : w(void 0, r), function (n) {
    var t = i.t(i.__[0], n);
    i.__[0] !== t && (i.__ = [t, i.__[1]], i.__c.setState({}));
  }], i.__c = u), i.__;
}
function y(r, o) {
  var i = m(t++, 3);
  !n.__s && k(i.__H, o) && (i.__ = r, i.__H = o, u.__H.__h.push(i));
}
function h(r, o) {
  var i = m(t++, 4);
  !n.__s && k(i.__H, o) && (i.__ = r, i.__H = o, u.__h.push(i));
}
function s(n) {
  return o = 5, d(function () {
    return {
      current: n
    };
  }, []);
}
function _(n, t, u) {
  o = 6, h(function () {
    "function" == typeof n ? n(t()) : n && (n.current = t());
  }, null == u ? u : u.concat(n));
}
function d(n, u) {
  var r = m(t++, 7);
  return k(r.__H, u) && (r.__ = n(), r.__H = u, r.__h = n), r.__;
}
function A(n, t) {
  return o = 8, d(function () {
    return n;
  }, t);
}
function F(n) {
  var r = u.context[n.__c],
    o = m(t++, 9);
  return o.c = n, r ? (null == o.__ && (o.__ = !0, r.sub(u)), r.props.value) : n.__;
}
function T(t, u) {
  n.useDebugValue && n.useDebugValue(u ? u(t) : t);
}
function q(n) {
  var r = m(t++, 10),
    o = l();
  return r.__ = n, u.componentDidCatch || (u.componentDidCatch = function (n) {
    r.__ && r.__(n), o[1](n);
  }), [o[0], function () {
    o[1](void 0);
  }];
}
function x() {
  i.forEach(function (t) {
    if (t.__P) try {
      t.__H.__h.forEach(g), t.__H.__h.forEach(j), t.__H.__h = [];
    } catch (u) {
      t.__H.__h = [], preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__e */ .YM.__e(u, t.__v);
    }
  }), i = [];
}
preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__b */ .YM.__b = function (n) {
  u = null, c && c(n);
}, preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__r */ .YM.__r = function (n) {
  f && f(n), t = 0;
  var r = (u = n.__c).__H;
  r && (r.__h.forEach(g), r.__h.forEach(j), r.__h = []);
}, preact__WEBPACK_IMPORTED_MODULE_4__/* .options.diffed */ .YM.diffed = function (t) {
  e && e(t);
  var o = t.__c;
  o && o.__H && o.__H.__h.length && (1 !== i.push(o) && r === preact__WEBPACK_IMPORTED_MODULE_4__/* .options.requestAnimationFrame */ .YM.requestAnimationFrame || ((r = preact__WEBPACK_IMPORTED_MODULE_4__/* .options.requestAnimationFrame */ .YM.requestAnimationFrame) || function (n) {
    var t,
      u = function u() {
        clearTimeout(r), b && cancelAnimationFrame(t), setTimeout(n);
      },
      r = setTimeout(u, 100);
    b && (t = requestAnimationFrame(u));
  })(x)), u = void 0;
}, preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__c */ .YM.__c = function (t, u) {
  u.some(function (t) {
    try {
      t.__h.forEach(g), t.__h = t.__h.filter(function (n) {
        return !n.__ || j(n);
      });
    } catch (r) {
      u.some(function (n) {
        n.__h && (n.__h = []);
      }), u = [], preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__e */ .YM.__e(r, t.__v);
    }
  }), a && a(t, u);
}, preact__WEBPACK_IMPORTED_MODULE_4__/* .options.unmount */ .YM.unmount = function (t) {
  v && v(t);
  var u = t.__c;
  if (u && u.__H) try {
    u.__H.__.forEach(g);
  } catch (t) {
    preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__e */ .YM.__e(t, u.__v);
  }
};
var b = "function" == typeof requestAnimationFrame;
function g(n) {
  var t = u;
  "function" == typeof n.__c && n.__c(), u = t;
}
function j(n) {
  var t = u;
  n.__c = n.__(), u = t;
}
function k(n, t) {
  return !n || n.length !== t.length || t.some(function (t, u) {
    return t !== n[u];
  });
}
function w(n, t) {
  return "function" == typeof t ? t(n) : t;
}


/***/ }),

/***/ 87751:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(72443);
__webpack_require__(39341);
__webpack_require__(73706);
__webpack_require__(10408);
__webpack_require__(30489);
__webpack_require__(68309);
__webpack_require__(54747);
__webpack_require__(47042);
__webpack_require__(65743);
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);
    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  exports.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction ||
    // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };
  exports.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function (arg) {
    return {
      __await: arg
    };
  };
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }
        return PromiseImpl.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function (error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }
    var previousPromise;
    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }
      return previousPromise =
      // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
      // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }
  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };
  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;
    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }
      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }
      context.method = method;
      context.arg = arg;
      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }
          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }
        state = GenStateExecuting;
        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;
          if (record.arg === ContinueSentinel) {
            continue;
          }
          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;
      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);
          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }
        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return ContinueSentinel;
    }
    var record = tryCatch(method, delegate.iterator, context.arg);
    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }
    var info = record.arg;
    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }
    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);
  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function () {
    return this;
  });
  define(Gp, "toString", function () {
    return "[object Generator]";
  });
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    if (1 in locs) {
      entry.catchLoc = locs[1];
    }
    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }
    this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }
  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{
      tryLoc: "root"
    }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }
  exports.keys = function (object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }
      if (typeof iterable.next === "function") {
        return iterable;
      }
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }
            next.value = undefined;
            next.done = true;
            return next;
          };
        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return {
      next: doneResult
    };
  }
  exports.values = values;
  function doneResult() {
    return {
      value: undefined,
      done: true
    };
  }
  Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;
      this.method = "next";
      this.arg = undefined;
      this.tryEntries.forEach(resetTryEntry);
      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },
    stop: function stop() {
      this.done = true;
      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }
      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;
        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }
        return !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;
        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }
      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;
      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }
      return this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }
      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }
      return ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };
      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }
      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;
}(
// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
( false ? 0 : _typeof(module)) === "object" ? module.exports : {});
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if ((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

/***/ }),

/***/ 19662:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);
var tryToString = __webpack_require__(66330);

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 39483:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isConstructor = __webpack_require__(4411);
var tryToString = __webpack_require__(66330);

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ 96077:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);

module.exports = function (argument) {
  if (typeof argument === 'object' || isCallable(argument)) return argument;
  throw TypeError("Can't set " + String(argument) + ' as a prototype');
};


/***/ }),

/***/ 51223:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__(5112);
var create = __webpack_require__(70030);
var definePropertyModule = __webpack_require__(3070);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ 31530:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var charAt = __webpack_require__(28710).charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ 25787:
/***/ ((module) => {

module.exports = function (it, Constructor, name) {
  if (it instanceof Constructor) return it;
  throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
};


/***/ }),

/***/ 19670:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(70111);

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};


/***/ }),

/***/ 24019:
/***/ ((module) => {

// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined';


/***/ }),

/***/ 90260:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NATIVE_ARRAY_BUFFER = __webpack_require__(24019);
var DESCRIPTORS = __webpack_require__(19781);
var global = __webpack_require__(17854);
var isCallable = __webpack_require__(60614);
var isObject = __webpack_require__(70111);
var has = __webpack_require__(86656);
var classof = __webpack_require__(70648);
var tryToString = __webpack_require__(66330);
var createNonEnumerableProperty = __webpack_require__(68880);
var redefine = __webpack_require__(31320);
var defineProperty = __webpack_require__(3070).f;
var getPrototypeOf = __webpack_require__(79518);
var setPrototypeOf = __webpack_require__(27674);
var wellKnownSymbol = __webpack_require__(5112);
var uid = __webpack_require__(69711);

var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = global.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var isPrototypeOf = ObjectPrototype.isPrototypeOf;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = uid('TYPED_ARRAY_CONSTRUCTOR');
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || has(TypedArrayConstructorsList, klass)
    || has(BigIntArrayConstructorsList, klass);
};

var isTypedArray = function (it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return has(TypedArrayConstructorsList, klass)
    || has(BigIntArrayConstructorsList, klass);
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw TypeError('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (isCallable(C) && (!setPrototypeOf || isPrototypeOf.call(TypedArray, C))) return C;
  throw TypeError(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod = function (KEY, property, forced) {
  if (!DESCRIPTORS) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && has(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) { /* empty */ }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    redefine(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS) return;
  if (setPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global[ARRAY];
      if (TypedArrayConstructor && has(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return redefine(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      redefine(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) createNonEnumerableProperty(Prototype, TYPED_ARRAY_CONSTRUCTOR, Constructor);
  else NATIVE_ARRAY_BUFFER_VIEWS = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) createNonEnumerableProperty(Prototype, TYPED_ARRAY_CONSTRUCTOR, Constructor);
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw TypeError('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (DESCRIPTORS && !has(TypedArrayPrototype, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQIRED = true;
  defineProperty(TypedArrayPrototype, TO_STRING_TAG, { get: function () {
    return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
  } });
  for (NAME in TypedArrayConstructorsList) if (global[NAME]) {
    createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
  }
}

module.exports = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_CONSTRUCTOR: TYPED_ARRAY_CONSTRUCTOR,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportTypedArrayMethod: exportTypedArrayMethod,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};


/***/ }),

/***/ 13331:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(17854);
var DESCRIPTORS = __webpack_require__(19781);
var NATIVE_ARRAY_BUFFER = __webpack_require__(24019);
var FunctionName = __webpack_require__(76530);
var createNonEnumerableProperty = __webpack_require__(68880);
var redefineAll = __webpack_require__(12248);
var fails = __webpack_require__(47293);
var anInstance = __webpack_require__(25787);
var toInteger = __webpack_require__(99958);
var toLength = __webpack_require__(17466);
var toIndex = __webpack_require__(57067);
var IEEE754 = __webpack_require__(11179);
var getPrototypeOf = __webpack_require__(79518);
var setPrototypeOf = __webpack_require__(27674);
var getOwnPropertyNames = __webpack_require__(8006).f;
var defineProperty = __webpack_require__(3070).f;
var arrayFill = __webpack_require__(21285);
var setToStringTag = __webpack_require__(58003);
var InternalStateModule = __webpack_require__(29909);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var NativeArrayBuffer = global[ARRAY_BUFFER];
var $ArrayBuffer = NativeArrayBuffer;
var $DataView = global[DATA_VIEW];
var $DataViewPrototype = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype = Object.prototype;
var RangeError = global.RangeError;

var packIEEE754 = IEEE754.pack;
var unpackIEEE754 = IEEE754.unpack;

var packInt8 = function (number) {
  return [number & 0xFF];
};

var packInt16 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var unpackInt32 = function (buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packFloat32 = function (number) {
  return packIEEE754(number, 23, 4);
};

var packFloat64 = function (number) {
  return packIEEE754(number, 52, 8);
};

var addGetter = function (Constructor, key) {
  defineProperty(Constructor[PROTOTYPE], key, { get: function () { return getInternalState(this)[key]; } });
};

var get = function (view, count, index, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalState(view);
  if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
  var bytes = getInternalState(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack = bytes.slice(start, start + count);
  return isLittleEndian ? pack : pack.reverse();
};

var set = function (view, count, index, conversion, value, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalState(view);
  if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
  var bytes = getInternalState(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack = conversion(+value);
  for (var i = 0; i < count; i++) bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
};

if (!NATIVE_ARRAY_BUFFER) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    setInternalState(this, {
      bytes: arrayFill.call(new Array(byteLength), 0),
      byteLength: byteLength
    });
    if (!DESCRIPTORS) this.byteLength = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = getInternalState(buffer).byteLength;
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    setInternalState(this, {
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset
    });
    if (!DESCRIPTORS) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, 'byteLength');
    addGetter($DataView, 'buffer');
    addGetter($DataView, 'byteLength');
    addGetter($DataView, 'byteOffset');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
    }
  });
} else {
  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
  /* eslint-disable no-new -- required for testing */
  if (!fails(function () {
    NativeArrayBuffer(1);
  }) || !fails(function () {
    new NativeArrayBuffer(-1);
  }) || fails(function () {
    new NativeArrayBuffer();
    new NativeArrayBuffer(1.5);
    new NativeArrayBuffer(NaN);
    return INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
  })) {
  /* eslint-enable no-new -- required for testing */
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new NativeArrayBuffer(toIndex(length));
    };
    var ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE] = NativeArrayBuffer[PROTOTYPE];
    for (var keys = getOwnPropertyNames(NativeArrayBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) {
        createNonEnumerableProperty($ArrayBuffer, key, NativeArrayBuffer[key]);
      }
    }
    ArrayBufferPrototype.constructor = $ArrayBuffer;
  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
    createNonEnumerableProperty(NativeArrayBuffer, 'name', ARRAY_BUFFER);
  }

  // WebKit bug - the same parent prototype for typed arrays and data view
  if (setPrototypeOf && getPrototypeOf($DataViewPrototype) !== ObjectPrototype) {
    setPrototypeOf($DataViewPrototype, ObjectPrototype);
  }

  // iOS Safari 7.x bug
  var testView = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataViewPrototype.setInt8;
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) redefineAll($DataViewPrototype, {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, { unsafe: true });
}

setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);

module.exports = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};


/***/ }),

/***/ 1048:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toObject = __webpack_require__(47908);
var toAbsoluteIndex = __webpack_require__(51400);
var toLength = __webpack_require__(17466);

var min = Math.min;

// `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
// eslint-disable-next-line es/no-array-prototype-copywithin -- safe
module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),

/***/ 21285:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toObject = __webpack_require__(47908);
var toAbsoluteIndex = __webpack_require__(51400);
var toLength = __webpack_require__(17466);

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ 18533:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $forEach = __webpack_require__(42092).forEach;
var arrayMethodIsStrict = __webpack_require__(9341);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ 97745:
/***/ ((module) => {

module.exports = function (Constructor, list) {
  var index = 0;
  var length = list.length;
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};


/***/ }),

/***/ 48457:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var bind = __webpack_require__(49974);
var toObject = __webpack_require__(47908);
var callWithSafeIterationClosing = __webpack_require__(53411);
var isArrayIteratorMethod = __webpack_require__(97659);
var isConstructor = __webpack_require__(4411);
var toLength = __webpack_require__(17466);
var createProperty = __webpack_require__(86135);
var getIterator = __webpack_require__(18554);
var getIteratorMethod = __webpack_require__(71246);

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = IS_CONSTRUCTOR ? new this(length) : Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ 41318:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toIndexedObject = __webpack_require__(45656);
var toLength = __webpack_require__(17466);
var toAbsoluteIndex = __webpack_require__(51400);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 42092:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var bind = __webpack_require__(49974);
var IndexedObject = __webpack_require__(68361);
var toObject = __webpack_require__(47908);
var toLength = __webpack_require__(17466);
var arraySpeciesCreate = __webpack_require__(65417);

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ 86583:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var toIndexedObject = __webpack_require__(45656);
var toInteger = __webpack_require__(99958);
var toLength = __webpack_require__(17466);
var arrayMethodIsStrict = __webpack_require__(9341);

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return $lastIndexOf.apply(this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = toLength(O.length);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toInteger(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;


/***/ }),

/***/ 81194:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var wellKnownSymbol = __webpack_require__(5112);
var V8_VERSION = __webpack_require__(7392);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ 9341:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(47293);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ 53671:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aCallable = __webpack_require__(19662);
var toObject = __webpack_require__(47908);
var IndexedObject = __webpack_require__(68361);
var toLength = __webpack_require__(17466);

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),

/***/ 94362:
/***/ ((module) => {

// TODO: use something more complex like timsort?
var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    mergeSort(array.slice(0, middle), comparefn),
    mergeSort(array.slice(middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;
  var result = [];

  while (lindex < llength || rindex < rlength) {
    if (lindex < llength && rindex < rlength) {
      result.push(comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]);
    } else {
      result.push(lindex < llength ? left[lindex++] : right[rindex++]);
    }
  } return result;
};

module.exports = mergeSort;


/***/ }),

/***/ 77475:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArray = __webpack_require__(43157);
var isConstructor = __webpack_require__(4411);
var isObject = __webpack_require__(70111);
var wellKnownSymbol = __webpack_require__(5112);

var SPECIES = wellKnownSymbol('species');

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ 65417:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arraySpeciesConstructor = __webpack_require__(77475);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ 53411:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var anObject = __webpack_require__(19670);
var iteratorClose = __webpack_require__(99212);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};


/***/ }),

/***/ 17072:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ 84326:
/***/ ((module) => {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ 70648:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var TO_STRING_TAG_SUPPORT = __webpack_require__(51694);
var isCallable = __webpack_require__(60614);
var classofRaw = __webpack_require__(84326);
var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 95631:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineProperty = __webpack_require__(3070).f;
var create = __webpack_require__(70030);
var redefineAll = __webpack_require__(12248);
var bind = __webpack_require__(49974);
var anInstance = __webpack_require__(25787);
var iterate = __webpack_require__(20408);
var defineIterator = __webpack_require__(70654);
var setSpecies = __webpack_require__(96340);
var DESCRIPTORS = __webpack_require__(19781);
var fastKey = __webpack_require__(62423).fastKey;
var InternalStateModule = __webpack_require__(29909);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll(C.prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineProperty(C.prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return C;
  },
  setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),

/***/ 77710:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);
var isForced = __webpack_require__(54705);
var redefine = __webpack_require__(31320);
var InternalMetadataModule = __webpack_require__(62423);
var iterate = __webpack_require__(20408);
var anInstance = __webpack_require__(25787);
var isCallable = __webpack_require__(60614);
var isObject = __webpack_require__(70111);
var fails = __webpack_require__(47293);
var checkCorrectnessOfIteration = __webpack_require__(17072);
var setToStringTag = __webpack_require__(58003);
var inheritIfRequired = __webpack_require__(79587);

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var nativeMethod = NativePrototype[KEY];
    redefine(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        nativeMethod.call(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        nativeMethod.call(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, Constructor, CONSTRUCTOR_NAME);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ 99920:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var has = __webpack_require__(86656);
var ownKeys = __webpack_require__(53887);
var getOwnPropertyDescriptorModule = __webpack_require__(31236);
var definePropertyModule = __webpack_require__(3070);

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ 84964:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__(5112);

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ 49920:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ 14230:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var requireObjectCoercible = __webpack_require__(84488);
var toString = __webpack_require__(41340);

var quot = /"/g;

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = toString(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + toString(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ 24994:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var IteratorPrototype = __webpack_require__(13383).IteratorPrototype;
var create = __webpack_require__(70030);
var createPropertyDescriptor = __webpack_require__(79114);
var setToStringTag = __webpack_require__(58003);
var Iterators = __webpack_require__(97497);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ 68880:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var definePropertyModule = __webpack_require__(3070);
var createPropertyDescriptor = __webpack_require__(79114);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 79114:
/***/ ((module) => {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 86135:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toPropertyKey = __webpack_require__(34948);
var definePropertyModule = __webpack_require__(3070);
var createPropertyDescriptor = __webpack_require__(79114);

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ 70654:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var IS_PURE = __webpack_require__(31913);
var FunctionName = __webpack_require__(76530);
var isCallable = __webpack_require__(60614);
var createIteratorConstructor = __webpack_require__(24994);
var getPrototypeOf = __webpack_require__(79518);
var setPrototypeOf = __webpack_require__(27674);
var setToStringTag = __webpack_require__(58003);
var createNonEnumerableProperty = __webpack_require__(68880);
var redefine = __webpack_require__(31320);
var wellKnownSymbol = __webpack_require__(5112);
var Iterators = __webpack_require__(97497);
var IteratorsCore = __webpack_require__(13383);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return nativeIterator.call(this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    redefine(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ 97235:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var path = __webpack_require__(40857);
var has = __webpack_require__(86656);
var wrappedWellKnownSymbolModule = __webpack_require__(6061);
var defineProperty = __webpack_require__(3070).f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ 19781:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ 80317:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var isObject = __webpack_require__(70111);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 48324:
/***/ ((module) => {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ 98509:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__(80317);

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ 68886:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var userAgent = __webpack_require__(88113);

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];


/***/ }),

/***/ 30256:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var UA = __webpack_require__(88113);

module.exports = /MSIE|Trident/.test(UA);


/***/ }),

/***/ 88113:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getBuiltIn = __webpack_require__(35005);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ 7392:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var userAgent = __webpack_require__(88113);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ 98008:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var userAgent = __webpack_require__(88113);

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];


/***/ }),

/***/ 80748:
/***/ ((module) => {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 82109:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var getOwnPropertyDescriptor = __webpack_require__(31236).f;
var createNonEnumerableProperty = __webpack_require__(68880);
var redefine = __webpack_require__(31320);
var setGlobal = __webpack_require__(83505);
var copyConstructorProperties = __webpack_require__(99920);
var isForced = __webpack_require__(54705);

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 47293:
/***/ ((module) => {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 27007:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(74916);
var redefine = __webpack_require__(31320);
var regexpExec = __webpack_require__(22261);
var fails = __webpack_require__(47293);
var wellKnownSymbol = __webpack_require__(5112);
var createNonEnumerableProperty = __webpack_require__(68880);

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });

    redefine(String.prototype, KEY, methods[0]);
    redefine(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ 76677:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ 49974:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aCallable = __webpack_require__(19662);

// optional / simple context binding
module.exports = function (fn, that, length) {
  aCallable(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 27065:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var aCallable = __webpack_require__(19662);
var isObject = __webpack_require__(70111);

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func -- we have no proper alternatives, IE8- only
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aCallable(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};


/***/ }),

/***/ 76530:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var has = __webpack_require__(86656);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = has(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 35005:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var isCallable = __webpack_require__(60614);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 71246:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var classof = __webpack_require__(70648);
var getMethod = __webpack_require__(58173);
var Iterators = __webpack_require__(97497);
var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ 18554:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aCallable = __webpack_require__(19662);
var anObject = __webpack_require__(19670);
var getIteratorMethod = __webpack_require__(71246);

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(iteratorMethod.call(argument));
  throw TypeError(String(argument) + ' is not iterable');
};


/***/ }),

/***/ 58173:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aCallable = __webpack_require__(19662);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};


/***/ }),

/***/ 10647:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toObject = __webpack_require__(47908);

var floor = Math.floor;
var replace = ''.replace;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace.call(replacement, symbols, function (match, ch) {
    var capture;
    switch (ch.charAt(0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return str.slice(0, position);
      case "'": return str.slice(tailPos);
      case '<':
        capture = namedCaptures[ch.slice(1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ 17854:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();


/***/ }),

/***/ 86656:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toObject = __webpack_require__(47908);

var hasOwnProperty = {}.hasOwnProperty;

module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};


/***/ }),

/***/ 3501:
/***/ ((module) => {

module.exports = {};


/***/ }),

/***/ 60490:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getBuiltIn = __webpack_require__(35005);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ 64664:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var fails = __webpack_require__(47293);
var createElement = __webpack_require__(80317);

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ 11179:
/***/ ((module) => {

// IEEE754 conversions based on https://github.com/feross/ieee754
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;

var pack = function (number, mantissaLength, bytes) {
  var buffer = new Array(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs(number);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (number != number || number === Infinity) {
    // eslint-disable-next-line no-self-compare -- NaN check
    mantissa = number != number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor(log(number) / LN2);
    if (number * (c = pow(2, -exponent)) < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow(2, mantissaLength);
      exponent = exponent + eBias;
    } else {
      mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
      exponent = 0;
    }
  }
  for (; mantissaLength >= 8; buffer[index++] = mantissa & 255, mantissa /= 256, mantissaLength -= 8);
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  for (; exponentLength > 0; buffer[index++] = exponent & 255, exponent /= 256, exponentLength -= 8);
  buffer[--index] |= sign * 128;
  return buffer;
};

var unpack = function (buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;
  for (; nBits > 0; exponent = exponent * 256 + buffer[index], index--, nBits -= 8);
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  for (; nBits > 0; mantissa = mantissa * 256 + buffer[index], index--, nBits -= 8);
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity : Infinity;
  } else {
    mantissa = mantissa + pow(2, mantissaLength);
    exponent = exponent - eBias;
  } return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
};

module.exports = {
  pack: pack,
  unpack: unpack
};


/***/ }),

/***/ 68361:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var classof = __webpack_require__(84326);

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ 79587:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);
var isObject = __webpack_require__(70111);
var setPrototypeOf = __webpack_require__(27674);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ 42788:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);
var store = __webpack_require__(5465);

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 62423:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var hiddenKeys = __webpack_require__(3501);
var isObject = __webpack_require__(70111);
var has = __webpack_require__(86656);
var defineProperty = __webpack_require__(3070).f;
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertyNamesExternalModule = __webpack_require__(1156);
var uid = __webpack_require__(69711);
var FREEZING = __webpack_require__(76677);

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = [].splice;
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice.call(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ 29909:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var NATIVE_WEAK_MAP = __webpack_require__(68536);
var global = __webpack_require__(17854);
var isObject = __webpack_require__(70111);
var createNonEnumerableProperty = __webpack_require__(68880);
var objectHas = __webpack_require__(86656);
var shared = __webpack_require__(5465);
var sharedKey = __webpack_require__(6200);
var hiddenKeys = __webpack_require__(3501);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 97659:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__(5112);
var Iterators = __webpack_require__(97497);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ 43157:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var classof = __webpack_require__(84326);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ 60614:
/***/ ((module) => {

// `isCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument === 'function';
};


/***/ }),

/***/ 4411:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var isCallable = __webpack_require__(60614);
var classof = __webpack_require__(70648);
var getBuiltIn = __webpack_require__(35005);
var inspectSource = __webpack_require__(42788);

var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = constructorRegExp.exec;
var INCORRECT_TO_STRING = !constructorRegExp.exec(function () { /* empty */ });

var isConstructorModern = function (argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(Object, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function (argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
    // we can't check .prototype since constructors produced by .bind haven't it
  } return INCORRECT_TO_STRING || !!exec.call(constructorRegExp, inspectSource(argument));
};

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ 54705:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var isCallable = __webpack_require__(60614);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 18730:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(70111);

var floor = Math.floor;

// `Number.isInteger` method implementation
// https://tc39.es/ecma262/#sec-number.isinteger
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ 70111:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 31913:
/***/ ((module) => {

module.exports = false;


/***/ }),

/***/ 47850:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(70111);
var classof = __webpack_require__(84326);
var wellKnownSymbol = __webpack_require__(5112);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ 52190:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);
var getBuiltIn = __webpack_require__(35005);
var USE_SYMBOL_AS_UID = __webpack_require__(43307);

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && Object(it) instanceof $Symbol;
};


/***/ }),

/***/ 20408:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var anObject = __webpack_require__(19670);
var isArrayIteratorMethod = __webpack_require__(97659);
var toLength = __webpack_require__(17466);
var bind = __webpack_require__(49974);
var getIterator = __webpack_require__(18554);
var getIteratorMethod = __webpack_require__(71246);
var iteratorClose = __webpack_require__(99212);

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw TypeError(String(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};


/***/ }),

/***/ 99212:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var anObject = __webpack_require__(19670);
var getMethod = __webpack_require__(58173);

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = innerResult.call(iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ 13383:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(47293);
var isCallable = __webpack_require__(60614);
var create = __webpack_require__(70030);
var getPrototypeOf = __webpack_require__(79518);
var redefine = __webpack_require__(31320);
var wellKnownSymbol = __webpack_require__(5112);
var IS_PURE = __webpack_require__(31913);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  redefine(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ 97497:
/***/ ((module) => {

module.exports = {};


/***/ }),

/***/ 30133:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(7392);
var fails = __webpack_require__(47293);

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 590:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var wellKnownSymbol = __webpack_require__(5112);
var IS_PURE = __webpack_require__(31913);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});


/***/ }),

/***/ 68536:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var isCallable = __webpack_require__(60614);
var inspectSource = __webpack_require__(42788);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ 3929:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isRegExp = __webpack_require__(47850);

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ 21574:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(19781);
var fails = __webpack_require__(47293);
var objectKeys = __webpack_require__(81956);
var getOwnPropertySymbolsModule = __webpack_require__(25181);
var propertyIsEnumerableModule = __webpack_require__(55296);
var toObject = __webpack_require__(47908);
var IndexedObject = __webpack_require__(68361);

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 70030:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(19670);
var defineProperties = __webpack_require__(36048);
var enumBugKeys = __webpack_require__(80748);
var hiddenKeys = __webpack_require__(3501);
var html = __webpack_require__(60490);
var documentCreateElement = __webpack_require__(80317);
var sharedKey = __webpack_require__(6200);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ 36048:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var definePropertyModule = __webpack_require__(3070);
var anObject = __webpack_require__(19670);
var objectKeys = __webpack_require__(81956);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ 3070:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var IE8_DOM_DEFINE = __webpack_require__(64664);
var anObject = __webpack_require__(19670);
var toPropertyKey = __webpack_require__(34948);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 31236:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var propertyIsEnumerableModule = __webpack_require__(55296);
var createPropertyDescriptor = __webpack_require__(79114);
var toIndexedObject = __webpack_require__(45656);
var toPropertyKey = __webpack_require__(34948);
var has = __webpack_require__(86656);
var IE8_DOM_DEFINE = __webpack_require__(64664);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ 1156:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var toIndexedObject = __webpack_require__(45656);
var $getOwnPropertyNames = __webpack_require__(8006).f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ 8006:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var internalObjectKeys = __webpack_require__(16324);
var enumBugKeys = __webpack_require__(80748);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 25181:
/***/ ((__unused_webpack_module, exports) => {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 79518:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var has = __webpack_require__(86656);
var isCallable = __webpack_require__(60614);
var toObject = __webpack_require__(47908);
var sharedKey = __webpack_require__(6200);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(49920);

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (has(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ 16324:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var has = __webpack_require__(86656);
var toIndexedObject = __webpack_require__(45656);
var indexOf = __webpack_require__(41318).indexOf;
var hiddenKeys = __webpack_require__(3501);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ 81956:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var internalObjectKeys = __webpack_require__(16324);
var enumBugKeys = __webpack_require__(80748);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ 55296:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 27674:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable no-proto -- safe */
var anObject = __webpack_require__(19670);
var aPossiblePrototype = __webpack_require__(96077);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ 90288:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(51694);
var classof = __webpack_require__(70648);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ 92140:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);
var isObject = __webpack_require__(70111);

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = fn.call(input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = fn.call(input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 53887:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getBuiltIn = __webpack_require__(35005);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertySymbolsModule = __webpack_require__(25181);
var anObject = __webpack_require__(19670);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 40857:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);

module.exports = global;


/***/ }),

/***/ 12248:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var redefine = __webpack_require__(31320);

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ 31320:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var isCallable = __webpack_require__(60614);
var has = __webpack_require__(86656);
var createNonEnumerableProperty = __webpack_require__(68880);
var setGlobal = __webpack_require__(83505);
var inspectSource = __webpack_require__(42788);
var InternalStateModule = __webpack_require__(29909);
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(76530).CONFIGURABLE;

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!has(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
      createNonEnumerableProperty(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ 97651:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var anObject = __webpack_require__(19670);
var isCallable = __webpack_require__(60614);
var classof = __webpack_require__(84326);
var regexpExec = __webpack_require__(22261);

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = exec.call(R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return regexpExec.call(R, S);
  throw TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),

/***/ 22261:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var toString = __webpack_require__(41340);
var regexpFlags = __webpack_require__(67066);
var stickyHelpers = __webpack_require__(52999);
var shared = __webpack_require__(72309);
var create = __webpack_require__(70030);
var getInternalState = __webpack_require__(29909).get;
var UNSUPPORTED_DOT_ALL = __webpack_require__(9441);
var UNSUPPORTED_NCG = __webpack_require__(38173);

var nativeExec = RegExp.prototype.exec;
var nativeReplace = shared('native-string-replace', String.prototype.replace);

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  // eslint-disable-next-line max-statements -- TODO
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = patchedExec.call(raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = str.slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str.charAt(re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ 67066:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var anObject = __webpack_require__(19670);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ 52999:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var global = __webpack_require__(17854);

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

exports.UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),

/***/ 9441:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var global = __webpack_require__(17854);

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),

/***/ 38173:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var global = __webpack_require__(17854);

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ 84488:
/***/ ((module) => {

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 81150:
/***/ ((module) => {

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),

/***/ 83505:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);

module.exports = function (key, value) {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 96340:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var getBuiltIn = __webpack_require__(35005);
var definePropertyModule = __webpack_require__(3070);
var wellKnownSymbol = __webpack_require__(5112);
var DESCRIPTORS = __webpack_require__(19781);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ 58003:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var defineProperty = __webpack_require__(3070).f;
var has = __webpack_require__(86656);
var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ 6200:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var shared = __webpack_require__(72309);
var uid = __webpack_require__(69711);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 5465:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var setGlobal = __webpack_require__(83505);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ 72309:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var IS_PURE = __webpack_require__(31913);
var store = __webpack_require__(5465);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.18.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ 36707:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var anObject = __webpack_require__(19670);
var aConstructor = __webpack_require__(39483);
var wellKnownSymbol = __webpack_require__(5112);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ 43429:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ 28710:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toInteger = __webpack_require__(99958);
var toString = __webpack_require__(41340);
var requireObjectCoercible = __webpack_require__(84488);

// `String.prototype.codePointAt` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ 33197:
/***/ ((module) => {

"use strict";

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;
var floor = Math.floor;
var stringFromCharCode = String.fromCharCode;

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = string.charCodeAt(counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = string.charCodeAt(counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  for (; delta > baseMinusTMin * tMax >> 1; k += base) {
    delta = floor(delta / baseMinusTMin);
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
// eslint-disable-next-line max-statements -- TODO
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      output.push(stringFromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    output.push(delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      throw RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw RangeError(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        for (var k = base; /* no condition */; k += base) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor(qMinusT / baseMinusT);
        }

        output.push(stringFromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        ++handledCPCount;
      }
    }

    ++delta;
    ++n;
  }
  return output.join('');
};

module.exports = function (input) {
  var encoded = [];
  var labels = input.toLowerCase().replace(regexSeparators, '\u002E').split('.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    encoded.push(regexNonASCII.test(label) ? 'xn--' + encode(label) : label);
  }
  return encoded.join('.');
};


/***/ }),

/***/ 76091:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var PROPER_FUNCTION_NAME = __webpack_require__(76530).PROPER;
var fails = __webpack_require__(47293);
var whitespaces = __webpack_require__(81361);

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};


/***/ }),

/***/ 53111:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var requireObjectCoercible = __webpack_require__(84488);
var toString = __webpack_require__(41340);
var whitespaces = __webpack_require__(81361);

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ 51400:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toInteger = __webpack_require__(99958);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 57067:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toInteger = __webpack_require__(99958);
var toLength = __webpack_require__(17466);

// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length or index');
  return length;
};


/***/ }),

/***/ 45656:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(68361);
var requireObjectCoercible = __webpack_require__(84488);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 99958:
/***/ ((module) => {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ 17466:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toInteger = __webpack_require__(99958);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 47908:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var requireObjectCoercible = __webpack_require__(84488);

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 84590:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toPositiveInteger = __webpack_require__(73002);

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw RangeError('Wrong offset');
  return offset;
};


/***/ }),

/***/ 73002:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toInteger = __webpack_require__(99958);

module.exports = function (it) {
  var result = toInteger(it);
  if (result < 0) throw RangeError("The argument can't be less than 0");
  return result;
};


/***/ }),

/***/ 57593:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(70111);
var isSymbol = __webpack_require__(52190);
var getMethod = __webpack_require__(58173);
var ordinaryToPrimitive = __webpack_require__(92140);
var wellKnownSymbol = __webpack_require__(5112);

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = exoticToPrim.call(input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 34948:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toPrimitive = __webpack_require__(57593);
var isSymbol = __webpack_require__(52190);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : String(key);
};


/***/ }),

/***/ 51694:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 41340:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var classof = __webpack_require__(70648);

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};


/***/ }),

/***/ 66330:
/***/ ((module) => {

module.exports = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 19843:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);
var DESCRIPTORS = __webpack_require__(19781);
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(63832);
var ArrayBufferViewCore = __webpack_require__(90260);
var ArrayBufferModule = __webpack_require__(13331);
var anInstance = __webpack_require__(25787);
var createPropertyDescriptor = __webpack_require__(79114);
var createNonEnumerableProperty = __webpack_require__(68880);
var isInteger = __webpack_require__(18730);
var toLength = __webpack_require__(17466);
var toIndex = __webpack_require__(57067);
var toOffset = __webpack_require__(84590);
var toPropertyKey = __webpack_require__(34948);
var has = __webpack_require__(86656);
var classof = __webpack_require__(70648);
var isObject = __webpack_require__(70111);
var isSymbol = __webpack_require__(52190);
var create = __webpack_require__(70030);
var setPrototypeOf = __webpack_require__(27674);
var getOwnPropertyNames = __webpack_require__(8006).f;
var typedArrayFrom = __webpack_require__(97321);
var forEach = __webpack_require__(42092).forEach;
var setSpecies = __webpack_require__(96340);
var definePropertyModule = __webpack_require__(3070);
var getOwnPropertyDescriptorModule = __webpack_require__(31236);
var InternalStateModule = __webpack_require__(29909);
var inheritIfRequired = __webpack_require__(79587);

var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var round = Math.round;
var RangeError = global.RangeError;
var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var DataView = ArrayBufferModule.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_CONSTRUCTOR = ArrayBufferViewCore.TYPED_ARRAY_CONSTRUCTOR;
var TYPED_ARRAY_TAG = ArrayBufferViewCore.TYPED_ARRAY_TAG;
var TypedArray = ArrayBufferViewCore.TypedArray;
var TypedArrayPrototype = ArrayBufferViewCore.TypedArrayPrototype;
var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var isTypedArray = ArrayBufferViewCore.isTypedArray;
var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var WRONG_LENGTH = 'Wrong length';

var fromList = function (C, list) {
  var index = 0;
  var length = list.length;
  var result = new (aTypedArrayConstructor(C))(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var addGetter = function (it, key) {
  nativeDefineProperty(it, key, { get: function () {
    return getInternalState(this)[key];
  } });
};

var isArrayBuffer = function (it) {
  var klass;
  return it instanceof ArrayBuffer || (klass = classof(it)) == 'ArrayBuffer' || klass == 'SharedArrayBuffer';
};

var isTypedArrayIndex = function (target, key) {
  return isTypedArray(target)
    && !isSymbol(key)
    && key in target
    && isInteger(+key)
    && key >= 0;
};

var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
  key = toPropertyKey(key);
  return isTypedArrayIndex(target, key)
    ? createPropertyDescriptor(2, target[key])
    : nativeGetOwnPropertyDescriptor(target, key);
};

var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
  key = toPropertyKey(key);
  if (isTypedArrayIndex(target, key)
    && isObject(descriptor)
    && has(descriptor, 'value')
    && !has(descriptor, 'get')
    && !has(descriptor, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable
    && (!has(descriptor, 'writable') || descriptor.writable)
    && (!has(descriptor, 'enumerable') || descriptor.enumerable)
  ) {
    target[key] = descriptor.value;
    return target;
  } return nativeDefineProperty(target, key, descriptor);
};

if (DESCRIPTORS) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
    definePropertyModule.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype, 'buffer');
    addGetter(TypedArrayPrototype, 'byteOffset');
    addGetter(TypedArrayPrototype, 'byteLength');
    addGetter(TypedArrayPrototype, 'length');
  }

  $({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });

  module.exports = function (TYPE, wrapper, CLAMPED) {
    var BYTES = TYPE.match(/\d+$/)[0] / 8;
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + TYPE;
    var SETTER = 'set' + TYPE;
    var NativeTypedArrayConstructor = global[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};

    var getter = function (that, index) {
      var data = getInternalState(that);
      return data.view[GETTER](index * BYTES + data.byteOffset, true);
    };

    var setter = function (that, index, value) {
      var data = getInternalState(that);
      if (CLAMPED) value = (value = round(value)) < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
      data.view[SETTER](index * BYTES + data.byteOffset, value, true);
    };

    var addElement = function (that, index) {
      nativeDefineProperty(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };

    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
        anInstance(that, TypedArrayConstructor, CONSTRUCTOR_NAME);
        var index = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer(byteLength);
        } else if (isArrayBuffer(data)) {
          buffer = data;
          byteOffset = toOffset(offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + byteOffset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray(data)) {
          return fromList(TypedArrayConstructor, data);
        } else {
          return typedArrayFrom.call(TypedArrayConstructor, data);
        }
        setInternalState(that, {
          buffer: buffer,
          byteOffset: byteOffset,
          byteLength: byteLength,
          length: length,
          view: new DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create(TypedArrayPrototype);
    } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
        anInstance(dummy, TypedArrayConstructor, CONSTRUCTOR_NAME);
        return inheritIfRequired(function () {
          if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
          if (isArrayBuffer(data)) return $length !== undefined
            ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length)
            : typedArrayOffset !== undefined
              ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES))
              : new NativeTypedArrayConstructor(data);
          if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
          return typedArrayFrom.call(TypedArrayConstructor, data);
        }(), dummy, TypedArrayConstructor);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }

    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
    }

    createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_CONSTRUCTOR, TypedArrayConstructor);

    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }

    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

    $({
      global: true, forced: TypedArrayConstructor != NativeTypedArrayConstructor, sham: !NATIVE_ARRAY_BUFFER_VIEWS
    }, exported);

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }

    setSpecies(CONSTRUCTOR_NAME);
  };
} else module.exports = function () { /* empty */ };


/***/ }),

/***/ 63832:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable no-new -- required for testing */
var global = __webpack_require__(17854);
var fails = __webpack_require__(47293);
var checkCorrectnessOfIteration = __webpack_require__(17072);
var NATIVE_ARRAY_BUFFER_VIEWS = __webpack_require__(90260).NATIVE_ARRAY_BUFFER_VIEWS;

var ArrayBuffer = global.ArrayBuffer;
var Int8Array = global.Int8Array;

module.exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function () {
  Int8Array(1);
}) || !fails(function () {
  new Int8Array(-1);
}) || !checkCorrectnessOfIteration(function (iterable) {
  new Int8Array();
  new Int8Array(null);
  new Int8Array(1.5);
  new Int8Array(iterable);
}, true) || fails(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array(new ArrayBuffer(2), 1, undefined).length !== 1;
});


/***/ }),

/***/ 43074:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayFromConstructorAndList = __webpack_require__(97745);
var typedArraySpeciesConstructor = __webpack_require__(66304);

module.exports = function (instance, list) {
  return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
};


/***/ }),

/***/ 97321:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aConstructor = __webpack_require__(39483);
var toObject = __webpack_require__(47908);
var toLength = __webpack_require__(17466);
var getIterator = __webpack_require__(18554);
var getIteratorMethod = __webpack_require__(71246);
var isArrayIteratorMethod = __webpack_require__(97659);
var bind = __webpack_require__(49974);
var aTypedArrayConstructor = __webpack_require__(90260).aTypedArrayConstructor;

module.exports = function from(source /* , mapfn, thisArg */) {
  var C = aConstructor(this);
  var O = toObject(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var i, length, result, step, iterator, next;
  if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    O = [];
    while (!(step = next.call(iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = bind(mapfn, arguments[2], 2);
  }
  length = toLength(O.length);
  result = new (aTypedArrayConstructor(C))(length);
  for (i = 0; length > i; i++) {
    result[i] = mapping ? mapfn(O[i], i) : O[i];
  }
  return result;
};


/***/ }),

/***/ 66304:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ArrayBufferViewCore = __webpack_require__(90260);
var speciesConstructor = __webpack_require__(36707);

var TYPED_ARRAY_CONSTRUCTOR = ArrayBufferViewCore.TYPED_ARRAY_CONSTRUCTOR;
var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;

// a part of `TypedArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#typedarray-species-create
module.exports = function (originalArray) {
  return aTypedArrayConstructor(speciesConstructor(originalArray, originalArray[TYPED_ARRAY_CONSTRUCTOR]));
};


/***/ }),

/***/ 69711:
/***/ ((module) => {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ 43307:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(30133);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 6061:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__(5112);

exports.f = wellKnownSymbol;


/***/ }),

/***/ 5112:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var shared = __webpack_require__(72309);
var has = __webpack_require__(86656);
var uid = __webpack_require__(69711);
var NATIVE_SYMBOL = __webpack_require__(30133);
var USE_SYMBOL_AS_UID = __webpack_require__(43307);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 81361:
/***/ ((module) => {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ 92222:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var fails = __webpack_require__(47293);
var isArray = __webpack_require__(43157);
var isObject = __webpack_require__(70111);
var toObject = __webpack_require__(47908);
var toLength = __webpack_require__(17466);
var createProperty = __webpack_require__(86135);
var arraySpeciesCreate = __webpack_require__(65417);
var arrayMethodHasSpeciesSupport = __webpack_require__(81194);
var wellKnownSymbol = __webpack_require__(5112);
var V8_VERSION = __webpack_require__(7392);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ 57327:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $filter = __webpack_require__(42092).filter;
var arrayMethodHasSpeciesSupport = __webpack_require__(81194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 34553:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $findIndex = __webpack_require__(42092).findIndex;
var addToUnscopables = __webpack_require__(51223);

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ 69826:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $find = __webpack_require__(42092).find;
var addToUnscopables = __webpack_require__(51223);

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ 91038:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var from = __webpack_require__(48457);
var checkCorrectnessOfIteration = __webpack_require__(17072);

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ 26699:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $includes = __webpack_require__(41318).includes;
var addToUnscopables = __webpack_require__(51223);

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ 66992:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toIndexedObject = __webpack_require__(45656);
var addToUnscopables = __webpack_require__(51223);
var Iterators = __webpack_require__(97497);
var InternalStateModule = __webpack_require__(29909);
var defineIterator = __webpack_require__(70654);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ 69600:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var IndexedObject = __webpack_require__(68361);
var toIndexedObject = __webpack_require__(45656);
var arrayMethodIsStrict = __webpack_require__(9341);

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ 21249:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $map = __webpack_require__(42092).map;
var arrayMethodHasSpeciesSupport = __webpack_require__(81194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 47042:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var isArray = __webpack_require__(43157);
var isConstructor = __webpack_require__(4411);
var isObject = __webpack_require__(70111);
var toAbsoluteIndex = __webpack_require__(51400);
var toLength = __webpack_require__(17466);
var toIndexedObject = __webpack_require__(45656);
var createProperty = __webpack_require__(86135);
var wellKnownSymbol = __webpack_require__(5112);
var arrayMethodHasSpeciesSupport = __webpack_require__(81194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ 2707:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var aCallable = __webpack_require__(19662);
var toObject = __webpack_require__(47908);
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var fails = __webpack_require__(47293);
var internalSort = __webpack_require__(94362);
var arrayMethodIsStrict = __webpack_require__(9341);
var FF = __webpack_require__(68886);
var IE_OR_EDGE = __webpack_require__(30256);
var V8 = __webpack_require__(7392);
var WEBKIT = __webpack_require__(98008);

var test = [];
var nativeSort = test.sort;

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString(x) > toString(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort.call(array) : nativeSort.call(array, comparefn);

    var items = [];
    var arrayLength = toLength(array.length);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) items.push(array[index]);
    }

    items = internalSort(items, getSortCompare(comparefn));
    itemsLength = items.length;
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) delete array[index++];

    return array;
  }
});


/***/ }),

/***/ 40561:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var toAbsoluteIndex = __webpack_require__(51400);
var toInteger = __webpack_require__(99958);
var toLength = __webpack_require__(17466);
var toObject = __webpack_require__(47908);
var arraySpeciesCreate = __webpack_require__(65417);
var createProperty = __webpack_require__(86135);
var arrayMethodHasSpeciesSupport = __webpack_require__(81194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),

/***/ 68309:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var FUNCTION_NAME_EXISTS = __webpack_require__(76530).EXISTS;
var defineProperty = __webpack_require__(3070).f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ 35837:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);

// `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis
$({ global: true }, {
  globalThis: global
});


/***/ }),

/***/ 73706:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var setToStringTag = __webpack_require__(58003);

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 10408:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var setToStringTag = __webpack_require__(58003);

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);


/***/ }),

/***/ 9653:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(19781);
var global = __webpack_require__(17854);
var isForced = __webpack_require__(54705);
var redefine = __webpack_require__(31320);
var has = __webpack_require__(86656);
var classof = __webpack_require__(84326);
var inheritIfRequired = __webpack_require__(79587);
var isSymbol = __webpack_require__(52190);
var toPrimitive = __webpack_require__(57593);
var fails = __webpack_require__(47293);
var create = __webpack_require__(70030);
var getOwnPropertyNames = __webpack_require__(8006).f;
var getOwnPropertyDescriptor = __webpack_require__(31236).f;
var defineProperty = __webpack_require__(3070).f;
var trim = __webpack_require__(53111).trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  if (isSymbol(argument)) throw TypeError('Cannot convert a Symbol value to a number');
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ 33161:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var isInteger = __webpack_require__(18730);

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isInteger
});


/***/ }),

/***/ 44048:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);

// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
$({ target: 'Number', stat: true }, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return number != number;
  }
});


/***/ }),

/***/ 19601:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var assign = __webpack_require__(21574);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ 38880:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var fails = __webpack_require__(47293);
var toIndexedObject = __webpack_require__(45656);
var nativeGetOwnPropertyDescriptor = __webpack_require__(31236).f;
var DESCRIPTORS = __webpack_require__(19781);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ 49337:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var DESCRIPTORS = __webpack_require__(19781);
var ownKeys = __webpack_require__(53887);
var toIndexedObject = __webpack_require__(45656);
var getOwnPropertyDescriptorModule = __webpack_require__(31236);
var createProperty = __webpack_require__(86135);

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ 36210:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var fails = __webpack_require__(47293);
var getOwnPropertyNames = __webpack_require__(1156).f;

// eslint-disable-next-line es/no-object-getownpropertynames -- required for testing
var FAILS_ON_PRIMITIVES = fails(function () { return !Object.getOwnPropertyNames(1); });

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  getOwnPropertyNames: getOwnPropertyNames
});


/***/ }),

/***/ 30489:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var fails = __webpack_require__(47293);
var toObject = __webpack_require__(47908);
var nativeGetPrototypeOf = __webpack_require__(79518);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(49920);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ 47941:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var toObject = __webpack_require__(47908);
var nativeKeys = __webpack_require__(81956);
var fails = __webpack_require__(47293);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ 41539:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var TO_STRING_TAG_SUPPORT = __webpack_require__(51694);
var redefine = __webpack_require__(31320);
var toString = __webpack_require__(90288);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ 36535:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var getBuiltIn = __webpack_require__(35005);
var aCallable = __webpack_require__(19662);
var anObject = __webpack_require__(19670);
var fails = __webpack_require__(47293);

var nativeApply = getBuiltIn('Reflect', 'apply');
var functionApply = Function.apply;

// MS Edge argumentsList argument is optional
var OPTIONAL_ARGUMENTS_LIST = !fails(function () {
  nativeApply(function () { /* empty */ });
});

// `Reflect.apply` method
// https://tc39.es/ecma262/#sec-reflect.apply
$({ target: 'Reflect', stat: true, forced: OPTIONAL_ARGUMENTS_LIST }, {
  apply: function apply(target, thisArgument, argumentsList) {
    aCallable(target);
    anObject(argumentsList);
    return nativeApply
      ? nativeApply(target, thisArgument, argumentsList)
      : functionApply.call(target, thisArgument, argumentsList);
  }
});


/***/ }),

/***/ 12419:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var getBuiltIn = __webpack_require__(35005);
var aConstructor = __webpack_require__(39483);
var anObject = __webpack_require__(19670);
var isObject = __webpack_require__(70111);
var create = __webpack_require__(70030);
var bind = __webpack_require__(27065);
var fails = __webpack_require__(47293);

var nativeConstruct = getBuiltIn('Reflect', 'construct');

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});
var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aConstructor(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ 67556:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var ownKeys = __webpack_require__(53887);

// `Reflect.ownKeys` method
// https://tc39.es/ecma262/#sec-reflect.ownkeys
$({ target: 'Reflect', stat: true }, {
  ownKeys: ownKeys
});


/***/ }),

/***/ 24603:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var global = __webpack_require__(17854);
var isForced = __webpack_require__(54705);
var inheritIfRequired = __webpack_require__(79587);
var createNonEnumerableProperty = __webpack_require__(68880);
var defineProperty = __webpack_require__(3070).f;
var getOwnPropertyNames = __webpack_require__(8006).f;
var isRegExp = __webpack_require__(47850);
var toString = __webpack_require__(41340);
var getFlags = __webpack_require__(67066);
var stickyHelpers = __webpack_require__(52999);
var redefine = __webpack_require__(31320);
var fails = __webpack_require__(47293);
var has = __webpack_require__(86656);
var enforceInternalState = __webpack_require__(29909).enforce;
var setSpecies = __webpack_require__(96340);
var wellKnownSymbol = __webpack_require__(5112);
var UNSUPPORTED_DOT_ALL = __webpack_require__(9441);
var UNSUPPORTED_NCG = __webpack_require__(38173);

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
// TODO: Use only propper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS &&
  (!CORRECT_NEW || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = string.charAt(index);
    if (chr === '\\') {
      result += chr + string.charAt(++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = string.charAt(index);
    if (chr === '\\') {
      chr = chr + string.charAt(++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (IS_NCG.test(string.slice(index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || has(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named.push([groupname, groupid]);
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || pattern instanceof RegExpWrapper) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = 'flags' in rawPattern ? rawPattern.flags : getFlags.call(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString(pattern);
    flags = flags === undefined ? '' : toString(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && flags.indexOf('s') > -1;
      if (dotAll) flags = flags.replace(/s/g, '');
    }

    rawFlags = flags;

    if (UNSUPPORTED_Y && 'sticky' in re1) {
      sticky = !!flags && flags.indexOf('y') > -1;
      if (sticky) flags = flags.replace(/y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxy(keys[index++]);
  }

  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global, 'RegExp', RegExpWrapper);
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),

/***/ 74916:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var exec = __webpack_require__(22261);

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ 39714:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var PROPER_FUNCTION_NAME = __webpack_require__(76530).PROPER;
var redefine = __webpack_require__(31320);
var anObject = __webpack_require__(19670);
var $toString = __webpack_require__(41340);
var fails = __webpack_require__(47293);
var flags = __webpack_require__(67066);

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = $toString(R.source);
    var rf = R.flags;
    var f = $toString(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ 70189:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var collection = __webpack_require__(77710);
var collectionStrong = __webpack_require__(95631);

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
module.exports = collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ 27852:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var getOwnPropertyDescriptor = __webpack_require__(31236).f;
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var notARegExp = __webpack_require__(3929);
var requireObjectCoercible = __webpack_require__(84488);
var correctIsRegExpLogic = __webpack_require__(84964);
var IS_PURE = __webpack_require__(31913);

// eslint-disable-next-line es/no-string-prototype-endswith -- safe
var $endsWith = ''.endsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = toString(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),

/***/ 32023:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var notARegExp = __webpack_require__(3929);
var requireObjectCoercible = __webpack_require__(84488);
var toString = __webpack_require__(41340);
var correctIsRegExpLogic = __webpack_require__(84964);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~toString(requireObjectCoercible(this))
      .indexOf(toString(notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 78783:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var charAt = __webpack_require__(28710).charAt;
var toString = __webpack_require__(41340);
var InternalStateModule = __webpack_require__(29909);
var defineIterator = __webpack_require__(70654);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ 4723:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(27007);
var anObject = __webpack_require__(19670);
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var requireObjectCoercible = __webpack_require__(84488);
var getMethod = __webpack_require__(58173);
var advanceStringIndex = __webpack_require__(31530);
var regExpExec = __webpack_require__(97651);

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : getMethod(regexp, MATCH);
      return matcher ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ 15306:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(27007);
var fails = __webpack_require__(47293);
var anObject = __webpack_require__(19670);
var isCallable = __webpack_require__(60614);
var toInteger = __webpack_require__(99958);
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var requireObjectCoercible = __webpack_require__(84488);
var advanceStringIndex = __webpack_require__(31530);
var getMethod = __webpack_require__(58173);
var getSubstitution = __webpack_require__(10647);
var regExpExec = __webpack_require__(97651);
var wellKnownSymbol = __webpack_require__(5112);

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue === 'string' &&
        replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1 &&
        replaceValue.indexOf('$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = toString(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),

/***/ 64765:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(27007);
var anObject = __webpack_require__(19670);
var requireObjectCoercible = __webpack_require__(84488);
var sameValue = __webpack_require__(81150);
var toString = __webpack_require__(41340);
var getMethod = __webpack_require__(58173);
var regExpExec = __webpack_require__(97651);

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = regexp == undefined ? undefined : getMethod(regexp, SEARCH);
      return searcher ? searcher.call(regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),

/***/ 23123:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(27007);
var isRegExp = __webpack_require__(47850);
var anObject = __webpack_require__(19670);
var requireObjectCoercible = __webpack_require__(84488);
var speciesConstructor = __webpack_require__(36707);
var advanceStringIndex = __webpack_require__(31530);
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var getMethod = __webpack_require__(58173);
var callRegExpExec = __webpack_require__(97651);
var regexpExec = __webpack_require__(22261);
var stickyHelpers = __webpack_require__(52999);
var fails = __webpack_require__(47293);

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var arrayPush = [].push;
var min = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? splitter.call(separator, O, limit)
        : internalSplit.call(toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? S.slice(q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ }),

/***/ 23157:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var getOwnPropertyDescriptor = __webpack_require__(31236).f;
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var notARegExp = __webpack_require__(3929);
var requireObjectCoercible = __webpack_require__(84488);
var correctIsRegExpLogic = __webpack_require__(84964);
var IS_PURE = __webpack_require__(31913);

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var $startsWith = ''.startsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ 60086:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var createHTML = __webpack_require__(14230);
var forcedStringHTMLMethod = __webpack_require__(43429);

// `String.prototype.sub` method
// https://tc39.es/ecma262/#sec-string.prototype.sub
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('sub') }, {
  sub: function sub() {
    return createHTML(this, 'sub', '', '');
  }
});


/***/ }),

/***/ 73210:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $trim = __webpack_require__(53111).trim;
var forcedStringTrimMethod = __webpack_require__(76091);

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ 72443:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var defineWellKnownSymbol = __webpack_require__(97235);

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');


/***/ }),

/***/ 41817:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__(82109);
var DESCRIPTORS = __webpack_require__(19781);
var global = __webpack_require__(17854);
var has = __webpack_require__(86656);
var isCallable = __webpack_require__(60614);
var isObject = __webpack_require__(70111);
var defineProperty = __webpack_require__(3070).f;
var copyConstructorProperties = __webpack_require__(99920);

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var nativeSymbol = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = nativeSymbol ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ 32165:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var defineWellKnownSymbol = __webpack_require__(97235);

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ 82526:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);
var getBuiltIn = __webpack_require__(35005);
var IS_PURE = __webpack_require__(31913);
var DESCRIPTORS = __webpack_require__(19781);
var NATIVE_SYMBOL = __webpack_require__(30133);
var fails = __webpack_require__(47293);
var has = __webpack_require__(86656);
var isArray = __webpack_require__(43157);
var isCallable = __webpack_require__(60614);
var isObject = __webpack_require__(70111);
var isSymbol = __webpack_require__(52190);
var anObject = __webpack_require__(19670);
var toObject = __webpack_require__(47908);
var toIndexedObject = __webpack_require__(45656);
var toPropertyKey = __webpack_require__(34948);
var $toString = __webpack_require__(41340);
var createPropertyDescriptor = __webpack_require__(79114);
var nativeObjectCreate = __webpack_require__(70030);
var objectKeys = __webpack_require__(81956);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertyNamesExternal = __webpack_require__(1156);
var getOwnPropertySymbolsModule = __webpack_require__(25181);
var getOwnPropertyDescriptorModule = __webpack_require__(31236);
var definePropertyModule = __webpack_require__(3070);
var propertyIsEnumerableModule = __webpack_require__(55296);
var redefine = __webpack_require__(31320);
var shared = __webpack_require__(72309);
var sharedKey = __webpack_require__(6200);
var hiddenKeys = __webpack_require__(3501);
var uid = __webpack_require__(69711);
var wellKnownSymbol = __webpack_require__(5112);
var wrappedWellKnownSymbolModule = __webpack_require__(6061);
var defineWellKnownSymbol = __webpack_require__(97235);
var setToStringTag = __webpack_require__(58003);
var InternalStateModule = __webpack_require__(29909);
var $forEach = __webpack_require__(42092).forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = $toString(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (isCallable($replacer)) value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  var valueOf = $Symbol[PROTOTYPE].valueOf;
  redefine($Symbol[PROTOTYPE], TO_PRIMITIVE, function () {
    return valueOf.apply(this, arguments);
  });
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ 39341:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var defineWellKnownSymbol = __webpack_require__(97235);

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');


/***/ }),

/***/ 92990:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $copyWithin = __webpack_require__(1048);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
exportTypedArrayMethod('copyWithin', function copyWithin(target, start /* , end */) {
  return $copyWithin.call(aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});


/***/ }),

/***/ 18927:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $every = __webpack_require__(42092).every;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.every` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
exportTypedArrayMethod('every', function every(callbackfn /* , thisArg */) {
  return $every(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 33105:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $fill = __webpack_require__(21285);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
// eslint-disable-next-line no-unused-vars -- required for `.length`
exportTypedArrayMethod('fill', function fill(value /* , start, end */) {
  return $fill.apply(aTypedArray(this), arguments);
});


/***/ }),

/***/ 35035:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $filter = __webpack_require__(42092).filter;
var fromSpeciesAndList = __webpack_require__(43074);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.filter` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
exportTypedArrayMethod('filter', function filter(callbackfn /* , thisArg */) {
  var list = $filter(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  return fromSpeciesAndList(this, list);
});


/***/ }),

/***/ 7174:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $findIndex = __webpack_require__(42092).findIndex;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
exportTypedArrayMethod('findIndex', function findIndex(predicate /* , thisArg */) {
  return $findIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 74345:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $find = __webpack_require__(42092).find;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.find` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
exportTypedArrayMethod('find', function find(predicate /* , thisArg */) {
  return $find(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 32846:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $forEach = __webpack_require__(42092).forEach;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.forEach` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
exportTypedArrayMethod('forEach', function forEach(callbackfn /* , thisArg */) {
  $forEach(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 44731:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $includes = __webpack_require__(41318).includes;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.includes` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
exportTypedArrayMethod('includes', function includes(searchElement /* , fromIndex */) {
  return $includes(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 77209:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $indexOf = __webpack_require__(41318).indexOf;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
exportTypedArrayMethod('indexOf', function indexOf(searchElement /* , fromIndex */) {
  return $indexOf(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 96319:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(17854);
var PROPER_FUNCTION_NAME = __webpack_require__(76530).PROPER;
var ArrayBufferViewCore = __webpack_require__(90260);
var ArrayIterators = __webpack_require__(66992);
var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');
var Uint8Array = global.Uint8Array;
var arrayValues = ArrayIterators.values;
var arrayKeys = ArrayIterators.keys;
var arrayEntries = ArrayIterators.entries;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var nativeTypedArrayIterator = Uint8Array && Uint8Array.prototype[ITERATOR];

var PROPER_ARRAY_VALUES_NAME = !!nativeTypedArrayIterator && nativeTypedArrayIterator.name === 'values';

var typedArrayValues = function values() {
  return arrayValues.call(aTypedArray(this));
};

// `%TypedArray%.prototype.entries` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
exportTypedArrayMethod('entries', function entries() {
  return arrayEntries.call(aTypedArray(this));
});
// `%TypedArray%.prototype.keys` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
exportTypedArrayMethod('keys', function keys() {
  return arrayKeys.call(aTypedArray(this));
});
// `%TypedArray%.prototype.values` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
exportTypedArrayMethod('values', typedArrayValues, PROPER_FUNCTION_NAME && !PROPER_ARRAY_VALUES_NAME);
// `%TypedArray%.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
exportTypedArrayMethod(ITERATOR, typedArrayValues, PROPER_FUNCTION_NAME && !PROPER_ARRAY_VALUES_NAME);


/***/ }),

/***/ 58867:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $join = [].join;

// `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
// eslint-disable-next-line no-unused-vars -- required for `.length`
exportTypedArrayMethod('join', function join(separator) {
  return $join.apply(aTypedArray(this), arguments);
});


/***/ }),

/***/ 37789:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $lastIndexOf = __webpack_require__(86583);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
// eslint-disable-next-line no-unused-vars -- required for `.length`
exportTypedArrayMethod('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */) {
  return $lastIndexOf.apply(aTypedArray(this), arguments);
});


/***/ }),

/***/ 33739:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $map = __webpack_require__(42092).map;
var typedArraySpeciesConstructor = __webpack_require__(66304);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.map` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
exportTypedArrayMethod('map', function map(mapfn /* , thisArg */) {
  return $map(aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function (O, length) {
    return new (typedArraySpeciesConstructor(O))(length);
  });
});


/***/ }),

/***/ 14483:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $reduceRight = __webpack_require__(53671).right;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduceRicht` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
exportTypedArrayMethod('reduceRight', function reduceRight(callbackfn /* , initialValue */) {
  return $reduceRight(aTypedArray(this), callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 29368:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $reduce = __webpack_require__(53671).left;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduce` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
exportTypedArrayMethod('reduce', function reduce(callbackfn /* , initialValue */) {
  return $reduce(aTypedArray(this), callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 12056:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var floor = Math.floor;

// `%TypedArray%.prototype.reverse` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
exportTypedArrayMethod('reverse', function reverse() {
  var that = this;
  var length = aTypedArray(that).length;
  var middle = floor(length / 2);
  var index = 0;
  var value;
  while (index < middle) {
    value = that[index];
    that[index++] = that[--length];
    that[length] = value;
  } return that;
});


/***/ }),

/***/ 3462:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var toLength = __webpack_require__(17466);
var toOffset = __webpack_require__(84590);
var toObject = __webpack_require__(47908);
var fails = __webpack_require__(47293);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var FORCED = fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  new Int8Array(1).set({});
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod('set', function set(arrayLike /* , offset */) {
  aTypedArray(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var length = this.length;
  var src = toObject(arrayLike);
  var len = toLength(src.length);
  var index = 0;
  if (len + offset > length) throw RangeError('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, FORCED);


/***/ }),

/***/ 30678:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var typedArraySpeciesConstructor = __webpack_require__(66304);
var fails = __webpack_require__(47293);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $slice = [].slice;

var FORCED = fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  new Int8Array(1).slice();
});

// `%TypedArray%.prototype.slice` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
exportTypedArrayMethod('slice', function slice(start, end) {
  var list = $slice.call(aTypedArray(this), start, end);
  var C = typedArraySpeciesConstructor(this);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
}, FORCED);


/***/ }),

/***/ 27462:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $some = __webpack_require__(42092).some;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.some` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
exportTypedArrayMethod('some', function some(callbackfn /* , thisArg */) {
  return $some(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 33824:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var global = __webpack_require__(17854);
var fails = __webpack_require__(47293);
var aCallable = __webpack_require__(19662);
var toLength = __webpack_require__(17466);
var internalSort = __webpack_require__(94362);
var FF = __webpack_require__(68886);
var IE_OR_EDGE = __webpack_require__(30256);
var V8 = __webpack_require__(7392);
var WEBKIT = __webpack_require__(98008);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var Uint16Array = global.Uint16Array;
var nativeSort = Uint16Array && Uint16Array.prototype.sort;

// WebKit
var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort && !fails(function () {
  var array = new Uint16Array(2);
  array.sort(null);
  array.sort({});
});

var STABLE_SORT = !!nativeSort && !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 74;
  if (FF) return FF < 67;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 602;

  var array = new Uint16Array(516);
  var expected = Array(516);
  var index, mod;

  for (index = 0; index < 516; index++) {
    mod = index % 4;
    array[index] = 515 - index;
    expected[index] = index - 2 * mod + 3;
  }

  array.sort(function (a, b) {
    return (a / 4 | 0) - (b / 4 | 0);
  });

  for (index = 0; index < 516; index++) {
    if (array[index] !== expected[index]) return true;
  }
});

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (y !== y) return -1;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (x !== x) return 1;
    if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
    return x > y;
  };
};

// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
exportTypedArrayMethod('sort', function sort(comparefn) {
  var array = this;
  if (comparefn !== undefined) aCallable(comparefn);
  if (STABLE_SORT) return nativeSort.call(array, comparefn);

  aTypedArray(array);
  var arrayLength = toLength(array.length);
  var items = Array(arrayLength);
  var index;

  for (index = 0; index < arrayLength; index++) {
    items[index] = array[index];
  }

  items = internalSort(array, getSortCompare(comparefn));

  for (index = 0; index < arrayLength; index++) {
    array[index] = items[index];
  }

  return array;
}, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);


/***/ }),

/***/ 55021:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var toLength = __webpack_require__(17466);
var toAbsoluteIndex = __webpack_require__(51400);
var typedArraySpeciesConstructor = __webpack_require__(66304);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.subarray` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
exportTypedArrayMethod('subarray', function subarray(begin, end) {
  var O = aTypedArray(this);
  var length = O.length;
  var beginIndex = toAbsoluteIndex(begin, length);
  var C = typedArraySpeciesConstructor(O);
  return new C(
    O.buffer,
    O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT,
    toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex)
  );
});


/***/ }),

/***/ 12974:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(17854);
var ArrayBufferViewCore = __webpack_require__(90260);
var fails = __webpack_require__(47293);

var Int8Array = global.Int8Array;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;
var $slice = [].slice;

// iOS Safari 6.x fails here
var TO_LOCALE_STRING_BUG = !!Int8Array && fails(function () {
  $toLocaleString.call(new Int8Array(1));
});

var FORCED = fails(function () {
  return [1, 2].toLocaleString() != new Int8Array([1, 2]).toLocaleString();
}) || !fails(function () {
  Int8Array.prototype.toLocaleString.call([1, 2]);
});

// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
exportTypedArrayMethod('toLocaleString', function toLocaleString() {
  return $toLocaleString.apply(TO_LOCALE_STRING_BUG ? $slice.call(aTypedArray(this)) : aTypedArray(this), arguments);
}, FORCED);


/***/ }),

/***/ 15016:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var exportTypedArrayMethod = __webpack_require__(90260).exportTypedArrayMethod;
var fails = __webpack_require__(47293);
var global = __webpack_require__(17854);

var Uint8Array = global.Uint8Array;
var Uint8ArrayPrototype = Uint8Array && Uint8Array.prototype || {};
var arrayToString = [].toString;
var arrayJoin = [].join;

if (fails(function () { arrayToString.call({}); })) {
  arrayToString = function toString() {
    return arrayJoin.call(this);
  };
}

var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString != arrayToString;

// `%TypedArray%.prototype.toString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
exportTypedArrayMethod('toString', arrayToString, IS_NOT_ARRAY_METHOD);


/***/ }),

/***/ 82472:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var createTypedArrayConstructor = __webpack_require__(19843);

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint8', function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ 65743:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// TODO: Remove from `core-js@4`
__webpack_require__(35837);


/***/ }),

/***/ 54747:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var DOMIterables = __webpack_require__(48324);
var DOMTokenListPrototype = __webpack_require__(98509);
var forEach = __webpack_require__(18533);
var createNonEnumerableProperty = __webpack_require__(68880);

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ 33948:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var DOMIterables = __webpack_require__(48324);
var DOMTokenListPrototype = __webpack_require__(98509);
var ArrayIteratorMethods = __webpack_require__(66992);
var createNonEnumerableProperty = __webpack_require__(68880);
var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ 41637:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(66992);
var $ = __webpack_require__(82109);
var getBuiltIn = __webpack_require__(35005);
var USE_NATIVE_URL = __webpack_require__(590);
var redefine = __webpack_require__(31320);
var redefineAll = __webpack_require__(12248);
var setToStringTag = __webpack_require__(58003);
var createIteratorConstructor = __webpack_require__(24994);
var InternalStateModule = __webpack_require__(29909);
var anInstance = __webpack_require__(25787);
var isCallable = __webpack_require__(60614);
var hasOwn = __webpack_require__(86656);
var bind = __webpack_require__(49974);
var classof = __webpack_require__(70648);
var anObject = __webpack_require__(19670);
var isObject = __webpack_require__(70111);
var $toString = __webpack_require__(41340);
var create = __webpack_require__(70030);
var createPropertyDescriptor = __webpack_require__(79114);
var getIterator = __webpack_require__(18554);
var getIteratorMethod = __webpack_require__(71246);
var wellKnownSymbol = __webpack_require__(5112);

var nativeFetch = getBuiltIn('fetch');
var NativeRequest = getBuiltIn('Request');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var Headers = getBuiltIn('Headers');
var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = it.replace(plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = result.replace(percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replace = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replace[match];
};

var serialize = function (it) {
  return encodeURIComponent(it).replace(find, replacer);
};

var parseSearchParams = function (result, query) {
  if (query) {
    var attributes = query.split('&');
    var index = 0;
    var attribute, entry;
    while (index < attributes.length) {
      attribute = attributes[index++];
      if (attribute.length) {
        entry = attribute.split('=');
        result.push({
          key: deserialize(entry.shift()),
          value: deserialize(entry.join('='))
        });
      }
    }
  }
};

var updateSearchParams = function (query) {
  this.entries.length = 0;
  parseSearchParams(this.entries, query);
};

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw TypeError('Not enough arguments');
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
});

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsConstructor, URL_SEARCH_PARAMS);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var that = this;
  var entries = [];
  var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;

  setInternalState(that, {
    type: URL_SEARCH_PARAMS,
    entries: entries,
    updateURL: function () { /* empty */ },
    updateSearchParams: updateSearchParams
  });

  if (init !== undefined) {
    if (isObject(init)) {
      iteratorMethod = getIteratorMethod(init);
      if (iteratorMethod) {
        iterator = getIterator(init, iteratorMethod);
        next = iterator.next;
        while (!(step = next.call(iterator)).done) {
          entryIterator = getIterator(anObject(step.value));
          entryNext = entryIterator.next;
          if (
            (first = entryNext.call(entryIterator)).done ||
            (second = entryNext.call(entryIterator)).done ||
            !entryNext.call(entryIterator).done
          ) throw TypeError('Expected sequence with length 2');
          entries.push({ key: $toString(first.value), value: $toString(second.value) });
        }
      } else for (key in init) if (hasOwn(init, key)) entries.push({ key: key, value: $toString(init[key]) });
    } else {
      parseSearchParams(
        entries,
        typeof init === 'string' ? init.charAt(0) === '?' ? init.slice(1) : init : $toString(init)
      );
    }
  }
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

redefineAll(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    state.entries.push({ key: $toString(name), value: $toString(value) });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = $toString(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) entries.splice(index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) result.push(entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = $toString(name);
    var val = $toString(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) entries.splice(index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) entries.push({ key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    var entries = state.entries;
    // Array#sort is not stable in some engines
    var slice = entries.slice();
    var entry, entriesIndex, sliceIndex;
    entries.length = 0;
    for (sliceIndex = 0; sliceIndex < slice.length; sliceIndex++) {
      entry = slice[sliceIndex];
      for (entriesIndex = 0; entriesIndex < sliceIndex; entriesIndex++) {
        if (entries[entriesIndex].key > entry.key) {
          entries.splice(entriesIndex, 0, entry);
          break;
        }
      }
      if (entriesIndex === sliceIndex) entries.push(entry);
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined, 3);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
redefine(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
redefine(URLSearchParamsPrototype, 'toString', function toString() {
  var entries = getInternalParamsState(this).entries;
  var result = [];
  var index = 0;
  var entry;
  while (index < entries.length) {
    entry = entries[index++];
    result.push(serialize(entry.key) + '=' + serialize(entry.value));
  } return result.join('&');
}, { enumerable: true });

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headers.has('content-type')) {
          headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, String(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    $({ global: true, enumerable: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestConstructor, 'Request');
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $({ global: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};


/***/ }),

/***/ 60285:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(78783);
var $ = __webpack_require__(82109);
var DESCRIPTORS = __webpack_require__(19781);
var USE_NATIVE_URL = __webpack_require__(590);
var global = __webpack_require__(17854);
var defineProperties = __webpack_require__(36048);
var redefine = __webpack_require__(31320);
var anInstance = __webpack_require__(25787);
var has = __webpack_require__(86656);
var assign = __webpack_require__(21574);
var arrayFrom = __webpack_require__(48457);
var codeAt = __webpack_require__(28710).codeAt;
var toASCII = __webpack_require__(33197);
var $toString = __webpack_require__(41340);
var setToStringTag = __webpack_require__(58003);
var URLSearchParamsModule = __webpack_require__(41637);
var InternalStateModule = __webpack_require__(29909);

var NativeURL = global.URL;
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;
var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var floor = Math.floor;
var pow = Math.pow;

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[A-Za-z]/;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.A-Za-z]/;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\dA-Fa-f]+$/;
/* eslint-disable no-control-regex -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable no-control-regex -- safe */
var EOF;

var parseHost = function (url, input) {
  var result, codePoints, index;
  if (input.charAt(0) == '[') {
    if (input.charAt(input.length - 1) != ']') return INVALID_HOST;
    result = parseIPv6(input.slice(1, -1));
    if (!result) return INVALID_HOST;
    url.host = result;
  // opaque host
  } else if (!isSpecial(url)) {
    if (FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT.test(input)) return INVALID_HOST;
    result = '';
    codePoints = arrayFrom(input);
    for (index = 0; index < codePoints.length; index++) {
      result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
    }
    url.host = result;
  } else {
    input = toASCII(input);
    if (FORBIDDEN_HOST_CODE_POINT.test(input)) return INVALID_HOST;
    result = parseIPv4(input);
    if (result === null) return INVALID_HOST;
    url.host = result;
  }
};

var parseIPv4 = function (input) {
  var parts = input.split('.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.pop();
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && part.charAt(0) == '0') {
      radix = HEX_START.test(part) ? 16 : 8;
      part = part.slice(radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!(radix == 10 ? DEC : radix == 8 ? OCT : HEX).test(part)) return input;
      number = parseInt(part, radix);
    }
    numbers.push(number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = numbers.pop();
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return input.charAt(pointer);
  };

  if (chr() == ':') {
    if (input.charAt(1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex == 8) return;
    if (chr() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && HEX.test(chr())) {
      value = value * 16 + parseInt(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!DIGIT.test(chr())) return;
        while (DIGIT.test(chr())) {
          number = parseInt(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (chr() == ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      result.unshift(host % 256);
      host = floor(host / 256);
    } return result.join('.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += host[index].toString(16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !has(set, chr) ? chr : encodeURIComponent(chr);
};

var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

var isSpecial = function (url) {
  return has(specialSchemes, url.scheme);
};

var includesCredentials = function (url) {
  return url.username != '' || url.password != '';
};

var cannotHaveUsernamePasswordPort = function (url) {
  return !url.host || url.cannotBeABaseURL || url.scheme == 'file';
};

var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && ALPHA.test(string.charAt(0))
    && ((second = string.charAt(1)) == ':' || (!normalized && second == '|'));
};

var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(string.slice(0, 2)) && (
    string.length == 2 ||
    ((third = string.charAt(2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

var shortenURLsPath = function (url) {
  var path = url.path;
  var pathSize = path.length;
  if (pathSize && (url.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
    path.pop();
  }
};

var isSingleDot = function (segment) {
  return segment === '.' || segment.toLowerCase() === '%2e';
};

var isDoubleDot = function (segment) {
  segment = segment.toLowerCase();
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

// eslint-disable-next-line max-statements -- TODO
var parseURL = function (url, input, stateOverride, base) {
  var state = stateOverride || SCHEME_START;
  var pointer = 0;
  var buffer = '';
  var seenAt = false;
  var seenBracket = false;
  var seenPasswordToken = false;
  var codePoints, chr, bufferCodePoints, failure;

  if (!stateOverride) {
    url.scheme = '';
    url.username = '';
    url.password = '';
    url.host = null;
    url.port = null;
    url.path = [];
    url.query = null;
    url.fragment = null;
    url.cannotBeABaseURL = false;
    input = input.replace(LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
  }

  input = input.replace(TAB_AND_NEW_LINE, '');

  codePoints = arrayFrom(input);

  while (pointer <= codePoints.length) {
    chr = codePoints[pointer];
    switch (state) {
      case SCHEME_START:
        if (chr && ALPHA.test(chr)) {
          buffer += chr.toLowerCase();
          state = SCHEME;
        } else if (!stateOverride) {
          state = NO_SCHEME;
          continue;
        } else return INVALID_SCHEME;
        break;

      case SCHEME:
        if (chr && (ALPHANUMERIC.test(chr) || chr == '+' || chr == '-' || chr == '.')) {
          buffer += chr.toLowerCase();
        } else if (chr == ':') {
          if (stateOverride && (
            (isSpecial(url) != has(specialSchemes, buffer)) ||
            (buffer == 'file' && (includesCredentials(url) || url.port !== null)) ||
            (url.scheme == 'file' && !url.host)
          )) return;
          url.scheme = buffer;
          if (stateOverride) {
            if (isSpecial(url) && specialSchemes[url.scheme] == url.port) url.port = null;
            return;
          }
          buffer = '';
          if (url.scheme == 'file') {
            state = FILE;
          } else if (isSpecial(url) && base && base.scheme == url.scheme) {
            state = SPECIAL_RELATIVE_OR_AUTHORITY;
          } else if (isSpecial(url)) {
            state = SPECIAL_AUTHORITY_SLASHES;
          } else if (codePoints[pointer + 1] == '/') {
            state = PATH_OR_AUTHORITY;
            pointer++;
          } else {
            url.cannotBeABaseURL = true;
            url.path.push('');
            state = CANNOT_BE_A_BASE_URL_PATH;
          }
        } else if (!stateOverride) {
          buffer = '';
          state = NO_SCHEME;
          pointer = 0;
          continue;
        } else return INVALID_SCHEME;
        break;

      case NO_SCHEME:
        if (!base || (base.cannotBeABaseURL && chr != '#')) return INVALID_SCHEME;
        if (base.cannotBeABaseURL && chr == '#') {
          url.scheme = base.scheme;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          url.cannotBeABaseURL = true;
          state = FRAGMENT;
          break;
        }
        state = base.scheme == 'file' ? FILE : RELATIVE;
        continue;

      case SPECIAL_RELATIVE_OR_AUTHORITY:
        if (chr == '/' && codePoints[pointer + 1] == '/') {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          pointer++;
        } else {
          state = RELATIVE;
          continue;
        } break;

      case PATH_OR_AUTHORITY:
        if (chr == '/') {
          state = AUTHORITY;
          break;
        } else {
          state = PATH;
          continue;
        }

      case RELATIVE:
        url.scheme = base.scheme;
        if (chr == EOF) {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
        } else if (chr == '/' || (chr == '\\' && isSpecial(url))) {
          state = RELATIVE_SLASH;
        } else if (chr == '?') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = '';
          state = QUERY;
        } else if (chr == '#') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          state = FRAGMENT;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.path.pop();
          state = PATH;
          continue;
        } break;

      case RELATIVE_SLASH:
        if (isSpecial(url) && (chr == '/' || chr == '\\')) {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        } else if (chr == '/') {
          state = AUTHORITY;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          state = PATH;
          continue;
        } break;

      case SPECIAL_AUTHORITY_SLASHES:
        state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        if (chr != '/' || buffer.charAt(pointer + 1) != '/') continue;
        pointer++;
        break;

      case SPECIAL_AUTHORITY_IGNORE_SLASHES:
        if (chr != '/' && chr != '\\') {
          state = AUTHORITY;
          continue;
        } break;

      case AUTHORITY:
        if (chr == '@') {
          if (seenAt) buffer = '%40' + buffer;
          seenAt = true;
          bufferCodePoints = arrayFrom(buffer);
          for (var i = 0; i < bufferCodePoints.length; i++) {
            var codePoint = bufferCodePoints[i];
            if (codePoint == ':' && !seenPasswordToken) {
              seenPasswordToken = true;
              continue;
            }
            var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
            if (seenPasswordToken) url.password += encodedCodePoints;
            else url.username += encodedCodePoints;
          }
          buffer = '';
        } else if (
          chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
          (chr == '\\' && isSpecial(url))
        ) {
          if (seenAt && buffer == '') return INVALID_AUTHORITY;
          pointer -= arrayFrom(buffer).length + 1;
          buffer = '';
          state = HOST;
        } else buffer += chr;
        break;

      case HOST:
      case HOSTNAME:
        if (stateOverride && url.scheme == 'file') {
          state = FILE_HOST;
          continue;
        } else if (chr == ':' && !seenBracket) {
          if (buffer == '') return INVALID_HOST;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PORT;
          if (stateOverride == HOSTNAME) return;
        } else if (
          chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
          (chr == '\\' && isSpecial(url))
        ) {
          if (isSpecial(url) && buffer == '') return INVALID_HOST;
          if (stateOverride && buffer == '' && (includesCredentials(url) || url.port !== null)) return;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PATH_START;
          if (stateOverride) return;
          continue;
        } else {
          if (chr == '[') seenBracket = true;
          else if (chr == ']') seenBracket = false;
          buffer += chr;
        } break;

      case PORT:
        if (DIGIT.test(chr)) {
          buffer += chr;
        } else if (
          chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
          (chr == '\\' && isSpecial(url)) ||
          stateOverride
        ) {
          if (buffer != '') {
            var port = parseInt(buffer, 10);
            if (port > 0xFFFF) return INVALID_PORT;
            url.port = (isSpecial(url) && port === specialSchemes[url.scheme]) ? null : port;
            buffer = '';
          }
          if (stateOverride) return;
          state = PATH_START;
          continue;
        } else return INVALID_PORT;
        break;

      case FILE:
        url.scheme = 'file';
        if (chr == '/' || chr == '\\') state = FILE_SLASH;
        else if (base && base.scheme == 'file') {
          if (chr == EOF) {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
          } else if (chr == '?') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            if (!startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
              url.host = base.host;
              url.path = base.path.slice();
              shortenURLsPath(url);
            }
            state = PATH;
            continue;
          }
        } else {
          state = PATH;
          continue;
        } break;

      case FILE_SLASH:
        if (chr == '/' || chr == '\\') {
          state = FILE_HOST;
          break;
        }
        if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
          if (isWindowsDriveLetter(base.path[0], true)) url.path.push(base.path[0]);
          else url.host = base.host;
        }
        state = PATH;
        continue;

      case FILE_HOST:
        if (chr == EOF || chr == '/' || chr == '\\' || chr == '?' || chr == '#') {
          if (!stateOverride && isWindowsDriveLetter(buffer)) {
            state = PATH;
          } else if (buffer == '') {
            url.host = '';
            if (stateOverride) return;
            state = PATH_START;
          } else {
            failure = parseHost(url, buffer);
            if (failure) return failure;
            if (url.host == 'localhost') url.host = '';
            if (stateOverride) return;
            buffer = '';
            state = PATH_START;
          } continue;
        } else buffer += chr;
        break;

      case PATH_START:
        if (isSpecial(url)) {
          state = PATH;
          if (chr != '/' && chr != '\\') continue;
        } else if (!stateOverride && chr == '?') {
          url.query = '';
          state = QUERY;
        } else if (!stateOverride && chr == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (chr != EOF) {
          state = PATH;
          if (chr != '/') continue;
        } break;

      case PATH:
        if (
          chr == EOF || chr == '/' ||
          (chr == '\\' && isSpecial(url)) ||
          (!stateOverride && (chr == '?' || chr == '#'))
        ) {
          if (isDoubleDot(buffer)) {
            shortenURLsPath(url);
            if (chr != '/' && !(chr == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else if (isSingleDot(buffer)) {
            if (chr != '/' && !(chr == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else {
            if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
              if (url.host) url.host = '';
              buffer = buffer.charAt(0) + ':'; // normalize windows drive letter
            }
            url.path.push(buffer);
          }
          buffer = '';
          if (url.scheme == 'file' && (chr == EOF || chr == '?' || chr == '#')) {
            while (url.path.length > 1 && url.path[0] === '') {
              url.path.shift();
            }
          }
          if (chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          }
        } else {
          buffer += percentEncode(chr, pathPercentEncodeSet);
        } break;

      case CANNOT_BE_A_BASE_URL_PATH:
        if (chr == '?') {
          url.query = '';
          state = QUERY;
        } else if (chr == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (chr != EOF) {
          url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
        } break;

      case QUERY:
        if (!stateOverride && chr == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (chr != EOF) {
          if (chr == "'" && isSpecial(url)) url.query += '%27';
          else if (chr == '#') url.query += '%23';
          else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
        } break;

      case FRAGMENT:
        if (chr != EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
        break;
    }

    pointer++;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLConstructor, 'URL');
  var base = arguments.length > 1 ? arguments[1] : undefined;
  var urlString = $toString(url);
  var state = setInternalState(that, { type: 'URL' });
  var baseState, failure;
  if (base !== undefined) {
    if (base instanceof URLConstructor) baseState = getInternalURLState(base);
    else {
      failure = parseURL(baseState = {}, $toString(base));
      if (failure) throw TypeError(failure);
    }
  }
  failure = parseURL(state, urlString, null, baseState);
  if (failure) throw TypeError(failure);
  var searchParams = state.searchParams = new URLSearchParams();
  var searchParamsState = getInternalSearchParamsState(searchParams);
  searchParamsState.updateSearchParams(state.query);
  searchParamsState.updateURL = function () {
    state.query = String(searchParams) || null;
  };
  if (!DESCRIPTORS) {
    that.href = serializeURL.call(that);
    that.origin = getOrigin.call(that);
    that.protocol = getProtocol.call(that);
    that.username = getUsername.call(that);
    that.password = getPassword.call(that);
    that.host = getHost.call(that);
    that.hostname = getHostname.call(that);
    that.port = getPort.call(that);
    that.pathname = getPathname.call(that);
    that.search = getSearch.call(that);
    that.searchParams = getSearchParams.call(that);
    that.hash = getHash.call(that);
  }
};

var URLPrototype = URLConstructor.prototype;

var serializeURL = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var username = url.username;
  var password = url.password;
  var host = url.host;
  var port = url.port;
  var path = url.path;
  var query = url.query;
  var fragment = url.fragment;
  var output = scheme + ':';
  if (host !== null) {
    output += '//';
    if (includesCredentials(url)) {
      output += username + (password ? ':' + password : '') + '@';
    }
    output += serializeHost(host);
    if (port !== null) output += ':' + port;
  } else if (scheme == 'file') output += '//';
  output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
  if (query !== null) output += '?' + query;
  if (fragment !== null) output += '#' + fragment;
  return output;
};

var getOrigin = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var port = url.port;
  if (scheme == 'blob') try {
    return new URLConstructor(scheme.path[0]).origin;
  } catch (error) {
    return 'null';
  }
  if (scheme == 'file' || !isSpecial(url)) return 'null';
  return scheme + '://' + serializeHost(url.host) + (port !== null ? ':' + port : '');
};

var getProtocol = function () {
  return getInternalURLState(this).scheme + ':';
};

var getUsername = function () {
  return getInternalURLState(this).username;
};

var getPassword = function () {
  return getInternalURLState(this).password;
};

var getHost = function () {
  var url = getInternalURLState(this);
  var host = url.host;
  var port = url.port;
  return host === null ? ''
    : port === null ? serializeHost(host)
    : serializeHost(host) + ':' + port;
};

var getHostname = function () {
  var host = getInternalURLState(this).host;
  return host === null ? '' : serializeHost(host);
};

var getPort = function () {
  var port = getInternalURLState(this).port;
  return port === null ? '' : String(port);
};

var getPathname = function () {
  var url = getInternalURLState(this);
  var path = url.path;
  return url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
};

var getSearch = function () {
  var query = getInternalURLState(this).query;
  return query ? '?' + query : '';
};

var getSearchParams = function () {
  return getInternalURLState(this).searchParams;
};

var getHash = function () {
  var fragment = getInternalURLState(this).fragment;
  return fragment ? '#' + fragment : '';
};

var accessorDescriptor = function (getter, setter) {
  return { get: getter, set: setter, configurable: true, enumerable: true };
};

if (DESCRIPTORS) {
  defineProperties(URLPrototype, {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    href: accessorDescriptor(serializeURL, function (href) {
      var url = getInternalURLState(this);
      var urlString = $toString(href);
      var failure = parseURL(url, urlString);
      if (failure) throw TypeError(failure);
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    origin: accessorDescriptor(getOrigin),
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    protocol: accessorDescriptor(getProtocol, function (protocol) {
      var url = getInternalURLState(this);
      parseURL(url, $toString(protocol) + ':', SCHEME_START);
    }),
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    username: accessorDescriptor(getUsername, function (username) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom($toString(username));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.username = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    password: accessorDescriptor(getPassword, function (password) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom($toString(password));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.password = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    host: accessorDescriptor(getHost, function (host) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, $toString(host), HOST);
    }),
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    hostname: accessorDescriptor(getHostname, function (hostname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, $toString(hostname), HOSTNAME);
    }),
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    port: accessorDescriptor(getPort, function (port) {
      var url = getInternalURLState(this);
      if (cannotHaveUsernamePasswordPort(url)) return;
      port = $toString(port);
      if (port == '') url.port = null;
      else parseURL(url, port, PORT);
    }),
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    pathname: accessorDescriptor(getPathname, function (pathname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      url.path = [];
      parseURL(url, $toString(pathname), PATH_START);
    }),
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    search: accessorDescriptor(getSearch, function (search) {
      var url = getInternalURLState(this);
      search = $toString(search);
      if (search == '') {
        url.query = null;
      } else {
        if ('?' == search.charAt(0)) search = search.slice(1);
        url.query = '';
        parseURL(url, search, QUERY);
      }
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    searchParams: accessorDescriptor(getSearchParams),
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    hash: accessorDescriptor(getHash, function (hash) {
      var url = getInternalURLState(this);
      hash = $toString(hash);
      if (hash == '') {
        url.fragment = null;
        return;
      }
      if ('#' == hash.charAt(0)) hash = hash.slice(1);
      url.fragment = '';
      parseURL(url, hash, FRAGMENT);
    })
  });
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
redefine(URLPrototype, 'toJSON', function toJSON() {
  return serializeURL.call(this);
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
redefine(URLPrototype, 'toString', function toString() {
  return serializeURL.call(this);
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  if (nativeCreateObjectURL) redefine(URLConstructor, 'createObjectURL', function createObjectURL(blob) {
    return nativeCreateObjectURL.apply(NativeURL, arguments);
  });
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  if (nativeRevokeObjectURL) redefine(URLConstructor, 'revokeObjectURL', function revokeObjectURL(url) {
    return nativeRevokeObjectURL.apply(NativeURL, arguments);
  });
}

setToStringTag(URLConstructor, 'URL');

$({ global: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});


/***/ }),

/***/ 22032:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" d=\"M8 4l4 4-4 4V4zM4 .889C4 .398 4.448 0 5 0s1 .398 1 .889V15.11c0 .491-.448.889-1 .889s-1-.398-1-.889V.89z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 44859:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic_stroke\" d=\"M9.9094 12.3334H9.75603L9.61808 12.4004C8.82771 12.7844 7.93998 13 6.99998 13C3.68627 13 0.99998 10.3137 0.99998 7.00004C0.99998 3.68633 3.68627 1.00004 6.99998 1.00004C10.3137 1.00004 13 3.68633 13 7.00004C13 7.94004 12.7843 8.82777 12.4003 9.61815L12.3333 9.75609V9.90946V12.3334H9.9094Z\" stroke-width=\"1.33333\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 30245:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" d=\"M4 8h8l-4 4-4-4zM.889 6C.398 6 0 5.552 0 5s.398-1 .889-1H15.11c.491 0 .889.448.889 1s-.398 1-.889 1H.89z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 28852:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.66539 2.97174C8.91134 2.76785 9.06826 2.45833 9.06826 2.11176C9.06826 1.49775 8.57569 1 7.96808 1C7.36047 1 6.8679 1.49775 6.8679 2.11176C6.8679 2.48731 7.05217 2.81937 7.33432 3.02064V4.29412H4.29183C3.18914 4.29412 2.29523 5.19744 2.29523 6.31175V12.9824C2.29523 14.0967 3.18914 15 4.29183 15H11.7079C12.8106 15 13.7045 14.0967 13.7045 12.9824V6.31175C13.7045 5.19744 12.8106 4.29412 11.7079 4.29412H8.66539V2.97174ZM11.7079 5.63921H4.29183C3.92427 5.63921 3.6263 5.94032 3.6263 6.31175V12.9824C3.6263 13.3538 3.92427 13.6549 4.29183 13.6549H11.7079C12.0754 13.6549 12.3734 13.3538 12.3734 12.9824V6.31175C12.3734 5.94032 12.0754 5.63921 11.7079 5.63921ZM15.3345 6.09216C15.702 6.09216 16 6.39327 16 6.76471V10.8824C16 11.2538 15.702 11.5549 15.3345 11.5549C14.9669 11.5549 14.6689 11.2538 14.6689 10.8824V6.76471C14.6689 6.39327 14.9669 6.09216 15.3345 6.09216ZM1.33107 6.76471C1.33107 6.39327 1.0331 6.09216 0.665535 6.09216C0.29797 6.09216 0 6.39327 0 6.76471L0 10.8824C0 11.2538 0.29797 11.5549 0.665535 11.5549C1.0331 11.5549 1.33107 11.2538 1.33107 10.8824V6.76471ZM5.94991 10.4294C6.50125 10.4294 6.94821 9.97775 6.94821 9.4206C6.94821 8.86344 6.50125 8.41178 5.94991 8.41178C5.39856 8.41178 4.95161 8.86344 4.95161 9.4206C4.95161 9.97775 5.39856 10.4294 5.94991 10.4294ZM10.7418 9.4206C10.7418 9.97775 10.2948 10.4294 9.74346 10.4294C9.19211 10.4294 8.74515 9.97775 8.74515 9.4206C8.74515 8.86344 9.19211 8.41178 9.74346 8.41178C10.2948 8.41178 10.7418 8.86344 10.7418 9.4206Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 86766:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M1.66683 6.99998C1.66683 4.05446 4.05464 1.66665 7.00016 1.66665C9.94568 1.66665 12.3335 4.05446 12.3335 6.99998C12.3335 9.9455 9.94568 12.3333 7.00016 12.3333C4.05464 12.3333 1.66683 9.9455 1.66683 6.99998ZM7.00016 0.333313C3.31826 0.333313 0.333496 3.31808 0.333496 6.99998C0.333496 10.6819 3.31826 13.6666 7.00016 13.6666C10.6821 13.6666 13.6668 10.6819 13.6668 6.99998C13.6668 3.31808 10.6821 0.333313 7.00016 0.333313ZM10.5123 5.42677C10.748 5.14392 10.7098 4.72354 10.427 4.48783C10.1441 4.25212 9.72372 4.29034 9.48802 4.57319L6.55081 8.09784L4.72099 6.79083C4.42138 6.57682 4.00501 6.64622 3.79101 6.94583C3.577 7.24543 3.6464 7.6618 3.946 7.87581L6.78285 9.90212L10.5123 5.42677Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 44461:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M12.3335 7.00001C12.3335 4.05449 9.94568 1.66668 7.00016 1.66668C4.05464 1.66668 1.66683 4.05449 1.66683 7.00001C1.66683 9.94553 4.05464 12.3333 7.00016 12.3333C9.94568 12.3333 12.3335 9.94553 12.3335 7.00001ZM13.6668 7.00001C13.6668 10.6819 10.6821 13.6667 7.00016 13.6667C3.31826 13.6667 0.333496 10.6819 0.333496 7.00001C0.333496 3.31811 3.31826 0.333344 7.00016 0.333344C10.6821 0.333344 13.6668 3.31811 13.6668 7.00001ZM5.99844 4.73459C5.7869 4.97257 5.66683 5.30872 5.66683 5.66668C5.66683 6.03487 5.36835 6.33334 5.00016 6.33334C4.63197 6.33334 4.3335 6.03487 4.3335 5.66668C4.3335 5.02463 4.54676 4.36079 5.00189 3.84877C5.46793 3.32448 6.15259 3.00001 7.00016 3.00001C7.74335 3.00001 8.41196 3.19655 8.906 3.61763C9.41141 4.0484 9.66683 4.65811 9.66683 5.33334C9.66683 5.76319 9.57758 6.17871 9.34926 6.57034C9.12475 6.95544 8.79108 7.27397 8.36996 7.55471C7.89842 7.86907 7.74592 8.05285 7.69682 8.13467C7.67159 8.17672 7.66683 8.18467 7.66683 8.33334C7.66683 8.70153 7.36835 9.00001 7.00016 9.00001C6.63197 9.00001 6.3335 8.70153 6.3335 8.33334L6.33349 8.32243C6.3334 8.13632 6.33325 7.81577 6.5535 7.44868C6.7544 7.11384 7.10191 6.79761 7.63036 6.44531C7.93768 6.24043 8.10401 6.05896 8.19739 5.8988C8.28696 5.74516 8.3335 5.57017 8.3335 5.33334C8.3335 5.00858 8.2201 4.78495 8.0411 4.63239C7.85073 4.47014 7.51934 4.33334 7.00016 4.33334C6.5144 4.33334 6.19907 4.50888 5.99844 4.73459ZM7.66683 10.3333C7.66683 10.7015 7.36835 11 7.00016 11C6.63197 11 6.3335 10.7015 6.3335 10.3333C6.3335 9.96515 6.63197 9.66668 7.00016 9.66668C7.36835 9.66668 7.66683 9.96515 7.66683 10.3333Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 60251:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"10","height":"13","viewBox":"0 0 10 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.333984 1.24984C0.333984 0.927673 0.595152 0.666504 0.917318 0.666504C0.917839 0.666504 0.91836 0.666505 0.918881 0.666506L3.25065 0.666504C3.98774 0.666504 4.55348 1.04063 4.9667 1.3139L5.01555 1.34617C5.4755 1.64945 5.7833 1.83317 6.16732 1.83317C6.602 1.83317 7.22352 1.6008 7.80228 1.31142C8.0773 1.17391 8.3191 1.03578 8.4922 0.931926C8.57848 0.880156 8.64703 0.837302 8.69333 0.807833C8.71647 0.793109 8.73401 0.781755 8.74539 0.774335L8.75775 0.766235L8.76054 0.764392C8.93952 0.645138 9.16961 0.634042 9.35924 0.735529C9.54891 0.83704 9.66732 1.03471 9.66732 1.24984V6.49984C9.66732 6.69488 9.56984 6.87701 9.40756 6.9852L9.08399 6.49984C9.40756 6.9852 9.40765 6.98514 9.40756 6.9852L9.4051 6.98683L9.40011 6.99014L9.3827 7.00155C9.36788 7.01122 9.34668 7.02493 9.31969 7.04211C9.26574 7.07644 9.18845 7.12473 9.09244 7.18233C8.90095 7.29723 8.63234 7.45076 8.32403 7.60492C7.73612 7.89887 6.8993 8.24984 6.16732 8.24984C5.4082 8.24984 4.81694 7.87335 4.38107 7.59581L4.34897 7.57538C3.86321 7.2664 3.55209 7.08317 3.18583 7.08317H1.50065V11.7498C1.50065 12.072 1.23948 12.3332 0.917318 12.3332C0.595152 12.3332 0.333984 12.072 0.333984 11.7498V1.24984Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 79058:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M6.05558 1.55357C6.36687 0.658012 7.6334 0.658002 7.9447 1.55357L9.04496 4.71887L12.3953 4.78714C13.3433 4.80646 13.7346 6.011 12.9791 6.58381L10.3087 8.60835L11.2791 11.8158C11.5537 12.7233 10.529 13.4678 9.75078 12.9262L7.00014 11.0122L4.24949 12.9262C3.47126 13.4678 2.4466 12.7234 2.72116 11.8158L3.69155 8.60835L1.02117 6.58381C0.265637 6.01101 0.657009 4.80646 1.60494 4.78714L4.95532 4.71887L6.05558 1.55357ZM7.00014 2.89714L6.13858 5.37574C6.00125 5.77081 5.63256 6.03868 5.21439 6.0472L2.59086 6.10066L4.68191 7.68599C5.01521 7.93867 5.15604 8.3721 5.03492 8.77244L4.27506 11.2841L6.42896 9.78526C6.77227 9.54636 7.228 9.54636 7.57132 9.78526L9.72522 11.2841L8.96535 8.77244C8.84424 8.3721 8.98507 7.93867 9.31836 7.68599L11.4094 6.10066L8.78589 6.0472C8.36772 6.03868 7.99903 5.77081 7.8617 5.37574L7.00014 2.89714Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 10812:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 0.666667C0 0.298477 0.298477 0 0.666667 0H11.3333C11.7015 0 12 0.298477 12 0.666667C12 1.03486 11.7015 1.33333 11.3333 1.33333H0.666667C0.298477 1.33333 0 1.03486 0 0.666667ZM0 3.33333C0 2.96514 0.298477 2.66667 0.666667 2.66667H7.33333C7.70152 2.66667 8 2.96514 8 3.33333C8 3.70152 7.70152 4 7.33333 4H0.666667C0.298477 4 0 3.70152 0 3.33333ZM0.666667 5.33333C0.298477 5.33333 0 5.63181 0 6C0 6.36819 0.298477 6.66667 0.666667 6.66667H11.3333C11.7015 6.66667 12 6.36819 12 6C12 5.63181 11.7015 5.33333 11.3333 5.33333H0.666667ZM0 8.66667C0 8.29848 0.298477 8 0.666667 8H7.33333C7.70152 8 8 8.29848 8 8.66667C8 9.03486 7.70152 9.33333 7.33333 9.33333H0.666667C0.298477 9.33333 0 9.03486 0 8.66667ZM0.666667 10.6667C0.298477 10.6667 0 10.9651 0 11.3333C0 11.7015 0.298477 12 0.666667 12H11.3333C11.7015 12 12 11.7015 12 11.3333C12 10.9651 11.7015 10.6667 11.3333 10.6667H0.666667Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 67906:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"10","viewBox":"0 0 14 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.333496 0.99998C0.333496 0.63179 0.631973 0.333313 1.00016 0.333313H13.0002C13.3684 0.333313 13.6668 0.63179 13.6668 0.99998C13.6668 1.36817 13.3684 1.66665 13.0002 1.66665H1.00016C0.631973 1.66665 0.333496 1.36817 0.333496 0.99998ZM0.333496 4.99998C0.333496 4.63179 0.631973 4.33331 1.00016 4.33331H13.0002C13.3684 4.33331 13.6668 4.63179 13.6668 4.99998C13.6668 5.36817 13.3684 5.66665 13.0002 5.66665H1.00016C0.631973 5.66665 0.333496 5.36817 0.333496 4.99998ZM1.00016 8.33331C0.631973 8.33331 0.333496 8.63179 0.333496 8.99998C0.333496 9.36817 0.631973 9.66665 1.00016 9.66665H13.0002C13.3684 9.66665 13.6668 9.36817 13.6668 8.99998C13.6668 8.63179 13.3684 8.33331 13.0002 8.33331H1.00016Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 89959:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"12","viewBox":"0 0 14 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.66651 0.666687C3.96417 0.666687 4.22576 0.864005 4.30753 1.15021L6.9742 10.4835C7.07535 10.8376 6.87035 11.2066 6.51633 11.3077C6.1623 11.4089 5.79331 11.2039 5.69216 10.8498L5.06744 8.6633C5.04521 8.66554 5.02266 8.66669 4.99985 8.66669H2.33318C2.31036 8.66669 2.28781 8.66554 2.26559 8.6633L1.64086 10.8498C1.53971 11.2039 1.17072 11.4089 0.816699 11.3077C0.462675 11.2066 0.257681 10.8376 0.35883 10.4835L3.0255 1.15021C3.10727 0.864005 3.36886 0.666687 3.66651 0.666687ZM2.64557 7.33335H4.68745L3.66651 3.76006L2.64557 7.33335ZM8.33318 1.33335C8.33318 0.965164 8.63166 0.666687 8.99985 0.666687H12.9998C13.2239 0.666687 13.433 0.779276 13.5564 0.96636C13.6798 1.15344 13.7009 1.38999 13.6126 1.59597L10.0109 10H12.9998C13.368 10 13.6665 10.2985 13.6665 10.6667C13.6665 11.0349 13.368 11.3334 12.9998 11.3334H8.99985C8.77575 11.3334 8.56665 11.2208 8.44329 11.0337C8.31992 10.8466 8.29881 10.61 8.38708 10.4041L11.9888 2.00002H8.99985C8.63166 2.00002 8.33318 1.70154 8.33318 1.33335ZM6.99985 6.00002C6.99985 5.63183 7.29832 5.33335 7.66651 5.33335H8.33318C8.70137 5.33335 8.99985 5.63183 8.99985 6.00002C8.99985 6.36821 8.70137 6.66669 8.33318 6.66669H7.66651C7.29832 6.66669 6.99985 6.36821 6.99985 6.00002Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 65216:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"11","viewBox":"0 0 12 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.195287 0.195262C0.455636 -0.0650874 0.877746 -0.0650874 1.1381 0.195262L2.46574 1.52291C2.51433 1.57023 2.55433 1.62356 2.58549 1.68078C2.6819 1.85741 2.69246 2.06845 2.61717 2.25261C2.59251 2.31292 2.55865 2.37035 2.51558 2.42275L1.18727 4.08313C0.957264 4.37064 0.537736 4.41725 0.250228 4.18725C-0.0372801 3.95724 -0.0838944 3.53771 0.146112 3.2502L1.10669 2.04948L0.195287 1.13807C-0.0650629 0.877722 -0.0650629 0.455612 0.195287 0.195262ZM4.00002 2C4.00002 1.63181 4.2985 1.33333 4.66669 1.33333H11.3334C11.7015 1.33333 12 1.63181 12 2C12 2.36819 11.7015 2.66667 11.3334 2.66667H4.66669C4.2985 2.66667 4.00002 2.36819 4.00002 2ZM4.00002 6C4.00002 5.63181 4.2985 5.33333 4.66669 5.33333H11.3334C11.7015 5.33333 12 5.63181 12 6C12 6.36819 11.7015 6.66667 11.3334 6.66667H4.66669C4.2985 6.66667 4.00002 6.36819 4.00002 6ZM4.66669 9.33333C4.2985 9.33333 4.00002 9.63181 4.00002 10C4.00002 10.3682 4.2985 10.6667 4.66669 10.6667H11.3334C11.7015 10.6667 12 10.3682 12 10C12 9.63181 11.7015 9.33333 11.3334 9.33333H4.66669Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 88098:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"9","viewBox":"0 0 11 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M5.49633 0.250001C5.29741 0.250001 5.09758 0.286163 4.90966 0.358065L0.815374 1.91133C0.584833 1.99879 0.590791 2.29313 0.820874 2.38059L4.93762 3.87667C5.29828 4.0108 5.70171 4.0108 6.06237 3.87667L10.1791 2.38059C10.4097 2.29818 10.4097 1.99879 10.1846 1.91133L6.07933 0.358065C5.89487 0.28651 5.6966 0.249758 5.49633 0.250001ZM10.725 2.81074C10.6901 2.81095 10.6555 2.81738 10.6232 2.82967L6.03441 4.45988C5.98307 4.47917 5.93912 4.51201 5.90812 4.55422C5.87712 4.59643 5.86046 4.64613 5.86025 4.69703V8.43765C5.86068 8.4786 5.87197 8.51884 5.89315 8.55489C5.91432 8.59095 5.94475 8.62173 5.98179 8.64458C6.01884 8.66743 6.06139 8.68166 6.10577 8.68605C6.15016 8.69043 6.19504 8.68484 6.23654 8.66976L10.8258 7.03408C10.8773 7.01655 10.9216 6.9849 10.9528 6.94345C10.9839 6.902 11.0004 6.85275 11 6.80239V3.06177C10.9995 2.99515 10.9703 2.93141 10.9188 2.88446C10.8673 2.83751 10.7976 2.81116 10.725 2.81116V2.81074ZM0.309833 2.82714C0.269139 2.82582 0.228587 2.83223 0.190726 2.84598C0.152864 2.85973 0.118514 2.88052 0.0898333 2.90703C0.0394166 2.95371 0 3.01005 0 3.07733V6.59047C0 6.77632 0.236042 6.90036 0.416166 6.81753L3.28991 5.55356L3.43062 5.49175L4.79141 4.88793C5.005 4.79543 4.9885 4.50613 4.76345 4.42876L0.404708 2.84522C0.374619 2.83368 0.34244 2.8274 0.309833 2.82672V2.82714Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 32577:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill=\"#F24242\" d=\"M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zM7 10h2v2H7v-2zm0-6h2v5H7V4z\"/>         <path d=\"M0 0h16v16H0z\" opacity=\".486\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 87163:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm3 4a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1zm-2 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4zm2 5a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1zm-2 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 36842:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm1 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4zm-1 5a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm1 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 35596:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm1 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4zm-1 5a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm1 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 4802:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm6 4a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H10a1 1 0 0 1-1-1zm-5 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4zm5 5a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H10a1 1 0 0 1-1-1zm-5 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 19379:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" d=\"M4 7h8l-4 4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 61177:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path fill=\"#AEB7B8\" d=\"M10 4v8L6 8z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 61093:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"5","height":"6","viewBox":"0 0 5 6","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M0 4.82578V1.17422C0 0.319867 1.00212 -0.141041 1.65079 0.414964L3.78087 2.24074C4.24648 2.63984 4.24648 3.36016 3.78087 3.75926L1.65079 5.58504C1.00212 6.14104 0 5.68013 0 4.82578Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 83675:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path fill=\"#AEB7B8\" d=\"M6 4v8l4-4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 4817:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M18.662 2.059l-4.611 1.536A3 3 0 0 0 12 6.442v8.35c-.849-.507-1.894-.792-3-.792-1.3 0-2.515.394-3.428 1.079C4.658 15.764 4 16.786 4 18c0 1.214.658 2.236 1.572 2.921C6.485 21.606 7.7 22 9 22c1.3 0 2.515-.394 3.428-1.079C13.342 20.236 14 19.214 14 18v-7.279l3.949-1.316A3 3 0 0 0 20 6.559V3.023a.979.979 0 0 0-.126-.509.992.992 0 0 0-1.212-.455zM14 8.613l3.316-1.106A.999.999 0 0 0 18 6.559V4.387l-3.316 1.106a1 1 0 0 0-.684.949v2.171zm-2.772 8.066c.535.401.772.878.772 1.321 0 .443-.237.921-.772 1.321C10.694 19.722 9.909 20 9 20c-.909 0-1.694-.278-2.228-.679C6.237 18.921 6 18.443 6 18c0-.443.237-.92.772-1.321C7.306 16.278 8.091 16 9 16c.909 0 1.694.278 2.228.679z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 69710:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" d=\"M8.0002 2.66665C7.26382 2.66665 6.66687 3.2636 6.66687 3.99998V6.66665C6.66687 7.40303 7.26382 7.99998 8.0002 7.99998C8.73658 7.99998 9.33354 7.40303 9.33354 6.66665V3.99998C9.33354 3.2636 8.73658 2.66665 8.0002 2.66665ZM5.33354 3.99998C5.33354 2.52722 6.52744 1.33331 8.0002 1.33331C9.47296 1.33331 10.6669 2.52722 10.6669 3.99998V6.66665C10.6669 8.13941 9.47296 9.33331 8.0002 9.33331C6.52744 9.33331 5.33354 8.13941 5.33354 6.66665V3.99998ZM4.0002 5.99998C4.0002 5.63179 3.70173 5.33331 3.33354 5.33331C2.96535 5.33331 2.66687 5.63179 2.66687 5.99998V6.66665C2.66687 9.38682 4.70331 11.6314 7.33479 11.9589C7.33396 11.9725 7.33354 11.9862 7.33354 12V13.3333H6.66687C6.29868 13.3333 6.0002 13.6318 6.0002 14C6.0002 14.3682 6.29868 14.6666 6.66687 14.6666H9.33354C9.70173 14.6666 10.0002 14.3682 10.0002 14C10.0002 13.6318 9.70173 13.3333 9.33354 13.3333H8.66687V12C8.66687 11.9862 8.66645 11.9725 8.66562 11.9589C11.2971 11.6314 13.3335 9.38682 13.3335 6.66665V5.99998C13.3335 5.63179 13.0351 5.33331 12.6669 5.33331C12.2987 5.33331 12.0002 5.63179 12.0002 5.99998V6.66665C12.0002 8.87579 10.2093 10.6666 8.0002 10.6666C5.79106 10.6666 4.0002 8.87579 4.0002 6.66665V5.99998Z\" fill=\"#5C6061\" />     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 86306:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.193851 6.46999C0.19432 6.47046 0.194791 6.47093 0.195262 6.4714C0.195376 6.47152 0.19549 6.47163 0.195605 6.47175L5.5286 11.8047C5.78895 12.0651 6.21106 12.0651 6.4714 11.8047C6.73175 11.5444 6.73175 11.1223 6.4714 10.8619L2.27614 6.66667H11.3333C11.7015 6.66667 12 6.36819 12 6C12 5.63181 11.7015 5.33333 11.3333 5.33333H2.27614L6.4714 1.13807C6.73175 0.877722 6.73175 0.455612 6.4714 0.195262C6.21106 -0.0650875 5.78895 -0.0650875 5.5286 0.195262L0.195262 5.5286L0.193851 5.53001C0.0740375 5.65054 0 5.81662 0 6C0 6.09039 0.0179904 6.17659 0.0505859 6.25519C0.052061 6.25875 0.0535685 6.26231 0.0551082 6.26585C0.0872743 6.3399 0.133522 6.4093 0.193851 6.46999Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 11803:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.333 3.333a.667.667 0 1 1 1.334 0c0 .167.061.32.163.437l.009.01.035.042.132.16c.113.136.268.329.438.551.348.454.735.998.964 1.44.253.488.488 1.186.665 1.792a21.283 21.283 0 0 1 .273 1.03l.002.01a.663.663 0 0 0 .18.333l1 1 .53.529H2.942l.528-.529 1-1a.663.663 0 0 0 .181-.332l.002-.01a9.955 9.955 0 0 1 .069-.28c.048-.19.117-.455.204-.751.177-.606.412-1.304.665-1.791.23-.443.616-.987.964-1.441a21.281 21.281 0 0 1 .57-.71l.035-.042.009-.01V3.77a.664.664 0 0 0 .163-.437zm5.272 4.996l.866.866.529.529c.84.84.245 2.276-.943 2.276h-2.39a2.667 2.667 0 0 1-5.334 0h-2.39C1.755 12 1.16 10.564 2 9.724l.529-.529.866-.866.035-.14c.05-.202.125-.482.217-.798.181-.62.446-1.422.761-2.031.286-.552.733-1.174 1.09-1.639.181-.236.346-.44.466-.586l.053-.065a2 2 0 0 1 3.966 0l.053.065c.12.145.285.35.466.586.357.465.804 1.087 1.09 1.639.315.609.58 1.41.761 2.031a22.717 22.717 0 0 1 .252.938zM8 13.333A1.333 1.333 0 0 1 6.667 12h2.666c0 .736-.597 1.333-1.333 1.333z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 38096:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.33337 2.66663C6.59699 2.66663 6.00004 3.26358 6.00004 3.99996V12C6.00004 12.7363 6.59699 13.3333 7.33337 13.3333H8.66671C9.40309 13.3333 10 12.7363 10 12V3.99996C10 3.26358 9.40309 2.66663 8.66671 2.66663H7.33337ZM7.33337 3.99996L8.66671 3.99996V12H7.33337V3.99996Z\" fill=\"black\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.33337 4.66663C1.33337 3.93025 1.93033 3.33329 2.66671 3.33329H4.00004C4.73642 3.33329 5.33337 3.93025 5.33337 4.66663V11.3333C5.33337 12.0697 4.73642 12.6666 4.00004 12.6666H2.66671C1.93033 12.6666 1.33337 12.0697 1.33337 11.3333V4.66663ZM4.00004 4.66663L2.66671 4.66663V11.3333H4.00004V4.66663Z\" fill=\"black\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.6667 4.66663C10.6667 3.93025 11.2637 3.33329 12 3.33329H13.3334C14.0698 3.33329 14.6667 3.93025 14.6667 4.66663V11.3333C14.6667 12.0697 14.0698 12.6666 13.3334 12.6666H12C11.2637 12.6666 10.6667 12.0697 10.6667 11.3333V4.66663ZM13.3334 4.66663L12 4.66663V11.3333H13.3334V4.66663Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 69425:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M6 2.5H4.5v19H14a5.5 5.5 0 0 0 2.532-10.384A5.5 5.5 0 0 0 12 2.5H6zm6 8a2.5 2.5 0 1 0 0-5H7.5v5H12zm-4.5 3v5H14a2.5 2.5 0 1 0 0-5H7.5z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 22793:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"22","height":"28","viewBox":"0 0 22 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.33337 0.666504C2.12404 0.666504 0.333374 2.45717 0.333374 4.6665V25.9998C0.333374 26.3345 0.457374 26.6412 0.661374 26.8758C0.714707 26.9372 0.774707 26.9945 0.840041 27.0465C1.05071 27.2118 1.31071 27.3158 1.59604 27.3318C1.63204 27.3332 1.66937 27.3332 1.70537 27.3332C2.02404 27.3238 2.31471 27.2025 2.54004 27.0078L11 19.7558L19.46 27.0078C19.6854 27.2025 19.976 27.3238 20.2947 27.3332C20.3307 27.3332 20.368 27.3332 20.404 27.3318C20.6894 27.3158 20.9494 27.2118 21.16 27.0465C21.468 26.8025 21.6667 26.4238 21.6667 25.9998V4.6665C21.6667 2.45717 19.876 0.666504 17.6667 0.666504H4.33337ZM3.00004 4.6665C3.00004 3.9305 3.59737 3.33317 4.33337 3.33317H17.6667C18.4027 3.33317 19 3.9305 19 4.6665V23.1012L11.8734 16.9918C11.64 16.7892 11.3347 16.6665 11 16.6665C10.6654 16.6665 10.36 16.7892 10.1267 16.9918L3.00004 23.1012V4.6665Z\" fill=\"#AEB7B8\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 60681:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"10","viewBox":"0 0 14 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.333344 3.66665C0.333344 1.8257 1.82573 0.333313 3.66668 0.333313H10.3333C12.1743 0.333313 13.6667 1.8257 13.6667 3.66665V6.33335C13.6667 8.1743 12.1743 9.66668 10.3333 9.66668H3.66668C1.82573 9.66668 0.333344 8.1743 0.333344 6.33335V3.66665ZM1.71514 4.10621C1.72692 4.15875 1.74077 4.2105 1.75659 4.26139C2.00982 5.07552 2.76921 5.66665 3.66668 5.66665H10.3333C11.2871 5.66665 12.085 4.99897 12.285 4.10551C12.3167 3.96428 12.3333 3.81741 12.3333 3.66665C12.3333 2.56208 11.4379 1.66665 10.3333 1.66665H3.66668C2.56211 1.66665 1.66668 2.56208 1.66668 3.66665C1.66668 3.81766 1.68341 3.96477 1.71514 4.10621Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 74985:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"currentColor\" d=\"M5.333 2c.368 0 .667.298.667.667v.666h4v-.666a.667.667 0 0 1 1.333 0v.666H12a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5.333a2 2 0 0 1 2-2h.667v-.666c0-.369.298-.667.666-.667zM10 4.667v.666a.667.667 0 0 0 1.333 0v-.666H12c.368 0 .667.298.667.666v1.334H3.333V5.333c0-.368.299-.666.667-.666h.667v.666a.667.667 0 0 0 1.333 0v-.666h4zM3.333 8v4c0 .368.299.667.667.667h8a.667.667 0 0 0 .667-.667V8H3.333z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 31887:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"47","height":"46","viewBox":"0 0 47 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.1583 11.3914C44.1583 9.56889 42.6808 8.09143 40.8583 8.09143H33.275C32.557 8.09143 31.975 8.67346 31.975 9.39143C31.975 10.1094 32.557 10.6914 33.275 10.6914H40.8583C41.2449 10.6914 41.5583 11.0048 41.5583 11.3914V16.0998C41.5583 16.8177 42.1403 17.3998 42.8583 17.3998C43.5763 17.3998 44.1583 16.8177 44.1583 16.0998V11.3914ZM15.4083 9.39143C15.4083 8.67346 14.8263 8.09143 14.1083 8.09143H6.52497C4.70243 8.09143 3.22498 9.56889 3.22498 11.3914V16.0998C3.22498 16.8177 3.807 17.3998 4.52497 17.3998C5.24295 17.3998 5.82497 16.8177 5.82497 16.0998V11.3914C5.82497 11.0048 6.13837 10.6914 6.52497 10.6914H14.1083C14.8263 10.6914 15.4083 10.1094 15.4083 9.39143ZM42.8583 28.2164C42.1403 28.2164 41.5583 28.7985 41.5583 29.5164V34.2248C41.5583 34.6114 41.2449 34.9248 40.8583 34.9248H33.275C32.557 34.9248 31.975 35.5068 31.975 36.2248C31.975 36.9427 32.557 37.5248 33.275 37.5248H40.8583C42.6808 37.5248 44.1583 36.0473 44.1583 34.2248V29.5164C44.1583 28.7985 43.5763 28.2164 42.8583 28.2164ZM4.52497 28.2164C3.807 28.2164 3.22498 28.7985 3.22498 29.5164V34.2248C3.22498 36.0473 4.70243 37.5248 6.52497 37.5248H14.1083C14.8263 37.5248 15.4083 36.9427 15.4083 36.2248C15.4083 35.5068 14.8263 34.9248 14.1083 34.9248H6.52497C6.13838 34.9248 5.82497 34.6114 5.82497 34.2248V29.5164C5.82497 28.7985 5.24295 28.2164 4.52497 28.2164Z\" fill=\"#00A1B7\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32.5 23C32.5 27.9706 28.4706 32 23.5 32C18.5294 32 14.5 27.9706 14.5 23C14.5 18.0294 18.5294 14 23.5 14C28.4706 14 32.5 18.0294 32.5 23ZM25.8625 20.6375C25.8625 21.9423 24.8048 23 23.5 23C22.1952 23 21.1375 21.9423 21.1375 20.6375C21.1375 19.3327 22.1952 18.275 23.5 18.275C24.8048 18.275 25.8625 19.3327 25.8625 20.6375ZM26.8718 27.0538C27.3662 26.8479 27.5539 26.2508 27.224 25.829C26.3592 24.7233 25.0126 24.0125 23.5 24.0125C21.9874 24.0125 20.6408 24.7233 19.776 25.829C19.4461 26.2508 19.6338 26.8479 20.1281 27.0538C21.1662 27.4862 22.3052 27.725 23.5 27.725C24.6947 27.725 25.8337 27.4862 26.8718 27.0538Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 21088:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"47","height":"46","viewBox":"0 0 47 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.1583 11.3914C44.1583 9.56889 42.6808 8.09143 40.8583 8.09143H33.275C32.557 8.09143 31.975 8.67346 31.975 9.39143C31.975 10.1094 32.557 10.6914 33.275 10.6914H40.8583C41.2449 10.6914 41.5583 11.0048 41.5583 11.3914V16.0998C41.5583 16.8177 42.1403 17.3998 42.8583 17.3998C43.5763 17.3998 44.1583 16.8177 44.1583 16.0998V11.3914ZM15.4083 9.39143C15.4083 8.67346 14.8263 8.09143 14.1083 8.09143H6.52497C4.70243 8.09143 3.22498 9.56889 3.22498 11.3914V16.0998C3.22498 16.8177 3.807 17.3998 4.52497 17.3998C5.24295 17.3998 5.82497 16.8177 5.82497 16.0998V11.3914C5.82497 11.0048 6.13837 10.6914 6.52497 10.6914H14.1083C14.8263 10.6914 15.4083 10.1094 15.4083 9.39143ZM42.8583 28.2164C42.1403 28.2164 41.5583 28.7985 41.5583 29.5164V34.2248C41.5583 34.6114 41.2449 34.9248 40.8583 34.9248H33.275C32.557 34.9248 31.975 35.5068 31.975 36.2248C31.975 36.9427 32.557 37.5248 33.275 37.5248H40.8583C42.6808 37.5248 44.1583 36.0473 44.1583 34.2248V29.5164C44.1583 28.7985 43.5763 28.2164 42.8583 28.2164ZM4.52497 28.2164C3.807 28.2164 3.22498 28.7985 3.22498 29.5164V34.2248C3.22498 36.0473 4.70243 37.5248 6.52497 37.5248H14.1083C14.8263 37.5248 15.4083 36.9427 15.4083 36.2248C15.4083 35.5068 14.8263 34.9248 14.1083 34.9248H6.52497C6.13838 34.9248 5.82497 34.6114 5.82497 34.2248V29.5164C5.82497 28.7985 5.24295 28.2164 4.52497 28.2164Z\" fill=\"#A5B3BD\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32.5 23C32.5 27.9706 28.4706 32 23.5 32C18.5294 32 14.5 27.9706 14.5 23C14.5 18.0294 18.5294 14 23.5 14C28.4706 14 32.5 18.0294 32.5 23ZM25.8625 20.6375C25.8625 21.9423 24.8048 23 23.5 23C22.1952 23 21.1375 21.9423 21.1375 20.6375C21.1375 19.3327 22.1952 18.275 23.5 18.275C24.8048 18.275 25.8625 19.3327 25.8625 20.6375ZM26.8718 27.0538C27.3662 26.8479 27.5539 26.2508 27.224 25.829C26.3592 24.7233 25.0126 24.0125 23.5 24.0125C21.9874 24.0125 20.6408 24.7233 19.776 25.829C19.4461 26.2508 19.6338 26.8479 20.1281 27.0538C21.1662 27.4862 22.3052 27.725 23.5 27.725C24.6947 27.725 25.8337 27.4862 26.8718 27.0538Z\" fill=\"#A5B3BD\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 21855:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"10","viewBox":"0 0 14 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.2304 0.914805C13.4908 1.17515 13.4908 1.59726 13.2304 1.85761L5.68792 9.4001C5.42758 9.66045 5.00547 9.66045 4.74512 9.4001L0.528599 5.1836C0.268249 4.92325 0.268248 4.50114 0.528597 4.24079C0.788946 3.98044 1.21106 3.98044 1.47141 4.24079L5.21652 7.98589L12.2876 0.914806C12.5479 0.654456 12.9701 0.654456 13.2304 0.914805Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 41614:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg","style":"color: #00a1b7;"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 0C0.895431 0 0 0.89543 0 2V16C0 17.1046 0.89543 18 2 18H16C17.1046 18 18 17.1046 18 16V2C18 0.895431 17.1046 0 16 0H2ZM14.2682 6.64018C14.6218 6.21591 14.5645 5.58534 14.1402 5.23178C13.7159 4.87821 13.0853 4.93554 12.7318 5.35982L8.32597 10.6468L5.58124 8.68627C5.13182 8.36526 4.50727 8.46935 4.18627 8.91877C3.86526 9.36818 3.96935 9.99273 4.41876 10.3137L7.91876 12.8137L8.67403 13.3532L9.26822 12.6402L14.2682 6.64018Z\" fill=\"currentColor\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 98892:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6zM5 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6zm12.268 3.64a1 1 0 1 0-1.536-1.28l-4.406 5.287-2.745-1.96a1 1 0 1 0-1.162 1.627l3.5 2.5.755.54.594-.714 5-6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 36598:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M9.70711 3.70711C10.0976 3.31658 10.0976 2.68342 9.70711 2.29289C9.31658 1.90237 8.68342 1.90237 8.29289 2.29289L5 5.58579L3.70711 4.29289C3.31658 3.90237 2.68342 3.90237 2.29289 4.29289C1.90237 4.68342 1.90237 5.31658 2.29289 5.70711L4.29289 7.70711C4.68342 8.09763 5.31658 8.09763 5.70711 7.70711L9.70711 3.70711Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M12 5C11.4477 5 11 5.44772 11 6C11 6.55228 11.4477 7 12 7H21C21.5523 7 22 6.55228 22 6C22 5.44772 21.5523 5 21 5H12Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11H3Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M3 19C2.44772 19 2 18.5523 2 18C2 17.4477 2.44772 17 3 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H3Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 47904:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" fill-rule=\"nonzero\" d=\"M6 9.414l5 5L12.414 13l-5-5 5-5L11 1.586 4.586 8 6 9.414z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 16186:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" fill-rule=\"nonzero\" d=\"M11 9.414l-5 5L4.586 13l5-5-5-5L6 1.586 12.414 8 11 9.414z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 57872:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4 3a1 1 0 0 1 1-1h14a1 1 0 0 1 0 2h-6v6.877l-2-1.913V4H5a1 1 0 0 1-1-1zm.265 3.322a1 1 0 0 1 1.413-.057l13 12a1 1 0 0 1-1.356 1.47L13 15.745V21a1 1 0 0 1-2 0v-7.101L4.322 7.735a1 1 0 0 1-.057-1.413z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 71185:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"30","height":"24","viewBox":"0 0 30 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.25 24C8.50282 24 8.75298 23.9886 9 23.9664V24H22.5V23.9588C22.7463 23.986 22.9965 24 23.25 24C26.9779 24 30 20.9779 30 17.25C30 13.7314 27.3077 10.8416 23.8708 10.5282C23.9557 10.0315 24 9.52091 24 9C24 4.02944 19.9706 0 15 0C10.4404 0 6.67276 3.39066 6.08089 7.78812C2.57683 8.7405 0 11.9443 0 15.75C0 20.3063 3.69365 24 8.25 24ZM9.43934 7.93934C10.0251 7.35355 10.9749 7.35355 11.5607 7.93934L15 11.3787L18.4393 7.93934C19.0251 7.35355 19.9749 7.35355 20.5607 7.93934C21.1464 8.52513 21.1464 9.47487 20.5607 10.0607L17.1213 13.5L20.5607 16.9393C21.1464 17.5251 21.1464 18.4749 20.5607 19.0607C19.9749 19.6464 19.0251 19.6464 18.4393 19.0607L15 15.6213L11.5607 19.0607C10.9749 19.6464 10.0251 19.6464 9.43934 19.0607C8.85355 18.4749 8.85355 17.5251 9.43934 16.9393L12.8787 13.5L9.43934 10.0607C8.85355 9.47487 8.85355 8.52513 9.43934 7.93934Z\" fill=\"#C8C8C8\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 47778:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M14.961 5.275a1 1 0 0 0-1.922-.55l-4 14a1.001 1.001 0 0 0 1.922.55l4-14zm-7.336.944a1 1 0 0 1 .156 1.406L4.28 12l3.5 4.375a1 1 0 0 1-1.562 1.25L2.232 12.64A.986.986 0 0 1 2 12a1 1 0 0 1 .232-.64l3.987-4.985a1 1 0 0 1 1.406-.156zm8.75 0a1 1 0 0 1 1.406.156l3.987 4.985a1.003 1.003 0 0 1 0 1.28l-3.987 4.985a1 1 0 0 1-1.562-1.25L19.72 12l-3.5-4.375a1 1 0 0 1 .156-1.406z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 97368:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"10","viewBox":"0 0 12 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M0.666667 0.333374C0.298477 0.333374 0 0.631851 0 1.00004C0 1.36823 0.298477 1.66671 0.666667 1.66671H4.66667C5.03486 1.66671 5.33333 1.36823 5.33333 1.00004C5.33333 0.631851 5.03486 0.333374 4.66667 0.333374H0.666667Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M0.666667 3.00004C0.298477 3.00004 0 3.29852 0 3.66671C0 4.0349 0.298477 4.33337 0.666667 4.33337H4.66667C5.03486 4.33337 5.33333 4.0349 5.33333 3.66671C5.33333 3.29852 5.03486 3.00004 4.66667 3.00004H0.666667Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M0 6.33337C0 5.96518 0.298477 5.66671 0.666667 5.66671H4.66667C5.03486 5.66671 5.33333 5.96518 5.33333 6.33337C5.33333 6.70156 5.03486 7.00004 4.66667 7.00004H0.666667C0.298477 7.00004 0 6.70156 0 6.33337Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M0.666667 8.33337C0.298477 8.33337 0 8.63185 0 9.00004C0 9.36823 0.298477 9.66671 0.666667 9.66671H4.66667C5.03486 9.66671 5.33333 9.36823 5.33333 9.00004C5.33333 8.63185 5.03486 8.33337 4.66667 8.33337H0.666667Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M6.66667 1.00004C6.66667 0.631851 6.96514 0.333374 7.33333 0.333374H11.3333C11.7015 0.333374 12 0.631851 12 1.00004C12 1.36823 11.7015 1.66671 11.3333 1.66671H7.33333C6.96514 1.66671 6.66667 1.36823 6.66667 1.00004Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M7.33333 3.00004C6.96514 3.00004 6.66667 3.29852 6.66667 3.66671C6.66667 4.0349 6.96514 4.33337 7.33333 4.33337H11.3333C11.7015 4.33337 12 4.0349 12 3.66671C12 3.29852 11.7015 3.00004 11.3333 3.00004H7.33333Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M6.66667 6.33337C6.66667 5.96518 6.96514 5.66671 7.33333 5.66671H11.3333C11.7015 5.66671 12 5.96518 12 6.33337C12 6.70156 11.7015 7.00004 11.3333 7.00004H7.33333C6.96514 7.00004 6.66667 6.70156 6.66667 6.33337Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M7.33333 8.33337C6.96514 8.33337 6.66667 8.63185 6.66667 9.00004C6.66667 9.36823 6.96514 9.66671 7.33333 9.66671H11.3333C11.7015 9.66671 12 9.36823 12 9.00004C12 8.63185 11.7015 8.33337 11.3333 8.33337H7.33333Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 58191:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"19","height":"18","viewBox":"0 0 19 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.3999 1.5C5.25777 1.5 1.8999 4.85786 1.8999 9C1.8999 13.1421 5.25777 16.5 9.3999 16.5C10.5734 16.5 11.6839 16.2305 12.673 15.75H16.1499V12.2731C16.6304 11.284 16.8999 10.1735 16.8999 9C16.8999 4.85786 13.542 1.5 9.3999 1.5Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 7688:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.333313 7C0.333313 3.3181 3.31808 0.333336 6.99998 0.333336C10.6819 0.333336 13.6666 3.3181 13.6666 7C13.6666 8.0431 13.4271 9.03024 13 9.90942V13H9.9094C9.03022 13.4271 8.04308 13.6667 6.99998 13.6667C3.31808 13.6667 0.333313 10.6819 0.333313 7Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 3641:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic_stroke\" d=\"M14.3641 18H14.1341L13.9272 18.1005C12.7416 18.6765 11.41 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10C19 11.41 18.6765 12.7416 18.1005 13.9272L18 14.1341V14.3641V18H14.3641Z\" stroke-width=\"2\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 67012:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M7.33317 2C6.2286 2 5.33317 2.89543 5.33317 4V4.66667H4.6665C3.56193 4.66667 2.6665 5.5621 2.6665 6.66667V12C2.6665 13.1046 3.56193 14 4.6665 14H8.6665C9.77107 14 10.6665 13.1046 10.6665 12V11.3333H11.3332C12.4377 11.3333 13.3332 10.4379 13.3332 9.33333V4C13.3332 2.89543 12.4377 2 11.3332 2H7.33317ZM10.6665 10V6.66667C10.6665 5.5621 9.77107 4.66667 8.6665 4.66667H6.6665V4C6.6665 3.63181 6.96498 3.33333 7.33317 3.33333H11.3332C11.7014 3.33333 11.9998 3.63181 11.9998 4V9.33333C11.9998 9.70152 11.7014 10 11.3332 10H10.6665ZM3.99984 6.66667C3.99984 6.29848 4.29831 6 4.6665 6H8.6665C9.03469 6 9.33317 6.29848 9.33317 6.66667V12C9.33317 12.3682 9.03469 12.6667 8.6665 12.6667H4.6665C4.29831 12.6667 3.99984 12.3682 3.99984 12V6.66667Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 13532:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 2C0 0.895431 0.895431 0 2 0H4C4.62951 0 5.22229 0.296388 5.6 0.8L7 2.66667H10C11.1046 2.66667 12 3.5621 12 4.66667V6.35176C12.055 6.40102 12.1089 6.45207 12.1618 6.5049C13.7239 8.067 13.7239 10.5997 12.1618 12.1618C10.5997 13.7239 8.067 13.7239 6.50491 12.1618C6.45207 12.1089 6.40103 12.055 6.35177 12H2C0.89543 12 0 11.1046 0 10V2ZM10.6667 5.56111C9.25957 5.06486 7.63034 5.37946 6.50491 6.5049C5.37947 7.63034 5.06487 9.25957 5.56111 10.6667H2C1.63181 10.6667 1.33333 10.3682 1.33333 10V4H10C10.3682 4 10.6667 4.29848 10.6667 4.66667V5.56111ZM4.53333 1.6L5.33333 2.66667H1.33333V2C1.33333 1.63181 1.63181 1.33333 2 1.33333H4C4.20984 1.33333 4.40743 1.43213 4.53333 1.6ZM6.67441 9.33112C6.67441 8.96293 6.97288 8.66445 7.34107 8.66445H8.66897V7.33655C8.66897 6.96836 8.96744 6.66988 9.33563 6.66988C9.70382 6.66988 10.0023 6.96836 10.0023 7.33655V8.66445H11.3302C11.6984 8.66445 11.9969 8.96293 11.9969 9.33112C11.9969 9.69931 11.6984 9.99778 11.3302 9.99778H10.0023V11.3257C10.0023 11.6939 9.70382 11.9923 9.33563 11.9923C8.96744 11.9923 8.66897 11.6939 8.66897 11.3257V9.99778H7.34107C6.97288 9.99778 6.67441 9.69931 6.67441 9.33112Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 44744:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"13","height":"16","viewBox":"0 0 13 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.166672 2.51702C0.166672 1.41245 1.0621 0.517017 2.16667 0.517017H8.83334C9.93791 0.517017 10.8333 1.41245 10.8333 2.51702V8.20221C11.6517 8.93464 12.1667 9.99902 12.1667 11.1837C12.1667 13.3928 10.3758 15.1837 8.16667 15.1837C6.98201 15.1837 5.91762 14.6687 5.1852 13.8504H2.16667C1.0621 13.8504 0.166672 12.9549 0.166672 11.8504V2.51702ZM4.39428 12.517C4.24688 12.1 4.16667 11.6512 4.16667 11.1837C4.16667 8.97455 5.95753 7.18368 8.16667 7.18368C8.63419 7.18368 9.08297 7.26389 9.50001 7.41129V2.51702C9.50001 2.14883 9.20153 1.85035 8.83334 1.85035H2.16667C1.79848 1.85035 1.50001 2.14883 1.50001 2.51702V11.8504C1.50001 12.2185 1.79848 12.517 2.16667 12.517H4.39428ZM2.83334 3.85035C2.83334 3.48216 3.13182 3.18368 3.50001 3.18368H7.50001C7.86819 3.18368 8.16667 3.48216 8.16667 3.85035C8.16667 4.21854 7.86819 4.51702 7.50001 4.51702H3.50001C3.13182 4.51702 2.83334 4.21854 2.83334 3.85035ZM3.50001 5.85035C3.13182 5.85035 2.83334 6.14883 2.83334 6.51702C2.83334 6.88521 3.13182 7.18368 3.50001 7.18368H4.83334C5.20153 7.18368 5.50001 6.88521 5.50001 6.51702C5.50001 6.14883 5.20153 5.85035 4.83334 5.85035H3.50001ZM8.83334 9.18368C8.83334 8.81549 8.53486 8.51702 8.16667 8.51702C7.79848 8.51702 7.50001 8.81549 7.50001 9.18368V10.517H6.16667C5.79848 10.517 5.50001 10.8155 5.50001 11.1837C5.50001 11.5519 5.79848 11.8504 6.16667 11.8504H7.50001V13.1837C7.50001 13.5519 7.79848 13.8504 8.16667 13.8504C8.53486 13.8504 8.83334 13.5519 8.83334 13.1837V11.8504H10.1667C10.5349 11.8504 10.8333 11.5519 10.8333 11.1837C10.8333 10.8155 10.5349 10.517 10.1667 10.517H8.83334V9.18368Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 33597:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","viewBox":"0 0 12 12"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h12v12H0z\"/>         <path class=\"graphic\" fill=\"#FFFFFF\" d=\"M6.707 6l2.98 2.98.353.353-.707.707-.353-.353L6 6.707l-2.98 2.98-.353.353-.707-.707.353-.353L5.293 6l-2.98-2.98-.353-.353.707-.707.353.353L6 5.293l2.98-2.98.353-.353.707.707-.353.353L6.707 6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 89883:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 1.33333C1.63181 1.33333 1.33333 1.63181 1.33333 2V3.33333C1.33333 3.70152 1.03486 4 0.666667 4C0.298477 4 0 3.70152 0 3.33333V2C0 0.895431 0.895431 0 2 0H3.33333C3.70152 0 4 0.298477 4 0.666667C4 1.03486 3.70152 1.33333 3.33333 1.33333H2ZM8 0.666667C8 0.298477 8.29848 0 8.66667 0H10C11.1046 0 12 0.895431 12 2V3.33333C12 3.70152 11.7015 4 11.3333 4C10.9651 4 10.6667 3.70152 10.6667 3.33333V2C10.6667 1.63181 10.3682 1.33333 10 1.33333H8.66667C8.29848 1.33333 8 1.03486 8 0.666667ZM0.666667 8C1.03486 8 1.33333 8.29848 1.33333 8.66667V10C1.33333 10.3682 1.63181 10.6667 2 10.6667H3.33333C3.70152 10.6667 4 10.9651 4 11.3333C4 11.7015 3.70152 12 3.33333 12H2C0.895431 12 0 11.1046 0 10V8.66667C0 8.29848 0.298477 8 0.666667 8ZM11.3333 8C11.7015 8 12 8.29848 12 8.66667V10C12 11.1046 11.1046 12 10 12H8.66667C8.29848 12 8 11.7015 8 11.3333C8 10.9651 8.29848 10.6667 8.66667 10.6667H10C10.3682 10.6667 10.6667 10.3682 10.6667 10V8.66667C10.6667 8.29848 10.9651 8 11.3333 8Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 23996:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M3.33329 11.3334C2.9651 11.3334 2.66663 11.6319 2.66663 12C2.66663 12.3682 2.9651 12.6667 3.33329 12.6667H4.66663C5.03482 12.6667 5.33329 12.3682 5.33329 12C5.33329 11.6319 5.03482 11.3334 4.66663 11.3334H3.33329Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M2.66663 8.00004C2.66663 7.63185 2.9651 7.33337 3.33329 7.33337H4.66663C5.03482 7.33337 5.33329 7.63185 5.33329 8.00004C5.33329 8.36823 5.03482 8.66671 4.66663 8.66671H3.33329C2.9651 8.66671 2.66663 8.36823 2.66663 8.00004Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M8.66663 12C8.66663 11.6319 8.9651 11.3334 9.33329 11.3334C9.70148 11.3334 9.99996 11.6319 9.99996 12C9.99996 12.3682 9.70148 12.6667 9.33329 12.6667C8.9651 12.6667 8.66663 12.3682 8.66663 12Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M11.3333 11.3334C10.9651 11.3334 10.6666 11.6319 10.6666 12C10.6666 12.3682 10.9651 12.6667 11.3333 12.6667H12C12.3681 12.6667 12.6666 12.3682 12.6666 12C12.6666 11.6319 12.3681 11.3334 12 11.3334H11.3333Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M9.33329 7.33337C8.9651 7.33337 8.66663 7.63185 8.66663 8.00004C8.66663 8.36823 8.9651 8.66671 9.33329 8.66671C9.70148 8.66671 9.99996 8.36823 9.99996 8.00004C9.99996 7.63185 9.70148 7.33337 9.33329 7.33337Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M10.6666 8.00004C10.6666 7.63185 10.9651 7.33337 11.3333 7.33337H12C12.3681 7.33337 12.6666 7.63185 12.6666 8.00004C12.6666 8.36823 12.3681 8.66671 12 8.66671H11.3333C10.9651 8.66671 10.6666 8.36823 10.6666 8.00004Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M8.66663 4.00004C8.66663 3.63185 8.9651 3.33337 9.33329 3.33337C9.70148 3.33337 9.99996 3.63185 9.99996 4.00004C9.99996 4.36823 9.70148 4.66671 9.33329 4.66671C8.9651 4.66671 8.66663 4.36823 8.66663 4.00004Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M11.3333 3.33337C10.9651 3.33337 10.6666 3.63185 10.6666 4.00004C10.6666 4.36823 10.9651 4.66671 11.3333 4.66671H12C12.3681 4.66671 12.6666 4.36823 12.6666 4.00004C12.6666 3.63185 12.3681 3.33337 12 3.33337H11.3333Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M3.33329 3.33337C2.9651 3.33337 2.66663 3.63185 2.66663 4.00004C2.66663 4.36823 2.9651 4.66671 3.33329 4.66671H4.66663C5.03482 4.66671 5.33329 4.36823 5.33329 4.00004C5.33329 3.63185 5.03482 3.33337 4.66663 3.33337H3.33329Z\" fill=\"black\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.666626 3.33337C0.666626 2.2288 1.56206 1.33337 2.66663 1.33337H13.3333C14.4379 1.33337 15.3333 2.2288 15.3333 3.33337V12.6667C15.3333 13.7713 14.4379 14.6667 13.3333 14.6667H2.66663C1.56206 14.6667 0.666626 13.7713 0.666626 12.6667V3.33337ZM1.99996 10.6667V12.6667C1.99996 13.0349 2.29844 13.3334 2.66663 13.3334H5.99996V10.6667H1.99996ZM5.99996 9.33337H1.99996V6.66671H5.99996V9.33337ZM7.33329 13.3334H13.3333C13.7015 13.3334 14 13.0349 14 12.6667V10.6667H7.33329V13.3334ZM14 9.33337H7.33329V6.66671H14V9.33337ZM7.33329 5.33337H14V3.33337C14 2.96518 13.7015 2.66671 13.3333 2.66671L7.33329 2.66671V5.33337ZM1.99996 5.33337H5.99996V2.66671H2.66663C2.29844 2.66671 1.99996 2.96518 1.99996 3.33337V5.33337Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 28824:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"22","height":"23","viewBox":"0 0 22 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<rect x=\"0.5\" y=\"1\" width=\"21\" height=\"21\" rx=\"1.5\" fill=\"url(#paint0_linear_7154_6246)\"/>   <path d=\"M11.3164 6.4082L7.49316 17.5H5.18164L9.99805 4.70312H11.4746L11.3164 6.4082ZM14.5156 17.5L10.6836 6.4082L10.5166 4.70312H12.002L16.8359 17.5H14.5156ZM14.3311 12.7539V14.5029H7.37012V12.7539H14.3311Z\" fill=\"url(#paint1_linear_7154_6246)\"/>   <rect class=\"graphic_stroke\" x=\"0.5\" y=\"1\" width=\"21\" height=\"21\" rx=\"1.5\" stroke=\"#505050\"/>   <defs>   <linearGradient id=\"paint0_linear_7154_6246\" x1=\"22\" y1=\"4.77778\" x2=\"4.18548e-07\" y2=\"4.77778\" gradientUnits=\"userSpaceOnUse\">   <stop offset=\"0.411458\" stop-color=\"#505050\"/>   <stop offset=\"0.494792\"/>   <stop offset=\"0.494892\" stop-color=\"white\"/>   </linearGradient>   <linearGradient id=\"paint1_linear_7154_6246\" x1=\"2.38462\" y1=\"9\" x2=\"20\" y2=\"9\" gradientUnits=\"userSpaceOnUse\">   <stop offset=\"0.411458\" stop-color=\"#505050\"/>   <stop offset=\"0.494792\"/>   <stop offset=\"0.494892\" stop-color=\"white\"/>   </linearGradient>   </defs>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 41286:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12 4H7a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9h-5a1 1 0 0 1-1-1V4zm8 5.008V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h5.992L20 9.008zM14 8V5.414L16.586 8H14zm-6 9a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1zm1-5a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2H9z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 91177:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path fill=\"#00A1B7\" d=\"M7.493 11.87a.997.997 0 0 1-1.105-.079L2.4 8.8a1 1 0 1 1 1.2-1.6l3.306 2.48 6.387-6.387a1 1 0 0 1 1.414 1.414l-6.99 6.99a.993.993 0 0 1-.224.173z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 99635:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M7.493 11.87a.997.997 0 0 1-1.105-.079L2.4 8.8a1 1 0 1 1 1.2-1.6l3.306 2.48 6.387-6.387a1 1 0 0 1 1.414 1.414l-6.99 6.99a.993.993 0 0 1-.224.173z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 27317:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.0002 1.33331C8.36839 1.33331 8.66687 1.63179 8.66687 1.99998L8.66688 9.72383L12.1955 6.19524C12.4558 5.93489 12.8779 5.93489 13.1383 6.19524C13.3986 6.45559 13.3986 6.8777 13.1383 7.13805L8.47386 11.8025C8.46681 11.8096 8.4596 11.8165 8.45223 11.8233C8.39454 11.8766 8.32973 11.9179 8.26102 11.947C8.18149 11.9809 8.09403 11.9997 8.00221 12L8.00021 12L7.99405 12C7.90806 11.9992 7.82595 11.9821 7.75066 11.9517C7.66991 11.9192 7.59424 11.8702 7.5288 11.8047L2.86213 7.13805C2.60178 6.8777 2.60178 6.45559 2.86213 6.19524C3.12248 5.93489 3.54459 5.93489 3.80494 6.19524L7.33355 9.72385L7.33354 1.99998C7.33354 1.63179 7.63201 1.33331 8.0002 1.33331ZM3.33354 13.3333C2.96535 13.3333 2.66687 13.6318 2.66687 14C2.66687 14.3682 2.96535 14.6666 3.33354 14.6666L12.6669 14.6666C13.0351 14.6666 13.3335 14.3682 13.3335 14C13.3335 13.6318 13.0351 13.3333 12.6669 13.3333L3.33354 13.3333Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 97393:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"15","height":"14","viewBox":"0 0 15 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<mask id=\"path-1-outside-1\" maskUnits=\"userSpaceOnUse\" x=\"0.323242\" y=\"0.25\" width=\"14\" height=\"14\" fill=\"black\">   <rect fill=\"white\" x=\"0.323242\" y=\"0.25\" width=\"14\" height=\"14\"/>   <path d=\"M1.32324 10.6322V12.6043C1.32324 12.786 1.46596 12.9287 1.64761 12.9287H3.61974C3.70407 12.9287 3.78841 12.8963 3.8468 12.8314L10.9309 5.75376L8.49818 3.32103L1.42055 10.3987C1.35568 10.4635 1.32324 10.5414 1.32324 10.6322ZM12.8122 3.87245C12.8724 3.81243 12.9201 3.74114 12.9526 3.66266C12.9852 3.58419 13.0019 3.50006 13.0019 3.41509C13.0019 3.33013 12.9852 3.246 12.9526 3.16752C12.9201 3.08905 12.8724 3.01776 12.8122 2.95774L11.2942 1.43972C11.2342 1.37958 11.1629 1.33186 11.0844 1.29931C11.0059 1.26676 10.9218 1.25 10.8368 1.25C10.7519 1.25 10.6677 1.26676 10.5893 1.29931C10.5108 1.33186 10.4395 1.37958 10.3795 1.43972L9.19232 2.62689L11.625 5.05962L12.8122 3.87245Z\"/>   </mask>   <path class=\"graphic\" d=\"M3.8468 12.8314L3.14001 12.124C3.1275 12.1365 3.11533 12.1493 3.1035 12.1624L3.8468 12.8314ZM10.9309 5.75376L11.6377 6.46119C11.8254 6.27368 11.9308 6.01928 11.9309 5.75399C11.931 5.48869 11.8256 5.23425 11.638 5.04665L10.9309 5.75376ZM8.49818 3.32103L9.20528 2.61392C9.01775 2.42639 8.76339 2.32103 8.49818 2.32103C8.23296 2.32103 7.97861 2.42639 7.79107 2.61392L8.49818 3.32103ZM1.42055 10.3987L2.12766 11.1058L1.42055 10.3987ZM12.8122 2.95774L12.1051 3.66485L12.1058 3.66557L12.8122 2.95774ZM11.2942 1.43972L10.5864 2.1461L10.5871 2.14682L11.2942 1.43972ZM10.8368 1.25V0.25V1.25ZM10.3795 1.43972L11.0866 2.14682L11.0873 2.1461L10.3795 1.43972ZM9.19232 2.62689L8.48521 1.91978C8.09469 2.31031 8.09469 2.94347 8.48521 3.334L9.19232 2.62689ZM11.625 5.05962L10.9179 5.76673C11.1055 5.95426 11.3598 6.05962 11.625 6.05962C11.8903 6.05962 12.1446 5.95426 12.3322 5.76673L11.625 5.05962ZM0.323242 10.6322V12.6043H2.32324V10.6322H0.323242ZM0.323242 12.6043C0.323242 13.3383 0.913678 13.9287 1.64761 13.9287V11.9287C2.01825 11.9287 2.32324 12.2337 2.32324 12.6043H0.323242ZM1.64761 13.9287H3.61974V11.9287H1.64761V13.9287ZM3.61974 13.9287C3.95128 13.9287 4.31908 13.8015 4.59009 13.5003L3.1035 12.1624C3.25774 11.991 3.45687 11.9287 3.61974 11.9287V13.9287ZM4.55358 13.5388L11.6377 6.46119L10.2241 5.04633L3.14001 12.124L4.55358 13.5388ZM11.638 5.04665L9.20528 2.61392L7.79107 4.02814L10.2238 6.46087L11.638 5.04665ZM7.79107 2.61392L0.713445 9.69155L2.12766 11.1058L9.20528 4.02814L7.79107 2.61392ZM0.713445 9.69155C0.463178 9.94181 0.323242 10.2731 0.323242 10.6322H2.32324C2.32324 10.7086 2.30901 10.7982 2.27065 10.8903C2.23237 10.9822 2.17941 11.054 2.12766 11.1058L0.713445 9.69155ZM13.5186 4.58028C13.6718 4.42738 13.7934 4.24576 13.8763 4.04582L12.0289 3.27951C12.0468 3.23653 12.0729 3.19749 12.1058 3.16462L13.5186 4.58028ZM13.8763 4.04582C13.9592 3.84588 14.0019 3.63155 14.0019 3.41509H12.0019C12.0019 3.36856 12.0111 3.32249 12.0289 3.27951L13.8763 4.04582ZM14.0019 3.41509C14.0019 3.19864 13.9592 2.9843 13.8763 2.78437L12.0289 3.55068C12.0111 3.5077 12.0019 3.46163 12.0019 3.41509H14.0019ZM13.8763 2.78437C13.7934 2.58443 13.6718 2.40281 13.5186 2.24991L12.1058 3.66557C12.0729 3.6327 12.0468 3.59366 12.0289 3.55068L13.8763 2.78437ZM13.5193 2.25063L12.0013 0.73261L10.5871 2.14682L12.1051 3.66485L13.5193 2.25063ZM12.002 0.733335C11.8491 0.58012 11.6675 0.458565 11.4676 0.375628L10.7013 2.22299C10.6583 2.20517 10.6192 2.17903 10.5864 2.1461L12.002 0.733335ZM11.4676 0.375628C11.2676 0.29269 11.0533 0.25 10.8368 0.25V2.25C10.7903 2.25 10.7442 2.24082 10.7013 2.22299L11.4676 0.375628ZM10.8368 0.25C10.6204 0.25 10.4061 0.29269 10.2061 0.375628L10.9724 2.22299C10.9294 2.24082 10.8834 2.25 10.8368 2.25V0.25ZM10.2061 0.375628C10.0062 0.458565 9.82456 0.58012 9.67166 0.733335L11.0873 2.1461C11.0545 2.17903 11.0154 2.20517 10.9724 2.22299L10.2061 0.375628ZM9.67238 0.73261L8.48521 1.91978L9.89942 3.334L11.0866 2.14682L9.67238 0.73261ZM8.48521 3.334L10.9179 5.76673L12.3322 4.35251L9.89942 1.91978L8.48521 3.334ZM12.3322 5.76673L13.5193 4.57955L12.1051 3.16534L10.9179 4.35251L12.3322 5.76673Z\" fill=\"#161616\" mask=\"url(#path-1-outside-1)\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 13783:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" fill-rule=\"nonzero\" d=\"M5.544 13.474L2.5 10.451l9.086-8.865a2 2 0 0 1 2.828 2.828l-8.87 9.06zM2 11l3 3H2z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 55782:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12 3a1 1 0 0 1 1 1v1h5a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-5v1a1 1 0 0 1-2 0v-1H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h5V4a1 1 0 0 1 1-1zm0 14h6a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 47529:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M20 3a1 1 0 0 1 1 1v16a1 1 0 0 1-2 0v-1.171A2.983 2.983 0 0 1 18 19H6c-.351 0-.687-.06-1-.171V20a1 1 0 0 1-2 0V4a1 1 0 0 1 2 0v1.171A2.983 2.983 0 0 1 6 5h12c.351 0 .687.06 1 .171V4a1 1 0 0 1 1-1zM5 8v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 54970:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M5 4a1 1 0 0 0-2 0v16a1 1 0 0 0 2 0V4zm5 1a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3h-8zM9 8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V8z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 51093:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M21 4a1 1 0 0 0-2 0v16a1 1 0 0 0 2 0V4zM6 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H6zM5 8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V8z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 99474:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<rect class=\"graphic\" width=\"11\" height=\"11\" rx=\"1\" fill=\"#5C6061\"/>   <path class=\"graphic_stroke_bg\" d=\"M4.5 3L2 5.5L4.5 8\" stroke=\"white\"/>   <path class=\"graphic_stroke_bg\" d=\"M6.5 3L9 5.5L6.5 8\" stroke=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 26258:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"8","viewBox":"0 0 14 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.18725 1.08312C4.41726 0.795615 4.37064 0.376087 4.08313 0.146081C3.79563 -0.0839249 3.3761 -0.0373104 3.14609 0.250198L0.487778 3.57309C0.450835 3.61733 0.420376 3.66551 0.396556 3.71628C0.354065 3.80646 0.333253 3.90345 0.333313 4C0.333253 4.09654 0.354066 4.19353 0.396557 4.28371C0.420375 4.33447 0.450831 4.38266 0.48777 4.42689L3.14609 7.74979C3.3761 8.0373 3.79563 8.08391 4.08313 7.85391C4.37064 7.6239 4.41726 7.20437 4.18725 6.91686L1.85376 4L4.18725 1.08312ZM10.8539 0.250197C10.6239 -0.0373106 10.2044 -0.0839248 9.91687 0.146081C9.62937 0.376088 9.58275 0.795616 9.81276 1.08312L12.1463 3.99999L9.81276 6.91686C9.58275 7.20437 9.62937 7.6239 9.91687 7.85391C10.2044 8.08391 10.6239 8.0373 10.8539 7.74979L13.5123 4.42677C13.5485 4.38342 13.5785 4.33628 13.6021 4.28663C13.6455 4.19563 13.6668 4.09758 13.6667 3.99999C13.6668 3.90241 13.6455 3.80436 13.6021 3.71336C13.5785 3.66371 13.5485 3.61656 13.5123 3.57321L10.8539 0.250197Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 80648:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"28","viewBox":"0 0 36 28"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h36v28H0z\"/>         <rect class=\"graphic\" width=\"32\" height=\"26\" x=\"2\" y=\"1\" fill=\"#9DA5A6\" rx=\"2\"/>         <rect class=\"grachic-background\" width=\"30\" height=\"24\" x=\"3\" y=\"2\" fill=\"#FFF\" rx=\"1\"/>         <path class=\"graphic\" fill=\"#9DA5A6\" fill-rule=\"nonzero\" d=\"M18.75 18.833l-2.395 3.222a1 1 0 1 1-1.605-1.193l.907-1.22a2.006 2.006 0 0 1-.064-.055s-3.02-2.673-3.024-2.668L7.744 22.29a1 1 0 0 1-1.488-1.336l4.826-5.372a2.013 2.013 0 0 1 2.825-.169l2.945 2.618.296-.395.928-1.248a1.01 1.01 0 0 1 .077-.092l3.45-4.6a1.88 1.88 0 0 1 2.812-.25l6.264 5.796a1 1 0 1 1-1.358 1.468l-6.186-5.723-4.385 5.846zM10 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 91027:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 47346:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M1.58755 6.14294C1.87625 5.91558 2.29436 5.96478 2.52245 6.25257L2.52342 6.2538C2.52359 6.25401 2.52376 6.25424 2 6.66669L1.47625 7.07915C1.24845 6.78989 1.29828 6.37073 1.58755 6.14294Z\" fill=\"currentColor\"></path> \t<path d=\"M9.47877 9.87784C9.01604 9.95562 8.52288 10 8 10C7.47713 10 6.98397 9.95562 6.52124 9.87784L5.96579 11.5442C5.84936 11.8935 5.47181 12.0822 5.12252 11.9658C4.77322 11.8494 4.58445 11.4718 4.70088 11.1225L5.22344 9.55486C4.60376 9.34849 4.05847 9.08881 3.59023 8.81654L2.5547 10.3698C2.35047 10.6762 1.93656 10.759 1.6302 10.5547C1.32385 10.3505 1.24107 9.93658 1.4453 9.63023L2.49117 8.06143C2.26463 7.87906 2.0757 7.70812 1.92497 7.56196C1.78355 7.42483 1.67517 7.30893 1.60034 7.22504C1.56291 7.18308 1.53382 7.14905 1.51313 7.12431C1.50278 7.11194 1.49453 7.10188 1.48838 7.0943L1.48074 7.08481L1.4781 7.08149L1.47707 7.0802L1.47625 7.07915C1.47605 7.0789 1.47625 7.07915 2 6.66669L2.52342 6.2538L2.52391 6.25439L2.53595 6.26897C2.54793 6.28329 2.56776 6.30656 2.59537 6.33751C2.65062 6.39946 2.73677 6.49189 2.85316 6.60476C3.08633 6.83086 3.43844 7.13659 3.90413 7.44322C4.83433 8.0557 6.20884 8.66669 8 8.66669C9.79117 8.66669 11.1657 8.0557 12.0959 7.44322C12.5616 7.13659 12.9137 6.83086 13.1468 6.60476C13.2632 6.49189 13.3494 6.39946 13.4046 6.33751C13.4322 6.30656 13.4521 6.28329 13.4641 6.26897L13.4761 6.25439L13.4766 6.2538L13.4775 6.25261C13.7056 5.96479 14.1237 5.91557 14.4125 6.14294C14.7017 6.37073 14.7516 6.78989 14.5238 7.07915L14.031 6.69109C14.5238 7.07916 14.524 7.07891 14.5238 7.07915L14.5229 7.0802L14.5219 7.08149L14.5193 7.08481L14.5116 7.0943C14.5055 7.10188 14.4972 7.11194 14.4869 7.12431C14.4662 7.14905 14.4371 7.18308 14.3997 7.22504C14.3248 7.30893 14.2165 7.42483 14.075 7.56196C13.9243 7.70812 13.7354 7.87906 13.5088 8.06143L14.5547 9.63023C14.7589 9.93658 14.6762 10.3505 14.3698 10.5547C14.0635 10.759 13.6495 10.6762 13.4453 10.3698L12.4098 8.81654C11.9415 9.08881 11.3963 9.34849 10.7766 9.55486L11.2991 11.1225C11.4156 11.4718 11.2268 11.8494 10.8775 11.9658C10.5282 12.0822 10.1506 11.8935 10.0342 11.5442L9.47877 9.87784Z\" fill=\"currentColor\"></path>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 75259:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"17","height":"16","viewBox":"0 0 17 16","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.50004 5.3335C7.02728 5.3335 5.83338 6.5274 5.83338 8.00016C5.83338 9.47292 7.02728 10.6668 8.50004 10.6668C9.9728 10.6668 11.1667 9.47292 11.1667 8.00016C11.1667 6.5274 9.9728 5.3335 8.50004 5.3335ZM7.16671 8.00016C7.16671 7.26378 7.76366 6.66683 8.50004 6.66683C9.23642 6.66683 9.83338 7.26378 9.83338 8.00016C9.83338 8.73654 9.23642 9.3335 8.50004 9.3335C7.76366 9.3335 7.16671 8.73654 7.16671 8.00016Z\" fill=\"currentColor\"></path> \t<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.0545 7.63C15.0546 7.63019 15.0547 7.63036 14.5 8.00016C15.0547 8.36996 15.0546 8.37013 15.0545 8.37032L15.0534 8.37195L15.0511 8.37539L15.0435 8.38655C15.0372 8.39586 15.0283 8.40888 15.0169 8.42535C14.994 8.45829 14.961 8.50509 14.9184 8.56377C14.8332 8.68107 14.7093 8.84625 14.5505 9.04338C14.2337 9.43662 13.7739 9.96229 13.2022 10.49C12.082 11.5241 10.4231 12.6668 8.50004 12.6668C6.57701 12.6668 4.91814 11.5241 3.79786 10.49C3.22614 9.96229 2.7664 9.43662 2.44962 9.04338C2.29082 8.84625 2.16688 8.68107 2.0817 8.56377C2.03909 8.50509 2.0061 8.45829 1.98322 8.42535C1.97179 8.40888 1.96287 8.39586 1.95654 8.38655L1.94898 8.37539L1.94667 8.37195L1.94588 8.37077C1.94576 8.37059 1.94534 8.36996 2.50004 8.00016C1.94534 7.63036 1.94546 7.63019 1.94558 7.63L1.94667 7.62838L1.94898 7.62494L1.95654 7.61377C1.96287 7.60446 1.97179 7.59145 1.98322 7.57498C2.0061 7.54204 2.03909 7.49524 2.0817 7.43656C2.16688 7.31926 2.29082 7.15408 2.44962 6.95694C2.7664 6.5637 3.22614 6.03803 3.79786 5.51029C4.91814 4.47619 6.57701 3.3335 8.50004 3.3335C10.4231 3.3335 12.082 4.47619 13.2022 5.51029C13.7739 6.03803 14.2337 6.5637 14.5505 6.95694C14.7093 7.15408 14.8332 7.31926 14.9184 7.43656C14.961 7.49524 14.994 7.54204 15.0169 7.57498C15.0283 7.59145 15.0372 7.60446 15.0435 7.61377L15.0511 7.62494L15.0534 7.62838L15.0545 7.63ZM3.48796 8.20694C3.42779 8.13225 3.37342 8.06295 3.32512 8.00016C3.37342 7.93738 3.42779 7.86807 3.48796 7.79338C3.77535 7.43662 4.19061 6.96229 4.70223 6.49003C5.74862 5.52414 7.08975 4.66683 8.50004 4.66683C9.91034 4.66683 11.2515 5.52414 12.2979 6.49003C12.8095 6.96229 13.2247 7.43662 13.5121 7.79338C13.5723 7.86807 13.6267 7.93738 13.675 8.00016C13.6267 8.06295 13.5723 8.13225 13.5121 8.20694C13.2247 8.5637 12.8095 9.03803 12.2979 9.51029C11.2515 10.4762 9.91034 11.3335 8.50004 11.3335C7.08975 11.3335 5.74862 10.4762 4.70223 9.51029C4.19061 9.03803 3.77535 8.5637 3.48796 8.20694Z\" fill=\"currentColor\"></path> \t<path d=\"M14.5 8.00016L15.0545 7.63C15.2038 7.85394 15.2038 8.14639 15.0545 8.37032L14.5 8.00016Z\" fill=\"currentColor\" fill-opacity=\"0.54\"></path><path d=\"M1.94558 7.63L2.50004 8.00016L1.94534 8.36996C1.79605 8.14603 1.79629 7.85394 1.94558 7.63Z\" fill=\"currentColor\"></path>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 84581:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<path class=\"graphic\" fill=\"#5C6061\" fill-rule=\"evenodd\" d=\"M5 2.667c-1.971 0-3.667 1.648-3.667 3.791 0 1.909.526 3.003 1.986 4.524.166.173.36.35.578.533.384.32.844.651 1.364.991a28.457 28.457 0 0 0 2.435 1.42c.19.098.417.098.608 0l.213-.111a30.197 30.197 0 0 0 2.222-1.308c.52-.34.98-.673 1.364-.992.219-.182.412-.36.578-.533 1.46-1.52 1.986-2.615 1.986-4.524 0-2.143-1.696-3.791-3.667-3.791-1.035 0-2.156.456-3 1.12-.844-.664-1.965-1.12-3-1.12zm3.49 2.466C9.116 4.493 10.146 4 11 4c1.243 0 2.333 1.06 2.333 2.458 0 1.53-.374 2.31-1.614 3.601a5.78 5.78 0 0 1-.47.431c-.34.283-.76.586-1.24.9A27.154 27.154 0 0 1 8 12.58a29.668 29.668 0 0 1-2.01-1.19c-.48-.314-.9-.617-1.24-.9a5.78 5.78 0 0 1-.47-.43C3.042 8.767 2.668 7.986 2.668 6.457 2.667 5.06 3.757 4 5 4c.854 0 1.884.494 2.51 1.133a.665.665 0 0 0 .49.2.665.665 0 0 0 .49-.2z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 23953:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M14 4C14 2.89543 13.1046 2 12 2H4C2.89543 2 2 2.89543 2 4V9.33333C2 10.4379 2.89543 11.3333 4 11.3333V13.3333C4 13.5896 4.1469 13.8232 4.37787 13.9342C4.60885 14.0452 4.88302 14.014 5.08313 13.8539L8.05124 11.4794C8.16945 11.3849 8.31633 11.3333 8.46771 11.3333H12C13.1046 11.3333 14 10.4379 14 9.33333V4ZM12 3.33333C12.3682 3.33333 12.6667 3.63181 12.6667 4V9.33333C12.6667 9.70152 12.3682 10 12 10H8.46771C8.01357 10 7.57294 10.1546 7.21832 10.4383L5.33333 11.9463V10.6667C5.33333 10.2985 5.03486 10 4.66667 10H4C3.63181 10 3.33333 9.70152 3.33333 9.33333V4C3.33333 3.63181 3.63181 3.33333 4 3.33333H12Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 83763:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M4 4C4 5.10457 4.89543 6 6 6H8V2H6C4.89543 2 4 2.89543 4 4Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M8 2V6H10C11.1046 6 12 5.10457 12 4C12 2.89543 11.1046 2 10 2H8Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M4 8C4 6.89543 4.89543 6 6 6H8V10H6C4.89543 10 4 9.10457 4 8Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M4 12C4 10.8954 4.89543 10 6 10H8V12C8 13.1046 7.10457 14 6 14C4.89543 14 4 13.1046 4 12Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M8 8C8 6.89543 8.89543 6 10 6C11.1046 6 12 6.89543 12 8C12 9.10457 11.1046 10 10 10C8.89543 10 8 9.10457 8 8Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 42020:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<g id=\"file-check-alt-svgrepo-com 1\"> <path id=\"Vector\" d=\"M10.0002 12.6667L11.3335 14L14.0002 11.3333M8.66683 2H5.46683C4.7201 2 4.34672 2 4.06151 2.14533C3.81062 2.27315 3.60665 2.47713 3.47882 2.72801C3.3335 3.01323 3.3335 3.3866 3.3335 4.13333V11.8667C3.3335 12.6134 3.3335 12.9868 3.47882 13.272C3.60665 13.5229 3.81062 13.7269 4.06151 13.8547C4.34672 14 4.7201 14 5.46683 14H7.66683M8.66683 2L12.6668 6M8.66683 2V4.93333C8.66683 5.3067 8.66683 5.49339 8.7395 5.63599C8.80343 5.76143 8.90536 5.86342 9.03083 5.92734C9.17343 6 9.3601 6 9.7335 6H12.6668M12.6668 6V8.93333M6.00016 11.3333H7.66683M6.00016 8.66667H10.0002M6.00016 6H6.66683\" stroke=\"#737373\" stroke-width=\"1.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/> </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 62012:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M5.33329 11.3334C5.33329 10.9652 5.63177 10.6667 5.99996 10.6667H9.99996C10.3681 10.6667 10.6666 10.9652 10.6666 11.3334C10.6666 11.7016 10.3681 12 9.99996 12H5.99996C5.63177 12 5.33329 11.7016 5.33329 11.3334Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M5.99996 8.00004C5.63177 8.00004 5.33329 8.29852 5.33329 8.66671C5.33329 9.0349 5.63177 9.33337 5.99996 9.33337H9.99996C10.3681 9.33337 10.6666 9.0349 10.6666 8.66671C10.6666 8.29852 10.3681 8.00004 9.99996 8.00004H5.99996Z\" fill=\"black\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.3333 6.00531V12.6667C13.3333 13.7713 12.4379 14.6667 11.3333 14.6667H4.66663C3.56206 14.6667 2.66663 13.7713 2.66663 12.6667V3.33337C2.66663 2.2288 3.56206 1.33337 4.66663 1.33337H8.66139L13.3333 6.00531ZM7.99996 2.66671H4.66663C4.29844 2.66671 3.99996 2.96518 3.99996 3.33337V12.6667C3.99996 13.0349 4.29844 13.3334 4.66663 13.3334H11.3333C11.7015 13.3334 12 13.0349 12 12.6667V6.66671H8.66663C8.29844 6.66671 7.99996 6.36823 7.99996 6.00004V2.66671ZM9.33329 5.33337V3.60952L11.0571 5.33337H9.33329Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 51392:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M6 5a1 1 0 0 1 1-1h1v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-.586l3.707 3.707a1 1 0 0 1 .293.707V19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5zm6-1h-2v2h2V4zM7 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V9.828a3 3 0 0 0-.879-2.121l-4.828-4.828A3 3 0 0 0 12.172 2H7zm3 12a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm-1-3a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 7086:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M11.522 4.72a4.433 4.433 0 0 1 6.269 6.269l-4.924 4.925-.886.885a2.745 2.745 0 1 1-3.882-3.882l4.595-4.595a1 1 0 1 1 1.414 1.415L9.513 14.33a.746.746 0 0 0 1.054 1.054l.219-.22a.015.015 0 0 0 .004-.003l5.587-5.587a2.433 2.433 0 0 0-3.44-3.44l-.487.486-5.443 5.443a3.667 3.667 0 0 0 0 5.186l.454.454a3.667 3.667 0 0 0 5.186 0l4.714-4.714a1 1 0 1 1 1.414 1.414l-4.714 4.714a5.667 5.667 0 0 1-8.014 0l-.454-.454a5.667 5.667 0 0 1 0-8.014l5.443-5.443.486-.487z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 80124:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.25 4.5C2.25 4.08579 2.58579 3.75 3 3.75H15C15.4142 3.75 15.75 4.08579 15.75 4.5C15.75 4.91421 15.4142 5.25 15 5.25H3C2.58579 5.25 2.25 4.91421 2.25 4.5ZM5.25 9C5.25 8.58579 5.58579 8.25 6 8.25H12C12.4142 8.25 12.75 8.58579 12.75 9C12.75 9.41421 12.4142 9.75 12 9.75H6C5.58579 9.75 5.25 9.41421 5.25 9ZM8.25 12.75C7.83579 12.75 7.5 13.0858 7.5 13.5C7.5 13.9142 7.83579 14.25 8.25 14.25H10.5C10.9142 14.25 11.25 13.9142 11.25 13.5C11.25 13.0858 10.9142 12.75 10.5 12.75H8.25Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 32472:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6.667a2 2 0 0 0-2-2H9L7.6 2.8A2 2 0 0 0 6 2H4zm3.333 2.667l-.8-1.067A.667.667 0 0 0 6 3.333H4A.667.667 0 0 0 3.333 4v.667h4zm-4 7.333V6H12c.368 0 .667.298.667.667V12a.667.667 0 0 1-.667.667H4A.667.667 0 0 1 3.333 12z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 89129:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"20","height":"18","viewBox":"0 0 20 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 0C5.55228 0 6 0.447715 6 1V2H14V1C14 0.447715 14.4477 0 15 0C15.5523 0 16 0.447715 16 1V2H17C18.6569 2 20 3.34315 20 5V13C20 14.6569 18.6569 16 17 16H16V17C16 17.5523 15.5523 18 15 18C14.4477 18 14 17.5523 14 17V16H6V17C6 17.5523 5.55228 18 5 18C4.44772 18 4 17.5523 4 17V16H3C1.34315 16 0 14.6569 0 13V5C0 3.34315 1.34315 2 3 2H4V1C4 0.447715 4.44772 0 5 0ZM17 14C17.5523 14 18 13.5523 18 13V5C18 4.44772 17.5523 4 17 4H3C2.44772 4 2 4.44772 2 5V13C2 13.5523 2.44772 14 3 14H17Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 71492:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"9","viewBox":"0 0 11 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M7.40109 4.92674C6.97185 4.92674 6.62391 5.36322 6.62391 5.89976C6.62391 6.43738 6.97185 6.87386 7.40109 6.87386C7.83033 6.87386 8.17826 6.43738 8.17826 5.89976C8.17766 5.36322 7.83033 4.92674 7.40109 4.92674ZM10.1068 2.39387C10.1959 2.19645 10.1995 1.0747 9.72723 0C9.72723 0 8.64456 0.107632 7.00652 1.125C6.66277 1.03846 6.08109 0.996274 5.5006 0.996274C4.91891 0.996274 4.33783 1.03846 3.99408 1.125C2.35543 0.107632 1.27277 0 1.27277 0C0.801087 1.0747 0.80587 2.19645 0.89375 2.39387C0.338967 2.93906 0 3.59405 0 4.48756C0 8.37422 3.56484 8.43642 4.46397 8.43642L5.5006 8.4375L6.53603 8.43642C7.43636 8.43642 11 8.37422 11 4.48756C11 3.59405 10.6616 2.93906 10.1068 2.39387ZM5.51674 7.95884H5.48326C3.22886 7.95884 1.47245 7.71599 1.47245 5.73317C1.47245 5.25775 1.65777 4.81749 2.09837 4.45186C2.8319 3.84231 4.07418 4.16466 5.48326 4.16466H5.51674C6.92581 4.16466 8.1687 3.84231 8.90283 4.45186C9.34223 4.81749 9.52755 5.25775 9.52755 5.73317C9.52755 7.71599 7.77174 7.95884 5.51674 7.95884ZM3.59951 4.92674C3.17027 4.92674 2.82234 5.36322 2.82234 5.89976C2.82234 6.43738 3.17027 6.87386 3.59951 6.87386C4.02935 6.87386 4.37728 6.43738 4.37728 5.89976C4.37728 5.36322 4.02935 4.92674 3.59951 4.92674Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 55551:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 0.666656H4L8 7.33332H11.6667L8 0.666656ZM5.66667 4.99999L3.66667 1.66666L0 7.99999L2 11.3333L5.66667 4.99999ZM12 7.99999H4.66667L2.66667 11.3333H10.3333L12 7.99999Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 517:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"12","viewBox":"0 0 11 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M7.23684 2.78571C7.23684 3.08571 7.35263 3.34286 7.57263 3.55179C7.78684 3.76071 8.05895 3.85714 8.39474 3.85714C8.71316 3.85714 8.97368 3.76071 9.21105 3.55179C9.43684 3.34286 9.55263 3.08571 9.55263 2.78571C9.55263 2.50179 9.43684 2.25 9.19947 2.03036C8.97368 1.81607 8.68421 1.71429 8.39474 1.71429C8.07632 1.71429 7.81579 1.81607 7.58421 2.03036C7.35842 2.25 7.23684 2.50179 7.23684 2.78571ZM11 2.78571C11 3.32143 10.7742 3.95893 10.34 4.69286C9.90579 5.43214 9.47158 6.03214 9.03737 6.50357L8.39474 7.20536C8.18632 7.00714 7.94316 6.74464 7.65368 6.42857C7.36421 6.10714 6.97632 5.55536 6.50158 4.76786C6.02105 3.98036 5.78947 3.32143 5.78947 2.78571C5.78947 2.11607 6.03263 1.54821 6.54211 1.07679C7.04579 0.610714 7.65947 0.375 8.39474 0.375C9.10684 0.375 9.72632 0.610714 10.23 1.07679C10.7395 1.54821 11 2.11607 11 2.78571ZM10.4211 6.57857V10.5536C10.4211 10.8214 10.3053 11.0893 10.0679 11.2982C9.8421 11.5179 9.55263 11.625 9.26316 11.625H1.15789C0.868421 11.625 0.578947 11.5179 0.353158 11.2982C0.115789 11.0893 0 10.8214 0 10.5536V3.05357C0 2.78571 0.115789 2.51786 0.353158 2.30893C0.578947 2.08929 0.868421 1.98214 1.15789 1.98214H4.74737C4.67789 2.31964 4.63158 2.5875 4.63158 2.78571C4.63158 3.42321 4.88632 4.17321 5.37263 5.03571C5.86474 5.89286 6.27579 6.53571 6.60579 6.91607C6.94737 7.3125 7.25421 7.65 7.54368 7.93393L8.39474 8.78571L9.26316 7.93393C9.99842 7.07143 10.3863 6.61071 10.4211 6.57857ZM3.47368 8.14286V8.8875H4.77632C4.63158 9.48214 4.19737 9.76607 3.47368 9.76607C3.07421 9.76607 2.73842 9.63214 2.47211 9.36429C2.20419 9.10924 2.05638 8.76637 2.06105 8.41071C2.06105 8.04107 2.2 7.725 2.47211 7.45714C2.73842 7.18929 3.07421 7.05536 3.47368 7.05536C3.85579 7.05536 4.16263 7.1625 4.39421 7.38214L5.01947 6.83036C4.58526 6.46071 4.08158 6.26786 3.50263 6.26786H3.47368C2.84263 6.26786 2.29842 6.4875 1.84684 6.90536C1.39526 7.32321 1.15789 7.82679 1.15789 8.41071C1.15789 8.99464 1.39526 9.49821 1.84684 9.91607C2.29842 10.3339 2.84263 10.5536 3.47368 10.5536C4.14526 10.5536 4.68368 10.3554 5.08895 9.96964C5.5 9.58393 5.69684 9.08036 5.69684 8.45893C5.69684 8.30893 5.69105 8.20179 5.67368 8.14286H3.47368Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 1305:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M6 5a1 1 0 0 0-2 0v14a1 1 0 0 0 2 0v-6h4v6a1 1 0 0 0 2 0V5a1 1 0 0 0-2 0v6H6V5zm9 7a1 1 0 0 1 1 1v5h3a1 1 0 0 1 0 2h-4a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 41701:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M5 4a1 1 0 0 1 1 1v6h4V5a1 1 0 0 1 2 0v14a1 1 0 0 1-2 0v-6H6v6a1 1 0 0 1-2 0V5a1 1 0 0 1 1-1zm16.371 8.071a.997.997 0 0 0-1.18.341L18 15.333l-2.193-2.924-.041-.052a.99.99 0 0 0-.711-.356 1.019 1.019 0 0 0-.698.233.99.99 0 0 0-.356.711l-.001.067V19a1 1 0 0 0 2 0v-3l1.186 1.581a.997.997 0 0 0 1.628 0L20 16v3a1 1 0 0 0 2 0v-5.985a.997.997 0 0 0-.629-.944z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 70191:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M6 5a1 1 0 0 0-2 0v14a1 1 0 0 0 2 0v-6h4v6a1 1 0 0 0 2 0V5a1 1 0 0 0-2 0v6H6V5zm11 7a1 1 0 0 0 0 2h.003a3 3 0 1 1-2.559 4.572 1 1 0 0 1 1.703-1.049A1 1 0 1 0 17 16h-.003a3 3 0 1 1 1.988-5.25 1.001 1.001 0 0 1-1.324 1.5A.994.994 0 0 0 17 12z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 81740:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M14.701 3.279a3 3 0 1 1 4.76 3.653L10.96 18.01a3 3 0 0 1-3.252 1.045L7 20h12a1 1 0 0 1 0 2H5a1 1 0 0 1-.794-1.609l1.891-2.52a3.002 3.002 0 0 1 .102-3.512l6.373-8.305L11.7 5.4 9.3 8.6a1 1 0 1 1-1.6-1.2l2.997-3.996.003-.004a1 1 0 0 1 1.4-.2l.002.001 1.687 1.266.912-1.188zM7.786 15.576l6.386-8.322 1.6 1.2-6.399 8.34a1 1 0 0 1-1.376.204l-.034-.026a1 1 0 0 1-.177-1.396zm10.089-9.862l-.885 1.153-1.6-1.2.898-1.17a1 1 0 1 1 1.587 1.217z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 82052:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M7.33337 5.33337C7.33337 4.96518 7.63185 4.66671 8.00004 4.66671C8.36823 4.66671 8.66671 4.96518 8.66671 5.33337V8.66671C8.66671 9.0349 8.36823 9.33337 8.00004 9.33337C7.63185 9.33337 7.33337 9.0349 7.33337 8.66671V5.33337Z\" fill=\"black\"/>     <path class=\"graphic\" d=\"M8.00004 10.6667C7.63185 10.6667 7.33337 10.9652 7.33337 11.3334C7.33337 11.7016 7.63185 12 8.00004 12C8.36823 12 8.66671 11.7016 8.66671 11.3334C8.66671 10.9652 8.36823 10.6667 8.00004 10.6667Z\" fill=\"black\"/>     <path class=\"graphic\" d=\"M1.33337 8.00004C1.33337 11.6819 4.31814 14.6667 8.00004 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8.00004C14.6667 4.31814 11.6819 1.33337 8.00004 1.33337C4.31814 1.33337 1.33337 4.31814 1.33337 8.00004ZM8.00004 13.3334C5.05452 13.3334 2.66671 10.9456 2.66671 8.00004C2.66671 5.05452 5.05452 2.66671 8.00004 2.66671C10.9456 2.66671 13.3334 5.05452 13.3334 8.00004C13.3334 10.9456 10.9456 13.3334 8.00004 13.3334Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 28444:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 0.666626C8.36819 0.666626 8.66667 0.965103 8.66667 1.33329V3.33329H10.3831C10.6982 3.33329 10.8374 3.73008 10.5913 3.92692L8.20823 5.83337C8.08649 5.93077 7.91351 5.93077 7.79177 5.83337L5.4087 3.92692C5.16265 3.73008 5.30183 3.33329 5.61693 3.33329H7.33333V1.33329C7.33333 0.965103 7.63181 0.666626 8 0.666626ZM2 7.99996C2 7.63177 2.29848 7.33329 2.66667 7.33329H13.3333C13.7015 7.33329 14 7.63177 14 7.99996C14 8.36815 13.7015 8.66663 13.3333 8.66663H2.66667C2.29848 8.66663 2 8.36815 2 7.99996ZM7.33333 12.6666H5.61693C5.30183 12.6666 5.16265 12.2698 5.4087 12.073L7.79177 10.1665C7.91351 10.0692 8.08649 10.0692 8.20823 10.1665L10.5913 12.073C10.8374 12.2698 10.6982 12.6666 10.3831 12.6666H8.66667V14.6666C8.66667 15.0348 8.36819 15.3333 8 15.3333C7.63181 15.3333 7.33333 15.0348 7.33333 14.6666V12.6666Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 91527:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.8047 7.5286C14.0651 7.78895 14.0651 8.21106 13.8047 8.4714L8.66588 13.3658C8.66579 13.3676 8.6657 13.3694 8.6656 13.3712L13.8047 8.4714L8.47141 13.8047C8.3428 13.9333 8.17471 13.9984 8.00615 14C8.0041 14 8.00205 14 8 14C7.98934 14 7.97867 13.9997 7.96802 13.9992C7.80822 13.9916 7.65063 13.9268 7.5286 13.8047L2.19526 8.4714C1.93491 8.21106 1.93491 7.78895 2.19526 7.5286C2.45561 7.26825 2.87772 7.26825 3.13807 7.5286L7.33333 11.7239V2.66667C7.33333 2.29848 7.63181 2 8 2C8.36819 2 8.66667 2.29848 8.66667 2.66667V11.7239L12.8619 7.5286C13.1223 7.26825 13.5444 7.26825 13.8047 7.5286Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 79611:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.19526 8.4714C1.93491 8.21106 1.93491 7.78895 2.19526 7.5286L7.33412 2.6342C7.33421 2.63239 7.3343 2.63057 7.33441 2.62876L2.19526 7.5286L7.5286 2.19526C7.65721 2.06665 7.82529 2.00157 7.99385 2.00003C7.9959 2.00001 7.99795 2 8 2C8.01066 2 8.02133 2.00025 8.03198 2.00076C8.19178 2.00839 8.34937 2.07322 8.4714 2.19526L13.8047 7.5286C14.0651 7.78895 14.0651 8.21106 13.8047 8.4714C13.5444 8.73175 13.1223 8.73175 12.8619 8.4714L8.66667 4.27614V13.3333C8.66667 13.7015 8.36819 14 8 14C7.63181 14 7.33333 13.7015 7.33333 13.3333V4.27614L3.13807 8.4714C2.87772 8.73175 2.45561 8.73175 2.19526 8.4714Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 66995:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M8 6.586l5.293-5.293a1 1 0 0 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 1 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 1 1 1.414-1.414L8 6.586z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 5952:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M6.25914 3.9476C6.53567 3.83076 6.76197 3.65513 6.94152 3.49539C7.05669 3.39292 7.18212 3.26868 7.28932 3.16249C7.33767 3.1146 7.38234 3.07035 7.42066 3.03346C7.72916 2.73646 7.87696 2.66683 7.99967 2.66683C8.09746 2.66683 8.24753 2.7344 8.57809 3.04753C8.61723 3.0846 8.66154 3.12761 8.70899 3.17367C8.82054 3.28196 8.94953 3.40718 9.0694 3.51161C9.24876 3.66788 9.47719 3.84252 9.75208 3.95248C10.0252 4.06172 10.3022 4.09263 10.5326 4.10266C10.6773 4.10897 10.8469 4.10721 10.9899 4.10573C11.0559 4.10505 11.1163 4.10443 11.1659 4.10468C11.5669 4.10673 11.7009 4.15861 11.7791 4.23709C11.8336 4.2919 11.8827 4.39992 11.8812 4.81614C11.8811 4.85816 11.8804 4.90545 11.8797 4.9563C11.8776 5.10852 11.8751 5.29266 11.8843 5.46209C11.8973 5.70032 11.9346 5.98124 12.0522 6.25963C12.1691 6.53616 12.3447 6.76246 12.5044 6.94201C12.6069 7.05718 12.7312 7.1826 12.8373 7.28981C12.8852 7.33817 12.9295 7.38282 12.9664 7.42115C13.2634 7.72964 13.333 7.87744 13.333 8.00016C13.333 8.12288 13.2634 8.27068 12.9664 8.57917C12.9295 8.61749 12.8853 8.66211 12.8374 8.71044C12.7312 8.81765 12.6069 8.94315 12.5044 9.05832C12.3447 9.23787 12.1691 9.46416 12.0522 9.7407C11.9346 10.019 11.8975 10.2999 11.8848 10.5379C11.8757 10.7075 11.8785 10.8916 11.8808 11.0437C11.8815 11.0943 11.8822 11.1414 11.8824 11.1832C11.8844 11.5993 11.8355 11.7065 11.7818 11.7605C11.7048 11.8379 11.5913 11.8842 11.202 11.883C11.1589 11.8828 11.1104 11.8818 11.0574 11.8806C10.7252 11.8735 10.2154 11.8625 9.75208 12.0478C9.47719 12.1578 9.24876 12.3324 9.0694 12.4887C8.94954 12.5931 8.82065 12.7183 8.7091 12.8265C8.66166 12.8726 8.61722 12.9157 8.57809 12.9528C8.24753 13.2659 8.09746 13.3335 7.99967 13.3335C7.87696 13.3335 7.72916 13.2639 7.42066 12.9669C7.38233 12.93 7.33768 12.8857 7.28932 12.8378C7.18212 12.7316 7.05669 12.6074 6.94152 12.5049C6.76197 12.3452 6.53567 12.1696 6.25914 12.0527C5.98025 11.9349 5.69878 11.896 5.45919 11.8814C5.29079 11.8711 5.1072 11.8721 4.95473 11.8729C4.90179 11.8732 4.85257 11.8735 4.80906 11.8732C4.39175 11.871 4.27756 11.8208 4.2176 11.7605C4.16384 11.7065 4.11491 11.5993 4.11692 11.1832C4.11712 11.1414 4.11783 11.0943 4.11859 11.0437C4.12089 10.8916 4.12366 10.7075 4.11458 10.5379C4.10184 10.2999 4.0647 10.019 3.94711 9.7407C3.83027 9.46416 3.65464 9.23787 3.4949 9.05832C3.39244 8.94315 3.2682 8.81773 3.16201 8.71053C3.11411 8.66217 3.06987 8.6175 3.03297 8.57917C2.73598 8.27068 2.66634 8.12288 2.66634 8.00016C2.66634 7.87744 2.73598 7.72964 3.03297 7.42115C3.06987 7.38283 3.11409 7.33818 3.16198 7.28983C3.26817 7.18263 3.39243 7.05718 3.4949 6.94201C3.65464 6.76246 3.83027 6.53616 3.94711 6.25963C4.0647 5.98131 4.10184 5.70046 4.11458 5.46243C4.12366 5.29287 4.12089 5.10878 4.11859 4.95661C4.11783 4.90602 4.11712 4.8589 4.11692 4.81708C4.11491 4.401 4.16384 4.29387 4.2176 4.2398C4.27756 4.17949 4.39175 4.12935 4.80906 4.1271C4.85256 4.12686 4.90175 4.12713 4.9547 4.12741C5.10717 4.12822 5.29078 4.1292 5.45919 4.11894C5.69878 4.10435 5.98025 4.06543 6.25914 3.9476ZM7.99967 1.3335C7.29479 1.3335 6.80122 1.779 6.49593 2.07292C6.42621 2.14003 6.36692 2.19895 6.31221 2.25331C6.22285 2.34211 6.14569 2.41878 6.05525 2.49924C5.92187 2.61791 5.8223 2.68471 5.74021 2.71939C5.65706 2.75452 5.54391 2.77798 5.37814 2.78807C5.25649 2.79548 5.14266 2.79485 5.00772 2.7941C4.94469 2.79375 4.87705 2.79338 4.80186 2.79378C4.40926 2.79591 3.75807 2.81093 3.2721 3.29969C2.78803 3.78653 2.78174 4.43795 2.7836 4.82353C2.78395 4.89557 2.78493 4.9606 2.78585 5.02124C2.7879 5.15689 2.78961 5.2705 2.78316 5.39117C2.77446 5.55369 2.752 5.66237 2.7189 5.7407C2.68422 5.82279 2.61742 5.92236 2.49875 6.05574C2.41829 6.14618 2.34162 6.22333 2.25282 6.3127C2.19846 6.36741 2.13953 6.42671 2.07243 6.49641C1.77852 6.80171 1.33301 7.29528 1.33301 8.00016C1.33301 8.70505 1.77852 9.19862 2.07243 9.50391C2.13954 9.57362 2.19845 9.63291 2.25282 9.68762C2.34161 9.77698 2.4183 9.85415 2.49875 9.94458C2.61742 10.078 2.68422 10.1775 2.7189 10.2596C2.752 10.338 2.77446 10.4466 2.78316 10.6092C2.78961 10.7298 2.7879 10.8434 2.78585 10.9791C2.78493 11.0397 2.78395 11.1048 2.7836 11.1768C2.78174 11.5624 2.78803 12.2138 3.2721 12.7006C3.75807 13.1894 4.40926 13.2044 4.80186 13.2065C4.87704 13.2069 4.94468 13.2066 5.0077 13.2062C5.14265 13.2055 5.25649 13.2048 5.37814 13.2123C5.54391 13.2223 5.65706 13.2458 5.74021 13.2809C5.8223 13.3156 5.92187 13.3824 6.05525 13.5011C6.14569 13.5815 6.22285 13.6582 6.31222 13.747C6.36692 13.8014 6.42623 13.8603 6.49593 13.9274C6.80122 14.2213 7.29479 14.6668 7.99967 14.6668C8.68889 14.6668 9.1945 14.2055 9.49503 13.9208C9.56141 13.8579 9.61946 13.8014 9.67338 13.749C9.76921 13.6558 9.85202 13.5753 9.94526 13.494C10.0825 13.3745 10.1778 13.3136 10.2473 13.2858C10.4395 13.2089 10.6402 13.211 10.9824 13.2146C11.0486 13.2153 11.1201 13.216 11.1978 13.2163C11.6011 13.2175 12.2317 13.199 12.7273 12.7006C13.2113 12.2138 13.2176 11.5624 13.2157 11.1768C13.2154 11.1049 13.2144 11.0399 13.2135 10.9793C13.2115 10.8437 13.2097 10.7298 13.2162 10.6092C13.2249 10.4466 13.2473 10.338 13.2804 10.2596C13.3151 10.1775 13.3819 10.078 13.5006 9.94458C13.5811 9.85415 13.6577 9.77699 13.7465 9.68762C13.8009 9.63292 13.8598 9.57361 13.9269 9.50391C14.2208 9.19862 14.6663 8.70505 14.6663 8.00016C14.6663 7.29528 14.2208 6.80171 13.9269 6.49641C13.8598 6.42671 13.8009 6.36744 13.7466 6.31273C13.6578 6.22336 13.5811 6.14618 13.5006 6.05574C13.3819 5.92236 13.3151 5.82279 13.2804 5.7407C13.2471 5.66177 13.2245 5.55253 13.2156 5.3896C13.2091 5.26881 13.2106 5.15517 13.2125 5.01961C13.2134 4.95873 13.2143 4.89324 13.2145 4.82089C13.2159 4.43443 13.2085 3.78304 12.7239 3.29631C12.2302 2.80046 11.5826 2.77346 11.1728 2.77136C11.0752 2.77086 10.9931 2.77189 10.9181 2.77283C10.8023 2.77427 10.7035 2.77551 10.5906 2.77059C10.4236 2.76332 10.3185 2.743 10.2473 2.71451C10.1778 2.68674 10.0825 2.62586 9.94526 2.5063C9.85201 2.42506 9.76924 2.34455 9.67339 2.25133C9.61947 2.19889 9.56141 2.14242 9.49503 2.07954C9.1945 1.79486 8.68889 1.3335 7.99967 1.3335ZM9.33301 8.00016C9.33301 7.26378 8.73605 6.66683 7.99967 6.66683C7.2633 6.66683 6.66634 7.26378 6.66634 8.00016C6.66634 8.73654 7.2633 9.3335 7.99967 9.3335C8.73605 9.3335 9.33301 8.73654 9.33301 8.00016ZM10.6663 8.00016C10.6663 9.47292 9.47243 10.6668 7.99967 10.6668C6.52692 10.6668 5.33301 9.47292 5.33301 8.00016C5.33301 6.5274 6.52692 5.3335 7.99967 5.3335C9.47243 5.3335 10.6663 6.5274 10.6663 8.00016Z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 50375:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M5 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5zM4 7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7zm6 3a2 2 0 1 1-3.999.001A2 2 0 0 1 10 10zm4.747 2.341a.998.998 0 0 0-1.494 0L10 16l-1.626-1.832a.5.5 0 0 0-.748 0L6 16h12l-3.253-3.659z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 93034:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"28","viewBox":"0 0 36 28"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h36v28H0z\"/>         <rect width=\"32\" height=\"26\" x=\"2\" y=\"1\" fill=\"#9DA5A6\" rx=\"2\"/>         <rect width=\"30\" height=\"24\" x=\"3\" y=\"2\" fill=\"#FFF\" rx=\"1\"/>         <path fill=\"#9DA5A6\" fill-rule=\"nonzero\" d=\"M18.75 18.833l-2.395 3.222a1 1 0 1 1-1.605-1.193l.907-1.22a2.006 2.006 0 0 1-.064-.055s-3.02-2.673-3.024-2.668L7.744 22.29a1 1 0 0 1-1.488-1.336l4.826-5.372a2.013 2.013 0 0 1 2.825-.169l2.945 2.618.296-.395.928-1.248a1.01 1.01 0 0 1 .077-.092l3.45-4.6a1.88 1.88 0 0 1 2.812-.25l6.264 5.796a1 1 0 1 1-1.358 1.468l-6.186-5.723-4.385 5.846zM10 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 11894:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4zm6 4a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2H10zm-1 5a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H10a1 1 0 0 1-1-1zm1 3a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2H10zm-7 5a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm.89-11.887a.5.5 0 0 0-.89.312v7.15a.5.5 0 0 0 .89.312l2.86-3.575a.5.5 0 0 0 0-.624L3.89 8.113z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 13669:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M10.0018 0.312501H0.996942C0.445872 0.312501 0 0.730505 0 1.24713V9.68979C0 10.2058 0.445872 10.625 0.996942 10.625H10.0024C10.5529 10.625 11 10.2064 11 9.68979V1.24713C11 1.1243 10.9742 1.00267 10.924 0.8892C10.8738 0.77573 10.8003 0.672646 10.7076 0.585843C10.6149 0.499039 10.5048 0.430218 10.3837 0.383316C10.2626 0.336414 10.1329 0.31235 10.0018 0.312501ZM3.67584 2.31766C4.04098 2.31766 4.3474 2.5883 4.3474 2.93578C4.3474 3.28899 4.04098 3.55505 3.67584 3.55505V3.56766C3.30642 3.56766 3.00917 3.28899 3.00917 2.94381C3.00917 2.5969 3.30642 2.31766 3.67584 2.31766ZM8.1737 8.25344C7.49358 8.25344 7.16391 7.87385 7.16391 7.35551C7.16391 7.20642 7.1841 7.04989 7.23364 6.88991L7.55657 5.79702C7.59816 5.67775 7.60917 5.56479 7.60917 5.46388C7.60917 5.11124 7.37982 4.89966 7.01529 4.89966C6.54985 4.89966 6.24465 5.21101 6.08563 5.81594L5.45382 8.19323H4.34618L4.54618 7.4461C4.21957 7.94668 3.76881 8.25573 3.21101 8.25573C2.537 8.25573 2.22202 7.89335 2.22202 7.34748C2.2247 7.191 2.24437 7.03519 2.28073 6.88245L2.78593 4.95241H2.00428L2.24159 4.13245H4.12232L3.37859 6.88704C3.32966 7.06422 3.31132 7.20757 3.31132 7.31021C3.31132 7.48624 3.40183 7.53727 3.54679 7.56938C3.63609 7.58658 4.33884 7.57569 4.71988 6.78039L5.20795 4.95241H4.41651L4.65566 4.14736H6.36024L6.14067 5.07454C6.4367 4.55906 7.02875 4.06422 7.61223 4.06422C8.23119 4.06422 8.74679 4.48165 8.74679 5.27466C8.74679 5.50401 8.70826 5.73108 8.6367 5.95126L8.31865 7.01663C8.29246 7.10882 8.27708 7.20342 8.27278 7.29874C8.27278 7.48567 8.35596 7.57626 8.49786 7.57626C8.64343 7.57626 8.83609 7.47248 9.04771 6.90424L9.48073 7.06021C9.22752 7.90482 8.7578 8.25344 8.1737 8.25344Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 44819:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M13.0043 5.41667C13.0043 7.94797 10.5043 10 8.83768 10C7.17101 10 4.67101 7.94797 4.67101 5.41667C4.67101 2.88536 6.53649 0.833336 8.83768 0.833336C11.1389 0.833336 13.0043 2.88536 13.0043 5.41667ZM11.3377 5.41667C11.3377 3.6528 10.0725 2.5 8.83768 2.5C7.60289 2.5 6.33768 3.6528 6.33768 5.41667C6.33768 6.12695 6.69657 6.87065 7.30508 7.47629C7.95128 8.11947 8.59479 8.33333 8.83768 8.33333C9.08056 8.33333 9.72407 8.11947 10.3703 7.47629C10.9788 6.87065 11.3377 6.12695 11.3377 5.41667Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M9.68229 10.8333C9.92306 10.8333 10.162 10.8494 10.3977 10.8808C10.4721 10.7956 10.5499 10.7123 10.6311 10.6311C12.5838 8.67851 15.7496 8.67851 17.7022 10.6311C19.6548 12.5838 19.6548 15.7496 17.7022 17.7022C15.7496 19.6548 12.5838 19.6548 10.6311 17.7022C10.5651 17.6362 10.5013 17.5687 10.4397 17.5H3.83676C2.98192 17.5 2.34692 16.7084 2.53236 15.8739L2.78398 14.7416C2.9294 14.0873 3.20515 13.4689 3.59478 12.9234C4.53166 11.6118 6.04429 10.8333 7.65614 10.8333H9.68229ZM7.65614 12.5C6.58254 12.5 5.57503 13.0185 4.95101 13.8921C4.69148 14.2554 4.50781 14.6673 4.41095 15.1032L4.2487 15.8333H9.45139C9.07176 14.7569 9.07176 13.5764 9.45139 12.5H7.65614ZM17.357 14.1667C17.357 13.7064 16.9839 13.3333 16.5237 13.3333H15V11.8096C15 11.3494 14.6269 10.9763 14.1667 10.9763C13.7064 10.9763 13.3333 11.3494 13.3333 11.8096V13.3333H11.8096C11.3494 13.3333 10.9763 13.7064 10.9763 14.1667C10.9763 14.6269 11.3494 15 11.8096 15H13.3333V16.5237C13.3333 16.9839 13.7064 17.357 14.1667 17.357C14.6269 17.357 15 16.9839 15 16.5237V15H16.5237C16.9839 15 17.357 14.6269 17.357 14.1667Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 34061:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12.753 4L9.198 20H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-1.753l3.555-16H17a1 1 0 0 0 0-2h-6a1 1 0 0 0 0 2h1.753z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 78018:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"19","height":"16","viewBox":"0 0 19 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M6 0C6.55228 0 7 0.447715 7 1V7H11V1C11 0.447715 11.4477 0 12 0C12.5523 0 13 0.447715 13 1V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V9H7V15C7 15.5523 6.55228 16 6 16C5.44772 16 5 15.5523 5 15V1C5 0.447715 5.44772 0 6 0Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M15 9C15.5523 9 16 9.44771 16 10V14H18C18.5523 14 19 14.4477 19 15C19 15.5523 18.5523 16 18 16H15C14.4477 16 14 15.5523 14 15V10C14 9.44771 14.4477 9 15 9Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M2.31204 9.6109C2.15191 9.81056 1.84807 9.81056 1.68794 9.6109L0.11556 7.65025C-0.0944184 7.38842 0.0919813 7 0.427607 7H3.57237C3.908 7 4.0944 7.38842 3.88442 7.65025L2.31204 9.6109Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 76767:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M8.3238 2.75064C8.12245 2.63878 7.87763 2.63878 7.67628 2.75064L1.68792 6.07751C1.64715 6.09915 1.6089 6.12489 1.57372 6.15419C1.54546 6.17769 1.51934 6.20337 1.49556 6.23091C1.3945 6.34777 1.33337 6.50012 1.33337 6.66675V11.3334C1.33337 11.7016 1.63185 12.0001 2.00004 12.0001C2.36823 12.0001 2.66671 11.7016 2.66671 11.3334V7.79976L4.66671 8.91087V11.3334C4.66629 11.3439 4.66671 11.3546 4.66671 11.3655C4.66671 12.286 6.15909 13.3655 8.00004 13.3655C9.84099 13.3655 11.3334 12.286 11.3334 11.3655C11.3334 11.3546 11.3332 11.3439 11.3328 11.3334L11.3334 8.91087L14.3238 7.24952C14.5354 7.13194 14.6667 6.90886 14.6667 6.66675C14.6667 6.42464 14.5354 6.20156 14.3238 6.08398L8.3238 2.75064ZM8.00004 9.23744L3.37279 6.66675L8.00004 4.09605L12.6273 6.66675L8.00004 9.23744Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 4718:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.22881 8.9428C3.44776 9.72384 3.44776 10.9902 4.22881 11.7712C5.00986 12.5523 6.27619 12.5523 7.05724 11.7712L8.47145 10.357C8.7318 10.0967 9.15391 10.0967 9.41426 10.357C9.67461 10.6174 9.67461 11.0395 9.41426 11.2998L8.00005 12.714C6.6983 14.0158 4.58775 14.0158 3.286 12.714C1.98426 11.4123 1.98426 9.30173 3.286 7.99999L4.70022 6.58577C4.96057 6.32542 5.38268 6.32542 5.64303 6.58577C5.90337 6.84612 5.90337 7.26823 5.64303 7.52858L4.22881 8.9428ZM6.11443 9.8856C5.85408 9.62526 5.85408 9.20315 6.11443 8.9428L8.94286 6.11437C9.20321 5.85402 9.62532 5.85402 9.88567 6.11437C10.146 6.37472 10.146 6.79683 9.88567 7.05718L7.05724 9.8856C6.79689 10.146 6.37478 10.146 6.11443 9.8856ZM6.58583 4.70016C6.32548 4.96051 6.32548 5.38261 6.58583 5.64296C6.84618 5.90331 7.26829 5.90331 7.52864 5.64296L8.94286 4.22875C9.72391 3.4477 10.9902 3.4477 11.7713 4.22875C12.5523 5.0098 12.5523 6.27613 11.7713 7.05718L10.3571 8.47139C10.0967 8.73174 10.0967 9.15385 10.3571 9.4142C10.6174 9.67455 11.0395 9.67455 11.2999 9.4142L12.7141 7.99999C14.0158 6.69824 14.0158 4.58769 12.7141 3.28594C11.4123 1.98419 9.3018 1.98419 8.00005 3.28594L6.58583 4.70016Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 60623:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M7 9a3 3 0 1 0 0 6h3a1 1 0 0 1 0 2H7A5 5 0 0 1 7 7h3a1 1 0 0 1 0 2H7zm1 3a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1zm6-5a1 1 0 0 0 0 2h3a3 3 0 1 1 0 6h-3a1 1 0 0 0 0 2h3a5 5 0 0 0 0-10h-3z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 12479:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path class=\"graphic\" fill=\"#5C6061\" fill-rule=\"evenodd\" d=\"M11.293 3.293a1 1 0 0 1 1.414 0L20.05 11h.008l-7.35-7.708 8 8c.193.193.29.445.293.698V12l-.001.048a.997.997 0 0 1-.292.66l-8 8a1 1 0 0 1-1.414-1.415L17.586 13H4a1 1 0 1 1 0-2h13.586l-6.293-6.293a1 1 0 0 1 0-1.414z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 95161:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm4-2a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2H8zm0 6a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2H8zm-1 7a1 1 0 0 1 1-1h12a1 1 0 0 1 0 2H8a1 1 0 0 1-1-1zm-2-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-1 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 30350:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <circle class=\"graphic\" cx=\"12\" cy=\"12\" r=\"10\" fill=\"#5C6061\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 98854:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"8","height":"5","viewBox":"0 0 8 5","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M1.44948 0L6.55052 0C7.12009 0 7.42736 0.668079 7.05669 1.10053L4.50617 4.07613C4.24011 4.38654 3.75989 4.38654 3.49383 4.07613L0.943309 1.10053C0.572639 0.668079 0.879912 0 1.44948 0Z\" fill=\"#AEB7B8\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 35235:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M21.12 11.069L3.459 4.158c-.91-.357-1.74.672-1.196 1.486l3.867 5.801c.224.336.224.774 0 1.11l-3.867 5.801c-.543.814.285 1.843 1.196 1.486l17.661-6.911c.848-.331.848-1.531 0-1.862z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 59481:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3.414 10.586l7.172-7.172a2 2 0 0 1 2.828 0l7.172 7.172a2 2 0 0 1 0 2.828l-7.172 7.172a2 2 0 0 1-2.828 0l-7.172-7.172a2 2 0 0 1 0-2.828z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 47238:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4.5 4a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V5.707l-.146.147a.502.502 0 0 1-.708-.708l1-1A.502.502 0 0 1 4.5 4zM9 5h11a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2zm0 6h11a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2zm-1 7a1 1 0 0 1 1-1h11a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1zm-3.933-1.75a.5.5 0 1 1-.866-.5 1.5 1.5 0 1 1 2.417 1.75A1.5 1.5 0 1 1 3 18.5a.5.5 0 0 1 1 0 .5.5 0 1 0 .5-.5.5.5 0 0 1 0-1 .5.5 0 1 0-.433-.75zM4.5 10.5a.5.5 0 0 0-.495.428.5.5 0 1 1-.99-.141A1.501 1.501 0 0 1 6 11c0 .427-.179.813-.465 1.085L4.666 13H5.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.362-.845l1.692-1.779.011-.01A.5.5 0 0 0 4.5 10.5z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 56987:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 74107:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-2a8 8 0 1 1 0-16 8 8 0 0 1 0 16z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 60965:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path class=\"graphic\" fill=\"#5C6061\" fill-rule=\"evenodd\" d=\"M10.548 3.807c.467-1.343 2.367-1.343 2.834 0l1.65 4.748 5.026.103c1.422.029 2.009 1.836.875 2.695l-4.005 3.037 1.455 4.81c.412 1.362-1.125 2.479-2.292 1.666l-4.126-2.87-4.126 2.87c-1.167.813-2.704-.304-2.293-1.665l1.456-4.811-4.006-3.037c-1.133-.86-.546-2.666.876-2.695l5.026-.103 1.65-4.748z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 8941:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"20","viewBox":"0 0 16 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M4 4C4 1.79086 5.79086 0 8 0C10.2091 0 12 1.79086 12 4V6H13C14.6569 6 16 7.34315 16 9V17C16 18.6569 14.6569 20 13 20H3C1.34315 20 0 18.6569 0 17V9C0 7.34315 1.34315 6 3 6H4V4ZM10 4C10 2.89543 9.10457 2 8 2C6.89543 2 6 2.89543 6 4V6H10V4ZM3 8C2.44772 8 2 8.44772 2 9V17C2 17.5523 2.44772 18 3 18H13C13.5523 18 14 17.5523 14 17V9C14 8.44772 13.5523 8 13 8H3ZM10 12C10 12.7403 9.5978 13.3866 9 13.7324V15C9 15.5523 8.55228 16 8 16C7.44772 16 7 15.5523 7 15V13.7324C6.4022 13.3866 6 12.7403 6 12C6 10.8954 6.89543 10 8 10C9.10457 10 10 10.8954 10 12Z\" fill=\"rgb(0, 161, 183)\" fill-opacity=\"0.6\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 72102:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"20","viewBox":"0 0 16 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M4 4C4 1.79086 5.79086 0 8 0C10.2091 0 12 1.79086 12 4V6H13C14.6569 6 16 7.34315 16 9V17C16 18.6569 14.6569 20 13 20H3C1.34315 20 0 18.6569 0 17V9C0 7.34315 1.34315 6 3 6H4V4ZM10 4C10 2.89543 9.10457 2 8 2C6.89543 2 6 2.89543 6 4V6H10V4ZM3 8C2.44772 8 2 8.44772 2 9V17C2 17.5523 2.44772 18 3 18H13C13.5523 18 14 17.5523 14 17V9C14 8.44772 13.5523 8 13 8H3ZM10 12C10 12.7403 9.5978 13.3866 9 13.7324V15C9 15.5523 8.55228 16 8 16C7.44772 16 7 15.5523 7 15V13.7324C6.4022 13.3866 6 12.7403 6 12C6 10.8954 6.89543 10 8 10C9.10457 10 10 10.8954 10 12Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 29828:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 1C0 0.447715 0.447715 0 1 0H4C4.55228 0 5 0.447715 5 1C5 1.55228 4.55228 2 4 2H2V4C2 4.55228 1.55228 5 1 5C0.447715 5 0 4.55228 0 4V1ZM9 1C9 0.447715 9.44771 0 10 0H13C13.5523 0 14 0.447715 14 1V4C14 4.55228 13.5523 5 13 5C12.4477 5 12 4.55228 12 4V2H10C9.44771 2 9 1.55228 9 1ZM1 9C1.55228 9 2 9.44771 2 10V12H4C4.55228 12 5 12.4477 5 13C5 13.5523 4.55228 14 4 14H1C0.447715 14 0 13.5523 0 13V10C0 9.44771 0.447715 9 1 9ZM13 9C13.5523 9 14 9.44771 14 10V13C14 13.5523 13.5523 14 13 14H10C9.44771 14 9 13.5523 9 13C9 12.4477 9.44771 12 10 12H12V10C12 9.44771 12.4477 9 13 9Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 37871:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"21","height":"16","viewBox":"0 0 21 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M6 0C6.55228 0 7 0.447715 7 1V7H11V1C11 0.447715 11.4477 0 12 0C12.5523 0 13 0.447715 13 1V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V9H7V15C7 15.5523 6.55228 16 6 16C5.44772 16 5 15.5523 5 15V1C5 0.447715 5.44772 0 6 0Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M14.6838 9.05132C15.0921 8.9152 15.5417 9.05566 15.8 9.4L17.5 11.6667L19.2 9.4C19.4583 9.05566 19.9079 8.9152 20.3162 9.05132C20.7246 9.18743 21 9.56957 21 10V15C21 15.5523 20.5523 16 20 16C19.4477 16 19 15.5523 19 15V13L18.3 13.9333C18.1111 14.1851 17.8148 14.3333 17.5 14.3333C17.1852 14.3333 16.8889 14.1851 16.7 13.9333L16 13V15C16 15.5523 15.5523 16 15 16C14.4477 16 14 15.5523 14 15V10C14 9.56957 14.2754 9.18743 14.6838 9.05132Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M2.31204 9.6109C2.15191 9.81056 1.84807 9.81056 1.68794 9.6109L0.11556 7.65025C-0.0944184 7.38842 0.0919813 7 0.427607 7H3.57237C3.908 7 4.0944 7.38842 3.88442 7.65025L2.31204 9.6109Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 94384:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12 4a8 8 0 1 0 3.555 15.169 1 1 0 1 1 .89 1.791A9.961 9.961 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10v.571c0 1.297-.317 2.395-.948 3.193A3.199 3.199 0 0 1 18.5 17c-1.216 0-2.192-.685-2.801-1.636A5 5 0 1 1 15 8a1 1 0 0 1 2 0v5c0 1.222.85 2 1.5 2a1.2 1.2 0 0 0 .984-.478c.273-.345.516-.961.516-1.951V12a8 8 0 0 0-8-8zm3 8a3 3 0 1 0-6 0 3 3 0 0 0 6 0z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 16357:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"8","viewBox":"0 0 14 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.4714 0.861888C13.7318 1.12224 13.7318 1.54435 13.4714 1.8047L7.47142 7.8047C7.21108 8.06505 6.78897 8.06505 6.52862 7.8047L0.528615 1.8047C0.268266 1.54435 0.268266 1.12224 0.528615 0.861888C0.788965 0.601539 1.21107 0.601539 1.47143 0.861888L7.00002 6.39048L12.5286 0.861888C12.789 0.601539 13.2111 0.601539 13.4714 0.861888Z\" fill=\"#AEB7B8\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 63821:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"15","height":"14","viewBox":"0 0 15 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 0C4.55228 0 5 0.447715 5 1V4C5 4.55228 4.55228 5 4 5H1C0.447715 5 0 4.55228 0 4C0 3.44772 0.447715 3 1 3H3V1C3 0.447715 3.44772 0 4 0ZM10.5 0C11.0523 0 11.5 0.447715 11.5 1V3H13.5C14.0523 3 14.5 3.44772 14.5 4C14.5 4.55228 14.0523 5 13.5 5H10.5C9.94771 5 9.5 4.55228 9.5 4V1C9.5 0.447715 9.94771 0 10.5 0ZM0 10C0 9.44771 0.447715 9 1 9H4C4.55228 9 5 9.44771 5 10V13C5 13.5523 4.55228 14 4 14C3.44772 14 3 13.5523 3 13V11H1C0.447715 11 0 10.5523 0 10ZM9.5 10C9.5 9.44771 9.94771 9 10.5 9H13.5C14.0523 9 14.5 9.44771 14.5 10C14.5 10.5523 14.0523 11 13.5 11H11.5V13C11.5 13.5523 11.0523 14 10.5 14C9.94771 14 9.5 13.5523 9.5 13V10Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 31958:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M2 8c0-.368.298-.667.667-.667h10.666a.667.667 0 1 1 0 1.334H2.667A.667.667 0 0 1 2 8z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 26934:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M2 2H4L7.5 5.5L5.5 2H7.5L11 4.5L9 2H11L14 4L11 14H9L11 4.5L7.5 14H5.5L7.5 5.5L4 14H2L4 6L2 2Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 46605:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M7.5 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 92688:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<rect class=\"graphic\" width=\"11\" height=\"11\" rx=\"1\" fill=\"#5C6061\"/>   <path class=\"graphic_stroke_bg graphic_bg\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.27444 4.09162C4.4421 4.48418 4.57964 4.91014 4.88142 5.92473L4.88391 5.93307C5.18869 6.95775 5.32589 7.38581 5.50938 7.83045C5.63543 8.13585 5.76037 8.37659 5.897 8.56076C6.09828 8.83209 6.33766 8.99992 6.63376 8.99992C7.02753 8.99992 7.35911 8.8112 7.58923 8.47347C7.77042 8.20748 7.8816 7.86402 7.9424 7.44739C8.03504 6.81257 8.01171 6.00699 7.90265 5.02681C7.77939 3.9186 7.57845 3.02221 7.29363 2.33322C7.17562 2.04777 6.8691 1.92134 6.60896 2.05083C6.34884 2.18033 6.23362 2.5167 6.35163 2.80217C6.58752 3.37277 6.76436 4.16166 6.8759 5.16433C6.97415 6.0476 6.99484 6.76203 6.92103 7.26793C6.88444 7.51871 6.82674 7.69695 6.76077 7.79378C6.74119 7.82253 6.72453 7.84052 6.70449 7.85119C6.70276 7.84895 6.701 7.84659 6.69919 7.84415C6.62859 7.74897 6.54412 7.58625 6.45164 7.36215C6.29005 6.97058 6.15885 6.56128 5.86723 5.58084L5.86475 5.57252C5.54809 4.50793 5.40402 4.06171 5.21111 3.60996C5.07642 3.29453 4.94181 3.05136 4.79023 2.87167C4.55843 2.59684 4.26896 2.4538 3.94268 2.53586C3.59719 2.62276 3.353 2.90101 3.20629 3.30131C3.09221 3.61263 3.02918 4.01532 3.00803 4.5188C2.96864 5.45512 3.07431 6.78482 3.32264 8.52041C3.36694 8.83005 3.63161 9.04166 3.91379 8.99305C4.19597 8.94444 4.3888 8.65399 4.3445 8.34432C4.10605 6.6778 4.00579 5.4159 4.04132 4.57113C4.05521 4.24081 4.08973 3.98467 4.13918 3.80852C4.18103 3.88469 4.22654 3.97944 4.27444 4.09162Z\" stroke=\"white\" stroke-width=\"0.2\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 36771:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M0.500061 6C0.500061 2.96243 2.96249 0.5 6.00006 0.5C9.03763 0.5 11.5001 2.96243 11.5001 6C11.5001 9.03757 9.03763 11.5 6.00006 11.5C2.96249 11.5 0.500061 9.03757 0.500061 6Z\" stroke=\"#AEB7B8\"/>   <path d=\"M6.00002 6.00002C8.34317 3.65686 8.37091 3.62912 10.2427 1.75736C7.89952 -0.585793 4.10052 -0.585793 1.75736 1.75736C-0.585795 4.10052 -0.585795 7.89952 1.75736 10.2427C3.62912 8.37092 3.65686 8.34317 6.00002 6.00002Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 99562:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6Z\" stroke=\"#EDEDED\"/>   <path d=\"M6.00004 5.99998C3.65689 8.34314 3.62915 8.37088 1.75739 10.2426C4.10054 12.5858 7.89955 12.5858 10.2427 10.2426C12.5859 7.89948 12.5859 4.10048 10.2427 1.75732C8.37094 3.62908 8.3432 3.65683 6.00004 5.99998Z\" fill=\"#404B4C\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 42477:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g class=\"graphic_stroke\" fill=\"none\" fill-rule=\"nonzero\" stroke=\"#5C6061\" stroke-width=\"1.333\">         <circle cx=\"8\" cy=\"8\" r=\"7.333\"/>         <path stroke-linecap=\"square\" d=\"M3.333 12.667l9.334-9.334\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 8386:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4.667 1.333a2 2 0 0 0-2 2v9.334a2 2 0 0 0 2 2h6.666a2 2 0 0 0 2-2V3.333a2 2 0 0 0-2-2H4.667zm-.667 2c0-.368.299-.666.667-.666h6.666c.368 0 .667.298.667.666v9.334a.667.667 0 0 1-.667.666H4.667A.667.667 0 0 1 4 12.667V3.333zM6 4a.667.667 0 0 0 0 1.333h4A.667.667 0 0 0 10 4H6zm-.667 3.333c0-.368.299-.666.667-.666h4A.667.667 0 0 1 10 8H6a.667.667 0 0 1-.667-.667zm.667 2a.667.667 0 0 0 0 1.334h2.667a.667.667 0 0 0 0-1.334H6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 7306:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path class=\"graphic\" fill=\"#5C6061\" fill-rule=\"evenodd\" d=\"M4 3a1 1 0 0 0 0 2h16a1 1 0 1 0 0-2H4zm6 4a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H10zm-1 5a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1zm1 3a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H10zm-7 5a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1zm3.11-4.113a.5.5 0 0 0 .89-.312v-7.15a.5.5 0 0 0-.89-.312l-2.86 3.575a.5.5 0 0 0 0 .624l2.86 3.575z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 68234:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 2C2.89543 2 2 2.89543 2 4V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V4C14 2.89543 13.1046 2 12 2H4ZM12 3.33333H4C3.63181 3.33333 3.33333 3.63181 3.33333 4V12C3.33333 12.3682 3.63181 12.6667 4 12.6667H12C12.3682 12.6667 12.6667 12.3682 12.6667 12V4C12.6667 3.63181 12.3682 3.33333 12 3.33333Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 69435:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"7","height":"14","viewBox":"0 0 7 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.80346 4.98904C1.78031 4.97102 1.75769 4.95282 1.73564 4.93441C1.50696 4.74347 1.31117 4.51221 1.17845 4.21436C1.04746 3.92039 0.995605 3.60128 0.995605 3.25826C0.995605 1.78514 2.19097 0.590942 3.66552 0.590942C5.14007 0.590942 6.33543 1.78514 6.33543 3.25826C6.33543 3.62654 6.03659 3.92509 5.66796 3.92509C5.29932 3.92509 5.00048 3.62654 5.00048 3.25826C5.00048 2.5217 4.4028 1.9246 3.66552 1.9246C2.92824 1.9246 2.33056 2.5217 2.33056 3.25826C2.33056 3.46766 2.36215 3.59146 2.39802 3.67197C2.43217 3.7486 2.48668 3.82338 2.59174 3.9111C2.80358 4.08798 3.10896 4.23895 3.61983 4.49152C3.7236 4.54282 3.83596 4.59836 3.95762 4.65912C3.95976 4.66018 3.9619 4.66124 3.96404 4.66231C4.06208 4.71129 4.16009 4.75942 4.25727 4.80713C4.76491 5.0564 5.24972 5.29446 5.59539 5.58308C5.82407 5.77402 6.01986 6.00527 6.15259 6.30312C6.28358 6.59709 6.33543 6.9162 6.33543 7.25922C6.33543 7.91312 6.14432 8.73277 5.70168 9.32347C5.64876 9.3941 5.59078 9.46328 5.52759 9.5294C5.55073 9.54741 5.57335 9.56561 5.5954 9.58402C5.82408 9.77496 6.01986 10.0062 6.15259 10.3041C6.28358 10.598 6.33543 10.9172 6.33543 11.2602C6.33543 12.7333 5.14007 13.9275 3.66552 13.9275C2.19097 13.9275 0.995605 12.7333 0.995605 11.2602C0.995605 10.8919 1.29445 10.5933 1.66308 10.5933C2.03172 10.5933 2.33056 10.8919 2.33056 11.2602C2.33056 11.9967 2.92824 12.5938 3.66552 12.5938C4.4028 12.5938 5.00048 11.9967 5.00048 11.2602C5.00048 11.0508 4.96889 10.927 4.93302 10.8465C4.89887 10.7698 4.84436 10.6951 4.7393 10.6073C4.52746 10.4305 4.22208 10.2795 3.71121 10.0269C3.60831 9.97605 3.49675 9.92089 3.37627 9.86074L3.36701 9.85613C3.26899 9.80717 3.17099 9.75905 3.07382 9.71134C2.56617 9.46207 2.08132 9.224 1.73564 8.93537C1.50697 8.74443 1.31118 8.51317 1.17845 8.21532C1.04746 7.92135 0.995605 7.60224 0.995605 7.25922C0.995605 6.60532 1.18671 5.78567 1.62936 5.19496C1.68228 5.12434 1.74026 5.05515 1.80346 4.98904ZM3.36256 5.85295C3.14984 5.74768 3.02999 5.75981 2.96932 5.77677C2.89844 5.79659 2.80352 5.85344 2.69803 5.99421C2.47319 6.29426 2.33056 6.80828 2.33056 7.25922C2.33056 7.46862 2.36215 7.59242 2.39802 7.67293C2.43217 7.74955 2.48668 7.82433 2.59174 7.91205C2.80356 8.08892 3.10891 8.23988 3.6197 8.49241L3.62032 8.49272C3.72447 8.54421 3.83717 8.59993 3.95935 8.66094L3.96403 8.66326L3.97073 8.6666C4.18204 8.77067 4.30126 8.75857 4.36172 8.74167C4.4326 8.72185 4.52752 8.665 4.63301 8.52422C4.85785 8.22418 5.00048 7.71016 5.00048 7.25922C5.00048 7.04982 4.96889 6.92602 4.93302 6.84552C4.89888 6.7689 4.84436 6.69412 4.7393 6.6064C4.52749 6.42954 4.22216 6.27859 3.71141 6.02607C3.60665 5.97428 3.4931 5.91814 3.37009 5.8567C3.36906 5.8562 3.36804 5.85569 3.36701 5.85518C3.36553 5.85443 3.36404 5.85369 3.36256 5.85295Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 36419:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4 9a6 6 0 0 1 6-6h9a1 1 0 0 1 0 2h-3.057v15a.943.943 0 1 1-1.886 0V5h-2.114v15a.943.943 0 1 1-1.886 0v-5H10a6 6 0 0 1-6-6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 46015:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"54","height":"54","viewBox":"0 0 54 54","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<circle cx=\"27\" cy=\"27\" r=\"27\" fill=\"black\" fill-opacity=\"0.32\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24 19.5C24 17.8431 22.6569 16.5 21 16.5C19.3431 16.5 18 17.8431 18 19.5V34.5C18 36.1569 19.3431 37.5 21 37.5C22.6569 37.5 24 36.1569 24 34.5V19.5ZM36 19.5C36 17.8431 34.6569 16.5 33 16.5C31.3431 16.5 30 17.8431 30 19.5V34.5C30 36.1569 31.3431 37.5 33 37.5C34.6569 37.5 36 36.1569 36 34.5V19.5Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 10231:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"33","height":"32","viewBox":"0 0 33 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"player\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.3189 32C25.1555 32 32.3189 24.8366 32.3189 16C32.3189 7.16344 25.1555 0 16.3189 0C7.48235 0 0.318909 7.16344 0.318909 16C0.318909 24.8366 7.48235 32 16.3189 32Z\" fill=\"#00A1B7\"/> <rect class=\"player2\" x=\"18.3189\" y=\"11\" width=\"2\" height=\"10\" rx=\"1\" fill=\"white\"/> <rect class=\"player2\" x=\"12.3189\" y=\"11\" width=\"2\" height=\"10\" rx=\"1\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 26143:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"14","viewBox":"0 0 12 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2V12C0 13.1046 0.89543 14 2 14C3.10457 14 4 13.1046 4 12V2ZM12 2C12 0.89543 11.1046 0 10 0C8.89543 0 8 0.89543 8 2V12C8 13.1046 8.89543 14 10 14C11.1046 14 12 13.1046 12 12V2Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 68278:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M16.6472 3.83988C15.6711 2.86334 14.0884 2.86326 13.1123 3.8397L11.8314 5.12111C11.8262 5.12606 11.821 5.13109 11.8159 5.13621C11.8107 5.14139 11.8056 5.14663 11.8006 5.15192L2.74401 14.2117C2.58776 14.368 2.49999 14.58 2.5 14.8011L2.50013 17.2764C2.50014 17.4974 2.58793 17.7094 2.74419 17.8658C2.90046 18.0221 3.11239 18.1099 3.33336 18.1099L5.80776 18.11C6.02873 18.11 6.24064 18.0222 6.39688 17.8659L16.7652 7.49389C17.7413 6.51746 17.7412 4.93426 16.7651 3.95773L16.6472 3.83988ZM12.4055 6.90432L13.7019 8.2007L5.46254 16.443L4.16645 16.443L4.16639 15.1464L12.4055 6.90432ZM14.8802 7.02198L13.5838 5.7256L14.2907 5.01848C14.6161 4.693 15.1436 4.69303 15.469 5.01854L15.5868 5.13639C15.9122 5.4619 15.9122 5.98963 15.5869 6.31511L14.8802 7.02198Z\" fill=\"currentColor\"></path>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 53686:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"14","viewBox":"0 0 12 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.00001 3.99999C8.00001 4.56822 7.71289 5.16318 7.22609 5.64769C6.70912 6.16223 6.19432 6.33333 6.00001 6.33333C5.8057 6.33333 5.2909 6.16223 4.77393 5.64769C4.28713 5.16318 4.00001 4.56822 4.00001 3.99999C4.00001 2.5889 5.01218 1.66666 6.00001 1.66666C6.98784 1.66666 8.00001 2.5889 8.00001 3.99999ZM9.33334 3.99999C9.33334 6.02504 7.33334 7.66666 6.00001 7.66666C4.66668 7.66666 2.66668 6.02504 2.66668 3.99999C2.66668 1.97495 4.15906 0.333328 6.00001 0.333328C7.84096 0.333328 9.33334 1.97495 9.33334 3.99999ZM5.05478 9.66666H6.6757C7.55016 9.66666 8.38096 10.0488 8.95005 10.7127C9.27003 11.086 9.4932 11.5324 9.59986 12.0123L9.67119 12.3333H2.32883L2.45863 11.7492C2.53612 11.4005 2.68306 11.071 2.89068 10.7803C3.38989 10.0814 4.1959 9.66666 5.05478 9.66666ZM1.8057 10.0054C2.5552 8.95607 3.7653 8.33333 5.05478 8.33333H6.6757C7.93939 8.33333 9.13999 8.88552 9.96239 9.84499C10.4248 10.3845 10.7473 11.0295 10.9014 11.7231L11.0774 12.5147C11.2087 13.1059 10.7589 13.6667 10.1533 13.6667H1.99928C1.31541 13.6667 0.807406 13.0334 0.95576 12.3658L1.15705 11.46C1.27339 10.9365 1.49399 10.4418 1.8057 10.0054Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 4421:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M6 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm8 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm6 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 88398:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<g clip-path=\"url(#clip0)\"> <path d=\"M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z\" fill=\"#00A1B7\"/> <path d=\"M12.0834 9.16663C10.9622 9.16663 10.4864 10.5939 11.3834 11.2666L11.85 11.6166C11.9969 11.7268 12.0834 11.8997 12.0834 12.0833V14.4166C12.0834 14.6002 11.9969 14.7731 11.85 14.8833L11.3834 15.2333C10.4864 15.906 10.9622 17.3333 12.0834 17.3333H14.4167V20.25C14.4167 20.5721 14.6779 20.8333 15 20.8333C15.3222 20.8333 15.5834 20.5721 15.5834 20.25V17.3333H17.9167C19.0379 17.3333 19.5136 15.906 18.6167 15.2333L18.15 14.8833C18.0031 14.7731 17.9167 14.6002 17.9167 14.4166V12.0833C17.9167 11.8997 18.0031 11.7268 18.15 11.6166L18.6167 11.2666C19.5136 10.5939 19.0379 9.16663 17.9167 9.16663H12.0834ZM12.0834 10.3333H17.9167L17.45 10.6833C17.0094 11.0138 16.75 11.5325 16.75 12.0833V14.4166C16.75 14.9675 17.0094 15.4861 17.45 15.8166L17.9167 16.1666H12.0834L12.55 15.8166C12.9907 15.4861 13.25 14.9675 13.25 14.4166V12.0833C13.25 11.5325 12.9907 11.0138 12.55 10.6833L12.0834 10.3333Z\" fill=\"#F5F8FA\"/> </g> <defs> <clipPath id=\"clip0\"> <path d=\"M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z\" fill=\"white\"/> </clipPath> </defs>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 7393:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.33333 0.666667C1.33333 1.03486 1.03486 1.33333 0.666667 1.33333C0.298477 1.33333 0 1.03486 0 0.666667C0 0.298477 0.298477 0 0.666667 0C1.03486 0 1.33333 0.298477 1.33333 0.666667ZM4 0.666667C4 1.03486 3.70152 1.33333 3.33333 1.33333C2.96514 1.33333 2.66667 1.03486 2.66667 0.666667C2.66667 0.298477 2.96514 0 3.33333 0C3.70152 0 4 0.298477 4 0.666667ZM9.33333 0.666667C9.33333 1.03486 9.03486 1.33333 8.66667 1.33333C8.29848 1.33333 8 1.03486 8 0.666667C8 0.298477 8.29848 0 8.66667 0C9.03486 0 9.33333 0.298477 9.33333 0.666667ZM6 1.33333C6.36819 1.33333 6.66667 1.03486 6.66667 0.666667C6.66667 0.298477 6.36819 0 6 0C5.63181 0 5.33333 0.298477 5.33333 0.666667C5.33333 1.03486 5.63181 1.33333 6 1.33333ZM0.666667 6.66667C1.03486 6.66667 1.33333 6.36819 1.33333 6C1.33333 5.63181 1.03486 5.33333 0.666667 5.33333C0.298477 5.33333 0 5.63181 0 6C0 6.36819 0.298477 6.66667 0.666667 6.66667ZM1.33333 3.33333C1.33333 3.70152 1.03486 4 0.666667 4C0.298477 4 0 3.70152 0 3.33333C0 2.96514 0.298477 2.66667 0.666667 2.66667C1.03486 2.66667 1.33333 2.96514 1.33333 3.33333ZM0.666667 12C1.03486 12 1.33333 11.7015 1.33333 11.3333C1.33333 10.9651 1.03486 10.6667 0.666667 10.6667C0.298477 10.6667 0 10.9651 0 11.3333C0 11.7015 0.298477 12 0.666667 12ZM1.33333 8.66667C1.33333 9.03486 1.03486 9.33333 0.666667 9.33333C0.298477 9.33333 0 9.03486 0 8.66667C0 8.29848 0.298477 8 0.666667 8C1.03486 8 1.33333 8.29848 1.33333 8.66667ZM3.33333 12C3.70152 12 4 11.7015 4 11.3333C4 10.9651 3.70152 10.6667 3.33333 10.6667C2.96514 10.6667 2.66667 10.9651 2.66667 11.3333C2.66667 11.7015 2.96514 12 3.33333 12ZM9.33333 11.3333C9.33333 11.7015 9.03486 12 8.66667 12C8.29848 12 8 11.7015 8 11.3333C8 10.9651 8.29848 10.6667 8.66667 10.6667C9.03486 10.6667 9.33333 10.9651 9.33333 11.3333ZM11.3333 12C11.7015 12 12 11.7015 12 11.3333C12 10.9651 11.7015 10.6667 11.3333 10.6667C10.9651 10.6667 10.6667 10.9651 10.6667 11.3333C10.6667 11.7015 10.9651 12 11.3333 12ZM6.66667 11.3333C6.66667 11.7015 6.36819 12 6 12C5.63181 12 5.33333 11.7015 5.33333 11.3333C5.33333 10.9651 5.63181 10.6667 6 10.6667C6.36819 10.6667 6.66667 10.9651 6.66667 11.3333ZM11.3333 9.33333C11.7015 9.33333 12 9.03486 12 8.66667C12 8.29848 11.7015 8 11.3333 8C10.9651 8 10.6667 8.29848 10.6667 8.66667C10.6667 9.03486 10.9651 9.33333 11.3333 9.33333ZM12 6C12 6.36819 11.7015 6.66667 11.3333 6.66667C10.9651 6.66667 10.6667 6.36819 10.6667 6C10.6667 5.63181 10.9651 5.33333 11.3333 5.33333C11.7015 5.33333 12 5.63181 12 6ZM11.3333 1.33333C11.7015 1.33333 12 1.03486 12 0.666667C12 0.298477 11.7015 0 11.3333 0C10.9651 0 10.6667 0.298477 10.6667 0.666667C10.6667 1.03486 10.9651 1.33333 11.3333 1.33333ZM12 3.33333C12 3.70152 11.7015 4 11.3333 4C10.9651 4 10.6667 3.70152 10.6667 3.33333C10.6667 2.96514 10.9651 2.66667 11.3333 2.66667C11.7015 2.66667 12 2.96514 12 3.33333ZM2.66667 3.33333C2.66667 2.96514 2.96514 2.66667 3.33333 2.66667H8.66667C9.03486 2.66667 9.33333 2.96514 9.33333 3.33333C9.33333 3.70152 9.03486 4 8.66667 4H6.66667V8.66667C6.66667 9.03486 6.36819 9.33333 6 9.33333C5.63181 9.33333 5.33333 9.03486 5.33333 8.66667V4H3.33333C2.96514 4 2.66667 3.70152 2.66667 3.33333Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 69499:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"19","height":"22","viewBox":"0 0 19 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M18.1667 9.55666C19.2778 10.1982 19.2778 11.8019 18.1667 12.4434L3.16666 21.1037C2.05554 21.7452 0.666656 20.9433 0.666656 19.6603L0.666657 2.33978C0.666657 1.05678 2.05555 0.254901 3.16666 0.896401L18.1667 9.55666Z\" fill=\"#00BCD4\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 51195:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"33","height":"32","viewBox":"0 0 33 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"player\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.3189 32C25.1555 32 32.3189 24.8366 32.3189 16C32.3189 7.16344 25.1555 0 16.3189 0C7.48235 0 0.318909 7.16344 0.318909 16C0.318909 24.8366 7.48235 32 16.3189 32Z\" fill=\"#00A1B7\"/> <path class=\"player2\" d=\"M23.0538 15.5606C23.4073 15.7559 23.4073 16.2441 23.0538 16.4394L13.1141 21.9313C12.7607 22.1265 12.3189 21.8825 12.3189 21.4919L12.3189 10.5081C12.3189 10.1175 12.7607 9.87346 13.1141 10.0687L23.0538 15.5606Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 1250:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"14","viewBox":"0 0 11 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M1.53688 0.978013C0.871153 0.55437 0 1.03258 0 1.82167V12.1783C0 12.9674 0.87115 13.4456 1.53688 13.022L9.67424 7.84366C10.2917 7.45071 10.2917 6.54929 9.67425 6.15634L1.53688 0.978013Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 25637:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"20","viewBox":"0 0 16 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M8 0C8.55228 0 9 0.447714 9 0.999999L9.00001 12.5858L14.2929 7.29289C14.6834 6.90237 15.3166 6.90237 15.7071 7.29289C16.0976 7.68342 16.0976 8.31658 15.7071 8.70711L8.71049 15.7037C8.69991 15.7144 8.68909 15.7249 8.67804 15.735C8.59151 15.815 8.49429 15.8768 8.39122 15.9206C8.27192 15.9713 8.14074 15.9996 8.00301 16L8.00002 16L7.99078 16C7.86178 15.9988 7.73861 15.9732 7.62569 15.9276C7.50456 15.8788 7.39106 15.8053 7.29289 15.7071L0.292893 8.70711C-0.0976311 8.31658 -0.0976311 7.68342 0.292893 7.29289C0.683417 6.90237 1.31658 6.90237 1.70711 7.29289L7.00001 12.5858L7 1C7 0.447716 7.44771 0 8 0Z\" fill=\"white\"/>   <path class=\"graphic\" d=\"M1 18C0.447715 18 7.45058e-09 18.4477 7.45058e-09 19C7.45058e-09 19.5523 0.447715 20 1 20L15 20C15.5523 20 16 19.5523 16 19C16 18.4477 15.5523 18 15 18L1 18Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 47137:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M12.2292 3.14583C12.2292 2.6856 11.8562 2.3125 11.3959 2.3125C10.9357 2.3125 10.5626 2.6856 10.5626 3.14583L10.5626 18.1458C10.5626 18.6061 10.9357 18.9792 11.3959 18.9792C11.8562 18.9792 12.2292 18.6061 12.2292 18.1458V3.14583Z\" fill=\"white\"/>   <path d=\"M8.89592 3.97917H4.72925C3.34854 3.97917 2.22925 5.09845 2.22925 6.47917V14.8125C2.22925 16.1932 3.34854 17.3125 4.72925 17.3125H8.89592C9.35615 17.3125 9.72925 16.9394 9.72925 16.4792C9.72925 16.0189 9.35615 15.6458 8.89592 15.6458H4.72925C4.26901 15.6458 3.89591 15.2727 3.89591 14.8125V6.47917C3.89591 6.01893 4.26901 5.64583 4.72925 5.64583H8.89592C9.35615 5.64583 9.72925 5.27274 9.72925 4.8125C9.72925 4.35226 9.35615 3.97917 8.89592 3.97917Z\" fill=\"white\"/>   <path d=\"M16.3959 15.6458H13.8959C13.4357 15.6458 13.0626 16.0189 13.0626 16.4792C13.0626 16.9394 13.4357 17.3125 13.8959 17.3125H16.3959C17.7766 17.3125 18.8959 16.1932 18.8959 14.8125V6.47917C18.8959 5.09845 17.7766 3.97917 16.3959 3.97917H13.8959C13.4357 3.97917 13.0626 4.35226 13.0626 4.8125C13.0626 5.27274 13.4357 5.64583 13.8959 5.64583H16.3959C16.8562 5.64583 17.2292 6.01893 17.2292 6.47917V14.8125C17.2292 15.2727 16.8562 15.6458 16.3959 15.6458Z\" fill=\"white\"/>   <path d=\"M13.8959 7.3125C13.4357 7.3125 13.0626 7.6856 13.0626 8.14583C13.0626 8.60607 13.4357 8.97917 13.8959 8.97917H15.5626C16.0228 8.97917 16.3959 8.60607 16.3959 8.14583C16.3959 7.6856 16.0228 7.3125 15.5626 7.3125H13.8959Z\" fill=\"white\"/>   <path d=\"M13.0626 13.1458C13.0626 12.6856 13.4357 12.3125 13.8959 12.3125H15.5626C16.0228 12.3125 16.3959 12.6856 16.3959 13.1458C16.3959 13.6061 16.0228 13.9792 15.5626 13.9792H13.8959C13.4357 13.9792 13.0626 13.6061 13.0626 13.1458Z\" fill=\"white\"/>   <path d=\"M13.8959 9.8125C13.4357 9.8125 13.0626 10.1856 13.0626 10.6458C13.0626 11.1061 13.4357 11.4792 13.8959 11.4792H15.5626C16.0228 11.4792 16.3959 11.1061 16.3959 10.6458C16.3959 10.1856 16.0228 9.8125 15.5626 9.8125H13.8959Z\" fill=\"white\"/>   <path d=\"M8.9625 10.4661C9.22917 10.62 9.22917 11.005 8.9625 11.1589L6.4125 12.6312C6.14583 12.7851 5.8125 12.5927 5.8125 12.2847V9.34026C5.8125 9.03234 6.14583 8.83989 6.4125 8.99385L8.9625 10.4661Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 36520:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M9 7h4a1 1 0 0 1 0 2H9v4a1 1 0 0 1-2 0V9H3a1 1 0 1 1 0-2h4V3a1 1 0 1 1 2 0v4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 14211:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"10","viewBox":"0 0 21 10"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill=\"#ED5454\" d=\"M3 0h1v10H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z\"/>         <path fill=\"#8BC34A\" d=\"M18 0h-1v10h1a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3z\"/>         <path fill=\"#FDA639\" d=\"M4 0h13v10H4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 49962:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"10","viewBox":"0 0 21 10"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <rect width=\"21\" height=\"10\" fill=\"#F5F5F5\" rx=\"3\"/>         <path fill=\"#8BC34A\" d=\"M3 0h13v10H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 54958:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 2C2.89543 2 2 2.89543 2 4V6C2 7.10457 2.89543 8 4 8H20C21.1046 8 22 7.10457 22 6V4C22 2.89543 21.1046 2 20 2H4ZM8 4H20V6H8V4Z\" fill=\"black\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 11C2 9.89543 2.89543 9 4 9H20C21.1046 9 22 9.89543 22 11V13C22 14.1046 21.1046 15 20 15H4C2.89543 15 2 14.1046 2 13V11ZM20 11H12V13H20V11Z\" fill=\"black\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 18C2 16.8954 2.89543 16 4 16H20C21.1046 16 22 16.8954 22 18V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V18ZM16 18H20V20H16V18Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 38312:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M11.375 4.37437L10.5059 5.24354L8.75586 3.49354L9.62503 2.62437C9.87003 2.37937 10.185 2.2627 10.5 2.2627C10.815 2.2627 11.13 2.37937 11.375 2.62437C11.8592 3.10854 11.8592 3.8902 11.375 4.37437Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M10.0967 5.65788L3.79086 11.9579C3.30669 12.442 2.52503 12.442 2.04086 11.9579C1.55669 11.4737 1.55669 10.692 2.04086 10.2079L8.34672 3.90788L10.0967 5.65788Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M5.80511 2.04197L6.04427 1.23113C6.06761 1.1553 6.04427 1.07363 5.99177 1.0153C5.93927 0.956966 5.84594 0.933633 5.77011 0.956966L4.95928 1.19613L4.14845 0.956966C4.07261 0.933633 3.99095 0.956966 3.93261 1.00947C3.87428 1.0678 3.85678 1.14947 3.88011 1.2253L4.11345 2.04197L3.87428 2.8528C3.85095 2.92863 3.87428 3.0103 3.92678 3.06863C3.98511 3.12697 4.06678 3.14447 4.14261 3.12113L4.95928 2.8878L5.77011 3.12697C5.79345 3.1328 5.81095 3.13863 5.83427 3.13863C5.89261 3.13863 5.94511 3.1153 5.99177 3.07447C6.05011 3.01613 6.06761 2.93447 6.04427 2.85863L5.80511 2.04197Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M3.47113 5.54197L3.71029 4.73113C3.73363 4.65529 3.71029 4.57363 3.65779 4.5153C3.59946 4.45697 3.51779 4.43947 3.44196 4.4628L2.62529 4.69613L1.81446 4.45697C1.73862 4.43363 1.65696 4.45697 1.59863 4.50947C1.54029 4.5678 1.52279 4.64947 1.54613 4.7253L1.77946 5.54197L1.54029 6.35279C1.51696 6.42863 1.54029 6.51029 1.59279 6.56863C1.65113 6.62696 1.73279 6.64446 1.80862 6.62113L2.61946 6.38196L3.43029 6.62113C3.44779 6.62696 3.47113 6.62696 3.49446 6.62696C3.55279 6.62696 3.60529 6.60363 3.65196 6.56279C3.71029 6.50446 3.72779 6.42279 3.70446 6.34696L3.47113 5.54197Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M12.2202 8.45834L12.4593 7.6475C12.4827 7.57167 12.4593 7.49 12.4068 7.43167C12.3485 7.37334 12.2668 7.35584 12.191 7.37917L11.3802 7.61834L10.5693 7.37917C10.4935 7.35584 10.4118 7.37917 10.3535 7.43167C10.2952 7.49 10.2777 7.57167 10.301 7.6475L10.5402 8.45834L10.301 9.26917C10.2777 9.34501 10.301 9.42667 10.3535 9.485C10.4118 9.54334 10.4935 9.56084 10.5693 9.5375L11.3802 9.29834L12.191 9.5375C12.2085 9.54334 12.2318 9.54334 12.2552 9.54334C12.3135 9.54334 12.366 9.52 12.4127 9.47917C12.471 9.42084 12.4885 9.33917 12.4652 9.26334L12.2202 8.45834Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 40286:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<path class=\"graphics\" fill=\"#AEB7B8\" fill-rule=\"evenodd\" d=\"M13.333 8A5.333 5.333 0 1 1 2.667 8a5.333 5.333 0 0 1 10.666 0zm1.334 0A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.334 0zM6.998 5.735a1.406 1.406 0 0 0-.331.932.667.667 0 0 1-1.334 0c0-.642.214-1.306.669-1.818C6.468 4.324 7.152 4 8 4c1.687 0 2.667 1.357 2.667 2.667 0 .417-.106.781-.372 1.116-.232.292-.565.532-.925.772-.472.314-.624.498-.673.58-.026.042-.03.05-.03.198a.667.667 0 0 1-1.334 0v-.01c0-.187 0-.507.22-.874.201-.335.549-.651 1.077-1.004.369-.246.535-.383.621-.491.052-.065.082-.125.082-.287 0-.69-.495-1.334-1.333-1.334-.486 0-.801.176-1.002.402zm1.669 5.598a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 67308:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M7.608 13.954a9.589 9.589 0 0 1-1.255 1.265 7.536 7.536 0 0 1-1.765 1.118 1 1 0 1 0 .824 1.822 9.455 9.455 0 0 0 2.235-1.416C9.639 15.051 11 12.969 11 10a4 4 0 1 0-3.392 3.954zm8.745 1.265a9.589 9.589 0 0 0 1.255-1.265A4 4 0 1 1 21 10c0 2.969-1.361 5.051-3.353 6.743a9.455 9.455 0 0 1-2.235 1.416.999.999 0 1 1-.824-1.822 7.536 7.536 0 0 0 1.765-1.118z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 8507:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#00a1b7\" d=\"M4 12V3a1 1 0 0 1 1-1h4c1.264 0 2.233.641 2.942 1.11l.084.055C12.814 3.685 13.342 4 14 4c.745 0 1.811-.398 2.803-.894a18.198 18.198 0 0 0 1.617-.921l.021-.014.005-.003A.998.998 0 0 1 20 3v9a1 1 0 0 1-.445.832L19 12l.555.832-.005.003-.008.006-.03.019-.108.07a20.529 20.529 0 0 1-1.707.964C16.689 14.398 15.255 15 14 15c-1.301 0-2.315-.645-3.062-1.121l-.055-.035C10.05 13.314 9.517 13 8.889 13H6v8a1 1 0 0 1-2 0v-9z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 80764:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#AEB7B8\" d=\"M4 12V3a1 1 0 0 1 1-1h4c1.264 0 2.233.641 2.942 1.11l.084.055C12.814 3.685 13.342 4 14 4c.745 0 1.811-.398 2.803-.894a18.198 18.198 0 0 0 1.617-.921l.021-.014.005-.003A.998.998 0 0 1 20 3v9a1 1 0 0 1-.445.832L19 12l.555.832-.005.003-.008.006-.03.019-.108.07a20.529 20.529 0 0 1-1.707.964C16.689 14.398 15.255 15 14 15c-1.301 0-2.315-.645-3.062-1.121l-.055-.035C10.05 13.314 9.517 13 8.889 13H6v8a1 1 0 0 1-2 0v-9z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 98763:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#e8e8e8\" d=\"M4 12V3a1 1 0 0 1 1-1h4c1.264 0 2.233.641 2.942 1.11l.084.055C12.814 3.685 13.342 4 14 4c.745 0 1.811-.398 2.803-.894a18.198 18.198 0 0 0 1.617-.921l.021-.014.005-.003A.998.998 0 0 1 20 3v9a1 1 0 0 1-.445.832L19 12l.555.832-.005.003-.008.006-.03.019-.108.07a20.529 20.529 0 0 1-1.707.964C16.689 14.398 15.255 15 14 15c-1.301 0-2.315-.645-3.062-1.121l-.055-.035C10.05 13.314 9.517 13 8.889 13H6v8a1 1 0 0 1-2 0v-9z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 55009:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#ed5454\" d=\"M4 12V3a1 1 0 0 1 1-1h4c1.264 0 2.233.641 2.942 1.11l.084.055C12.814 3.685 13.342 4 14 4c.745 0 1.811-.398 2.803-.894a18.198 18.198 0 0 0 1.617-.921l.021-.014.005-.003A.998.998 0 0 1 20 3v9a1 1 0 0 1-.445.832L19 12l.555.832-.005.003-.008.006-.03.019-.108.07a20.529 20.529 0 0 1-1.707.964C16.689 14.398 15.255 15 14 15c-1.301 0-2.315-.645-3.062-1.121l-.055-.035C10.05 13.314 9.517 13 8.889 13H6v8a1 1 0 0 1-2 0v-9z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 71138:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#00a1b7\" fill-rule=\"evenodd\" d=\"M12 5.683C10.842 4.777 9.185 4 7.5 4 4.724 4 2 6.296 2 9.688c0 1.52.245 2.73.773 3.83.52 1.084 1.285 1.996 2.206 2.956 1.036 1.08 2.713 2.192 4.056 3.004a47.811 47.811 0 0 0 2.454 1.383l.04.021.01.006.005.002L12 20l-.456.89c.286.146.626.147.912 0L12 20l.456.89.004-.002.011-.006.04-.02.15-.079c.128-.068.313-.166.54-.29.453-.248 1.078-.6 1.764-1.015 1.343-.812 3.02-1.925 4.056-3.004.921-.96 1.685-1.872 2.206-2.955.528-1.101.773-2.31.773-3.832C22 6.297 19.276 4 16.5 4c-1.685 0-3.342.777-4.5 1.683z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 85625:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#AEB7B8\" fill-rule=\"evenodd\" d=\"M12 5.683C10.842 4.777 9.185 4 7.5 4 4.724 4 2 6.296 2 9.688c0 1.52.245 2.73.773 3.83.52 1.084 1.285 1.996 2.206 2.956 1.036 1.08 2.713 2.192 4.056 3.004a47.811 47.811 0 0 0 2.454 1.383l.04.021.01.006.005.002L12 20l-.456.89c.286.146.626.147.912 0L12 20l.456.89.004-.002.011-.006.04-.02.15-.079c.128-.068.313-.166.54-.29.453-.248 1.078-.6 1.764-1.015 1.343-.812 3.02-1.925 4.056-3.004.921-.96 1.685-1.872 2.206-2.955.528-1.101.773-2.31.773-3.832C22 6.297 19.276 4 16.5 4c-1.685 0-3.342.777-4.5 1.683z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 16030:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#e8e8e8\" fill-rule=\"evenodd\" d=\"M12 5.683C10.842 4.777 9.185 4 7.5 4 4.724 4 2 6.296 2 9.688c0 1.52.245 2.73.773 3.83.52 1.084 1.285 1.996 2.206 2.956 1.036 1.08 2.713 2.192 4.056 3.004a47.811 47.811 0 0 0 2.454 1.383l.04.021.01.006.005.002L12 20l-.456.89c.286.146.626.147.912 0L12 20l.456.89.004-.002.011-.006.04-.02.15-.079c.128-.068.313-.166.54-.29.453-.248 1.078-.6 1.764-1.015 1.343-.812 3.02-1.925 4.056-3.004.921-.96 1.685-1.872 2.206-2.955.528-1.101.773-2.31.773-3.832C22 6.297 19.276 4 16.5 4c-1.685 0-3.342.777-4.5 1.683z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 61335:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#ed5454\" fill-rule=\"evenodd\" d=\"M12 5.683C10.842 4.777 9.185 4 7.5 4 4.724 4 2 6.296 2 9.688c0 1.52.245 2.73.773 3.83.52 1.084 1.285 1.996 2.206 2.956 1.036 1.08 2.713 2.192 4.056 3.004a47.811 47.811 0 0 0 2.454 1.383l.04.021.01.006.005.002L12 20l-.456.89c.286.146.626.147.912 0L12 20l.456.89.004-.002.011-.006.04-.02.15-.079c.128-.068.313-.166.54-.29.453-.248 1.078-.6 1.764-1.015 1.343-.812 3.02-1.925 4.056-3.004.921-.96 1.685-1.872 2.206-2.955.528-1.101.773-2.31.773-3.832C22 6.297 19.276 4 16.5 4c-1.685 0-3.342.777-4.5 1.683z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 37322:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#00a1b7\" fill-rule=\"evenodd\" d=\"M10.548 3.807c.467-1.343 2.367-1.343 2.834 0l1.65 4.748 5.026.103c1.422.029 2.009 1.836.875 2.695l-4.005 3.037 1.455 4.81c.412 1.362-1.125 2.479-2.292 1.666l-4.126-2.87-4.126 2.87c-1.167.813-2.704-.304-2.293-1.665l1.456-4.811-4.006-3.037c-1.133-.86-.546-2.666.876-2.695l5.026-.103 1.65-4.748z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 75851:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#AEB7B8\" fill-rule=\"evenodd\" d=\"M10.548 3.807c.467-1.343 2.367-1.343 2.834 0l1.65 4.748 5.026.103c1.422.029 2.009 1.836.875 2.695l-4.005 3.037 1.455 4.81c.412 1.362-1.125 2.479-2.292 1.666l-4.126-2.87-4.126 2.87c-1.167.813-2.704-.304-2.293-1.665l1.456-4.811-4.006-3.037c-1.133-.86-.546-2.666.876-2.695l5.026-.103 1.65-4.748z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 4735:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#e8e8e8\" fill-rule=\"evenodd\" d=\"M10.548 3.807c.467-1.343 2.367-1.343 2.834 0l1.65 4.748 5.026.103c1.422.029 2.009 1.836.875 2.695l-4.005 3.037 1.455 4.81c.412 1.362-1.125 2.479-2.292 1.666l-4.126-2.87-4.126 2.87c-1.167.813-2.704-.304-2.293-1.665l1.456-4.811-4.006-3.037c-1.133-.86-.546-2.666.876-2.695l5.026-.103 1.65-4.748z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 76936:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#fda639\" fill-rule=\"evenodd\" d=\"M10.548 3.807c.467-1.343 2.367-1.343 2.834 0l1.65 4.748 5.026.103c1.422.029 2.009 1.836.875 2.695l-4.005 3.037 1.455 4.81c.412 1.362-1.125 2.479-2.292 1.666l-4.126-2.87-4.126 2.87c-1.167.813-2.704-.304-2.293-1.665l1.456-4.811-4.006-3.037c-1.133-.86-.546-2.666.876-2.695l5.026-.103 1.65-4.748z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 14698:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.0002 32C24.8368 32 32.0002 24.8366 32.0002 16C32.0002 7.16344 24.8368 0 16.0002 0C7.16369 0 0.000244141 7.16344 0.000244141 16C0.000244141 24.8366 7.16369 32 16.0002 32Z\" fill=\"#00A1B7\"/> <rect x=\"11.0002\" y=\"11\" width=\"10\" height=\"10\" rx=\"5\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 20065:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.58963 3.36764C4.85564 3.10011 5.28727 3.10011 5.55328 3.36764C5.81876 3.63464 5.81876 4.06716 5.55328 4.33416L4.65667 5.23596H10.5572C12.8277 5.23596 14.6667 7.0869 14.6667 9.36814C14.6667 11.6494 12.8277 13.5003 10.5572 13.5003H5.75717C5.3802 13.5003 5.07622 13.1932 5.07622 12.8164C5.07622 12.4396 5.3802 12.1325 5.75717 12.1325H10.5572C12.0737 12.1325 13.3048 10.8958 13.3048 9.36814C13.3048 7.84052 12.0737 6.60377 10.5572 6.60377H4.65667L5.55328 7.50557C5.81876 7.77258 5.81876 8.20506 5.55328 8.47207C5.28727 8.73961 4.85564 8.73961 4.58963 8.47207L2.53249 6.40312C2.267 6.13612 2.267 5.70361 2.53249 5.43661L4.58963 3.36764Z\" fill=\"currentColor\"></path>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 88170:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z\" fill=\"#00A1B7\"/> <path d=\"M15.3333 9.33337C14.2288 9.33337 13.3333 10.2288 13.3333 11.3334V12H11.3333C10.9651 12 10.6667 12.2985 10.6667 12.6667C10.6667 13.0349 10.9651 13.3334 11.3333 13.3334V20.6667C11.3333 21.7713 12.2288 22.6667 13.3333 22.6667H18.6667C19.7712 22.6667 20.6667 21.7713 20.6667 20.6667V13.3334C21.0348 13.3334 21.3333 13.0349 21.3333 12.6667C21.3333 12.2985 21.0348 12 20.6667 12H18.6667V11.3334C18.6667 10.2288 17.7712 9.33337 16.6667 9.33337H15.3333ZM17.3333 12H14.6667V11.3334C14.6667 10.9652 14.9651 10.6667 15.3333 10.6667H16.6667C17.0348 10.6667 17.3333 10.9652 17.3333 11.3334V12ZM12.6667 13.3334L19.3333 13.3334V20.6667C19.3333 21.0349 19.0348 21.3334 18.6667 21.3334H13.3333C12.9651 21.3334 12.6667 21.0349 12.6667 20.6667V13.3334ZM15.3333 15.3334V19.3334C15.3333 19.7016 15.0348 20 14.6667 20C14.2985 20 14 19.7016 14 19.3334V15.3334C14 14.9652 14.2985 14.6667 14.6667 14.6667C15.0348 14.6667 15.3333 14.9652 15.3333 15.3334ZM17.3333 14.6667C16.9651 14.6667 16.6667 14.9652 16.6667 15.3334V19.3334C16.6667 19.7016 16.9651 20 17.3333 20C17.7015 20 18 19.7016 18 19.3334V15.3334C18 14.9652 17.7015 14.6667 17.3333 14.6667Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 36039:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M4.66683 4C4.29864 4 4.00016 4.29848 4.00016 4.66667C4.00016 5.03486 4.29864 5.33333 4.66683 5.33333H9.3335C10.5761 5.33333 11.6201 6.18318 11.9162 7.33333H11.0819C10.728 7.33333 10.537 7.7762 10.7674 8.06287L12.1007 9.72221C12.3983 10.0926 12.9354 10.0926 13.233 9.72221L14.5663 8.06287C14.7966 7.7762 14.6057 7.33333 14.2518 7.33333H13.2782C12.9608 5.44152 11.3155 4 9.3335 4H4.66683Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M12.0002 11.3333C12.0002 11.7015 11.7017 12 11.3335 12H6.66683C4.68483 12 3.03952 10.5585 2.72213 8.66667H1.74857C1.39463 8.66667 1.20369 8.2238 1.43403 7.93713L2.76732 6.27779C3.06493 5.9074 3.60207 5.9074 3.89967 6.27779L5.23296 7.93713C5.4633 8.2238 5.27236 8.66667 4.91842 8.66667H4.08417C4.3802 9.81682 5.42427 10.6667 6.66683 10.6667H11.3335C11.7017 10.6667 12.0002 10.9651 12.0002 11.3333Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 91323:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" d=\"M12 6v6H6zM4 4h6l-6 6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 61762:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"47","height":"46","viewBox":"0 0 47 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.1583 11.3914C44.1583 9.56889 42.6808 8.09143 40.8583 8.09143H33.275C32.557 8.09143 31.975 8.67346 31.975 9.39143C31.975 10.1094 32.557 10.6914 33.275 10.6914H40.8583C41.2449 10.6914 41.5583 11.0048 41.5583 11.3914V16.0998C41.5583 16.8177 42.1403 17.3998 42.8583 17.3998C43.5763 17.3998 44.1583 16.8177 44.1583 16.0998V11.3914ZM15.4083 9.39143C15.4083 8.67346 14.8263 8.09143 14.1083 8.09143H6.52497C4.70243 8.09143 3.22498 9.56889 3.22498 11.3914V16.0998C3.22498 16.8177 3.807 17.3998 4.52497 17.3998C5.24295 17.3998 5.82497 16.8177 5.82497 16.0998V11.3914C5.82497 11.0048 6.13837 10.6914 6.52497 10.6914H14.1083C14.8263 10.6914 15.4083 10.1094 15.4083 9.39143ZM42.8583 28.2164C42.1403 28.2164 41.5583 28.7985 41.5583 29.5164V34.2248C41.5583 34.6114 41.2449 34.9248 40.8583 34.9248H33.275C32.557 34.9248 31.975 35.5068 31.975 36.2248C31.975 36.9427 32.557 37.5248 33.275 37.5248H40.8583C42.6808 37.5248 44.1583 36.0473 44.1583 34.2248V29.5164C44.1583 28.7985 43.5763 28.2164 42.8583 28.2164Z\" fill=\"#00A1B7\"/> <path d=\"M29.5833 23C29.5833 21.8 28.1274 21.0236 25.2157 19.4706C22.5888 18.0696 21.2753 17.3691 20.3043 17.9517L20.3043 17.9517C19.3333 18.5343 19.3333 20.0229 19.3333 23C19.3333 25.9772 19.3333 27.4658 20.3043 28.0484C21.2753 28.631 22.5888 27.9305 25.2157 26.5295C28.1274 24.9765 29.5833 24.2 29.5833 23Z\" fill=\"#00A1B7\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.5 33C19.5 37.9706 15.4706 42 10.5 42C5.52944 42 1.5 37.9706 1.5 33C1.5 28.0294 5.52944 24 10.5 24C15.4706 24 19.5 28.0294 19.5 33ZM12.8625 30.6375C12.8625 31.9423 11.8048 33 10.5 33C9.19523 33 8.1375 31.9423 8.1375 30.6375C8.1375 29.3327 9.19523 28.275 10.5 28.275C11.8048 28.275 12.8625 29.3327 12.8625 30.6375ZM13.8718 37.0538C14.3662 36.8479 14.5539 36.2508 14.224 35.829C13.3592 34.7233 12.0126 34.0125 10.5 34.0125C8.98738 34.0125 7.64079 34.7233 6.77596 35.829C6.44606 36.2508 6.6338 36.8479 7.12812 37.0538C8.16623 37.4862 9.30522 37.725 10.5 37.725C11.6947 37.725 12.8337 37.4862 13.8718 37.0538Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 80562:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"47","height":"46","viewBox":"0 0 47 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.1583 11.3914C44.1583 9.56889 42.6808 8.09143 40.8583 8.09143H33.275C32.557 8.09143 31.975 8.67346 31.975 9.39143C31.975 10.1094 32.557 10.6914 33.275 10.6914H40.8583C41.2449 10.6914 41.5583 11.0048 41.5583 11.3914V16.0998C41.5583 16.8177 42.1403 17.3998 42.8583 17.3998C43.5763 17.3998 44.1583 16.8177 44.1583 16.0998V11.3914ZM15.4083 9.39143C15.4083 8.67346 14.8263 8.09143 14.1083 8.09143H6.52497C4.70243 8.09143 3.22498 9.56889 3.22498 11.3914V16.0998C3.22498 16.8177 3.807 17.3998 4.52497 17.3998C5.24295 17.3998 5.82497 16.8177 5.82497 16.0998V11.3914C5.82497 11.0048 6.13837 10.6914 6.52497 10.6914H14.1083C14.8263 10.6914 15.4083 10.1094 15.4083 9.39143ZM42.8583 28.2164C42.1403 28.2164 41.5583 28.7985 41.5583 29.5164V34.2248C41.5583 34.6114 41.2449 34.9248 40.8583 34.9248H33.275C32.557 34.9248 31.975 35.5068 31.975 36.2248C31.975 36.9427 32.557 37.5248 33.275 37.5248H40.8583C42.6808 37.5248 44.1583 36.0473 44.1583 34.2248V29.5164C44.1583 28.7985 43.5763 28.2164 42.8583 28.2164Z\" fill=\"#A5B3BD\"/> <path d=\"M29.5833 23C29.5833 21.8 28.1274 21.0236 25.2157 19.4706C22.5888 18.0696 21.2753 17.3691 20.3043 17.9517L20.3043 17.9517C19.3333 18.5343 19.3333 20.0229 19.3333 23C19.3333 25.9772 19.3333 27.4658 20.3043 28.0484C21.2753 28.631 22.5888 27.9305 25.2157 26.5295C28.1274 24.9765 29.5833 24.2 29.5833 23Z\" fill=\"#A5B3BD\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.5 33C19.5 37.9706 15.4706 42 10.5 42C5.52944 42 1.5 37.9706 1.5 33C1.5 28.0294 5.52944 24 10.5 24C15.4706 24 19.5 28.0294 19.5 33ZM12.8625 30.6375C12.8625 31.9423 11.8048 33 10.5 33C9.19523 33 8.1375 31.9423 8.1375 30.6375C8.1375 29.3327 9.19523 28.275 10.5 28.275C11.8048 28.275 12.8625 29.3327 12.8625 30.6375ZM13.8718 37.0538C14.3662 36.8479 14.5539 36.2508 14.224 35.829C13.3592 34.7233 12.0126 34.0125 10.5 34.0125C8.98738 34.0125 7.64079 34.7233 6.77596 35.829C6.44606 36.2508 6.6338 36.8479 7.12812 37.0538C8.16623 37.4862 9.30522 37.725 10.5 37.725C11.6947 37.725 12.8337 37.4862 13.8718 37.0538Z\" fill=\"#A5B3BD\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 77142:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"47","height":"46","viewBox":"0 0 47 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.1583 11.3914C44.1583 9.56889 42.6808 8.09143 40.8583 8.09143H33.275C32.557 8.09143 31.975 8.67346 31.975 9.39143C31.975 10.1094 32.557 10.6914 33.275 10.6914H40.8583C41.2449 10.6914 41.5583 11.0048 41.5583 11.3914V16.0998C41.5583 16.8177 42.1403 17.3998 42.8583 17.3998C43.5763 17.3998 44.1583 16.8177 44.1583 16.0998V11.3914ZM15.4083 9.39143C15.4083 8.67346 14.8263 8.09143 14.1083 8.09143H6.52497C4.70243 8.09143 3.22498 9.56889 3.22498 11.3914V16.0998C3.22498 16.8177 3.807 17.3998 4.52497 17.3998C5.24295 17.3998 5.82497 16.8177 5.82497 16.0998V11.3914C5.82497 11.0048 6.13837 10.6914 6.52497 10.6914H14.1083C14.8263 10.6914 15.4083 10.1094 15.4083 9.39143ZM42.8583 28.2164C42.1403 28.2164 41.5583 28.7985 41.5583 29.5164V34.2248C41.5583 34.6114 41.2449 34.9248 40.8583 34.9248H33.275C32.557 34.9248 31.975 35.5068 31.975 36.2248C31.975 36.9427 32.557 37.5248 33.275 37.5248H40.8583C42.6808 37.5248 44.1583 36.0473 44.1583 34.2248V29.5164C44.1583 28.7985 43.5763 28.2164 42.8583 28.2164ZM4.52497 28.2164C3.807 28.2164 3.22498 28.7985 3.22498 29.5164V34.2248C3.22498 36.0473 4.70243 37.5248 6.52497 37.5248H14.1083C14.8263 37.5248 15.4083 36.9427 15.4083 36.2248C15.4083 35.5068 14.8263 34.9248 14.1083 34.9248H6.52497C6.13838 34.9248 5.82497 34.6114 5.82497 34.2248V29.5164C5.82497 28.7985 5.24295 28.2164 4.52497 28.2164Z\" fill=\"#00A1B7\"/> <path d=\"M29.5833 23C29.5833 21.8 28.1274 21.0236 25.2157 19.4706C22.5888 18.0696 21.2753 17.3691 20.3043 17.9517L20.3043 17.9517C19.3333 18.5343 19.3333 20.0229 19.3333 23C19.3333 25.9772 19.3333 27.4658 20.3043 28.0484C21.2753 28.631 22.5888 27.9305 25.2157 26.5295C28.1274 24.9765 29.5833 24.2 29.5833 23Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 30315:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"47","height":"46","viewBox":"0 0 47 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.1583 11.3914C44.1583 9.56889 42.6808 8.09143 40.8583 8.09143H33.275C32.557 8.09143 31.975 8.67346 31.975 9.39143C31.975 10.1094 32.557 10.6914 33.275 10.6914H40.8583C41.2449 10.6914 41.5583 11.0048 41.5583 11.3914V16.0998C41.5583 16.8177 42.1403 17.3998 42.8583 17.3998C43.5763 17.3998 44.1583 16.8177 44.1583 16.0998V11.3914ZM15.4083 9.39143C15.4083 8.67346 14.8263 8.09143 14.1083 8.09143H6.52497C4.70243 8.09143 3.22498 9.56889 3.22498 11.3914V16.0998C3.22498 16.8177 3.807 17.3998 4.52497 17.3998C5.24295 17.3998 5.82497 16.8177 5.82497 16.0998V11.3914C5.82497 11.0048 6.13837 10.6914 6.52497 10.6914H14.1083C14.8263 10.6914 15.4083 10.1094 15.4083 9.39143ZM42.8583 28.2164C42.1403 28.2164 41.5583 28.7985 41.5583 29.5164V34.2248C41.5583 34.6114 41.2449 34.9248 40.8583 34.9248H33.275C32.557 34.9248 31.975 35.5068 31.975 36.2248C31.975 36.9427 32.557 37.5248 33.275 37.5248H40.8583C42.6808 37.5248 44.1583 36.0473 44.1583 34.2248V29.5164C44.1583 28.7985 43.5763 28.2164 42.8583 28.2164ZM4.52497 28.2164C3.807 28.2164 3.22498 28.7985 3.22498 29.5164V34.2248C3.22498 36.0473 4.70243 37.5248 6.52497 37.5248H14.1083C14.8263 37.5248 15.4083 36.9427 15.4083 36.2248C15.4083 35.5068 14.8263 34.9248 14.1083 34.9248H6.52497C6.13838 34.9248 5.82497 34.6114 5.82497 34.2248V29.5164C5.82497 28.7985 5.24295 28.2164 4.52497 28.2164Z\" fill=\"#A5B3BD\"/> <path d=\"M29.5833 23C29.5833 21.8 28.1274 21.0236 25.2157 19.4706C22.5888 18.0696 21.2753 17.3691 20.3043 17.9517L20.3043 17.9517C19.3333 18.5343 19.3333 20.0229 19.3333 23C19.3333 25.9772 19.3333 27.4658 20.3043 28.0484C21.2753 28.631 22.5888 27.9305 25.2157 26.5295C28.1274 24.9765 29.5833 24.2 29.5833 23Z\" fill=\"#A5B3BD\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 26350:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <circle cx=\"9.5\" cy=\"6.5\" r=\"5\" stroke=\"#5C6061\"/>         <path class=\"graphic\" stroke=\"#5C6061\" stroke-linecap=\"round\" stroke-width=\"2\" d=\"M5 11l-2.5 2.5\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 31665:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M10.667 3.333a1.333 1.333 0 1 0 0 2.667 1.333 1.333 0 0 0 0-2.667zM8 4.667a2.667 2.667 0 1 1 .487 1.537l-1.356.775c.13.314.202.659.202 1.021 0 .362-.072.707-.202 1.021l1.356.775a2.667 2.667 0 1 1-.474 1.265l-1.694-.968a2.667 2.667 0 1 1 0-4.187l1.695-.967A2.712 2.712 0 0 1 8 4.667zm-3.333 2a1.333 1.333 0 1 0 0 2.666 1.333 1.333 0 0 0 0-2.666zm4.666 4.666a1.333 1.333 0 1 1 2.667 0 1.333 1.333 0 0 1-2.667 0z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 71571:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"19","height":"17","viewBox":"0 0 19 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M6 0C6.55228 0 7 0.447715 7 1V7H11V1C11 0.447715 11.4477 0 12 0C12.5523 0 13 0.447715 13 1V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V9H7V15C7 15.5523 6.55228 16 6 16C5.44772 16 5 15.5523 5 15V1C5 0.447715 5.44772 0 6 0Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M16.4592 11C16.3183 11 16.1852 11.0647 16.0981 11.1755C16.0819 11.1962 16.0697 11.2148 16.0612 11.23C16.0942 11.3176 16.134 11.3773 16.1718 11.4124C16.1919 11.4311 16.2178 11.4492 16.2583 11.4646C16.2998 11.4803 16.3751 11.5 16.5 11.5C17.1025 11.5 17.6161 11.654 18.0266 11.942C18.4313 12.2259 18.6665 12.5912 18.8005 12.904C19.1429 13.7037 18.7843 14.4426 18.5198 14.8273C17.5437 16.2471 15.5124 16.4183 14.3124 15.1819L14.2824 15.151C13.8978 14.7547 13.9072 14.1216 14.3035 13.737C14.6998 13.3523 15.3329 13.3618 15.7176 13.7581L15.7476 13.789C16.0682 14.1193 16.6109 14.0736 16.8717 13.6942C16.8916 13.6653 16.907 13.6392 16.9184 13.6169C16.9059 13.6016 16.8924 13.5894 16.878 13.5793C16.8514 13.5606 16.7533 13.5 16.5 13.5C15.7988 13.5 15.2293 13.2667 14.8105 12.8776C14.4138 12.5091 14.2197 12.0641 14.1223 11.7345C13.9022 10.9897 14.2163 10.3334 14.5255 9.93987C14.9917 9.34648 15.7046 9 16.4592 9H16.5432C16.8963 9 17.2459 9.07108 17.571 9.20902L18.0156 9.3976C18.524 9.61329 18.7613 10.2003 18.5456 10.7087C18.3299 11.2172 17.7429 11.4545 17.2344 11.2388L16.7899 11.0502C16.7119 11.0171 16.628 11 16.5432 11H16.4592Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M2.31204 9.6109C2.15191 9.81056 1.84807 9.81056 1.68794 9.6109L0.11556 7.65025C-0.0944184 7.38842 0.0919813 7 0.427607 7H3.57237C3.908 7 4.0944 7.38842 3.88442 7.65025L2.31204 9.6109Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 37620:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" d=\"M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10zm0 1A6 6 0 1 1 8 2a6 6 0 0 1 0 12zM6 9h4c0 1.333-.667 2-2 2s-2-.667-2-2zm4-1c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8zM6 8c-.552 0-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5S6.552 8 6 8z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 17884:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<path class=\"graphic\" fill=\"#FFF\" fill-rule=\"evenodd\" d=\"M2.667 3.333a.667.667 0 0 0 0 1.334H8a.667.667 0 1 0 0-1.334H2.667zM2 8c0-.368.298-.667.667-.667h8a.667.667 0 1 1 0 1.334h-8A.667.667 0 0 1 2 8zm0 4c0-.368.298-.667.667-.667h10.666a.667.667 0 1 1 0 1.334H2.667A.667.667 0 0 1 2 12z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 59681:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<path class=\"graphic\" fill=\"#FFF\" fill-rule=\"evenodd\" d=\"M2 4c0-.368.298-.667.667-.667h10.666a.667.667 0 1 1 0 1.334H2.667A.667.667 0 0 1 2 4zm0 4c0-.368.298-.667.667-.667h8a.667.667 0 1 1 0 1.334h-8A.667.667 0 0 1 2 8zm.667 3.333a.667.667 0 1 0 0 1.334H8a.667.667 0 1 0 0-1.334H2.667z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 24570:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"19","height":"14","viewBox":"0 0 19 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"player\" d=\"M1.13867 8.89784C0.437787 7.7297 0.437786 6.27037 1.13867 5.10223C1.36726 4.72125 1.75537 4.46355 2.19521 4.40072L4.5262 4.06772C4.82768 4.02465 5.09654 3.85521 5.26546 3.60182L5.63256 3.05118C5.9233 2.61507 6.06869 2.39699 6.23034 2.20094C6.80071 1.50925 7.54656 0.983633 8.38979 0.679139C8.62879 0.592836 8.88304 0.529272 9.39155 0.402145L10.0046 0.248883C10.3447 0.163862 10.5147 0.121352 10.6486 0.163014C10.7648 0.199186 10.8638 0.276507 10.9271 0.38048C11 0.500235 11 0.675509 11 1.02606V12.974C11 13.3246 11 13.4998 10.9271 13.6196C10.8638 13.7236 10.7648 13.8009 10.6486 13.8371C10.5147 13.8787 10.3447 13.8362 10.0046 13.7512L9.39155 13.5979C8.88304 13.4708 8.62879 13.4072 8.38979 13.3209C7.54656 13.0164 6.80071 12.4908 6.23034 11.7991C6.06868 11.6031 5.92331 11.385 5.63256 10.9489L5.26546 10.3983C5.09654 10.1449 4.82768 9.97542 4.5262 9.93235L2.19521 9.59935C1.75537 9.53652 1.36726 9.27883 1.13867 8.89784Z\" fill=\"#00A1B7\"/> <path class=\"player\" d=\"M18.7071 4.29293C19.0976 4.68345 19.0976 5.31662 18.7071 5.70714L17.4142 7.00004L18.7071 8.29293C19.0976 8.68345 19.0976 9.31662 18.7071 9.70714C18.3166 10.0977 17.6834 10.0977 17.2929 9.70714L16 8.41425L14.7071 9.70714C14.3166 10.0977 13.6834 10.0977 13.2929 9.70714C12.9024 9.31662 12.9024 8.68345 13.2929 8.29293L14.5858 7.00004L13.2929 5.70714C12.9024 5.31662 12.9024 4.68345 13.2929 4.29293C13.6834 3.90241 14.3166 3.90241 14.7071 4.29293L16 5.58582L17.2929 4.29293C17.6834 3.90241 18.3166 3.90241 18.7071 4.29293Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 10653:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"14","viewBox":"0 0 16 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"player\" d=\"M1.13867 8.89784C0.437787 7.7297 0.437786 6.27037 1.13867 5.10223C1.36726 4.72125 1.75537 4.46355 2.19521 4.40072L4.5262 4.06772C4.82768 4.02465 5.09654 3.85521 5.26546 3.60182L5.63256 3.05118C5.92331 2.61505 6.06868 2.39699 6.23034 2.20094C6.80071 1.50925 7.54656 0.983633 8.38979 0.679139C8.62879 0.592835 8.88304 0.529272 9.39155 0.402145L10.0046 0.248883C10.3447 0.163862 10.5147 0.121352 10.6486 0.163014C10.7648 0.199186 10.8638 0.276507 10.9271 0.38048C11 0.500235 11 0.675509 11 1.02606V12.974C11 13.3246 11 13.4998 10.9271 13.6196C10.8638 13.7236 10.7648 13.8009 10.6486 13.8371C10.5147 13.8787 10.3447 13.8362 10.0046 13.7512L9.39155 13.5979C8.88304 13.4708 8.62879 13.4072 8.38979 13.3209C7.54656 13.0164 6.80071 12.4908 6.23034 11.7991C6.06868 11.6031 5.92331 11.385 5.63256 10.9489L5.26546 10.3983C5.09654 10.1449 4.82768 9.97542 4.5262 9.93235L2.19521 9.59935C1.75537 9.53652 1.36726 9.27883 1.13867 8.89784Z\" fill=\"#00A1B7\"/> <path class=\"player\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.0052 2.93417C13.2981 2.64128 13.773 2.64128 14.0658 2.93417C15.1386 4.00696 15.744 5.46025 15.7499 6.97738C15.7559 8.49452 15.1621 9.95254 14.0978 11.0337C13.8072 11.3289 13.3323 11.3327 13.0371 11.0421C12.7419 10.7515 12.7382 10.2767 13.0288 9.98147C13.8154 9.18232 14.2544 8.10465 14.25 6.98329C14.2455 5.86193 13.7981 4.78776 13.0052 3.99483C12.7123 3.70194 12.7123 3.22707 13.0052 2.93417Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 42941:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M8.81935 3.19213C9.20847 2.07268 10.7916 2.07267 11.1808 3.19213L12.5561 7.14875L16.7441 7.2341C17.929 7.25824 18.4182 8.76392 17.4738 9.47993L14.1358 12.0106L15.3488 16.02C15.692 17.1543 14.4112 18.0849 13.4384 17.408L10.0001 15.0154L6.56175 17.408C5.58895 18.0849 4.30813 17.1544 4.65132 16.02L5.86431 12.0106L2.52634 9.47993C1.58192 8.76393 2.07114 7.25824 3.25605 7.2341L7.44402 7.14875L8.81935 3.19213ZM10.0001 4.87159L8.9231 7.96984C8.75144 8.46368 8.29058 8.79851 7.76786 8.80917L4.48845 8.876L7.10227 10.8577C7.51889 11.1735 7.69493 11.7153 7.54353 12.2157L6.5937 15.3553L9.28608 13.4817C9.71522 13.1831 10.2849 13.1831 10.714 13.4817L13.4064 15.3553L12.4566 12.2157C12.3052 11.7153 12.4812 11.1735 12.8978 10.8577L15.5116 8.876L12.2322 8.80917C11.7095 8.79851 11.2487 8.46368 11.077 7.96984L10.0001 4.87159Z\" fill=\"black\" fill-opacity=\"0.54\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 57551:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.10057 3.88063C3.22336 3.98697 3.22336 4.17746 3.10057 4.2838L1.77458 5.43214C1.60187 5.58171 1.33334 5.45903 1.33334 5.23056V2.93387C1.33334 2.7054 1.60187 2.58272 1.77458 2.73229L3.10057 3.88063ZM6.66667 3.41555C6.29848 3.41555 6 3.71402 6 4.08221C6 4.4504 6.29848 4.74888 6.66667 4.74888H14C14.3682 4.74888 14.6667 4.4504 14.6667 4.08221C14.6667 3.71402 14.3682 3.41555 14 3.41555H6.66667ZM6.66667 7.41555C6.29848 7.41555 6 7.71402 6 8.08221C6 8.4504 6.29848 8.74888 6.66667 8.74888H14C14.3682 8.74888 14.6667 8.4504 14.6667 8.08221C14.6667 7.71402 14.3682 7.41555 14 7.41555H6.66667ZM6 12.0822C6 11.714 6.29848 11.4155 6.66667 11.4155H14C14.3682 11.4155 14.6667 11.714 14.6667 12.0822C14.6667 12.4504 14.3682 12.7489 14 12.7489H6.66667C6.29848 12.7489 6 12.4504 6 12.0822Z\" fill=\"#737373\"/>   <path class=\"graphic\" d=\"M5 2.66669C5.18409 2.66669 5.33333 2.81593 5.33333 3.00002V5.00002C5.33333 5.18412 5.18409 5.33335 5 5.33335C4.81591 5.33335 4.66667 5.18412 4.66667 5.00002V3.80476L4.56904 3.90239C4.43886 4.03256 4.22781 4.03256 4.09763 3.90239C3.96746 3.77221 3.96746 3.56116 4.09763 3.43098L4.7643 2.76432C4.82462 2.704 4.90795 2.66669 5 2.66669Z\" fill=\"#737373\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 14345:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.0002 32C24.8368 32 32.0002 24.8366 32.0002 16C32.0002 7.16344 24.8368 0 16.0002 0C7.16369 0 0.000244141 7.16344 0.000244141 16C0.000244141 24.8366 7.16369 32 16.0002 32Z\" fill=\"#00A1B7\"/> <rect x=\"11.0002\" y=\"11\" width=\"10\" height=\"10\" rx=\"1\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 27501:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12.073 4.245c-2.44 0-4.145 1.665-4.145 3.409 0 .866.421 1.713 1.144 2.346H6.526a4.867 4.867 0 0 1-.598-2.346c0-3.127 2.902-5.409 6.145-5.409 2.685 0 5.082 1.533 5.877 3.821a1 1 0 0 1-1.889.656c-.471-1.355-2.011-2.477-3.988-2.477zm-.345 8.809a.955.955 0 0 0 .132.008c2.44 0 4.145 1.666 4.145 3.409 0 1.744-1.705 3.409-4.145 3.409-1.164 0-2.196-.395-2.936-1.007a3.354 3.354 0 0 1-1.052-1.47 1 1 0 1 0-1.889.656 5.36 5.36 0 0 0 1.666 2.355c1.112.92 2.599 1.466 4.211 1.466 3.243 0 6.145-2.282 6.145-5.409 0-1.354-.544-2.55-1.426-3.471H19a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2h6.146c.192.026.386.044.582.054z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 62428:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M4.00004 6C4.00004 3.79086 5.7909 2 8.00004 2C10.2092 2 12 3.79086 12 6V6.66667C12.7364 6.66667 13.3334 7.26362 13.3334 8V9.33333C13.3334 9.84269 13.0478 10.2853 12.628 10.5099C12.3825 12.1088 11.001 13.3333 9.33337 13.3333H9.155C8.92446 13.7319 8.49356 14 8.00004 14C7.26366 14 6.66671 13.403 6.66671 12.6667C6.66671 11.9303 7.26366 11.3333 8.00004 11.3333C8.49356 11.3333 8.92446 11.6015 9.155 12H9.33337C10.2076 12 10.9508 11.4391 11.2228 10.6575C10.9072 10.6048 10.6667 10.3305 10.6667 10V6C10.6667 4.52724 9.4728 3.33333 8.00004 3.33333C6.52728 3.33333 5.33337 4.52724 5.33337 6V10C5.33337 10.3682 5.0349 10.6667 4.66671 10.6667H4.00004C3.26366 10.6667 2.66671 10.0697 2.66671 9.33333V8C2.66671 7.26362 3.26366 6.66667 4.00004 6.66667V6Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 82481:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M5.68824 3.06668C5.51046 3.20002 5.51046 3.46668 5.68824 3.60002L7.46602 4.93335C7.68576 5.09816 7.99935 4.94136 7.99935 4.66668V4.00002C10.2085 4.00002 11.9993 5.79088 11.9993 8.00002C11.9993 8.75518 11.7907 9.45958 11.4283 10.061C11.2383 10.3764 11.3399 10.7861 11.6553 10.9761C11.9706 11.1661 12.3803 11.0645 12.5704 10.7491C13.0544 9.94584 13.3327 9.00441 13.3327 8.00002C13.3327 5.0545 10.9449 2.66668 7.99935 2.66668V2.00002C7.99935 1.72533 7.68576 1.56854 7.46602 1.73335L5.68824 3.06668ZM4.29082 5.08961C4.60952 5.27397 4.71843 5.68179 4.53407 6.0005C4.19412 6.58817 3.99935 7.27033 3.99935 8.00002C3.99935 10.2092 5.79021 12 7.99935 12V11.3333C7.99935 11.0587 8.31294 10.9019 8.53268 11.0667L10.3105 12.4C10.4882 12.5333 10.4882 12.8 10.3105 12.9333L8.53268 14.2667C8.31294 14.4315 7.99935 14.2747 7.99935 14V13.3333C5.05383 13.3333 2.66602 10.9455 2.66602 8.00002C2.66602 7.02969 2.92575 6.11801 3.37993 5.33286C3.56429 5.01416 3.97211 4.90525 4.29082 5.08961Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 18294:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.97429 3.51649C10.0754 3.16247 9.87045 2.79348 9.51642 2.69233C9.1624 2.59118 8.79341 2.79617 8.69226 3.15019L6.02559 12.4835C5.92444 12.8376 6.12944 13.2065 6.48346 13.3077C6.83749 13.4088 7.20648 13.2038 7.30763 12.8498L9.97429 3.51649ZM5.08307 4.1461C5.37058 4.3761 5.4172 4.79563 5.18719 5.08314L2.85369 8.00001L5.18719 10.9169C5.4172 11.2044 5.37058 11.6239 5.08307 11.8539C4.79557 12.0839 4.37604 12.0373 4.14603 11.7498L1.48772 8.42691C1.45077 8.38268 1.42032 8.33449 1.3965 8.28373C1.354 8.19355 1.33319 8.09656 1.33325 8.00001C1.33319 7.90346 1.354 7.80647 1.39649 7.71629C1.42031 7.66553 1.45077 7.61734 1.48772 7.57311L4.14603 4.25021C4.37604 3.9627 4.79556 3.91609 5.08307 4.1461ZM10.9168 4.1461C11.2043 3.91609 11.6238 3.9627 11.8539 4.25021L14.5123 7.57322C14.5485 7.61657 14.5784 7.66372 14.602 7.71337C14.6454 7.80438 14.6667 7.90242 14.6666 8.00001C14.6667 8.0976 14.6454 8.19564 14.602 8.28665C14.5784 8.33629 14.5485 8.38344 14.5123 8.42679L11.8539 11.7498C11.6238 12.0373 11.2043 12.0839 10.9168 11.8539C10.6293 11.6239 10.5827 11.2044 10.8127 10.9169L13.1462 8.00001L10.8127 5.08314C10.5827 4.79563 10.6293 4.3761 10.9168 4.1461Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 20913:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M2 7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7zm3-1a1 1 0 0 0-1 1v4h7V6H5zm6 7H4v4a1 1 0 0 0 1 1h6v-5zm2 0h7v4a1 1 0 0 1-1 1h-6v-5zm7-2V7a1 1 0 0 0-1-1h-6v5h7z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 12216:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M5 3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5zm0 2h4v4H5V5zm0 8a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H5zm0 2h4v4H5v-4zm8-6a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1-1-1zm1-5a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-6zm-1 11a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1-1-1zm1 3a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 64268:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M2.5 4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H7.5C8.42047 2.5 9.16667 3.24619 9.16667 4.16667V7.5C9.16667 8.42047 8.42047 9.16667 7.5 9.16667H4.16667C3.24619 9.16667 2.5 8.42047 2.5 7.5V4.16667ZM7.5 4.16667H4.16667V7.5H7.5V4.16667Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M2.5 12.5C2.5 11.5795 3.24619 10.8333 4.16667 10.8333H7.5C8.42047 10.8333 9.16667 11.5795 9.16667 12.5V15.8333C9.16667 16.7538 8.42047 17.5 7.5 17.5H4.16667C3.24619 17.5 2.5 16.7538 2.5 15.8333V12.5ZM7.5 12.5H4.16667V15.8333H7.5V12.5Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M12.5 2.5C11.5795 2.5 10.8333 3.24619 10.8333 4.16667V15.8333C10.8333 16.7538 11.5795 17.5 12.5 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5H12.5ZM12.5 4.16667H15.8333V15.8333H12.5V4.16667Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 62171:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"31","height":"35","viewBox":"0 0 31 35","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 23.9C0 23.4029 0.402944 23 0.9 23H26.9272C27.4242 23 27.8272 23.4029 27.8272 23.9V24.2C27.8272 24.6971 27.4242 25.1 26.9272 25.1H0.9C0.402943 25.1 0 24.6971 0 24.2V23.9ZM0 28.4C0 27.9029 0.402944 27.5 0.9 27.5H26.9272C27.4242 27.5 27.8272 27.9029 27.8272 28.4V28.7C27.8272 29.1971 27.4242 29.6 26.9272 29.6H0.9C0.402943 29.6 0 29.1971 0 28.7V28.4ZM0.9 32C0.402944 32 0 32.4029 0 32.9V33.2C0 33.6971 0.402944 34.1 0.900001 34.1H19.063C19.56 34.1 19.963 33.6971 19.963 33.2V32.9C19.963 32.4029 19.56 32 19.063 32H0.9Z\" fill=\"#E8E8E8\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z\" fill=\"#E8E8E8\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.3152 4.88556L16.9452 16.0355L30.9733 7.36356L19.3152 4.88556Z\" fill=\"#E8E8E8\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 76094:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"9","height":"10","viewBox":"0 0 9 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M5.65527 10V2.71289H8.30225V0.840332H0.691406V2.71289H3.33203V10H5.65527Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 88536:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3.333 2C2.597 2 2 2.597 2 3.333V6c0 .736.597 1.333 1.333 1.333H6c.737 0 1.333-.597 1.333-1.333V3.333C7.333 2.597 6.737 2 6 2H3.333zm0 1.333H6V6H3.333V3.333zm0 5.334C2.597 8.667 2 9.264 2 10v2.667C2 13.403 2.597 14 3.333 14H6c.737 0 1.333-.597 1.333-1.333V10c0-.736-.596-1.333-1.333-1.333H3.333zm0 1.333H6v2.667H3.333V10zm5.334-4c0-.368.298-.667.666-.667h4a.667.667 0 0 1 0 1.334h-4A.667.667 0 0 1 8.667 6zm.666-3.333a.667.667 0 0 0 0 1.333h4a.667.667 0 0 0 0-1.333h-4zM8.667 10c0-.368.298-.667.666-.667h4a.667.667 0 0 1 0 1.334h-4A.667.667 0 0 1 8.667 10zm.666 2a.667.667 0 0 0 0 1.333h4a.667.667 0 0 0 0-1.333h-4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 33277:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"11","viewBox":"0 0 12 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.195287 0.195262C0.455636 -0.0650874 0.877746 -0.0650874 1.1381 0.195262L2.46574 1.52291C2.51433 1.57023 2.55433 1.62356 2.58549 1.68078C2.6819 1.85741 2.69246 2.06845 2.61717 2.25261C2.59251 2.31292 2.55865 2.37035 2.51558 2.42275L1.18727 4.08313C0.957264 4.37064 0.537736 4.41725 0.250228 4.18725C-0.0372801 3.95724 -0.0838944 3.53771 0.146112 3.2502L1.10669 2.04948L0.195287 1.13807C-0.0650629 0.877722 -0.0650629 0.455612 0.195287 0.195262ZM4.00002 2C4.00002 1.63181 4.2985 1.33333 4.66669 1.33333H11.3334C11.7015 1.33333 12 1.63181 12 2C12 2.36819 11.7015 2.66667 11.3334 2.66667H4.66669C4.2985 2.66667 4.00002 2.36819 4.00002 2ZM4.00002 6C4.00002 5.63181 4.2985 5.33333 4.66669 5.33333H11.3334C11.7015 5.33333 12 5.63181 12 6C12 6.36819 11.7015 6.66667 11.3334 6.66667H4.66669C4.2985 6.66667 4.00002 6.36819 4.00002 6ZM4.66669 9.33333C4.2985 9.33333 4.00002 9.63181 4.00002 10C4.00002 10.3682 4.2985 10.6667 4.66669 10.6667H11.3334C11.7015 10.6667 12 10.3682 12 10C12 9.63181 11.7015 9.33333 11.3334 9.33333H4.66669Z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 60302:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<g clip-path=\"url(#clip0_304_117572)\">   <path class=\"graphic\" d=\"M4.18988 0.418762C3.95588 -0.140238 3.04388 -0.140238 2.80888 0.418762L0.0598756 6.95176C-0.102124 7.33476 0.0758756 7.77776 0.457876 7.93976C0.835876 8.10176 1.27888 7.92276 1.43988 7.53876L2.08888 5.99976H4.91188L5.55988 7.53876C5.68088 7.82676 5.95788 7.99876 6.24988 7.99876C6.34788 7.99876 6.44688 7.97976 6.54187 7.93976C6.92387 7.77776 7.10188 7.33476 6.93988 6.95176L4.18988 0.418762ZM2.71988 4.49976L3.49988 2.64676L4.27988 4.49976H2.71988Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M9.75 3.5C11.267 3.5 12.5 4.733 12.5 6.25C12.5 6.664 12.836 7 13.25 7C13.664 7 14 6.664 14 6.25C14 3.907 12.094 2 9.75 2C9.336 2 9 2.336 9 2.75C9 3.164 9.336 3.5 9.75 3.5Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M6.25 12.5C4.733 12.5 3.5 11.267 3.5 9.75C3.5 9.336 3.164 9 2.75 9C2.336 9 2 9.336 2 9.75C2 12.093 3.906 14 6.25 14C6.664 14 7 13.664 7 13.25C7 12.836 6.664 12.5 6.25 12.5Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M15.5207 14.551L14.0487 13.979C13.9227 13.93 13.8067 13.867 13.6887 13.807C14.3577 13.021 14.8017 12.056 14.9437 11H15.2497C15.6637 11 15.9997 10.664 15.9997 10.25C15.9997 9.836 15.6637 9.5 15.2497 9.5H13.2497V8.75C13.2497 8.336 12.9137 8 12.4997 8C12.0857 8 11.7497 8.336 11.7497 8.75V9.5H9.74966C9.33566 9.5 8.99966 9.836 8.99966 10.25C8.99966 10.664 9.33566 11 9.74966 11H10.0557C10.1977 12.056 10.6417 13.02 11.3107 13.807C11.1927 13.867 11.0767 13.93 10.9507 13.979L9.47866 14.551C9.09166 14.701 8.90066 15.136 9.05066 15.522C9.16666 15.818 9.45066 16 9.75066 16C9.84166 16 9.93366 15.984 10.0217 15.949L11.4937 15.377C11.8547 15.237 12.1847 15.051 12.4997 14.847C12.8147 15.051 13.1447 15.236 13.5057 15.377L14.9777 15.949C15.0667 15.984 15.1587 16 15.2487 16C15.5487 16 15.8327 15.818 15.9477 15.522C16.0987 15.136 15.9077 14.701 15.5207 14.551ZM13.4227 11C13.2887 11.713 12.9687 12.364 12.4997 12.895C12.0297 12.364 11.7107 11.713 11.5767 11H13.4227Z\" fill=\"black\"/>   </g>   <defs>   <clipPath id=\"clip0_304_117572\">   <rect width=\"16\" height=\"16\" fill=\"white\"/>   </clipPath>   </defs>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 77242:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M11 2a3 3 0 0 0-3 3v1H5a1 1 0 0 0 0 2v11a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a1 1 0 0 0 0-2h-3V5a3 3 0 0 0-3-3h-2zm3 4V5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v1h4zM8 8H7v11a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8H8zm3 3v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 2 0zm3-1a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 35783:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M9.82143 0.3125H1.17857C0.527902 0.3125 0 0.807408 0 1.41741V9.52009C0 10.1301 0.527902 10.625 1.17857 10.625H9.82143C10.4721 10.625 11 10.1301 11 9.52009V1.41741C11 0.807408 10.4721 0.3125 9.82143 0.3125ZM8.62076 3.96791C8.62567 4.03237 8.62567 4.09912 8.62567 4.16357C8.62567 6.15932 7.00513 8.45891 4.04397 8.45891C3.13058 8.45891 2.28348 8.21031 1.57143 7.78216C1.70156 7.79597 1.82679 7.80057 1.95938 7.80057C2.71317 7.80057 3.40558 7.56117 3.95804 7.15604C3.25089 7.14223 2.6567 6.70717 2.4529 6.10868C2.70089 6.14321 2.92433 6.14321 3.17969 6.08105C2.44308 5.94064 1.89062 5.33294 1.89062 4.59863V4.58022C2.10424 4.69301 2.35469 4.76207 2.61741 4.77128C2.39653 4.63354 2.21546 4.44668 2.09036 4.22737C1.96526 4.00807 1.90001 3.76314 1.90045 3.51444C1.90045 3.23361 1.97902 2.9758 2.11897 2.75251C2.91205 3.66867 4.1029 4.26716 5.43862 4.33161C5.21027 3.30727 6.0279 2.47628 7.01004 2.47628C7.47411 2.47628 7.89152 2.65813 8.18616 2.95278C8.54955 2.88832 8.89821 2.76172 9.20759 2.58908C9.08728 2.93896 8.83438 3.23361 8.50045 3.42006C8.82455 3.38783 9.13884 3.30266 9.42857 3.18527C9.21004 3.48682 8.93504 3.75384 8.62076 3.96791Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 93858:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M11.522 4.72a4.433 4.433 0 0 1 6.269 6.269l-4.924 4.925-.886.885a2.745 2.745 0 1 1-3.882-3.882l4.595-4.595a1 1 0 1 1 1.414 1.415L9.513 14.33a.746.746 0 0 0 1.054 1.054l.219-.22a.015.015 0 0 0 .004-.003l5.587-5.587a2.433 2.433 0 0 0-3.44-3.44l-.487.486-5.443 5.443a3.667 3.667 0 0 0 0 5.186l.454.454a3.667 3.667 0 0 0 5.186 0l4.714-4.714a1 1 0 1 1 1.414 1.414l-4.714 4.714a5.667 5.667 0 0 1-8.014 0l-.454-.454a5.667 5.667 0 0 1 0-8.014l5.443-5.443.486-.487z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 64631:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6zM5 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6zm12.268 3.64a1 1 0 1 0-1.536-1.28l-4.406 5.287-2.745-1.96a1 1 0 1 0-1.162 1.627l3.5 2.5.755.54.594-.714 5-6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 33753:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M15 7.5c0 .852-.431 1.745-1.161 2.472C13.064 10.743 12.291 11 12 11c-.291 0-1.064-.257-1.839-1.028C9.431 9.245 9 8.352 9 7.5 9 5.383 10.518 4 12 4s3 1.383 3 3.5zm2 0c0 3.038-3 5.5-5 5.5s-5-2.462-5-5.5S9.239 2 12 2s5 2.462 5 5.5zM10.582 16h2.432a4.494 4.494 0 0 1 4.386 3.518l.107.482H6.493l.195-.876A3.993 3.993 0 0 1 10.582 16zm-4.873.508A5.988 5.988 0 0 1 10.582 14h2.432a6.495 6.495 0 0 1 6.338 5.085l.264 1.187A1.42 1.42 0 0 1 18.23 22H5.999a1.603 1.603 0 0 1-1.565-1.951l.302-1.359a5.973 5.973 0 0 1 .973-2.182z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 325:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M11 17.887v-4.99c-2.268-.436-4-2.212-4-4.397s1.732-3.961 4-4.397V3a1 1 0 0 1 2 0v1.073c1.839.296 3.38 1.472 3.945 3.099a1 1 0 1 1-1.89.656c-.283-.815-1.063-1.463-2.055-1.715v4.99c2.268.436 4 2.212 4 4.397s-1.732 3.961-4 4.397V21a1 1 0 0 1-2 0v-1.073a5.34 5.34 0 0 1-2.558-1.138 4.453 4.453 0 0 1-1.387-1.961 1 1 0 0 1 1.89-.656c.139.4.404.772.771 1.076.36.297.8.516 1.284.64zm2-.046c1.182-.362 2-1.295 2-2.341 0-1.046-.818-1.979-2-2.34v4.68zm-2-7V6.159C9.818 6.521 9 7.454 9 8.5c0 1.046.818 1.979 2 2.34z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 24655:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M8 3a1 1 0 0 1 1 1v1h6V4a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h1V4a1 1 0 0 1 1-1zm7 4v1a1 1 0 0 0 2 0V7h1a1 1 0 0 1 1 1v2H5V8a1 1 0 0 1 1-1h1v1a1 1 0 0 0 2 0V7h6zM5 12v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6H5z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 52124:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M7 9a3 3 0 1 0 0 6h3a1 1 0 0 1 0 2H7A5 5 0 0 1 7 7h3a1 1 0 0 1 0 2H7zm1 3a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1zm6-5a1 1 0 0 0 0 2h3a3 3 0 1 1 0 6h-3a1 1 0 0 0 0 2h3a5 5 0 0 0 0-10h-3z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 66339:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M12 4a8 8 0 1 0 3.555 15.169 1 1 0 1 1 .89 1.791A9.961 9.961 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10v.571c0 1.297-.317 2.395-.948 3.193A3.199 3.199 0 0 1 18.5 17c-1.216 0-2.192-.685-2.801-1.636A5 5 0 1 1 15 8a1 1 0 0 1 2 0v5c0 1.222.85 2 1.5 2a1.2 1.2 0 0 0 .984-.478c.273-.345.516-.961.516-1.951V12a8 8 0 0 0-8-8zm3 8a3 3 0 1 0-6 0 3 3 0 0 0 6 0z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 12154:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M7 5h10a2 2 0 1 1 0 4H7a2 2 0 1 1 0-4zM3 7a4 4 0 0 1 4-4h10a4 4 0 0 1 0 8H7a4 4 0 0 1-4-4zm4 8h10a2 2 0 1 1 0 4H7a2 2 0 1 1 0-4zm-4 2a4 4 0 0 1 4-4h10a4 4 0 0 1 0 8H7a4 4 0 0 1-4-4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 39046:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M17.243 3.03a1 1 0 0 1 .727 1.212L17.031 8H20a1 1 0 0 1 0 2h-3.47l-1 4H18a1 1 0 0 1 0 2h-2.97l-1.06 4.242a1 1 0 0 1-1.94-.485L12.97 16H9.03l-1.06 4.242a1 1 0 0 1-1.94-.485L6.97 16H4a1 1 0 1 1 0-2h3.47l1-4H6a1 1 0 1 1 0-2h2.97l1.06-4.242a1 1 0 1 1 1.94.484L11.03 8h3.94l1.06-4.242a1 1 0 0 1 1.213-.728zM10.531 10l-1 4h3.938l1-4h-3.938z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 92702:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M20.707 3.293a1 1 0 0 1 0 1.414l-16 16a1 1 0 1 1-1.414-1.414l16-16a1 1 0 0 1 1.414 0zM6.5 5C5.835 5 5 5.717 5 7s.835 2 1.5 2S8 8.283 8 7s-.835-2-1.5-2zM3 7c0-2.03 1.404-4 3.5-4S10 4.97 10 7c0 2.03-1.404 4-3.5 4S3 9.03 3 7zm13 10c0-1.283.835-2 1.5-2s1.5.717 1.5 2-.835 2-1.5 2-1.5-.717-1.5-2zm1.5-4c-2.096 0-3.5 1.97-3.5 4 0 2.03 1.404 4 3.5 4s3.5-1.97 3.5-4c0-2.03-1.404-4-3.5-4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 21685:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M8.933 8.578l1.65-4.748c.466-1.343 2.368-1.343 2.834 0l1.65 4.748 5.025.103c1.422.029 2.01 1.836.876 2.695l-4.005 3.036 1.455 4.81c.414 1.362-1.125 2.48-2.292 1.667L12 18.018l-4.126 2.871c-1.167.813-2.706-.305-2.292-1.665l1.455-4.812-4.005-3.036c-1.134-.86-.546-2.666.876-2.695l5.025-.103zM12 5.846l-1.293 3.72a1.5 1.5 0 0 1-1.386 1.005l-3.935.08 3.139 2.38a1.5 1.5 0 0 1 .527 1.628l-1.14 3.767 3.232-2.249a1.502 1.502 0 0 1 1.713 0l3.23 2.249-1.139-3.765a1.5 1.5 0 0 1 .529-1.632l3.137-2.378-3.936-.08a1.5 1.5 0 0 1-1.386-1.007L12 5.846z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 56486:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M7 8h10a4 4 0 1 1 0 8H7a4 4 0 1 1 0-8zm0 2a2 2 0 1 0 0 4h10a2 2 0 1 0 0-4H7z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 85265:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M3 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2h-5v15a1 1 0 1 1-2 0V5H4a1 1 0 0 1-1-1zm14 9h3a1 1 0 1 1 0 2h-2v5a1 1 0 1 1-2 0v-5h-2a1 1 0 1 1 0-2h3z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 61615:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"10","viewBox":"0 0 11 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M5.28098 9.83974C4.07416 9.80988 3.00875 9.4217 2.05904 8.74237C1.41465 8.28102 0.865071 7.73756 0.472974 7.06869C0.0856979 6.40727 -0.0637489 5.70257 0.0246336 4.95157C0.103374 4.28419 0.416731 3.71833 0.902031 3.23907C1.24271 2.90314 1.6107 2.5896 1.97708 2.27756C2.39007 1.92371 2.8127 1.57882 3.23694 1.23543C3.56797 0.966682 3.91989 0.729291 4.3152 0.550127C4.82782 0.318708 5.37097 0.232112 5.93662 0.253015C7.00525 0.293327 7.94853 0.65016 8.79861 1.23692C9.47192 1.70125 10.0456 2.25666 10.4538 2.94196C11.0291 3.90795 11.156 4.9247 10.8057 5.98325C10.6402 6.48043 10.3333 6.90893 9.95883 7.29115C9.28873 7.97645 8.54792 8.58859 7.73641 9.12608C7.25593 9.44409 6.73046 9.677 6.14552 9.77107C5.86109 9.81586 5.57184 9.83079 5.2858 9.85915C5.2842 9.85169 5.28259 9.84572 5.28098 9.83974ZM5.16207 7.35983C5.36937 7.35983 5.5622 7.35535 5.75343 7.36132C5.8386 7.3643 5.85306 7.33594 5.85306 7.26427C5.85145 6.16988 5.85145 5.074 5.85145 3.97961C5.85145 3.94826 5.85145 3.9169 5.85145 3.8751C6.31747 3.8751 6.77063 3.8751 7.22218 3.8751C7.22218 3.66608 7.22218 3.469 7.22218 3.27192C6.07321 3.27192 4.93227 3.27192 3.78169 3.27192C3.78169 3.4466 3.78491 3.61531 3.78009 3.78402C3.77687 3.85718 3.79776 3.88256 3.88133 3.88107C4.27021 3.87659 4.65748 3.87958 5.04637 3.87958C5.16046 3.87958 5.16046 3.87958 5.16046 3.9826C5.16046 5.07251 5.16046 6.16242 5.16046 7.25233C5.16207 7.28368 5.16207 7.31653 5.16207 7.35983Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 78555:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M8 3a1 1 0 0 0-2 0v9a6 6 0 1 0 12 0V3a1 1 0 0 0-2 0v9a4 4 0 0 1-8 0V3zM7 20a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2H7z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 69206:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.58963 3.36764C4.85564 3.10011 5.28727 3.10011 5.55328 3.36764C5.81876 3.63464 5.81876 4.06716 5.55328 4.33416L4.65667 5.23596H10.5572C12.8277 5.23596 14.6667 7.0869 14.6667 9.36814C14.6667 11.6494 12.8277 13.5003 10.5572 13.5003H5.75717C5.3802 13.5003 5.07622 13.1932 5.07622 12.8164C5.07622 12.4396 5.3802 12.1325 5.75717 12.1325H10.5572C12.0737 12.1325 13.3048 10.8958 13.3048 9.36814C13.3048 7.84052 12.0737 6.60377 10.5572 6.60377H4.65667L5.55328 7.50557C5.81876 7.77258 5.81876 8.20506 5.55328 8.47207C5.28727 8.73961 4.85564 8.73961 4.58963 8.47207L2.53249 6.40312C2.267 6.13612 2.267 5.70361 2.53249 5.43661L4.58963 3.36764Z\" fill=\"currentColor\"></path>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 29300:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<g clip-path=\"url(#clip0)\"> <path d=\"M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z\" fill=\"#00A1B7\"/> <path d=\"M12.0833 9.16663C10.9621 9.16663 10.4864 10.5939 11.3833 11.2666L11.85 11.6166C11.9969 11.7268 12.0833 11.8997 12.0833 12.0833V14.4166C12.0833 14.6002 11.9969 14.7731 11.85 14.8833L11.3833 15.2333C10.4864 15.906 10.9621 17.3333 12.0833 17.3333H14.4167V20.25C14.4167 20.5721 14.6778 20.8333 15 20.8333C15.3222 20.8333 15.5833 20.5721 15.5833 20.25V17.3333H17.9167C19.0378 17.3333 19.5136 15.906 18.6167 15.2333L18.15 14.8833C18.0031 14.7731 17.9167 14.6002 17.9167 14.4166V12.0833C17.9167 11.8997 18.0031 11.7268 18.15 11.6166L18.6167 11.2666C19.5136 10.5939 19.0378 9.16663 17.9167 9.16663H12.0833Z\" fill=\"#F5F8FA\"/> </g> <defs> <clipPath id=\"clip0\"> <path d=\"M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z\" fill=\"white\"/> </clipPath> </defs>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 26798:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<circle class=\"graphic_stroke\" cx=\"18\" cy=\"18\" r=\"17\" stroke=\"#5C6061\" stroke-width=\"2\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18 8.625C18.5178 8.625 18.9375 9.04473 18.9375 9.5625L18.9375 20.4242L23.8996 15.4621C24.2657 15.096 24.8593 15.096 25.2254 15.4621C25.5915 15.8282 25.5915 16.4218 25.2254 16.7879L18.6661 23.3472C18.6562 23.3573 18.646 23.367 18.6357 23.3766C18.5545 23.4515 18.4634 23.5095 18.3668 23.5505C18.2549 23.5981 18.1319 23.6246 18.0028 23.625L18 23.625L17.9914 23.625C17.8704 23.6239 17.755 23.5999 17.6491 23.5571C17.5355 23.5113 17.4291 23.4424 17.3371 23.3504L10.7746 16.7879C10.4085 16.4218 10.4085 15.8282 10.7746 15.4621C11.1407 15.096 11.7343 15.096 12.1004 15.4621L17.0625 20.4242L17.0625 9.5625C17.0625 9.04473 17.4822 8.625 18 8.625ZM11.4375 25.5C10.9197 25.5 10.5 25.9197 10.5 26.4375C10.5 26.9553 10.9197 27.375 11.4375 27.375L24.5625 27.375C25.0803 27.375 25.5 26.9553 25.5 26.4375C25.5 25.9197 25.0803 25.5 24.5625 25.5L11.4375 25.5Z\" fill=\"black\" fill-opacity=\"0.6\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 29672:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<rect class=\"graphic_stroke\" x=\"1\" y=\"1\" width=\"11\" height=\"11\" rx=\"1\" stroke=\"#5C6061\"/>   <path class=\"graphic_stroke\" d=\"M5.5 4L3 6.5L5.5 9\" stroke=\"#5C6061\"/>   <path class=\"graphic_stroke\" d=\"M7.5 4L10 6.5L7.5 9\" stroke=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 77586:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M2.66675 14C2.66675 11.4227 4.75609 9.33333 7.33341 9.33333C7.55975 9.33333 7.78235 9.34947 8.00008 9.3806M10.0001 4.66667C10.0001 6.13943 8.80615 7.33333 7.33341 7.33333C5.86065 7.33333 4.66675 6.13943 4.66675 4.66667C4.66675 3.19391 5.86065 2 7.33341 2C8.80615 2 10.0001 3.19391 10.0001 4.66667Z\" stroke=\"#737373\" stroke-width=\"1.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.9236 9.30999L13.5424 9.92871C13.8841 10.2704 13.8841 10.8244 13.5424 11.1661L13.0164 11.6921L11.1603 9.83592L11.6862 9.30999C12.0279 8.96828 12.5819 8.96828 12.9236 9.30999ZM10.8509 10.1453L8.48041 12.5158C8.33946 12.6567 8.25086 12.8416 8.22928 13.0397L8.11436 14.0949C8.074 14.4655 8.38683 14.7783 8.75742 14.738L9.81258 14.6231C10.0108 14.6015 10.1956 14.5129 10.3366 14.3719L12.7071 12.0014L10.8509 10.1453Z\" fill=\"#737373\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 24327:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M10.4035 4.33268C10.4035 6.35773 8.40347 7.99935 7.07014 7.99935C5.73681 7.99935 3.73681 6.35773 3.73681 4.33268C3.73681 2.30764 5.22919 0.666016 7.07014 0.666016C8.91109 0.666016 10.4035 2.30764 10.4035 4.33268ZM9.07014 4.33268C9.07014 2.92159 8.05797 1.99935 7.07014 1.99935C6.08231 1.99935 5.07014 2.92159 5.07014 4.33268C5.07014 4.9009 5.35726 5.49586 5.84406 5.98038C6.36103 6.49492 6.87583 6.66602 7.07014 6.66602C7.26445 6.66602 7.77925 6.49492 8.29622 5.98038C8.78302 5.49586 9.07014 4.9009 9.07014 4.33268Z\" fill=\"currentColor\"/>   <path class=\"graphic\" d=\"M7.74583 8.66602C7.93845 8.66602 8.1296 8.67884 8.31817 8.70399C8.37771 8.63583 8.43996 8.5692 8.50491 8.50425C10.067 6.94216 12.5997 6.94216 14.1618 8.50425C15.7239 10.0663 15.7239 12.599 14.1618 14.1611C12.5997 15.7232 10.067 15.7232 8.50491 14.1611C8.45207 14.1083 8.40102 14.0543 8.35176 13.9993H3.06941C2.38554 13.9993 1.87754 13.3661 2.02589 12.6985L2.22718 11.7927C2.34352 11.2692 2.56412 10.7744 2.87583 10.3381C3.62532 9.28876 4.83543 8.66602 6.12491 8.66602H7.74583ZM6.12491 9.99935C5.26603 9.99935 4.46002 10.4141 3.96081 11.113C3.75319 11.4037 3.60625 11.7332 3.52876 12.0819L3.39896 12.666H7.56111C7.25741 11.8049 7.25741 10.8605 7.56111 9.99935H6.12491ZM13.8856 11.3327C13.8856 10.9645 13.5871 10.666 13.219 10.666H12V9.44707C12 9.07888 11.7015 8.7804 11.3333 8.7804C10.9651 8.7804 10.6667 9.07888 10.6667 9.44707V10.666H9.44771C9.07952 10.666 8.78105 10.9645 8.78105 11.3327C8.78105 11.7009 9.07952 11.9994 9.44771 11.9994H10.6667V13.2183C10.6667 13.5865 10.9651 13.885 11.3333 13.885C11.7015 13.885 12 13.5865 12 13.2183V11.9994H13.219C13.5871 11.9994 13.8856 11.7009 13.8856 11.3327Z\" fill=\"currentColor\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 59146:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12 3a1 1 0 0 1 1 1v9h2.575a.5.5 0 0 1 .312.89l-3.575 2.86a.5.5 0 0 1-.624 0l-3.575-2.86a.5.5 0 0 1 .312-.89H11V4a1 1 0 0 1 1-1zM3 20a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 52725:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12 1a1 1 0 0 1 1 1v3h2.575a.5.5 0 0 1 .312.89l-3.575 2.86a.5.5 0 0 1-.624 0L8.113 5.89A.5.5 0 0 1 8.425 5H11V2a1 1 0 0 1 1-1zM3 12a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm8 7H8.425a.5.5 0 0 1-.312-.89l3.575-2.86a.5.5 0 0 1 .624 0l3.575 2.86a.5.5 0 0 1-.312.89H13v3a1 1 0 0 1-2 0v-3z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 10226:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm10 7h2.575a.5.5 0 0 0 .312-.89l-3.575-2.86a.5.5 0 0 0-.624 0l-3.575 2.86a.5.5 0 0 0 .312.89H11v9a1 1 0 0 0 2 0v-9z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 22220:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M5 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5zM4 7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7zm6.757 2.454a.5.5 0 0 0-.757.429v4.234a.5.5 0 0 0 .757.429l3.528-2.117a.5.5 0 0 0 0-.858l-3.528-2.117z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 27237:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"</svg> <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">     <g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" d=\"M14.667 4C14.667 3.73036 14.5045 3.48727 14.2554 3.38408C14.0063 3.28089 13.7195 3.33793 13.5289 3.52859L10.667 6.39052V5.33333C10.667 4.22876 9.77152 3.33333 8.66695 3.33333H3.33362C2.22905 3.33333 1.33362 4.22876 1.33362 5.33333V10.6667C1.33362 11.7712 2.22905 12.6667 3.33362 12.6667H8.66695C9.77152 12.6667 10.667 11.7712 10.667 10.6667V9.60948L13.5289 12.4714C13.7195 12.6621 14.0063 12.7191 14.2554 12.6159C14.5045 12.5127 14.667 12.2696 14.667 12V4ZM9.33362 5.33333V10.6667C9.33362 11.0349 9.03514 11.3333 8.66695 11.3333H3.33362C2.96543 11.3333 2.66695 11.0349 2.66695 10.6667V5.33333C2.66695 4.96514 2.96543 4.66667 3.33362 4.66667H8.66695C9.03514 4.66667 9.33362 4.96514 9.33362 5.33333ZM13.3336 10.3905L10.9431 8L13.3336 5.60947V10.3905Z\" fill=\"#5C6061\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 89713:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M9.9 0.3125H1.1C0.493527 0.3125 0 0.775181 0 1.34375V9.59375C0 10.1623 0.493527 10.625 1.1 10.625H9.9C10.5065 10.625 11 10.1623 11 9.59375V1.34375C11 0.775181 10.5065 0.3125 9.9 0.3125ZM9.2567 3.73772C9.22232 4.46282 8.68214 5.45724 7.63616 6.71638C6.5558 8.03306 5.63996 8.69141 4.89353 8.69141C4.42946 8.69141 4.03906 8.29088 3.71741 7.48751C3.09129 5.33984 2.82366 4.08071 2.30804 4.08071C2.24911 4.08071 2.0404 4.1981 1.68437 4.43059L1.31116 3.97942C2.22701 3.2244 3.10112 2.38651 3.64866 2.34047C4.26741 2.28523 4.64799 2.68115 4.7904 3.53055C5.29866 6.55064 5.52455 7.00642 6.45022 5.63909C6.7817 5.14648 6.96094 4.77128 6.98549 4.51346C7.07143 3.74923 6.34955 3.80218 5.86094 3.99784C6.25134 2.79855 6.99777 2.21617 8.10022 2.2484C8.91786 2.26911 9.30335 2.76632 9.2567 3.73772Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 4311:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M5 11.0415L8.5 13.0622C9.16667 13.4471 10 12.966 10 12.1962L10 1.80386C10 1.03406 9.16667 0.552935 8.5 0.937835L5 2.95856V3H1C0.447715 3 0 3.44772 0 4V10C0 10.5523 0.447715 11 1 11H5V11.0415Z\" fill=\"white\"/>   <path class=\"graphic\" d=\"M14 7C14 8.10457 13.1046 9 12 9V5C13.1046 5 14 5.89543 14 7Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 84005:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"18","height":"14","viewBox":"0 0 18 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M4.92822 3H1C0.447715 3 0 3.44772 0 4V10C0 10.5523 0.447715 11 1 11H4.92818L8.5 13.0622C9.16667 13.4471 10 12.966 10 12.1962L10 1.80386C10 1.03406 9.16667 0.552935 8.5 0.937835L4.92822 3Z\" fill=\"white\"/>   <path class=\"graphic\" d=\"M12 9C13.1046 9 14 8.10457 14 7C14 5.89543 13.1046 5 12 5V9Z\" fill=\"white\"/>   <path class=\"graphic\" d=\"M12 3C14.2091 3 16 4.79086 16 7C16 9.20914 14.2091 11 12 11V13C15.3137 13 18 10.3137 18 7C18 3.68629 15.3137 1 12 1V3Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 80347:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"17","height":"14","viewBox":"0 0 17 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M1 3H4.92822L8.5 0.937835C9.16667 0.552935 10 1.03406 10 1.80386L10 12.1962C10 12.966 9.16667 13.4471 8.5 13.0622L4.92818 11H1C0.447715 11 0 10.5523 0 10V4C0 3.44772 0.447715 3 1 3Z\" fill=\"white\"/>   <path class=\"graphic\" d=\"M16.7071 4.29289C16.3166 3.90237 15.6834 3.90237 15.2929 4.29289L14 5.58579L12.7071 4.29289C12.3166 3.90237 11.6834 3.90237 11.2929 4.29289C10.9024 4.68342 10.9024 5.31658 11.2929 5.70711L12.5858 7L11.2929 8.29289C10.9024 8.68342 10.9024 9.31658 11.2929 9.70711C11.6834 10.0976 12.3166 10.0976 12.7071 9.70711L14 8.41421L15.2929 9.70711C15.6834 10.0976 16.3166 10.0976 16.7071 9.70711C17.0976 9.31658 17.0976 8.68342 16.7071 8.29289L15.4142 7L16.7071 5.70711C17.0976 5.31658 17.0976 4.68342 16.7071 4.29289Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 77445:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.68885 3.06662C5.51107 3.19995 5.51107 3.46662 5.68885 3.59995L7.46663 4.93329C7.68637 5.0981 7.99996 4.9413 7.99996 4.66662V3.99995C10.2091 3.99995 12 5.79081 12 7.99995C12 10.2091 10.2091 12 7.99996 12C5.79082 12 3.99996 10.2091 3.99996 7.99995C3.99996 7.63176 3.70148 7.33329 3.33329 7.33329C2.9651 7.33329 2.66663 7.63176 2.66663 7.99995C2.66663 10.9455 5.05444 13.3333 7.99996 13.3333C10.9455 13.3333 13.3333 10.9455 13.3333 7.99995C13.3333 5.05444 10.9455 2.66662 7.99996 2.66662V1.99995C7.99996 1.72527 7.68637 1.56848 7.46663 1.73329L5.68885 3.06662Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 7294:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 1.33333C4.89543 1.33333 4 2.22876 4 3.33333C4 4.4379 4.89543 5.33333 6 5.33333C7.10457 5.33333 8 4.4379 8 3.33333C8 2.22876 7.10457 1.33333 6 1.33333ZM2.66667 3.33333C2.66667 1.49238 4.15905 0 6 0C7.84095 0 9.33333 1.49238 9.33333 3.33333C9.33333 3.8157 9.23087 4.27414 9.04653 4.68807C10.7086 4.87662 12 6.2875 12 8C12 9.84095 10.5076 11.3333 8.66667 11.3333C7.57627 11.3333 6.60815 10.8098 6 10.0003C5.39185 10.8098 4.42373 11.3333 3.33333 11.3333C1.49238 11.3333 0 9.84095 0 8C0 6.2875 1.2914 4.87662 2.95347 4.68807C2.76913 4.27414 2.66667 3.8157 2.66667 3.33333ZM5.33333 8C5.33333 6.89543 4.4379 6 3.33333 6C2.22876 6 1.33333 6.89543 1.33333 8C1.33333 9.10457 2.22876 10 3.33333 10C4.4379 10 5.33333 9.10457 5.33333 8ZM6.66667 8C6.66667 9.10457 7.5621 10 8.66667 10C9.77124 10 10.6667 9.10457 10.6667 8C10.6667 6.89543 9.77124 6 8.66667 6C7.5621 6 6.66667 6.89543 6.66667 8Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 46921:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"8","viewBox":"0 0 11 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M10.7762 1.2108C10.6498 0.739231 10.2788 0.367144 9.80781 0.240184C8.94712 0.00385134 5.50381 4.17513e-06 5.50381 4.17513e-06C5.50381 4.17513e-06 2.06104 -0.00384321 1.1998 0.222047C0.738129 0.347908 0.356699 0.728239 0.229189 1.19926C0.00219935 2.05995 8.0526e-07 3.84508 8.0526e-07 3.84508C8.0526e-07 3.84508 -0.00219763 5.63901 0.223143 6.49091C0.349554 6.96193 0.720541 7.33401 1.19211 7.46097C2.06159 7.69731 5.49556 7.70115 5.49556 7.70115C5.49556 7.70115 8.93888 7.705 9.79957 7.47966C10.27 7.35325 10.6427 6.98171 10.7707 6.5107C10.9983 5.65056 10.9999 3.86597 10.9999 3.86597C10.9999 3.86597 11.0109 2.07149 10.7762 1.2108ZM4.40239 5.49886L4.40514 2.2012L7.26696 3.85278L4.40239 5.49886Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 26158:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"fileHorizontalPadding":"10","fileBorderWidth":"1px"};

/***/ }),

/***/ 81578:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"menuItemHeight":"32","menuPadding":"7"};

/***/ }),

/***/ 29650:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"transitionDuration":"400"};

/***/ }),

/***/ 20199:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"nimbusWhite":"#e8e8e8","popupAppearDuration":"200","scrollBlotClass":"nedit-root","blotMargin":"18","gunMetal":"#5c6061","linGrad1":"rgba(31,31,31,.2)","linGrad1dark":"rgba(243,246,250,.2)","linGrad2":"#00a1b7","progressColor":"#00a1b7","pageWidth":"1000px"};

/***/ }),

/***/ 12934:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"nimbusWhite":"#e8e8e8","popupAppearDuration":"200","scrollBlotClass":"nedit-root","blotMargin":"18","gunMetal":"#5c6061","linGrad1":"rgba(31,31,31,.2)","linGrad1dark":"rgba(243,246,250,.2)","linGrad2":"#00a1b7","progressColor":"#00a1b7","pageWidth":"1000px","fileHorizontalPadding":"10","fileBorderWidth":"1px","fullScreenViewerPagesMargin":"20","fullScreenViewerFirstPageTopMargin":"10","fullScreenViewerPreviewsMargin":"15","fullScreenViewerPreviewsTopMargin":"15"};

/***/ }),

/***/ 2769:
/***/ ((module) => {

module.exports = ".pdf-viewer-printing-pages {\n  display: none;\n}\n.pdf-viewer-printing-pages .pdf-viewer-printing-page {\n  position: relative;\n  top: 0;\n  left: 0;\n  width: 1px;\n  height: 1px;\n  overflow: visible;\n  page-break-after: always;\n  page-break-inside: avoid;\n}\n.pdf-viewer-printing-pages .pdf-viewer-printing-page img {\n  display: block;\n  max-width: unset;\n  height: unset;\n}\n\n@media print {\n  html {\n  width: 100%;\n    height: 100%;\n  }\n  body {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    background: transparent none;\n  }\n\n  * {\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  body > * {\n    display: none !important;\n  }\n\n  body > .pdf-viewer-printing-pages {\n    display: block !important;\n    width: 100%;\n    height: 100%;\n  }\n}"

/***/ }),

/***/ 49839:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);
function s(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function h(t,i){var n=t.i||(t.i={});return n[i]||(n[i]=function(n){t.refs[i]=n})}function e(t){for(var i={},n=0;n<t.length;n++)null!=t[n]&&(i[(r=t[n],s=n.toString(36),void 0,h=r&&r.key,null==h?s:h)]=t[n]);var r,s,h;return i}function a(t,i){t=t||{},i=i||{};var n=function(n){return i.hasOwnProperty(n)?i[n]:t[n]},r={},s=[];for(var h in t)i.hasOwnProperty(h)?s.length&&(r[h]=s,s=[]):s.push(h);var e={};for(var a in i){if(r.hasOwnProperty(a))for(var o=0;o<r[a].length;o++)e[r[a][o]]=n(r[a][o]);e[a]=n(a)}for(var f=0;f<s.length;f++)e[s[f]]=n(s[f]);return e}var o=function(r){var o,f;function u(i,n){var h;return(h=r.call(this,i,n)||this).refs={},h.state={children:e((0,preact__WEBPACK_IMPORTED_MODULE_0__/* .toChildArray */ .bR)((0,preact__WEBPACK_IMPORTED_MODULE_0__/* .toChildArray */ .bR)(h.props.children))||[])},h.performAppear=h.performAppear.bind(s(h)),h.performEnter=h.performEnter.bind(s(h)),h.performLeave=h.performLeave.bind(s(h)),h}f=r,(o=u).prototype=Object.create(f.prototype),o.prototype.constructor=o,o.__proto__=f;var v=u.prototype;return v.componentWillMount=function(){this.currentlyTransitioningKeys={},this.keysToAbortLeave=[],this.keysToEnter=[],this.keysToLeave=[]},v.componentDidMount=function(){var t=this.state.children;for(var i in t)t[i]&&this.performAppear(i)},v.componentWillReceiveProps=function(i){var n,r=e((0,preact__WEBPACK_IMPORTED_MODULE_0__/* .toChildArray */ .bR)(i.children)||[]),s=this.state.children;for(n in this.setState(function(t){return{children:a(t.children,r)}}),r)if(r.hasOwnProperty(n)){var h=s&&s.hasOwnProperty(n);r[n]&&h&&this.currentlyTransitioningKeys[n]?(this.keysToEnter.push(n),this.keysToAbortLeave.push(n)):!r[n]||h||this.currentlyTransitioningKeys[n]||this.keysToEnter.push(n)}for(n in s)if(s.hasOwnProperty(n)){var o=r&&r.hasOwnProperty(n);!s[n]||o||this.currentlyTransitioningKeys[n]||this.keysToLeave.push(n)}},v.componentDidUpdate=function(){var t=this.keysToEnter;this.keysToEnter=[],t.forEach(this.performEnter);var i=this.keysToLeave;this.keysToLeave=[],i.forEach(this.performLeave)},v.t=function(t){var i=this.keysToAbortLeave.indexOf(t);-1!==i&&this.keysToAbortLeave.splice(i,1)},v.performAppear=function(t){this.currentlyTransitioningKeys[t]=!0;var i=this.refs[t];i.componentWillAppear?i.componentWillAppear(this.n.bind(this,t)):this.n(t)},v.n=function(i){var n=this.refs[i];n.componentDidAppear&&n.componentDidAppear(),delete this.currentlyTransitioningKeys[i],this.t(i);var r=e((0,preact__WEBPACK_IMPORTED_MODULE_0__/* .toChildArray */ .bR)(this.props.children)||[]);r&&r.hasOwnProperty(i)||this.performLeave(i)},v.performEnter=function(t){this.currentlyTransitioningKeys[t]=!0;var i=this.refs[t];i.componentWillEnter?i.componentWillEnter(this.r.bind(this,t)):this.r(t)},v.r=function(i){var n=this.refs[i];n.componentDidEnter&&n.componentDidEnter(),delete this.currentlyTransitioningKeys[i],this.t(i);var r=e((0,preact__WEBPACK_IMPORTED_MODULE_0__/* .toChildArray */ .bR)(this.props.children)||[]);r&&r.hasOwnProperty(i)||this.performLeave(i)},v.performLeave=function(t){if(-1===this.keysToAbortLeave.indexOf(t)){this.currentlyTransitioningKeys[t]=!0;var i=this.refs[t];i.componentWillLeave?i.componentWillLeave(this.s.bind(this,t)):this.s(t)}},v.s=function(i){if(-1===this.keysToAbortLeave.indexOf(i)){var n=this.refs[i];n.componentDidLeave&&n.componentDidLeave(),delete this.currentlyTransitioningKeys[i];var r=e((0,preact__WEBPACK_IMPORTED_MODULE_0__/* .toChildArray */ .bR)(this.props.children)||[]);if(r&&r.hasOwnProperty(i))this.performEnter(i);else{var s=function(t,i){for(var n in i)i.hasOwnProperty(n)&&(t[n]=i[n]);return t}({},this.state.children);delete s[i],this.setState({children:s})}}},v.render=function(t,r){var s=t.childFactory,e=t.component,a=function(t,i){if(null==t)return{};var n,r,s={},h=Object.keys(t);for(r=0;r<h.length;r++)i.indexOf(n=h[r])>=0||(s[n]=t[n]);return s}(t,["childFactory","transitionLeave","transitionName","transitionAppear","transitionEnter","transitionLeaveTimeout","transitionEnterTimeout","transitionAppearTimeout","component"]),o=r.children,f=[];for(var u in o)if(o.hasOwnProperty(u)){var v=o[u];if(v){var c=h(this,u),l=(0,preact__WEBPACK_IMPORTED_MODULE_0__/* .cloneElement */ .Tm)(s(v),{ref:c,key:u});f.push(l)}}return (0,preact__WEBPACK_IMPORTED_MODULE_0__.h)(e,a,f)},u}(preact__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .wA);o.defaultProps={component:"span",childFactory:function(t){return t}};/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (o);
//# sourceMappingURL=preact-transition-group.mjs.map


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	(() => {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = (chunkId) => {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce((promises, key) => {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = (chunkId) => {
/******/ 			// return url for filenames not based on template
/******/ 			if (chunkId === 157) return "6adc244f74f15d86b974.vendors.pdfjs-dist.js";
/******/ 			// return url for filenames based on template
/******/ 			return undefined;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	(() => {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "web-editor:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = (url, done, key, chunkId) => {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = (prev, event) => {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach((fn) => (fn(event)));
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			;
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "/share/static/assets/";
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			471: 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = (chunkId, promises) => {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = (event) => {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						} else installedChunks[chunkId] = 0;
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		// no on chunks loaded
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 		
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkweb_editor"] = self["webpackChunkweb_editor"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ PDFViewerComponent)
});

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(87751);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.is-integer.js
var es_number_is_integer = __webpack_require__(33161);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(69600);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(30489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(12419);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(38880);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__(49337);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/preact/dist/preact.module.js
var preact_module = __webpack_require__(79758);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__(23157);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/pdfPageView.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }





















function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CSS_UNITS = 96.0 / 72.0;
var SEARCH_HIGHLIGHT_CLASS = 'highlight';
var PDFPageView = /*#__PURE__*/function (_Component) {
  _inherits(PDFPageView, _Component);
  var _super = _createSuper(PDFPageView);
  function PDFPageView(props) {
    var _this;
    _classCallCheck(this, PDFPageView);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "globalMouseUpListener", function () {
      if (_this.state.textLayerSelecting) {
        _this.setState({
          textLayerSelecting: false
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onTextLayerMouseDown", function () {
      _this.setState({
        textLayerSelecting: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onPageContainerRef", function (pageContainer) {
      _this.pageContainer = pageContainer;
    });
    _defineProperty(_assertThisInitialized(_this), "onCanvasRef", function (canvas) {
      _this.canvas = canvas;
    });
    _defineProperty(_assertThisInitialized(_this), "onCanvasWrapperRef", function (wrapper) {
      _this.canvasWrapper = wrapper;
    });
    _defineProperty(_assertThisInitialized(_this), "onTextContentDivRef", function (container) {
      _this.textContainer = container;
    });
    _defineProperty(_assertThisInitialized(_this), "onAnnotationContentDivRef", function (container) {
      _this.annotationContainer = container;
      _this.renderPage();
    });
    _this.state = {
      isRendered: false,
      isRendering: false,
      pageSizeHeight: 0
    };
    _this.textDivs = [];
    _this.textContentItemsStr = [];
    _this.renderTask;
    _this.textLayerRenderTask;
    _this.renderCounter = 0;
    return _this;
  }
  _createClass(PDFPageView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mouseup', this.globalMouseUpListener);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mouseup', this.globalMouseUpListener);
    }
  }, {
    key: "getPageSize",
    value: function getPageSize() {
      if (!this.props.pdfPage) {
        return {
          width: this.props.defaultWidth * this.props.scale * CSS_UNITS,
          height: this.props.defaultHeight * this.props.scale * CSS_UNITS
        };
      }
      var view = this.props.pdfPage.view;
      return {
        width: view[2] * this.props.scale * CSS_UNITS,
        height: view[3] * this.props.scale * CSS_UNITS
      };
    }
  }, {
    key: "clearSearchMatches",
    value: function clearSearchMatches() {
      var textDivs = this.textDivs;
      if (textDivs && textDivs.length) {
        var _iterator = _createForOfIteratorHelper(textDivs),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var div = _step.value;
            var highlights = div.querySelectorAll('.' + SEARCH_HIGHLIGHT_CLASS);
            var _iterator2 = _createForOfIteratorHelper(highlights),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var highlight = _step2.value;
                var _iterator3 = _createForOfIteratorHelper(highlight.childNodes),
                  _step3;
                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var child = _step3.value;
                    highlight.parentNode.insertBefore(child, highlight);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
                highlight.parentNode.removeChild(highlight);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "renderMatches",
    value: function renderMatches( /*{ matches, matchesLength, query, selectedMatchIdx }*/preparedMatches, activeMatch) {
      //console.log('REnder matches', matches)
      // Early exit if there is nothing to render.
      this.clearSearchMatches();
      if (!preparedMatches || preparedMatches.length === 0) {
        return;
      }
      var query = preparedMatches.query,
        matches = preparedMatches.matches,
        matchesLength = preparedMatches.matchesLength;
      var textContentItemsStr = this.textContentItemsStr,
        textDivs = this.textDivs;

      //console.log('CONVERTING!', matches, matchesLength, textContentItemsStr, query)

      matches = this._convertMatches(matches, matchesLength, textContentItemsStr, query);

      //const selectedMatchIdx = findController.selected.matchIdx;
      // const highlightAll = findController.state.highlightAll;
      var highlightAll = true;
      var prevEnd = null;
      var infinity = {
        divIdx: -1,
        offset: undefined
      };
      function beginText(begin, className) {
        var divIdx = begin.divIdx;
        textDivs[divIdx].textContent = '';
        appendTextToDiv(divIdx, 0, begin.offset, className);
      }
      function appendTextToDiv(divIdx, fromOffset, toOffset, className) {
        var div = textDivs[divIdx];
        var content = textContentItemsStr[divIdx].substring(fromOffset, toOffset);
        var node = document.createTextNode(content);
        if (className) {
          var span = document.createElement('span');
          span.className = className;
          span.appendChild(node);
          div.appendChild(span);
          return;
        }
        div.appendChild(node);
      }
      var selectedMatchIdx = 0;
      if (activeMatch) {
        selectedMatchIdx = activeMatch.selectedMatchIdx;
      }
      var i0 = selectedMatchIdx,
        i1 = i0 + 1;
      if (highlightAll) {
        i0 = 0;
        i1 = matches.length;
      }
      var updatedDivs = [];
      var activeMatchDiv = null;
      for (var i = i0; i < i1; i++) {
        var match = matches[i];
        var begin = match.begin;
        var end = match.end;
        var isSelected = activeMatch && i === selectedMatchIdx;
        var highlightSuffix = isSelected ? ' selected' : '';
        if (isSelected) {
          activeMatchDiv = textDivs[begin.divIdx];
        }
        updatedDivs.push(textDivs[begin.divIdx]);

        /*
              if (isSelected) { // Attempt to scroll the selected match into view.
                findController.scrollMatchIntoView({
                  element: textDivs[begin.divIdx],
                  pageIndex: pageIdx,
                  matchIndex: selectedMatchIdx,
                });
              }
        */

        // Match inside new div.
        if (!prevEnd || begin.divIdx !== prevEnd.divIdx) {
          // If there was a previous div, then add the text at the end.
          if (prevEnd !== null) {
            appendTextToDiv(prevEnd.divIdx, prevEnd.offset, infinity.offset);
          }
          // Clear the divs and set the content until the starting point.
          beginText(begin);
        } else {
          appendTextToDiv(prevEnd.divIdx, prevEnd.offset, begin.offset);
        }
        if (begin.divIdx === end.divIdx) {
          appendTextToDiv(begin.divIdx, begin.offset, end.offset, SEARCH_HIGHLIGHT_CLASS + highlightSuffix);
        } else {
          appendTextToDiv(begin.divIdx, begin.offset, infinity.offset, SEARCH_HIGHLIGHT_CLASS + ' begin' + highlightSuffix);
          for (var n0 = begin.divIdx + 1, n1 = end.divIdx; n0 < n1; n0++) {
            textDivs[n0].className = SEARCH_HIGHLIGHT_CLASS + ' middle' + highlightSuffix;
          }
          beginText(end, SEARCH_HIGHLIGHT_CLASS + ' end' + highlightSuffix);
        }
        prevEnd = end;
      }
      if (prevEnd) {
        appendTextToDiv(prevEnd.divIdx, prevEnd.offset, infinity.offset);
      }
      if (activeMatchDiv) {
        this.props.onActiveMatchRender(activeMatchDiv);
      }
    }

    /**
     * Отрисовка страницы
     * @param {Boolean} skipVisible учитывать видимость при рендринге
     * @returns {Promise<void>}
     */
  }, {
    key: "renderPage",
    value: function () {
      var _renderPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;
        var skipVisible,
          _this$props,
          pdfPage,
          scale,
          num,
          pdfjsLib,
          stateUpdate,
          counter,
          canvas,
          vpScale,
          viewport,
          pageSize,
          pageSizeHeight,
          textScale,
          textViewport,
          ctx,
          renderTask,
          renderTextPromise,
          renderAnnotationsTask,
          endOfContent,
          _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                skipVisible = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
                if (this.canvas) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return");
              case 3:
                _this$props = this.props, pdfPage = _this$props.pdfPage, scale = _this$props.scale, num = _this$props.num, pdfjsLib = _this$props.pdfjsLib;
                if (pdfPage) {
                  _context.next = 6;
                  break;
                }
                return _context.abrupt("return");
              case 6:
                if (!(!this.props.visible && !skipVisible)) {
                  _context.next = 8;
                  break;
                }
                return _context.abrupt("return");
              case 8:
                stateUpdate = {
                  isRendering: false
                };
                counter = ++this.renderCounter;
                this.setState(function () {
                  return {
                    isRendering: true
                  };
                });
                if (this.renderTask) {
                  try {
                    this.renderTask.cancel();
                  } catch (err) {
                    console.warn('fail to cancel render task', num, err);
                  }
                }
                if (this.textLayerRenderTask) {
                  try {
                    this.textLayerRenderTask.cancel();
                  } catch (err) {
                    console.warn('fail to cancel text render task', num, err);
                  }
                }
                // предотвращаем ошибку если this.textContainer === undefined | null
                if (this.textContainer) {
                  while (this.textContainer.firstChild) {
                    this.textContainer.removeChild(this.textContainer.firstChild);
                  }
                }
                canvas = this.canvas;
                vpScale = window.devicePixelRatio * scale * CSS_UNITS;
                viewport = pdfPage.getViewport({
                  scale: vpScale
                }); // иногда this.getPageSize() отдаёт не верную высоту страницы, поэтому нужно расчитывать
                // высоту в зависимости от вьюпорта и ширины которую выозвращает this.getPageSize()
                pageSize = this.getPageSize();
                pageSizeHeight = pageSize.width * viewport.height / viewport.width;
                stateUpdate = _objectSpread(_objectSpread({}, stateUpdate), {}, {
                  pageSizeHeight: pageSizeHeight
                });
                textScale = scale * CSS_UNITS;
                stateUpdate.textScale = textScale;
                textViewport = pdfPage.getViewport({
                  scale: textScale
                });
                canvas.width = Math.round(viewport.width);
                canvas.height = Math.round(viewport.height);
                canvas.style = "width: ".concat(pageSize.width, "px; height: ").concat(pageSizeHeight, "px;");
                this.canvasWrapper.style = "width: ".concat(pageSize.width, "px; height: ").concat(pageSizeHeight, "px;");
                ctx = canvas.getContext('2d');
                renderTask = pdfPage.render({
                  canvasContext: ctx,
                  viewport: viewport
                });
                this.renderTask = renderTask;
                this.textDivs = [];
                renderTextPromise = pdfPage.getTextContent().then(function (textContent) {
                  if (renderTask._canceled || counter !== _this2.renderCounter) {
                    throw new Error('render task was canceled');
                  }
                  _this2.textContainer.style = "width: ".concat(canvas.width, "px; height: ").concat(canvas.height, "px;");
                  _this2.textLayer = new pdfjsLib.TextLayer({
                    textContentSource: textContent,
                    container: _this2.textContainer,
                    viewport: textViewport
                  });
                  _this2.textLayerRenderTask = {
                    promise: _this2.textLayer.render(),
                    cancel: function cancel() {
                      return _this2.textLayer.cancel();
                    }
                  };

                  // Store reference to textDivs and textContentItemsStr for search functionality
                  _this2.textDivs = _this2.textLayer.textDivs;
                  _this2.textContentItemsStr = _this2.textLayer.textContentItemsStr;
                  return _this2.textLayerRenderTask.promise;
                });
                renderAnnotationsTask = pdfPage.getAnnotations({
                  intent: 'display'
                }).then(function (annotationData) {
                  if (renderTask._canceled || counter !== _this2.renderCounter) {
                    throw new Error('render task was canceled');
                  }
                  _this2.annotationLayer = new pdfjsLib.AnnotationLayer({
                    div: _this2.annotationContainer,
                    page: pdfPage,
                    viewport: viewport.clone({
                      dontFlip: true
                    }),
                    annotationCanvasMap: null,
                    accessibilityManager: null,
                    annotationEditorUIManager: null,
                    structTreeLayer: null,
                    commentManager: null
                  });
                  return _this2.annotationLayer.render({
                    viewport: viewport.clone({
                      dontFlip: true
                    }),
                    annotations: annotationData,
                    renderForms: true,
                    linkService: {
                      externalLinkTarget: 2,
                      // LinkTarget.BLANK
                      getDestinationHash: function getDestinationHash() {
                        return null;
                      },
                      getAnchorUrl: function getAnchorUrl(anchor) {
                        // Handle email links and other anchors
                        if (anchor && anchor.startsWith('mailto:')) {
                          return anchor;
                        }
                        return anchor;
                      },
                      addLinkAttributes: function addLinkAttributes(link, url) {
                        // Ensure email links are properly handled
                        if (url && url.startsWith('mailto:')) {
                          link.href = url;
                          link.target = '_blank';
                          link.rel = 'noopener noreferrer';
                        }
                      }
                    },
                    downloadManager: null,
                    annotationStorage: null,
                    imageResourcesPath: "",
                    enableScripting: false,
                    hasJSActions: false,
                    fieldObjects: null
                  });
                });
                _context.prev = 33;
                _context.next = 36;
                return Promise.all([renderTask.promise, renderTextPromise, renderAnnotationsTask.promise]);
              case 36:
                // create endContent
                endOfContent = document.createElement("div");
                endOfContent.className = "endOfContent";
                this.textContainer.appendChild(endOfContent);
                if (this.props.searchMatches) {
                  this.renderMatches(this.props.searchMatches, this.props.activeSearchMatch);
                }
                stateUpdate.isRendered = true;
                _context.next = 46;
                break;
              case 43:
                _context.prev = 43;
                _context.t0 = _context["catch"](33);
                console.warn('fail to render page', num, _context.t0);
              case 46:
                this.setState(function () {
                  return stateUpdate;
                });
              case 47:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[33, 43]]);
      }));
      function renderPage() {
        return _renderPage.apply(this, arguments);
      }
      return renderPage;
    }()
  }, {
    key: "_convertMatches",
    value: function _convertMatches(matches, matchesLength, textContentItemsStr, query) {
      // Early exit if there is nothing to convert.
      if (!matches) {
        return [];
      }

      //console.log('Convert matches', matches, textContentItemsStr)

      var i = 0,
        iIndex = 0;
      var end = textContentItemsStr.length - 1;
      var queryLen = query.length;
      var result = [];
      for (var m = 0, mm = matches.length; m < mm; m++) {
        // Calculate the start position.
        var matchIdx = matches[m];

        // Loop over the divIdxs.
        while (i !== end && matchIdx >= iIndex + textContentItemsStr[i].length) {
          iIndex += textContentItemsStr[i].length;
          i++;
        }
        if (i === textContentItemsStr.length) {
          console.error('Could not find a matching mapping');
        }
        var match = {
          begin: {
            divIdx: i,
            offset: matchIdx - iIndex
          }
        };

        // Calculate the end position.
        if (matchesLength) {
          // Multiterm search.
          matchIdx += matchesLength[m];
        } else {
          // Phrase search.
          matchIdx += queryLen;
        }

        // Somewhat the same array as above, but use > instead of >= to get
        // the end position right.
        while (i !== end && matchIdx > iIndex + textContentItemsStr[i].length) {
          iIndex += textContentItemsStr[i].length;
          i++;
        }
        match.end = {
          divIdx: i,
          offset: matchIdx - iIndex
        };
        result.push(match);
      }
      return result;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      if (oldProps.pdfPage !== this.props.pdfPage || this.props.visible && this.props.visible !== oldProps.visible && !this.state.isRendered && !this.state.isRendering) {
        this.renderPage();
      } else if (this.state.isRendered && this.props.scale !== oldProps.scale) {
        // при смене масштаба перерисовываем уже отрисованные страницы,
        // для того чтобы избежать артефактов
        this.renderPage(true);
      }
      if (oldProps.activeSearchMatch !== this.props.activeSearchMatch && this.state.isRendered) {
        this.renderMatches(this.props.searchMatches, this.props.activeSearchMatch);
      }
      if (oldProps.searchMatches !== this.props.searchMatches && this.state.isRendered) {
        this.renderMatches(this.props.searchMatches, this.props.activeSearchMatch);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getPageSize = this.getPageSize(),
        width = _this$getPageSize.width,
        height = _this$getPageSize.height;
      var classes = ['pdf-page'];
      if (this.props.active) classes.push('pdf-page-active'); // для тестирования активности страницы
      if (!this.props.pdfPage) classes.push('editor-loader2-grey editor-loader-cc');
      return (0,preact_module.h)("div", {
        className: classes.join(' '),
        style: {
          width: width + 'px',
          height: (this.state.pageSizeHeight || height) + 'px',
          '--scale-factor': this.state.textScale
        }
      }, (0,preact_module.h)("div", {
        className: "canvasWrapper",
        ref: this.onCanvasWrapperRef
      }, (0,preact_module.h)("canvas", {
        ref: this.onCanvasRef
      })), (0,preact_module.h)("div", {
        className: "textLayer " + (this.state.textLayerSelecting ? "selecting" : ""),
        ref: this.onTextContentDivRef,
        onMouseDown: this.onTextLayerMouseDown
      }), (0,preact_module.h)("div", {
        className: "annotationLayer",
        ref: this.onAnnotationContentDivRef
      }));
    }
  }]);
  return PDFPageView;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/lodash.throttle/index.js
var lodash_throttle = __webpack_require__(47983);
var lodash_throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/pdf/style.scss
var style = __webpack_require__(12934);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/util/dom.js
var dom = __webpack_require__(67546);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/pdfview.js
function pdfview_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { pdfview_typeof = function _typeof(obj) { return typeof obj; }; } else { pdfview_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return pdfview_typeof(obj); }










function pdfview_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function pdfview_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function pdfview_createClass(Constructor, protoProps, staticProps) { if (protoProps) pdfview_defineProperties(Constructor.prototype, protoProps); if (staticProps) pdfview_defineProperties(Constructor, staticProps); return Constructor; }
function pdfview_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) pdfview_setPrototypeOf(subClass, superClass); }
function pdfview_setPrototypeOf(o, p) { pdfview_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return pdfview_setPrototypeOf(o, p); }
function pdfview_createSuper(Derived) { var hasNativeReflectConstruct = pdfview_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = pdfview_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = pdfview_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return pdfview_possibleConstructorReturn(this, result); }; }
function pdfview_possibleConstructorReturn(self, call) { if (call && (pdfview_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return pdfview_assertThisInitialized(self); }
function pdfview_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function pdfview_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function pdfview_getPrototypeOf(o) { pdfview_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return pdfview_getPrototypeOf(o); }
function pdfview_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var PRELOAD_PAGES = 1;
var PAGE_BOTTOM_MARGIN = parseInt((style_default()).fullScreenViewerPagesMargin);
var FIRST_PAGE_TOP_MARGIN = parseInt((style_default()).fullScreenViewerFirstPageTopMargin);
var SCROLL_TO_PAGE_TOP_SPACE = 3;
var PDFView = /*#__PURE__*/function (_Component) {
  pdfview_inherits(PDFView, _Component);
  var _super = pdfview_createSuper(PDFView);
  function PDFView(props) {
    var _this;
    pdfview_classCallCheck(this, PDFView);
    _this = _super.call(this, props);
    pdfview_defineProperty(pdfview_assertThisInitialized(_this), "scrollTop", 0);
    pdfview_defineProperty(pdfview_assertThisInitialized(_this), "onSearchActiveMatchesRender", function (scrollToDiv) {
      if (!scrollToDiv) {
        return;
      }
      if ((0,dom/* isNodeInViewport */.gx)(scrollToDiv)) {
        return;
      }
      requestAnimationFrame(function () {
        scrollToDiv.scrollIntoView({
          block: 'center',
          inline: 'center'
        });
      });
    });
    pdfview_defineProperty(pdfview_assertThisInitialized(_this), "onRef", function (node) {
      if (!node) {
        return;
      }
      _this.rootNode = node;
      _this.rootNode.scrollTop = 0;
    });
    var pdfDocument = props.pdfDocument,
      pagesOverview = props.pagesOverview,
      scale = props.scale,
      defaultPageHeight = props.defaultPageHeight;
    _this.state = Object.assign({}, _this.getActivePage(0, pdfDocument, pagesOverview, scale, defaultPageHeight));
    _this.onScroll = lodash_throttle_default()(function (event) {
      var _this$props = _this.props,
        pdfDocument = _this$props.pdfDocument,
        pagesOverview = _this$props.pagesOverview,
        scale = _this$props.scale,
        defaultPageHeight = _this$props.defaultPageHeight;
      var _event$target = event.target,
        scrollHeight = _event$target.scrollHeight,
        scrollTop = _event$target.scrollTop,
        offsetHeight = _event$target.offsetHeight;
      var newState = _this.getActivePage(scrollTop, pdfDocument, pagesOverview, scale, defaultPageHeight);

      // Если проскроллили в конец то должна быть выделена последняя страница
      // нужно для масштаба 50%
      if (scrollTop + offsetHeight >= scrollHeight - PAGE_BOTTOM_MARGIN) {
        newState.pageActive = pdfDocument.numPages;
      }
      _this.setState(function () {
        return newState;
      }, function () {
        _this.scrollTop = scrollTop;
      });
    }, 300, {
      trailing: true
    });
    return _this;
  }
  pdfview_createClass(PDFView, [{
    key: "getActivePage",
    value: function getActivePage(scrollTop, pdfDocument, pagesOverview, scale, defaultPageHeight) {
      var y = FIRST_PAGE_TOP_MARGIN;
      var activePageNum = 1;
      for (var num = 1; num <= pdfDocument.numPages; num++) {
        var pageOverview = pagesOverview[num];
        var pageHeight = this.getPageHeight(pageOverview && pageOverview.height || defaultPageHeight, scale);
        if (scrollTop >= y - PAGE_BOTTOM_MARGIN && scrollTop <= y + pageHeight) {
          activePageNum = num;
          break;
        }
        y += pageHeight + PAGE_BOTTOM_MARGIN;
      }
      return {
        pageActive: activePageNum,
        pageVisibleStart: Math.max(0, activePageNum - PRELOAD_PAGES),
        pageVisibleEnd: Math.min(pdfDocument.numPages, activePageNum + PRELOAD_PAGES)
      };
    }
  }, {
    key: "getPageHeight",
    value: function getPageHeight(pdfHeight, scale) {
      return pdfHeight * scale * CSS_UNITS;
    }
  }, {
    key: "getPageBox",
    value: function getPageBox(pageNum, scale, pagesOverview) {
      var y = FIRST_PAGE_TOP_MARGIN;
      for (var num = 1; num < pageNum; num++) {
        // pagesOverview[pageNum] — для того чтобы сразу отобразить активную страницу
        // иначе если pagesOverview[num] выдаст ошибку пока другие странице не подгружены
        var pageOverview = pagesOverview[pageNum];
        if (!pagesOverview) {
          return null;
        }
        var _height = this.getPageHeight(pageOverview.height, scale);
        y += _height + PAGE_BOTTOM_MARGIN;
      }
      if (!pagesOverview[pageNum]) {
        return null;
      }
      var height = pagesOverview[pageNum].height;
      return {
        top: y,
        height: height
      };
    }
  }, {
    key: "scrollToActivePage",
    value: function scrollToActivePage(pageNum) {
      var _this$props2 = this.props,
        pagesOverview = _this$props2.pagesOverview,
        scale = _this$props2.scale;
      var box = this.getPageBox(pageNum, scale, pagesOverview);
      this.rootNode.scrollTop = box.top - SCROLL_TO_PAGE_TOP_SPACE;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.scale !== this.props.scale) {
        // при изменении масшатаба скроллим к текущей странице
        this.scrollToActivePage(this.state.pageActive);
      }
      if (prevState.pageActive !== this.state.pageActive) {
        this.props.onActivePageChange(this.state.pageActive);
      }
      if (prevProps.activatePage !== this.props.activatePage) {
        this.scrollToActivePage(this.props.activatePage.num);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        pdfDocument = _this$props3.pdfDocument,
        scale = _this$props3.scale,
        defaultPageWidth = _this$props3.defaultPageWidth,
        defaultPageHeight = _this$props3.defaultPageHeight,
        pagesOverview = _this$props3.pagesOverview,
        searchMatch = _this$props3.searchMatch,
        searchMatches = _this$props3.searchMatches,
        pdfjsLib = _this$props3.pdfjsLib;
      var _this$state = this.state,
        pages = _this$state.pages,
        scrollTop = _this$state.scrollTop,
        pageVisibleStart = _this$state.pageVisibleStart,
        pageVisibleEnd = _this$state.pageVisibleEnd;
      var pagesInstances = [];
      for (var num = 1; num <= pdfDocument.numPages; num++) {
        var pageOverview = pagesOverview[num];
        var visible = num >= pageVisibleStart && num <= pageVisibleEnd;
        var pageActiveSearchMatch = searchMatch && searchMatch.pageNum === num ? searchMatch : null;
        var pageSearchMatches = searchMatches[num - 1];
        pagesInstances.push((0,preact_module.h)(PDFPageView, {
          defaultWidth: defaultPageWidth,
          defaultHeight: defaultPageHeight,
          visible: visible,
          scale: scale,
          pdfPage: pageOverview && pageOverview.page,
          num: num,
          activeSearchMatch: pageActiveSearchMatch,
          searchMatches: pageSearchMatches,
          onActiveMatchRender: this.onSearchActiveMatchesRender,
          pdfjsLib: pdfjsLib,
          active: num === this.props.activePage
        }));
      }
      return (0,preact_module.h)("div", {
        className: "pdf-viewer-pages",
        ref: this.onRef,
        onScroll: this.onScroll
      }, pagesInstances);
    }
  }]);
  return PDFView;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/icons.js
var icons = __webpack_require__(49190);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreen/zoom.js
function zoom_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { zoom_typeof = function _typeof(obj) { return typeof obj; }; } else { zoom_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return zoom_typeof(obj); }











function zoom_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function zoom_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function zoom_createClass(Constructor, protoProps, staticProps) { if (protoProps) zoom_defineProperties(Constructor.prototype, protoProps); if (staticProps) zoom_defineProperties(Constructor, staticProps); return Constructor; }
function zoom_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) zoom_setPrototypeOf(subClass, superClass); }
function zoom_setPrototypeOf(o, p) { zoom_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return zoom_setPrototypeOf(o, p); }
function zoom_createSuper(Derived) { var hasNativeReflectConstruct = zoom_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = zoom_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = zoom_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return zoom_possibleConstructorReturn(this, result); }; }
function zoom_possibleConstructorReturn(self, call) { if (call && (zoom_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return zoom_assertThisInitialized(self); }
function zoom_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function zoom_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function zoom_getPrototypeOf(o) { zoom_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return zoom_getPrototypeOf(o); }
function zoom_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var ZOOM_LEVELS = [0.5, 0.75, 1, 1.25, 1.5, 2, 3, 4];
var Zoom = /*#__PURE__*/function (_Component) {
  zoom_inherits(Zoom, _Component);
  var _super = zoom_createSuper(Zoom);
  function Zoom() {
    var _this;
    zoom_classCallCheck(this, Zoom);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    zoom_defineProperty(zoom_assertThisInitialized(_this), "onSelect", function (event) {
      _this.scaleChanged(event.target.value);
    });
    zoom_defineProperty(zoom_assertThisInitialized(_this), "onDecreaseScale", function () {
      var prevIndex = ZOOM_LEVELS.indexOf(_this.props.scale) - 1;
      if (prevIndex < 0) {
        return;
      }
      _this.scaleChanged(ZOOM_LEVELS[prevIndex]);
    });
    zoom_defineProperty(zoom_assertThisInitialized(_this), "onIncreaseScale", function () {
      var nextIndex = ZOOM_LEVELS.indexOf(_this.props.scale) + 1;
      if (ZOOM_LEVELS.length <= nextIndex) {
        return;
      }
      _this.scaleChanged(ZOOM_LEVELS[nextIndex]);
    });
    return _this;
  }
  zoom_createClass(Zoom, [{
    key: "scaleChanged",
    value: function scaleChanged(newScale) {
      this.props.onScaleChange(newScale);
    }
  }, {
    key: "render",
    value: function render() {
      var scale = this.props.scale;
      var options = ZOOM_LEVELS.map(function (level) {
        return (0,preact_module.h)("option", {
          value: level
        }, Math.round(level * 100), "%");
      });
      return (0,preact_module.h)("div", {
        className: "pdf-viewer-zoom"
      }, (0,preact_module.h)("div", {
        className: "pdf-viewer-button",
        onClick: this.onIncreaseScale
      }, (0,preact_module.h)(icons/* IconPlus */.SC9, null)), (0,preact_module.h)("select", {
        onChange: this.onSelect,
        value: scale
      }, options), (0,preact_module.h)("div", {
        className: "pdf-viewer-button",
        onClick: this.onDecreaseScale
      }, (0,preact_module.h)(icons/* IconMinus */.UrD, null)));
    }
  }]);
  return Zoom;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.js
var web_url = __webpack_require__(60285);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.js
var web_url_search_params = __webpack_require__(41637);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreen/printPage.js
function printPage_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { printPage_typeof = function _typeof(obj) { return typeof obj; }; } else { printPage_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return printPage_typeof(obj); }

function printPage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function printPage_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { printPage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { printPage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }











function printPage_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function printPage_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function printPage_createClass(Constructor, protoProps, staticProps) { if (protoProps) printPage_defineProperties(Constructor.prototype, protoProps); if (staticProps) printPage_defineProperties(Constructor, staticProps); return Constructor; }
function printPage_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) printPage_setPrototypeOf(subClass, superClass); }
function printPage_setPrototypeOf(o, p) { printPage_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return printPage_setPrototypeOf(o, p); }
function printPage_createSuper(Derived) { var hasNativeReflectConstruct = printPage_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = printPage_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = printPage_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return printPage_possibleConstructorReturn(this, result); }; }
function printPage_possibleConstructorReturn(self, call) { if (call && (printPage_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return printPage_assertThisInitialized(self); }
function printPage_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function printPage_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function printPage_getPrototypeOf(o) { printPage_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return printPage_getPrototypeOf(o); }
function printPage_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var PRINT_RESOLUTION = 150;
var PRINT_UNITS = PRINT_RESOLUTION / 72.0;

// страница, которая будет выводится на печать
var PrintPage = /*#__PURE__*/function (_Component) {
  printPage_inherits(PrintPage, _Component);
  var _super = printPage_createSuper(PrintPage);
  function PrintPage(props) {
    var _this;
    printPage_classCallCheck(this, PrintPage);
    _this = _super.call(this, props);
    printPage_defineProperty(printPage_assertThisInitialized(_this), "onCanvasRef", function (canvas) {
      _this.canvas = canvas;
    });
    printPage_defineProperty(printPage_assertThisInitialized(_this), "onImgRef", function (img) {
      _this.img = img;
    });
    _this.state = {
      objectUrl: null
    };
    return _this;
  }
  printPage_createClass(PrintPage, [{
    key: "loadCanvasIntoImg",
    value: function loadCanvasIntoImg(canvas) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        var img = _this2.img;
        if (!img) {
          return reject(new Error('no img was loaded'));
        }
        img.onload = resolve;
        img.onerror = reject;
        canvas.toBlob(function (blob) {
          var objectUrl = URL.createObjectURL(blob);
          img.src = objectUrl;
          _this2.setState(function () {
            return {
              objectUrl: objectUrl
            };
          });
        });
      });
    }
  }, {
    key: "renderPage",
    value: function () {
      var _renderPage = printPage_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this3 = this;
        var _this$props, num, pdfDocument, pdfPage, canvas, viewport, ctx, renderTask;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, num = _this$props.num, pdfDocument = _this$props.pdfDocument;
                _context.next = 3;
                return pdfDocument.getPage(num);
              case 3:
                pdfPage = _context.sent;
                canvas = document.createElement('canvas');
                viewport = pdfPage.getViewport({
                  scale: 1
                });
                canvas.width = Math.floor(viewport.width * PRINT_UNITS);
                canvas.height = Math.floor(viewport.height * PRINT_UNITS);
                ctx = canvas.getContext('2d');
                renderTask = pdfPage.render({
                  canvasContext: ctx,
                  viewport: viewport,
                  transform: [PRINT_UNITS, 0, 0, PRINT_UNITS, 0, 0],
                  intent: 'print'
                });
                this.renderTask = renderTask;
                _context.prev = 11;
                _context.next = 14;
                return renderTask.promise;
              case 14:
                _context.next = 16;
                return this.loadCanvasIntoImg(canvas);
              case 16:
                _context.next = 21;
                break;
              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](11);
                return _context.abrupt("return", console.warn('rendering of a print page failed with', _context.t0));
              case 21:
                this.setState(function () {
                  return {
                    viewport: pdfPage.getViewport({
                      scale: 1
                    }),
                    width: Math.floor(viewport.width * CSS_UNITS),
                    height: Math.floor(viewport.height * CSS_UNITS)
                  };
                }, function () {
                  requestAnimationFrame(function () {
                    _this3.props.onLoad(pdfPage, num);
                  });
                  // удаляем ссылку на таск рендера, чтобы освободить память
                  _this3.renderTask = null;
                });
              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[11, 18]]);
      }));
      function renderPage() {
        return _renderPage.apply(this, arguments);
      }
      return renderPage;
    }()
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.canLoad) {
        this.renderPage();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.canLoad && prevProps.canLoad !== this.props.canLoad && !this.state.viewport) {
        this.renderPage();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.renderTask && !this.state.viewport) {
        this.renderTask.cancel();
      }
      if (this.state.objectUrl) {
        URL.revokeObjectURL(this.state.objectUrl);
      }

      // т.к. компоненты ресайклятся, то необходимо очистить ссылки
      this.renderTask = null;
      this.canvas = null;
      this.img = null;
      this.props = {};
    }
  }, {
    key: "render",
    value: function render() {
      var width = 1,
        height = 1;
      var viewport = this.state.viewport;
      if (viewport) {
        width = this.state.width;
        height = this.state.height;
      }
      return (0,preact_module.h)("div", {
        className: "pdf-viewer-printing-page"
      }, (0,preact_module.h)("img", {
        style: {
          width: width + 'px',
          height: height + 'px'
        },
        ref: this.onImgRef
      }));
    }
  }]);
  return PrintPage;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreen/print.css.txt
var print_css = __webpack_require__(2769);
var print_css_default = /*#__PURE__*/__webpack_require__.n(print_css);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/plugins/i18n/index.js + 16 modules
var plugins_i18n = __webpack_require__(81900);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreen/printingOverlay.js
function printingOverlay_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { printingOverlay_typeof = function _typeof(obj) { return typeof obj; }; } else { printingOverlay_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return printingOverlay_typeof(obj); }









function printingOverlay_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function printingOverlay_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function printingOverlay_createClass(Constructor, protoProps, staticProps) { if (protoProps) printingOverlay_defineProperties(Constructor.prototype, protoProps); if (staticProps) printingOverlay_defineProperties(Constructor, staticProps); return Constructor; }
function printingOverlay_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) printingOverlay_setPrototypeOf(subClass, superClass); }
function printingOverlay_setPrototypeOf(o, p) { printingOverlay_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return printingOverlay_setPrototypeOf(o, p); }
function printingOverlay_createSuper(Derived) { var hasNativeReflectConstruct = printingOverlay_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = printingOverlay_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = printingOverlay_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return printingOverlay_possibleConstructorReturn(this, result); }; }
function printingOverlay_possibleConstructorReturn(self, call) { if (call && (printingOverlay_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return printingOverlay_assertThisInitialized(self); }
function printingOverlay_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function printingOverlay_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function printingOverlay_getPrototypeOf(o) { printingOverlay_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return printingOverlay_getPrototypeOf(o); }
function printingOverlay_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





// не грузим все страницы сразу, а частями, иначе на больших пдф сильно грузится процессор
var MAX_SIM_PAGE_RENDERS = 30;
var PDFPagesContainer = /*#__PURE__*/function (_Component) {
  printingOverlay_inherits(PDFPagesContainer, _Component);
  var _super = printingOverlay_createSuper(PDFPagesContainer);
  function PDFPagesContainer(props) {
    var _this;
    printingOverlay_classCallCheck(this, PDFPagesContainer);
    _this = _super.call(this, props);
    printingOverlay_defineProperty(printingOverlay_assertThisInitialized(_this), "onPageLoad", function (page, num) {
      _this.props.onPageLoad(page, num);
      var _assertThisInitialize = printingOverlay_assertThisInitialized(_this),
        pagesState = _assertThisInitialize.pagesState;
      pagesState[num] = 'loaded';
      _this.loadingCnt--;
      var pagesLoaded = _this.state.pagesLoaded + 1;
      _this.setState(function () {
        return {
          pagesLoaded: pagesLoaded
        };
      }, function () {
        if (pagesLoaded >= _this.props.pdfDocument.numPages) {
          requestAnimationFrame(function () {
            _this.props.onPagesBuild();
          });
        }
        page.cleanup();
      });
    });
    _this.state = {
      pagesLoaded: 0
    };
    _this.loadingCnt = 0;
    _this.pagesState = {};
    for (var i = 1; i <= props.pdfDocument.numPages; i++) {
      _this.pagesState[i] = '';
    }
    return _this;
  }
  printingOverlay_createClass(PDFPagesContainer, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props = {};
    }
  }, {
    key: "render",
    value: function render() {
      var pdfDocument = this.props.pdfDocument;
      var pagesState = this.pagesState;
      var pages = [];
      for (var i = 1; i <= pdfDocument.numPages; i++) {
        var canLoad = false;
        if (this.loadingCnt < MAX_SIM_PAGE_RENDERS && pagesState[i] === '') {
          this.loadingCnt++;
          pagesState[i] = 'loading';
          canLoad = true;
        }
        pages.push((0,preact_module.h)(PrintPage, {
          num: i,
          pdfDocument: pdfDocument,
          canLoad: canLoad,
          onLoad: this.onPageLoad
        }));
      }
      return (0,preact_module.h)("div", {
        className: "pdf-viewer-printing-pages"
      }, pages);
    }
  }]);
  return PDFPagesContainer;
}(preact_module/* Component */.wA);
var PrintingOverlay = /*#__PURE__*/function (_Component2) {
  printingOverlay_inherits(PrintingOverlay, _Component2);
  var _super2 = printingOverlay_createSuper(PrintingOverlay);
  function PrintingOverlay(props) {
    var _this2;
    printingOverlay_classCallCheck(this, PrintingOverlay);
    _this2 = _super2.call(this, props);
    printingOverlay_defineProperty(printingOverlay_assertThisInitialized(_this2), "onPagesBuild", function () {
      window.print();
      _this2.props.onPrinted();
    });
    printingOverlay_defineProperty(printingOverlay_assertThisInitialized(_this2), "onPageLoad", function (page, num) {
      if (!_this2.pageStyleSheet) {
        var width = page.view[2];
        var height = page.view[3];
        _this2.pageStyleSheet = document.createElement('style');
        _this2.pageStyleSheet.textContent =
        // "size:<width> <height>" is what we need. But also add "A4" because
        // Firefox incorrectly reports support for the other value.
        '@supports ((size:A4) and (size:1pt 1pt)) {' + '@page { size: ' + width + 'pt ' + height + 'pt; margin: 0;}' + '}';
        document.body.appendChild(_this2.pageStyleSheet);
      }
      _this2.setState(function (prevState) {
        return {
          pagesLoaded: prevState.pagesLoaded + 1
        };
      });
    });
    printingOverlay_defineProperty(printingOverlay_assertThisInitialized(_this2), "onAbort", function () {
      _this2.props.onAbort();
    });
    _this2.state = {
      pagesLoaded: 0
    };
    // тут создается нода, вместо которой будет рендерится контент для печати
    var replaceableNode = document.createElement('div');
    document.body.insertBefore(replaceableNode, document.body.firstChild);
    return _this2;
  }
  printingOverlay_createClass(PrintingOverlay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var pdfDocument = this.props.pdfDocument;
      this.pRenderPages((0,preact_module.h)(PDFPagesContainer, {
        pdfDocument: pdfDocument,
        onPageLoad: this.onPageLoad,
        onPagesBuild: this.onPagesBuild
      }));
      this.printStyleSheet = document.createElement('style');
      this.printStyleSheet.textContent = (print_css_default());
      document.body.appendChild(this.printStyleSheet);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.pageStyleSheet) {
        this.pageStyleSheet.parentNode.removeChild(this.pageStyleSheet);
      }
      this.pRenderPages(null);
      this.printStyleSheet.parentNode.removeChild(this.printStyleSheet);
      this.props = {};
    }
  }, {
    key: "pRenderPages",
    value: function pRenderPages(component) {
      (0,preact_module/* render */.sY)(component, document.body);
    }
  }, {
    key: "render",
    value: function render() {
      var pdfDocument = this.props.pdfDocument;
      var percent = Math.round(this.state.pagesLoaded / pdfDocument.numPages * 100);
      return (0,preact_module.h)("div", {
        className: "pdf-viewer-printing-overlay"
      }, (0,preact_module.h)("div", {
        className: "pdf-viewer-printing-message"
      }, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
        id: "file.pdf_viewer.preparing_document_for_printing"
      }), ' ' + percent + '%', (0,preact_module.h)("br", null), (0,preact_module.h)("a", {
        onClick: this.onAbort
      }, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
        id: "file.pdf_viewer.abort"
      }))));
    }
  }]);
  return PrintingOverlay;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreen/pagePreview.js
function pagePreview_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { pagePreview_typeof = function _typeof(obj) { return typeof obj; }; } else { pagePreview_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return pagePreview_typeof(obj); }

function pagePreview_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function pagePreview_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { pagePreview_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { pagePreview_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }










function pagePreview_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function pagePreview_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function pagePreview_createClass(Constructor, protoProps, staticProps) { if (protoProps) pagePreview_defineProperties(Constructor.prototype, protoProps); if (staticProps) pagePreview_defineProperties(Constructor, staticProps); return Constructor; }
function pagePreview_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) pagePreview_setPrototypeOf(subClass, superClass); }
function pagePreview_setPrototypeOf(o, p) { pagePreview_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return pagePreview_setPrototypeOf(o, p); }
function pagePreview_createSuper(Derived) { var hasNativeReflectConstruct = pagePreview_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = pagePreview_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = pagePreview_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return pagePreview_possibleConstructorReturn(this, result); }; }
function pagePreview_possibleConstructorReturn(self, call) { if (call && (pagePreview_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return pagePreview_assertThisInitialized(self); }
function pagePreview_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function pagePreview_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function pagePreview_getPrototypeOf(o) { pagePreview_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return pagePreview_getPrototypeOf(o); }
function pagePreview_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var PagePreview = /*#__PURE__*/function (_Component) {
  pagePreview_inherits(PagePreview, _Component);
  var _super = pagePreview_createSuper(PagePreview);
  function PagePreview() {
    var _this;
    pagePreview_classCallCheck(this, PagePreview);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    pagePreview_defineProperty(pagePreview_assertThisInitialized(_this), "onCanvasRef", function (canvas) {
      _this.canvas = canvas;
      _this.state = {
        isRendered: false
      };
    });
    return _this;
  }
  pagePreview_createClass(PagePreview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        pageOverview = _this$props.pageOverview,
        visible = _this$props.visible;
      if (pageOverview && visible) {
        this.renderPage();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!this.state.isRendered) {
        var _this$props2 = this.props,
          pageOverview = _this$props2.pageOverview,
          visible = _this$props2.visible;
        if (pageOverview && visible && (pageOverview !== prevProps.pageOverview || visible !== prevProps.visible)) {
          this.renderPage();
        }
      }
    }
  }, {
    key: "getScale",
    value: function getScale() {
      var _this$props3 = this.props,
        pageOverview = _this$props3.pageOverview,
        width = _this$props3.width;
      var viewport = pageOverview.page.getViewport({
        scale: 1
      });
      return width / viewport.width;
    }
  }, {
    key: "renderPage",
    value: function () {
      var _renderPage = pagePreview_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var pageOverview, page, canvas, scale, vpScale, viewport, ctx, renderTask;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                pageOverview = this.props.pageOverview;
                page = pageOverview.page;
                canvas = this.canvas;
                scale = this.getScale();
                vpScale = window.devicePixelRatio * scale * CSS_UNITS;
                viewport = page.getViewport({
                  scale: vpScale
                });
                canvas.width = Math.round(viewport.width);
                canvas.height = Math.round(viewport.height);
                ctx = canvas.getContext('2d');
                renderTask = page.render({
                  canvasContext: ctx,
                  viewport: viewport
                });
                this.setState(function () {
                  return {
                    isRendered: true
                  };
                }, /*#__PURE__*/pagePreview_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return renderTask.promise;
                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })));
              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function renderPage() {
        return _renderPage.apply(this, arguments);
      }
      return renderPage;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        width = _this$props4.width,
        height = _this$props4.height;
      return (0,preact_module.h)("div", {
        className: 'pdf-viewer-page-preview ' + (this.props.active ? 'pdf-viewer-active-preview' : ''),
        style: {
          width: width + 'px',
          height: height + 'px'
        },
        onClick: this.props.onClick
      }, (0,preact_module.h)("canvas", {
        ref: this.onCanvasRef
      }));
    }
  }]);
  return PagePreview;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreen/sidebar.js
function sidebar_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { sidebar_typeof = function _typeof(obj) { return typeof obj; }; } else { sidebar_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return sidebar_typeof(obj); }









function sidebar_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function sidebar_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function sidebar_createClass(Constructor, protoProps, staticProps) { if (protoProps) sidebar_defineProperties(Constructor.prototype, protoProps); if (staticProps) sidebar_defineProperties(Constructor, staticProps); return Constructor; }
function sidebar_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) sidebar_setPrototypeOf(subClass, superClass); }
function sidebar_setPrototypeOf(o, p) { sidebar_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return sidebar_setPrototypeOf(o, p); }
function sidebar_createSuper(Derived) { var hasNativeReflectConstruct = sidebar_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = sidebar_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = sidebar_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return sidebar_possibleConstructorReturn(this, result); }; }
function sidebar_possibleConstructorReturn(self, call) { if (call && (sidebar_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return sidebar_assertThisInitialized(self); }
function sidebar_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function sidebar_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function sidebar_getPrototypeOf(o) { sidebar_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return sidebar_getPrototypeOf(o); }
function sidebar_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var MAX_PREVIEW_WIDTH = 100;
var PRELOAD_PREVIEWS = 10;
var PREVIEWS_TOP_MARGIN = parseInt((style_default()).fullScreenViewerPreviewsTopMargin);
var PREVIEW_BOTTOM_MARGIN = parseInt((style_default()).fullScreenViewerPreviewsMargin);
var SCROLL_TO_PREVIEW_TOP_SPACE = 3;
var Sidebar = /*#__PURE__*/function (_Component) {
  sidebar_inherits(Sidebar, _Component);
  var _super = sidebar_createSuper(Sidebar);
  function Sidebar(props) {
    var _this;
    sidebar_classCallCheck(this, Sidebar);
    _this = _super.call(this, props);
    sidebar_defineProperty(sidebar_assertThisInitialized(_this), "onRef", function (node) {
      if (!node) {
        return;
      }
      _this.rootNode = node;
      _this.rootNode.scrollTop = 0;
    });
    _this.state = {
      scrollTop: 0
    };
    _this.onScroll = lodash_throttle_default()(function (event) {
      _this.setState(function () {
        return {
          scrollTop: event.target.scrollTop
        };
      });
    }, 300, {
      trailing: true
    });
    return _this;
  }
  sidebar_createClass(Sidebar, [{
    key: "getPreviewSize",
    value: function getPreviewSize(pageOverview, defaultPageWidth, defaultPageHeight) {
      var pageWidth = defaultPageWidth;
      var pageHeight = defaultPageHeight;
      if (pageOverview) {
        pageWidth = pageOverview.width;
        pageHeight = pageOverview.height;
      }
      var pageRatio = pageWidth / pageHeight;
      var width = MAX_PREVIEW_WIDTH;
      var height = width / pageRatio;
      return {
        width: width,
        height: height
      };
    }
  }, {
    key: "getPreviewBox",
    value: function getPreviewBox(pageNum, pagesOverview, defaultPageWidth, defaultPageHeight) {
      var y = PREVIEWS_TOP_MARGIN;
      for (var num = 1; num < pageNum; num++) {
        var pageOverview = pagesOverview[num];
        var _this$getPreviewSize = this.getPreviewSize(pagesOverview[num], defaultPageWidth, defaultPageHeight),
          _height = _this$getPreviewSize.height;
        y += _height + PREVIEW_BOTTOM_MARGIN;
      }
      var _this$getPreviewSize2 = this.getPreviewSize(pagesOverview[pageNum], defaultPageWidth, defaultPageHeight),
        height = _this$getPreviewSize2.height;
      return {
        top: y,
        height: height
      };
    }

    // Скролл до текущей активной странице
  }, {
    key: "scrollTopActivePage",
    value: function scrollTopActivePage() {
      var _this$props = this.props,
        pagesOverview = _this$props.pagesOverview,
        defaultPageWidth = _this$props.defaultPageWidth,
        defaultPageHeight = _this$props.defaultPageHeight;
      // проверяем чтобы активная страница была видимой
      var box = this.getPreviewBox(this.props.activePage, pagesOverview, defaultPageWidth, defaultPageHeight);
      var viewTop = this.rootNode.scrollTop;
      var viewBottom = this.rootNode.offsetHeight + viewTop;
      if (viewTop <= box.top && viewBottom >= box.top + box.height) {} else {
        this.rootNode.scrollTop = box.top - SCROLL_TO_PREVIEW_TOP_SPACE;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scrollTopActivePage();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.activePage !== this.props.activePage) {
        this.scrollTopActivePage();
      }
    }
  }, {
    key: "onPageClick",
    value: function onPageClick(num) {
      this.props.onActivatePage(num);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        pdfDocument = _this$props2.pdfDocument,
        defaultPageWidth = _this$props2.defaultPageWidth,
        defaultPageHeight = _this$props2.defaultPageHeight,
        pagesOverview = _this$props2.pagesOverview;
      var scrollTop = this.state.scrollTop;
      var startVisibleNum, endVisibleNum;
      var y = PREVIEWS_TOP_MARGIN;
      for (var num = 1; num <= pdfDocument.numPages; num++) {
        var pageOverview = pagesOverview[num];
        var _this$getPreviewSize3 = this.getPreviewSize(pagesOverview[num], defaultPageWidth, defaultPageHeight),
          height = _this$getPreviewSize3.height;
        if (scrollTop >= y - PREVIEW_BOTTOM_MARGIN && scrollTop <= y + height + PREVIEW_BOTTOM_MARGIN) {
          startVisibleNum = Math.max(0, num - PRELOAD_PREVIEWS);
          endVisibleNum = Math.min(pdfDocument.numPages, num + PRELOAD_PREVIEWS);
          break;
        }
        y += height + PREVIEW_BOTTOM_MARGIN;
      }
      var previews = [];
      for (var _num = 1; _num <= pdfDocument.numPages; _num++) {
        var _pageOverview = pagesOverview[_num];
        var visible = _num >= startVisibleNum && _num <= endVisibleNum;
        var _this$getPreviewSize4 = this.getPreviewSize(_pageOverview, defaultPageWidth, defaultPageHeight),
          width = _this$getPreviewSize4.width,
          _height2 = _this$getPreviewSize4.height;
        previews.push((0,preact_module.h)(PagePreview, {
          width: width,
          height: _height2,
          pageOverview: _pageOverview,
          visible: visible,
          active: this.props.activePage === _num,
          onClick: this.onPageClick.bind(this, _num)
        }));
      }
      return (0,preact_module.h)("div", {
        ref: this.onRef,
        className: "pdf-viewer-sidebar",
        onScroll: this.onScroll
      }, (0,preact_module.h)("div", {
        className: "pdf-viewer-previews"
      }, previews));
    }
  }]);
  return Sidebar;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(21791);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/is-hotkey/lib/index.js
var lib = __webpack_require__(28199);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreen/search.js
function search_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { search_typeof = function _typeof(obj) { return typeof obj; }; } else { search_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return search_typeof(obj); }









function search_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function search_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function search_createClass(Constructor, protoProps, staticProps) { if (protoProps) search_defineProperties(Constructor.prototype, protoProps); if (staticProps) search_defineProperties(Constructor, staticProps); return Constructor; }
function search_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) search_setPrototypeOf(subClass, superClass); }
function search_setPrototypeOf(o, p) { search_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return search_setPrototypeOf(o, p); }
function search_createSuper(Derived) { var hasNativeReflectConstruct = search_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = search_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = search_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return search_possibleConstructorReturn(this, result); }; }
function search_possibleConstructorReturn(self, call) { if (call && (search_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return search_assertThisInitialized(self); }
function search_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function search_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function search_getPrototypeOf(o) { search_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return search_getPrototypeOf(o); }
function search_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var isEscKey = (0,lib/* default */.ZP)('escape');
var isEnterKey = (0,lib/* default */.ZP)('enter');
var SearchResult = /*#__PURE__*/function (_Component) {
  search_inherits(SearchResult, _Component);
  var _super = search_createSuper(SearchResult);
  function SearchResult(props) {
    var _this;
    search_classCallCheck(this, SearchResult);
    _this = _super.call(this, props);
    search_defineProperty(search_assertThisInitialized(_this), "onFoundMatches", function (_ref) {
      var pageNum = _ref.pageNum;
      //console.log('Found matches in', pageNum, 'total matches', this.props.finder.totalMatches, this.props.finder.query)
      var finder = _this.props.finder;
      _this.props.onTotalMatchesChange(finder.totalMatches);
    });
    _this.state = {};
    var _finder = props.finder;
    _finder.init();
    return _this;
  }
  search_createClass(SearchResult, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.finder.on('found-matches', this.onFoundMatches);
      this.doLookup();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.query !== this.props.query) {
        this.doLookup();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.finder.removeListener('found-matches', this.onFoundMatches);
    }
  }, {
    key: "doLookup",
    value: function doLookup() {
      var _this$props = this.props,
        finder = _this$props.finder,
        query = _this$props.query;
      finder.setQuery(query);
      finder.lookForMatches();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        totalMatches = _this$props2.totalMatches,
        selectedMatchIdx = _this$props2.selectedMatchIdx,
        notFound = _this$props2.notFound;
      var matchesText;
      if (notFound) {
        matchesText = (0,preact_module.h)("div", null, "Phrase not found");
      } else {
        if (totalMatches > 1000) {
          matchesText = (0,preact_module.h)("div", null, "Found More than 1000 matches");
        } else if (totalMatches === 0) {
          matchesText = (0,preact_module.h)("div", null, "Searching...");
        } else {
          matchesText = (0,preact_module.h)("div", null, selectedMatchIdx + 1, " of ", totalMatches, " match", totalMatches > 1 ? 'es' : '');
        }
      }
      return (0,preact_module.h)("div", {
        className: "pdf-viewer-search-result"
      }, matchesText, !notFound ? (0,preact_module.h)("div", null, (0,preact_module.h)("button", {
        onClick: this.props.onPrevMatch
      }, "Prev"), (0,preact_module.h)("button", {
        onClick: this.props.onNextMatch
      }, "Next")) : null, (0,preact_module.h)("div", {
        className: "close",
        onClick: this.props.onClose
      }, "\xD7"));
    }
  }]);
  return SearchResult;
}(preact_module/* Component */.wA);
var Search = /*#__PURE__*/function (_Component2) {
  search_inherits(Search, _Component2);
  var _super2 = search_createSuper(Search);
  function Search(props) {
    var _this2;
    search_classCallCheck(this, Search);
    _this2 = _super2.call(this, props);
    search_defineProperty(search_assertThisInitialized(_this2), "onChange", function (event) {
      _this2.props.finder.abort();
      _this2.setState(function () {
        return {
          query: event.target.value,
          scrollToFirstMatch: true,
          notFound: false
        };
      });
    });
    search_defineProperty(search_assertThisInitialized(_this2), "onInputKeyDown", function (event) {
      if (isEscKey(event)) {
        _this2.clearSearch();
      } else if (isEnterKey(event)) {
        _this2.onNextMatch();
      }
    });
    search_defineProperty(search_assertThisInitialized(_this2), "onFoundMatches", function () {
      var _this2$props = _this2.props,
        finder = _this2$props.finder,
        pdfDocument = _this2$props.pdfDocument;
      var matches = finder.rawMatches;
      if (_this2.state.scrollToFirstMatch) {
        var foundMatches;
        // ищем первую страницу, в которой найдено совпадение, чтобы проскроллить на него
        for (var i = 0; i !== pdfDocument.numPages; i++) {
          if (!matches[i]) {
            // совпадения еще не готовы, надо подождать, т.к. нам надо проскролить именно на первую страницу с совпадением,
            // а finder может искать в них не по порядку
            break;
          }
          if (!matches[i].length) {
            continue;
          }
          foundMatches = {
            pageNum: i + 1,
            matches: matches[i],
            matchesLength: finder.getPageMatchesLength(i),
            selectedMatchIdx: 0,
            query: _this2.state.query
          };
          break;
        }
        if (foundMatches) {
          _this2.setState(function () {
            return {
              scrollToFirstMatch: false,
              matchIdx: 0
            };
          }, function () {
            _this2.activateMatch(foundMatches);
          });
        }
      }
      _this2.foundMatchesDebounced(finder.matches);
    });
    search_defineProperty(search_assertThisInitialized(_this2), "onFinderSearchEnd", function () {
      var finder = _this2.props.finder;
      if (!finder.totalMatches) {
        _this2.setState(function () {
          return {
            notFound: true
          };
        }, function () {
          // говорим выше что матчи надо почистить
          _this2.activateMatch(null);
          _this2.foundMatches([]);
        });
      }
    });
    search_defineProperty(search_assertThisInitialized(_this2), "onPrevMatch", function () {
      if (_this2.state.matchIdx <= 0) {
        return;
      }
      var matchIdx = _this2.state.matchIdx - 1;
      _this2.setState(function () {
        return {
          matchIdx: matchIdx
        };
      }, function () {
        _this2.activateMatchByIdx(matchIdx);
      });
    });
    search_defineProperty(search_assertThisInitialized(_this2), "onNextMatch", function () {
      var totalMatches = _this2.state.totalMatches;
      var matchIdx = _this2.state.matchIdx + 1;
      if (matchIdx >= totalMatches) {
        return;
      }
      _this2.setState(function () {
        return {
          matchIdx: matchIdx
        };
      }, function () {
        _this2.activateMatchByIdx(matchIdx);
      });
    });
    search_defineProperty(search_assertThisInitialized(_this2), "onTotalMatchesChange", function (totalMatches) {
      _this2.setState(function () {
        return {
          totalMatches: totalMatches
        };
      });
    });
    search_defineProperty(search_assertThisInitialized(_this2), "onSearchResultClose", function () {
      _this2.clearSearch();
    });
    _this2.state = {
      query: '',
      scrollToFirstMatch: true,
      totalMatches: 0,
      matchIdx: 0,
      notFound: false
    };
    _this2.foundMatchesDebounced = lodash_debounce_default()(_this2.foundMatches, 200, {
      trailing: true
    });
    return _this2;
  }
  search_createClass(Search, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var finder = this.props.finder;
      finder.on('found-matches', this.onFoundMatches);
      finder.on('search-end', this.onFinderSearchEnd);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var finder = this.props.finder;
      finder.removeListener('found-matches', this.onFoundMatches);
      finder.removeListener('search-end', this.onFinderSearchEnd);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.query !== this.state.query && this.state.query === '') {
        // говорим выше что матчи надо почистить
        this.activateMatch(null);
        this.foundMatches([]);
      }
    }
  }, {
    key: "clearSearch",
    value: function clearSearch() {
      this.setState(function () {
        return {
          query: '',
          notFound: false
        };
      });
    }
  }, {
    key: "activateMatchByIdx",
    value: function activateMatchByIdx(idx) {
      var finder = this.props.finder;
      var pagesMatches = finder.rawMatches;
      var curIdx = 0;
      var matchIdx;
      var matches;
      var pageIdx;
      for (var i = 0; i != pagesMatches.length; i++) {
        if (curIdx + pagesMatches[i].length <= idx) {
          curIdx += pagesMatches[i].length;
        } else {
          matches = pagesMatches[i];
          matchIdx = idx - curIdx;
          pageIdx = i;
          break;
        }
      }
      if (matches) {
        var searchMatch = {
          pageNum: pageIdx + 1,
          matches: matches,
          matchesLength: finder.getPageMatchesLength(pageIdx),
          selectedMatchIdx: matchIdx,
          query: this.state.query
        };
        this.activateMatch(searchMatch);
      }
    }
  }, {
    key: "activateMatch",
    value: function activateMatch(searchMatch) {
      this.props.onActivateMatch(searchMatch);
    }
  }, {
    key: "foundMatches",
    value: function foundMatches(matches) {
      this.props.onMatches(matches);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        query = _this$state.query,
        totalMatches = _this$state.totalMatches,
        matchIdx = _this$state.matchIdx,
        notFound = _this$state.notFound;
      var searchResult = null;
      if (query.length > 0) {
        searchResult = (0,preact_module.h)(SearchResult, {
          query: query,
          finder: this.props.finder,
          onPrevMatch: this.onPrevMatch,
          onNextMatch: this.onNextMatch,
          totalMatches: totalMatches,
          selectedMatchIdx: matchIdx,
          onTotalMatchesChange: this.onTotalMatchesChange,
          notFound: notFound,
          onClose: this.onSearchResultClose
        });
      }
      return (0,preact_module.h)("div", {
        className: 'pdf-viewer-search ' + (notFound ? 'pdf-viewer-search-not-found' : '')
      }, (0,preact_module.h)("div", {
        className: "pdf-viewer-search-bar"
      }, (0,preact_module.h)("input", {
        value: query,
        type: "text",
        placeholder: "Search",
        onInput: this.onChange,
        onKeyDown: this.onInputKeyDown
      }), (0,preact_module.h)("div", {
        className: "pdf-viewer-search-icon"
      })), searchResult);
    }
  }]);
  return Search;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/lodash.chunk/index.js
var lodash_chunk = __webpack_require__(60764);
var lodash_chunk_default = /*#__PURE__*/__webpack_require__.n(lodash_chunk);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__(24603);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(15306);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(4723);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__(2707);
// EXTERNAL MODULE: ./node_modules/events/events.js
var events = __webpack_require__(94092);
var events_default = /*#__PURE__*/__webpack_require__.n(events);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreen/finder.js
function finder_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { finder_typeof = function _typeof(obj) { return typeof obj; }; } else { finder_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return finder_typeof(obj); }

function finder_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function finder_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { finder_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { finder_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function finder_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function finder_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function finder_createClass(Constructor, protoProps, staticProps) { if (protoProps) finder_defineProperties(Constructor.prototype, protoProps); if (staticProps) finder_defineProperties(Constructor, staticProps); return Constructor; }
function finder_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) finder_setPrototypeOf(subClass, superClass); }
function finder_setPrototypeOf(o, p) { finder_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return finder_setPrototypeOf(o, p); }
function finder_createSuper(Derived) { var hasNativeReflectConstruct = finder_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = finder_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = finder_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return finder_possibleConstructorReturn(this, result); }; }
function finder_possibleConstructorReturn(self, call) { if (call && (finder_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return finder_assertThisInitialized(self); }
function finder_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function finder_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function finder_getPrototypeOf(o) { finder_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return finder_getPrototypeOf(o); }


















var CHARACTERS_TO_NORMALIZE = {
  "\u2018": '\'',
  // Left single quotation mark
  "\u2019": '\'',
  // Right single quotation mark
  "\u201A": '\'',
  // Single low-9 quotation mark
  "\u201B": '\'',
  // Single high-reversed-9 quotation mark
  "\u201C": '"',
  // Left double quotation mark
  "\u201D": '"',
  // Right double quotation mark
  "\u201E": '"',
  // Double low-9 quotation mark
  "\u201F": '"',
  // Double high-reversed-9 quotation mark
  "\xBC": '1/4',
  // Vulgar fraction one quarter
  "\xBD": '1/2',
  // Vulgar fraction one half
  "\xBE": '3/4' // Vulgar fraction three quarters
};

var normalizationRegex = null;
function normalize(text) {
  if (!normalizationRegex) {
    // Compile the regular expression for text normalization once.
    var replace = Object.keys(CHARACTERS_TO_NORMALIZE).join('');
    normalizationRegex = new RegExp("[".concat(replace, "]"), 'g');
  }
  return text.replace(normalizationRegex, function (ch) {
    return CHARACTERS_TO_NORMALIZE[ch];
  });
}
var Finder = /*#__PURE__*/function (_EventEmitter) {
  finder_inherits(Finder, _EventEmitter);
  var _super = finder_createSuper(Finder);
  function Finder(pdfDocument) {
    var _this;
    finder_classCallCheck(this, Finder);
    _this = _super.call(this);
    _this._extractTextPromises = [];
    _this._pageContents = [];
    _this._pageContentsItems = [];
    _this._pendingFindMatches = [];
    _this._pageMatches = [];
    // содержит подготовленные метчи, с информацией о запросе
    _this._pageMatchesPrepared = [];
    _this._pageMatchesLength = [];
    _this._initialized = false;
    _this._initialization = false;
    _this._query = null;
    _this._matchesCountTotal = 0;
    _this._lookingForMatches = false;
    _this.pdfDocument = pdfDocument;
    _this.caseSensitive = false;
    _this.entireWord = false;
    _this.phraseSearch = true;
    _this.taskId = 0;
    return _this;
  }
  finder_createClass(Finder, [{
    key: "init",
    value: function () {
      var _init = finder_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this._initialized || this._initialization)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                this._initialization = true;
                _context.next = 5;
                return this._extractText();
              case 5:
                this._initialization = false;
                this._initialized = true;
                this.emit('initialized');
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "totalMatches",
    get: function get() {
      return this._matchesCountTotal;
    }
  }, {
    key: "matches",
    get: function get() {
      return this._pageMatchesPrepared;
    }
  }, {
    key: "rawMatches",
    get: function get() {
      return this._pageMatches;
    }
  }, {
    key: "getPageMatchesLength",
    value: function getPageMatchesLength(num) {
      var pageIdx = num - 1;
      return this._pageMatchesLength[pageIdx];
    }
  }, {
    key: "setQuery",
    value: function setQuery(query) {
      this._query = query;
    }
  }, {
    key: "abort",
    value: function abort() {
      this._pendingFindMatches = [];
      this._pageMatches = [];
      this._pageMatchesPrepared = [];
      this._pageMatchesLength = [];
      this._query = null;
      this._matchesCountTotal = 0;
      this._lookingForMatches = false;
      this.taskId++;
    }
  }, {
    key: "lookForMatches",
    value: function () {
      var _lookForMatches = finder_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;
        var currentTaskId, promises, i;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.taskId++;
                currentTaskId = this.taskId;
                this._lookingForMatches = true;
                promises = [];
                i = 0;
              case 5:
                if (!(i < this.pdfDocument.numPages)) {
                  _context2.next = 16;
                  break;
                }
                if (!(currentTaskId !== this.taskId)) {
                  _context2.next = 9;
                  break;
                }
                // таск поиска был отменен
                this._lookingForMatches = false;
                return _context2.abrupt("return");
              case 9:
                if (!(this._pendingFindMatches[i] === true)) {
                  _context2.next = 11;
                  break;
                }
                return _context2.abrupt("continue", 13);
              case 11:
                this._pendingFindMatches[i] = true;
                promises.push(this._extractTextPromises[i].then(function (pageIdx) {
                  if (currentTaskId !== _this2.taskId) {
                    // таск поиска был отменен
                    _this2._lookingForMatches = false;
                    return;
                  }
                  delete _this2._pendingFindMatches[pageIdx];
                  _this2._calculateMatch(pageIdx);
                }));
              case 13:
                i++;
                _context2.next = 5;
                break;
              case 16:
                if (!(currentTaskId !== this.taskId)) {
                  _context2.next = 19;
                  break;
                }
                // таск поиска был отменен
                this._lookingForMatches = false;
                return _context2.abrupt("return");
              case 19:
                _context2.next = 21;
                return Promise.all(promises);
              case 21:
                this._lookingForMatches = false;
                this.emit('search-end');
              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function lookForMatches() {
        return _lookForMatches.apply(this, arguments);
      }
      return lookForMatches;
    }()
  }, {
    key: "_calculateMatch",
    value: function _calculateMatch(pageIndex) {
      var pageContent = this._pageContents[pageIndex];
      var query = this._query;
      var caseSensitive = this.caseSensitive,
        entireWord = this.entireWord,
        phraseSearch = this.phraseSearch;
      if (query.length === 0) {
        return;
      }
      if (!caseSensitive) {
        pageContent = pageContent.toLowerCase();
        query = query.toLowerCase();
      }
      if (phraseSearch) {
        this._calculatePhraseMatch(query, pageIndex, pageContent, entireWord);
      } else {
        this._calculateWordMatch(query, pageIndex, pageContent, entireWord);
      }
      this._pageMatchesPrepared[pageIndex] = {
        matches: this._pageMatches[pageIndex],
        matchesLength: this._pageMatchesLength[pageIndex],
        query: this._query
      };

      // Update the match count.
      var pageMatchesCount = this._pageMatches[pageIndex].length;
      if (pageMatchesCount > 0) {
        this._matchesCountTotal += pageMatchesCount;
        this.emit('found-matches', {
          pageNum: pageIndex + 1
        });
      }
    }
  }, {
    key: "_calculatePhraseMatch",
    value: function _calculatePhraseMatch(query, pageIndex, pageContent, entireWord) {
      var matches = [];
      var queryLen = query.length;
      var matchIdx = -queryLen;
      while (true) {
        matchIdx = pageContent.indexOf(query, matchIdx + queryLen);
        if (matchIdx === -1) {
          break;
        }
        if (entireWord && !this._isEntireWord(pageContent, matchIdx, queryLen)) {
          continue;
        }
        matches.push(matchIdx);
      }
      if (matches.length) {
        console.info('Found matches', matches, 'For page', pageIndex);
      }
      this._pageMatches[pageIndex] = matches;
    }
  }, {
    key: "_calculateWordMatch",
    value: function _calculateWordMatch(query, pageIndex, pageContent, entireWord) {
      var matchesWithLength = [];

      // Divide the query into pieces and search for text in each piece.
      var queryArray = query.match(/\S+/g);
      for (var i = 0, len = queryArray.length; i < len; i++) {
        var subquery = queryArray[i];
        var subqueryLen = subquery.length;
        var matchIdx = -subqueryLen;
        while (true) {
          matchIdx = pageContent.indexOf(subquery, matchIdx + subqueryLen);
          if (matchIdx === -1) {
            break;
          }
          if (entireWord && !this._isEntireWord(pageContent, matchIdx, subqueryLen)) {
            continue;
          }
          // Other searches do not, so we store the length.
          matchesWithLength.push({
            match: matchIdx,
            matchLength: subqueryLen,
            skipped: false
          });
        }
      }

      // Prepare arrays for storing the matches.
      this._pageMatchesLength[pageIndex] = [];
      this._pageMatches[pageIndex] = [];

      // Sort `matchesWithLength`, remove intersecting terms and put the result
      // into the two arrays.
      this._prepareMatches(matchesWithLength, this._pageMatches[pageIndex], this._pageMatchesLength[pageIndex]);
    }

    /**
     * Helper for multi-term search that fills the `matchesWithLength` array
     * and handles cases where one search term includes another search term (for
     * example, "tamed tame" or "this is"). It looks for intersecting terms in
     * the `matches` and keeps elements with a longer match length.
     */
  }, {
    key: "_prepareMatches",
    value: function _prepareMatches(matchesWithLength, matches, matchesLength) {
      function isSubTerm(matchesWithLength, currentIndex) {
        var currentElem = matchesWithLength[currentIndex];
        var nextElem = matchesWithLength[currentIndex + 1];

        // Check for cases like "TAMEd TAME".
        if (currentIndex < matchesWithLength.length - 1 && currentElem.match === nextElem.match) {
          currentElem.skipped = true;
          return true;
        }

        // Check for cases like "thIS IS".
        for (var i = currentIndex - 1; i >= 0; i--) {
          var prevElem = matchesWithLength[i];
          if (prevElem.skipped) {
            continue;
          }
          if (prevElem.match + prevElem.matchLength < currentElem.match) {
            break;
          }
          if (prevElem.match + prevElem.matchLength >= currentElem.match + currentElem.matchLength) {
            currentElem.skipped = true;
            return true;
          }
        }
        return false;
      }

      // Sort the array of `{ match: <match>, matchLength: <matchLength> }`
      // objects on increasing index first and on the length otherwise.
      matchesWithLength.sort(function (a, b) {
        return a.match === b.match ? a.matchLength - b.matchLength : a.match - b.match;
      });
      for (var i = 0, len = matchesWithLength.length; i < len; i++) {
        if (isSubTerm(matchesWithLength, i)) {
          continue;
        }
        matches.push(matchesWithLength[i].match);
        matchesLength.push(matchesWithLength[i].matchLength);
      }
    }

    /**
     * Determine if the search query constitutes a "whole word", by comparing the
     * first/last character type with the preceding/following character type.
     */
  }, {
    key: "_isEntireWord",
    value: function _isEntireWord(content, startIdx, length) {
      if (startIdx > 0) {
        var first = content.charCodeAt(startIdx);
        var limit = content.charCodeAt(startIdx - 1);
        if (getCharacterType(first) === getCharacterType(limit)) {
          return false;
        }
      }
      var endIdx = startIdx + length - 1;
      if (endIdx < content.length - 1) {
        var last = content.charCodeAt(endIdx);
        var _limit = content.charCodeAt(endIdx + 1);
        if (getCharacterType(last) === getCharacterType(_limit)) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "_extractPageText",
    value: function () {
      var _extractPageText2 = finder_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(i) {
        var pdfPage, textContent, textItems, strBuf, j, jj;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.pdfDocument.getPage(i + 1);
              case 3:
                pdfPage = _context3.sent;
                _context3.next = 6;
                return pdfPage.getTextContent({
                  normalizeWhitespace: true
                });
              case 6:
                textContent = _context3.sent;
                textItems = textContent.items;
                strBuf = [];
                for (j = 0, jj = textItems.length; j < jj; j++) {
                  strBuf.push(textItems[j].str);
                }

                // Store the normalized page content (text items) as one string.
                this._pageContents[i] = normalize(strBuf.join(''));
                _context3.next = 17;
                break;
              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](0);
                console.error("Unable to get text content for page ".concat(i + 1), _context3.t0);
                // Page error -- assuming no text content.
                this._pageContents[i] = '';
              case 17:
                return _context3.abrupt("return", i);
              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 13]]);
      }));
      function _extractPageText(_x) {
        return _extractPageText2.apply(this, arguments);
      }
      return _extractPageText;
    }()
  }, {
    key: "_extractText",
    value: function _extractText() {
      if (this._extractTextPromises.length) {
        return;
      }
      for (var i = 0; i < this.pdfDocument.numPages; i++) {
        this._extractTextPromises[i] = this._extractPageText(i);
      }
      return Promise.all(this._extractTextPromises);
    }
  }]);
  return Finder;
}((events_default()));

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/util.js
var util = __webpack_require__(33103);
// EXTERNAL MODULE: ./node_modules/downloadjs/download.js
var download = __webpack_require__(27266);
var download_default = /*#__PURE__*/__webpack_require__.n(download);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreen/navigation.js
function navigation_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { navigation_typeof = function _typeof(obj) { return typeof obj; }; } else { navigation_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return navigation_typeof(obj); }









function navigation_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function navigation_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function navigation_createClass(Constructor, protoProps, staticProps) { if (protoProps) navigation_defineProperties(Constructor.prototype, protoProps); if (staticProps) navigation_defineProperties(Constructor, staticProps); return Constructor; }
function navigation_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) navigation_setPrototypeOf(subClass, superClass); }
function navigation_setPrototypeOf(o, p) { navigation_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return navigation_setPrototypeOf(o, p); }
function navigation_createSuper(Derived) { var hasNativeReflectConstruct = navigation_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = navigation_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = navigation_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return navigation_possibleConstructorReturn(this, result); }; }
function navigation_possibleConstructorReturn(self, call) { if (call && (navigation_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return navigation_assertThisInitialized(self); }
function navigation_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function navigation_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function navigation_getPrototypeOf(o) { navigation_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return navigation_getPrototypeOf(o); }
function navigation_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var navigation_isEnterKey = (0,lib/* default */.ZP)('enter');

var PdfPageNavigation = /*#__PURE__*/function (_Component) {
  navigation_inherits(PdfPageNavigation, _Component);
  var _super = navigation_createSuper(PdfPageNavigation);
  function PdfPageNavigation(props) {
    var _this;
    navigation_classCallCheck(this, PdfPageNavigation);
    _this = _super.call(this, props);
    navigation_defineProperty(navigation_assertThisInitialized(_this), "onRefInput", function (node) {
      _this.inputText = node;
    });
    navigation_defineProperty(navigation_assertThisInitialized(_this), "onChange", function (event) {
      var _this$props = _this.props,
        activePage = _this$props.activePage,
        pdfDocument = _this$props.pdfDocument;
      if (navigation_isEnterKey(event)) {
        var page = _this.inputText.value;
        if (!page) {
          return false;
        }
        page = parseInt(page) || 0;
        if (page > pdfDocument.numPages || page === 0) {
          _this.inputText.value = activePage;
        } else if (page === activePage) {
          return false;
        } else {
          _this.props.onActivatePage(page);
        }
      }
    });
    navigation_defineProperty(navigation_assertThisInitialized(_this), "onInput", function (event) {
      if (!event.data) {
        return false;
      }
      var page = parseInt(event.data);
      if (isNaN(page)) {
        _this.inputText.value = '';
      }
    });
    navigation_defineProperty(navigation_assertThisInitialized(_this), "onNextPageClick", function (event) {
      var _this$props2 = _this.props,
        activePage = _this$props2.activePage,
        pdfDocument = _this$props2.pdfDocument;
      if (activePage === pdfDocument.numPages) {
        return false;
      } else {
        _this.props.onActivatePage(activePage + 1);
      }
    });
    navigation_defineProperty(navigation_assertThisInitialized(_this), "onPrevPageClick", function (event) {
      var activePage = _this.props.activePage;
      if (activePage === 1) {
        return false;
      } else {
        _this.props.onActivatePage(activePage - 1);
      }
    });
    return _this;
  }
  navigation_createClass(PdfPageNavigation, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        activePage = _this$props3.activePage,
        pdfDocument = _this$props3.pdfDocument;
      var inputText = (0,preact_module.h)("input", {
        type: "text",
        id: "page-navigation",
        className: "current-page",
        value: activePage,
        maxLength: "4",
        onKeyDown: this.onChange,
        onInput: this.onInput,
        ref: this.onRefInput
      });
      return (0,preact_module.h)("div", {
        className: "pdf-viewer-navigation"
      }, (0,preact_module.h)("div", {
        className: "pdf-viewer-button to-prev",
        style: {
          transform: 'rotate(90deg)'
        },
        onClick: this.onPrevPageClick
      }, (0,preact_module.h)(icons/* IconChevronLeft */.ed9, null)), (0,preact_module.h)("div", {
        className: "pdf-viewer-button to-next",
        style: {
          transform: 'rotate(-90deg)'
        },
        onClick: this.onNextPageClick
      }, (0,preact_module.h)(icons/* IconChevronLeft */.ed9, null)), inputText, " / ", pdfDocument.numPages);
    }
  }]);
  return PdfPageNavigation;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreen.js
function fullscreen_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { fullscreen_typeof = function _typeof(obj) { return typeof obj; }; } else { fullscreen_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return fullscreen_typeof(obj); }
function fullscreen_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = fullscreen_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function fullscreen_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return fullscreen_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return fullscreen_arrayLikeToArray(o, minLen); }
function fullscreen_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function fullscreen_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function fullscreen_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { fullscreen_ownKeys(Object(source), true).forEach(function (key) { fullscreen_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { fullscreen_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















function fullscreen_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function fullscreen_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { fullscreen_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { fullscreen_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function fullscreen_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function fullscreen_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function fullscreen_createClass(Constructor, protoProps, staticProps) { if (protoProps) fullscreen_defineProperties(Constructor.prototype, protoProps); if (staticProps) fullscreen_defineProperties(Constructor, staticProps); return Constructor; }
function fullscreen_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) fullscreen_setPrototypeOf(subClass, superClass); }
function fullscreen_setPrototypeOf(o, p) { fullscreen_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return fullscreen_setPrototypeOf(o, p); }
function fullscreen_createSuper(Derived) { var hasNativeReflectConstruct = fullscreen_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = fullscreen_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = fullscreen_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return fullscreen_possibleConstructorReturn(this, result); }; }
function fullscreen_possibleConstructorReturn(self, call) { if (call && (fullscreen_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return fullscreen_assertThisInitialized(self); }
function fullscreen_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function fullscreen_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function fullscreen_getPrototypeOf(o) { fullscreen_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return fullscreen_getPrototypeOf(o); }
function fullscreen_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }














var fullscreen_isEscKey = (0,lib/* default */.ZP)('escape');
var PDFFullScreenViewer = /*#__PURE__*/function (_Component) {
  fullscreen_inherits(PDFFullScreenViewer, _Component);
  var _super = fullscreen_createSuper(PDFFullScreenViewer);
  function PDFFullScreenViewer(props) {
    var _this;
    fullscreen_classCallCheck(this, PDFFullScreenViewer);
    _this = _super.call(this, props);
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onPageLoaded", /*#__PURE__*/function () {
      var _ref = fullscreen_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(num, promise, stateUpdate) {
        var page, viewport, countLoadedPages, state;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return promise;
              case 2:
                page = _context.sent;
                viewport = page.getViewport({
                  scale: 1
                });
                countLoadedPages = _this.state.countLoadedPages + 1;
                state = {
                  countLoadedPages: countLoadedPages,
                  isLoadingPages: countLoadedPages < _this.props.pdfDocument.numPages
                };
                if (stateUpdate) {
                  Object.assign(state, stateUpdate);
                }
                if (num === _this.props.page) {
                  state = fullscreen_objectSpread(fullscreen_objectSpread({}, state), {}, {
                    activePage: num,
                    activatePage: {
                      num: _this.props.page
                    }
                  });
                }
                _this.setState(function (prev) {
                  return fullscreen_objectSpread(fullscreen_objectSpread({}, state), {}, {
                    pagesOverview: fullscreen_objectSpread(fullscreen_objectSpread({}, prev.pagesOverview), {}, fullscreen_defineProperty({}, num, {
                      width: viewport.width,
                      height: viewport.height,
                      page: page
                    }))
                  });
                });
              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }());
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onDocumentKeydown", function (event) {
      if (event.target && (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA')) {
        return;
      }
      if (fullscreen_isEscKey(event)) {
        // останавливаем пропагацию, чтобы событие не уходило в редактор
        _this.callOnClose();
      }
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "handleWindowResize", function () {
      // Обработчик изменения размера окна
      _this.checkScreenWidth();
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onClose", function () {
      // передаём номер текущий страницы из полноэкранного режима
      _this.props.onPageChange(_this.state.activePage);
      _this.callOnClose();
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onScaleChange", function (scale) {
      _this.props.onScaleChange(scale);
      _this.setState(function () {
        return {
          scale: scale
        };
      });
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "getDefaultScale", function (size) {
      // рассчитываем уровень зума при открытии PDF
      // адаптируемся под размер экрана, считаем что максимальный размер страницы это половина экрана
      var screenWidth = window.screen.width;
      var availableWidth = screenWidth / 2;
      var availableScale = availableWidth / size.width;
      var delta = Number.POSITIVE_INFINITY;
      var scale = 0;
      var _iterator = fullscreen_createForOfIteratorHelper(ZOOM_LEVELS),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var s = _step.value;
          var d = Math.abs(s - availableScale);
          if (d < delta) {
            delta = d;
            scale = s;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return scale;
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onPrint", function () {
      if (_this.props.options && _this.props.options.onPrint) {
        if (_this.props.options.onPrint({
          attachment: _this.props.attachment
        }) === true) {
          return;
        }
      }
      _this.setState(function () {
        return {
          isPrinting: true
        };
      });
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onPrinted", function () {
      _this.setState(function () {
        return {
          isPrinting: false
        };
      });
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onPrintAbort", function () {
      _this.setState(function () {
        return {
          isPrinting: false
        };
      });
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onActivePageChange", function (num) {
      _this.setState(function () {
        return {
          activePage: num
        };
      });
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onActivatePage", function (num) {
      _this.setState(function () {
        return {
          activatePage: {
            num: num
          }
        };
      });
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onToggleSidebar", function () {
      _this.setState(function (prevState) {
        return {
          isSidebarVisible: !prevState.isSidebarVisible
        };
      });
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onDownload", function () {
      var _this$props = _this.props,
        attachment = _this$props.attachment,
        editor = _this$props.editor;
      if (!editor.plugins.attachmentManager.download(attachment)) {
        download_default()(attachment.url);
      }
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onActivateSearchMatch", function (searchMatch) {
      _this.setState(function (prevState) {
        var newState = {
          searchMatch: searchMatch
        };
        if (searchMatch && searchMatch.pageNum !== prevState.activatePage.num) {
          newState.activatePage = {
            num: searchMatch.pageNum
          };
        }
        return newState;
      });
    });
    fullscreen_defineProperty(fullscreen_assertThisInitialized(_this), "onSearchMatches", function (matches) {
      // делаем копию массива чтобы изменить состояние, т.к. в matches всегда приходит один и тотже массив в рамках одного поиска
      _this.setState(function () {
        return {
          searchMatches: matches.slice()
        };
      });
    });
    var _scale = _this.props.scale ? _this.props.scale : _this.getDefaultScale(props.pageSize);
    _this.state = {
      scale: _scale,
      isPrinting: false,
      isInitialLoadComplete: false,
      isLoadingPages: true,
      countLoadedPages: 0,
      pagesOverview: props.pagesOverview,
      activePage: 1,
      activatePage: {
        num: 1
      },
      isSidebarVisible: true,
      searchMatch: null,
      searchMatches: []
    };
    var pdfDocument = props.pdfDocument;
    _this.finder = new Finder(pdfDocument);
    return _this;
  }
  fullscreen_createClass(PDFFullScreenViewer, [{
    key: "loadPages",
    value: function () {
      var _loadPages = fullscreen_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(numbers) {
        var _this2 = this;
        var pdfDocument, chunks, loadChunk, _iterator2, _step2, chunk;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // грузим страницы постепенно, используются цифры количество загружаемых страниц и таймаута,
                // которые позволяют не грузить сильно браузер
                pdfDocument = this.props.pdfDocument;
                chunks = lodash_chunk_default()(numbers, 20);
                loadChunk = function loadChunk(chunk) {
                  chunk.forEach(function (num) {
                    _this2.onPageLoaded(num, pdfDocument.getPage(num));
                  });
                };
                _iterator2 = fullscreen_createForOfIteratorHelper(chunks);
                _context2.prev = 4;
                _iterator2.s();
              case 6:
                if ((_step2 = _iterator2.n()).done) {
                  _context2.next = 13;
                  break;
                }
                chunk = _step2.value;
                loadChunk(chunk);
                _context2.next = 11;
                return (0,util/* wait */.Dc)(500);
              case 11:
                _context2.next = 6;
                break;
              case 13:
                _context2.next = 18;
                break;
              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](4);
                _iterator2.e(_context2.t0);
              case 18:
                _context2.prev = 18;
                _iterator2.f();
                return _context2.finish(18);
              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 15, 18, 21]]);
      }));
      function loadPages(_x4) {
        return _loadPages.apply(this, arguments);
      }
      return loadPages;
    }()
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      var editor = this.props.editor;
      document.addEventListener('keydown', this.onDocumentKeydown, false);
      editor.scroll.stopHandlingKeydown();

      // устанавливаем текущую страницу
      this.setState(function () {
        return {
          activePage: _this3.props.page,
          activatePage: {
            num: _this3.props.page
          },
          isInitialLoadComplete: true
        };
      });
      window.addEventListener('resize', this.handleWindowResize);
      // Проверяем ширину экрана при монтировании компонента
      this.checkScreenWidth();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var editor = this.props.editor;
      document.removeEventListener('keydown', this.onDocumentKeydown, false);
      editor.scroll.resumeHandlingKeydown();
      window.removeEventListener('resize', this.handleWindowResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.isInitialLoadComplete && prevState.isInitialLoadComplete !== this.state.isInitialLoadComplete) {
        var pagesOverview = this.state.pagesOverview;
        var _pdfDocument = this.props.pdfDocument;
        // подгружаем информацию об остальных страницах
        var toLoad = [];
        for (var num = 1; num <= _pdfDocument.numPages; num++) {
          if (!pagesOverview[num]) {
            toLoad.push(num);
          }
        }
        this.loadPages(toLoad);
      }
    }
  }, {
    key: "checkScreenWidth",
    value: function checkScreenWidth() {
      // Проверяем ширину экрана и скрываем сайдбар, если необходимо
      var screenWidth = window.innerWidth;
      var isSidebarVisible = this.state.isSidebarVisible;
      if (screenWidth <= 1100 && isSidebarVisible) {
        this.onToggleSidebar();
      } else if (screenWidth > 1100 && !isSidebarVisible) {
        // Если ширина экрана стала больше 1100, и сайдбар был скрыт, показываем его
        this.onToggleSidebar();
      }
    }
  }, {
    key: "callOnClose",
    value: function callOnClose() {
      this.props.onClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        pageSize = _this$props2.pageSize,
        pdfDocument = _this$props2.pdfDocument,
        pdfjsLib = _this$props2.pdfjsLib,
        attachment = _this$props2.attachment,
        blot = _this$props2.blot;
      var _this$state = this.state,
        isPrinting = _this$state.isPrinting,
        pagesOverview = _this$state.pagesOverview,
        activePage = _this$state.activePage,
        isSidebarVisible = _this$state.isSidebarVisible,
        searchMatch = _this$state.searchMatch,
        searchMatches = _this$state.searchMatches;
      var printingOverlay = null;
      if (isPrinting) {
        printingOverlay = (0,preact_module.h)(PrintingOverlay, {
          onAbort: this.onPrintAbort,
          onPrinted: this.onPrinted,
          pdfDocument: pdfDocument
        });
      }
      var downloading = null;
      var printing = null;
      if (blot && !blot.disallowDownloading) {
        downloading = (0,preact_module.h)("div", {
          className: "pdf-viewer-button pdf-viewer-download",
          onClick: this.onDownload
        }, (0,preact_module.h)("i", null));
        printing = (0,preact_module.h)("div", {
          className: "pdf-viewer-button pdf-viewer-print",
          onClick: this.onPrint
        }, (0,preact_module.h)("i", null));
      }
      return (0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, (0,preact_module.h)("div", null, printingOverlay, (0,preact_module.h)("div", {
        className: "pdf-viewer-top"
      }, (0,preact_module.h)("div", {
        className: "pdf-viewer-top-left"
      }, (0,preact_module.h)("div", {
        className: "pdf-viewer-button pdf-viewer-exit",
        onClick: this.onClose
      }, (0,preact_module.h)("i", null)), (0,preact_module.h)("div", {
        className: 'pdf-viewer-button pdf-viewer-sidebar ' + (isSidebarVisible ? 'pdf-viewer-button-pressed' : ''),
        onClick: this.onToggleSidebar
      }, (0,preact_module.h)("i", null))), (0,preact_module.h)(PdfPageNavigation, {
        activePage: activePage,
        pdfDocument: pdfDocument,
        onActivatePage: this.onActivatePage
      }), window.innerWidth > 620 && (0,preact_module.h)(Zoom, {
        onScaleChange: this.onScaleChange,
        scale: this.state.scale
      }), (0,preact_module.h)("div", {
        className: "pdf-viewer-top-right"
      }, (0,preact_module.h)(Search, {
        finder: this.finder,
        pdfDocument: pdfDocument,
        onActivateMatch: this.onActivateSearchMatch,
        onMatches: this.onSearchMatches
      }), printing, downloading)), (0,preact_module.h)("div", {
        className: 'pdf-viewer-body ' + (isSidebarVisible ? 'pdf-viewer-with-sidebar' : null)
      }, (0,preact_module.h)(Sidebar, {
        defaultPageWidth: pageSize.width,
        defaultPageHeight: pageSize.height,
        pdfDocument: pdfDocument,
        pagesOverview: pagesOverview,
        activePage: activePage,
        onActivatePage: this.onActivatePage
      }), (0,preact_module.h)(PDFView, {
        defaultPageWidth: pageSize.width,
        defaultPageHeight: pageSize.height,
        scale: this.state.scale,
        pagesOverview: pagesOverview,
        activePage: activePage,
        pdfDocument: pdfDocument,
        onActivePageChange: this.onActivePageChange,
        activatePage: this.state.activatePage,
        searchMatch: searchMatch,
        searchMatches: searchMatches,
        pdfjsLib: pdfjsLib
      }))));
    }
  }]);
  return PDFFullScreenViewer;
}(preact_module/* Component */.wA);
var PDFFullWrapper = /*#__PURE__*/function (_Component2) {
  fullscreen_inherits(PDFFullWrapper, _Component2);
  var _super2 = fullscreen_createSuper(PDFFullWrapper);
  function PDFFullWrapper() {
    fullscreen_classCallCheck(this, PDFFullWrapper);
    return _super2.apply(this, arguments);
  }
  fullscreen_createClass(PDFFullWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.container = document.createElement('div');
      this.container.classList.add('pdf-viewer-full-screen');
      document.body.appendChild(this.container);
      this.renderFullScreenViewer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderFullScreenViewer();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var Nothing = function Nothing() {
        return null;
      };
      (0,preact_module/* render */.sY)((0,preact_module.h)(Nothing, null), this.container, this.container.firstChild);
      this.container.parentNode.removeChild(this.container);
    }
  }, {
    key: "renderFullScreenViewer",
    value: function renderFullScreenViewer() {
      (0,preact_module/* render */.sY)((0,preact_module.h)(PDFFullScreenViewer, this.props), this.container);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return PDFFullWrapper;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/pdfjsloader.js





function pdfjsloader_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function pdfjsloader_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { pdfjsloader_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { pdfjsloader_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function pdfjsloader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function pdfjsloader_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function pdfjsloader_createClass(Constructor, protoProps, staticProps) { if (protoProps) pdfjsloader_defineProperties(Constructor.prototype, protoProps); if (staticProps) pdfjsloader_defineProperties(Constructor, staticProps); return Constructor; }
var pdfjsDist = null;
var promise = null;
var PDFJSLoader = /*#__PURE__*/function () {
  function PDFJSLoader(workerPath) {
    pdfjsloader_classCallCheck(this, PDFJSLoader);
    this.workerPath = workerPath;
  }
  pdfjsloader_createClass(PDFJSLoader, [{
    key: "load",
    value: function () {
      var _load = pdfjsloader_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!promise) {
                  _context.next = 4;
                  break;
                }
                _context.next = 3;
                return promise;
              case 3:
                return _context.abrupt("return", _context.sent);
              case 4:
                promise = __webpack_require__.e(/* import() | pdfjs-dist.js */ 157).then(__webpack_require__.bind(__webpack_require__, 6637));
                _context.next = 7;
                return promise;
              case 7:
                pdfjsDist = _context.sent;
                if (!pdfjsDist.GlobalWorkerOptions.workerSrc) {
                  pdfjsDist.GlobalWorkerOptions.workerSrc = this.workerPath;
                }
                return _context.abrupt("return", pdfjsDist);
              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "get",
    value: function get() {
      return pdfjsDist;
    }
  }]);
  return PDFJSLoader;
}();

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/print.js
function print_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { print_typeof = function _typeof(obj) { return typeof obj; }; } else { print_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return print_typeof(obj); }










function print_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function print_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { print_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { print_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function print_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function print_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function print_createClass(Constructor, protoProps, staticProps) { if (protoProps) print_defineProperties(Constructor.prototype, protoProps); if (staticProps) print_defineProperties(Constructor, staticProps); return Constructor; }
function print_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) print_setPrototypeOf(subClass, superClass); }
function print_setPrototypeOf(o, p) { print_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return print_setPrototypeOf(o, p); }
function print_createSuper(Derived) { var hasNativeReflectConstruct = print_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = print_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = print_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return print_possibleConstructorReturn(this, result); }; }
function print_possibleConstructorReturn(self, call) { if (call && (print_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return print_assertThisInitialized(self); }
function print_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function print_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function print_getPrototypeOf(o) { print_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return print_getPrototypeOf(o); }




var PrintComponent = /*#__PURE__*/function (_Component) {
  print_inherits(PrintComponent, _Component);
  var _super = print_createSuper(PrintComponent);
  function PrintComponent(props) {
    var _this;
    print_classCallCheck(this, PrintComponent);
    _this = _super.call(this, props);
    _this.pdfJsLoader = new PDFJSLoader(props.options.workerPath);
    _this.state = {
      pdfDocument: null,
      pdfDocumentLoadTask: null,
      documentLoading: true,
      // ставим по умолчанию в true(печать выполняется на стороне приложения), для того чтобы избежать промаргивания окна с
      // прогрессом печати
      printDelegated: true
    };
    return _this;
  }
  print_createClass(PrintComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var onPrint = this.getOnPrintFunction();
      if (onPrint) {
        if (onPrint({
          attachment: this.props.attachment
        }) === true) {
          setTimeout(function () {
            _this2.props.onPrinted();
          }, 0);
          return;
        }
      }
      this.setState(function () {
        return {
          printDelegated: false
        };
      }, function () {
        _this2.loadDocument();
      });
    }
  }, {
    key: "loadDocument",
    value: function () {
      var _loadDocument = print_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var pdfjsLib, pdfDocumentLoadTask, pdfDocument;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.pdfJsLoader.load();
              case 2:
                pdfjsLib = _context.sent;
                pdfDocumentLoadTask = pdfjsLib.getDocument(this.props.attachment.url);
                _context.next = 6;
                return pdfDocumentLoadTask.promise;
              case 6:
                pdfDocument = _context.sent;
                this.setState(function () {
                  return {
                    documentLoading: false,
                    pdfDocument: pdfDocument,
                    pdfDocumentLoadTask: pdfDocumentLoadTask
                  };
                });
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function loadDocument() {
        return _loadDocument.apply(this, arguments);
      }
      return loadDocument;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.documentLoading !== this.state.documentLoading) {
        if (this.props.onSizeUpdate) {
          this.props.onSizeUpdate();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.pdfDocument) {
        this.state.pdfDocumentLoadTask.destroy();
        this.state.pdfDocument.cleanup();
        this.state.pdfDocument.destroy();
      }
    }
  }, {
    key: "getOnPrintFunction",
    value: function getOnPrintFunction() {
      if (this.props.options && this.props.options.onPrint) {
        return this.props.options.onPrint;
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.printDelegated) {
        return null;
      }
      var content;
      if (this.state.documentLoading) {
        content = (0,preact_module.h)("div", null, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "file.pdf_viewer.printing_initialization"
        }));
      } else {
        content = (0,preact_module.h)(PrintingOverlay, {
          onPrinted: this.props.onPrinted,
          onAbort: this.props.onAbort,
          pdfDocument: this.state.pdfDocument
        });
      }
      return (0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, (0,preact_module.h)("div", null, content));
    }
  }]);
  return PrintComponent;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/fullscreenAction.js
function fullscreenAction_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { fullscreenAction_typeof = function _typeof(obj) { return typeof obj; }; } else { fullscreenAction_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return fullscreenAction_typeof(obj); }










function fullscreenAction_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function fullscreenAction_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { fullscreenAction_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { fullscreenAction_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function fullscreenAction_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function fullscreenAction_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function fullscreenAction_createClass(Constructor, protoProps, staticProps) { if (protoProps) fullscreenAction_defineProperties(Constructor.prototype, protoProps); if (staticProps) fullscreenAction_defineProperties(Constructor, staticProps); return Constructor; }
function fullscreenAction_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) fullscreenAction_setPrototypeOf(subClass, superClass); }
function fullscreenAction_setPrototypeOf(o, p) { fullscreenAction_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return fullscreenAction_setPrototypeOf(o, p); }
function fullscreenAction_createSuper(Derived) { var hasNativeReflectConstruct = fullscreenAction_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = fullscreenAction_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = fullscreenAction_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return fullscreenAction_possibleConstructorReturn(this, result); }; }
function fullscreenAction_possibleConstructorReturn(self, call) { if (call && (fullscreenAction_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return fullscreenAction_assertThisInitialized(self); }
function fullscreenAction_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function fullscreenAction_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function fullscreenAction_getPrototypeOf(o) { fullscreenAction_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return fullscreenAction_getPrototypeOf(o); }
function fullscreenAction_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var FullScreenAction = /*#__PURE__*/function (_Component) {
  fullscreenAction_inherits(FullScreenAction, _Component);
  var _super = fullscreenAction_createSuper(FullScreenAction);
  function FullScreenAction(props) {
    var _this;
    fullscreenAction_classCallCheck(this, FullScreenAction);
    _this = _super.call(this, props);
    fullscreenAction_defineProperty(fullscreenAction_assertThisInitialized(_this), "pdfJsLoader", null);
    _this.state = {
      pdfDocument: null,
      pdfPage: null
    };
    _this.pdfJsLoader = new PDFJSLoader(props.options.workerPath);
    return _this;
  }
  fullscreenAction_createClass(FullScreenAction, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadDocument();
    }
  }, {
    key: "loadDocument",
    value: function () {
      var _loadDocument = fullscreenAction_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var pdfjsLib, pdfDocument, pdfPage, pdfPageViewport;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.pdfJsLoader.load();
              case 2:
                pdfjsLib = _context.sent;
                _context.next = 5;
                return pdfjsLib.getDocument(this.props.attachment.url).promise;
              case 5:
                pdfDocument = _context.sent;
                _context.next = 8;
                return pdfDocument.getPage(1);
              case 8:
                pdfPage = _context.sent;
                pdfPageViewport = pdfPage.getViewport({
                  scale: 1
                });
                this.setState(function () {
                  return {
                    pdfDocument: pdfDocument,
                    pdfPage: pdfPage,
                    pageWidth: pdfPageViewport.width,
                    pageHeight: pdfPageViewport.height
                  };
                });
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function loadDocument() {
        return _loadDocument.apply(this, arguments);
      }
      return loadDocument;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        pdfDocument = _this$state.pdfDocument,
        pdfPage = _this$state.pdfPage,
        pageWidth = _this$state.pageWidth,
        pageHeight = _this$state.pageHeight;
      if (!pdfDocument || !pdfPage) {
        return (0,preact_module.h)("div", null, (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "file.pdf_viewer.initializing_full_window_view"
        }));
      }
      return (0,preact_module.h)(PDFFullWrapper, {
        pdfDocument: pdfDocument,
        pageSize: {
          width: pageWidth,
          height: pageHeight
        },
        onClose: this.props.onClose,
        attachment: this.props.attachment,
        editor: this.props.editor,
        options: this.props.options,
        pdfjsLib: this.pdfJsLoader.get()
      });
    }
  }]);
  return FullScreenAction;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/scss/file-vars.scss
var file_vars = __webpack_require__(26158);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/pdfSinglePage.js
function pdfSinglePage_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { pdfSinglePage_typeof = function _typeof(obj) { return typeof obj; }; } else { pdfSinglePage_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return pdfSinglePage_typeof(obj); }













function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || pdfSinglePage_unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function pdfSinglePage_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return pdfSinglePage_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return pdfSinglePage_arrayLikeToArray(o, minLen); }
function pdfSinglePage_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function pdfSinglePage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function pdfSinglePage_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { pdfSinglePage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { pdfSinglePage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function pdfSinglePage_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function pdfSinglePage_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function pdfSinglePage_createClass(Constructor, protoProps, staticProps) { if (protoProps) pdfSinglePage_defineProperties(Constructor.prototype, protoProps); if (staticProps) pdfSinglePage_defineProperties(Constructor, staticProps); return Constructor; }
function pdfSinglePage_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) pdfSinglePage_setPrototypeOf(subClass, superClass); }
function pdfSinglePage_setPrototypeOf(o, p) { pdfSinglePage_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return pdfSinglePage_setPrototypeOf(o, p); }
function pdfSinglePage_createSuper(Derived) { var hasNativeReflectConstruct = pdfSinglePage_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = pdfSinglePage_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = pdfSinglePage_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return pdfSinglePage_possibleConstructorReturn(this, result); }; }
function pdfSinglePage_possibleConstructorReturn(self, call) { if (call && (pdfSinglePage_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return pdfSinglePage_assertThisInitialized(self); }
function pdfSinglePage_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function pdfSinglePage_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function pdfSinglePage_getPrototypeOf(o) { pdfSinglePage_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return pdfSinglePage_getPrototypeOf(o); }
function pdfSinglePage_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var PdfSinglePage = /*#__PURE__*/function (_Component) {
  pdfSinglePage_inherits(PdfSinglePage, _Component);
  var _super = pdfSinglePage_createSuper(PdfSinglePage);
  function PdfSinglePage(props) {
    var _this;
    pdfSinglePage_classCallCheck(this, PdfSinglePage);
    _this = _super.call(this, props);
    pdfSinglePage_defineProperty(pdfSinglePage_assertThisInitialized(_this), "onIntersectionObserver", function (entries) {
      // страница не в зоне видимости
      if (entries[0].intersectionRatio <= 0) {
        _this.setState(function () {
          return {
            visible: false
          };
        });
        return false;
      }

      // страница в зоне видимости
      var renderPdf = false;
      _this.setState(function (prevState) {
        if (!prevState.visible) {
          renderPdf = true;
          return {
            visible: true
          };
        }
        return null;
      }, function () {
        if (renderPdf) {
          _this.renderPdfPage();
        }
      });
    });
    pdfSinglePage_defineProperty(pdfSinglePage_assertThisInitialized(_this), "onPageMouseDown", function () {
      _this.props.onPageMouseDown();
    });
    pdfSinglePage_defineProperty(pdfSinglePage_assertThisInitialized(_this), "onMouseOver", function () {
      _this.props.onPageMouseOver();
    });
    pdfSinglePage_defineProperty(pdfSinglePage_assertThisInitialized(_this), "onMouseOut", function () {
      _this.props.onPageMouseOut();
    });
    pdfSinglePage_defineProperty(pdfSinglePage_assertThisInitialized(_this), "onPageClick", function () {
      _this.props.setPage(_this.props.num);
      _this.props.onPageClick();
    });
    pdfSinglePage_defineProperty(pdfSinglePage_assertThisInitialized(_this), "onCanvasRef", /*#__PURE__*/function () {
      var _ref = pdfSinglePage_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ref) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.canvas = ref;
                _context.next = 3;
                return _this.renderPdfPage();
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    pdfSinglePage_defineProperty(pdfSinglePage_assertThisInitialized(_this), "onPageRef", function (ref) {
      if (ref) {
        // начать наблюдение
        _this.intersectionObserver.observe(ref);
      }
    });
    pdfSinglePage_defineProperty(pdfSinglePage_assertThisInitialized(_this), "renderPdfPage", /*#__PURE__*/pdfSinglePage_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var rendered, pageOverview, canvas, _pageOverview$page$vi, origWidth, origHeight, renderRatio, viewport, bufferCanvas, ctx, renderTask;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              rendered = false;
              pageOverview = _this.state.pageOverview;
              canvas = _this.canvas;
              if (!(!canvas || !pageOverview)) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              // рендер через двойной буфер
              _pageOverview$page$vi = _slicedToArray(pageOverview.page.view, 4), origWidth = _pageOverview$page$vi[2], origHeight = _pageOverview$page$vi[3];
              renderRatio = _this.getPageRenderRatio(origWidth, origHeight);
              viewport = pageOverview.page.getViewport({
                scale: window.devicePixelRatio * renderRatio
              });
              if (!_this.state.visible) {
                _context2.next = 21;
                break;
              }
              bufferCanvas = document.createElement('canvas');
              bufferCanvas.width = viewport.width;
              bufferCanvas.height = viewport.height;
              ctx = bufferCanvas.getContext('2d');
              renderTask = pageOverview.page.render({
                canvasContext: ctx,
                viewport: viewport
              });
              _context2.next = 16;
              return renderTask.promise;
            case 16:
              canvas.width = viewport.width;
              canvas.height = viewport.height;
              canvas.getContext('2d').drawImage(bufferCanvas, 0, 0);
              _this.props.setViewport(viewport);
              rendered = true;
            case 21:
              _this.setState(function () {
                return {
                  viewport: viewport,
                  rendered: rendered
                };
              });
            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    pdfSinglePage_defineProperty(pdfSinglePage_assertThisInitialized(_this), "getPageSize", function () {
      var viewport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _viewport$width = viewport.width,
        width = _viewport$width === void 0 ? 800 : _viewport$width,
        _viewport$height = viewport.height,
        height = _viewport$height === void 0 ? 600 : _viewport$height;
      width /= window.devicePixelRatio;
      height /= window.devicePixelRatio;
      return {
        width: width,
        height: height
      };
    });
    var _pageOverview = props.pageOverview;
    _this.state = {
      pageOverview: _pageOverview,
      maxWidth: props.maxWidth,
      viewport: _pageOverview && _pageOverview.viewport,
      visible: _this.props.visible,
      rendered: false
    };
    _this.TID = 0;
    _this.pageBottomMargin = parseInt((style_default()).fullScreenViewerPagesMargin);
    _this.fileHorizontalPadding = parseInt(file_vars.fileHorizontalPadding);

    // Используем IntersectionObserver для определения видимости страниц
    // для оптимизации рендеренга, если страница в зоне видимости то мы её отрисовываем
    // если нет то ничего не делаем
    _this.intersectionObserver = new IntersectionObserver(_this.onIntersectionObserver);
    return _this;
  }
  pdfSinglePage_createClass(PdfSinglePage, [{
    key: "getPageRenderRatio",
    value: function getPageRenderRatio(width) {
      // пдф должен быть растянут на всю ширину элемента, высота автоматическая
      var maxWidth = this.props.maxWidth - this.fileHorizontalPadding * 2;
      var ratio = maxWidth / width;
      return ratio;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps, previousState, previousContext) {
      var _this2 = this;
      // после изменения размера окна браузера, перерисовывать страницы
      if (previousProps.maxWidth !== this.props.maxWidth) {
        clearTimeout(this.TID);
        this.TID = setTimeout(this.renderPdfPage, 100);
      }
      if (previousProps.pageOverview !== this.state.pageOverview && this.props.pageOverview) {
        this.setState(function () {
          return {
            pageOverview: _this2.props.pageOverview,
            viewport: _this2.props.pageOverview.viewport
          };
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.TID);
      this.intersectionObserver.disconnect();
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.pageOverview) {
        var _this$getPageSize = this.getPageSize(this.props.viewport),
          _width = _this$getPageSize.width,
          _height = _this$getPageSize.height;
        return (0,preact_module.h)("div", {
          className: "pdf-page editor-loader2-grey editor-loader-cc",
          style: {
            width: _width + 'px',
            height: _height + 'px',
            marginBottom: this.props.isLastPage ? 0 : this.pageBottomMargin + 'px'
          }
        });
      }
      var _this$getPageSize2 = this.getPageSize(this.state.viewport),
        width = _this$getPageSize2.width,
        height = _this$getPageSize2.height;
      var style = {
        width: width + 'px',
        height: height + 'px',
        marginBottom: this.props.isLastPage ? 0 : this.pageBottomMargin + 'px'
      };
      var rendered = this.state.rendered;
      var className = ['pdf-page'];
      if (!this.props.options.openFullScreenByTwoClicks || this.props.options.allowOpenOnMouseOver) {
        className.push('open-on-mouse-over');
      }
      if (!rendered) {
        className.push('editor-loader2-grey editor-loader-cc');
      }
      return (0,preact_module.h)("div", {
        ref: this.onPageRef,
        onMouseDown: this.onPageMouseDown,
        onMouseOver: this.onMouseOver,
        onMouseOut: this.onMouseOut,
        onClick: this.onPageClick,
        className: className.join(' '),
        style: style
      }, (0,preact_module.h)("canvas", {
        ref: this.onCanvasRef
      }), (0,preact_module.h)("div", {
        className: "pdf-page-number"
      }, this.props.num));
    }
  }]);
  return PdfSinglePage;
}(preact_module/* Component */.wA);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/pdfViewAsAllPages.js
function pdfViewAsAllPages_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { pdfViewAsAllPages_typeof = function _typeof(obj) { return typeof obj; }; } else { pdfViewAsAllPages_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return pdfViewAsAllPages_typeof(obj); }
function pdfViewAsAllPages_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = pdfViewAsAllPages_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }


















function pdfViewAsAllPages_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function pdfViewAsAllPages_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { pdfViewAsAllPages_ownKeys(Object(source), true).forEach(function (key) { pdfViewAsAllPages_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { pdfViewAsAllPages_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function pdfViewAsAllPages_slicedToArray(arr, i) { return pdfViewAsAllPages_arrayWithHoles(arr) || pdfViewAsAllPages_iterableToArrayLimit(arr, i) || pdfViewAsAllPages_unsupportedIterableToArray(arr, i) || pdfViewAsAllPages_nonIterableRest(); }
function pdfViewAsAllPages_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function pdfViewAsAllPages_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return pdfViewAsAllPages_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return pdfViewAsAllPages_arrayLikeToArray(o, minLen); }
function pdfViewAsAllPages_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function pdfViewAsAllPages_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function pdfViewAsAllPages_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function pdfViewAsAllPages_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function pdfViewAsAllPages_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { pdfViewAsAllPages_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { pdfViewAsAllPages_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function pdfViewAsAllPages_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function pdfViewAsAllPages_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function pdfViewAsAllPages_createClass(Constructor, protoProps, staticProps) { if (protoProps) pdfViewAsAllPages_defineProperties(Constructor.prototype, protoProps); if (staticProps) pdfViewAsAllPages_defineProperties(Constructor, staticProps); return Constructor; }
function pdfViewAsAllPages_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) pdfViewAsAllPages_setPrototypeOf(subClass, superClass); }
function pdfViewAsAllPages_setPrototypeOf(o, p) { pdfViewAsAllPages_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return pdfViewAsAllPages_setPrototypeOf(o, p); }
function pdfViewAsAllPages_createSuper(Derived) { var hasNativeReflectConstruct = pdfViewAsAllPages_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = pdfViewAsAllPages_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = pdfViewAsAllPages_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return pdfViewAsAllPages_possibleConstructorReturn(this, result); }; }
function pdfViewAsAllPages_possibleConstructorReturn(self, call) { if (call && (pdfViewAsAllPages_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return pdfViewAsAllPages_assertThisInitialized(self); }
function pdfViewAsAllPages_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function pdfViewAsAllPages_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function pdfViewAsAllPages_getPrototypeOf(o) { pdfViewAsAllPages_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return pdfViewAsAllPages_getPrototypeOf(o); }
function pdfViewAsAllPages_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var PdfViewAsAllPages = /*#__PURE__*/function (_Component) {
  pdfViewAsAllPages_inherits(PdfViewAsAllPages, _Component);
  var _super = pdfViewAsAllPages_createSuper(PdfViewAsAllPages);
  function PdfViewAsAllPages(props) {
    var _this;
    pdfViewAsAllPages_classCallCheck(this, PdfViewAsAllPages);
    _this = _super.call(this, props);
    pdfViewAsAllPages_defineProperty(pdfViewAsAllPages_assertThisInitialized(_this), "onPageLoaded", /*#__PURE__*/function () {
      var _ref = pdfViewAsAllPages_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(num, pagePromise) {
        var page, countLoadedPages, _page$view, origWidth, origHeight, renderRatio, vpScale, viewport, _page$getViewport, width, height;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return pagePromise;
              case 2:
                page = _context.sent;
                countLoadedPages = _this.state.countLoadedPages + 1; // инциализация viewport для первоначальной отрисовки страниц
                _page$view = pdfViewAsAllPages_slicedToArray(page.view, 4), origWidth = _page$view[2], origHeight = _page$view[3];
                renderRatio = _this.getPageRenderRatio(origWidth, origHeight);
                vpScale = window.devicePixelRatio * renderRatio;
                viewport = page.getViewport({
                  scale: vpScale
                }); // Для передачи страниц в полноэкранный режим
                _page$getViewport = page.getViewport({
                  scale: 1
                }), width = _page$getViewport.width, height = _page$getViewport.height;
                _this.props.updatePagesOverview(pdfViewAsAllPages_defineProperty({}, num, {
                  width: width,
                  height: height,
                  page: page,
                  viewport: viewport
                }));
                _this.setState(function (prev) {
                  return {
                    countLoadedPages: countLoadedPages,
                    isLoadingPages: countLoadedPages <= 1,
                    // после загрузки сразу 1-ю страницу
                    pagesOverview: pdfViewAsAllPages_objectSpread(pdfViewAsAllPages_objectSpread({}, prev.pagesOverview), {}, pdfViewAsAllPages_defineProperty({}, num, {
                      page: page,
                      viewport: viewport
                    }))
                  };
                });
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    pdfViewAsAllPages_defineProperty(pdfViewAsAllPages_assertThisInitialized(_this), "setViewport", function (viewport) {
      _this.setState(function () {
        return {
          viewport: viewport
        };
      });
    });
    _this.state = {
      isLoadingPages: true,
      pagesOverview: props.pagesOverview,
      countLoadedPages: _this.getPagesOverviewLength(props.pagesOverview)
    };
    _this.fileHorizontalPadding = parseInt(file_vars.fileHorizontalPadding);
    return _this;
  }
  pdfViewAsAllPages_createClass(PdfViewAsAllPages, [{
    key: "getPagesOverviewLength",
    value: function getPagesOverviewLength(obj) {
      var len = 0;
      for (var key in obj) {
        len++;
      }
      return len;
    }
  }, {
    key: "getPageRenderRatio",
    value: function getPageRenderRatio(width) {
      // пдф должен быть растянут на всю ширину элемента, высота автоматическая
      var maxWidth = this.props.maxWidth - this.fileHorizontalPadding * 2;
      var ratio = maxWidth / width;
      return ratio;
    }

    /**
     * Событие при загрузке страницы
     * @param {Number} num
     * @param {Promise<>} pagePromise
     * @returns {Promise<void>}
     */
  }, {
    key: "loadPages",
    value: function () {
      var _loadPages = pdfViewAsAllPages_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(numbers) {
        var _this2 = this;
        var pdfDocument, chunks, loadChunk, _iterator, _step, chunk;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // грузим страницы постепенно, используются цифры количество загружаемых страниц и таймаута,
                // которые позволяют не грузить сильно браузер
                pdfDocument = this.props.pdfDocument;
                chunks = lodash_chunk_default()(numbers, 20);
                loadChunk = function loadChunk(chunk) {
                  chunk.forEach(function (num) {
                    _this2.onPageLoaded(num, pdfDocument.getPage(num));
                  });
                };
                _iterator = pdfViewAsAllPages_createForOfIteratorHelper(chunks);
                _context2.prev = 4;
                _iterator.s();
              case 6:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 13;
                  break;
                }
                chunk = _step.value;
                loadChunk(chunk);
                _context2.next = 11;
                return (0,util/* wait */.Dc)(500);
              case 11:
                _context2.next = 6;
                break;
              case 13:
                _context2.next = 18;
                break;
              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](4);
                _iterator.e(_context2.t0);
              case 18:
                _context2.prev = 18;
                _iterator.f();
                return _context2.finish(18);
              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 15, 18, 21]]);
      }));
      function loadPages(_x3) {
        return _loadPages.apply(this, arguments);
      }
      return loadPages;
    }() // Для того чтобы передать размеры для неподгруженных страниц
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var pagesOverview = this.state.pagesOverview;
      var pdfDocument = this.props.pdfDocument;
      // подгружаем информацию об остальных страницах
      var toLoad = [];
      for (var num = 1; num <= pdfDocument.numPages; num++) {
        if (!pagesOverview[num]) {
          toLoad.push(num);
        }
      }
      if (toLoad.length) {
        // если есть страницы для загрузки то загружаем
        this.loadPages(toLoad);
      } else {
        // иначе сразу показываем страницы
        this.setState(function () {
          return {
            isLoadingPages: false
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        pdfDocument = _this$props.pdfDocument,
        _onPageClick = _this$props.onPageClick,
        onPageMouseDown = _this$props.onPageMouseDown,
        onPageMouseOver = _this$props.onPageMouseOver,
        onPageMouseOut = _this$props.onPageMouseOut,
        setPage = _this$props.setPage,
        maxWidth = _this$props.maxWidth;
      var _this$state = this.state,
        pagesOverview = _this$state.pagesOverview,
        isLoadingPages = _this$state.isLoadingPages;
      if (isLoadingPages) return (0,preact_module.h)("div", {
        className: "pdf-loading-document"
      }, (0,preact_module.h)("div", {
        className: "editor-loader2-grey editor-loader-cc"
      }), (0,preact_module.h)("div", {
        className: "pdf-loading-message"
      }, "Loading pages ...please wait..."));
      var pdfPages = [];
      var _loop = function _loop(i) {
        pdfPages.push((0,preact_module.h)(PdfSinglePage, {
          num: i,
          viewport: _this3.state.viewport,
          pageOverview: pagesOverview[i],
          isLastPage: i === pdfDocument.numPages,
          onPageClick: function onPageClick() {
            _onPageClick(i);
          },
          onPageMouseDown: onPageMouseDown,
          onPageMouseOver: onPageMouseOver,
          onPageMouseOut: onPageMouseOut,
          setPage: setPage,
          setViewport: _this3.setViewport,
          maxWidth: maxWidth,
          visible: i === 1 // первая страница всегда видимая
          ,
          options: _this3.props.options
        }));
      };
      for (var i = 1; i <= pdfDocument.numPages; i++) {
        _loop(i);
      }
      return (0,preact_module.h)("div", {
        className: "pdf-all-pages"
      }, pdfPages);
    }
  }]);
  return PdfViewAsAllPages;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/components/popupMenu.js
var popupMenu = __webpack_require__(10856);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/components/popupMenuItem.js
var popupMenuItem = __webpack_require__(28411);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/plugins/tooltipManager/index.js
var tooltipManager = __webpack_require__(95174);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/pdf/index.js
function pdf_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { pdf_typeof = function _typeof(obj) { return typeof obj; }; } else { pdf_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return pdf_typeof(obj); }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function pdf_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function pdf_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { pdf_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { pdf_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function pdf_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function pdf_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { pdf_ownKeys(Object(source), true).forEach(function (key) { pdf_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { pdf_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















function pdf_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function pdf_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function pdf_createClass(Constructor, protoProps, staticProps) { if (protoProps) pdf_defineProperties(Constructor.prototype, protoProps); if (staticProps) pdf_defineProperties(Constructor, staticProps); return Constructor; }
function pdf_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) pdf_setPrototypeOf(subClass, superClass); }
function pdf_setPrototypeOf(o, p) { pdf_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return pdf_setPrototypeOf(o, p); }
function pdf_createSuper(Derived) { var hasNativeReflectConstruct = pdf_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = pdf_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = pdf_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return pdf_possibleConstructorReturn(this, result); }; }
function pdf_possibleConstructorReturn(self, call) { if (call && (pdf_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return pdf_assertThisInitialized(self); }
function pdf_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function pdf_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function pdf_getPrototypeOf(o) { pdf_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return pdf_getPrototypeOf(o); }
function pdf_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var fileHorizontalPadding = parseInt(file_vars.fileHorizontalPadding);
var PDFViewerComponent = /*#__PURE__*/function (_Component) {
  pdf_inherits(PDFViewerComponent, _Component);
  var _super = pdf_createSuper(PDFViewerComponent);
  function PDFViewerComponent(props) {
    var _this;
    pdf_classCallCheck(this, PDFViewerComponent);
    _this = _super.call(this, props);
    pdf_defineProperty(pdf_assertThisInitialized(_this), "pdfJsLoader", null);
    pdf_defineProperty(pdf_assertThisInitialized(_this), "onCanvasRef", function (canvas) {
      _this.canvas = canvas;
      _this.renderPdfPage();
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "incPage", function () {
      var page = Math.min(_this.getCurrentPageNumber() + 1, _this.state.pdfDocument.numPages);
      _this.props.setSyncedState({
        page: page
      });
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "decPage", function () {
      var page = Math.max(_this.getCurrentPageNumber() - 1, 1);
      _this.props.setSyncedState({
        page: page
      });
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "setPage", function (page) {
      _this.props.setSyncedState({
        page: page
      });
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "pinPage", function () {
      var page = _this.getCurrentPageNumber();
      _this.props.setSyncedState({
        pinned: page
      });
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "unpinPage", function () {
      _this.props.setSyncedState({
        pinned: false
      });
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "onPageClick", function () {
      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var allow = _this.pageMouseDownOnFocused;
      if (_this.props.options && _this.props.options.allowOpenOnMouseOver && _this.state.isMouseOver) {
        allow = true;
      }
      if (allow) {
        if (_this.props.options && _this.props.options.onClick) {
          _this.props.options.onClick({
            attachment: _this.props.attachment,
            params: {
              disallowDownloading: _this.props.blot && _this.props.blot.disallowDownloading
            }
          });
        } else {
          var newState = {
            fullscreen: true
          };
          if (pageNumber && Number.isInteger(parseInt(pageNumber))) {
            newState.page = parseInt(pageNumber);
          } else {
            newState.page = _this.getCurrentPageNumber();
          }
          _this.setState(function () {
            return newState;
          });
        }
      }
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "onPageMouseDown", function () {
      // если в настройках разрешено отркывать по двум кликикам то проверяем фокус
      _this.pageMouseDownOnFocused = _this.props.options.openFullScreenByTwoClicks ? _this.props.focused : true;
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "onPageChange", function (page) {
      _this.props.setSyncedState({
        page: page
      });
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "onMouseOver", function () {
      setTimeout(function () {
        _this.setState(function () {
          return {
            isMouseOver: true
          };
        });
      }, 0);
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "onMouseOut", function () {
      _this.setState(function () {
        return {
          isMouseOver: false
        };
      });
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "onFullScreenClose", function () {
      _this.setState(function () {
        return {
          fullscreen: false
        };
      });
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "onScaleChange", function (scale) {
      _this.setState(function () {
        return {
          scale: scale
        };
      });
    });
    pdf_defineProperty(pdf_assertThisInitialized(_this), "updatePagesOverview", function (pagesOverview) {
      _this.setState(function (prev) {
        return {
          pagesOverview: pdf_objectSpread(pdf_objectSpread({}, prev.pagesOverview), pagesOverview)
        };
      });
    });
    _this.pdfJsLoader = new PDFJSLoader(props.options.workerPath);
    _this.state = {
      pdfDocument: null,
      pdfPage: null,
      pdfPageViewport: null,
      documentLoading: false,
      pageLoading: false,
      pageRendering: false,
      page: _this.getCurrentPageNumber(),
      renderRatio: null,
      fullscreen: false,
      isMouseOver: false,
      pdfJsLoaded: Boolean(_this.pdfJsLoader.get()),
      pagesOverview: {},
      scale: null,
      viewAs: props.blot.getViewAs(),
      init: true
    };

    // для того, чтобы сразу по клику открывать фулскрин
    _this.pageMouseDownOnFocused = true;
    return _this;
  }
  pdf_createClass(PDFViewerComponent, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.pdfDocument) {
        this.state.pdfDocument.destroy();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (!this.pdfJsLoader.get()) {
        this.pdfJsLoader.load().then(function () {
          _this2.setState(function () {
            return {
              pdfJsLoaded: true
            };
          });
        });
      }
    }
  }, {
    key: "loadPdfDocument",
    value: function () {
      var _loadPdfDocument = pdf_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState(function () {
                  return {
                    documentLoading: true
                  };
                }, /*#__PURE__*/pdf_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var pdfjsLib, options, pdfDocument;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _this3.pdfJsLoader.load();
                        case 2:
                          pdfjsLib = _context.sent;
                          options = {
                            url: _this3.props.attachment.url,
                            cMapUrl: _this3.props.options.cMapUrl,
                            cMapPacked: true
                          };
                          _context.next = 6;
                          return pdfjsLib.getDocument(options).promise;
                        case 6:
                          pdfDocument = _context.sent;
                          _this3.setState(function () {
                            return {
                              documentLoading: false,
                              pdfDocument: pdfDocument
                            };
                          });
                        case 8:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })));
              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function loadPdfDocument() {
        return _loadPdfDocument.apply(this, arguments);
      }
      return loadPdfDocument;
    }()
  }, {
    key: "getPageRenderRatio",
    value: function getPageRenderRatio(width, height, pdfPage) {
      // rotate -90/90 указывает на то, что пдф развернута,
      // по этому при расчете скейла решение брать ширину будет не верным и пдф не влезет в границы вьюпорта
      var useHeight = (pdfPage === null || pdfPage === void 0 ? void 0 : pdfPage.rotate) === 90 || (pdfPage === null || pdfPage === void 0 ? void 0 : pdfPage.rotate) === -90;
      // пдф должен быть растянут на всю ширину элемента, высота автоматическая
      var maxWidth = this.props.maxWidth - fileHorizontalPadding * 2;
      var ratio = useHeight ? maxWidth / height : maxWidth / width;
      return ratio;
    }
  }, {
    key: "loadPdfPage",
    value: function () {
      var _loadPdfPage = pdf_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this4 = this;
        var init, page;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.setState(function (prevState) {
                  page = _this4.getCurrentPageNumber();
                  init = false;
                  if (prevState.init) {
                    if (_this4.props.syncedState.pinned) {
                      page = _this4.props.syncedState.pinned;
                      init = true;
                    }
                  }
                  return {
                    pageLoading: true,
                    init: false,
                    page: page
                  };
                }, /*#__PURE__*/pdf_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                  var pdfPage, origWidth, origHeight, renderRatio, scale, pdfPageViewport, isCanvasAvailable;
                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return _this4.state.pdfDocument.getPage(page);
                        case 2:
                          pdfPage = _context3.sent;
                          origWidth = pdfPage.view[2];
                          origHeight = pdfPage.view[3];
                          renderRatio = _this4.getPageRenderRatio(origWidth, origHeight, pdfPage);
                          scale = window.devicePixelRatio * renderRatio;
                          pdfPageViewport = pdfPage.getViewport({
                            scale: scale
                          });
                          if (!(!init && page !== _this4.getCurrentPageNumber())) {
                            _context3.next = 10;
                            break;
                          }
                          return _context3.abrupt("return");
                        case 10:
                          isCanvasAvailable = Boolean(_this4.canvas);
                          _this4.setState(function (prev) {
                            var _pdfPage$getViewport = pdfPage.getViewport({
                                scale: 1
                              }),
                              width = _pdfPage$getViewport.width,
                              height = _pdfPage$getViewport.height;
                            return {
                              pageLoading: false,
                              pdfPage: pdfPage,
                              pdfPageViewport: pdfPageViewport,
                              renderRatio: renderRatio,
                              pagesOverview: pdf_objectSpread(pdf_objectSpread({}, prev.pagesOverview), {}, pdf_defineProperty({}, page, {
                                width: width,
                                height: height,
                                page: pdfPage,
                                viewport: pdfPageViewport
                              }))
                            };
                          }, function () {
                            var opts = {
                              pageWidth: pdfPage.view[2],
                              pageHeight: pdfPage.view[3]
                            };
                            if (init) {
                              opts.page = page;
                            }
                            _this4.props.setSyncedState(opts);
                            if (isCanvasAvailable) {
                              _this4.renderPdfPage();
                            }
                          });
                        case 12:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })));
              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function loadPdfPage() {
        return _loadPdfPage.apply(this, arguments);
      }
      return loadPdfPage;
    }()
  }, {
    key: "getCurrentPageSize",
    value: function getCurrentPageSize() {
      if (!this.state.pdfPage) {
        return null;
      }
      var pdfPage = this.state.pdfPage;
      var width = pdfPage.view[2];
      var height = pdfPage.view[3];
      return {
        width: width,
        height: height
      };
    }
  }, {
    key: "renderPdfPage",
    value: function () {
      var _renderPdfPage = pdf_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var canvas, viewport, bufferCanvas, ctx, renderTask;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                canvas = this.canvas;
                if (canvas) {
                  _context5.next = 3;
                  break;
                }
                return _context5.abrupt("return");
              case 3:
                // рендер через двойной буфер
                viewport = this.state.pdfPageViewport;
                bufferCanvas = document.createElement('canvas');
                bufferCanvas.width = viewport.width;
                bufferCanvas.height = viewport.height;
                ctx = bufferCanvas.getContext('2d');
                renderTask = this.state.pdfPage.render({
                  canvasContext: ctx,
                  viewport: viewport
                });
                _context5.next = 11;
                return renderTask.promise;
              case 11:
                canvas.width = viewport.width;
                canvas.height = viewport.height;
                canvas.getContext('2d').drawImage(bufferCanvas, 0, 0);
              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
      function renderPdfPage() {
        return _renderPdfPage.apply(this, arguments);
      }
      return renderPdfPage;
    }()
  }, {
    key: "getCurrentViewAs",
    value: function getCurrentViewAs() {
      return this.props.blot.getViewAs();
    }
  }, {
    key: "getCurrentPageNumber",
    value: function getCurrentPageNumber() {
      return this.props.syncedState.page || 1;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this5 = this;
      // Устанавливаем режим просмотра Одна страница / Все страницы
      this.setState(function (prev) {
        if (_this5.getCurrentViewAs() !== prev.viewAs) {
          return {
            viewAs: _this5.getCurrentViewAs()
          };
        }
        return null;
      });
      if (prevProps.fullscreen !== this.props.fullscreen && this.props.fullscreen && this.props.fullscreen.enable) {
        this.setState(function () {
          return {
            fullscreen: true
          };
        });
      }
      if (prevState.fullscreen !== this.state.fullscreen && !this.state.fullscreen) {
        // фуллскрин закрывается, сообщаем об этом выше
        this.props.onFullScreenClose && this.props.onFullScreenClose();
      }
      if (prevState.fullscreen !== this.state.fullscreen && this.state.fullscreen) {
        // фуллскрин закрывается, сообщаем об этом выше
        this.props.onViewerGoFullScreen && this.props.onViewerGoFullScreen();
      }
      if (prevState.pdfDocument !== this.state.pdfDocument) {
        // установить количество pdf страниц у блота
        // влияет на отображение пункта меню "Отображать как"
        this.props.blot.setPdfNumPages(this.state.pdfDocument.numPages);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.pdfDocument) {
        if (!this.state.documentLoading) {
          this.loadPdfDocument();
        }
      } else if (!this.state.pdfPage) {
        if (!this.state.pageLoading) {
          this.loadPdfPage();
        }
      }
      if (this.state.page !== this.getCurrentPageNumber()) {
        this.loadPdfPage();
      }
      if (this.state.pdfPage && !this.state.pageLoading) {
        var _this$getCurrentPageS = this.getCurrentPageSize(),
          width = _this$getCurrentPageS.width,
          height = _this$getCurrentPageS.height;
        var neededRatio = this.getPageRenderRatio(width, height, this.state.pdfPage);
        if (!isNaN(neededRatio) && neededRatio !== this.state.renderRatio) {
          this.loadPdfPage();
        }
      }
      var pdfPageNode;
      var pdfControlsNode;
      var _this$props = this.props,
        editor = _this$props.editor,
        blot = _this$props.blot;
      if (!this.state.pdfPageViewport) {
        var _this$props$syncedSta = this.props.syncedState,
          pageWidth = _this$props$syncedSta.pageWidth,
          pageHeight = _this$props$syncedSta.pageHeight;
        if (pageWidth && pageHeight) {
          var ratio = this.getPageRenderRatio(pageWidth, pageHeight, this.state.pdfPage);
          var _width = pageWidth * ratio;
          var _height = pageHeight * ratio;
          pdfPageNode = (0,preact_module.h)("div", {
            className: "pdf-page",
            style: {
              width: _width + 'px',
              height: _height + 'px'
            }
          }, (0,preact_module.h)("div", {
            className: "pdf-page-loading editor-loader2-grey editor-loader-cc"
          }));
        } else {
          pdfPageNode = (0,preact_module.h)("div", {
            className: "pdf-loading-document"
          }, (0,preact_module.h)("div", {
            className: "editor-loader2-grey editor-loader-cc"
          }), (0,preact_module.h)("div", {
            className: "pdf-loading-message"
          }, "Loading PDF file...please wait..."));
        }
      } else {
        var _this$state$pdfPageVi = this.state.pdfPageViewport,
          _width2 = _this$state$pdfPageVi.width,
          _height2 = _this$state$pdfPageVi.height;
        _width2 /= window.devicePixelRatio;
        _height2 /= window.devicePixelRatio;
        var currentPage = this.getCurrentPageNumber();
        var numPages = this.state.pdfDocument.numPages;
        var className = ['pdf-page'];
        if (!this.props.options.openFullScreenByTwoClicks || this.props.options.allowOpenOnMouseOver) {
          className.push('open-on-mouse-over');
        }
        if (this.state.viewAs === 'single') {
          pdfPageNode = (0,preact_module.h)("div", {
            onMouseDown: this.onPageMouseDown,
            onMouseOver: this.onMouseOver,
            onMouseOut: this.onMouseOut,
            onClick: this.onPageClick,
            className: className.join(' '),
            style: {
              width: _width2 + 'px',
              height: _height2 + 'px'
            }
          }, (0,preact_module.h)("canvas", {
            ref: this.onCanvasRef
          }));
          var pinContainer = null;
          if (editor.mode === editor.constructor.MODE_EDIT && !blot.isBlotLocked) {
            var _ref3;
            var i18n = editor.plugins.i18n;
            var pinText = i18n.get('file.pdf_viewer.set_page_as_default');
            var iconPin = (0,preact_module.h)("div", _extends({
              className: "pin-button",
              onClick: this.pinPage
            }, (_ref3 = {}, pdf_defineProperty(_ref3, tooltipManager/* TOOLTIP_ATTR */.qZ, pinText), pdf_defineProperty(_ref3, tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD, JSON.stringify({
              positionFixed: true
            })), _ref3)), (0,preact_module.h)(icons/* IconPin */.DgX, null));
            var pinned = this.props.syncedState.pinned;
            if (pinned && pinned === currentPage) {
              var _ref4;
              pinText = i18n.get('file.pdf_viewer.unset_page_as_default');
              iconPin = (0,preact_module.h)("div", _extends({
                className: "pin-button",
                onClick: this.unpinPage
              }, (_ref4 = {}, pdf_defineProperty(_ref4, tooltipManager/* TOOLTIP_ATTR */.qZ, pinText), pdf_defineProperty(_ref4, tooltipManager/* TOOLTIP_ADD_OPTIONS */.cD, JSON.stringify({
                positionFixed: true
              })), _ref4)), (0,preact_module.h)(icons/* IconUnpin */.uII, null));
            }
            pinContainer = (0,preact_module.h)("div", {
              className: "pdf-controls pin-buttons"
            }, iconPin);
          }
          pdfControlsNode = (0,preact_module.h)("div", {
            className: "pdf-controls-container"
          }, (0,preact_module.h)("div", {
            className: "pdf-controls"
          }, (0,preact_module.h)("div", {
            onClick: this.decPage,
            className: 'pdf-control-arrow pdf-control-arrow-left ' + (currentPage > 1 ? 'pdf-control-arrow-active' : '')
          }, "\u2039"), currentPage, " of ", numPages, (0,preact_module.h)("div", {
            onClick: this.incPage,
            className: 'pdf-control-arrow pdf-control-arrow-right ' + (currentPage < numPages ? 'pdf-control-arrow-active' : '')
          }, "\u203A")), pinContainer);
        } else {
          var view = this.state.pdfPage.view;
          pdfPageNode = (0,preact_module.h)(PdfViewAsAllPages, {
            pdfDocument: this.state.pdfDocument,
            pdfjsLib: this.pdfJsLoader.get(),
            pagesOverview: this.state.pagesOverview,
            maxWidth: this.props.maxWidth,
            onPageMouseDown: this.onPageMouseDown,
            onPageMouseOver: this.onMouseOver,
            onPageMouseOut: this.onMouseOut,
            onPageClick: this.onPageClick,
            updatePagesOverview: this.updatePagesOverview,
            setPage: this.setPage,
            options: this.props.options
          });
        }
      }
      var fullScreenViewer = null;
      if (this.state.fullscreen) {
        var _view = this.state.pdfPage.view;
        fullScreenViewer = (0,preact_module.h)(PDFFullWrapper, {
          pdfDocument: this.state.pdfDocument,
          pageSize: {
            width: _view[2],
            height: _view[3]
          },
          onClose: this.onFullScreenClose,
          attachment: this.props.attachment,
          editor: this.props.editor,
          options: this.props.options,
          pdfjsLib: this.pdfJsLoader.get(),
          page: this.state.page,
          onPageChange: this.onPageChange,
          pagesOverview: this.state.pagesOverview,
          scale: this.state.scale,
          onScaleChange: this.onScaleChange,
          blot: this.props.blot
        });
      }
      return (0,preact_module.h)(plugins_i18n/* IntlProvider */.Pj, null, (0,preact_module.h)("div", {
        className: "pdf-viewer"
      }, fullScreenViewer, pdfPageNode, pdfControlsNode));
    }
  }]);
  return PDFViewerComponent;
}(preact_module/* Component */.wA); /**
               *  Возвращает дополнительные пункты меню для pdf блота
               * @param blot
               * @param viewerOption
               * @returns {{submenu: JSX.Element, index: number, action: boolean, label: JSX.Element}} | {}
               */

var getMenuItems = function getMenuItems(blot) {
  var viewerOption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var viewAsSubMenuItems = [{
    id: 'file-view_pdf_as-single',
    code: 'single',
    text: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
      id: "file.menu.single_page"
    }),
    action: 'onViewPdfAsChange'
  }, {
    id: 'file-view_pdf_as-all_pages',
    code: 'all_pages',
    text: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
      id: "file.menu.all_pages"
    }),
    action: 'onViewPdfAsChange'
  }];
  var ViewAsSubMenu = (0,preact_module.h)(popupMenu/* default */.Z, {
    anchorOptions: {
      boundariesElement: blot.editor.scrollingContainer
    }
  }, viewAsSubMenuItems.map(function (_ref5) {
    var id = _ref5.id,
      code = _ref5.code,
      text = _ref5.text,
      action = _ref5.action;
    var viewAs = blot.getViewAs();
    var icon = code === viewAs ? icons/* IconDone */.EZi : null;
    var style = icon ? 'done' : 'undone';
    return (0,preact_module.h)(popupMenuItem/* default */.Z, {
      key: id,
      id: id,
      text: text,
      icon: icon,
      menuStyle: [style],
      onClick: blot.onViewPdfAsChange(code)
    });
  }));
  var menu = {};

  // Проверка можно ли отображать пункт "Отображать как"
  var _viewerOption$showAsP = viewerOption.showAsPagesLimit,
    showAsPagesLimit = _viewerOption$showAsP === void 0 ? 0 : _viewerOption$showAsP;
  var isShowViewAsItem = blot.pdfNumPages <= showAsPagesLimit || !showAsPagesLimit;
  if (isShowViewAsItem && blot.getFileViewMode() === 'full') {
    menu = pdf_objectSpread(pdf_objectSpread({}, menu), {}, {
      view_pdf_as: {
        label: (0,preact_module.h)(plugins_i18n/* Text */.xv, {
          id: "file.menu.view_as"
        }),
        index: 2,
        action: false,
        submenu: ViewAsSubMenu
      }
    });
  }
  return menu;
};
PDFViewerComponent.printable = true;
PDFViewerComponent.supportsFullscreen = true;
PDFViewerComponent.hasAdditionMenuItems = true;
PDFViewerComponent.PrintAction = PrintComponent;
PDFViewerComponent.FullScreenAction = FullScreenAction;
PDFViewerComponent.getMenuItems = getMenuItems;
PDFViewerComponent.viewerName = 'PDFViewer';
})();

module.exports = __webpack_exports__;
/******/ })()
;